import _extends$1 from '@babel/runtime/helpers/extends';
import _defineProperty$1 from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties$1 from '@babel/runtime/helpers/objectWithoutProperties';
import * as React$2 from 'react';
import React__default, { useLayoutEffect, useContext, createElement, Fragment, createContext, forwardRef, useRef, isValidElement, cloneElement, Children, useMemo, useCallback, useReducer, useEffect, useState, Suspense, useImperativeHandle, Component } from 'react';
import '@babel/runtime/helpers/esm/extends';
import require$$0, { isFragment } from 'react-is';
import PropTypes, { bool, string, node as node$2, oneOf, any, oneOfType, arrayOf, array as array$2, shape, func, number as number$4, object as object$1, instanceOf } from 'prop-types';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _typeof from '@babel/runtime/helpers/typeof';
import _slicedToArray$1 from '@babel/runtime/helpers/slicedToArray';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _get from '@babel/runtime/helpers/get';
import _classCallCheck$1 from '@babel/runtime/helpers/classCallCheck';
import _createClass$1 from '@babel/runtime/helpers/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits$1 from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn$1 from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _taggedTemplateLiteral from '@babel/runtime/helpers/taggedTemplateLiteral';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { css as css$1, html, LitElement } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { styleMap } from 'lit/directives/style-map.js';
import _objectDestructuringEmpty from '@babel/runtime/helpers/objectDestructuringEmpty';
import * as ReactDOM from 'react-dom';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire (path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var classnames$1 = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames$1));

var cx = classnames$1.exports;

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (process.env.NODE_ENV !== 'production') {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (process.env.NODE_ENV !== 'production') {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };

  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';

/**
 * @param {number}
 * @return {number}
 */
var abs$1 = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash$2 (value, length) {
	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim$2 (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append$1 (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

var line$1 = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node$1 (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line$1, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy$1 (root, props) {
	return assign(node$1('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? charat(characters, --position) : 0;

	if (column--, character === 10)
		column = 1, line$1--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < length ? charat(characters, position++) : 0;

	if (column++, character === 10)
		column = 1, line$1++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line$1 = column = 1, length = strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim$2(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse$1('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse$1 (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && charat(characters, length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append$1(comment(commenter(next(), caret()), root, parent), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset:
						if (property > 0 && (strlen(characters) - length))
							append$1(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append$1(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

						if (character === 123)
							if (offset === 0)
								parse$1(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
									// d m s
									case 100: case 109: case 115:
										parse$1(value, reference, reference, rule && append$1(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse$1(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs$1(j = points[i])), z = value; x < size; ++x)
			if (z = trim$2(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node$1(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node$1(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node$1(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';
	var length = sizeof(children);

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case RULESET: element.value = element.props.join(',');
	}

	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

function memoize$2(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = element.parent === children[0]; // in nested rules comments become children of the "auto-inserted" rule
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? children[0].children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (hash$2(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    // order

    case 6165:
      return WEBKIT + value + MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return replace(value, ':', ':' + WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return WEBKIT + value + MS + value + value;
  }

  return value;
}

var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;

    case KEYFRAMES:
      return serialize([copy$1(element, {
        value: replace(element.value, '@', '@' + WEBKIT)
      })], callback);

    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize([copy$1(element, {
              props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return serialize([copy$1(element, {
              props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
            }), copy$1(element, {
              props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy$1(element, {
              props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var isBrowser$4 = typeof document !== 'undefined';
var getServerStylisCache = isBrowser$4 ? undefined : weakMemoize(function () {
  return memoize$2(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (process.env.NODE_ENV !== 'production' && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }

  if (isBrowser$4 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  if (isBrowser$4) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (process.env.NODE_ENV !== 'production') {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }

    }), incorrectImportAlarm);
  }

  if (isBrowser$4) {
    var currentSheet;
    var finalizingPlugins = [stringify, process.env.NODE_ENV !== 'production' ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify];

    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    }; // $FlowFixMe


    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

var reactIs = require$$0;
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

var isBrowser$3 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$3 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$3 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$3 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize$2(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error(noComponentSelectorMessage);
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var isBrowser$2 = typeof document !== 'undefined';

var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = React$2['useInsertion' + 'Effect'] ? React$2['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser$2 ? syncFallback : useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || useLayoutEffect;

var isBrowser$1 = typeof document !== 'undefined';
var hasOwnProperty$a = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);

if (process.env.NODE_ENV !== 'production') {
  EmotionCacheContext.displayName = 'EmotionCacheContext';
}

EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/forwardRef(function (props, ref) {
    // the cache will never be null in the browser
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser$1) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = useContext(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext = /* #__PURE__ */createContext({});

if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'EmotionThemeContext';
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (process.env.NODE_ENV !== 'production' && typeof props.css === 'string' && // check if there is a css declaration
  props.css.indexOf(':') !== -1) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + props.css + "`");
  }

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty$a.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (process.env.NODE_ENV !== 'production' && !!props.css && (typeof props.css !== 'object' || typeof props.css.name !== 'string' || props.css.name.indexOf('-') === -1)) {
    var label = getLabelFromStackTrace(new Error().stack);
    if (label) newProps[labelPropName] = label;
  }

  return newProps;
};

var Insertion$1 = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  if (!isBrowser$1 && rules !== undefined) {
    var _ref2;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, useContext(ThemeContext));

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty$a.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Insertion$1, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/createElement(WrappedComponent, newProps));
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

var pkg = {
	name: "@emotion/react",
	version: "11.10.6",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	exports: {
		".": {
			module: {
				worker: "./dist/emotion-react.worker.esm.js",
				browser: "./dist/emotion-react.browser.esm.js",
				"default": "./dist/emotion-react.esm.js"
			},
			"default": "./dist/emotion-react.cjs.js"
		},
		"./jsx-runtime": {
			module: {
				worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
				browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
				"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
			},
			"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
		},
		"./_isolated-hnrs": {
			module: {
				worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
				browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
				"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
			},
			"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
		},
		"./jsx-dev-runtime": {
			module: {
				worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
				browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
				"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
			},
			"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
		},
		"./package.json": "./package.json",
		"./types/css-prop": "./types/css-prop.d.ts",
		"./macro": "./macro.js"
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.js",
		"macro.d.ts",
		"macro.js.flow"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.18.3",
		"@emotion/babel-plugin": "^11.10.6",
		"@emotion/cache": "^11.10.5",
		"@emotion/serialize": "^1.1.1",
		"@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
		"@emotion/utils": "^1.2.0",
		"@emotion/weak-memoize": "^0.3.0",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@definitelytyped/dtslint": "0.0.112",
		"@emotion/css": "11.10.6",
		"@emotion/css-prettifier": "1.1.1",
		"@emotion/server": "11.10.0",
		"@emotion/styled": "11.10.6",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact",
		exports: {
			envConditions: [
				"browser",
				"worker"
			],
			extra: {
				"./types/css-prop": "./types/css-prop.d.ts",
				"./macro": "./macro.js"
			}
		}
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwnProperty$a.call(props, 'css')) {
    // $FlowFixMe
    return createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {
  if (process.env.NODE_ENV !== 'production' && !warnedAboutCssPropForGlobal && ( // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  props.className || props.css)) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }

  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, useContext(ThemeContext));

  if (!isBrowser$1) {
    var _ref;

    var serializedNames = serialized.name;
    var serializedStyles = serialized.styles;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      serializedStyles += next.styles;
      next = next.next;
    }

    var shouldCache = cache.compat === true;
    var rules = cache.insert("", {
      name: serializedNames,
      styles: serializedStyles
    }, cache.sheet, shouldCache);

    if (shouldCache) {
      return null;
    }

    return /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  } // yes, i know these hooks are used conditionally
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = useRef();
  useInsertionEffectWithLayoutFallback(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffectWithLayoutFallback(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

if (process.env.NODE_ENV !== 'production') {
  Global.displayName = 'EmotionGlobal';
}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (process.env.NODE_ENV !== 'production' && arg.styles !== undefined && arg.name !== undefined) {
              console.error('You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n' + '`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.');
            }

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    var rules = '';

    for (var i = 0; i < serializedArr.length; i++) {
      var res = insertStyles(cache, serializedArr[i], false);

      if (!isBrowser$1 && res !== undefined) {
        rules += res;
      }
    }

    if (!isBrowser$1) {
      return rules;
    }
  });

  if (!isBrowser$1 && rules.length !== 0) {
    var _ref2;

    return /*#__PURE__*/createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function (serialized) {
      return serialized.name;
    }).join(' '), _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var ClassNames = /* #__PURE__ */withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && process.env.NODE_ENV !== 'production') {
      throw new Error('css can only be used during render');
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && process.env.NODE_ENV !== 'production') {
      throw new Error('cx can only be used during render');
    }

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
});

if (process.env.NODE_ENV !== 'production') {
  ClassNames.displayName = 'EmotionClassNames';
}

if (process.env.NODE_ENV !== 'production') {
  var isBrowser = typeof document !== 'undefined'; // #1727, #2905 for some reason Jest and Vitest evaluate modules twice if some consuming module gets mocked

  var isTestEnv = typeof jest !== 'undefined' || typeof vi !== 'undefined';

  if (isBrowser && !isTestEnv) {
    // globalThis has wide browser support - https://caniuse.com/?search=globalThis, Node.js 12 and later
    var globalContext = // $FlowIgnore
    typeof globalThis !== 'undefined' ? globalThis // eslint-disable-line no-undef
    : isBrowser ? window : global;
    var globalKey = "__EMOTION_REACT_" + pkg.version.split('.')[0] + "__";

    if (globalContext[globalKey]) {
      console.warn('You are loading @emotion/react when it is already loaded. Running ' + 'multiple instances may cause problems. This can happen if multiple ' + 'versions are used, or if multiple builds of the same version are ' + 'used.');
    }

    globalContext[globalKey] = true;
  }
}

var _excluded$_ = ["las", "lab", "lar", "inline", "name", "className", "children"];
function Icon(props) {
  var _cx;
  var _ref = props || {},
    las = _ref.las,
    lab = _ref.lab,
    lar = _ref.lar,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    name = _ref.name,
    className = _ref.className,
    children = _ref.children,
    restProps = _objectWithoutProperties$1(_ref, _excluded$_);
  var isLASIcon = las || lar || lab;
  var iconClass = cx((_cx = {
    'fwc-icon': !isLASIcon && !inline,
    'fwc-inline-icon': !isLASIcon && inline
  }, _defineProperty$1(_cx, "fwc-icon-".concat(name), !isLASIcon && !!name), _defineProperty$1(_cx, "las", las), _defineProperty$1(_cx, "lab", lab), _defineProperty$1(_cx, "lar", lar), _defineProperty$1(_cx, "la-".concat(name), isLASIcon && !!name), _defineProperty$1(_cx, className, !!className), _cx));
  return jsx("span", _extends$1({}, restProps, {
    className: iconClass
  }), children);
}
Icon.propTypes = {
  las: bool,
  lar: bool,
  lab: bool,
  inline: bool,
  name: string,
  className: string,
  children: node$2
};

var _excluded$Z = ["className", "btnType", "circle", "small", "wrap", "children", "disabled", "loading", "icon", "iconPosition", "useAnchor"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$E() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssLink$1 = process.env.NODE_ENV === "production" ? {
  name: "pxxsmj-cssLink",
  styles: "font-family:'Lato';span.fwc-icon.icon-right,span.icon-right{padding-left:0px;margin-left:var(--fwcu);}span.fwc-icon.icon-left,span.icon-left{padding-right:0px;margin-right:var(--fwcu);}span.las,span.lar,span.lab{font-size:18.6px;&.icon-right{margin-left:5px;}&.icon-left{margin-right:5px;}}&.fwc-link.fwc-link-continue.large{span.las,span.lar,span.lab{font-size:18.6px;}}&.fwc-link-icon{span{font-weight:700;font-size:calc(2 * var(--fwcu));}span.las,span.lar,span.lab{font-size:22px;color:var(--color-gray-three);}};label:cssLink;"
} : {
  name: "pxxsmj-cssLink",
  styles: "font-family:'Lato';span.fwc-icon.icon-right,span.icon-right{padding-left:0px;margin-left:var(--fwcu);}span.fwc-icon.icon-left,span.icon-left{padding-right:0px;margin-right:var(--fwcu);}span.las,span.lar,span.lab{font-size:18.6px;&.icon-right{margin-left:5px;}&.icon-left{margin-right:5px;}}&.fwc-link.fwc-link-continue.large{span.las,span.lar,span.lab{font-size:18.6px;}}&.fwc-link-icon{span{font-weight:700;font-size:calc(2 * var(--fwcu));}span.las,span.lar,span.lab{font-size:22px;color:var(--color-gray-three);}};label:cssLink;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$E
};
var cssButton = process.env.NODE_ENV === "production" ? {
  name: "1ek83j-cssButton",
  styles: "span.icon-right{margin-left:var(--fwcu);}span.icon-left{margin-right:var(--fwcu);}span.las,span.lar,span.lab{font-size:18.6px;&.icon-right{margin-left:5px;}&.icon-left{margin-right:5px;}}&.fwc-btn-icon{span{margin-right:0;}span.icon-right{margin-left:var(--fwcu);}span.icon-left{margin-right:var(--fwcu);}span.las,span.lar,span.lab{&.icon-right{margin-left:5px;}&.icon-left{margin-right:5px;}}}&.fwc-btn-icon.small{.las,.lar,.lab{font-size:18.6px;}}&.fwc-btn-circle-large{.las,.lar,.lab{font-size:36px;}span.icon-right{margin-left:0px;}span.icon-left{margin-right:0px;}}&.fwc-btn-circle-small{.las,.lar,.lab{font-size:22px;}span.icon-right{margin-left:0px;}span.icon-left{margin-right:0px;}};label:cssButton;"
} : {
  name: "1ek83j-cssButton",
  styles: "span.icon-right{margin-left:var(--fwcu);}span.icon-left{margin-right:var(--fwcu);}span.las,span.lar,span.lab{font-size:18.6px;&.icon-right{margin-left:5px;}&.icon-left{margin-right:5px;}}&.fwc-btn-icon{span{margin-right:0;}span.icon-right{margin-left:var(--fwcu);}span.icon-left{margin-right:var(--fwcu);}span.las,span.lar,span.lab{&.icon-right{margin-left:5px;}&.icon-left{margin-right:5px;}}}&.fwc-btn-icon.small{.las,.lar,.lab{font-size:18.6px;}}&.fwc-btn-circle-large{.las,.lar,.lab{font-size:36px;}span.icon-right{margin-left:0px;}span.icon-left{margin-right:0px;}}&.fwc-btn-circle-small{.las,.lar,.lab{font-size:22px;}span.icon-right{margin-left:0px;}span.icon-left{margin-right:0px;}};label:cssButton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$E
};
var Button = /*#__PURE__*/forwardRef(function (props, ref) {
  var _ref, _icon$props, _icon$props2;
  var className = props.className,
    _props$btnType = props.btnType,
    btnType = _props$btnType === void 0 ? 'primary' : _props$btnType,
    _props$circle = props.circle,
    circle = _props$circle === void 0 ? false : _props$circle,
    _props$small = props.small,
    small = _props$small === void 0 ? false : _props$small,
    _props$wrap = props.wrap,
    wrap = _props$wrap === void 0 ? false : _props$wrap,
    children = props.children,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    icon = props.icon,
    _props$iconPosition = props.iconPosition,
    iconPosition = _props$iconPosition === void 0 ? 'left' : _props$iconPosition,
    _props$useAnchor = props.useAnchor,
    useAnchor = _props$useAnchor === void 0 ? false : _props$useAnchor,
    restProps = _objectWithoutProperties$1(props, _excluded$Z);
  var isBtnType = ['primary', 'secondary', 'success', 'warning', 'urgent', 'ghost'].includes(btnType);
  var buttonClass = cx(isBtnType ? (_ref = {
    'fwc-btn': true
  }, _defineProperty$1(_ref, "fwc-btn-".concat(btnType), !!btnType), _defineProperty$1(_ref, 'fwc-btn-wrap', !!wrap), _defineProperty$1(_ref, 'fwc-btn-circle-large', circle && !small), _defineProperty$1(_ref, 'fwc-btn-circle-small', circle && small), _defineProperty$1(_ref, 'fwc-btn-icon', !circle && (!!icon || loading)), _defineProperty$1(_ref, "small", !circle && small), _ref) : {
    'fwc-link': true,
    'fwc-btn-wrap': !!wrap,
    'fwc-link-icon': !(btnType !== null && btnType !== void 0 && btnType.includes('continue')) && btnType !== 'dark-link' && !!icon,
    'fwc-link-dark': btnType === 'dark-link',
    'fwc-link-continue': btnType === null || btnType === void 0 ? void 0 : btnType.includes('continue'),
    large: btnType === 'continue-large-link'
  }, className);
  var TagName = useAnchor ? 'a' : 'button';
  return jsx(TagName, _extends$1({}, restProps, {
    ref: ref,
    css: isBtnType ? cssButton : cssLink$1,
    className: buttonClass,
    disabled: disabled || loading
  }), loading && jsx(Icon, {
    las: true,
    name: "circle-notch",
    className: "icon-left la-spin"
  }), !loading && iconPosition === 'left' && /*#__PURE__*/isValidElement(icon) && /*#__PURE__*/cloneElement(icon, {
    className: "".concat((icon === null || icon === void 0 ? void 0 : (_icon$props = icon.props) === null || _icon$props === void 0 ? void 0 : _icon$props.className) || '', " icon-left")
  }), isBtnType && circle && loading ? null : children, !loading && iconPosition === 'right' && /*#__PURE__*/isValidElement(icon) && /*#__PURE__*/cloneElement(icon, {
    className: "".concat((icon === null || icon === void 0 ? void 0 : (_icon$props2 = icon.props) === null || _icon$props2 === void 0 ? void 0 : _icon$props2.className) || '', " icon-right")
  }));
});
Button.displayName = 'Button';
Button.propTypes = {
  className: string,
  disabled: bool,
  loading: bool,
  btnType: oneOf(['primary', 'secondary', 'success', 'warning', 'urgent', 'ghost', 'link', 'dark-link', 'continue-link', 'continue-large-link']),
  /**
   * <b>Note:</b> "circle" props will only work for 'primary', 'secondary', and 'ghost' button types
   */

  circle: bool,
  /**
   * <b>Note:</b> "small" props will only work for 'primary', 'secondary', and 'ghost' button types
   */
  small: bool,
  /**
   * If you pass true we will use `<a/>` instead `<button/>`
   * <hr />
   */
  useAnchor: bool,
  wrap: bool,
  icon: node$2,
  children: node$2,
  iconPosition: oneOf(['left', 'right'])
};

var _excluded$Y = ["className", "children"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$D() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssLayout = process.env.NODE_ENV === "production" ? {
  name: "1q1mr1-cssLayout",
  styles: "display:flex;flex:auto;flex-direction:column;min-height:0;background:#f0f2f5;width:100%;label:cssLayout;"
} : {
  name: "1q1mr1-cssLayout",
  styles: "display:flex;flex:auto;flex-direction:column;min-height:0;background:#f0f2f5;width:100%;label:cssLayout;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxheW91dC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLcUIiLCJmaWxlIjoiTGF5b3V0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBjeCBmcm9tICdjbGFzc25hbWVzJztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IG5vZGUsIHN0cmluZyB9IGZyb20gJ3Byb3AtdHlwZXMnO1xuXG5jb25zdCBjc3NMYXlvdXQgPSBjc3NgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXg6IGF1dG87XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIG1pbi1oZWlnaHQ6IDA7XG4gIGJhY2tncm91bmQ6ICNmMGYyZjU7XG4gIHdpZHRoOiAxMDAlO1xuYDtcblxuZXhwb3J0IGNvbnN0IExheW91dCA9IHByb3BzID0+IHtcbiAgY29uc3QgeyBjbGFzc05hbWUsIGNoaWxkcmVuLCAuLi5yZXN0UHJvcHMgfSA9IHByb3BzO1xuICBjb25zdCBsYXlvdXRDbGFzcyA9IGN4KCdzYnVpLWxheW91dCcsIGNsYXNzTmFtZSk7XG4gIHJldHVybiAoXG4gICAgPHNlY3Rpb24gey4uLnJlc3RQcm9wc30gY3NzPXtjc3NMYXlvdXR9IGNsYXNzTmFtZT17bGF5b3V0Q2xhc3N9PlxuICAgICAge2NoaWxkcmVufVxuICAgIDwvc2VjdGlvbj5cbiAgKTtcbn07XG5cbkxheW91dC5wcm9wVHlwZXMgPSB7XG4gIGNsYXNzTmFtZTogc3RyaW5nLFxuICBjaGlsZHJlbjogbm9kZSxcbn07XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$D
};
var Layout = function Layout(props) {
  var className = props.className,
    children = props.children,
    restProps = _objectWithoutProperties$1(props, _excluded$Y);
  var layoutClass = cx('sbui-layout', className);
  return jsx("section", _extends$1({}, restProps, {
    css: cssLayout,
    className: layoutClass
  }), children);
};
Layout.propTypes = {
  className: string,
  children: node$2
};

var _excluded$X = ["className", "children", "noContainer"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$C() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssHeader = process.env.NODE_ENV === "production" ? {
  name: "tf7h11-cssHeader",
  styles: "padding:32px 0;box-shadow:0 1px 2px 0 rgba(0, 0, 0, 0.5);background-color:#fff;width:100%;.container{max-width:calc(144 * var(--fwcu));margin:0 auto;};label:cssHeader;"
} : {
  name: "tf7h11-cssHeader",
  styles: "padding:32px 0;box-shadow:0 1px 2px 0 rgba(0, 0, 0, 0.5);background-color:#fff;width:100%;.container{max-width:calc(144 * var(--fwcu));margin:0 auto;};label:cssHeader;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkhlYWRlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLcUIiLCJmaWxlIjoiSGVhZGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBjeCBmcm9tICdjbGFzc25hbWVzJztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IG5vZGUsIHN0cmluZywgYm9vbCB9IGZyb20gJ3Byb3AtdHlwZXMnO1xuXG5jb25zdCBjc3NIZWFkZXIgPSBjc3NgXG4gIHBhZGRpbmc6IDMycHggMDtcbiAgYm94LXNoYWRvdzogMCAxcHggMnB4IDAgcmdiYSgwLCAwLCAwLCAwLjUpO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmZmO1xuICB3aWR0aDogMTAwJTtcblxuICAuY29udGFpbmVyIHtcbiAgICBtYXgtd2lkdGg6IGNhbGMoMTQ0ICogdmFyKC0tZndjdSkpO1xuICAgIG1hcmdpbjogMCBhdXRvO1xuICB9XG5gO1xuXG5leHBvcnQgY29uc3QgSGVhZGVyID0gcHJvcHMgPT4ge1xuICBjb25zdCB7IGNsYXNzTmFtZSwgY2hpbGRyZW4sIG5vQ29udGFpbmVyLCAuLi5yZXN0UHJvcHMgfSA9IHByb3BzO1xuICBjb25zdCBoZWFkZXJDbGFzcyA9IGN4KCdsYXlvdXQtaGVhZGVyJywgY2xhc3NOYW1lKTtcbiAgcmV0dXJuIChcbiAgICA8aGVhZGVyIHsuLi5yZXN0UHJvcHN9IGNzcz17Y3NzSGVhZGVyfSBjbGFzc05hbWU9e2hlYWRlckNsYXNzfT5cbiAgICAgIHtub0NvbnRhaW5lciA/IGNoaWxkcmVuIDogPGRpdiBjbGFzc05hbWU9XCJjb250YWluZXJcIj57Y2hpbGRyZW59PC9kaXY+fVxuICAgIDwvaGVhZGVyPlxuICApO1xufTtcblxuSGVhZGVyLnByb3BUeXBlcyA9IHtcbiAgY2xhc3NOYW1lOiBzdHJpbmcsXG4gIGNoaWxkcmVuOiBub2RlLFxuICBub0NvbnRhaW5lcjogYm9vbCxcbn07XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$C
};
var Header = function Header(props) {
  var className = props.className,
    children = props.children,
    noContainer = props.noContainer,
    restProps = _objectWithoutProperties$1(props, _excluded$X);
  var headerClass = cx('layout-header', className);
  return jsx("header", _extends$1({}, restProps, {
    css: cssHeader,
    className: headerClass
  }), noContainer ? children : jsx("div", {
    className: "container"
  }, children));
};
Header.propTypes = {
  className: string,
  children: node$2,
  noContainer: bool
};

var img = "data:image/png;base64,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";

var _excluded$W = ["className", "children", "noContainer"];
var cssContent$1 = /*#__PURE__*/css("flex:auto;min-height:900px;width:100%;background:url(", img, ");.container{max-width:calc(144 * var(--fwcu));margin:0 auto;};label:cssContent;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTXNCIiwiZmlsZSI6IkNvbnRlbnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IGN4IGZyb20gJ2NsYXNzbmFtZXMnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgbm9kZSwgc3RyaW5nLCBib29sIH0gZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgYmFja2dyb3VuZCBmcm9tICcuL2JhY2tncm91bmQucG5nJztcblxuY29uc3QgY3NzQ29udGVudCA9IGNzc2BcbiAgZmxleDogYXV0bztcbiAgbWluLWhlaWdodDogOTAwcHg7XG4gIHdpZHRoOiAxMDAlO1xuICAvLyBGYWNpbmcgaXNzdWVzIHdpdGggKi5zdmcsIFNvIHdlIGFyZSB1c2luZyAqLnBuZ1xuICBiYWNrZ3JvdW5kOiB1cmwoJHtiYWNrZ3JvdW5kfSk7XG5cbiAgLmNvbnRhaW5lciB7XG4gICAgbWF4LXdpZHRoOiBjYWxjKDE0NCAqIHZhcigtLWZ3Y3UpKTtcbiAgICBtYXJnaW46IDAgYXV0bztcbiAgfVxuYDtcblxuZXhwb3J0IGNvbnN0IENvbnRlbnQgPSBwcm9wcyA9PiB7XG4gIGNvbnN0IHsgY2xhc3NOYW1lLCBjaGlsZHJlbiwgbm9Db250YWluZXIsIC4uLnJlc3RQcm9wcyB9ID0gcHJvcHM7XG4gIGNvbnN0IGNvbnRlbnRDbGFzcyA9IGN4KCdsYXlvdXQtY29udGVudCcsIGNsYXNzTmFtZSk7XG4gIHJldHVybiAoXG4gICAgPG1haW4gey4uLnJlc3RQcm9wc30gY3NzPXtjc3NDb250ZW50fSBjbGFzc05hbWU9e2NvbnRlbnRDbGFzc30+XG4gICAgICB7bm9Db250YWluZXIgPyBjaGlsZHJlbiA6IDxkaXYgY2xhc3NOYW1lPVwiY29udGFpbmVyXCI+e2NoaWxkcmVufTwvZGl2Pn1cbiAgICA8L21haW4+XG4gICk7XG59O1xuXG5Db250ZW50LnByb3BUeXBlcyA9IHtcbiAgbm9Db250YWluZXI6IGJvb2wsXG4gIGNsYXNzTmFtZTogc3RyaW5nLFxuICBjaGlsZHJlbjogbm9kZSxcbn07XG4iXX0= */"));
var Content = function Content(props) {
  var className = props.className,
    children = props.children,
    noContainer = props.noContainer,
    restProps = _objectWithoutProperties$1(props, _excluded$W);
  var contentClass = cx('layout-content', className);
  return jsx("main", _extends$1({}, restProps, {
    css: cssContent$1,
    className: contentClass
  }), noContainer ? children : jsx("div", {
    className: "container"
  }, children));
};
Content.propTypes = {
  noContainer: bool,
  className: string,
  children: node$2
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$a = ".fwc-footer-main {\n  background-color: var(--color-black);\n  padding: calc(4 * var(--fwcu)) 0;\n  color: var(--color-white);\n}\n.fwc-footer-flex-column {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n.fwc-icon-block-container .fwc-icon-block {\n  display: inline-flex;\n  align-items: center;\n  text-decoration: none;\n}\n.fwc-icon-block-container .fwc-icon-block:last-child {\n  border: 0px;\n}\n.fwc-icon-block-container .fwc-icon-block:hover {\n  cursor: pointer;\n}\n.fwc-icon-block-container .fwc-icon-block div {\n  padding: calc(3 * var(--fwcu)) 0;\n  border-bottom: 2px solid rgba(var(--color-rgb-white), 0.1);\n  width: 100%;\n  color: var(--color-white);\n}\n.fwc-icon-block-container a {\n  width: 100%;\n}\n.fwc-footer-main .fwc-icon-block-container .fwc-icon {\n  font-size: calc(3.75 * var(--fwcu));\n  margin-right: calc(2 * var(--fwcu));\n  color: var(--color-white);\n}\n.fwc-icon-block-container .fwc-icon-block .fwc-footer-icon {\n  background-repeat: no-repeat;\n  margin-right: calc(2 * var(--fwcu));\n  height: calc(3.75 * var(--fwcu));\n  width: calc(4 * var(--fwcu));\n}\n.fwc-icon-column {\n  display: flex;\n  width: 100%;\n  margin-bottom: calc(4 * var(--fwcu));\n  flex-direction: row-reverse;\n}\n.fwc-footer-links {\n  display: flex;\n  justify-content: flex-start;\n}\n.fwc-footer-links a {\n  margin-right: calc(2 * var(--fwcu));\n  color: var(--color-white);\n  font-size: calc(1.5 * var(--fwcu));\n}\n.fwc-footer-paragraph {\n  margin-bottom: calc(2 * var(--fwcu));\n}\n.fwc-footer-main .fwc-select-list label {\n  display: none;\n}\n.fwc-footer-main .fwc-select-list {\n  max-width: 85%;\n  min-width: 85%;\n  margin-left: auto;\n}\n.fwc-footer-main-links {\n  margin-bottom: calc(4 * var(--fwcu));\n}\n.fwc-footer-main .fwc-btn-ghost {\n  font-size: calc(2 * var(--fwcu));\n  margin-bottom: calc(2 * var(--fwcu));\n  width: 75%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: auto;\n}\n.fwc-footer-main .fwc-btn-ghost .fwc-icon-double-tick,\n.fwc-footer-minimal .fwc-icon-double-tick {\n  margin-right: calc(0.5 * var(--fwcu));\n  font-weight: 700;\n}\n.fwc-footer-minimal {\n  padding: calc(3 * var(--fwcu)) 0;\n  background-color: var(--color-black);\n  color: var(--color-white);\n}\n.fwc-footer-minimal .fwc-footer-minimal-links {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n}\n.fwc-footer-minimal .fwc-btn-ghost {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.fwc-footer-minimal .fwc-footer-minimal-links a {\n  color: var(--color-white);\n  padding-right: calc(2 * var(--fwcu));\n}\n@media screen and (max-width: 900px) {\n  .fwc-icon-block-container {\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    display: flex;\n  }\n  .fwc-icon-block-container .fwc-icon-block {\n    width: 31.33%;\n    display: inline-flex;\n    justify-content: center;\n    border: 2px solid rgba(var(--color-rgb-white), 0.2);\n    border-radius: calc(0.5 * var(--fwcu));\n    margin: 0 0 calc(var(--fwcu));\n    text-align: center;\n    padding: calc(2.5 * var(--fwcu));\n  }\n  .fwc-icon-block-container .fwc-icon-block:last-child {\n    border: 2px solid rgba(var(--color-rgb-white), 0.2);\n  }\n  .fwc-icon-block-container .fwc-icon-block.max-width {\n    width: 100%;\n    margin: 0 0 calc(4 * var(--fwcu));\n  }\n  .fwc-icon-block-container .fwc-icon-block.max-width div {\n    display: block;\n    margin-top: 0px;\n  }\n  .fwc-icon-block-container .fwc-icon-block div {\n    border-bottom: 0px;\n    padding: 0px;\n    display: none;\n  }\n  .fwc-icon-block-container .fwc-icon-block .fwc-footer-icon {\n    margin-right: 0;\n    background-repeat: no-repeat;\n    width: calc(4 * var(--fwcu));\n    height: calc(4 * var(--fwcu));\n  }\n  .fwc-footer-main .fwc-icon-block-container .fwc-icon {\n    margin-right: 0px;\n  }\n  .fwc-footer-main-links,\n  .fwc-reverse-column-mobile {\n    flex-direction: column-reverse;\n  }\n  .fwc-reverse-column-mobile {\n    display: flex;\n    flex-direction: column-reverse;\n  }\n  .fwc-icon-column {\n    display: block;\n    width: 100%;\n    margin: 0px;\n  }\n  .fwc-footer-links {\n    justify-content: flex-start;\n    margin-top: calc(var(--fwcu));\n    margin-bottom: calc(3 * var(--fwcu));\n    flex-wrap: wrap;\n  }\n  .fwc-footer-links a {\n    margin-right: calc(2.5 * var(--fwcu));\n  }\n  .fwc-footer-main-links {\n    margin-bottom: calc(2 * var(--fwcu));\n  }\n  .fwc-footer-main .fwc-btn-ghost {\n    margin-bottom: calc(2 * var(--fwcu));\n    margin-left: 0px;\n    max-width: calc(25 * var(--fwcu));\n  }\n  .fwc-footer-main .fwc-select-list {\n    max-width: calc(31.25 * var(--fwcu));\n    min-width: 0px;\n    margin-left: 0px;\n  }\n  .border {\n    border-top: 2px solid var(--color-gray-one);\n    border-bottom: 2px solid var(--color-gray-one);\n  }\n  .border.no-top-border {\n    border-top: 0px;\n  }\n\n  .fwc-footer-minimal .fwc-footer-minimal-links {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .fwc-footer-minimal .fwc-footer-minimal-links > * {\n    margin-top: calc(2 * var(--fwcu));\n  }\n}\n";
styleInject(css_248z$a);

var _excluded$V = ["className", "noContainer", "children"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$B() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssFooter = process.env.NODE_ENV === "production" ? {
  name: "loumzm-cssFooter",
  styles: "min-height:210px;.container{max-width:calc(144 * var(--fwcu));margin:0 auto;};label:cssFooter;"
} : {
  name: "loumzm-cssFooter",
  styles: "min-height:210px;.container{max-width:calc(144 * var(--fwcu));margin:0 auto;};label:cssFooter;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZvb3Rlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPcUIiLCJmaWxlIjoiRm9vdGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBjeCBmcm9tICdjbGFzc25hbWVzJztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IGJvb2wsIG5vZGUsIHN0cmluZyB9IGZyb20gJ3Byb3AtdHlwZXMnO1xuXG5pbXBvcnQgJy4uLy4uL3B1YmxpYy9md2MtYXNzZXRzL3N0eWxlcy90ZW1wbGF0ZXMvZndjLWZvb3Rlci5jc3MnO1xuXG5jb25zdCBjc3NGb290ZXIgPSBjc3NgXG4gIG1pbi1oZWlnaHQ6IDIxMHB4O1xuICAuY29udGFpbmVyIHtcbiAgICBtYXgtd2lkdGg6IGNhbGMoMTQ0ICogdmFyKC0tZndjdSkpO1xuICAgIG1hcmdpbjogMCBhdXRvO1xuICB9XG5gO1xuXG5leHBvcnQgY29uc3QgRm9vdGVyID0gcHJvcHMgPT4ge1xuICBjb25zdCB7IGNsYXNzTmFtZSwgbm9Db250YWluZXIsIGNoaWxkcmVuLCAuLi5yZXN0UHJvcHMgfSA9IHByb3BzO1xuICBjb25zdCBmb290ZXJDbGFzcyA9IGN4KCdmd2MtZm9vdGVyLW1haW4nLCBjbGFzc05hbWUpO1xuICByZXR1cm4gKFxuICAgIDxmb290ZXIgey4uLnJlc3RQcm9wc30gY3NzPXtjc3NGb290ZXJ9IGNsYXNzTmFtZT17Zm9vdGVyQ2xhc3N9PlxuICAgICAge25vQ29udGFpbmVyID8gY2hpbGRyZW4gOiA8ZGl2IGNsYXNzTmFtZT1cImNvbnRhaW5lclwiPntjaGlsZHJlbn08L2Rpdj59XG4gICAgPC9mb290ZXI+XG4gICk7XG59O1xuXG5Gb290ZXIucHJvcFR5cGVzID0ge1xuICBub0NvbnRhaW5lcjogYm9vbCxcbiAgY2xhc3NOYW1lOiBzdHJpbmcsXG4gIGNoaWxkcmVuOiBub2RlLFxufTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$B
};
var Footer = function Footer(props) {
  var className = props.className,
    noContainer = props.noContainer,
    children = props.children,
    restProps = _objectWithoutProperties$1(props, _excluded$V);
  var footerClass = cx('fwc-footer-main', className);
  return jsx("footer", _extends$1({}, restProps, {
    css: cssFooter,
    className: footerClass
  }), noContainer ? children : jsx("div", {
    className: "container"
  }, children));
};
Footer.propTypes = {
  noContainer: bool,
  className: string,
  children: node$2
};

var _excluded$U = ["href", "children", "linkType", "className"];
function HyperLink(_ref) {
  var _ref2, _cx;
  var href = _ref.href,
    children = _ref.children,
    _ref$linkType = _ref.linkType,
    linkType = _ref$linkType === void 0 ? null : _ref$linkType,
    className = _ref.className,
    rest = _objectWithoutProperties$1(_ref, _excluded$U);
  var _linkType = (_ref2 = linkType || '') !== null && _ref2 !== void 0 && _ref2.includes('continue') ? 'continue' : linkType;
  var hyperLinkClass = cx((_cx = {}, _defineProperty$1(_cx, "fwc-link-".concat(_linkType), !!_linkType), _defineProperty$1(_cx, "large", linkType === 'continue-large'), _cx), className);
  return jsx("a", _extends$1({}, rest, {
    href: href,
    className: hyperLinkClass
  }), children);
}
HyperLink.propTypes = {
  /**
   * The URL customer is going to be redirected to
   */
  href: string,
  /**
   Is the link button disabled?
   */
  disabled: bool,
  /**
   What type of link?
   1. icon
   2. dark
   3. continue
   4. continue-large
   */
  linkType: oneOf(['icon', 'dark', 'continue', 'continue-large']),
  children: node$2,
  className: string
};

var _excluded$T = ["className", "children"];
var Container = function Container(props) {
  var className = props.className,
    children = props.children,
    restProps = _objectWithoutProperties$1(props, _excluded$T);
  var containerClass = cx('fwc-container', className);
  return jsx("div", _extends$1({}, restProps, {
    className: containerClass
  }), children);
};
Container.propTypes = {
  className: string,
  children: node$2
};

var _excluded$S = ["lg", "md", "sm", "bottomMargin", "className", "children"];
var Col = function Col(props) {
  var _cx;
  var _props$lg = props.lg,
    lg = _props$lg === void 0 ? '12' : _props$lg,
    md = props.md,
    sm = props.sm,
    _props$bottomMargin = props.bottomMargin,
    bottomMargin = _props$bottomMargin === void 0 ? false : _props$bottomMargin,
    className = props.className,
    children = props.children,
    restProps = _objectWithoutProperties$1(props, _excluded$S);
  var colClass = cx("fwc-col-".concat(lg), (_cx = {}, _defineProperty$1(_cx, "md-".concat(md), !!md), _defineProperty$1(_cx, "sm-".concat(sm), !!sm), _defineProperty$1(_cx, 'fwc-col-bm', bottomMargin), _cx), className);
  return jsx("div", _extends$1({}, restProps, {
    className: colClass
  }), children);
};
var columns$1 = ['1', 1, '2', 2, '3', 3, '4', 4, '5', 5, '6', 6, '7', 7, '8', 8, '9', 9, '10', 10, '11', 11, '12', 12];
Col.propTypes = {
  lg: oneOf(columns$1),
  md: oneOf(columns$1),
  sm: oneOf(columns$1),
  bottomMargin: bool,
  className: string,
  children: node$2
};

var _excluded$R = ["wrap", "justifyContent", "alignItems", "bottomMargin", "className", "children"];
var Row = function Row(props) {
  var _props$wrap = props.wrap,
    wrap = _props$wrap === void 0 ? false : _props$wrap,
    _props$justifyContent = props.justifyContent,
    justifyContent = _props$justifyContent === void 0 ? 'start' : _props$justifyContent,
    _props$alignItems = props.alignItems,
    alignItems = _props$alignItems === void 0 ? 'start' : _props$alignItems,
    _props$bottomMargin = props.bottomMargin,
    bottomMargin = _props$bottomMargin === void 0 ? false : _props$bottomMargin,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    children = props.children,
    restProps = _objectWithoutProperties$1(props, _excluded$R);
  var rowClass = cx(_defineProperty$1({
    'fwc-row': true,
    'fwc-row-wrap': wrap,
    'fwc-row-bm': bottomMargin,
    'j-between': justifyContent === 'between',
    'j-center': justifyContent === 'center',
    'j-end': justifyContent === 'end',
    'a-base': alignItems === 'base',
    'a-start': alignItems === 'start',
    'a-center': alignItems === 'center',
    'a-end': alignItems === 'end',
    'a-stretch': alignItems === 'stretch'
  }, className, className));
  return jsx("div", _extends$1({}, restProps, {
    className: rowClass
  }), children);
};
Row.propTypes = {
  wrap: bool,
  bottomMargin: bool,
  alignItems: oneOf(['base', 'start', 'center', 'end', 'stretch']),
  justifyContent: oneOf(['start', 'center', 'end', 'between']),
  className: string,
  children: node$2
};

var _excluded$Q = ["className", "small"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$A() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssDivider = process.env.NODE_ENV === "production" ? {
  name: "1v6kpos-cssDivider",
  styles: "&.small{height:1px;margin:0px;background-color:var(--color-gray-four);};label:cssDivider;"
} : {
  name: "1v6kpos-cssDivider",
  styles: "&.small{height:1px;margin:0px;background-color:var(--color-gray-four);};label:cssDivider;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkRpdmlkZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBS3NCIiwiZmlsZSI6IkRpdmlkZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IGN4IGZyb20gJ2NsYXNzbmFtZXMnO1xuaW1wb3J0IHsgc3RyaW5nLCBib29sIH0gZnJvbSAncHJvcC10eXBlcyc7XG5cbmNvbnN0IGNzc0RpdmlkZXIgPSBjc3NgXG4gICYuc21hbGwge1xuICAgIGhlaWdodDogMXB4O1xuICAgIG1hcmdpbjogMHB4O1xuICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLWNvbG9yLWdyYXktZm91cik7XG4gIH1cbmA7XG5cbmV4cG9ydCBjb25zdCBEaXZpZGVyID0gcHJvcHMgPT4ge1xuICBjb25zdCB7IGNsYXNzTmFtZSwgc21hbGwsIC4uLnJlc3RQcm9wcyB9ID0gcHJvcHM7XG4gIGNvbnN0IGNvbnRhaW5lckNsYXNzID0gY3goJ2Z3Yy1kaXZpZGVyJywgY2xhc3NOYW1lLCB7IHNtYWxsOiBzbWFsbCB9KTtcbiAgcmV0dXJuIDxkaXYgey4uLnJlc3RQcm9wc30gY2xhc3NOYW1lPXtjb250YWluZXJDbGFzc30gY3NzPXtjc3NEaXZpZGVyfSAvPjtcbn07XG5cbkRpdmlkZXIucHJvcFR5cGVzID0ge1xuICBzbWFsbDogYm9vbCxcbiAgY2xhc3NOYW1lOiBzdHJpbmcsXG59O1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$A
};
var Divider = function Divider(props) {
  var className = props.className,
    small = props.small,
    restProps = _objectWithoutProperties$1(props, _excluded$Q);
  var containerClass = cx('fwc-divider', className, {
    small: small
  });
  return jsx("div", _extends$1({}, restProps, {
    className: containerClass,
    css: cssDivider
  }));
};
Divider.propTypes = {
  small: bool,
  className: string
};

function ownKeys$i(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$i(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$i(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$i(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var fontSizeMap = {
  sm: '12px',
  md: '14px',
  lg: '16px'
};
var typeToColorsMap = {
  black: 'var(--color-black)',
  white: 'var(--color-white)',
  primary: 'var(--color-primary)',
  grey: 'var(--color-gray-one)',
  success: 'var(--color-alert-success)',
  warning: 'var(--color-alert-warning)',
  error: 'var(--color-alert-error)'
};
var getFwcProps$1 = function getFwcProps(props, keysMap) {
  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var fwcProps = {};
  Object.keys(_objectSpread$i(_objectSpread$i({}, keysMap), {}, {
    id: 'id',
    className: 'class'
  })).forEach(function (key) {
    var value = props[key];
    var defaultValue = defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps[key];
    if (value || defaultValue) {
      var fwcKey = keysMap[key];
      fwcProps[fwcKey] = value || defaultValue;
    }
  });
  return fwcProps;
};

function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return function (node) {
    refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref != null) {
        ref.current = node;
      }
    });
  };
}

function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$h(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function toArray(children, option) {
  var result = [];
  Children.forEach(children, function (child) {
    if ((child === undefined || child === null) && !option.keepEmpty) {
      return;
    }
    if (Array.isArray(child)) {
      result = result.concat(toArray(child));
    } else if (isFragment(child) && child.props) {
      result = result.concat(toArray(child.props.children, option));
    } else {
      result.push(child);
    }
  });
  return result;
}
function parseTabList(children) {
  var componentName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return toArray(children).map(function (node) {
    var _node$type;
    if (componentName && (node === null || node === void 0 ? void 0 : (_node$type = node.type) === null || _node$type === void 0 ? void 0 : _node$type.displayName) !== componentName) {
      return null;
    }
    if ( /*#__PURE__*/isValidElement(node)) {
      var key = node.key !== undefined ? String(node.key) : undefined;
      return _objectSpread$h(_objectSpread$h({
        key: key
      }, node.props), {}, {
        node: node
      });
    }
    return null;
  }).filter(function (tab) {
    return tab;
  });
}

var _excluded$P = ["className", "level", "align", "type", "bold"];
var cssTitle = function cssTitle(config) {
  var align = config.align,
    type = config.type,
    bold = config.bold;
  return /*#__PURE__*/css("&.title-header{text-align:", align && align, ";color:", type && typeToColorsMap[type], ";font-weight:", bold && 'bold', ";};label:cssTitle;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRpdGxlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFZIiwiZmlsZSI6IlRpdGxlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGJvb2wsIG5vZGUsIG9uZU9mLCBzdHJpbmcgfSBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCBjeCBmcm9tICdjbGFzc25hbWVzJztcbmltcG9ydCB7IHR5cGVUb0NvbG9yc01hcCB9IGZyb20gJy4uL3V0aWxzJztcblxuY29uc3QgY3NzVGl0bGUgPSBjb25maWcgPT4ge1xuICBjb25zdCB7IGFsaWduLCB0eXBlLCBib2xkIH0gPSBjb25maWc7XG4gIHJldHVybiBjc3NgXG4gICAgJi50aXRsZS1oZWFkZXIge1xuICAgICAgdGV4dC1hbGlnbjogJHthbGlnbiAmJiBhbGlnbn07XG4gICAgICBjb2xvcjogJHt0eXBlICYmIHR5cGVUb0NvbG9yc01hcFt0eXBlXX07XG4gICAgICBmb250LXdlaWdodDogJHtib2xkICYmICdib2xkJ307XG4gICAgfVxuICBgO1xufTtcblxuZXhwb3J0IGZ1bmN0aW9uIFRpdGxlKHByb3BzKSB7XG4gIGNvbnN0IHtcbiAgICBjbGFzc05hbWUsXG4gICAgbGV2ZWwgPSAnMScsXG4gICAgYWxpZ24gPSBudWxsLFxuICAgIHR5cGUgPSBudWxsLFxuICAgIGJvbGQgPSBmYWxzZSxcbiAgICAuLi5yZXN0UHJvcHNcbiAgfSA9IHByb3BzO1xuICBjb25zdCBUYWdOYW1lID0gYGgke2xldmVsfWA7XG4gIHJldHVybiAoXG4gICAgPFRhZ05hbWVcbiAgICAgIHsuLi5yZXN0UHJvcHN9XG4gICAgICBjc3M9e2Nzc1RpdGxlKHsgYWxpZ24sIHR5cGUsIGJvbGQgfSl9XG4gICAgICBjbGFzc05hbWU9e2N4KCd0aXRsZS1oZWFkZXInLCBjbGFzc05hbWUpfVxuICAgIC8+XG4gICk7XG59XG5cblRpdGxlLnByb3BUeXBlcyA9IHtcbiAgY2xhc3NOYW1lOiBzdHJpbmcsXG4gIGJvbGQ6IGJvb2wsXG4gIGxldmVsOiBvbmVPZihbMSwgJzEnLCAyLCAnMicsIDMsICczJywgNCwgJzQnLCA1LCAnNScsIDYsICc2J10pLFxuICBhbGlnbjogb25lT2YoWydsZWZ0JywgJ3JpZ2h0JywgJ2NlbnRlciddKSxcbiAgdHlwZTogb25lT2YoW1xuICAgICdwcmltYXJ5JyxcbiAgICAnc3VjY2VzcycsXG4gICAgJ3dhcm5pbmcnLFxuICAgICdlcnJvcicsXG4gICAgJ2dyZXknLFxuICAgICd3aGl0ZScsXG4gICAgJ2JsYWNrJyxcbiAgXSksXG4gIGNoaWxkcmVuOiBub2RlLFxufTtcbiJdfQ== */"));
};
function Title(props) {
  var className = props.className,
    _props$level = props.level,
    level = _props$level === void 0 ? '1' : _props$level,
    _props$align = props.align,
    align = _props$align === void 0 ? null : _props$align,
    _props$type = props.type,
    type = _props$type === void 0 ? null : _props$type,
    _props$bold = props.bold,
    bold = _props$bold === void 0 ? false : _props$bold,
    restProps = _objectWithoutProperties$1(props, _excluded$P);
  var TagName = "h".concat(level);
  return jsx(TagName, _extends$1({}, restProps, {
    css: cssTitle({
      align: align,
      type: type,
      bold: bold
    }),
    className: cx('title-header', className)
  }));
}
Title.propTypes = {
  className: string,
  bold: bool,
  level: oneOf([1, '1', 2, '2', 3, '3', 4, '4', 5, '5', 6, '6']),
  align: oneOf(['left', 'right', 'center']),
  type: oneOf(['primary', 'success', 'warning', 'error', 'grey', 'white', 'black']),
  children: node$2
};

var _excluded$O = ["underline", "italic", "bold", "type", "align", "size", "className"];
var cssText$1 = function cssText(underline, italic, bold, type, align, size) {
  return /*#__PURE__*/css("&.paragraph{text-align:", align && align, ";text-decoration:", underline && 'underline', ";font-style:", italic && 'italic', ";font-weight:", bold && 'bold', ";font-size:", size && fontSizeMap[size], ";color:", type && typeToColorsMap[type], ";};label:cssText;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBhcmFncmFwaC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPWSIsImZpbGUiOiJQYXJhZ3JhcGguanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IGN4IGZyb20gJ2NsYXNzbmFtZXMnO1xuaW1wb3J0IHsgYm9vbCwgc3RyaW5nLCBvbmVPZiB9IGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IHsgZm9udFNpemVNYXAsIHR5cGVUb0NvbG9yc01hcCB9IGZyb20gJy4uL3V0aWxzJztcblxuY29uc3QgY3NzVGV4dCA9ICh1bmRlcmxpbmUsIGl0YWxpYywgYm9sZCwgdHlwZSwgYWxpZ24sIHNpemUpID0+IHtcbiAgcmV0dXJuIGNzc2BcbiAgICAmLnBhcmFncmFwaCB7XG4gICAgICB0ZXh0LWFsaWduOiAke2FsaWduICYmIGFsaWdufTtcbiAgICAgIHRleHQtZGVjb3JhdGlvbjogJHt1bmRlcmxpbmUgJiYgJ3VuZGVybGluZSd9O1xuICAgICAgZm9udC1zdHlsZTogJHtpdGFsaWMgJiYgJ2l0YWxpYyd9O1xuICAgICAgZm9udC13ZWlnaHQ6ICR7Ym9sZCAmJiAnYm9sZCd9O1xuICAgICAgZm9udC1zaXplOiAke3NpemUgJiYgZm9udFNpemVNYXBbc2l6ZV19O1xuICAgICAgY29sb3I6ICR7dHlwZSAmJiB0eXBlVG9Db2xvcnNNYXBbdHlwZV19O1xuICAgIH1cbiAgYDtcbn07XG5cbmV4cG9ydCBjb25zdCBQYXJhZ3JhcGggPSBwcm9wcyA9PiB7XG4gIGNvbnN0IHtcbiAgICB1bmRlcmxpbmUsXG4gICAgaXRhbGljLFxuICAgIGJvbGQsXG4gICAgdHlwZSA9IG51bGwsXG4gICAgYWxpZ24gPSBudWxsLFxuICAgIHNpemUgPSAnbWQnLFxuICAgIGNsYXNzTmFtZSxcbiAgICAuLi5yZXN0UHJvcHNcbiAgfSA9IHByb3BzO1xuICByZXR1cm4gKFxuICAgIDxwXG4gICAgICB7Li4ucmVzdFByb3BzfVxuICAgICAgY3NzPXtjc3NUZXh0KHVuZGVybGluZSwgaXRhbGljLCBib2xkLCB0eXBlLCBhbGlnbiwgc2l6ZSl9XG4gICAgICBjbGFzc05hbWU9e2N4KCdwYXJhZ3JhcGgnLCBjbGFzc05hbWUpfVxuICAgIC8+XG4gICk7XG59O1xuXG5QYXJhZ3JhcGgucHJvcFR5cGVzID0ge1xuICB1bmRlcmxpbmU6IGJvb2wsXG4gIGl0YWxpYzogYm9vbCxcbiAgYm9sZDogYm9vbCxcbiAgdHlwZTogb25lT2YoW1xuICAgICdwcmltYXJ5JyxcbiAgICAnc3VjY2VzcycsXG4gICAgJ3dhcm5pbmcnLFxuICAgICdlcnJvcicsXG4gICAgJ3doaXRlJyxcbiAgICAnZ3JleScsXG4gICAgJ2JsYWNrJyxcbiAgXSksXG4gIGFsaWduOiBvbmVPZihbJ2xlZnQnLCAnY2VudGVyJywgJ3JpZ2h0J10pLFxuICBzaXplOiBvbmVPZihbJ2xnJywgJ21kJywgJ3NtJ10pLFxuICBjbGFzc05hbWU6IHN0cmluZyxcbn07XG4iXX0= */"));
};
var Paragraph = function Paragraph(props) {
  var underline = props.underline,
    italic = props.italic,
    bold = props.bold,
    _props$type = props.type,
    type = _props$type === void 0 ? null : _props$type,
    _props$align = props.align,
    align = _props$align === void 0 ? null : _props$align,
    _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    className = props.className,
    restProps = _objectWithoutProperties$1(props, _excluded$O);
  return jsx("p", _extends$1({}, restProps, {
    css: cssText$1(underline, italic, bold, type, align, size),
    className: cx('paragraph', className)
  }));
};
Paragraph.propTypes = {
  underline: bool,
  italic: bool,
  bold: bool,
  type: oneOf(['primary', 'success', 'warning', 'error', 'white', 'grey', 'black']),
  align: oneOf(['left', 'center', 'right']),
  size: oneOf(['lg', 'md', 'sm']),
  className: string
};

var _excluded$N = ["underline", "italic", "bold", "type", "size", "className"];
var cssText = function cssText(underline, italic, bold, type, size) {
  return /*#__PURE__*/css("&.text{text-decoration:", underline && 'underline', ";font-style:", italic && 'italic', ";font-weight:", bold && 'bold', ";font-size:", size && fontSizeMap[size], ";color:", type && typeToColorsMap[type], ";};label:cssText;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRleHQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT1kiLCJmaWxlIjoiVGV4dC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBib29sLCBvbmVPZiwgc3RyaW5nIH0gZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgY3ggZnJvbSAnY2xhc3NuYW1lcyc7XG5pbXBvcnQgeyB0eXBlVG9Db2xvcnNNYXAsIGZvbnRTaXplTWFwIH0gZnJvbSAnLi4vdXRpbHMnO1xuXG5jb25zdCBjc3NUZXh0ID0gKHVuZGVybGluZSwgaXRhbGljLCBib2xkLCB0eXBlLCBzaXplKSA9PiB7XG4gIHJldHVybiBjc3NgXG4gICAgJi50ZXh0IHtcbiAgICAgIHRleHQtZGVjb3JhdGlvbjogJHt1bmRlcmxpbmUgJiYgJ3VuZGVybGluZSd9O1xuICAgICAgZm9udC1zdHlsZTogJHtpdGFsaWMgJiYgJ2l0YWxpYyd9O1xuICAgICAgZm9udC13ZWlnaHQ6ICR7Ym9sZCAmJiAnYm9sZCd9O1xuICAgICAgZm9udC1zaXplOiAke3NpemUgJiYgZm9udFNpemVNYXBbc2l6ZV19O1xuICAgICAgY29sb3I6ICR7dHlwZSAmJiB0eXBlVG9Db2xvcnNNYXBbdHlwZV19O1xuICAgIH1cbiAgYDtcbn07XG5cbmV4cG9ydCBjb25zdCBUZXh0ID0gKHtcbiAgdW5kZXJsaW5lID0gZmFsc2UsXG4gIGl0YWxpYyA9IGZhbHNlLFxuICBib2xkID0gZmFsc2UsXG4gIHR5cGUgPSBudWxsLFxuICBzaXplID0gJ21kJyxcbiAgY2xhc3NOYW1lLFxuICAuLi5yZXN0UHJvcHNcbn0pID0+IHtcbiAgcmV0dXJuIChcbiAgICA8c3BhblxuICAgICAgey4uLnJlc3RQcm9wc31cbiAgICAgIGNzcz17Y3NzVGV4dCh1bmRlcmxpbmUsIGl0YWxpYywgYm9sZCwgdHlwZSwgc2l6ZSl9XG4gICAgICBjbGFzc05hbWU9e2N4KCd0ZXh0JywgY2xhc3NOYW1lKX1cbiAgICAvPlxuICApO1xufTtcblxuVGV4dC5wcm9wVHlwZXMgPSB7XG4gIGNsYXNzTmFtZTogc3RyaW5nLFxuICB1bmRlcmxpbmU6IGJvb2wsXG4gIGl0YWxpYzogYm9vbCxcbiAgYm9sZDogYm9vbCxcbiAgLyoqXG4gICB3aGF0IHR5cGUgb2YgbWVzc2FnZT9cbiAgIDEuIHN1Y2Nlc3NcbiAgIDIuIHdhcm5pbmdcbiAgIDMuIGVycm9yXG4gICA0LiBwcmltYXJ5XG4gICA1LiBncmV5XG4gICA2LiB3aGl0ZVxuICAgNy4gd2hpdGVcbiAgICovXG4gIHR5cGU6IG9uZU9mKFtcbiAgICAncHJpbWFyeScsXG4gICAgJ2JsYWNrJyxcbiAgICAnZ3JleScsXG4gICAgJ3doaXRlJyxcbiAgICAnc3VjY2VzcycsXG4gICAgJ3dhcm5pbmcnLFxuICAgICdlcnJvcicsXG4gIF0pLFxuICAvKipcbiAgIHRoZSBzaXplIG9mOlxuICAgIHNtYWxsIHRleHQ6ICAxMnB4LFxuICAgIG1lZGl1bSB0ZXh0OiAxNHB4LFxuICAgIGxhcmdlIHRleHQ6ICAxNnB4IFxuICAgKi9cbiAgc2l6ZTogb25lT2YoWydsZycsICdtZCcsICdzbSddKSxcbn07XG4iXX0= */"));
};
var Text$1 = function Text(_ref) {
  var _ref$underline = _ref.underline,
    underline = _ref$underline === void 0 ? false : _ref$underline,
    _ref$italic = _ref.italic,
    italic = _ref$italic === void 0 ? false : _ref$italic,
    _ref$bold = _ref.bold,
    bold = _ref$bold === void 0 ? false : _ref$bold,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? null : _ref$type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    className = _ref.className,
    restProps = _objectWithoutProperties$1(_ref, _excluded$N);
  return jsx("span", _extends$1({}, restProps, {
    css: cssText(underline, italic, bold, type, size),
    className: cx('text', className)
  }));
};
Text$1.propTypes = {
  className: string,
  underline: bool,
  italic: bool,
  bold: bool,
  /**
   what type of message?
   1. success
   2. warning
   3. error
   4. primary
   5. grey
   6. white
   7. white
   */
  type: oneOf(['primary', 'black', 'grey', 'white', 'success', 'warning', 'error']),
  /**
   the size of:
    small text:  12px,
    medium text: 14px,
    large text:  16px 
   */
  size: oneOf(['lg', 'md', 'sm'])
};

var _excluded$M = ["children", "className", "align"];
var cssCardHeader = function cssCardHeader(align) {
  return /*#__PURE__*/css("padding:5px 10px;text-align:", align || 'inherit', ";;label:cssCardHeader;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhcmRIZWFkZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTUsiLCJmaWxlIjoiQ2FyZEhlYWRlci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgY3ggZnJvbSAnY2xhc3NuYW1lcyc7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBub2RlLCBzdHJpbmcsIG9uZU9mIH0gZnJvbSAncHJvcC10eXBlcyc7XG5cbmNvbnN0IGNzc0NhcmRIZWFkZXIgPSBhbGlnbiA9PlxuICBjc3NgXG4gICAgcGFkZGluZzogNXB4IDEwcHg7XG4gICAgdGV4dC1hbGlnbjogJHthbGlnbiB8fCAnaW5oZXJpdCd9O1xuICBgO1xuXG5leHBvcnQgY29uc3QgQ2FyZEhlYWRlciA9IHByb3BzID0+IHtcbiAgY29uc3QgeyBjaGlsZHJlbiwgY2xhc3NOYW1lLCBhbGlnbiwgLi4ucmVzdFByb3BzIH0gPSBwcm9wcztcbiAgY29uc3QgY2FyZEhlYWRlckNsYXNzID0gY3goJ2NhcmQtaGVhZGVyJywgY2xhc3NOYW1lKTtcbiAgcmV0dXJuIChcbiAgICA8ZGl2IHsuLi5yZXN0UHJvcHN9IGNzcz17Y3NzQ2FyZEhlYWRlcihhbGlnbil9IGNsYXNzTmFtZT17Y2FyZEhlYWRlckNsYXNzfT5cbiAgICAgIHtjaGlsZHJlbn1cbiAgICA8L2Rpdj5cbiAgKTtcbn07XG5cbkNhcmRIZWFkZXIucHJvcFR5cGVzID0ge1xuICBjbGFzc05hbWU6IHN0cmluZyxcbiAgYWxpZ246IG9uZU9mKFsnbGVmdCcsICdyaWdodCcsICdjZW50ZXInXSksXG4gIGNoaWxkcmVuOiBub2RlLFxufTtcbiJdfQ== */"));
};
var CardHeader = function CardHeader(props) {
  var children = props.children,
    className = props.className,
    align = props.align,
    restProps = _objectWithoutProperties$1(props, _excluded$M);
  var cardHeaderClass = cx('card-header', className);
  return jsx("div", _extends$1({}, restProps, {
    css: cssCardHeader(align),
    className: cardHeaderClass
  }), children);
};
CardHeader.propTypes = {
  className: string,
  align: oneOf(['left', 'right', 'center']),
  children: node$2
};

var _excluded$L = ["children", "className", "align"];
var cssCardBody = function cssCardBody(align) {
  return /*#__PURE__*/css("flex:1 1 auto;padding:10px;text-align:", align || 'inherit', ";;label:cssCardBody;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhcmRCb2R5LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1LIiwiZmlsZSI6IkNhcmRCb2R5LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBjeCBmcm9tICdjbGFzc25hbWVzJztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IG5vZGUsIHN0cmluZywgb25lT2YgfSBmcm9tICdwcm9wLXR5cGVzJztcblxuY29uc3QgY3NzQ2FyZEJvZHkgPSBhbGlnbiA9PlxuICBjc3NgXG4gICAgZmxleDogMSAxIGF1dG87XG4gICAgcGFkZGluZzogMTBweDtcbiAgICB0ZXh0LWFsaWduOiAke2FsaWduIHx8ICdpbmhlcml0J307XG4gIGA7XG5cbmV4cG9ydCBjb25zdCBDYXJkQm9keSA9IHByb3BzID0+IHtcbiAgY29uc3QgeyBjaGlsZHJlbiwgY2xhc3NOYW1lLCBhbGlnbiwgLi4ucmVzdFByb3BzIH0gPSBwcm9wcztcbiAgY29uc3QgY2FyZEJvZHlDbGFzcyA9IGN4KCdjYXJkLWJvZHknLCBjbGFzc05hbWUpO1xuICByZXR1cm4gKFxuICAgIDxkaXYgey4uLnJlc3RQcm9wc30gY3NzPXtjc3NDYXJkQm9keShhbGlnbil9IGNsYXNzTmFtZT17Y2FyZEJvZHlDbGFzc30+XG4gICAgICB7Y2hpbGRyZW59XG4gICAgPC9kaXY+XG4gICk7XG59O1xuXG5DYXJkQm9keS5wcm9wVHlwZXMgPSB7XG4gIGNsYXNzTmFtZTogc3RyaW5nLFxuICBhbGlnbjogb25lT2YoWydsZWZ0JywgJ3JpZ2h0JywgJ2NlbnRlciddKSxcbiAgY2hpbGRyZW46IG5vZGUsXG59O1xuIl19 */"));
};
var CardBody = function CardBody(props) {
  var children = props.children,
    className = props.className,
    align = props.align,
    restProps = _objectWithoutProperties$1(props, _excluded$L);
  var cardBodyClass = cx('card-body', className);
  return jsx("div", _extends$1({}, restProps, {
    css: cssCardBody(align),
    className: cardBodyClass
  }), children);
};
CardBody.propTypes = {
  className: string,
  align: oneOf(['left', 'right', 'center']),
  children: node$2
};

var _excluded$K = ["children", "className", "align"];
var cssCardFooter = function cssCardFooter(align) {
  return /*#__PURE__*/css("padding:5px 10px;text-align:", align || 'inherit', ";;label:cssCardFooter;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhcmRGb290ZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTUsiLCJmaWxlIjoiQ2FyZEZvb3Rlci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgY3ggZnJvbSAnY2xhc3NuYW1lcyc7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBub2RlLCBzdHJpbmcsIG9uZU9mIH0gZnJvbSAncHJvcC10eXBlcyc7XG5cbmNvbnN0IGNzc0NhcmRGb290ZXIgPSBhbGlnbiA9PlxuICBjc3NgXG4gICAgcGFkZGluZzogNXB4IDEwcHg7XG4gICAgdGV4dC1hbGlnbjogJHthbGlnbiB8fCAnaW5oZXJpdCd9O1xuICBgO1xuXG5leHBvcnQgY29uc3QgQ2FyZEZvb3RlciA9IHByb3BzID0+IHtcbiAgY29uc3QgeyBjaGlsZHJlbiwgY2xhc3NOYW1lLCBhbGlnbiwgLi4ucmVzdFByb3BzIH0gPSBwcm9wcztcbiAgY29uc3QgY2FyZEZvb3RlckNsYXNzID0gY3goJ2NhcmQtZm9vdGVyJywgY2xhc3NOYW1lKTtcbiAgcmV0dXJuIChcbiAgICA8ZGl2IHsuLi5yZXN0UHJvcHN9IGNzcz17Y3NzQ2FyZEZvb3RlcihhbGlnbil9IGNsYXNzTmFtZT17Y2FyZEZvb3RlckNsYXNzfT5cbiAgICAgIHtjaGlsZHJlbn1cbiAgICA8L2Rpdj5cbiAgKTtcbn07XG5cbkNhcmRGb290ZXIucHJvcFR5cGVzID0ge1xuICBjbGFzc05hbWU6IHN0cmluZyxcbiAgYWxpZ246IG9uZU9mKFsnbGVmdCcsICdyaWdodCcsICdjZW50ZXInXSksXG4gIGNoaWxkcmVuOiBub2RlLFxufTtcbiJdfQ== */"));
};
var CardFooter = function CardFooter(props) {
  var children = props.children,
    className = props.className,
    align = props.align,
    restProps = _objectWithoutProperties$1(props, _excluded$K);
  var cardFooterClass = cx('card-footer', className);
  return jsx("div", _extends$1({}, restProps, {
    css: cssCardFooter(align),
    className: cardFooterClass
  }), children);
};
CardFooter.propTypes = {
  className: string,
  align: oneOf(['left', 'right', 'center']),
  children: node$2
};

var _excluded$J = ["children", "align", "flat", "hover", "className", "borderColor"];
var cssCardBorder = function cssCardBorder(borderColor) {
  return /*#__PURE__*/css("border:1px solid ", typeToColorsMap[borderColor], ";;label:cssCardBorder;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};
var cssContent = function cssContent(align) {
  return /*#__PURE__*/css("display:flex;flex-direction:column;word-wrap:break-word;text-align:", align, ";;label:cssContent;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};
var Card = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$children = props.children,
    children = _props$children === void 0 ? null : _props$children,
    _props$align = props.align,
    align = _props$align === void 0 ? null : _props$align,
    _props$flat = props.flat,
    flat = _props$flat === void 0 ? false : _props$flat,
    _props$hover = props.hover,
    hover = _props$hover === void 0 ? false : _props$hover,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$borderColor = props.borderColor,
    borderColor = _props$borderColor === void 0 ? null : _props$borderColor,
    restProps = _objectWithoutProperties$1(props, _excluded$J);
  var cardClass = cx('fwc-card-generic', {
    flat: flat,
    hover: hover
  }, className);
  return jsx("div", _extends$1({}, restProps, {
    ref: ref,
    css: [cssContent(align), borderColor && cssCardBorder(borderColor), ";label:Card;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")],
    className: cardClass
  }), children);
});
Card.displayName = 'Card';
Card.Header = CardHeader;
Card.Header.displayName = 'Card.Header';
Card.Body = CardBody;
Card.Body.displayName = 'Card.Body';
Card.Footer = CardFooter;
Card.Footer.displayName = 'Card.Footer';
Card.propTypes = {
  className: string,
  borderColor: oneOf(['primary', 'success', 'warning', 'error', 'black', 'white', 'grey']),
  align: oneOf(['left', 'right', 'center']),
  flat: bool,
  hover: bool,
  children: node$2
};

var _excluded$I = ["className", "alignSelf", "left", "right"],
  _excluded2$7 = ["className"],
  _excluded3$2 = ["className", "noMargin"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$z() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssMediaObject = function cssMediaObject(left, right, alignSelf) {
  return /*#__PURE__*/css("align-self:", alignSelf === 'center' ? 'center' : "flex-".concat(alignSelf), ";margin-right:", left ? '1rem' : 'inherit', ";margin-left:", right ? '1rem' : 'inherit', ";;label:cssMediaObject;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1lZGlhLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVNZIiwiZmlsZSI6Ik1lZGlhLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBjeCBmcm9tICdjbGFzc25hbWVzJztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IGJvb2wsIG9uZU9mLCBzdHJpbmcgfSBmcm9tICdwcm9wLXR5cGVzJztcblxuLy8gLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLVxuLy8gU1RBUlQgOjogTWVkaWFPYmplY3QgQ29tcG9uZW50XG4vLyAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tXG5jb25zdCBjc3NNZWRpYU9iamVjdCA9IChsZWZ0LCByaWdodCwgYWxpZ25TZWxmKSA9PiB7XG4gIHJldHVybiBjc3NgXG4gICAgYWxpZ24tc2VsZjogJHthbGlnblNlbGYgPT09ICdjZW50ZXInID8gJ2NlbnRlcicgOiBgZmxleC0ke2FsaWduU2VsZn1gfTtcbiAgICBtYXJnaW4tcmlnaHQ6ICR7bGVmdCA/ICcxcmVtJyA6ICdpbmhlcml0J307XG4gICAgbWFyZ2luLWxlZnQ6ICR7cmlnaHQgPyAnMXJlbScgOiAnaW5oZXJpdCd9O1xuICBgO1xufTtcblxuZXhwb3J0IGNvbnN0IE1lZGlhT2JqZWN0ID0gcHJvcHMgPT4ge1xuICBjb25zdCB7IGNsYXNzTmFtZSwgYWxpZ25TZWxmID0gJ3N0YXJ0JywgbGVmdCwgcmlnaHQsIC4uLnJlc3RQcm9wcyB9ID0gcHJvcHM7XG4gIGNvbnN0IG1lZGlhSXRlbUNsYXNzID0gY3goJ21lZGlhLW9iamVjdCcsIGNsYXNzTmFtZSk7XG4gIHJldHVybiAoXG4gICAgPGRpdlxuICAgICAgey4uLnJlc3RQcm9wc31cbiAgICAgIGNzcz17Y3NzTWVkaWFPYmplY3QobGVmdCwgcmlnaHQsIGFsaWduU2VsZil9XG4gICAgICBjbGFzc05hbWU9e21lZGlhSXRlbUNsYXNzfVxuICAgIC8+XG4gICk7XG59O1xuXG5NZWRpYU9iamVjdC5wcm9wVHlwZXMgPSB7XG4gIGNsYXNzTmFtZTogc3RyaW5nLFxuICBhbGlnblNlbGY6IG9uZU9mKFsnc3RhcnQnLCAnY2VudGVyJywgJ2VuZCddKSxcbiAgbGVmdDogYm9vbCxcbiAgcmlnaHQ6IGJvb2wsXG59O1xuXG4vLyAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tXG4vLyBFTkQgOjogTWVkaWFPYmplY3QgQ29tcG9uZW50XG4vLyAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tXG5cbi8vIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1cbi8vIFNUQVJUIDo6IE1lZGlhQm9keSBDb21wb25lbnRcbi8vIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1cblxuY29uc3QgY3NzTWVkaWFCb2R5ID0gY3NzYFxuICBmbGV4OiAxO1xuICAudGl0bGUge1xuICAgIG1hcmdpbi10b3A6IDA7XG4gICAgbWFyZ2luLWJvdHRvbTogNXB4O1xuICB9XG5gO1xuXG5jb25zdCBNZWRpYUJvZHkgPSBwcm9wcyA9PiB7XG4gIGNvbnN0IHsgY2xhc3NOYW1lLCAuLi5yZXN0UHJvcHMgfSA9IHByb3BzO1xuICBjb25zdCBtZWRpYUJvZHlDbGFzcyA9IGN4KCdtZWRpYS1ib2R5JywgY2xhc3NOYW1lKTtcbiAgcmV0dXJuIDxkaXYgey4uLnJlc3RQcm9wc30gY3NzPXtjc3NNZWRpYUJvZHl9IGNsYXNzTmFtZT17bWVkaWFCb2R5Q2xhc3N9IC8+O1xufTtcblxuTWVkaWFCb2R5LnByb3BUeXBlcyA9IHtcbiAgY2xhc3NOYW1lOiBzdHJpbmcsXG59O1xuXG4vLyAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tXG4vLyBFTkQgOjogTWVkaWFCb2R5IENvbXBvbmVudFxuLy8gLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLVxuXG4vLyAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tXG4vLyBTVEFSVCA6OiBNZWRpYSBDb21wb25lbnRcbi8vIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1cblxuY29uc3QgY3NzTWVkaWFNYXJnaW4gPSBjc3NgXG4gIG1hcmdpbi10b3A6IDEwcHg7XG4gIG1hcmdpbi1ib3R0b206IDEwcHg7XG5gO1xuXG5jb25zdCBjc3NNZWRpYSA9IGNzc2BcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGZsZXgtc3RhcnQ7XG5gO1xuXG5leHBvcnQgY29uc3QgTWVkaWEgPSBwcm9wcyA9PiB7XG4gIGNvbnN0IHsgY2xhc3NOYW1lLCBub01hcmdpbiA9IGZhbHNlLCAuLi5yZXN0UHJvcHMgfSA9IHByb3BzO1xuICBjb25zdCBtZWRpYUNsYXNzID0gY3goeyBtZWRpYTogdHJ1ZSB9LCBjbGFzc05hbWUpO1xuICByZXR1cm4gKFxuICAgIDxkaXZcbiAgICAgIHsuLi5yZXN0UHJvcHN9XG4gICAgICBjc3M9e1tjc3NNZWRpYSwgIW5vTWFyZ2luICYmIGNzc01lZGlhTWFyZ2luXX1cbiAgICAgIGNsYXNzTmFtZT17bWVkaWFDbGFzc31cbiAgICAvPlxuICApO1xufTtcblxuTWVkaWEuQm9keSA9IE1lZGlhQm9keTtcbk1lZGlhLkJvZHkuZGlzcGxheU5hbWUgPSAnTWVkaWEuQm9keSc7XG5cbk1lZGlhLk9iamVjdCA9IE1lZGlhT2JqZWN0O1xuTWVkaWEuT2JqZWN0LmRpc3BsYXlOYW1lID0gJ01lZGlhLk9iamVjdCc7XG5cbk1lZGlhLnByb3BUeXBlcyA9IHtcbiAgbm9NYXJnaW46IGJvb2wsXG4gIGNsYXNzTmFtZTogc3RyaW5nLFxufTtcblxuLy8gLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLVxuLy8gRU5EIDo6IE1lZGlhIENvbXBvbmVudFxuLy8gLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLVxuIl19 */"));
};
var MediaObject = function MediaObject(props) {
  var className = props.className,
    _props$alignSelf = props.alignSelf,
    alignSelf = _props$alignSelf === void 0 ? 'start' : _props$alignSelf,
    left = props.left,
    right = props.right,
    restProps = _objectWithoutProperties$1(props, _excluded$I);
  var mediaItemClass = cx('media-object', className);
  return jsx("div", _extends$1({}, restProps, {
    css: cssMediaObject(left, right, alignSelf),
    className: mediaItemClass
  }));
};
MediaObject.propTypes = {
  className: string,
  alignSelf: oneOf(['start', 'center', 'end']),
  left: bool,
  right: bool
};

// -------------------------------------------------
// END :: MediaObject Component
// -------------------------------------------------

// -------------------------------------------------
// START :: MediaBody Component
// -------------------------------------------------

var cssMediaBody = process.env.NODE_ENV === "production" ? {
  name: "1hbvqcj-cssMediaBody",
  styles: "flex:1;.title{margin-top:0;margin-bottom:5px;};label:cssMediaBody;"
} : {
  name: "1hbvqcj-cssMediaBody",
  styles: "flex:1;.title{margin-top:0;margin-bottom:5px;};label:cssMediaBody;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$z
};
var MediaBody = function MediaBody(props) {
  var className = props.className,
    restProps = _objectWithoutProperties$1(props, _excluded2$7);
  var mediaBodyClass = cx('media-body', className);
  return jsx("div", _extends$1({}, restProps, {
    css: cssMediaBody,
    className: mediaBodyClass
  }));
};
MediaBody.propTypes = {
  className: string
};

// -------------------------------------------------
// END :: MediaBody Component
// -------------------------------------------------

// -------------------------------------------------
// START :: Media Component
// -------------------------------------------------

var cssMediaMargin = process.env.NODE_ENV === "production" ? {
  name: "138yfye-cssMediaMargin",
  styles: "margin-top:10px;margin-bottom:10px;label:cssMediaMargin;"
} : {
  name: "138yfye-cssMediaMargin",
  styles: "margin-top:10px;margin-bottom:10px;label:cssMediaMargin;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$z
};
var cssMedia = process.env.NODE_ENV === "production" ? {
  name: "gohfpr-cssMedia",
  styles: "display:flex;align-items:flex-start;label:cssMedia;"
} : {
  name: "gohfpr-cssMedia",
  styles: "display:flex;align-items:flex-start;label:cssMedia;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$z
};
var Media = function Media(props) {
  var className = props.className,
    _props$noMargin = props.noMargin,
    noMargin = _props$noMargin === void 0 ? false : _props$noMargin,
    restProps = _objectWithoutProperties$1(props, _excluded3$2);
  var mediaClass = cx({
    media: true
  }, className);
  return jsx("div", _extends$1({}, restProps, {
    css: [cssMedia, !noMargin && cssMediaMargin, ";label:Media;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")],
    className: mediaClass
  }));
};
Media.Body = MediaBody;
Media.Body.displayName = 'Media.Body';
Media.Object = MediaObject;
Media.Object.displayName = 'Media.Object';
Media.propTypes = {
  noMargin: bool,
  className: string
};

// -------------------------------------------------
// END :: Media Component
// -------------------------------------------------

var css_248z$9 = "/*\n    Style only for Motif Checkbox\n    Dependencies: icons.css, vars.css\n*/\n\n/* TODO: Make self contained sheet with icon */\n\n/* TODO: Inactive States */\n\n.fwc-checkbox input {\n  position: absolute;\n  left: -99999px;\n}\n\n.fwc-checkbox input[disabled] + label {\n  opacity: var(--disabled-opacity);\n  cursor: default;\n  pointer-events: none;\n}\n\n.fwc-checkbox input[disabled] + label::before {\n  border-color: rgba(var(--color-rgb-gray-three), var(--disabled-opacity));\n  cursor: default;\n  pointer-events: none;\n}\n\n.fwc-checkbox label {\n  display: inline-flex;\n  cursor: pointer;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.fwc-checkbox label::before {\n  content: '\\e906';\n  color: rgba(var(--color-rgb-white), 0);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: var(--fwcu);\n  background-color: white;\n  border-width: 1px;\n  border-style: solid;\n  border-color: var(--color-gray-three);\n  border-radius: calc(0.5 * var(--fwcu));\n  cursor: pointer;\n  font-family: 'fwc-motif-icons' !important;\n  font-size: calc(1.25 * var(--fwcu));\n  line-height: 1;\n  width: calc(2 * var(--fwcu));\n  height: calc(2 * var(--fwcu));\n}\n\n.fwc-checkbox input:checked + label:before {\n  color: white;\n  background-color: var(--color-primary);\n}\n\n.fwc-checkbox input:focus label:before {\n  outline: var(--fwc-focus);\n}\n";
styleInject(css_248z$9);

var _excluded$H = ["id", "name", "value", "label", "className", "disabled", "checked"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$y() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssCheckbox = process.env.NODE_ENV === "production" ? {
  name: "1wfxmmq-cssCheckbox",
  styles: ".checkbox-label{padding:2px;}&.fwc-checkbox-disabled{.checkbox-label{opacity:calc(var(--disabled-opacity) + 0.2);}};label:cssCheckbox;"
} : {
  name: "1wfxmmq-cssCheckbox",
  styles: ".checkbox-label{padding:2px;}&.fwc-checkbox-disabled{.checkbox-label{opacity:calc(var(--disabled-opacity) + 0.2);}};label:cssCheckbox;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZWNrYm94LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU91QiIsImZpbGUiOiJDaGVja2JveC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBmb3J3YXJkUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IGN4IGZyb20gJ2NsYXNzbmFtZXMnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgc3RyaW5nLCBib29sLCBhbnksIG5vZGUgfSBmcm9tICdwcm9wLXR5cGVzJztcblxuaW1wb3J0ICcuLi8uLi9wdWJsaWMvZndjLWFzc2V0cy9zdHlsZXMvY29tcG9uZW50cy9md2MtY2hlY2tib3guY3NzJztcblxuY29uc3QgY3NzQ2hlY2tib3ggPSBjc3NgXG4gIC5jaGVja2JveC1sYWJlbCB7XG4gICAgcGFkZGluZzogMnB4O1xuICB9XG4gICYuZndjLWNoZWNrYm94LWRpc2FibGVkIHtcbiAgICAuY2hlY2tib3gtbGFiZWwge1xuICAgICAgb3BhY2l0eTogY2FsYyh2YXIoLS1kaXNhYmxlZC1vcGFjaXR5KSArIDAuMik7XG4gICAgfVxuICB9XG5gO1xuXG5leHBvcnQgY29uc3QgQ2hlY2tib3ggPSBmb3J3YXJkUmVmKChwcm9wcywgcmVmKSA9PiB7XG4gIGNvbnN0IHtcbiAgICBpZCxcbiAgICBuYW1lLFxuICAgIHZhbHVlLFxuICAgIGxhYmVsLFxuICAgIGNsYXNzTmFtZSxcbiAgICBkaXNhYmxlZCA9IGZhbHNlLFxuICAgIGNoZWNrZWQgPSBmYWxzZSxcbiAgICAuLi5yZXN0UHJvcHNcbiAgfSA9IHByb3BzO1xuICBjb25zdCBDaGVja2JveERpdkNsYXNzID0gY3goXG4gICAgJ2Z3Yy1jaGVja2JveCcsXG4gICAgeyAnZndjLWNoZWNrYm94LWRpc2FibGVkJzogZGlzYWJsZWQgfSxcbiAgICBjbGFzc05hbWUsXG4gICk7XG4gIHJldHVybiAoXG4gICAgPGRpdiBjbGFzc05hbWU9e0NoZWNrYm94RGl2Q2xhc3N9IGNzcz17Y3NzQ2hlY2tib3h9PlxuICAgICAgPGlucHV0XG4gICAgICAgIHsuLi5yZXN0UHJvcHN9XG4gICAgICAgIHJlZj17cmVmfVxuICAgICAgICB0eXBlPVwiY2hlY2tib3hcIlxuICAgICAgICBuYW1lPXtuYW1lfVxuICAgICAgICB2YWx1ZT17dmFsdWV9XG4gICAgICAgIGlkPXtpZCB8fCBuYW1lfVxuICAgICAgICBkaXNhYmxlZD17ZGlzYWJsZWR9XG4gICAgICAgIGNoZWNrZWQ9e2NoZWNrZWR9XG4gICAgICAvPlxuICAgICAgPGxhYmVsIGNsYXNzTmFtZT1cImNoZWNrYm94LWxhYmVsXCIgaHRtbEZvcj17aWQgfHwgbmFtZX0+XG4gICAgICAgIHtsYWJlbH1cbiAgICAgIDwvbGFiZWw+XG4gICAgPC9kaXY+XG4gICk7XG59KTtcblxuQ2hlY2tib3guZGlzcGxheU5hbWUgPSAnQ2hlY2tib3gnO1xuQ2hlY2tib3gucHJvcFR5cGVzID0ge1xuICBpZDogc3RyaW5nLFxuICB2YWx1ZTogYW55LFxuICBuYW1lOiBzdHJpbmcsXG4gIGxhYmVsOiBub2RlLFxuICBjbGFzc05hbWU6IHN0cmluZyxcbiAgZGlzYWJsZWQ6IGJvb2wsXG4gIGNoZWNrZWQ6IGJvb2wsXG59O1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$y
};
var Checkbox = /*#__PURE__*/forwardRef(function (props, ref) {
  var id = props.id,
    name = props.name,
    value = props.value,
    label = props.label,
    className = props.className,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$checked = props.checked,
    checked = _props$checked === void 0 ? false : _props$checked,
    restProps = _objectWithoutProperties$1(props, _excluded$H);
  var CheckboxDivClass = cx('fwc-checkbox', {
    'fwc-checkbox-disabled': disabled
  }, className);
  return jsx("div", {
    className: CheckboxDivClass,
    css: cssCheckbox
  }, jsx("input", _extends$1({}, restProps, {
    ref: ref,
    type: "checkbox",
    name: name,
    value: value,
    id: id || name,
    disabled: disabled,
    checked: checked
  })), jsx("label", {
    className: "checkbox-label",
    htmlFor: id || name
  }, label));
});
Checkbox.displayName = 'Checkbox';
Checkbox.propTypes = {
  id: string,
  value: any,
  name: string,
  label: node$2,
  className: string,
  disabled: bool,
  checked: bool
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$x() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssErrorMessage = process.env.NODE_ENV === "production" ? {
  name: "ztu163-cssErrorMessage",
  styles: "color:var(--color-alert-error);display:flex;align-items:center;padding-top:var(--fwcu);&::before{color:var(--color-alert-error);font-size:calc(1.75 * var(--fwcu));};label:cssErrorMessage;"
} : {
  name: "ztu163-cssErrorMessage",
  styles: "color:var(--color-alert-error);display:flex;align-items:center;padding-top:var(--fwcu);&::before{color:var(--color-alert-error);font-size:calc(1.75 * var(--fwcu));};label:cssErrorMessage;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkhlbHBlck1lc3NhZ2UuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSzJCIiwiZmlsZSI6IkhlbHBlck1lc3NhZ2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgdXNlTWVtbyB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IHN0cmluZywgYm9vbCwgb25lT2ZUeXBlLCBhcnJheU9mLCBub2RlIH0gZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgeyBJY29uIH0gZnJvbSAnLi4vSWNvbic7XG5cbmNvbnN0IGNzc0Vycm9yTWVzc2FnZSA9IGNzc2BcbiAgY29sb3I6IHZhcigtLWNvbG9yLWFsZXJ0LWVycm9yKTtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgcGFkZGluZy10b3A6IHZhcigtLWZ3Y3UpO1xuXG4gICY6OmJlZm9yZSB7XG4gICAgY29sb3I6IHZhcigtLWNvbG9yLWFsZXJ0LWVycm9yKTtcbiAgICBmb250LXNpemU6IGNhbGMoMS43NSAqIHZhcigtLWZ3Y3UpKTtcbiAgfVxuYDtcblxuY29uc3QgRXJyb3JNZXNzYWdlID0gcHJvcHMgPT4gKFxuICA8SWNvblxuICAgIHsuLi5wcm9wc31cbiAgICBpbmxpbmVcbiAgICBuYW1lPVwiZGVsZXRlXCJcbiAgICBjc3M9e2Nzc0Vycm9yTWVzc2FnZX1cbiAgICBjbGFzc05hbWU9XCJlcnJvci1tZXNzYWdlXCJcbiAgLz5cbik7XG5cbmV4cG9ydCBmdW5jdGlvbiBIZWxwZXJNZXNzYWdlKHByb3BzKSB7XG4gIGNvbnN0IHsgdG91Y2hlZCwgaGVscGVyVGV4dCB9ID0gcHJvcHMgfHwge307XG5cbiAgY29uc3QgZGlzcGxheUhlbHBlclRleHQgPSB1c2VNZW1vKCgpID0+IHtcbiAgICBpZiAodG91Y2hlZCAmJiBoZWxwZXJUZXh0KSB7XG4gICAgICByZXR1cm4gQXJyYXkuaXNBcnJheShoZWxwZXJUZXh0KSA/IGhlbHBlclRleHQ/Lmxlbmd0aCA+IDAgOiB0cnVlO1xuICAgIH0gZWxzZSB7XG4gICAgICByZXR1cm4gZmFsc2U7XG4gICAgfVxuICB9LCBbdG91Y2hlZCwgaGVscGVyVGV4dF0pO1xuXG4gIHJldHVybiAoXG4gICAgPD5cbiAgICAgIHtkaXNwbGF5SGVscGVyVGV4dCAmJlxuICAgICAgICAoQXJyYXkuaXNBcnJheShoZWxwZXJUZXh0KSA/IChcbiAgICAgICAgICBoZWxwZXJUZXh0Py5tYXAobXNnID0+IDxFcnJvck1lc3NhZ2Uga2V5PXttc2d9Pnttc2d9PC9FcnJvck1lc3NhZ2U+KVxuICAgICAgICApIDogKFxuICAgICAgICAgIDxFcnJvck1lc3NhZ2U+e2hlbHBlclRleHR9PC9FcnJvck1lc3NhZ2U+XG4gICAgICAgICkpfVxuICAgIDwvPlxuICApO1xufVxuXG5IZWxwZXJNZXNzYWdlLnByb3BUeXBlcyA9IHtcbiAgdG91Y2hlZDogYm9vbCxcbiAgaGVscGVyVGV4dDogb25lT2ZUeXBlKFtzdHJpbmcsIG5vZGUsIGFycmF5T2Yobm9kZSldKSxcbn07XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$x
};
var ErrorMessage = function ErrorMessage(props) {
  return jsx(Icon, _extends$1({}, props, {
    inline: true,
    name: "delete",
    css: cssErrorMessage,
    className: "error-message"
  }));
};
function HelperMessage(props) {
  var _ref = props || {},
    touched = _ref.touched,
    helperText = _ref.helperText;
  var displayHelperText = useMemo(function () {
    if (touched && helperText) {
      return Array.isArray(helperText) ? (helperText === null || helperText === void 0 ? void 0 : helperText.length) > 0 : true;
    } else {
      return false;
    }
  }, [touched, helperText]);
  return jsx(React__default.Fragment, null, displayHelperText && (Array.isArray(helperText) ? helperText === null || helperText === void 0 ? void 0 : helperText.map(function (msg) {
    return jsx(ErrorMessage, {
      key: msg
    }, msg);
  }) : jsx(ErrorMessage, null, helperText)));
}
HelperMessage.propTypes = {
  touched: bool,
  helperText: oneOfType([string, node$2, arrayOf(node$2)])
};

var _excluded$G = ["className", "label", "layout", "cbLayout", "name", "value", "touched", "helperText", "options", "onChange", "onBlur"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$w() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssCheckboxGroupHorizontal = function cssCheckboxGroupHorizontal(cbLayout) {
  return /*#__PURE__*/css("flex-flow:row nowrap;.field-label{width:30%;margin-top:", cbLayout === 'row' ? '5px' : '2px', ";margin-right:10px;text-align:right;}.field-control{width:70%;display:flex;flex-flow:", cbLayout, " wrap;}@media screen and (max-width: 420px){flex-flow:column wrap;.field-label{width:100%;margin-top:0px;margin-right:0px;text-align:start;}.field-control{width:100%;}};label:cssCheckboxGroupHorizontal;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};
var cssCheckboxGroupVertical = function cssCheckboxGroupVertical(cbLayout) {
  return /*#__PURE__*/css("flex-flow:column wrap;.field-control{display:flex;flex-flow:", cbLayout, " wrap;};label:cssCheckboxGroupVertical;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};
var cssCheckboxGroup = process.env.NODE_ENV === "production" ? {
  name: "k3t3z7-cssCheckboxGroup",
  styles: "display:flex;flex-flow:column wrap;margin-bottom:20px;.field-label{label{font-weight:bold;}}.fwc-checkbox{padding-right:10px;};label:cssCheckboxGroup;"
} : {
  name: "k3t3z7-cssCheckboxGroup",
  styles: "display:flex;flex-flow:column wrap;margin-bottom:20px;.field-label{label{font-weight:bold;}}.fwc-checkbox{padding-right:10px;};label:cssCheckboxGroup;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$w
};
var CheckboxGroup = function CheckboxGroup(props) {
  var className = props.className,
    _props$label = props.label,
    label = _props$label === void 0 ? '' : _props$label,
    _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'vertical' : _props$layout,
    _props$cbLayout = props.cbLayout,
    cbLayout = _props$cbLayout === void 0 ? 'column' : _props$cbLayout,
    name = props.name,
    _props$value = props.value,
    value = _props$value === void 0 ? [] : _props$value,
    _props$touched = props.touched,
    touched = _props$touched === void 0 ? false : _props$touched,
    _props$helperText = props.helperText,
    helperText = _props$helperText === void 0 ? '' : _props$helperText,
    _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    onChange = props.onChange,
    onBlur = props.onBlur,
    rest = _objectWithoutProperties$1(props, _excluded$G);
  var handleChange = useCallback(function (e) {
    var _e$target, _newValues;
    var newValues = _toConsumableArray(value || []);
    var newVal = (e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value) || '';
    if ((_newValues = newValues) !== null && _newValues !== void 0 && _newValues.includes(newVal)) {
      var _newValues2;
      newValues = (_newValues2 = newValues) === null || _newValues2 === void 0 ? void 0 : _newValues2.filter(function (val) {
        return val !== newVal;
      });
    } else {
      newValues = [].concat(_toConsumableArray(newValues), [newVal]);
    }
    onChange(e, newValues);
  }, [value, onChange]);
  return jsx("div", _extends$1({}, rest, {
    className: cx('field-checkbox-group', className),
    css: [cssCheckboxGroup, layout === 'vertical' ? cssCheckboxGroupVertical(cbLayout) : cssCheckboxGroupHorizontal(cbLayout), ";label:CheckboxGroup;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")]
  }), label && jsx("div", {
    className: "field-label"
  }, jsx("label", null, label)), jsx("div", {
    className: "field-control"
  }, options === null || options === void 0 ? void 0 : options.map(function (opt) {
    return jsx(Checkbox, _extends$1({}, opt, {
      key: opt === null || opt === void 0 ? void 0 : opt.value,
      name: name,
      id: "checkbox-group-".concat(opt === null || opt === void 0 ? void 0 : opt.value),
      checked: (value === null || value === void 0 ? void 0 : value.includes(opt === null || opt === void 0 ? void 0 : opt.value)) || false,
      onChange: handleChange,
      onBlur: onBlur
    }));
  }), jsx(HelperMessage, {
    touched: touched,
    helperText: helperText
  })));
};
CheckboxGroup.propTypes = {
  className: string,
  layout: oneOf(['vertical', 'horizontal']),
  cbLayout: oneOf(['row', 'column']),
  label: string,
  name: string,
  value: array$2,
  touched: bool,
  helperText: oneOfType([string, node$2, arrayOf(node$2)]),
  options: arrayOf(shape({
    label: string,
    value: string,
    disabled: bool
  })),
  onChange: func,
  onBlur: func
};

var _excluded$F = ["id", "name", "value", "label", "className", "disabled"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$v() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssRadio = process.env.NODE_ENV === "production" ? {
  name: "108vngp-cssRadio",
  styles: ".radio-label{padding:2px;}&.fwc-radio-disabled{.radio-label{opacity:calc(var(--disabled-opacity) + 0.2);}};label:cssRadio;"
} : {
  name: "108vngp-cssRadio",
  styles: ".radio-label{padding:2px;}&.fwc-radio-disabled{.radio-label{opacity:calc(var(--disabled-opacity) + 0.2);}};label:cssRadio;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJhZGlvLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUtvQiIsImZpbGUiOiJSYWRpby5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBmb3J3YXJkUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IGN4IGZyb20gJ2NsYXNzbmFtZXMnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgc3RyaW5nLCBib29sLCBhbnkgfSBmcm9tICdwcm9wLXR5cGVzJztcblxuY29uc3QgY3NzUmFkaW8gPSBjc3NgXG4gIC5yYWRpby1sYWJlbCB7XG4gICAgcGFkZGluZzogMnB4O1xuICB9XG4gICYuZndjLXJhZGlvLWRpc2FibGVkIHtcbiAgICAucmFkaW8tbGFiZWwge1xuICAgICAgb3BhY2l0eTogY2FsYyh2YXIoLS1kaXNhYmxlZC1vcGFjaXR5KSArIDAuMik7XG4gICAgfVxuICB9XG5gO1xuXG5leHBvcnQgY29uc3QgUmFkaW8gPSBmb3J3YXJkUmVmKChwcm9wcywgcmVmKSA9PiB7XG4gIGNvbnN0IHtcbiAgICBpZCxcbiAgICBuYW1lLFxuICAgIHZhbHVlLFxuICAgIGxhYmVsLFxuICAgIGNsYXNzTmFtZSxcbiAgICBkaXNhYmxlZCA9IGZhbHNlLFxuICAgIC4uLnJlc3RQcm9wc1xuICB9ID0gcHJvcHM7XG4gIGNvbnN0IHJhZGlvRGl2Q2xhc3MgPSBjeChcbiAgICAnZndjLXJhZGlvJyxcbiAgICB7ICdmd2MtcmFkaW8tZGlzYWJsZWQnOiBkaXNhYmxlZCB9LFxuICAgIGNsYXNzTmFtZSxcbiAgKTtcbiAgcmV0dXJuIChcbiAgICA8ZGl2IGNsYXNzTmFtZT17cmFkaW9EaXZDbGFzc30gY3NzPXtjc3NSYWRpb30+XG4gICAgICA8aW5wdXRcbiAgICAgICAgey4uLnJlc3RQcm9wc31cbiAgICAgICAgcmVmPXtyZWZ9XG4gICAgICAgIHR5cGU9XCJyYWRpb1wiXG4gICAgICAgIG5hbWU9e25hbWV9XG4gICAgICAgIHZhbHVlPXt2YWx1ZX1cbiAgICAgICAgaWQ9e2lkIHx8IG5hbWV9XG4gICAgICAgIGRpc2FibGVkPXtkaXNhYmxlZH1cbiAgICAgIC8+XG4gICAgICA8bGFiZWwgY2xhc3NOYW1lPVwicmFkaW8tbGFiZWxcIiBodG1sRm9yPXtpZCB8fCBuYW1lfT5cbiAgICAgICAge2xhYmVsfVxuICAgICAgPC9sYWJlbD5cbiAgICA8L2Rpdj5cbiAgKTtcbn0pO1xuXG5SYWRpby5kaXNwbGF5TmFtZSA9ICdSYWRpbyc7XG5SYWRpby5wcm9wVHlwZXMgPSB7XG4gIGlkOiBzdHJpbmcsXG4gIHZhbHVlOiBhbnksXG4gIG5hbWU6IHN0cmluZyxcbiAgbGFiZWw6IHN0cmluZyxcbiAgY2xhc3NOYW1lOiBzdHJpbmcsXG4gIGRpc2FibGVkOiBib29sLFxufTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$v
};
var Radio = /*#__PURE__*/forwardRef(function (props, ref) {
  var id = props.id,
    name = props.name,
    value = props.value,
    label = props.label,
    className = props.className,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    restProps = _objectWithoutProperties$1(props, _excluded$F);
  var radioDivClass = cx('fwc-radio', {
    'fwc-radio-disabled': disabled
  }, className);
  return jsx("div", {
    className: radioDivClass,
    css: cssRadio
  }, jsx("input", _extends$1({}, restProps, {
    ref: ref,
    type: "radio",
    name: name,
    value: value,
    id: id || name,
    disabled: disabled
  })), jsx("label", {
    className: "radio-label",
    htmlFor: id || name
  }, label));
});
Radio.displayName = 'Radio';
Radio.propTypes = {
  id: string,
  value: any,
  name: string,
  label: string,
  className: string,
  disabled: bool
};

var _excluded$E = ["label", "className", "layout", "name", "value", "touched", "helperText", "options", "rLayout"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$u() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssRadioGroupHorizontal = function cssRadioGroupHorizontal(rLayout) {
  return /*#__PURE__*/css("flex-flow:row nowrap;.field-label{width:30%;margin-top:", rLayout === 'row' ? '5px' : '2px', ";margin-right:10px;text-align:right;}.field-control{width:70%;display:flex;flex-flow:", rLayout, " wrap;}@media screen and (max-width: 420px){flex-flow:column wrap;.field-label{width:100%;margin-top:0px;margin-right:0px;text-align:start;}.field-control{width:100%;}};label:cssRadioGroupHorizontal;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};
var cssRadioGroupVertical = function cssRadioGroupVertical(rLayout) {
  return /*#__PURE__*/css("flex-flow:column wrap;.field-control{display:flex;flex-flow:", rLayout, " wrap;};label:cssRadioGroupVertical;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};
var cssRadioGroup = process.env.NODE_ENV === "production" ? {
  name: "1ak3lce-cssRadioGroup",
  styles: "display:flex;flex-flow:column wrap;margin-bottom:20px;.field-label{label{font-weight:bold;}}.fwc-radio{padding-right:10px;width:auto;};label:cssRadioGroup;"
} : {
  name: "1ak3lce-cssRadioGroup",
  styles: "display:flex;flex-flow:column wrap;margin-bottom:20px;.field-label{label{font-weight:bold;}}.fwc-radio{padding-right:10px;width:auto;};label:cssRadioGroup;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$u
};
function RadioGroup(props) {
  var label = props.label,
    className = props.className,
    _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'vertical' : _props$layout,
    name = props.name,
    value = props.value,
    touched = props.touched,
    helperText = props.helperText,
    _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    _props$rLayout = props.rLayout,
    rLayout = _props$rLayout === void 0 ? 'column' : _props$rLayout,
    restProps = _objectWithoutProperties$1(props, _excluded$E);
  return jsx("div", _extends$1({}, restProps, {
    css: [cssRadioGroup, layout === 'vertical' ? cssRadioGroupVertical(rLayout) : cssRadioGroupHorizontal(rLayout), ";label:RadioGroup;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")],
    className: cx('field-radio-group', className)
  }), label && jsx("div", {
    className: "field-label"
  }, jsx("label", null, label)), jsx("div", {
    className: "field-control"
  }, options === null || options === void 0 ? void 0 : options.map(function (opt) {
    return jsx(Radio, _extends$1({}, opt, {
      key: opt === null || opt === void 0 ? void 0 : opt.value,
      name: name,
      id: "radio-group-".concat(opt === null || opt === void 0 ? void 0 : opt.value),
      checked: (opt === null || opt === void 0 ? void 0 : opt.value) === value,
      onChange: props.onChange,
      onBlur: props.onBlur
    }));
  }), jsx(HelperMessage, {
    touched: touched,
    helperText: helperText
  })));
}
RadioGroup.propTypes = {
  className: string,
  layout: oneOf(['vertical', 'horizontal']),
  rLayout: oneOf(['row', 'column']),
  label: string,
  name: string,
  value: oneOfType([string, number$4]),
  touched: bool,
  helperText: oneOfType([string, node$2, arrayOf(node$2)]),
  options: arrayOf(shape({
    label: string,
    value: string,
    disabled: bool
  })),
  onChange: func,
  onBlur: func
};

var css_248z$8 = ".fwc-select-list {\n  position: relative;\n}\n.fwc-select-list select {\n  border: 1px solid var(--color-gray-three);\n  width: 100%;\n  -webkit-appearance: none;\n  appearance: none;\n  color: var(--color-primary);\n  padding: calc(0.5 * var(--fwcu)) calc(1.25 * var(--fwcu));\n  height: calc(5 * var(--fwcu));\n  text-align: left;\n  border-radius: var(--border-radius);\n  box-shadow: var(--box-shadow-light);\n  cursor: pointer;\n  background-repeat: no-repeat;\n  background-color: var(--color-white);\n  background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZD0iTTAsMTIuOCBDMCwxNC41NjczMTEyIDEuNDMyNjg4OCwxNiAzLjIsMTYgTDMuMiwxNiBMMCwxNiBaIE0xNiwxMi44IEwxNiwxNiBMMTIuOCwxNiBDMTQuNTY3MzExMiwxNiAxNiwxNC41NjczMTEyIDE2LDEyLjggTDE2LDEyLjggWiBNMTYsMy4yIEMxNiwxLjQzMjY4ODggMTQuNTY3MzExMiwwIDEyLjgsMCBMMTIuOCwwIEwxNiwwIFogTTAsMCBMMy4yLDAgQzEuNDMyNjg4OCwwIDAsMS40MzI2ODg4IDAsMy4yIEwwLDMuMiBMMCwwIFoiLz4KICAgIDxwYXRoIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTkuNjQ1NDgzMzkgOS42TDYuNCA5LjZDNi4yMzAyNjE0NCA5LjYgNi4wNjc0NzQ5NCA5LjY2NzQyODM4IDUuOTQ3NDUxNjUgOS43ODc0NTE2NSA1LjcxMDY3MDYyIDEwLjAyNDIzMjcgNS42OTgyMDg0NSAxMC40MDAzODc2IDUuOTEwMDY1MTggMTAuNjUxODM5Nkw1Ljk0NzQ1MTY1IDEwLjY5MjU0ODQgNy41NzAxOTMzNCAxMi4zMTUyOUM3LjgwNjk3NDQgMTIuNTUyMDcxMSA4LjE4MzEyOTM0IDEyLjU2NDUzMzIgOC40MzQ1ODEzMSAxMi4zNTI2NzY1TDguNDc1MjkwMDUgMTIuMzE1MjkgMTAuMDk4MDMxNyAxMC42OTI1NDg0QzEwLjIxODA1NSAxMC41NzI1MjUxIDEwLjI4NTQ4MzQgMTAuNDA5NzM4NiAxMC4yODU0ODM0IDEwLjI0IDEwLjI4NTQ4MzQgOS45MDI2MDQyMiAxMC4wMjQ0MDI1IDkuNjI2MTg3MTcgOS42OTMyNDczNiA5LjYwMTc1NTQyTDkuNjQ1NDgzMzkgOS42ek04LjQ3NTI5MDA1IDMuMzg3NDUxNjVDOC4yMzg1MDg5OSAzLjE1MDY3MDYxIDcuODYyMzU0MDggMy4xMzgyMDg0NSA3LjYxMDkwMjA4IDMuMzUwMDY1MThMNy41NzAxOTMzNCAzLjM4NzQ1MTY1IDUuOTQ3NDUxNjUgNS4wMTAxOTMzNEM1LjgyNzQyODM4IDUuMTMwMjE2NjQgNS43NiA1LjI5MzAwMzE0IDUuNzYgNS40NjI3NDE3IDUuNzYgNS44MDAxMzc0NyA2LjAyMTA4MDkgNi4wNzY1NTQ1MyA2LjM1MjIzNjA2IDYuMTAwOTg2MjdMNi40IDYuMTAyNzQxNyA5LjY0NTQ4MzM5IDYuMTAyNzQxN0M5LjgxNTIyMTk1IDYuMTAyNzQxNyA5Ljk3ODAwODQ1IDYuMDM1MzEzMzEgMTAuMDk4MDMxNyA1LjkxNTI5MDA1IDEwLjMzNDgxMjggNS42Nzg1MDg5OSAxMC4zNDcyNzQ5IDUuMzAyMzU0MDggMTAuMTM1NDE4MiA1LjA1MDkwMjA4TDEwLjA5ODAzMTcgNS4wMTAxOTMzNCA4LjQ3NTI5MDA1IDMuMzg3NDUxNjV6Ii8+CiAgPC9nPgo8L3N2Zz4K'),\n    linear-gradient(var(--color-primary), var(--color-primary));\n  background-position: 95% 50%;\n  background-size: calc(2 * var(--fwcu)) calc(2 * var(--fwcu));\n  font-weight: bold;\n}\n/*\n    Background images are base64'd versions of fwc-icon-select inversed. Color of arrows, and inversed corners comes from image and matches background-color of select element.\n    The 2nd background-image (gradient) is set to a solid primary color\n*/\n.fwc-select-list.dark select {\n  color: var(--color-white);\n  background-color: var(--color-gray-one);\n  background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8ZyBmaWxsPSIjMzMzIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZD0iTTAsMTIuOCBDMCwxNC41NjczMTEyIDEuNDMyNjg4OCwxNiAzLjIsMTYgTDMuMiwxNiBMMCwxNiBaIE0xNiwxMi44IEwxNiwxNiBMMTIuOCwxNiBDMTQuNTY3MzExMiwxNiAxNiwxNC41NjczMTEyIDE2LDEyLjggTDE2LDEyLjggWiBNMTYsMy4yIEMxNiwxLjQzMjY4ODggMTQuNTY3MzExMiwwIDEyLjgsMCBMMTIuOCwwIEwxNiwwIFogTTAsMCBMMy4yLDAgQzEuNDMyNjg4OCwwIDAsMS40MzI2ODg4IDAsMy4yIEwwLDMuMiBMMCwwIFoiLz4KICAgIDxwYXRoIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTkuNjQ1NDgzMzkgOS42TDYuNCA5LjZDNi4yMzAyNjE0NCA5LjYgNi4wNjc0NzQ5NCA5LjY2NzQyODM4IDUuOTQ3NDUxNjUgOS43ODc0NTE2NSA1LjcxMDY3MDYyIDEwLjAyNDIzMjcgNS42OTgyMDg0NSAxMC40MDAzODc2IDUuOTEwMDY1MTggMTAuNjUxODM5Nkw1Ljk0NzQ1MTY1IDEwLjY5MjU0ODQgNy41NzAxOTMzNCAxMi4zMTUyOUM3LjgwNjk3NDQgMTIuNTUyMDcxMSA4LjE4MzEyOTM0IDEyLjU2NDUzMzIgOC40MzQ1ODEzMSAxMi4zNTI2NzY1TDguNDc1MjkwMDUgMTIuMzE1MjkgMTAuMDk4MDMxNyAxMC42OTI1NDg0QzEwLjIxODA1NSAxMC41NzI1MjUxIDEwLjI4NTQ4MzQgMTAuNDA5NzM4NiAxMC4yODU0ODM0IDEwLjI0IDEwLjI4NTQ4MzQgOS45MDI2MDQyMiAxMC4wMjQ0MDI1IDkuNjI2MTg3MTcgOS42OTMyNDczNiA5LjYwMTc1NTQyTDkuNjQ1NDgzMzkgOS42ek04LjQ3NTI5MDA1IDMuMzg3NDUxNjVDOC4yMzg1MDg5OSAzLjE1MDY3MDYxIDcuODYyMzU0MDggMy4xMzgyMDg0NSA3LjYxMDkwMjA4IDMuMzUwMDY1MThMNy41NzAxOTMzNCAzLjM4NzQ1MTY1IDUuOTQ3NDUxNjUgNS4wMTAxOTMzNEM1LjgyNzQyODM4IDUuMTMwMjE2NjQgNS43NiA1LjI5MzAwMzE0IDUuNzYgNS40NjI3NDE3IDUuNzYgNS44MDAxMzc0NyA2LjAyMTA4MDkgNi4wNzY1NTQ1MyA2LjM1MjIzNjA2IDYuMTAwOTg2MjdMNi40IDYuMTAyNzQxNyA5LjY0NTQ4MzM5IDYuMTAyNzQxN0M5LjgxNTIyMTk1IDYuMTAyNzQxNyA5Ljk3ODAwODQ1IDYuMDM1MzEzMzEgMTAuMDk4MDMxNyA1LjkxNTI5MDA1IDEwLjMzNDgxMjggNS42Nzg1MDg5OSAxMC4zNDcyNzQ5IDUuMzAyMzU0MDggMTAuMTM1NDE4MiA1LjA1MDkwMjA4TDEwLjA5ODAzMTcgNS4wMTAxOTMzNCA4LjQ3NTI5MDA1IDMuMzg3NDUxNjV6Ii8+CiAgPC9nPgo8L3N2Zz4K'),\n    linear-gradient(var(--color-gray-five), var(--color-gray-five));\n}\n.fwc-select-list select:disabled {\n  border-color: rgba(var(--color-rgb-gray-three), var(--disabled-opacity));\n  background-color: rgba(var(--color-rgb-white), var(--disabled-opacity));\n  pointer-events: none;\n}\n.fwc-select-list.dark select:disabled {\n  background-color: rgba(var(--color-rgb-gray-one), var(--disabled-opacity));\n}\n.fwc-select-list.fwc-disabled label {\n  opacity: var(--disabled-opacity);\n}\n/*Focus styles*/\n.fwc-select-list select:focus {\n  outline: var(--fwc-focus);\n}\n";
styleInject(css_248z$8);

var _excluded$D = ["id", "name", "label", "value", "placeholder", "layout", "disabled", "dark", "touched", "helperText", "className", "options"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$t() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssSelectHorizontal = process.env.NODE_ENV === "production" ? {
  name: "1tuog4z-cssSelectHorizontal",
  styles: "display:flex;flex-flow:row nowrap;.field-label{width:30%;margin-top:10px;margin-right:10px;text-align:right;}.field-control{width:70%;}@media screen and (max-width: 420px){flex-flow:column wrap;.field-label{width:100%;margin-top:0px;margin-right:0px;text-align:start;}.field-control{width:100%;}};label:cssSelectHorizontal;"
} : {
  name: "1tuog4z-cssSelectHorizontal",
  styles: "display:flex;flex-flow:row nowrap;.field-label{width:30%;margin-top:10px;margin-right:10px;text-align:right;}.field-control{width:70%;}@media screen and (max-width: 420px){flex-flow:column wrap;.field-label{width:100%;margin-top:0px;margin-right:0px;text-align:start;}.field-control{width:100%;}};label:cssSelectHorizontal;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$t
};
var cssSelectVertical = process.env.NODE_ENV === "production" ? {
  name: "4brfr6-cssSelectVertical",
  styles: "display:flex;flex-flow:column wrap;label:cssSelectVertical;"
} : {
  name: "4brfr6-cssSelectVertical",
  styles: "display:flex;flex-flow:column wrap;label:cssSelectVertical;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$t
};
var cssSelect$1 = process.env.NODE_ENV === "production" ? {
  name: "4txqbs-cssSelect",
  styles: "margin-bottom:20px;.field-label{.select-label{font-weight:bold;}}.fwc-select{border:1px solid var(--color-gray-six);background-position:right 10px center;}.fwc-select[aria-invalid='true']{border-color:var(--color-alert-error);}&.fwc-select-disabled{.field-label{opacity:calc(var(--disabled-opacity) + 0.2);}.field-control .fwc-select{opacity:calc(var(--disabled-opacity) + 0.4);}};label:cssSelect;"
} : {
  name: "4txqbs-cssSelect",
  styles: "margin-bottom:20px;.field-label{.select-label{font-weight:bold;}}.fwc-select{border:1px solid var(--color-gray-six);background-position:right 10px center;}.fwc-select[aria-invalid='true']{border-color:var(--color-alert-error);}&.fwc-select-disabled{.field-label{opacity:calc(var(--disabled-opacity) + 0.2);}.field-control .fwc-select{opacity:calc(var(--disabled-opacity) + 0.4);}};label:cssSelect;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$t
};
var Select = /*#__PURE__*/forwardRef(function (props, ref) {
  var id = props.id,
    name = props.name,
    label = props.label,
    value = props.value,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? '-- Select the option --' : _props$placeholder,
    _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'vertical' : _props$layout,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$dark = props.dark,
    dark = _props$dark === void 0 ? false : _props$dark,
    touched = props.touched,
    helperText = props.helperText,
    className = props.className,
    options = props.options,
    restProps = _objectWithoutProperties$1(props, _excluded$D);
  var selectDivClass = cx({
    'field-select': true,
    'fwc-select-list': true,
    dark: dark,
    'fwc-select-disabled': disabled
  }, className);
  return jsx("div", {
    className: selectDivClass,
    css: [cssSelect$1, layout === 'vertical' ? cssSelectVertical : cssSelectHorizontal, ";label:Select;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")]
  }, label && jsx("div", {
    className: "field-label"
  }, jsx("label", {
    className: "select-label",
    htmlFor: id || name
  }, label)), jsx("div", {
    className: "field-control"
  }, jsx("select", _extends$1({}, restProps, {
    ref: ref,
    id: id || name,
    className: "fwc-select",
    name: name,
    value: value || '',
    placeholder: placeholder,
    disabled: disabled,
    "aria-invalid": touched && !!helperText,
    multiple: false
  }), options === null || options === void 0 ? void 0 : options.map(function (opt) {
    return jsx("option", {
      key: opt.value,
      value: opt.value
    }, opt.label);
  })), jsx(HelperMessage, {
    touched: touched,
    helperText: helperText
  })));
});
Select.displayName = 'Select';
Select.propTypes = {
  id: string,
  label: string,
  name: string,
  value: string,
  layout: oneOf(['vertical', 'horizontal']),
  disabled: bool,
  placeholder: string,
  dark: bool,
  className: string,
  touched: bool,
  helperText: oneOfType([string, node$2, arrayOf(node$2)]),
  options: arrayOf(shape({
    label: string,
    value: string
  }))
};

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$2(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$2;

var eq$1 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;

var _ListCache = ListCache$4;

var ListCache$3 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$3;
  this.size = 0;
}

var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$1(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$1(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$1(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$1;

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$9 = freeGlobal || freeSelf || Function('return this')();

var _root = root$9;

var root$8 = _root;

/** Built-in value references. */
var Symbol$5 = root$8.Symbol;

var _Symbol = Symbol$5;

var Symbol$4 = _Symbol;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$c.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$9.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto$b = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$b.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

var Symbol$3 = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$3 ? Symbol$3.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$5(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

var _baseGetTag = baseGetTag$5;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$7(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$7;

var baseGetTag$4 = _baseGetTag,
    isObject$6 = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$3(value) {
  if (!isObject$6(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$4(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$3;

var root$7 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$7['__core-js_shared__'];

var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */

var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$2;

var isFunction$2 = isFunction_1,
    isMasked = _isMasked,
    isObject$5 = isObject_1,
    toSource$1 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$a = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$8).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$5(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$2(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

var baseIsNative = _baseIsNative,
    getValue = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$7;

var getNative$6 = _getNative,
    root$6 = _root;

/* Built-in method references that are verified to be native. */
var Map$4 = getNative$6(root$6, 'Map');

var _Map = Map$4;

var getNative$5 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$5(Object, 'create');

var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }
  return hasOwnProperty$7.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$6.call(data, key);
}

var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

var _hashSet = hashSet$1;

var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;

var _Hash = Hash$1;

var Hash = _Hash,
    ListCache$2 = _ListCache,
    Map$3 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$3 || ListCache$2),
    'string': new Hash
  };
}

var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$1(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$2(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$2.prototype.clear = mapCacheClear;
MapCache$2.prototype['delete'] = mapCacheDelete;
MapCache$2.prototype.get = mapCacheGet;
MapCache$2.prototype.has = mapCacheHas;
MapCache$2.prototype.set = mapCacheSet;

var _MapCache = MapCache$2;

var ListCache$1 = _ListCache,
    Map$2 = _Map,
    MapCache$1 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$1;

var ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$1(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$1.prototype.clear = stackClear;
Stack$1.prototype['delete'] = stackDelete;
Stack$1.prototype.get = stackGet;
Stack$1.prototype.has = stackHas;
Stack$1.prototype.set = stackSet;

var _Stack = Stack$1;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach$1(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach$1;

var getNative$4 = _getNative;

var defineProperty$1 = (function() {
  try {
    var func = getNative$4(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty = defineProperty$1;

var defineProperty = _defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$2(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$2;

var baseAssignValue$1 = _baseAssignValue,
    eq = eq_1;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$2(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$5.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue$1(object, key, value);
  }
}

var _assignValue = assignValue$2;

var assignValue$1 = _assignValue,
    baseAssignValue = _baseAssignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject$4(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject$4;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes$1;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$6(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$6;

var baseGetTag$3 = _baseGetTag,
    isObjectLike$5 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$5(value) && baseGetTag$3(value) == argsTag$2;
}

var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
    isObjectLike$4 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$1 = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike$4(value) && hasOwnProperty$4.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

var isArguments_1 = isArguments$1;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$7 = Array.isArray;

var isArray_1 = isArray$7;

var isBuffer$2 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

(function (module, exports) {
var root = _root,
    stubFalse = stubFalse_1;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;
}(isBuffer$2, isBuffer$2.exports));

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$1(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex$1;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$2(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength$2;

var baseGetTag$2 = _baseGetTag,
    isLength$1 = isLength_1,
    isObjectLike$3 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] =
typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] =
typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] =
typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] =
typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] =
typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$2] =
typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] =
typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$4] = typedArrayTags[numberTag$2] =
typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$2] =
typedArrayTags[setTag$4] = typedArrayTags[stringTag$2] =
typedArrayTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$3(value) &&
    isLength$1(value.length) && !!typedArrayTags[baseGetTag$2(value)];
}

var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$3(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$3;

var _nodeUtil = {exports: {}};

(function (module, exports) {
var freeGlobal = _freeGlobal;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
}(_nodeUtil, _nodeUtil.exports));

var baseIsTypedArray = _baseIsTypedArray,
    baseUnary$2 = _baseUnary,
    nodeUtil$2 = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil$2 && nodeUtil$2.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$1 = nodeIsTypedArray ? baseUnary$2(nodeIsTypedArray) : baseIsTypedArray;

var isTypedArray_1 = isTypedArray$1;

var baseTimes = _baseTimes,
    isArguments = isArguments_1,
    isArray$6 = isArray_1,
    isBuffer$1 = isBuffer$2.exports,
    isIndex = _isIndex,
    isTypedArray = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$5.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$6(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer$1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys$2;

/** Used for built-in method references. */

var objectProto$4 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$3(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$4;

  return value === proto;
}

var _isPrototype = isPrototype$3;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$2;

var overArg$1 = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg$1(Object.keys, Object);

var _nativeKeys = nativeKeys$1;

var isPrototype$2 = _isPrototype,
    nativeKeys = _nativeKeys;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$1(object) {
  if (!isPrototype$2(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys$1;

var isFunction$1 = isFunction_1,
    isLength = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$2(value) {
  return value != null && isLength(value.length) && !isFunction$1(value);
}

var isArrayLike_1 = isArrayLike$2;

var arrayLikeKeys$1 = _arrayLikeKeys,
    baseKeys = _baseKeys,
    isArrayLike$1 = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$3(object) {
  return isArrayLike$1(object) ? arrayLikeKeys$1(object) : baseKeys(object);
}

var keys_1 = keys$3;

var copyObject$3 = _copyObject,
    keys$2 = keys_1;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign$1(object, source) {
  return object && copyObject$3(source, keys$2(source), object);
}

var _baseAssign = baseAssign$1;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn$1;

var isObject$4 = isObject_1,
    isPrototype$1 = _isPrototype,
    nativeKeysIn = _nativeKeysIn;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$1(object) {
  if (!isObject$4(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$1(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$1.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn$1;

var arrayLikeKeys = _arrayLikeKeys,
    baseKeysIn = _baseKeysIn,
    isArrayLike = isArrayLike_1;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$3(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

var keysIn_1 = keysIn$3;

var copyObject$2 = _copyObject,
    keysIn$2 = keysIn_1;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn$1(object, source) {
  return object && copyObject$2(source, keysIn$2(source), object);
}

var _baseAssignIn = baseAssignIn$1;

var _cloneBuffer = {exports: {}};

(function (module, exports) {
var root = _root;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
}(_cloneBuffer, _cloneBuffer.exports));

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray$2(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray$2;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$1;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$2() {
  return [];
}

var stubArray_1 = stubArray$2;

var arrayFilter = _arrayFilter,
    stubArray$1 = stubArray_1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$1.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$3 = !nativeGetSymbols$1 ? stubArray$1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

var _getSymbols = getSymbols$3;

var copyObject$1 = _copyObject,
    getSymbols$2 = _getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols$1(source, object) {
  return copyObject$1(source, getSymbols$2(source), object);
}

var _copySymbols = copySymbols$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$2(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush$2;

var overArg = _overArg;

/** Built-in value references. */
var getPrototype$2 = overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype$2;

var arrayPush$1 = _arrayPush,
    getPrototype$1 = _getPrototype,
    getSymbols$1 = _getSymbols,
    stubArray = stubArray_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn$2 = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush$1(result, getSymbols$1(object));
    object = getPrototype$1(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn$2;

var copyObject = _copyObject,
    getSymbolsIn$1 = _getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn$1(source, object) {
  return copyObject(source, getSymbolsIn$1(source), object);
}

var _copySymbolsIn = copySymbolsIn$1;

var arrayPush = _arrayPush,
    isArray$5 = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$5(object) ? result : arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$2;

var baseGetAllKeys$1 = _baseGetAllKeys,
    getSymbols = _getSymbols,
    keys$1 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$1(object) {
  return baseGetAllKeys$1(object, keys$1, getSymbols);
}

var _getAllKeys = getAllKeys$1;

var baseGetAllKeys = _baseGetAllKeys,
    getSymbolsIn = _getSymbolsIn,
    keysIn$1 = keysIn_1;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn$1(object) {
  return baseGetAllKeys(object, keysIn$1, getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn$1;

var getNative$3 = _getNative,
    root$5 = _root;

/* Built-in method references that are verified to be native. */
var DataView$2 = getNative$3(root$5, 'DataView');

var _DataView = DataView$2;

var getNative$2 = _getNative,
    root$4 = _root;

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative$2(root$4, 'Promise');

var _Promise = Promise$2;

var getNative$1 = _getNative,
    root$3 = _root;

/* Built-in method references that are verified to be native. */
var Set$2 = getNative$1(root$3, 'Set');

var _Set = Set$2;

var getNative = _getNative,
    root$2 = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$2 = getNative(root$2, 'WeakMap');

var _WeakMap = WeakMap$2;

var DataView$1 = _DataView,
    Map$1 = _Map,
    Promise$1 = _Promise,
    Set$1 = _Set,
    WeakMap$1 = _WeakMap,
    baseGetTag$1 = _baseGetTag,
    toSource = _toSource;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$3 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView$1),
    mapCtorString = toSource(Map$1),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$1),
    weakMapCtorString = toSource(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$3 = baseGetTag$1;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView$1 && getTag$3(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2) ||
    (Map$1 && getTag$3(new Map$1) != mapTag$3) ||
    (Promise$1 && getTag$3(Promise$1.resolve()) != promiseTag) ||
    (Set$1 && getTag$3(new Set$1) != setTag$3) ||
    (WeakMap$1 && getTag$3(new WeakMap$1) != weakMapTag$1)) {
  getTag$3 = function(value) {
    var result = baseGetTag$1(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$3;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$3;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag$3;

/** Used for built-in method references. */

var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray$1(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray$1;

var root$1 = _root;

/** Built-in value references. */
var Uint8Array$1 = root$1.Uint8Array;

var _Uint8Array = Uint8Array$1;

var Uint8Array = _Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer$3(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer$3;

var cloneArrayBuffer$2 = _cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView$1(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$2(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView$1;

/** Used to match `RegExp` flags from their coerced string values. */

var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp$1(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp$1;

var Symbol$2 = _Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol$1(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol$1;

var cloneArrayBuffer$1 = _cloneArrayBuffer;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray$1(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$1(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray$1;

var cloneArrayBuffer = _cloneArrayBuffer,
    cloneDataView = _cloneDataView,
    cloneRegExp = _cloneRegExp,
    cloneSymbol = _cloneSymbol,
    cloneTypedArray = _cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$2 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag$1(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$1:
      return cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor;

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return cloneRegExp(object);

    case setTag$2:
      return new Ctor;

    case symbolTag$2:
      return cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag$1;

var isObject$3 = isObject_1;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate$1 = (function() {
  function object() {}
  return function(proto) {
    if (!isObject$3(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate$1;

var baseCreate = _baseCreate,
    getPrototype = _getPrototype,
    isPrototype = _isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject$1(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject$1;

var getTag$2 = _getTag,
    isObjectLike$2 = isObjectLike_1;

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap$1(value) {
  return isObjectLike$2(value) && getTag$2(value) == mapTag$1;
}

var _baseIsMap = baseIsMap$1;

var baseIsMap = _baseIsMap,
    baseUnary$1 = _baseUnary,
    nodeUtil$1 = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap$1 = nodeIsMap ? baseUnary$1(nodeIsMap) : baseIsMap;

var isMap_1 = isMap$1;

var getTag$1 = _getTag,
    isObjectLike$1 = isObjectLike_1;

/** `Object#toString` result references. */
var setTag$1 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet$1(value) {
  return isObjectLike$1(value) && getTag$1(value) == setTag$1;
}

var _baseIsSet = baseIsSet$1;

var baseIsSet = _baseIsSet,
    baseUnary = _baseUnary,
    nodeUtil = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet$1 = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

var isSet_1 = isSet$1;

var Stack = _Stack,
    arrayEach = _arrayEach,
    assignValue = _assignValue,
    baseAssign = _baseAssign,
    baseAssignIn = _baseAssignIn,
    cloneBuffer = _cloneBuffer.exports,
    copyArray$1 = _copyArray,
    copySymbols = _copySymbols,
    copySymbolsIn = _copySymbolsIn,
    getAllKeys = _getAllKeys,
    getAllKeysIn = _getAllKeysIn,
    getTag = _getTag,
    initCloneArray = _initCloneArray,
    initCloneByTag = _initCloneByTag,
    initCloneObject = _initCloneObject,
    isArray$4 = isArray_1,
    isBuffer = isBuffer$2.exports,
    isMap = isMap_1,
    isObject$2 = isObject_1,
    isSet = isSet_1,
    keys = keys_1,
    keysIn = keysIn_1;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag$1 = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag$1] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone$1(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$2(value)) {
    return value;
  }
  var isArr = isArray$4(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray$1(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone$1(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone$1;

var baseClone = _baseClone;

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

var clone_1 = clone;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$2(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$2;

var baseGetTag = _baseGetTag,
    isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$4(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol$4;

var MapCache = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache;

var memoize_1 = memoize$1;

var memoize = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$2 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$2;

var isSymbol$3 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$2(value) {
  if (typeof value == 'string' || isSymbol$3(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _toKey = toKey$2;

var Symbol$1 = _Symbol,
    arrayMap$1 = _arrayMap,
    isArray$3 = isArray_1,
    isSymbol$2 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$3(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$1(value, baseToString$1) + '';
  }
  if (isSymbol$2(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _baseToString = baseToString$1;

var baseToString = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$2(value) {
  return value == null ? '' : baseToString(value);
}

var toString_1 = toString$2;

var arrayMap = _arrayMap,
    copyArray = _copyArray,
    isArray$2 = isArray_1,
    isSymbol$1 = isSymbol_1,
    stringToPath$1 = _stringToPath,
    toKey$1 = _toKey,
    toString$1 = toString_1;

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray$2(value)) {
    return arrayMap(value, toKey$1);
  }
  return isSymbol$1(value) ? [value] : copyArray(stringToPath$1(toString$1(value)));
}

var toPath_1 = toPath;

/** @private is the given object a Function? */
var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};

/** @private is the given object an Object? */
var isObject$1 = function isObject(obj) {
  return obj !== null && _typeof(obj) === 'object';
};

/** @private is the given object an integer? */
var isInteger = function isInteger(obj) {
  return String(Math.floor(Number(obj))) === obj;
};

/** @private is the given object/value a promise? */
var isPromise = function isPromise(value) {
  return isObject$1(value) && isFunction(value.then);
};
/**
 * Deeply get a value from an object via its path.
 */
function getIn(obj, key, def) {
  var p = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var path = toPath_1(key);
  while (obj && p < path.length) {
    obj = obj[path[p++]];
  }
  return obj === undefined ? def : obj;
}

/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */
function setIn(obj, path, value) {
  var _ref;
  var res = clone_1(obj); // this keeps inheritance when obj is a class
  var resVal = res;
  var i = 0;
  var pathArray = toPath_1(path);
  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn(obj, pathArray.slice(0, i + 1));
    if (currentObj && (isObject$1(currentObj) || Array.isArray(currentObj))) {
      resVal = resVal[currentPath] = clone_1(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  }

  // Return original object if new value is the same as current
  if (((_ref = i === 0 ? obj : resVal) === null || _ref === void 0 ? void 0 : _ref[pathArray === null || pathArray === void 0 ? void 0 : pathArray[i]]) === value) {
    return obj;
  }
  if (value === undefined) {
    delete resVal[pathArray[i]];
  } else {
    resVal[pathArray[i]] = value;
  }

  // If the path array has a single element, the loop did not run.
  // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
  if (i === 0 && value === undefined) {
    delete res[pathArray[i]];
  }
  return res;
}

function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$g(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var convertToTouchedObject = function convertToTouchedObject(errors) {
  var replacer = function replacer(_, value) {
    if (!value) return false;
    if (['boolean', 'number', 'string'].includes(_typeof(value))) return true;
    return value;
  };
  var convertedStr = JSON.stringify(errors, replacer);
  return JSON.parse(convertedStr);
};
function formReducer(state, action) {
  switch (action.type) {
    case 'RESET_FORM':
      return _objectSpread$g(_objectSpread$g({}, state), action.payload);
    case 'SET_VALUES':
      return _objectSpread$g(_objectSpread$g({}, state), {}, {
        values: action.payload
      });
    case 'SET_TOUCHED':
      return _objectSpread$g(_objectSpread$g({}, state), {}, {
        touched: convertToTouchedObject(action.payload)
      });
    case 'SET_FIELD_VALUE':
      return _objectSpread$g(_objectSpread$g({}, state), {}, {
        values: setIn(state.values, action.payload.path, action.payload.value)
      });
    case 'SET_FIELD_TOUCHED':
      return _objectSpread$g(_objectSpread$g({}, state), {}, {
        touched: setIn(state.touched, action.payload.path, action.payload.value)
      });
    case 'SUBMIT_ATTEMPT':
      return _objectSpread$g(_objectSpread$g({}, state), {}, {
        isSubmitting: true,
        submitCount: state.submitCount + 1
      });
    case 'SET_SUBMITTING':
      return _objectSpread$g(_objectSpread$g({}, state), {}, {
        isSubmitting: action.payload
      });
    case 'SUBMIT_FAILURE':
      return _objectSpread$g(_objectSpread$g({}, state), {}, {
        isSubmitting: false
      });
    case 'SUBMIT_SUCCESS':
      return _objectSpread$g(_objectSpread$g({}, state), {}, {
        isSubmitting: false
      });
    default:
      return state;
  }
}
function useFormix(props) {
  var _ref = props || {},
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? 'horizontal' : _ref$layout,
    _ref$initialValues = _ref.initialValues,
    initialValues = _ref$initialValues === void 0 ? {} : _ref$initialValues,
    _ref$initialTouched = _ref.initialTouched,
    initialTouched = _ref$initialTouched === void 0 ? {} : _ref$initialTouched,
    validate = _ref.validate,
    onSubmit = _ref.onSubmit,
    onReset = _ref.onReset;
  var isMounted = useRef(false);
  var _useReducer = useReducer(formReducer, {
      values: initialValues || {},
      touched: initialTouched || {},
      isSubmitting: false,
      submitCount: 0
    }),
    _useReducer2 = _slicedToArray$1(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  useEffect(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  var setValues = useCallback(function (values) {
    dispatch({
      type: 'SET_VALUES',
      payload: values
    });
  }, []);
  var setTouched = useCallback(function (touched) {
    dispatch({
      type: 'SET_TOUCHED',
      payload: touched
    });
  }, []);
  var setSubmitting = useCallback(function (isSubmitting) {
    dispatch({
      type: 'SET_SUBMITTING',
      payload: isSubmitting
    });
  }, []);
  var setFieldValue = useCallback(function (path, value) {
    dispatch({
      type: 'SET_FIELD_VALUE',
      payload: {
        path: path,
        value: value
      }
    });
  }, []);
  var setFieldTouched = useCallback(function (path) {
    dispatch({
      type: 'SET_FIELD_TOUCHED',
      payload: {
        path: path,
        value: true
      }
    });
  }, []);
  var imperativeMethods = useMemo(function () {
    return {
      setValues: setValues,
      setTouched: setTouched,
      setFieldValue: setFieldValue,
      setSubmitting: setSubmitting,
      setFieldTouched: setFieldTouched
    };
  }, [setFieldTouched, setFieldValue, setSubmitting, setTouched, setValues]);
  var handleChange = useCallback(function (e, value, path) {
    var _e$target, _e$target2;
    var _path = path || (e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.name);
    var _value = value || (e === null || e === void 0 ? void 0 : (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.value);
    setFieldValue(_path, _value);
  }, [setFieldValue]);
  var handleBlur = useCallback(function (e, path) {
    var _e$target3;
    var _path = path || (e === null || e === void 0 ? void 0 : (_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : _e$target3.name);
    setFieldTouched(_path);
  }, [setFieldTouched]);
  var restForm = useCallback(function (nextState) {
    var values = (nextState === null || nextState === void 0 ? void 0 : nextState.values) || initialValues || {};
    var touched = (nextState === null || nextState === void 0 ? void 0 : nextState.touched) || initialTouched || {};
    var isSubmitting = (nextState === null || nextState === void 0 ? void 0 : nextState.isSubmitting) || false;
    var submitCount = (nextState === null || nextState === void 0 ? void 0 : nextState.submitCount) || 0;
    var dispatchFn = function dispatchFn() {
      dispatch({
        type: 'RESET_FORM',
        payload: {
          values: values,
          touched: touched,
          isSubmitting: isSubmitting,
          submitCount: submitCount
        }
      });
    };
    if (onReset) {
      var maybePromisedOnReset = onReset(state.values, imperativeMethods);
      if (isPromise(maybePromisedOnReset)) {
        // eslint-disable-next-line promise/catch-or-return
        maybePromisedOnReset.then(dispatchFn);
      } else {
        dispatchFn();
      }
    } else {
      dispatchFn();
    }
  }, [imperativeMethods, initialTouched, initialValues, state.values, onReset]);
  var handleReset = useCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }
    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    }
    restForm();
  }, [restForm]);
  var handleSubmit = useCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }
    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    }
    var errors = (validate === null || validate === void 0 ? void 0 : validate(state.values)) || {};
    var isActuallyValid = Object.keys(errors).filter(function (val) {
      return (val === null || val === void 0 ? void 0 : val.length) > 0;
    }).length === 0;
    if (isActuallyValid) {
      dispatch({
        type: 'SUBMIT_ATTEMPT'
      });
      var promiseOrUndefined = onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(state.values, imperativeMethods);
      // Bail if it's sync, consumer is responsible for cleaning up
      // via setSubmitting(false)
      if (promiseOrUndefined === undefined) {
        return;
      }
      dispatch({
        type: 'SUBMIT_ATTEMPT'
      });
      Promise.resolve(promiseOrUndefined).then(function (result) {
        var mounted = !!isMounted.current;
        if (mounted) {
          dispatch({
            type: 'SUBMIT_SUCCESS'
          });
        }
        return result;
      })["catch"](function (_errors) {
        var mounted = !!isMounted.current;
        if (mounted) {
          dispatch({
            type: 'SUBMIT_FAILURE'
          });
          // This is a legit error rejected by the onSubmit fn
          // so we don't want to break the promise chain
          throw _errors;
        }
      });
    } else {
      // we are converting error object into touched in reducer
      setTouched(errors);
    }
  }, [imperativeMethods, onSubmit, validate, state.values, setTouched]);
  var errors = (validate === null || validate === void 0 ? void 0 : validate(state.values)) || {};
  return _objectSpread$g(_objectSpread$g(_objectSpread$g({}, state), {}, {
    layout: layout,
    errors: errors
  }, imperativeMethods), {}, {
    handleChange: handleChange,
    handleBlur: handleBlur,
    handleSubmit: handleSubmit,
    handleReset: handleReset
  });
}

var _excluded$C = ["children", "layout", "initialValues", "initialTouched", "onSubmit", "onReset"];
function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$f(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var isEmptyChildren = function isEmptyChildren(children) {
  return React__default.Children.count(children) === 0;
};
var FormContext = /*#__PURE__*/createContext();
function Formix(props) {
  var children = props.children,
    _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'vertical' : _props$layout,
    _props$initialValues = props.initialValues,
    initialValues = _props$initialValues === void 0 ? {} : _props$initialValues,
    _props$initialTouched = props.initialTouched,
    initialTouched = _props$initialTouched === void 0 ? {} : _props$initialTouched,
    _props$onSubmit = props.onSubmit,
    onSubmit = _props$onSubmit === void 0 ? function () {} : _props$onSubmit,
    _props$onReset = props.onReset,
    onReset = _props$onReset === void 0 ? function () {} : _props$onReset,
    restProps = _objectWithoutProperties$1(props, _excluded$C);
  var formBag = useFormix(_objectSpread$f(_objectSpread$f({}, restProps), {}, {
    initialValues: initialValues,
    initialTouched: initialTouched,
    onSubmit: onSubmit,
    onReset: onReset,
    layout: layout
  }));
  return jsx(FormContext.Provider, {
    value: formBag
  }, children ? isFunction(children) ? children(formBag) : !isEmptyChildren(children) ? React__default.Children.only(children) : null : null);
}
Formix.displayName = 'Formix';
Formix.propTypes = {
  initialValues: object$1,
  initialTouched: object$1,
  children: any,
  layout: oneOf(['vertical', 'horizontal']),
  validate: func,
  onSubmit: func,
  onReset: func
};

var _excluded$B = ["form", "name", "children", "onChange", "onBlur"];
function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$e(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function Field(props) {
  var form = props.form,
    name = props.name,
    children = props.children,
    _onChange = props.onChange,
    _onBlur = props.onBlur,
    restProps = _objectWithoutProperties$1(props, _excluded$B);
  return jsx(React__default.Fragment, null, Children.only(children) ? /*#__PURE__*/isValidElement(children) ? /*#__PURE__*/cloneElement(children, _objectSpread$e(_objectSpread$e({
    layout: form === null || form === void 0 ? void 0 : form.layout
  }, restProps), {}, {
    name: name,
    value: getIn((form === null || form === void 0 ? void 0 : form.values) || {}, name, undefined),
    touched: !!getIn((form === null || form === void 0 ? void 0 : form.touched) || {}, name, false),
    helperText: getIn((form === null || form === void 0 ? void 0 : form.errors) || {}, name, ''),
    onChange: function onChange() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      form === null || form === void 0 ? void 0 : form.handleChange.apply(form, args);
      _onChange === null || _onChange === void 0 ? void 0 : _onChange.apply(void 0, args);
    },
    onBlur: function onBlur() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      form === null || form === void 0 ? void 0 : form.handleBlur.apply(form, args);
      _onBlur === null || _onBlur === void 0 ? void 0 : _onBlur.apply(void 0, args);
    }
  })) : null : null);
}
Field.displayName = 'Field';
Field.propTypes = {
  form: object$1,
  name: string,
  children: node$2,
  onChange: func,
  onBlur: func
};

var _excluded$A = ["action", "form"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$s() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssForm = process.env.NODE_ENV === "production" ? {
  name: "7mgnji-cssForm",
  styles: "width:100%;label:cssForm;"
} : {
  name: "7mgnji-cssForm",
  styles: "width:100%;label:cssForm;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZvcm0uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSW1CIiwiZmlsZSI6IkZvcm0uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgb2JqZWN0LCBzdHJpbmcgfSBmcm9tICdwcm9wLXR5cGVzJztcblxuY29uc3QgY3NzRm9ybSA9IGNzc2BcbiAgd2lkdGg6IDEwMCU7XG5gO1xuXG5leHBvcnQgY29uc3QgRm9ybSA9IHByb3BzID0+IHtcbiAgLy8gaU9TIG5lZWRzIGFuIFwiYWN0aW9uXCIgYXR0cmlidXRlIGZvciBuaWNlIGlucHV0OiBodHRwczovL3N0YWNrb3ZlcmZsb3cuY29tL2EvMzk0ODUxNjIvNDA2NzI1XG4gIC8vIFdlIGRlZmF1bHQgdGhlIGFjdGlvbiB0byBcIiNcIiBpbiBjYXNlIHRoZSBwcmV2ZW50RGVmYXVsdCBmYWlscyAoanVzdCB1cGRhdGVzIHRoZSBVUkwgaGFzaClcbiAgY29uc3QgeyBhY3Rpb24sIGZvcm0sIC4uLnJlc3QgfSA9IHByb3BzO1xuICBjb25zdCBfYWN0aW9uID0gYWN0aW9uID8/ICcjJztcblxuICByZXR1cm4gKFxuICAgIDxmb3JtXG4gICAgICB7Li4ucmVzdH1cbiAgICAgIGNzcz17Y3NzRm9ybX1cbiAgICAgIG9uU3VibWl0PXtmb3JtPy5oYW5kbGVTdWJtaXR9XG4gICAgICBvblJlc2V0PXtmb3JtPy5oYW5kbGVSZXNldH1cbiAgICAgIGFjdGlvbj17X2FjdGlvbn1cbiAgICAvPlxuICApO1xufTtcblxuRm9ybS5kaXNwbGF5TmFtZSA9ICdGb3JtJztcblxuRm9ybS5wcm9wVHlwZXMgPSB7XG4gIGZvcm06IG9iamVjdCxcbiAgYWN0aW9uOiBzdHJpbmcsXG59O1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$s
};
var Form = function Form(props) {
  // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
  // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
  var action = props.action,
    form = props.form,
    rest = _objectWithoutProperties$1(props, _excluded$A);
  var _action = action !== null && action !== void 0 ? action : '#';
  return jsx("form", _extends$1({}, rest, {
    css: cssForm,
    onSubmit: form === null || form === void 0 ? void 0 : form.handleSubmit,
    onReset: form === null || form === void 0 ? void 0 : form.handleReset,
    action: _action
  }));
};
Form.displayName = 'Form';
Form.propTypes = {
  form: object$1,
  action: string
};

var _templateObject$2, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6$1, _templateObject7$1, _templateObject14$1, _templateObject15$1, _templateObject16$1, _templateObject17$1, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69, _templateObject70, _templateObject71, _templateObject72, _templateObject73, _templateObject74, _templateObject75, _templateObject76, _templateObject77, _templateObject78, _templateObject79, _templateObject80, _templateObject81, _templateObject89, _templateObject90, _templateObject91, _templateObject92, _templateObject93, _templateObject94, _templateObject95, _templateObject96, _templateObject97, _templateObject98, _templateObject99, _templateObject100, _templateObject104, _templateObject105, _templateObject114, _templateObject115, _templateObject116, _templateObject135, _templateObject136, _templateObject144, _templateObject145, _templateObject146, _templateObject147, _templateObject152, _templateObject153, _templateObject154, _templateObject155, _templateObject156, _templateObject157, _templateObject158, _templateObject159, _templateObject160, _templateObject161, _templateObject162, _templateObject163, _templateObject164, _templateObject165, _templateObject166, _templateObject167, _templateObject168, _templateObject169, _templateObject170, _templateObject171, _templateObject172, _templateObject173, _templateObject174, _templateObject175, _templateObject176, _templateObject177, _templateObject178, _templateObject179, _templateObject180, _templateObject181, _templateObject187, _templateObject188, _templateObject189, _templateObject190, _templateObject191, _templateObject192, _templateObject193, _templateObject199, _templateObject200, _templateObject201, _templateObject202, _templateObject203;
function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$d(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }
function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }
function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var sharedStyles$1 = css$1(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n  :host {\n    display: block;\n    width: 100%;\n    line-height: var(--default-line-height);\n  }\n  .sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    margin: -1px;\n    padding: 0;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    border: 0;\n  }\n  button:focus,\n  a:focus,\n  .fwc-toggle input:focus + label,\n  .fwc-select-list select:focus,\n  .fwc-radio input:focus,\n  .fwc-input input:focus,\n  input:focus + label,\n  .fwc-checkbox input:focus + label:before,\n  .fwc-carousel-generic-wrapper .fwc-list-cont:focus,\n  div.tip-btn:focus {\n    outline: var(--fwc-focus);\n  }\n"])));
var FwcAlertComponent = /*#__PURE__*/function (_LitElement) {
  _inherits$1(FwcAlertComponent, _LitElement);
  var _super = _createSuper$8(FwcAlertComponent);
  function FwcAlertComponent() {
    var _this2;
    _classCallCheck$1(this, FwcAlertComponent);
    _this2 = _super.call(this);
    _this2._refocusElem = null;
    _this2.type = 'info';
    _this2.area = 'inline';
    _this2.labelAriaCloseBtn = 'Close Alert';
    _this2.bgColor = '';
    _this2.closing = false;
    _this2._onEnd = function () {
      if (_this2.parentElement && _this2.closing) {
        _this2.parentElement.removeChild(_assertThisInitialized(_this2));
        _this2.closing = false;
        var event = new CustomEvent('fwc-alert-closed', {
          detail: _assertThisInitialized(_this2),
          bubbles: true
        });
        _this2.dispatchEvent(event);
        _this2._returnFocus();
      }
    };
    return _this2;
  }
  _createClass$1(FwcAlertComponent, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      var wrapper = this.shadowRoot.getElementById('fwcAlertRow');
      wrapper.addEventListener('transitionend', this._onEnd);
      if (this.area === 'global') this.classList.add('fwc-container');
    }
  }, {
    key: "_xIcon",
    value: function _xIcon() {
      var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var style = color === 'red' ? 'red-fill' : 'close-fill';
      return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      <svg\n        aria-hidden=\"true\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        width=\"20\"\n        height=\"20\"\n        viewBox=\"0 0 50 50\"\n        focusable=\"false\"\n      >\n        <polygon\n          class=\"", "\"\n          points=\"3.523 50 0 46.477 21.477 25 0 3.523 3.523 0 25 21.477 46.477 0 50 3.523 28.523 25 50 46.477 46.477 50 25 28.523\"\n        />\n      </svg>\n    "])), style);
    }
  }, {
    key: "_setBackground",
    value: function _setBackground() {
      var bg = '';
      switch (this.bgColor) {
        case 'white':
          bg = 'bg-white';
          break;
        default:
          bg = 'bg-default';
      }
      return bg;
    }
  }, {
    key: "_buildIcon",
    value: function _buildIcon() {
      var success = html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      <svg\n        aria-hidden=\"true\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        width=\"20\"\n        height=\"20\"\n        viewBox=\"0 0 50 50\"\n        focusable=\"false\"\n      >\n        <polygon\n          class=\"success-fill\"\n          points=\"47.38 43.674 15.888 12.182 2.62 25.451 0 22.831 14.579 8.253 15.888 7 17.198 8.253 50 41.055\"\n          transform=\"matrix(1 0 0 -1 0 50.674)\"\n        />\n      </svg>\n    "])));
      var info = html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      <svg\n        aria-hidden=\"true\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        width=\"20\"\n        height=\"20\"\n        viewBox=\"0 0 50 50\"\n        focusable=\"false\"\n      >\n        <path\n          class=\"info-fill\"\n          d=\"M25,50 C11.2154447,50 0,38.7845553 0,25 C0,11.2154447 11.2154447,0 25,0 C38.7845553,0 50,11.2154447 50,25 C50,38.7845553 38.7845553,50 25,50 Z M25,46.1538462 C36.703726,46.1538462 46.1538462,36.703726 46.1538462,25 C46.1538462,13.296274 36.703726,3.84615385 25,3.84615385 C13.296274,3.84615385 3.84615385,13.296274 3.84615385,25 C3.84615385,36.703726 13.296274,46.1538462 25,46.1538462 Z M23.0769231,36.5384615 L23.0769231,32.6923077 L26.9230769,32.6923077 L26.9230769,36.5384615 L23.0769231,36.5384615 Z M23.0769231,28.8461538 L23.0769231,13.4615385 L26.9230769,13.4615385 L26.9230769,28.8461538 L23.0769231,28.8461538 Z\"\n          transform=\"matrix(1 0 0 -1 0 50)\"\n        />\n      </svg>\n    "])));
      var error = this._xIcon('red');
      var urgent = html(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      <svg\n        aria-hidden=\"true\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        width=\"20\"\n        height=\"20\"\n        viewBox=\"0 0 50 50\"\n        focusable=\"false\"\n      >\n        <path\n          class=\"red-fill\"\n          d=\"M25,46.3371298 L23.405467,43.6036446 L1.53758542,5.73348519 L0,3 L50,3 L48.4624146,5.73348519 L26.594533,43.6036446 L25,46.3371298 Z M25,39.047836 L43.6788155,6.64464692 L6.32118451,6.64464692 L25,39.047836 Z M23.1776765,26.690205 L23.1776765,15.7562642 L26.8223235,15.7562642 L26.8223235,26.690205 L23.1776765,26.690205 Z M23.1776765,13.9339408 L23.1776765,10.2892938 L26.8223235,10.2892938 L26.8223235,13.9339408 L23.1776765,13.9339408 Z\"\n          transform=\"matrix(1 0 0 -1 0 49.337)\"\n        />\n      </svg>\n    "])));
      var icons = {
        success: success,
        info: info,
        error: error,
        urgent: urgent
      };
      return icons[this.type];
    }
  }, {
    key: "_onCloseClick",
    value: function _onCloseClick() {
      this.closing = true;
      this.shadowRoot.getElementById('fwcAlertRow').classList.add('remove');
    }

    // a public func allowing projects to close the alert
  }, {
    key: "closeAlert",
    value: function closeAlert() {
      this._onCloseClick();
    }

    // a public function allowing projects to put focus on the alert close button when opened
  }, {
    key: "focusOnCloseBtn",
    value: function focusOnCloseBtn() {
      var _this3 = this;
      setTimeout(function () {
        _this3.shadowRoot.getElementById('fwc-alert-close-button').focus();
      }, 250);
    }

    //private method to return focus to a element
  }, {
    key: "_returnFocus",
    value: function _returnFocus() {
      if (this._refocusElem) {
        // Return focus to calling element
        this._refocusElem.focus();
      }
    }

    // a public func allowing projects to set the refocus element can call private _returnfocus method
  }, {
    key: "setReFocus",
    value: function setReFocus(elem) {
      this._refocusElem = elem;
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n      <div\n        class=\"fwc-alert-row ", " ", "\"\n        id=\"fwcAlertRow\"\n        role=\"alert\"\n      >\n        <div class=\"fwc-alert-wrapper\">\n          <div class=\"fwc-alert-flex\">\n            ", "\n            <slot id=\"alertMessage\"></slot>\n          </div>\n          <button\n            id=\"fwc-alert-close-button\"\n            type=\"button\"\n            role=\"button\"\n            aria-label=\"", "\"\n            aria-describedby=\"alertMessage\"\n            @click=\"", "\"\n          >\n            ", "\n          </button>\n        </div>\n      </div>\n      <div\n        class=\"fwc-alert-highlight ", "\"\n      ></div>\n    "])), this.area === 'global' ? 'fwc-alert-row-full' : '', this._setBackground(), this._buildIcon(), this.labelAriaCloseBtn, this._onCloseClick, this._xIcon(), this.area === 'global' ? 'show' : '');
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n        :host {\n          overflow: hidden;\n          position: relative;\n        }\n        .fwc-alert-flex svg {\n          flex-shrink: 0;\n          margin-right: calc(1.5 * var(--fwcu));\n        }\n        .fwc-alert-highlight {\n          position: absolute;\n          box-sizing: content-box;\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          pointer-events: none;\n        }\n        .fwc-alert-highlight.show {\n          animation-name: fwcHighlight;\n          animation-delay: 0ms;\n          animation-duration: 2s;\n          animation-timing-function: ease-out;\n          animation-fill-mode: both;\n          transform-origin: 50% 50%;\n        }\n\n        .fwc-alert-row {\n          margin-top: 0;\n          transition: all 1s ease-in;\n          margin-bottom: calc(0.25 * var(--fwcu));\n        }\n\n        .fwc-alert-row-full {\n          animation-name: fwcGrow;\n          animation-delay: 0ms;\n          animation-duration: 2s;\n          animation-timing-function: ease-out;\n          animation-fill-mode: none;\n          transform-origin: 0% 50%;\n        }\n        .fwc-alert-row-full .fwc-alert-wrapper {\n          max-width: calc(144 * var(--fwcu));\n          margin: 0 auto;\n        }\n        .fwc-alert-wrapper {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          line-height: 1;\n          padding: calc(var(--fwcu)) calc(1.5 * var(--fwcu));\n          font-size: calc(2 * var(--fwcu));\n        }\n\n        @media screen and (max-width: 600px) {\n          .fwc-alert-wrapper {\n            /*\n              There is no col padding to add to:\n              4*fwcu = 32px for mobile\n            */\n            padding-right: calc(4 * var(--fwcu));\n            padding-left: calc(4 * var(--fwcu));\n          }\n        }\n\n        .fwc-alert-row.remove {\n          margin-top: -100%;\n          overflow: hidden;\n        }\n        .fwc-alert-flex {\n          display: flex;\n          align-items: center;\n        }\n\n        .success-fill {\n          fill: var(--color-alert-success);\n        }\n        .success-color {\n          color: var(--color-alert-success);\n        }\n\n        .info-fill {\n          fill: var(--color-alert-info);\n        }\n        .info-color {\n          color: var(--color-alert-info);\n        }\n\n        .red-fill {\n          fill: var(--color-alert-error);\n        }\n        .red-color {\n          color: var(--color-alert-error);\n        }\n\n        .close-fill {\n          fill: var(--color-gray-two);\n        }\n\n        .bg-white {\n          background-color: var(--color-white);\n        }\n        .bg-default {\n          background-color: var(--color-gray-five);\n        }\n\n        button {\n          border: none;\n          background: transparent;\n          cursor: pointer;\n          right: var(--fwcu);\n          padding: calc(0.5 * var(--fwcu));\n          display: flex;\n          align-items: center;\n        }\n\n        button svg {\n          width: calc(2 * var(--fwcu));\n          height: calc(2 * var(--fwcu));\n        }\n\n        @keyframes fwcHighlight {\n          from {\n            background: var(--color-dviz-eight);\n            opacity: 1;\n          }\n          to {\n            opacity: 0;\n          }\n        }\n\n        @keyframes fwcGrow {\n          from {\n            max-height: 0;\n          }\n          to {\n            max-height: 25rem;\n          }\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        type: {
          type: String
        },
        // urgent | success | info | error
        area: {
          type: String
        },
        // global | inline
        labelAriaCloseBtn: {
          attribute: 'label-aria-close-btn',
          type: String
        },
        bgColor: {
          attribute: 'bg-color',
          type: String
        } // white | null
      };
    }
  }]);
  return FwcAlertComponent;
}(LitElement);
var FwcBase$1 = /*#__PURE__*/function () {
  function FwcBase(name, component) {
    _classCallCheck$1(this, FwcBase);
    this.element = customElements.get(name);
    this.name = name;
    this.component = component;
  }
  _createClass$1(FwcBase, [{
    key: "build",
    value: function build() {
      if (!this.element) {
        customElements.define(this.name, this.component);
      }
    }
  }]);
  return FwcBase;
}();
var FwcAlert = /*#__PURE__*/function (_FwcBase) {
  _inherits$1(FwcAlert, _FwcBase);
  var _super2 = _createSuper$8(FwcAlert);
  function FwcAlert() {
    _classCallCheck$1(this, FwcAlert);
    return _super2.call(this, 'fwc-alert', FwcAlertComponent);
  }
  return _createClass$1(FwcAlert);
}(FwcBase$1);
var breakpoints$1 = {
  md: 900,
  sm: 600
};
var baseUnit$1 = 8;
var fwcConfig$1 = {
  assetsPath: '/'
};
var FwcAnimColDropComponent = /*#__PURE__*/function (_LitElement5) {
  _inherits$1(FwcAnimColDropComponent, _LitElement5);
  var _super8 = _createSuper$8(FwcAnimColDropComponent);
  function FwcAnimColDropComponent() {
    var _this7;
    _classCallCheck$1(this, FwcAnimColDropComponent);
    _this7 = _super8.call(this);
    _this7.delay = 0;
    _this7.bar = null;
    _this7.content = null;
    _this7.disableAnimateMobile = ''; // small, medium
    return _this7;
  }
  _createClass$1(FwcAnimColDropComponent, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldVal, newVal) {
      _get(_getPrototypeOf(FwcAnimColDropComponent.prototype), "attributeChangedCallback", this).call(this, name, oldVal, newVal);
      if (name === 'trigger-animate') {
        this.startAnimation();
      }
    }
  }, {
    key: "firstUpdated",
    value: function firstUpdated() {
      var _this8 = this;
      var isAnimationDisabled = this.checkAnimationDisabled();
      this.bar = this.shadowRoot.querySelector('.fwc-anim-bar');
      this.content = this.shadowRoot.querySelector('.fwc-anim-content');
      this.bar.addEventListener('transitionend', function (e) {
        _this8.content.classList.add('animate');
      });
      if (!isAnimationDisabled) {
        this.bar.classList.add('prep-animate');
        this.content.classList.add('prep-animate');
      }
      if (this.triggerAnimate) {
        this.startAnimation();
      }
    }
  }, {
    key: "checkAnimationDisabled",
    value: function checkAnimationDisabled() {
      if (window.innerWidth <= breakpoints$1.md && this.disableAnimateMobile === 'medium') {
        return true;
      }
      if (window.innerWidth <= breakpoints$1.sm && this.disableAnimateMobile === 'small') {
        return true;
      }
      return false;
    }
  }, {
    key: "startAnimation",
    value: function startAnimation() {
      var _this9 = this;
      setTimeout(function () {
        _this9.bar.classList.add('animate');
      }, this.delay);
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteral(["\n      <div class=\"fwc-anim-wrapper\">\n        <div class=\"fwc-anim-bar\"></div>\n        <div class=\"fwc-anim-content\">\n          <slot></slot>\n        </div>\n      </div>\n    "])));
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject15$1 || (_templateObject15$1 = _taggedTemplateLiteral(["\n        :host {\n          width: 100%;\n          display: block;\n        }\n        .fwc-anim-wrapper {\n          position: relative;\n          width: 100%;\n          padding-bottom: var(--fwcu2);\n          overflow: hidden;\n        }\n        .fwc-anim-bar {\n          width: 100%;\n          height: 2px;\n          margin: 0 auto;\n          margin-bottom: calc(var(--fwcu) + var(--fwcu05));\n          background: var(--color-gray-five, #f7f7f7);\n        }\n        .fwc-anim-bar.prep-animate {\n          width: 0%;\n        }\n        .fwc-anim-bar.animate {\n          width: 100%;\n          transition: width 500ms ease-in-out;\n        }\n        .fwc-anim-content {\n          padding: calc(1.5 * var(--fwcu)) 0;\n        }\n        .fwc-anim-content.prep-animate {\n          transform: translateY(-125%);\n        }\n        .fwc-anim-content.animate {\n          animation: slideIn 1s ease-in-out 1;\n          transform: translateY(0%);\n        }\n\n        @keyframes slideIn {\n          0% {\n            transform: translateY(-125%);\n          }\n          33% {\n            transform: translateY(20%);\n          }\n          100% {\n            transform: translateY(0%);\n          }\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        delay: {
          type: Number
        },
        triggerAnimate: {
          attribute: 'trigger-animate',
          type: Boolean
        },
        disableAnimateMobile: {
          attribute: 'disable-animate-mobile',
          type: String
        } // small, medium
      };
    }
  }]);
  return FwcAnimColDropComponent;
}(LitElement);
var FwcAnimColDrop = /*#__PURE__*/function (_FwcBase4) {
  _inherits$1(FwcAnimColDrop, _FwcBase4);
  var _super9 = _createSuper$8(FwcAnimColDrop);
  function FwcAnimColDrop() {
    _classCallCheck$1(this, FwcAnimColDrop);
    return _super9.call(this, 'fwc-anim-col-drop', FwcAnimColDropComponent);
  }
  return _createClass$1(FwcAnimColDrop);
}(FwcBase$1);
function debounce$2(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
var FwcBackToTopComponent = /*#__PURE__*/function (_LitElement6) {
  _inherits$1(FwcBackToTopComponent, _LitElement6);
  var _super10 = _createSuper$8(FwcBackToTopComponent);
  function FwcBackToTopComponent() {
    var _this10;
    _classCallCheck$1(this, FwcBackToTopComponent);
    _this10 = _super10.call(this);
    _this10._bodyEle = document.documentElement;
    _this10._hideButton = true;
    _this10.labelBtn = 'Back to Top';
    _this10.showButtonAtPx = 1000;
    //listen for scroll every 250ms
    _this10._handleScroll = debounce$2(function () {
      _this10.checkScrollPos();
    }, 250);
    return _this10;
  }
  _createClass$1(FwcBackToTopComponent, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this11 = this;
      _get(_getPrototypeOf(FwcBackToTopComponent.prototype), "connectedCallback", this).call(this);
      window.addEventListener('scroll', function () {
        _this11._handleScroll();
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this12 = this;
      window.removeEventListener('scroll', function () {
        _this12._handleScroll();
      });
      _get(_getPrototypeOf(FwcBackToTopComponent.prototype), "disconnectedCallback", this).call(this);
    }

    // check if we show or hide btn based on if page is scrolled past showButtonAtPx
  }, {
    key: "checkScrollPos",
    value: function checkScrollPos() {
      this._hideButton = window.pageYOffset >= this.showButtonAtPx ? false : true;
    }
  }, {
    key: "scrollToTopOfWindow",
    value: function scrollToTopOfWindow() {
      this._hideButton = true;
      //passing in reference of (this) since setInterval takes scope of this keyword
      this.fadeOut(this._bodyEle, this.fadeIn, this);
    }

    //fade out body
  }, {
    key: "fadeOut",
    value: function fadeOut(element, callback, _this) {
      var op = 1; // initial opacity
      var increment = 0.05;
      var timer = setInterval(function () {
        if (op <= 0) {
          clearInterval(timer);
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          callback(element, _this);
        }
        element.style.opacity = op;
        element.style.filter = 'alpha(opacity=' + op + ')';
        op = op - increment;
      }, 15);
    }

    //fade in body
  }, {
    key: "fadeIn",
    value: function fadeIn(element, _this) {
      var op = 0; // initial opacity
      var increment = 0.05;
      var timer = setInterval(function () {
        if (op >= 1) {
          clearInterval(timer);
          /* c8 ignore next 2 */
          _this._returnFocus();
        }
        element.style.opacity = op;
        element.style.filter = 'alpha(opacity=' + op + ')';
        op = op + increment;
      }, 15);
    }
  }, {
    key: "_returnFocus",
    value: function _returnFocus() {
      if (this._refocusElem) {
        // Return focus to calling element
        this._refocusElem.focus();
      }
    }

    // a public func allowing projects to set the refocus element
  }, {
    key: "setReFocus",
    value: function setReFocus(elem) {
      this._refocusElem = elem;
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject16$1 || (_templateObject16$1 = _taggedTemplateLiteral(["\n      <button\n        role=\"button\"\n        class=\"back-to-top ", " \"\n        @click=\"", "\"\n      >\n        <svg\n          class=\"fwc-icon-arrow\"\n          aria-hidden=\"true\"\n          xmlns=\"http://www.w3.org/2000/svg\"\n          width=\"20\"\n          height=\"20\"\n          viewBox=\"0 0 50 50\"\n          focusable=\"false\"\n        >\n          <polygon\n            id=\"Path\"\n            points=\"30.7843137 5 27.7777778 8.00653595 41.9607843 22.1895425 0 22.1895425 0 26.372549 41.9607843 26.372549 27.7777778 40.5555556 30.7843137 43.5620915 48.5620915 25.7843137 50 24.2810458 48.5620915 22.7777778\"\n          ></polygon>\n        </svg>\n        <span>", "</span>\n      </button>\n    "])), this._hideButton ? 'hidden' : '', this.scrollToTopOfWindow, this.labelBtn);
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject17$1 || (_templateObject17$1 = _taggedTemplateLiteral(["\n        .back-to-top {\n          font-family: var(--font-sans-serif);\n          position: fixed;\n          bottom: 5%;\n          left: 50%;\n          transform: translateX(-50%);\n          color: white;\n          opacity: 0.85;\n          background: var(--color-util-four);\n          display: flex;\n          line-height: calc(2 * var(--fwcu));\n          flex-direction: row;\n          justify-content: space-between;\n          align-items: center;\n          padding: calc(1.25 * var(--fwcu)) calc(2 * var(--fwcu));\n          text-decoration: none;\n          border-radius: calc(3.25 * var(--fwcu));\n          z-index: 1;\n          font-weight: 700;\n          font-size: var(--default-font-size);\n          border: none;\n        }\n        .back-to-top:hover,\n        .back-to-top:focus,\n        .back-to-top:active,\n        .back-to-top:active:focus {\n          color: var(--color-white);\n        }\n        .back-to-top:hover {\n          opacity: 1;\n          background: var(--color-util-four);\n          cursor: pointer;\n        }\n        .fwc-icon-arrow {\n          transform: rotate(-90deg);\n          font-size: calc(2.25 * var(--fwcu));\n          fill: var(--color-white);\n        }\n        .back-to-top.hidden {\n          display: none;\n        }\n        span {\n          display: block;\n          margin-left: calc(1.25 * var(--fwcu));\n        }\n        @media screen and (max-width: 600px) {\n          .back-to-top {\n            bottom: 10%;\n          }\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        labelBtn: {
          attribute: 'label-btn',
          type: String
        },
        showButtonAtPx: {
          attribute: 'show-button-at-px',
          type: Number
        },
        _hideButton: {}
      };
    }
  }]);
  return FwcBackToTopComponent;
}(LitElement);
var FwcBackToTop = /*#__PURE__*/function (_FwcBase5) {
  _inherits$1(FwcBackToTop, _FwcBase5);
  var _super11 = _createSuper$8(FwcBackToTop);
  function FwcBackToTop() {
    _classCallCheck$1(this, FwcBackToTop);
    return _super11.call(this, 'fwc-back-to-top', FwcBackToTopComponent);
  }
  return _createClass$1(FwcBackToTop);
}(FwcBase$1);
var FwcBarsComponent = /*#__PURE__*/function (_LitElement7) {
  _inherits$1(FwcBarsComponent, _LitElement7);
  var _super12 = _createSuper$8(FwcBarsComponent);
  function FwcBarsComponent() {
    var _this13;
    _classCallCheck$1(this, FwcBarsComponent);
    _this13 = _super12.call(this);
    _this13.bars = [];
    return _this13;
  }
  _createClass$1(FwcBarsComponent, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldval, newval) {
      if (name === 'bars' && oldval) {
        this.bars = JSON.parse(newval);
        this._buildBars();
      }
      _get(_getPrototypeOf(FwcBarsComponent.prototype), "attributeChangedCallback", this).call(this, name, oldval, newval);
    }
  }, {
    key: "_buildBars",
    value: function _buildBars() {
      // TODO: Num types: $, %, etc
      // TODO: Aria

      var bars = html(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["", ""])), this.bars.map(function (bar) {
        var w = Math.floor(bar.value / bar.max * 100);
        return html(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n        <dt>", "</dt>\n        <dd class=\"fwc-cb-flex\">\n          <div class=\"fwc-cb-container\">\n            <div class=\"fwc-cb-bar\" style=\"width:", "%\"></div>\n          </div>\n          <div><strong>", "</strong><span>/", "</span></div>\n        </dd>\n      "])), bar.title, w, bar.value, bar.max);
      }));
      return bars;
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral([" <dl>", "</dl> "])), this._buildBars());
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n        .fwc-cb-flex {\n          width: 100%;\n          display: flex;\n          flex-direction: row;\n        }\n        .fwc-cb-container {\n          width: calc(100% - 1.5 * var(--fwcu));\n          height: calc(2.75 * var(--fwcu));\n          display: flex;\n          align-items: center;\n          justify-content: flex-start;\n          overflow: hidden;\n          border: 1px solid transparent;\n          border-radius: calc(2.75 * var(--fwcu));\n          background-color: var(--color-gray-five);\n        }\n        .fwc-cb-bar {\n          height: calc(2.75 * var(--fwcu));\n          border: 1px solid transparent;\n          border-radius: calc(2.75 * var(--fwcu));\n          transition: width 500ms cubic-bezier(0.2, -0.02, 0.8, 1.4);\n          background-color: var(--color-dviz-one);\n        }\n        dl {\n          color: var(--color-gray-one);\n          font-size: var(--default-font-size);\n        }\n\n        dl .fwc-cb-flex:nth-of-type(2n) .fwc-cb-bar {\n          background-color: var(--color-dviz-four);\n        }\n        dl .fwc-cb-flex:nth-of-type(3n) .fwc-cb-bar {\n          background-color: var(--color-dviz-eight);\n        }\n        dl .fwc-cb-flex:nth-of-type(4n) .fwc-cb-bar {\n          background-color: var(--color-dviz-seven);\n        }\n\n        dl,\n        dt,\n        dd {\n          margin: 0;\n          padding: 0;\n        }\n        strong {\n          padding-left: calc(1.5 * var(--fwcu));\n        }\n        @media screen and (max-width: 900px) {\n          .fwc-cb-flex {\n            flex-direction: column;\n          }\n          .fwc-cb-container {\n            width: 100%;\n          }\n          strong {\n            padding-left: 0;\n          }\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        bars: {
          type: Array
        }
      };
    }
  }]);
  return FwcBarsComponent;
}(LitElement);
var FwcBars = /*#__PURE__*/function (_FwcBase6) {
  _inherits$1(FwcBars, _FwcBase6);
  var _super13 = _createSuper$8(FwcBars);
  function FwcBars() {
    _classCallCheck$1(this, FwcBars);
    return _super13.call(this, 'fwc-bars', FwcBarsComponent);
  }
  return _createClass$1(FwcBars);
}(FwcBase$1);
var FwcCardMediaImageComponent = /*#__PURE__*/function (_LitElement10) {
  _inherits$1(FwcCardMediaImageComponent, _LitElement10);
  var _super18 = _createSuper$8(FwcCardMediaImageComponent);
  function FwcCardMediaImageComponent() {
    var _this21;
    _classCallCheck$1(this, FwcCardMediaImageComponent);
    _this21 = _super18.call(this);
    _this21.badge = null;
    _this21.badgeClass = 'success';
    _this21.bookmark = null;
    _this21.bookmarkStates = {
      checked: 'checked',
      unchecked: 'unchecked'
    };
    _this21.config = fwcConfig$1;
    _this21.sizes = {
      sm: 'sm',
      md: 'md',
      lg: 'lg',
      full: 'full'
    };
    _this21.image = null;
    _this21.labelAriaBookmark = 'Bookmark';
    _this21.size = _this21.sizes.sm;
    return _this21;
  }
  _createClass$1(FwcCardMediaImageComponent, [{
    key: "updated",
    value: function updated(changedProperties) {
      var _this22 = this;
      changedProperties.forEach(function (oldValue, propName) {
        if (propName === 'bookmark' && oldValue) {
          _this22._updateBookmarkState();
        }
        if (propName === 'image') {
          _this22._initImage();
          _this22._onImageLoad();
        }
      });
    }
  }, {
    key: "_updateBookmarkState",
    value: function _updateBookmarkState() {
      var btn = this.shadowRoot.querySelector('#Bookmark');
      switch (this.bookmark) {
        case this.bookmarkStates.unchecked:
          btn.classList.remove('active');
          break;
        case this.bookmarkStates.checked:
          btn.classList.add('active');
          break;
      }
    }
  }, {
    key: "_setBookmarkState",
    value: function _setBookmarkState() {
      var oldVal = this.shadowRoot.querySelector('#Bookmark').classList.contains('active');
      this.bookmark = oldVal ? this.bookmarkStates.unchecked : this.bookmarkStates.checked;
    }
  }, {
    key: "_onBookmarkClick",
    value: function _onBookmarkClick(e) {
      this._setBookmarkState();
      var event = new CustomEvent('fwc-card-media-image-bookmark', {
        detail: this,
        bubbles: true
      });
      this.dispatchEvent(event);
    }
  }, {
    key: "_initBookmark",
    value: function _initBookmark() {
      return html(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n      <button\n        id=\"Bookmark\"\n        class=\"bookmark ", "\"\n        @click=", "\n        aria-label=\"", "\"\n        aria-pressed=\"", "\"\n      >\n        <svg\n          xmlns=\"http://www.w3.org/2000/svg\"\n          version=\"1.1\"\n          width=\"50px\"\n          height=\"50px\"\n          viewBox=\"0 0 50 50\"\n        >\n          <path\n            d=\"M5,0 L5,50 L8.46467391,47.4184783 L24.5652174,35.326087 L40.6657609,47.4184783 L44.1304348,50 L44.1304348,0 L5,0 Z M9.34782609,4.34782609 L39.7826087,4.34782609 L39.7826087,41.3043478 L25.8559783,30.8423913 L24.5652174,29.8913043 L23.2744565,30.8423913 L9.34782609,41.3043478 L9.34782609,4.34782609 Z\"\n          />\n        </svg>\n      </button>\n    "])), this.bookmark === this.bookmarkStates.checked ? 'active' : '', this._onBookmarkClick, this.labelAriaBookmark, this.bookmark === this.bookmarkStates.checked);
    }
  }, {
    key: "_initOptional",
    value: function _initOptional() {
      return html(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n      <div class=\"optional ", "\" id=\"Optional\">\n        ", "\n        ", "\n      </div>\n    "])), this.badge ? 'between' : 'end', this._initBadge(), ifDefined(this.bookmark ? this._initBookmark() : null));
    }
  }, {
    key: "_initBadge",
    value: function _initBadge() {
      var badge = this.badge ? html(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["<span class=\"fwc-badge ", "\">", "</span>"])), this.badgeClass, this.badge) : null;
      return badge;
    }
  }, {
    key: "_initBody",
    value: function _initBody() {
      var slot = html(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["<slot name=\"body\"></slot>"])));
      var body = html(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["<p>", "</p>"])), this.body);
      return this.body ? body : slot;
    }
  }, {
    key: "_initTitle",
    value: function _initTitle() {
      var h2 = html(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["<h2>", "</h2>"])), this.title);
      var h3 = html(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["<h3>", "</h3>"])), this.title);
      var title = this.size === this.sizes.lg ? h2 : h3;
      return title;
    }
  }, {
    key: "_onImageLoad",
    value: function _onImageLoad() {
      var img = this.shadowRoot.querySelector('#Image');
      if (img) {
        img.addEventListener('load', function (e) {
          e.target.classList.add('load');
        });
      }
    }
  }, {
    key: "_initImage",
    value: function _initImage() {
      if (this.image) {
        var source = this.image.source ? this.image.source : [];
        var srcset = source.map(function (src) {
          return html(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n          <source\n            srcset=\"", "\"\n            media=\"", "\"\n            type=\"", "\"\n          />\n        "])), src.srcset, ifDefined(src.media ? src.media : undefined), ifDefined(src.type ? src.type : undefined));
        });
        return html(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n        <picture>\n          ", "\n          <img\n            id=\"Image\"\n            src=\"", "\"\n            alt=\"", "\"\n            width=\"", "\"\n            height=\"", "\"\n            class=\"", "\"\n            @loadstart=", "\n          />\n        </picture>\n      "])), srcset, this.image.img.src, this.image.img.alt, this.image.img.width, this.image.img.height, this.size, this._onImageLoad);
      }
      return html(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n      <div id=\"Placeholder\" class=\"placeholder ", "\">\n        <svg\n          xmlns=\"http://www.w3.org/2000/svg\"\n          width=\"50\"\n          height=\"51\"\n          viewBox=\"0 0 50 51\"\n        >\n          <path\n            d=\"M0,5 L0,43.4615385 L50,43.4615385 L50,5 L0,5 Z M3.84615385,8.84615385 L46.1538462,8.84615385 L46.1538462,34.9278846 L31.1899038,19.9639423 L29.8076923,18.6418269 L28.4254808,19.9639423 L24.0384615,24.3509615 L16.7668269,17.0793269 L15.3846154,15.7572115 L14.0024038,17.0793269 L3.84615385,27.2355769 L3.84615385,8.84615385 Z M37.5,10.7692308 C34.8707942,10.7692308 32.6923077,12.9477173 32.6923077,15.5769231 C32.6923077,18.2061308 34.8707942,20.3846154 37.5,20.3846154 C40.1292077,20.3846154 42.3076923,18.2061308 42.3076923,15.5769231 C42.3076923,12.9477173 40.1292077,10.7692308 37.5,10.7692308 Z M37.5,14.6153846 C38.0558904,14.6153846 38.4615385,15.0210346 38.4615385,15.5769231 C38.4615385,16.1328135 38.0558904,16.5384615 37.5,16.5384615 C36.9441115,16.5384615 36.5384615,16.1328135 36.5384615,15.5769231 C36.5384615,15.0210346 36.9441115,14.6153846 37.5,14.6153846 Z M15.3846154,21.2259615 L21.2740385,27.1153846 L8.77403846,39.6153846 L3.84615385,39.6153846 L3.84615385,32.7644231 L15.3846154,21.2259615 Z M29.8076923,24.1105769 L45.3125,39.6153846 L14.3028846,39.6153846 L29.8076923,24.1105769 Z\"\n            transform=\"translate(0 .23)\"\n          />\n        </svg>\n      </div>\n    "])), this.size);
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n      <link\n        rel=\"stylesheet\"\n        href=\"", "fwc-assets/styles/components/fwc-badges.css\"\n      />\n      <link\n        rel=\"stylesheet\"\n        href=\"", "fwc-assets/styles/typography.css\"\n      />\n\n      <div class=\"card ", "\">\n        <div class=\"wrapper\">\n          ", "\n          ", "\n        </div>\n        <div class=\"content\" id=\"Content\">\n          ", "\n          ", " ", "\n          ", "\n          <slot name=\"links\"></slot>\n        </div>\n      </div>\n    "])), this.config.assetsPath, this.config.assetsPath, this.size, this._initImage(), this.size !== this.sizes.full ? this._initOptional() : '', this.size === this.sizes.full ? this._initOptional() : '', this._initTitle(), this.body ? html(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["<p>", "</p>"])), this.body) : null, !this.body ? html(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["<slot name=\"body\" id=\"SlotBody\"></slot>"]))) : null);
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n        :host {\n          width: 100%;\n          height: 100%;\n          display: block;\n        }\n        .card {\n          background: var(--color-white);\n          border-radius: var(--border-radius);\n          box-shadow: var(--box-shadow);\n          overflow: hidden;\n          height: 100%;\n        }\n        .card.full {\n          display: flex;\n          flex-direction: row-reverse;\n          align-items: stretch;\n          max-height: calc(34 * var(--fwcu)); /* 272px */\n        }\n\n        .wrapper {\n          position: relative;\n        }\n\n        .optional {\n          position: absolute;\n          display: flex;\n          align-items: center;\n          height: calc(4 * var(--fwcu));\n          width: 100%;\n          bottom: calc(-1 * var(--fwcu));\n          padding: 0 calc(3 * var(--fwcu));\n        }\n        .optional.end {\n          justify-content: flex-end;\n        }\n        .optional.between {\n          justify-content: space-between;\n        }\n\n        .content {\n          padding: calc(3 * var(--fwcu));\n        }\n\n        .card.md .content {\n          padding: calc(4 * var(--fwcu));\n        }\n        .card.md .optional {\n          padding: 0 calc(4 * var(--fwcu));\n        }\n\n        .card.lg .content {\n          padding: calc(4 * var(--fwcu)) calc(6 * var(--fwcu));\n        }\n        .card.full .content {\n          padding: calc(4 * var(--fwcu)) calc(6 * var(--fwcu));\n        }\n\n        .card.lg .optional {\n          padding: 0 calc(6 * var(--fwcu));\n        }\n\n        .content p {\n          padding: calc(1.5 * var(--fwcu)) 0 calc(2.5 * var(--fwcu));\n        }\n\n        /* Full size cards */\n        .content .optional {\n          position: static;\n          height: auto;\n          padding: 0 0 calc(3.25 * var(--fwcu)) 0;\n        }\n\n        .bookmark {\n          height: calc(5 * var(--fwcu));\n          width: calc(5 * var(--fwcu));\n          border: 1px solid var(--color-primary);\n          border-radius: 50%;\n          background-color: var(--color-white);\n          font-size: calc(2.75 * var(--fwcu));\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          cursor: pointer;\n          padding: 0;\n        }\n        .bookmark.active {\n          background-color: var(--color-primary);\n        }\n        .bookmark svg {\n          fill: var(--color-primary);\n          height: calc(2.25 * var(--fwcu));\n          width: calc(2.25 * var(--fwcu));\n        }\n        .bookmark.active svg {\n          fill: var(--color-white);\n        }\n\n        slot[name='links'] {\n          display: flex;\n          align-items: center;\n          justify-content: flex-start;\n          flex-wrap: wrap;\n        }\n        slot[name='links']::slotted(a) {\n          flex: 0 0 auto;\n          padding-right: calc(2 * var(--fwcu));\n          padding-bottom: var(--fwcu);\n        }\n        slot[name='body'] {\n          padding: calc(1.5 * var(--fwcu)) 0 calc(2.5 * var(--fwcu));\n          display: block;\n        }\n\n        .placeholder {\n          background: var(--color-gray-six);\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n        .placeholder svg {\n          fill: var(--color-gray-four);\n        }\n\n        img {\n          opacity: 0;\n          transition: opacity 250ms ease-out;\n        }\n        img.load {\n          opacity: 1;\n        }\n        img,\n        .placeholder {\n          object-fit: cover;\n          object-position: top center;\n          width: 100%;\n          height: auto;\n        }\n        img.full,\n        .placeholder.full {\n          aspect-ratio: 1.68 / 1;\n          height: 100%;\n        }\n\n        img.sm,\n        .placeholder.sm {\n          aspect-ratio: 1.6 / 1;\n        }\n        img.md,\n        .placeholder.md {\n          aspect-ratio: 2.45 / 1;\n        }\n        img.lg,\n        .placeholder.lg {\n          aspect-ratio: 2 / 1;\n        }\n\n        @media screen and (max-width: 600px) {\n          .card.md .content,\n          .card.lg .content,\n          .card.full .content {\n            padding: calc(3 * var(--fwcu));\n          }\n\n          .card.md .optional,\n          .card.lg .optional {\n            padding: 0 calc(3 * var(--fwcu));\n          }\n\n          .card.full {\n            display: block;\n            max-height: none;\n          }\n          .card.full .content {\n            padding-top: 0;\n          }\n          .content .optional {\n            position: relative;\n            top: calc(-3 * var(--fwcu));\n            padding-bottom: 0;\n          }\n\n          img.md,\n          img.lg,\n          img.full,\n          .placeholder.md,\n          .placeholder.lg,\n          .placeholder.full {\n            aspect-ratio: 1.6 / 1;\n          }\n        }\n\n        /* Safari doesn't support aspect-raitio yet */\n        @supports not (aspect-ratio: 1.6 / 1) {\n          img.sm,\n          img.md,\n          .placeholder.sm,\n          .placeholder.md {\n            height: calc(28 * var(--fwcu)); /* 224px */\n          }\n          img.lg,\n          .placeholder.lg {\n            height: calc(46.5 * var(--fwcu)); /* 372px */\n          }\n          img.full,\n          .placeholder.full {\n            height: calc(34 * var(--fwcu)); /* 272px */\n          }\n          @media screen and (max-width: 600px) {\n            img.lg,\n            img.full,\n            .placeholder.lg,\n            .placeholder.full {\n              height: calc(28 * var(--fwcu)); /* 224px */\n            }\n          }\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        badge: {
          type: String
        },
        badgeClass: {
          attribute: 'badge-class',
          type: String
        },
        body: {
          type: String
        },
        bookmark: {
          type: String,
          reflect: true
        },
        config: {
          type: Object
        },
        image: {
          type: Object
        },
        labelAriaBookmark: {
          attribute: 'label-aria-bookmark',
          type: String
        },
        size: {
          type: String
        },
        title: {
          type: String
        }
      };
    }
  }]);
  return FwcCardMediaImageComponent;
}(LitElement);
var FwcCardMediaImage = /*#__PURE__*/function (_FwcBase9) {
  _inherits$1(FwcCardMediaImage, _FwcBase9);
  var _super19 = _createSuper$8(FwcCardMediaImage);
  function FwcCardMediaImage() {
    _classCallCheck$1(this, FwcCardMediaImage);
    return _super19.call(this, 'fwc-card-media-image', FwcCardMediaImageComponent);
  }
  return _createClass$1(FwcCardMediaImage);
}(FwcBase$1);
var FwcCarouselGenericComponent = /*#__PURE__*/function (_LitElement11) {
  _inherits$1(FwcCarouselGenericComponent, _LitElement11);
  var _super20 = _createSuper$8(FwcCarouselGenericComponent);
  function FwcCarouselGenericComponent() {
    var _this23;
    _classCallCheck$1(this, FwcCarouselGenericComponent);
    _this23 = _super20.call(this);
    _this23._active = 0;
    _this23.carouselItems = [];
    _this23.grouping = 1;
    _this23.labelAria = 'Carousel';
    _this23.labelAriaNextBtn = 'Next Slide';
    _this23.labelAriaPrevBtn = 'Previous Slide';
    _this23.dataAnalyticsPrevBtn = '';
    _this23.dataAnalyticsNextBtn = '';
    _this23.wrapper = null;
    _this23._nextDisabled = false;
    _this23._prevDisabled = false;
    _this23._timeout = false;
    _this23._groupingStore = 1;
    return _this23;
  }
  _createClass$1(FwcCarouselGenericComponent, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this24 = this;
      _get(_getPrototypeOf(FwcCarouselGenericComponent.prototype), "connectedCallback", this).call(this);
      window.addEventListener('resize', function () {
        return _this24._handleResize();
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this25 = this;
      window.removeEventListener('resize', function () {
        return _this25._handleResize();
      });
      _get(_getPrototypeOf(FwcCarouselGenericComponent.prototype), "disconnectedCallback", this).call(this);
    }
  }, {
    key: "firstUpdated",
    value: function firstUpdated() {
      var _this26 = this;
      var pagerEl = this.shadowRoot.getElementById('Pagination');
      var animationEndEvent = new CustomEvent('fwc-carousel-generic-animation-end', {
        detail: this,
        bubbles: true,
        composed: false
      });
      this.carouselItems = this._getSlotted();
      this._hideBtns = this.carouselItems.length > 1 ? false : true;
      this._handleScroll();
      this.requestUpdate();
      this._setDisabled();
      this._groupingStore = this.grouping;
      this._setPagerView();
      pagerEl.onanimationend = function () {
        _this26.dispatchEvent(animationEndEvent);
      };
    }
  }, {
    key: "_handleScroll",
    value: function _handleScroll() {
      var _this27 = this;
      var scrollContainer = this.shadowRoot.getElementById('Container');
      var ticking = false;
      var last_known_x_pos = 0;
      scrollContainer.addEventListener('scroll', function () {
        last_known_x_pos = Math.round(scrollContainer.scrollLeft);
        if (!ticking) {
          window.requestAnimationFrame(function () {
            _this27._setActivePageFromScroll(last_known_x_pos);
            ticking = false;
          });
          ticking = true;
        }
      });
    }
  }, {
    key: "_setActivePageFromScroll",
    value: function _setActivePageFromScroll(posLeft) {
      if (posLeft === 0) {
        this._active = 0;
        return;
      }
      this._active = Math.ceil(Math.round(posLeft / this.carouselItems[0].offsetWidth));
      this._setDisabled();
    }
  }, {
    key: "_getPager",
    value: function _getPager(cards) {
      var numPagers = this.grouping > 1 ? Math.ceil(cards.length / this.grouping) : cards.length;
      var active = this.grouping > 1 ? Math.ceil(this._active / this.grouping) : this._active;
      var items = [];
      for (var i = 0; i < numPagers; i++) {
        items.push(html(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["<span\n          id=\"pager_", "\"\n          class=\"", "\"\n        ></span>"])), i, i === active ? 'active' : ''));
      }
      return items;
    }
  }, {
    key: "_setPagerView",
    value: function _setPagerView() {
      if (window.innerWidth <= breakpoints$1.sm) {
        this.grouping = 1;
      } else {
        this.grouping = this._groupingStore;
      }
    }
  }, {
    key: "_handleResize",
    value: function _handleResize() {
      var _this28 = this;
      clearTimeout(this._timeout);
      this._timeout = setTimeout(function () {
        _this28._setPagerView();
      }, 250);
    }
  }, {
    key: "_setEventAndScroll",
    value: function _setEventAndScroll(slide, name) {
      var event = new CustomEvent(name, {
        detail: this,
        bubbles: true,
        composed: false
      });
      this.carouselItems[slide].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
      this.dispatchEvent(event);
    }
  }, {
    key: "_next",
    value: function _next() {
      var next = this._active;
      this._nextDisabled = true;
      if (next + 1 >= this.carouselItems.length) {
        return;
      }
      if (this.grouping > 1) {
        next = this._active + this.grouping * 2 - 1;
        if (next > this.carouselItems.length - 1) {
          next = this.carouselItems.length - 1;
        }
      } else {
        next += 1;
      }
      this._setEventAndScroll(next, 'fwc-carousel-generic-next');
    }
  }, {
    key: "_prev",
    value: function _prev() {
      var prev = this._active;
      this._prevDisabled = true;
      if (this.grouping > 1) {
        if (prev % this.grouping === 1) {
          prev -= 1;
        } else {
          prev = this._active - this.grouping;
        }
      } else {
        prev -= 1;
      }
      if (prev < 0) {
        prev = 0;
      }
      this._setEventAndScroll(prev, 'fwc-carousel-generic-prev');
    }
  }, {
    key: "_setDisabled",
    value: function _setDisabled() {
      var gCheck = this.grouping > 1 ? this._active + this.grouping : this._active + 1;
      if (this._active - 1 < 0) {
        this._prevDisabled = true;
      } else {
        this._prevDisabled = false;
      }
      if (gCheck >= this.carouselItems.length) {
        this._nextDisabled = true;
      } else {
        this._nextDisabled = false;
      }
    }
  }, {
    key: "nextSlide",
    value: function nextSlide() {
      this._next();
    }
  }, {
    key: "prevSlide",
    value: function prevSlide() {
      this._prev();
    }
  }, {
    key: "slideToId",
    value: function slideToId(id) {
      if (this.isValidData(id)) {
        this._setEventAndScroll(id, 'fwc-carousel-generic-slide');
      }
    }
  }, {
    key: "_buildGroupedChildren",
    value: function _buildGroupedChildren(children) {
      for (var i = 0; i < children.length; i++) {
        children[i].setStyles(100 / this.grouping);
        children[i].setAttribute('id', 'Slide_' + i);
      }
      return children;
    }
  }, {
    key: "_getSlotted",
    value: function _getSlotted() {
      var slot = this.shadowRoot.querySelector('slot');
      var childNodes = slot ? slot.assignedNodes({
        flatten: true
      }) : [];
      var children = childNodes.filter(function (node) {
        return node.nodeType == Node.ELEMENT_NODE && node.nodeName === 'FWC-CAROUSEL-GENERIC-ITEM';
      });
      var slides = this.grouping > 1 ? this._buildGroupedChildren(children) : children;
      return slides;
    }

    /* c8 ignore next 21 */
  }, {
    key: "isValidData",
    value: function isValidData(id) {
      var errors = false;
      try {
        if (id > this.carouselItems.length - 1) {
          errors = true;
          throw new Error("slideToId: ".concat(id, " is greater than this.carouselItems.length. Max: ").concat(this.carouselItems.length - 1, " "));
        }
      } catch (error) {
        console.error(error);
      }
      try {
        if (id < 0) {
          errors = true;
          throw new Error("slideToId: ".concat(id, " is not valid. Min: 0 or greater is required "));
        }
      } catch (error) {
        console.error(error);
      }
      return !errors;
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n      <section\n        class=\"fwc-carousel-generic-wrapper\"\n        aria-roledescription=\"carousel\"\n        aria-label=\"", "\"\n      >\n        <div class=\"fwc-carousal-wrapper\">\n          <button\n            class=\"fwc-prev ", "\"\n            ?disabled=", "\n            @click=\"", "\"\n            aria-label=\"", "\"\n            aria-hidden=\"", "\"\n            aria-disabled=\"", "\"\n            data-analytics=\"", "\"\n          >\n            <svg\n              xmlns=\"http://www.w3.org/2000/svg\"\n              width=\"50\"\n              height=\"50\"\n              viewBox=\"0 0 50 50\"\n              focusable=\"false\"\n            >\n              <polygon\n                points=\"2.719 39.66 0 36.941 23.641 13.3 25 12 26.359 13.3 50 36.941 47.281 39.66 25 17.378\"\n                transform=\"matrix(1 0 0 -1 0 51.66)\"\n              ></polygon>\n            </svg>\n          </button>\n\n          <div id=\"Container\" class=\"fwc-list-cont\" tabindex=\"0\">\n            <slot role=\"list\" aria-label=\"carousel\"></slot>\n          </div>\n\n          <button\n            class=\"fwc-next ", "\"\n            ?disabled=", "\n            @click=\"", "\"\n            aria-label=\"", "\"\n            aria-hidden=\"", "\"\n            aria-disabled=\"", "\"\n            data-analytics=\"", "\"\n          >\n            <svg\n              xmlns=\"http://www.w3.org/2000/svg\"\n              width=\"50\"\n              height=\"50\"\n              viewBox=\"0 0 50 50\"\n              focusable=\"false\"\n            >\n              <polygon\n                points=\"2.719 39.66 0 36.941 23.641 13.3 25 12 26.359 13.3 50 36.941 47.281 39.66 25 17.378\"\n                transform=\"matrix(1 0 0 -1 0 51.66)\"\n              ></polygon>\n            </svg>\n          </button>\n        </div>\n        <div id=\"Pagination\" class=\"fwc-pager\">\n          ", "\n        </div>\n      </section>\n    "])), this.labelAria, this._hideBtns ? 'hidden' : '', this._prevDisabled, this._prev, this.labelAriaPrevBtn, this._hideBtns, this._prevDisabled, this.dataAnalyticsPrevBtn, this._hideBtns ? 'hidden' : '', this._nextDisabled, this._next, this.labelAriaNextBtn, this._hideBtns, this._nextDisabled, this.dataAnalyticsNextBtn, this._getPager(this.carouselItems));
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n        :host {\n          width: 100%;\n          display: block;\n        }\n        .fwc-carousel-generic-wrapper {\n          position: relative;\n        }\n\n        .fwc-carousel-generic-wrapper:focus {\n          outline: none;\n        }\n\n        .fwc-list-cont {\n          flex-grow: 1;\n          flex-shrink: 1;\n          flex-basis: calc(100% - (9 * var(--fwcu)));\n          padding: 0;\n          overflow-x: auto;\n          overflow-y: hidden;\n          -webkit-overflow-scrolling: touch;\n          scroll-snap-type: x mandatory;\n          scroll-behavior: smooth;\n          scrollbar-width: none;\n          display: flex;\n          max-width: calc(144 * var(--fwcu));\n          margin: 0 auto;\n          align-items: stretch;\n          justify-content: flex-start;\n          flex-wrap: nowrap;\n        }\n        .fwc-list-cont::-webkit-scrollbar,\n        .fwc-list-cont::-webkit-scrollbar-track,\n        .fwc-list-cont::-webkit-scrollbar-thumb {\n          width: 0;\n          height: 0;\n          display: none;\n        }\n\n        .fwc-carousal-wrapper {\n          background-color: transparent;\n          padding: calc(4.5 * var(--fwcu)) 0;\n          display: flex;\n          align-items: center;\n          width: 100%;\n          margin: 0 auto;\n        }\n\n        button {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          height: calc(4.5 * var(--fwcu));\n          width: calc(4.5 * var(--fwcu));\n          background: var(--color-white);\n          border-radius: 50%;\n          border: 1px solid var(--color-gray-four);\n          flex-basis: calc(4.5 * var(--fwcu));\n          box-shadow: var(--box-shadow);\n          padding: 0;\n          cursor: pointer;\n        }\n        button:disabled {\n          border-color: var(--color-gray-five);\n          pointer-events: none;\n          color: var(--color-gray-three);\n          box-shadow: none;\n        }\n        button:disabled svg {\n          fill: var(--color-gray-three);\n        }\n        button.hidden {\n          visibility: hidden;\n          opacity: 0;\n        }\n        button svg {\n          width: calc(1.75 * var(--fwcu));\n          height: calc(1.75 * var(--fwcu));\n          fill: var(--color-primary);\n        }\n        button.fwc-prev svg {\n          transform: rotate(90deg);\n          margin-left: calc(-0.25 * var(--fwcu));\n        }\n        button.fwc-next svg {\n          transform: rotate(-90deg);\n        }\n        .fwc-pager {\n          display: flex;\n          position: absolute;\n          bottom: calc(0.75 * var(--fwcu));\n          left: 0;\n          right: 0;\n          justify-content: center;\n        }\n        .fwc-pager span {\n          width: calc(0.5 * var(--fwcu));\n          height: calc(0.5 * var(--fwcu));\n          background: var(--color-gray-four);\n          display: inline-block;\n          margin: 0 calc(0.25 * var(--fwcu));\n          border-radius: var(--border-radius);\n          transition: all 0.25s ease-in-out;\n        }\n        .fwc-pager span.active {\n          animation-name: carouselSlide;\n          animation-duration: 250ms;\n          background: var(--color-primary);\n          width: calc(1.75 * var(--fwcu));\n        }\n        @keyframes carouselSlide {\n          from {\n            width: calc(0.5 * var(--fwcu));\n          }\n          to {\n            width: calc(1.75 * var(--fwcu));\n          }\n        }\n        @media screen and (max-width: 600px) {\n          .fwc-carousal-wrapper {\n            padding: calc(4.5 * var(--fwcu)) 0;\n          }\n          .fwc-list-cont {\n            width: 100%;\n          }\n        }\n\n        @media screen and (hover: none) and (pointer: coarse) {\n          button {\n            display: none;\n          }\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        grouping: {
          type: Number
        },
        labelAria: {
          attribute: 'label-aria',
          type: String
        },
        labelAriaPrevBtn: {
          attribute: 'label-aria-prev-btn',
          type: String
        },
        labelAriaNextBtn: {
          attribute: 'label-aria-next-btn',
          type: String
        },
        dataAnalyticsPrevBtn: {
          attribute: 'data-analytics-prev-btn',
          type: String
        },
        dataAnalyticsNextBtn: {
          attribute: 'data-analytics-next-btn',
          type: String
        },
        _active: {},
        _nextDisabled: {},
        _prevDisabled: {}
      };
    }
  }]);
  return FwcCarouselGenericComponent;
}(LitElement);
var FwcCarouselGenericItemComponent = /*#__PURE__*/function (_LitElement12) {
  _inherits$1(FwcCarouselGenericItemComponent, _LitElement12);
  var _super21 = _createSuper$8(FwcCarouselGenericItemComponent);
  function FwcCarouselGenericItemComponent() {
    var _this29;
    _classCallCheck$1(this, FwcCarouselGenericItemComponent);
    _this29 = _super21.call(this);
    _this29.basis = 100;
    return _this29;
  }
  _createClass$1(FwcCarouselGenericItemComponent, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      this.setStyles(this.basis);
    }
  }, {
    key: "setStyles",
    value: function setStyles(basis) {
      this.shadowRoot.host.style.width = basis + '%';
      this.shadowRoot.host.style.paddingLeft = 1.5 * baseUnit$1 + 'px';
      this.shadowRoot.host.style.paddingRight = 1.5 * baseUnit$1 + 'px';
      this.basis = basis;
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral([" <slot></slot>"])));
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n        :host {\n          flex-grow: 0;\n          flex-shrink: 0;\n          scroll-snap-align: start;\n        }\n        @media screen and (max-width: 600px) {\n          :host {\n            flex-grow: 1 !important;\n            flex-basis: 100% !important;\n          }\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        basis: {
          type: Number
        }
      };
    }
  }]);
  return FwcCarouselGenericItemComponent;
}(LitElement);
var FwcCarouselGeneric = /*#__PURE__*/function (_FwcBase10) {
  _inherits$1(FwcCarouselGeneric, _FwcBase10);
  var _super22 = _createSuper$8(FwcCarouselGeneric);
  function FwcCarouselGeneric() {
    var _this30;
    _classCallCheck$1(this, FwcCarouselGeneric);
    _this30 = _super22.call(this, 'fwc-carousel-generic', FwcCarouselGenericComponent);
    var FwcCarouselGenericItem = new FwcBase$1('fwc-carousel-generic-item', FwcCarouselGenericItemComponent);
    FwcCarouselGenericItem.build();
    return _this30;
  }
  return _createClass$1(FwcCarouselGeneric);
}(FwcBase$1);
var FOCUSABLE_ELEMENT_SELECTORS = ['a[href]', 'button:not([disabled])', 'input:not([disabled]):not([type="hidden"])', 'select:not([disabled])', 'textarea:not([disabled])', '[contenteditable]', '[tabindex]:not([tabindex="-1"])'].join(', ');
var KEY_CODE_MAP = {
  TAB: 9
};
var keyboardHandler = null;
var containerElementRef = null;
var ignoredSelectorsRef = null;
var targetTrap = null;
function getActiveElement() {
  var activeElement;
  try {
    activeElement = document.activeElement;
  } catch (e) {
    activeElement = document.body || null;
  }
  while (activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement) {
    activeElement = activeElement.shadowRoot.activeElement;
  }
  return activeElement;
}
function getFocusableElements(containerElement, ignoreSelectors) {
  if (!containerElement) {
    throw new Error('Could not initialize focus-trapping - Container Element Missing');
  }

  // store a ref for refresh
  containerElementRef = containerElement;
  ignoredSelectorsRef = ignoreSelectors;
  var focusableElements = [].slice.call(containerElement.querySelectorAll(FOCUSABLE_ELEMENT_SELECTORS));

  // if there is a shadowRoot we need a separate query
  if (containerElement.shadowRoot) {
    var shadowEls = [].slice.call(containerElement.shadowRoot.querySelectorAll(FOCUSABLE_ELEMENT_SELECTORS));
    // shadow elements need to be at the beginning
    focusableElements = shadowEls.concat(focusableElements);
  }

  // remove ignored elements
  if (ignoreSelectors) {
    var ignoredShadowElements = [].slice.call(containerElement.shadowRoot.querySelectorAll(ignoreSelectors.join(',')));
    var ignoredElements = [].slice.call(containerElement.querySelectorAll(ignoreSelectors.join(','))).concat(ignoredShadowElements);
    focusableElements = focusableElements.filter(function (focusableEl) {
      return !ignoredElements.some(function (ignoredEl) {
        return ignoredEl === focusableEl;
      });
    });
  }

  // order by tabindex
  return focusableElements.sort(function (a, b) {
    return Number(a.getAttribute('tabindex')) - Number(b.getAttribute('tabindex'));
  });
}

// ignoreSelectors is an array of strings, a list of css selectors to be ignored by the focus trap
// ['.someElement button']
function focusTrap(containerElement, ignoreSelectors) {
  var focusableElements = getFocusableElements(containerElement, ignoreSelectors);
  targetTrap = focusTrap;
  if (focusableElements.length > 0) {
    var firstFocusableEl = focusableElements[0];
    var lastFocusableEl = focusableElements[focusableElements.length - 1];
    keyboardHandler = function keyboardHandler(e) {
      var activeElem = getActiveElement();
      if (e.keyCode === KEY_CODE_MAP.TAB) {
        // Rotate Focus
        if (e.shiftKey && activeElem === firstFocusableEl) {
          e.preventDefault();
          lastFocusableEl.focus();
        } else if (!e.shiftKey && activeElem === lastFocusableEl) {
          e.preventDefault();
          firstFocusableEl.focus();
        }
      }
    };
    firstFocusableEl.focus();
    containerElement.addEventListener('keydown', keyboardHandler);
  }
}
function focusTrapCustomTabs(containerElement, ignoreSelectors) {
  var focusableElements = getFocusableElements(containerElement, ignoreSelectors);
  targetTrap = focusTrapCustomTabs;
  if (focusableElements.length > 0) {
    var firstFocusableEl = focusableElements[0];
    var lastFocusableEl = focusableElements[focusableElements.length - 1];
    firstFocusableEl.focus();
    keyboardHandler = function keyboardHandler(e) {
      var activeElem = getActiveElement();
      if (e.keyCode === KEY_CODE_MAP.TAB) {
        // Rotate Focus
        if (e.shiftKey && activeElem === firstFocusableEl) {
          e.preventDefault();
          lastFocusableEl.focus();
        } else if (!e.shiftKey && activeElem === lastFocusableEl) {
          e.preventDefault();
          firstFocusableEl.focus();
        } else if (e.shiftKey) {
          // custom tabbing, move to previous tab item on keydown
          e.preventDefault();
          for (var i = focusableElements.length; i > 0; i--) {
            if (activeElem === focusableElements[i]) {
              focusableElements[i - 1].focus();
              return;
            }
          }
        } else {
          // this is the custom tabbing, move to next tab item on keydown
          e.preventDefault();
          for (var _i = 0; _i < focusableElements.length; _i++) {
            if (activeElem === focusableElements[_i]) {
              focusableElements[_i + 1].focus();
              return;
            }
          }
        }
      }
    };

    // firstFocusableEl.focus();
    containerElement.addEventListener('keydown', keyboardHandler);
  }
}
function resetFocusTrap() {
  removeFocusTrapListener(containerElementRef);
  setTimeout(function () {
    targetTrap(containerElementRef, ignoredSelectorsRef);
  }, 0);
}
function removeFocusTrapListener(containerElement) {
  if (containerElement && keyboardHandler) {
    containerElement.removeEventListener('keydown', keyboardHandler);
  }
}
var FwcHeaderPageComponent = /*#__PURE__*/function (_LitElement13) {
  _inherits$1(FwcHeaderPageComponent, _LitElement13);
  var _super23 = _createSuper$8(FwcHeaderPageComponent);
  function FwcHeaderPageComponent() {
    var _this31;
    _classCallCheck$1(this, FwcHeaderPageComponent);
    _this31 = _super23.call(this);
    _this31.title = null;
    _this31.config = fwcConfig$1;
    return _this31;
  }
  _createClass$1(FwcHeaderPageComponent, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      this.classList.add('fwc-container');
    }
  }, {
    key: "_blobs",
    value: function _blobs() {
      var leftBlob = html(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n      <svg\n        class=\"left\"\n        focusable=\"false\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        width=\"450\"\n        height=\"550\"\n        viewBox=\"0 0 450 550\"\n      >\n        <defs>\n          <linearGradient\n            id=\"left-a\"\n            x1=\"29.451%\"\n            x2=\"73.736%\"\n            y1=\"15.098%\"\n            y2=\"84.421%\"\n          >\n            <stop offset=\"0%\" stop-color=\"#FFF\" stop-opacity=\".408\" />\n            <stop offset=\"58.024%\" stop-color=\"#FFF\" stop-opacity=\".182\" />\n            <stop offset=\"100%\" stop-opacity=\".09\" />\n          </linearGradient>\n        </defs>\n        <path\n          fill=\"url(#left-a)\"\n          d=\"M206.715387,10.3410556 L235.347677,9.18888856 C343.848361,4.8228068 435.344954,89.2405817 439.711035,197.741266 C439.926588,203.097915 439.922967,208.461138 439.700183,213.817491 L434.117864,348.031848 C429.780097,452.323739 346.15034,535.840657 241.852688,540.037608 L213.220398,541.189775 C104.719713,545.555857 13.2231213,461.138082 8.85703955,352.637398 C8.64148731,347.280749 8.64510794,341.917526 8.86789236,336.561173 L14.4502111,202.346816 C18.7879779,98.0549252 102.417734,14.5380069 206.715387,10.3410556 Z\"\n          opacity=\".8\"\n          transform=\"translate(.346)\"\n        />\n      </svg>\n    "])));
      var rightBlob = html(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n      <svg\n        class=\"right\"\n        focusable=\"false\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        width=\"450\"\n        height=\"549\"\n        viewBox=\"0 0 450 549\"\n      >\n        <path\n          fill=\"#FFF\"\n          fill-opacity=\".2\"\n          d=\"M1243.71539,9.73218384 L1272.34768,8.58001675 C1380.84836,4.21393499 1472.34495,88.6317099 1476.71104,197.132394 C1476.92659,202.489043 1476.92297,207.852266 1476.70018,213.208619 L1471.11786,347.422976 C1466.7801,451.714867 1383.15034,535.231785 1278.85269,539.428737 L1250.2204,540.580904 C1141.71971,544.946985 1050.22312,460.52921 1045.85704,352.028526 C1045.64149,346.671877 1045.64511,341.308654 1045.86789,335.952301 L1051.45021,201.737945 C1055.78798,97.4460534 1139.41773,13.929135 1243.71539,9.73218384 Z\"\n          transform=\"translate(-1036.654)\"\n        />\n      </svg>\n    "])));
      var midBottomBlob = html(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["\n      <svg\n        class=\"mid-bottom\"\n        focusable=\"false\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        width=\"454\"\n        height=\"547\"\n        viewBox=\"0 0 454 547\"\n      >\n        <defs>\n          <linearGradient\n            id=\"mid-bottom-a\"\n            x1=\"26%\"\n            x2=\"79.518%\"\n            y1=\"36.887%\"\n            y2=\"89.438%\"\n          >\n            <stop offset=\"0%\" stop-color=\"#FFF\" stop-opacity=\".21\" />\n            <stop offset=\"100%\" stop-opacity=\".15\" />\n          </linearGradient>\n        </defs>\n        <path\n          fill=\"url(#mid-bottom-a)\"\n          d=\"M1786.71539,15.7321838 L1815.34768,14.5800167 C1923.84836,10.213935 2015.34495,94.6317099 2019.71104,203.132394 C2019.92659,208.489043 2019.92297,213.852266 2019.70018,219.208619 L2014.11786,353.422976 C2009.7801,457.714867 1926.15034,541.231785 1821.85269,545.428737 L1793.2204,546.580904 C1684.71971,550.946985 1593.22312,466.52921 1588.85704,358.028526 C1588.64149,352.671877 1588.64511,347.308654 1588.86789,341.952301 L1594.45021,207.737945 C1598.78798,103.446053 1682.41773,19.929135 1786.71539,15.7321838 Z\"\n          transform=\"translate(-1577.654 -7)\"\n          style=\"mix-blend-mode:color\"\n        />\n      </svg>\n    "])));
      var midTopBlob = html(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["\n      <svg\n        class=\"mid-top\"\n        focusable=\"false\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        width=\"454\"\n        height=\"548\"\n        viewBox=\"0 0 454 548\"\n      >\n        <defs>\n          <linearGradient\n            id=\"mid-top-a\"\n            x1=\"79.518%\"\n            x2=\"26%\"\n            y1=\"89.438%\"\n            y2=\"36.887%\"\n          >\n            <stop offset=\"0%\" stop-color=\"#FFF\" stop-opacity=\".15\" />\n            <stop offset=\"100%\" stop-opacity=\".15\" />\n          </linearGradient>\n        </defs>\n        <path\n          fill=\"url(#mid-top-a)\"\n          d=\"M738.715387,10.7776312 L767.347677,9.62546415 C875.848361,5.25938239 967.344954,89.6771573 971.711035,198.177842 C971.926588,203.53449 971.922967,208.897714 971.700183,214.254067 L966.117864,348.468423 C961.780097,452.760314 878.15034,536.277233 773.852688,540.474184 L745.220398,541.626351 C636.719713,545.992433 545.223121,461.574658 540.85704,353.073973 C540.641487,347.717325 540.645108,342.354101 540.867892,336.997749 L546.450211,202.783392 C550.787978,98.4915008 634.417734,14.9745825 738.715387,10.7776312 Z\"\n          transform=\"translate(-527.654 -3)\"\n          style=\"mix-blend-mode:color\"\n        />\n      </svg>\n    "])));
      return {
        right: rightBlob,
        left: leftBlob,
        midTop: midTopBlob,
        midBottom: midBottomBlob
      };
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject59 || (_templateObject59 = _taggedTemplateLiteral(["\n      <link\n        rel=\"stylesheet\"\n        href=\"", "fwc-assets/styles/typography.css\"\n      />\n      <section>\n        <div class=\"blobs\">\n          ", " ", "\n          ", " ", "\n        </div>\n        <div class=", ">\n          ", "\n          <slot></slot>\n        </div>\n      </section>\n    "])), this.config.assetsPath, this._blobs().right, this._blobs().midBottom, this._blobs().midTop, this._blobs().left, this.title ? 'shadowed' : 'slotted', this.title ? html(_templateObject60 || (_templateObject60 = _taggedTemplateLiteral(["<h1>", "</h1>"])), this.title) : html(_templateObject61 || (_templateObject61 = _taggedTemplateLiteral([""]))));
    }
  }], [{
    key: "styles",
    get: /* For slotted content, use ./fwc-assets/styles/components/fwc-header-page.css */
    function get() {
      return [sharedStyles$1, css$1(_templateObject62 || (_templateObject62 = _taggedTemplateLiteral(["\n        @keyframes rotation {\n          0% {\n            transform: rotate(0deg) scale(1);\n          }\n          50% {\n            transform: scale(2);\n          }\n          100% {\n            transform: rotate(359deg) scale(1);\n          }\n        }\n        :host {\n          position: relative;\n        }\n        section {\n          background-color: var(--color-primary);\n          padding: calc(6 * var(--fwcu)) 0;\n        }\n        .blobs {\n          overflow: hidden;\n          position: absolute;\n          inset: 0;\n          z-index: 0;\n          pointer-events: none;\n        }\n        div.shadowed:not(.slotted) {\n          display: flex;\n          max-width: calc(144 * var(--fwcu));\n          margin: 0 auto;\n          align-items: flex-start;\n          justify-content: flex-start;\n          flex-wrap: nowrap;\n        }\n        .shadowed h1,\n        .slotted h1 {\n          margin: 0;\n        }\n        svg {\n          position: absolute;\n          opacity: 0.2;\n          animation-name: rotation;\n          animation-fill-mode: none;\n          animation-duration: 20s;\n          animation-iteration-count: infinite;\n          transform-origin: center;\n          animation-timing-function: cubic-bezier(0.785, 0.135, 0.15, 0.86);\n        }\n        svg.left {\n          left: -115px;\n          top: -70px;\n          transform: rotate(293deg);\n        }\n        svg.mid-top {\n          left: 37%;\n          top: -375px;\n          transform: rotate(-50deg);\n        }\n        svg.mid-bottom {\n          left: 47%;\n          transform: rotate(302deg);\n          top: 36%;\n        }\n        svg.right {\n          right: -348px;\n          transform: rotateX(180deg);\n        }\n        h1 {\n          color: white;\n          padding: 0 calc(1.5 * var(--fwcu));\n          margin: calc(4 * var(--fwcu)) 0;\n        }\n        @media screen and (max-width: 600px) {\n          div.shadowed:not(.slotted) {\n            /* Match fwc-row */\n            width: calc(100% - (5 * var(--fwcu)));\n          }\n          section {\n            padding: calc(2 * var(--fwcu)) 0;\n          }\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        config: {
          type: Object
        },
        title: {
          type: String
        }
      };
    }
  }]);
  return FwcHeaderPageComponent;
}(LitElement);
var FwcHeaderPage = /*#__PURE__*/function (_FwcBase11) {
  _inherits$1(FwcHeaderPage, _FwcBase11);
  var _super24 = _createSuper$8(FwcHeaderPage);
  function FwcHeaderPage() {
    _classCallCheck$1(this, FwcHeaderPage);
    return _super24.call(this, 'fwc-header-page', FwcHeaderPageComponent);
  }
  return _createClass$1(FwcHeaderPage);
}(FwcBase$1);
var MobileViewComponent = /*#__PURE__*/function (_LitElement14) {
  _inherits$1(MobileViewComponent, _LitElement14);
  var _super25 = _createSuper$8(MobileViewComponent);
  function MobileViewComponent() {
    var _this32;
    _classCallCheck$1(this, MobileViewComponent);
    _this32 = _super25.call(this);
    _this32.config = null; // Must pass config in parent component.
    _this32.hideFooter = false;
    _this32.mobileHeaderText = '';
    _this32.open = false;
    _this32.decreaseIndexZ = false;
    var header = new FwcHeaderPage();
    header.build();
    return _this32;
  }
  _createClass$1(MobileViewComponent, [{
    key: "render",
    value: function render() {
      return html(_templateObject63 || (_templateObject63 = _taggedTemplateLiteral(["\n      <div\n        class=\"mobile-view-wrapper ", " ", "\"\n      >\n        <fwc-header-page\n          title=", "\n          config=", "\n          class=\"mobile-view-header \"\n        ></fwc-header-page>\n\n        <div class=\"mobile-view-body ", "\">\n          <slot name=\"body\"></slot>\n        </div>\n\n        <div class=\"mobile-view-footer ", "\">\n          <slot name=\"mobile-actions\"></slot>\n        </div>\n      </div>\n    "])), this.open ? 'open' : '', this.decreaseIndexZ ? 'decrease-index-z' : '', this.mobileHeaderText, JSON.stringify(this.config), this.hideFooter ? 'full' : '', this.hideFooter ? 'hide' : '');
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject64 || (_templateObject64 = _taggedTemplateLiteral(["\n        .mobile-view-header,\n        .mobile-view-footer {\n          display: none;\n        }\n\n        @media screen and (max-width: 600px) {\n          .mobile-view-wrapper.open {\n            position: fixed;\n            display: flex;\n            flex-direction: column;\n            width: 100%;\n            top: 0;\n            left: 0;\n            background: var(--color-white);\n            height: 100%;\n            z-index: 3;\n          }\n          .open .mobile-view-header {\n            display: block;\n            width: 100%;\n          }\n          .open .mobile-view-body {\n            flex-grow: 1;\n            flex-shrink: 1;\n            flex-basis: auto;\n            overflow: auto;\n            position: relative;\n            margin-bottom: calc(9.75 * var(--fwcu));\n            z-index: 3;\n          }\n          .open .mobile-view-body.full {\n            margin-bottom: 0;\n          }\n\n          .open .mobile-view-footer {\n            position: fixed;\n            bottom: 0;\n            left: 0;\n            width: 100%;\n            height: calc(9.75 * var(--fwcu));\n            display: block;\n            padding: calc(2.5 * var(--fwcu));\n            background: var(--color-white);\n            box-shadow: 0px -4px 3px 0 rgba(50, 50, 50, 0.1);\n            z-index: 3;\n          }\n          .mobile-view-footer.hide {\n            display: none;\n          }\n          .mobile-view-wrapper.decrease-index-z .mobile-view-header,\n          .mobile-view-wrapper.decrease-index-z .mobile-view-footer {\n            z-index: 2;\n          }\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        config: {
          type: Object
        },
        hideFooter: {
          attribute: 'hide-footer',
          type: Boolean
        },
        mobileHeaderText: {
          attribute: 'mobile-header-text',
          type: String
        },
        open: {
          type: Boolean
        },
        decreaseIndexZ: {
          attribute: 'decrease-index-z',
          type: Boolean
        }
      };
    }
  }]);
  return MobileViewComponent;
}(LitElement);
var MobileView = /*#__PURE__*/function (_FwcBase12) {
  _inherits$1(MobileView, _FwcBase12);
  var _super26 = _createSuper$8(MobileView);
  function MobileView() {
    _classCallCheck$1(this, MobileView);
    return _super26.call(this, 'mobile-view', MobileViewComponent);
  }
  return _createClass$1(MobileView);
}(FwcBase$1);
var sharedMobileViewStyles = css$1(_templateObject65 || (_templateObject65 = _taggedTemplateLiteral(["\n  .mobile-view-footer-slot {\n    display: none;\n  }\n\n  @media screen and (max-width: 600px) {\n    .mobile-view-footer-slot {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 0 4rem;\n    }\n    .mobile-view-footer-slot button {\n      flex-basis: 50%;\n    }\n    .mobile-view-footer-slot button.fwc-link {\n      text-align: center;\n      font-size: calc(2 * var(--fwcu));\n    }\n  }\n"])));
var FwcDatePickerComponent = /*#__PURE__*/function (_LitElement15) {
  _inherits$1(FwcDatePickerComponent, _LitElement15);
  var _super27 = _createSuper$8(FwcDatePickerComponent);
  function FwcDatePickerComponent() {
    var _this33;
    _classCallCheck$1(this, FwcDatePickerComponent);
    _this33 = _super27.call(this);
    _this33.mobileView = new MobileView();
    _this33.mobileView.build();
    _this33.startDate = new Date();
    _this33._startDate = new Date();
    _this33.monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    _this33.dayNames = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
    _this33.dateRange = [null, null];
    _this33.disabledDates = [];
    _this33.inputLabel = 'Select a Date';
    _this33.labelAriaClose = 'Cancel';
    _this33.invalid = false;
    _this33.btnApply = 'Apply';
    _this33.btnCancel = 'Cancel';
    _this33.labelAriaNext = 'Next Month';
    _this33.labelAriaCancel = 'Cancel';
    _this33.labelAriaApply = 'Apply';
    _this33.labelAriaPrevious = 'Previous Month';
    _this33.labelAriaCalendarIcon = 'Toggle Calendar';
    _this33.errorDisabledLabel = 'Disabled Date';
    _this33.errorInvalidLabel = 'Invalid Date';
    _this33.labelAriaDayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    _this33._calendarMonths = [];
    _this33._calendarTableRows = [];
    _this33.selectedDate = '';
    _this33._isCalendarOpen = false;
    _this33._rangeEnd = false;
    _this33._rangeStart = false;
    _this33._calendarMaxDate = new Date();
    _this33._calendarMinDate = new Date('01/01/1900');
    _this33._numMonthsToDisplay = 2;
    _this33._maxFutureYears = 20;
    _this33._tempDateStorage = null;
    _this33.config = fwcConfig$1;
    _this33._calendarMaxDate.setFullYear(_this33._calendarMaxDate.getFullYear() + _this33._maxFutureYears);
    _this33.focusTrapDesk = ['button.fwc-hide', '.fwc-btn-primary', '.fwc-btn-secondary', '.fwc-calendar-mobile-nav .fwc-btn-prev', '.fwc-calendar-mobile-nav .fwc-btn-next', '.fwc-selected-date', '.fwc-icon-calendar'];
    _this33.focusTrapMobile = ['button.fwc-hide', '.fwc-calendar-header button', '.fwc-selected-date', '.fwc-icon-calendar'];
    _this33.disabled = false;
    _this33._handleCalendarClickOut = _this33._handleCalendarClickOut.bind(_assertThisInitialized(_this33));
    return _this33;
  }
  _createClass$1(FwcDatePickerComponent, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(FwcDatePickerComponent.prototype), "connectedCallback", this).call(this);
      document.addEventListener('click', this._handleCalendarClickOut);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      document.removeEventListener('click', this._handleCalendarClickOut);
      _get(_getPrototypeOf(FwcDatePickerComponent.prototype), "disconnectedCallback", this).call(this);
    }
  }, {
    key: "firstUpdated",
    value: function firstUpdated() {
      var _this34 = this;
      var calendar = this.shadowRoot.querySelector('.fwc-calendar');
      calendar.addEventListener('transitionend', function (e) {
        // set the focus trap inside the calendar after open
        if (_this34._isCalendarOpen && e.propertyName === 'opacity') {
          var ignoredFocusTrapSelectors = window.innerWidth > breakpoints$1.sm ? _this34.focusTrapDesk : _this34.focusTrapMobile;
          focusTrapCustomTabs(_this34, ignoredFocusTrapSelectors);
        }
        // set the focus back to the open button on calendar close
        if (!_this34._isCalendarOpen && e.propertyName === 'opacity') {
          var iconBtn = _this34.shadowRoot.querySelector('.fwc-icon-calendar');
          iconBtn.focus();
          removeFocusTrapListener(_this34);
        }
      });

      // allow esc to close the calendar
      this.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          _this34.toggleCalendarOpen();
        }
      });
      this._setMinMaxDates();
    }
  }, {
    key: "updated",
    value: function updated(changedProperties) {
      var _this35 = this;
      changedProperties.forEach(function (oldValue, propName) {
        if (propName === 'startDate') {
          var newStartDate = _this35.startDate || new Date();
          var parsedDate = new Date(newStartDate);
          // check if a valid date string was passed as an attribute
          if (parsedDate instanceof Date && !isNaN(parsedDate)) {
            _this35._startDate = new Date(newStartDate);
            _this35._setInputDate();
            _this35._buildCalendar();
          } else {
            try {
              throw new Error('Invalid date string passed to "start-date" attribute');
            } catch (e) {
              /* eslint-disable no-console */
              console.error(e);
              /* eslint-enable no-console */
            }
          }
        }

        // when the calendar view changes
        // check and set the selectedDate corresponding button to active
        if (propName === '_calendarTableRows') {
          _this35._setActiveBtnState(_this35.selectedDate);
        }
      });
    }
  }, {
    key: "_setInputDate",
    value: function _setInputDate() {
      // Set date on init with show-date attribute
      if (!this.showDate) return;
      this._changeSelectedDate(this._startDate, true);
    }
  }, {
    key: "_handleCalendarClickOut",
    value: function _handleCalendarClickOut(e) {
      if (!this.contains(e.target) && this._isCalendarOpen) {
        this.toggleCalendarOpen();
      }
    }
  }, {
    key: "_buildCalendar",
    value: function _buildCalendar() {
      var _this36 = this;
      // show one month in the calendar view between 600 and 900 viewport
      if (window.innerWidth > breakpoints$1.sm && window.innerWidth <= breakpoints$1.md) {
        this._numMonthsToDisplay = 1;
      } else {
        this._numMonthsToDisplay = 2;
      }
      this._calendarMonths = this._getDaysInMonths(this._startDate, this._numMonthsToDisplay);
      this._calendarTableRows = this._calendarMonths.map(function (month) {
        return _this36._breakDaysIntoTableRows(month);
      });

      //disable all date outside of dateRange and individual dates passed
      this._rangeEnd = this._isEndOfRange();
      this._rangeStart = this._isStartOfRange();
      this._disableDates();
    }
  }, {
    key: "_getDaysInMonths",
    value: function _getDaysInMonths(date, numMonths) {
      var months = [];
      var dt = new Date(date);
      for (var i = 0; i < numMonths; i++) {
        var month = dt.getMonth();
        var days = [];
        dt.setDate(1);
        while (dt.getMonth() === month) {
          days.push(new Date(dt));
          dt.setDate(dt.getDate() + 1);
        }
        months.push(days);

        // set date to 1st day of next month
        dt.setDate(dt.getMonth() + 1);
        dt.setDate(1);
      }
      return months;
    }
  }, {
    key: "_isEndOfRange",
    value: function _isEndOfRange() {
      // check if we can move to a calendar in the future
      if (this._calendarMonths.length) {
        var i = this._calendarMonths.length - 1;
        var lastDayInCalendarView = this._calendarMonths[i][this._calendarMonths[i].length - 1];
        return lastDayInCalendarView.getFullYear() === this._calendarMaxDate.getFullYear() && lastDayInCalendarView.getMonth() >= this._calendarMaxDate.getMonth();
      }
      return false;
    }
  }, {
    key: "_isStartOfRange",
    value: function _isStartOfRange() {
      // check if we can move to a calendar in the past
      if (this._calendarMonths.length) {
        var firstDayInCalendarView = this._calendarMonths[0][0];
        return firstDayInCalendarView.getFullYear() === this._calendarMinDate.getFullYear() && firstDayInCalendarView.getMonth() <= this._calendarMinDate.getMonth();
      }
      return false;
    }
  }, {
    key: "_disableDates",
    value: function _disableDates() {
      var _this37 = this;
      setTimeout(function () {
        var dateButtons = _this37.shadowRoot.querySelectorAll('[data-date]');
        dateButtons.forEach(function (btn) {
          var btnDate = new Date(btn.getAttribute('data-date'));
          btnDate.setHours(0, 0, 0, 0);

          // remove disabled for all active buttons, ignore empty placeholders
          // all active date buttons need a tabindex of 4 by default
          if (btn.getAttribute('data-date')) {
            btn.removeAttribute('disabled');
            btn.setAttribute('tabindex', 4);
          }

          // check list from attribute disabled-dates
          _this37.disabledDates.forEach(function (disabledDate) {
            disabledDate = new Date(disabledDate);
            if (btnDate.getFullYear() === disabledDate.getFullYear() && btnDate.getMonth() === disabledDate.getMonth() && btnDate.getDate() === disabledDate.getDate()) {
              btn.setAttribute('disabled', '');
              btn.setAttribute('tabindex', -1);
            }
          });

          // check against date range
          // move time to seconds vs milliseconds
          if (Math.floor(_this37._calendarMinDate.getTime() / 1000) > Math.floor(btnDate.getTime() / 1000) || Math.floor(_this37._calendarMaxDate.getTime() / 1000) < Math.floor(btnDate.getTime() / 1000)) {
            btn.setAttribute('disabled', '');
            btn.setAttribute('tabindex', -1);
          }
        });
      }, 0);
    }
  }, {
    key: "_setMinMaxDates",
    value: function _setMinMaxDates() {
      // if null is passed for start date set it to year 1900
      this._calendarMinDate = !this.dateRange[0] ? new Date('01/01/1900') : new Date(this.dateRange[0]);
      // if null is passed for end date set it to 20 years from now
      if (!this.dateRange[1]) {
        this._calendarMaxDate = new Date();
        this._calendarMaxDate.setFullYear(this._calendarMaxDate.getFullYear() + this._maxFutureYears);
      } else {
        this._calendarMaxDate = new Date(this.dateRange[1]);
      }
      this._calendarMinDate.setHours(0, 0, 0, 0);
      this._calendarMaxDate.setHours(0, 0, 0, 0);
    }
  }, {
    key: "_buildTableHeaders",
    value: function _buildTableHeaders() {
      return html(_templateObject66 || (_templateObject66 = _taggedTemplateLiteral(["\n      <tr>\n        <th aria-label=\"", "\">", "</th>\n        <th aria-label=\"", "\">", "</th>\n        <th aria-label=\"", "\">", "</th>\n        <th aria-label=\"", "\">", "</th>\n        <th aria-label=\"", "\">", "</th>\n        <th aria-label=\"", "\">", "</th>\n        <th aria-label=\"", "\">", "</th>\n      </tr>\n    "])), this.labelAriaDayNames[0], this.dayNames[0], this.labelAriaDayNames[1], this.dayNames[1], this.labelAriaDayNames[2], this.dayNames[2], this.labelAriaDayNames[3], this.dayNames[3], this.labelAriaDayNames[4], this.dayNames[4], this.labelAriaDayNames[5], this.dayNames[5], this.labelAriaDayNames[6], this.dayNames[6]);
    }
  }, {
    key: "_breakDaysIntoTableRows",
    value: function _breakDaysIntoTableRows(days) {
      var daysArr = _toConsumableArray(days);
      var rows = [];
      var week = [];
      var startDay = days[0].getDay();
      var lastDay = days[days.length - 1].getDay();

      // we need to add empty slots to the beginning and end of each month to fill out the table rows
      // add empty values to beginning
      for (var i = 0; i < startDay; i++) {
        daysArr.unshift(null);
      }

      // add empty values to the end
      for (var _i2 = 0; _i2 < 6 - lastDay; _i2++) {
        daysArr.push(null);
      }

      // break daysArr into rows by week, sunday to saturday
      for (var _i3 = 1; _i3 <= daysArr.length; _i3++) {
        week.push(daysArr[_i3 - 1]);
        if (_i3 % 7 === 0) {
          rows.push(week);
          week = [];
        }
      }
      return rows;
    }
  }, {
    key: "_getMonthAndYear",
    value: function _getMonthAndYear(date) {
      if (window.innerWidth > breakpoints$1.sm) {
        return "".concat(this.monthNames[date.getMonth()], " ").concat(date.getFullYear());
      } else {
        return "".concat(this.monthNames[date.getMonth()]);
      }
    }
  }, {
    key: "_formatDate",
    value: function _formatDate(date) {
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var year = date.getFullYear();
      return month + '/' + day + '/' + year;
    }
  }, {
    key: "_changeCalendarMonths",
    value: function _changeCalendarMonths(dir) {
      var num = dir === 'next' ? this._numMonthsToDisplay : -this._numMonthsToDisplay;
      this._startDate = new Date(this._calendarMonths[0][0].getFullYear(), this._calendarMonths[0][0].getMonth() + num, 1);
      this._buildCalendar();
      resetFocusTrap();
    }
  }, {
    key: "_updateSelectDateInput",
    value: function _updateSelectDateInput(date) {
      var input = this.shadowRoot.querySelector('#SelectedDateInput');
      input.value = date ? this._formatDate(date) : '';
    }
  }, {
    key: "_changeSelectedDate",
    value: function _changeSelectedDate(date, set) {
      this._updateSelectDateInput(date);
      this.selectedDate = date;
      this._emitSelectedEvent(date);
      if (set) this._setActiveBtnState(date);
    }
  }, {
    key: "_handleSelectedDate",
    value: function _handleSelectedDate(date, e) {
      // Store date and let _handleApply set date
      if (e.code === 'Enter' || e.code === 'Space') {
        this._tempDateStorage = date;
        this._changeSelectedDate(this._tempDateStorage, true);
      } else if (e.type === 'click') {
        this._tempDateStorage = date;
        this._setActiveBtnState(date);
      }
    }
  }, {
    key: "_handleApply",
    value: function _handleApply() {
      if (this._tempDateStorage) this._changeSelectedDate(this._tempDateStorage, false);
      this.toggleCalendarOpen();
    }

    //public method to reset calendar and input
  }, {
    key: "resetDate",
    value: function resetDate(emit) {
      this._updateSelectDateInput('');
      this._resetDate(emit);
    }
  }, {
    key: "_resetDate",
    value: function _resetDate(emit) {
      this.selectedDate = '';
      this._setActiveBtnState('');
      if (emit) this._emitSelectedEvent('');
    }
  }, {
    key: "_parseDate",
    value: function _parseDate(e) {
      if (!e.target.value) {
        this._resetDate();
        this._emitBlurEvent();
        return;
      }
      // some browsers do not like to parse dates as 01-01-2020
      // so we replace all the dashes with slashes, if a user typed in that format
      var parsedDate = new Date(e.target.value.replace(/-/g, '/'));

      // check manual entered date against disabled dates & min/max range
      if (this._checkDisabledDate(parsedDate)) {
        this._emitErrorEvent(this.errorDisabledLabel);
        return false;
      }
      this._emitBlurEvent();
      if (parsedDate instanceof Date && !isNaN(parsedDate)) {
        this._startDate = parsedDate;
        // build the calendar view to reflect the new typed starting date
        this._buildCalendar();
        // highlight the date
        this._changeSelectedDate(parsedDate, true);
      } else {
        this._emitErrorEvent(this.errorInvalidLabel);
      }
    }

    //returns true if date is disabled or out of min/max range
  }, {
    key: "_checkDisabledDate",
    value: function _checkDisabledDate(date) {
      var _this38 = this;
      return this.disabledDates.some(function (disabledDate) {
        disabledDate = new Date(disabledDate);
        return date.getFullYear() === disabledDate.getFullYear() && date.getMonth() === disabledDate.getMonth() && date.getDate() === disabledDate.getDate() || Math.floor(_this38._calendarMinDate.getTime() / 1000) > Math.floor(date.getTime() / 1000) || Math.floor(_this38._calendarMaxDate.getTime() / 1000) < Math.floor(date.getTime() / 1000);
      });
    }
  }, {
    key: "_emitErrorEvent",
    value: function _emitErrorEvent(error) {
      // emit date parse error, date entered into input field was not valid
      var event = new CustomEvent('fwc-date-picker-error', {
        detail: error,
        bubbles: true
      });
      this.dispatchEvent(event);
      this._resetDate();
    }
  }, {
    key: "_emitFocusEvent",
    value: function _emitFocusEvent() {
      var event = new CustomEvent('fwc-date-picker-focus', {
        detail: this,
        bubbles: true
      });
      this.dispatchEvent(event);
    }
  }, {
    key: "_emitBlurEvent",
    value: function _emitBlurEvent() {
      var event = new CustomEvent('fwc-date-picker-blur', {
        detail: this,
        bubbles: true
      });
      this.dispatchEvent(event);
    }
  }, {
    key: "_emitSelectedEvent",
    value: function _emitSelectedEvent(data) {
      var event = new CustomEvent('fwc-date-picker-selected', {
        detail: data,
        bubbles: true
      });
      this.dispatchEvent(event);
    }
  }, {
    key: "_setActiveBtnState",
    value: function _setActiveBtnState(curDate) {
      // loop all the buttons and match their data-date attr to the selectedDate to add an active state
      // this happens because we need to check/set the active date when switching calendar months, typing in a date, and clicking one
      var btns = this.shadowRoot.querySelectorAll('.fwc-calendar-body button');
      var lastActiveBtn = this.shadowRoot.querySelector('button.active');
      if (lastActiveBtn) {
        lastActiveBtn.classList.remove('active');
      }
      if (btns && curDate) {
        var curDateFormatted = this._formatDate(curDate);
        btns.forEach(function (btn) {
          var dt = btn.getAttribute('data-date');
          if (dt === curDateFormatted) {
            btn.classList.add('active');
          }
        });
      }
    }
  }, {
    key: "toggleCalendarOpen",
    value: function toggleCalendarOpen() {
      var _this39 = this;
      this._buildCalendar();
      // check the calendar before it opens and set its position
      if (!this._isCalendarOpen && window.innerWidth > breakpoints$1.sm) {
        setTimeout(function () {
          _this39._setCalendarPosition();
        }, 0);
      } else {
        // remove transform positioning from calendar on close
        // because the getBoundingClientRect will now be changed with the new transform styling
        this._removeCalendarPositioning();
      }
      this._isCalendarOpen = !this._isCalendarOpen;
      if (this._isCalendarOpen && this.selectedDate) {
        this._setActiveBtnState(this.selectedDate);
      } else {
        this._tempDateStorage = null;
      }
      this._toggleBodyScrollClass(this._isCalendarOpen);
    }
  }, {
    key: "_toggleBodyScrollClass",
    value: function _toggleBodyScrollClass(isOpen) {
      if (isOpen && window.innerWidth <= breakpoints$1.sm) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    }
  }, {
    key: "_setCalendarPosition",
    value: function _setCalendarPosition() {
      var calendar = this.shadowRoot.querySelector('.fwc-calendar');
      var input = this.shadowRoot.querySelector('.fwc-date-picker-input');
      var viewportWidth = document.documentElement.clientWidth;
      var viewportHeight = document.documentElement.clientHeight;
      var CALENDAR_VERTICAL_MARGIN = baseUnit$1 * 2;
      var inputRect = null;
      var calendarRect = null;
      // this sets the calendar width and height to auto so we can get its dimensions
      calendar.classList.add('pre-open');
      inputRect = input.getBoundingClientRect();
      calendarRect = calendar.getBoundingClientRect();

      // check and set left and right positioning
      if (viewportWidth - inputRect.left > calendarRect.width) {
        // set left positioned
        // check first if there is space right as initial option
        calendar.style.left = '0px';
      } else if (inputRect.right > calendarRect.width) {
        // set right positioned
        calendar.style.right = '0px';
      } else {
        // fallback left positioned
        calendar.style.left = '0px';
      }
      if (viewportHeight - inputRect.bottom > calendarRect.height) {
        // set bottom positioned
        // check first if there is space below as initial option
        calendar.style.top = "calc(100% + ".concat(CALENDAR_VERTICAL_MARGIN, "px");
      } else if (inputRect.top > calendarRect.height) {
        // set top positioned
        calendar.style.bottom = "calc(100% - ".concat(CALENDAR_VERTICAL_MARGIN, "px)");
      } else {
        // fallback bottom positioned
        calendar.style.top = "calc(100% + ".concat(CALENDAR_VERTICAL_MARGIN, "px");
      }
      calendar.classList.remove('pre-open');
    }
  }, {
    key: "_removeCalendarPositioning",
    value: function _removeCalendarPositioning() {
      var calendar = this.shadowRoot.querySelector('.fwc-calendar');
      calendar.style.removeProperty('left');
      calendar.style.removeProperty('right');
      calendar.style.removeProperty('bottom');
      calendar.style.removeProperty('top');
    }
  }, {
    key: "_buildApplyButton",
    value: function _buildApplyButton() {
      return html(_templateObject67 || (_templateObject67 = _taggedTemplateLiteral(["\n      <button\n        class=\"fwc-btn fwc-btn-primary\"\n        aria-label=\"", "\"\n        @click=\"", "\"\n        tabindex=\"6\"\n      >\n        ", "\n      </button>\n    "])), this.labelAriaApply, this._handleApply, this.btnApply);
    }
  }, {
    key: "_buildCancelButton",
    value: function _buildCancelButton() {
      return html(_templateObject68 || (_templateObject68 = _taggedTemplateLiteral(["\n      <button\n        class=\"fwc-btn fwc-btn-secondary\"\n        aria-label=\"", "\"\n        @click=\"", "\"\n        tabindex=\"5\"\n      >\n        ", "\n      </button>\n    "])), this.labelAriaCancel, this.toggleCalendarOpen, this.btnCancel);
    }
  }, {
    key: "_arrowSvg",
    value: function _arrowSvg() {
      return html(_templateObject69 || (_templateObject69 = _taggedTemplateLiteral(["\n      <svg\n        xmlns=\"http://www.w3.org/2000/svg\"\n        width=\"50\"\n        height=\"50\"\n        viewBox=\"0 0 50 50\"\n        focusable=\"false\"\n      >\n        <polygon\n          points=\"14.067 50 11 46.933 32.933 25 11 3.067 14.067 0 37.533 23.467 39 25 37.533 26.533\"\n        />\n      </svg>\n    "])));
    }
  }, {
    key: "_buttonPrev",
    value: function _buttonPrev() {
      var _this40 = this;
      return html(_templateObject70 || (_templateObject70 = _taggedTemplateLiteral(["\n      <button\n        class=\"fwc-btn-prev ", "\"\n        @click=\"", "\"\n        aria-label=\"", "\"\n        tabindex=\"1\"\n      >\n        ", "\n      </button>\n    "])), this._rangeStart ? 'fwc-hide' : '', function () {
        return _this40._changeCalendarMonths('prev');
      }, this.labelAriaPrevious, this._arrowSvg());
    }
  }, {
    key: "_buttonNext",
    value: function _buttonNext() {
      var _this41 = this;
      return html(_templateObject71 || (_templateObject71 = _taggedTemplateLiteral(["\n      <button\n        class=\"fwc-btn-next ", "\"\n        aria-label=\"", "\"\n        @click=\"", "\"\n        tabindex=\"2\"\n      >\n        ", "\n      </button>\n    "])), this._rangeEnd ? 'fwc-hide' : '', this.labelAriaNext, function () {
        return _this41._changeCalendarMonths('next');
      }, this._arrowSvg());
    }
  }, {
    key: "_calendarIcon",
    value: function _calendarIcon() {
      return html(_templateObject72 || (_templateObject72 = _taggedTemplateLiteral(["\n      <svg\n        version=\"1.1\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n        focusable=\"false\"\n        width=\"20px\"\n        height=\"20px\"\n        viewBox=\"0 0 36.449 36.448\"\n        xml:space=\"preserve\"\n      >\n        <g>\n          <g>\n            <rect x=\"12.858\" y=\"14.626\" width=\"4.596\" height=\"4.089\" />\n            <rect x=\"18.996\" y=\"14.626\" width=\"4.595\" height=\"4.089\" />\n            <rect x=\"25.128\" y=\"14.626\" width=\"4.596\" height=\"4.089\" />\n            <rect x=\"6.724\" y=\"20.084\" width=\"4.595\" height=\"4.086\" />\n            <rect x=\"12.858\" y=\"20.084\" width=\"4.596\" height=\"4.086\" />\n            <rect x=\"18.996\" y=\"20.084\" width=\"4.595\" height=\"4.086\" />\n            <rect x=\"25.128\" y=\"20.084\" width=\"4.596\" height=\"4.086\" />\n            <rect x=\"6.724\" y=\"25.54\" width=\"4.595\" height=\"4.086\" />\n            <rect x=\"12.858\" y=\"25.54\" width=\"4.596\" height=\"4.086\" />\n            <rect x=\"18.996\" y=\"25.54\" width=\"4.595\" height=\"4.086\" />\n            <rect x=\"25.128\" y=\"25.54\" width=\"4.596\" height=\"4.086\" />\n            <path\n              d=\"M31.974,32.198c0,0.965-0.785,1.75-1.75,1.75h-24c-0.965,0-1.75-0.785-1.75-1.75V12.099h-2.5v20.099\n            c0,2.343,1.907,4.25,4.25,4.25h24c2.344,0,4.25-1.907,4.25-4.25V12.099h-2.5V32.198z\"\n            />\n            <path\n              d=\"M30.224,3.948h-1.098V2.75c0-1.517-1.197-2.75-2.67-2.75c-1.474,0-2.67,1.233-2.67,2.75v1.197h-2.74V2.75\n            c0-1.517-1.197-2.75-2.67-2.75c-1.473,0-2.67,1.233-2.67,2.75v1.197h-2.74V2.75c0-1.517-1.197-2.75-2.67-2.75\n            c-1.473,0-2.67,1.233-2.67,2.75v1.197H6.224c-2.343,0-4.25,1.907-4.25,4.25v2h2.5h27.5h2.5v-2\n            C34.474,5.855,32.568,3.948,30.224,3.948z M11.466,7.646c0,0.689-0.525,1.25-1.17,1.25s-1.17-0.561-1.17-1.25V2.75\n            c0-0.689,0.525-1.25,1.17-1.25s1.17,0.561,1.17,1.25V7.646z M19.546,7.646c0,0.689-0.525,1.25-1.17,1.25s-1.17-0.561-1.17-1.25\n            V2.75c0-0.689,0.525-1.25,1.17-1.25s1.17,0.561,1.17,1.25V7.646z M27.626,7.646c0,0.689-0.525,1.25-1.17,1.25\n            c-0.646,0-1.17-0.561-1.17-1.25V2.75c0-0.689,0.524-1.25,1.17-1.25c0.645,0,1.17,0.561,1.17,1.25V7.646z\"\n            />\n          </g>\n        </g>\n      </svg>\n    "])));
    }
  }, {
    key: "_desktopFooterNav",
    value: function _desktopFooterNav(isLastCalender) {
      if (isLastCalender) {
        return html(_templateObject73 || (_templateObject73 = _taggedTemplateLiteral(["<div class=\"fwc-calender-desktop-footer\">\n        <div>", "</div>\n        <div>", "</div>\n      </div>"])), this._buildCancelButton(), this._buildApplyButton());
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this42 = this;
      return html(_templateObject74 || (_templateObject74 = _taggedTemplateLiteral(["\n      <link\n        rel=\"stylesheet\"\n        href=\"", "fwc-assets/styles/buttons-links.css\"\n      />\n      <link\n        rel=\"stylesheet\"\n        href=\"", "fwc-assets/styles/components/fwc-input.css\"\n      />\n      <mobile-view\n        mobile-header-text=\"", "\"\n        ?open=", "\n        config=", "\n      >\n        <!-- mobile-view is a shared 'modal' overlay. Body slot is for both desktop and mobile. -->\n        <div slot=\"body\">\n          <div class=\"fwc-date-picker-wrapper\">\n            <div class=\"fwc-input ", "\">\n              <label class=\"fwc-label\" for=\"SelectedDateInput\"\n                >", "</label\n              >\n              <div class=\"fwc-date-picker-input\">\n                <input\n                  type=\"text\"\n                  id=\"SelectedDateInput\"\n                  class=\"fwc-selected-date\"\n                  aria-haspopup=\"dialog\"\n                  aria-describedby=\"date_error\"\n                  @blur=\"", "\"\n                  @focus=\"", "\"\n                  aria-invalid=", "\n                  ?disabled=", "\n                />\n                <button\n                  class=\"fwc-icon-calendar ", "\"\n                  @click=\"", "\"\n                  aria-label=\"", "\"\n                  ?disabled=", "\n                >\n                  ", "\n                </button>\n              </div>\n            </div>\n            <div class=\"fwc-calendar ", "\">\n              ", "\n            </div>\n          </div>\n        </div>\n\n        <!-- Mobile specific footer to allow for fixed design/position in mobile-view -->\n        <div class=\"mobile-view-footer-slot\" slot=\"mobile-actions\">\n          ", " ", "\n        </div>\n      </mobile-view>\n    "])), this.config.assetsPath, this.config.assetsPath, this.inputLabel, this._isCalendarOpen, JSON.stringify(this.config), this._isCalendarOpen ? 'open' : '', this.inputLabel, function (e) {
        return _this42._parseDate(e);
      }, function (e) {
        return _this42._emitFocusEvent(e);
      }, this.invalid, this.disabled, this.invalid ? 'invalid' : '', this.toggleCalendarOpen, this.labelAriaCalendarIcon, this.disabled, this._calendarIcon(), this._isCalendarOpen ? 'open' : '', this._calendarTableRows.map(function (month, i, arr) {
        return html(_templateObject75 || (_templateObject75 = _taggedTemplateLiteral(["\n                  ", "\n                  <div class=\"fwc-calendar-month\">\n                    <div class=\"fwc-calendar-header\">\n                      ", "\n                      <span\n                        class=\"fwc-month-year\"\n                        id=\"", "", "\"\n                      >\n                        ", "\n                      </span>\n                      ", "\n                    </div>\n                    <div class=\"fwc-calendar-body\">\n                      <table\n                        role=\"table\"\n                        width=\"100%\"\n                        aria-labelledby=\"", "", "\"\n                      >\n                        ", "\n                        ", "\n                      </table>\n                    </div>\n                    ", "\n                  </div>\n                "])), i === 0 ? html(_templateObject76 || (_templateObject76 = _taggedTemplateLiteral(["\n                        <div class=\"fwc-calendar-mobile-nav\">\n                          <span>", "</span>\n                          <span\n                            >", "</span\n                          >\n                          <span>", "</span>\n                        </div>\n                      "])), _this42._buttonPrev(), _this42._calendarMonths[i][0].getFullYear(), _this42._buttonNext()) : '', i === 0 ? _this42._buttonPrev() : '', _this42.monthNames[_this42._calendarMonths[i][0].getMonth()], _this42._calendarMonths[i][0].getFullYear(), _this42._calendarMonths ? _this42._getMonthAndYear(_this42._calendarMonths[i][0]) : '', i === _this42._calendarTableRows.length - 1 ? _this42._buttonNext() : '', _this42.monthNames[_this42._calendarMonths[i][0].getMonth()], _this42._calendarMonths[i][0].getFullYear(), _this42._buildTableHeaders(), month.map(function (row) {
          return html(_templateObject77 || (_templateObject77 = _taggedTemplateLiteral(["\n                            <tr role=\"row\">\n                              ", "\n                            </tr>\n                          "])), row.map(function (day) {
            return html(_templateObject78 || (_templateObject78 = _taggedTemplateLiteral(["\n                                  <td>\n                                    <button\n                                      tabindex=\"", "\"\n                                      ?disabled=\"", "\"\n                                      aria-hidden=\"", "\"\n                                      aria-pressed=\"", "\"\n                                      aria-label=\"", "\"\n                                      data-date=\"", "\"\n                                      @click=\"", "\"\n                                      @keydown=\"", "\"\n                                    >\n                                      <span>", "</span>\n                                    </button>\n                                  </td>\n                                "])), day ? 4 : -1, day ? false : true, day ? false : true, day === _this42.selectedDate, day ? "".concat(_this42._formatDate(day)) : '', day ? _this42._formatDate(day) : '', function (e) {
              _this42._handleSelectedDate(day, e);
            }, function (e) {
              _this42._handleSelectedDate(day, e);
            }, day ? day.getDate() : '');
          }));
        }), _this42._desktopFooterNav(i === arr.length - 1));
      }), this._buildCancelButton(), this._buildApplyButton());
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, sharedMobileViewStyles, css$1(_templateObject79 || (_templateObject79 = _taggedTemplateLiteral(["\n        :host {\n          position: relative;\n        }\n        button[disabled] {\n          appearance: none;\n          border: none;\n          background: transparent;\n        }\n        .fwc-overlay {\n          position: fixed;\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n        }\n        .fwc-date-picker-wrapper {\n          width: 100%;\n        }\n        .fwc-calendar {\n          position: absolute;\n          display: flex;\n          flex-direction: row;\n          visibility: hidden;\n          opacity: 0;\n          transition: opacity 0.3s ease-in-out;\n          box-shadow: var(--box-shadow);\n          border: none;\n          background: white;\n          margin-top: 0;\n          height: 0;\n          width: 0;\n          overflow: hidden;\n        }\n        .fwc-calendar-mobile-nav {\n          display: none;\n        }\n        .fwc-calendar-month {\n          padding: calc(2.5 * var(--fwcu)) calc(1.5 * var(--fwcu))\n            calc(1.5 * var(--fwcu));\n        }\n        .fwc-calendar.open {\n          z-index: 3;\n          visibility: visible;\n          opacity: 1;\n          height: auto;\n          width: auto;\n          border: solid 1px rgba(var(--color-rgb-primary), 0.06);\n          overflow: visible;\n        }\n        /* we use this class to get the calendar dimensions and set it position before it opens _setCalendarPosition()*/\n        .fwc-calendar.pre-open {\n          height: auto;\n          width: auto;\n        }\n        .fwc-calendar-header {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          position: relative;\n          margin-bottom: calc(2.5 * var(--fwcu));\n        }\n        .fwc-date-picker-input {\n          position: relative;\n        }\n        .fwc-date-picker-input span {\n          position: absolute;\n        }\n        .fwc-date-picker-input input {\n          width: 100%;\n          font-family: var(--font-sans-serif, 'sans-serif');\n        }\n        .fwc-icon-calendar {\n          border: none;\n          appearance: none;\n          background: none;\n          position: absolute;\n          right: calc(1.25 * var(--fwcu));\n          top: 0;\n          bottom: 0;\n        }\n        .fwc-icon-calendar:hover {\n          cursor: pointer;\n        }\n        .fwc-icon-calendar svg {\n          fill: var(--color-primary);\n        }\n        .fwc-icon-calendar.invalid svg {\n          fill: var(--color-alert-error);\n        }\n\n        .fwc-btn-prev,\n        .fwc-btn-next {\n          border: none;\n          appearance: none;\n          background: transparent;\n          position: absolute;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          height: calc(3 * var(--fwcu));\n          width: calc(3 * var(--fwcu));\n          padding: 0;\n        }\n        .fwc-btn-prev svg,\n        .fwc-btn-next svg {\n          fill: var(--color-primary);\n          height: auto;\n          width: 100%;\n        }\n        .fwc-btn-next {\n          right: calc(1.5 * var(--fwcu));\n          top: 0;\n          bottom: 0;\n          margin: auto;\n        }\n        .fwc-btn-prev {\n          transform: rotate(180deg);\n          left: calc(1.5 * var(--fwcu));\n          top: 0;\n          bottom: 0;\n          margin: auto;\n        }\n        .fwc-btn-next:hover,\n        .fwc-btn-prev:hover {\n          cursor: pointer;\n        }\n        .fwc-month-year {\n          font-weight: 700;\n          text-transform: uppercase;\n          color: var(--color-gray-one);\n        }\n        .fwc-calendar-body th {\n          font-size: calc(1.5 * var(--fwcu));\n          padding-bottom: calc(1.5 * var(--fwcu));\n          color: var(--color-gray-one);\n        }\n        .fwc-calendar-body button {\n          appearance: none;\n          border: none;\n          background: transparent;\n          width: calc(5.5 * var(--fwcu));\n          height: calc(5.5 * var(--fwcu));\n          border-radius: 50%;\n          font-size: calc(1.5 * var(--fwcu));\n          color: var(--color-gray-one);\n          font-family: var(--font-sans-serif, 'sans-serif');\n        }\n        .fwc-calendar-body button:hover {\n          cursor: pointer;\n        }\n        .fwc-calendar-body button:hover,\n        .fwc-calendar-body button:focus {\n          border: 2px solid var(--color-primary);\n          font-size: calc(2 * var(--fwcu));\n          font-weight: 700;\n          color: var(--color-primary);\n          outline: none;\n        }\n        .fwc-calendar-body button:disabled {\n          color: var(--color-gray-four);\n        }\n        .fwc-calendar-body button:disabled {\n          cursor: auto;\n        }\n        .fwc-calendar-body button:disabled:hover,\n        .fwc-calendar-body button:disabled:focus {\n          border: 2px solid transparent;\n          color: var(--color-gray-four);\n          outline: none;\n          font-size: calc(1.5 * var(--fwcu));\n          font-weight: 400;\n        }\n        .fwc-calendar-body button.active {\n          background: var(--color-primary);\n          color: var(--color-white);\n          font-size: calc(2 * var(--fwcu));\n        }\n        .fwc-calendar-body button.active:hover {\n          border: 2px solid transparent;\n          color: var(--color-white);\n        }\n        .fwc-calendar-body button span {\n          pointer-events: none;\n        }\n        .fwc-calendar-body button[data-date=''] {\n          visibility: hidden;\n        }\n        .fwc-hide {\n          display: none;\n          visibility: hidden;\n        }\n        .fwc-footer-container {\n          position: relative;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n        .fwc-calender-desktop-footer {\n          display: flex;\n          flex-direction: row;\n          justify-content: flex-end;\n          align-items: center;\n          margin-top: calc(4 * var(--fwcu));\n        }\n        .fwc-calender-desktop-footer .fwc-btn-secondary {\n          margin-right: calc(2 * var(--fwcu));\n        }\n        @media screen and (max-width: 900px) {\n          .fwc-calendar {\n            display: block;\n          }\n          .fwc-calendar-month:nth-of-type(3) {\n            padding-top: 0;\n          }\n        }\n        @media screen and (max-width: 600px) {\n          .fwc-overlay {\n            background-color: var(--color-white);\n          }\n          .fwc-input.open {\n            opacity: 0;\n          }\n          .fwc-calendar-header .fwc-btn-prev,\n          .fwc-calendar-header .fwc-btn-next {\n            display: none;\n          }\n          .fwc-calendar.open {\n            width: 100%;\n            margin-top: 0;\n            /* important is needed to override the inline positioning */\n            top: 0 !important;\n            bottom: 0 !important;\n            left: 0 !important;\n            right: 0 !important;\n            box-shadow: none;\n            border: none;\n          }\n          .fwc-btn-prev,\n          .fwc-btn-next {\n            position: relative;\n          }\n          .fwc-calendar-mobile-nav {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            padding: calc(2.5 * var(--fwcu)) 0 0;\n            font-size: calc(2 * var(--fwcu));\n            color: var(--color-gray-one);\n            font-weight: 700;\n          }\n          .fwc-calendar-mobile-nav span {\n            display: inline-block;\n            min-width: calc(4 * var(--fwcu));\n          }\n          .fwc-calendar-mobile-nav span:nth-child(2) {\n            margin: 0 calc(4 * var(--fwcu));\n          }\n          /* ios flex padding bottom hack */\n          .fwc-calendar:after {\n            content: '';\n            display: block;\n            padding-bottom: calc(12.5 * var(--fwcu));\n          }\n          .fwc-calendar-month {\n            flex-basis: 100%;\n            padding: calc(2.5 * var(--fwcu)) calc(2.5 * var(--fwcu))\n              calc(1.5 * var(--fwcu));\n          }\n          .fwc-calendar-body table {\n            width: 100%;\n          }\n          .fwc-calendar-body td {\n            width: 14.29%;\n          }\n          .fwc-calendar-body button {\n            width: 100%;\n            padding-top: 90%;\n            position: relative;\n            border: 2px solid transparent;\n          }\n          .fwc-calendar-body button > span {\n            position: absolute;\n            width: 100%;\n            height: 100%;\n            top: 0;\n            left: 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n          }\n          .fwc-calender-desktop-footer {\n            display: none;\n          }\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        startDate: {
          attribute: 'start-date',
          type: String
        },
        showDate: {
          attribute: 'show-date',
          type: Boolean
        },
        monthNames: {
          attribute: 'month-names',
          type: Array
        },
        dayNames: {
          attribute: 'day-names',
          type: Array
        },
        dateRange: {
          attribute: 'date-range',
          type: Array
        },
        disabledDates: {
          attribute: 'disabled-dates',
          type: Array
        },
        btnCancel: {
          attribute: 'btn-cancel',
          type: String
        },
        btnApply: {
          attribute: 'btn-apply',
          type: String
        },
        errorInvalidLabel: {
          attribute: 'error-invalid-label',
          type: String
        },
        errorDisabledLabel: {
          attribute: 'error-disabled-label',
          type: String
        },
        inputLabel: {
          attribute: 'input-label',
          type: String
        },
        labelAriaNext: {
          attribute: 'label-aria-next',
          type: String
        },
        labelAriaPrevious: {
          attribute: 'label-aria-previous',
          type: String
        },
        labelAriaCancel: {
          attribute: 'label-aria-cancel',
          type: String
        },
        labelAriaApply: {
          attribute: 'label-aria-apply',
          type: String
        },
        labelAriaCalendarIcon: {
          attribute: 'label-aria-calendar-icon',
          type: String
        },
        labelAriaDayNames: {
          attribute: 'label-aria-day-names',
          type: Array
        },
        invalid: {
          type: Boolean
        },
        config: {
          type: Object
        },
        disabled: {
          type: Boolean
        },
        selectedDate: {},
        _calendarTableRows: {},
        _isCalendarOpen: {},
        _rangeStart: {},
        _rangeEnd: {}
      };
    }
  }]);
  return FwcDatePickerComponent;
}(LitElement);
var FwcDatePicker = /*#__PURE__*/function (_FwcBase13) {
  _inherits$1(FwcDatePicker, _FwcBase13);
  var _super28 = _createSuper$8(FwcDatePicker);
  function FwcDatePicker() {
    _classCallCheck$1(this, FwcDatePicker);
    return _super28.call(this, 'fwc-date-picker', FwcDatePickerComponent);
  }
  return _createClass$1(FwcDatePicker);
}(FwcBase$1);
var FwcPreloaderComponent = /*#__PURE__*/function (_LitElement16) {
  _inherits$1(FwcPreloaderComponent, _LitElement16);
  var _super29 = _createSuper$8(FwcPreloaderComponent);
  function FwcPreloaderComponent() {
    var _this43;
    _classCallCheck$1(this, FwcPreloaderComponent);
    _this43 = _super29.call(this);
    _this43.labelAriaValueText = 'Loading';
    return _this43;
  }
  _createClass$1(FwcPreloaderComponent, [{
    key: "render",
    value: function render() {
      return html(_templateObject80 || (_templateObject80 = _taggedTemplateLiteral(["\n      <div class=\"fwc-preloader\">\n        <div\n          class=\"fwc-preloader-heart\"\n          role=\"progressbar\"\n          aria-label=\"", "\"\n        >\n          <span></span>\n          <span></span>\n          <span></span>\n          <span></span>\n          <span></span>\n          <span></span>\n          <span></span>\n        </div>\n      </div>\n    "])), this.labelAriaValueText);
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject81 || (_templateObject81 = _taggedTemplateLiteral(["\n        @keyframes slideDown {\n          0% {\n            top: 0%;\n            bottom: 100%;\n            opacity: 0;\n          }\n\n          5% {\n            top: 0%;\n            bottom: 0%;\n          }\n\n          12% {\n            opacity: 1;\n          }\n\n          50% {\n            top: 0%;\n            bottom: 0%;\n            opacity: 1;\n          }\n\n          55% {\n            top: 0%;\n            bottom: 100%;\n          }\n\n          62% {\n            opacity: 0;\n          }\n\n          100% {\n            top: 0%;\n            bottom: 100%;\n            opacity: 0%;\n          }\n        }\n        @keyframes slideUp {\n          0% {\n            top: 100%;\n            bottom: 0%;\n            opacity: 0;\n          }\n\n          5% {\n            top: 0%;\n            bottom: 0%;\n          }\n\n          12% {\n            opacity: 1;\n          }\n\n          50% {\n            top: 0%;\n            bottom: 0%;\n          }\n\n          55% {\n            top: 100%;\n            bottom: 0%;\n            opacity: 1;\n          }\n\n          62% {\n            opacity: 0;\n          }\n\n          100% {\n            top: 100%;\n            bottom: 0%;\n          }\n        }\n        .fwc-preloader {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n        .fwc-preloader .fwc-preloader-heart {\n          display: flex;\n          padding: calc(1.5 * var(--fwcu));\n          height: calc(15 * var(--fwcu));\n        }\n        .fwc-preloader .fwc-preloader-heart span {\n          position: relative;\n          background: var(--color-gray-five, #eee);\n          width: var(--fwcu);\n          display: flex;\n          margin: calc(0.5 * var(--fwcu));\n          border-radius: calc(0.5 * var(--fwcu));\n          height: calc(10 * var(--fwcu));\n          top: calc(3 * var(--fwcu));\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(even)::before {\n          animation: slideUp 5s ease-out infinite;\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(odd)::before {\n          animation: slideDown 5s ease-out infinite;\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(2)::before {\n          animation-delay: 0.286s;\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(3)::before {\n          animation-delay: 0.572s;\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(4)::before {\n          animation-delay: 0.858s;\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(5)::before {\n          animation-delay: 1.144s;\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(6)::before {\n          animation-delay: 1.43s;\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(7)::before {\n          animation-delay: 1.716s;\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(1),\n        .fwc-preloader .fwc-preloader-heart span:nth-child(7) {\n          height: calc(3.75 * var(--fwcu));\n          top: calc(2.5 * var(--fwcu));\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(2),\n        .fwc-preloader .fwc-preloader-heart span:nth-child(6) {\n          height: calc(7.5 * var(--fwcu));\n          top: calc(1.25 * var(--fwcu));\n        }\n        .fwc-preloader {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n        .fwc-preloader .fwc-preloader-heart {\n          display: flex;\n          padding: calc(1.5 * var(--fwcu));\n          height: calc(15 * var(--fwcu));\n        }\n        .fwc-preloader .fwc-preloader-heart span {\n          position: relative;\n          background: var(--color-gray-five, #eee);\n          width: var(--fwcu);\n          display: flex;\n          margin: calc(0.5 * var(--fwcu));\n          border-radius: calc(0.5 * var(--fwcu));\n          height: calc(10 * var(--fwcu));\n          top: calc(3 * var(--fwcu));\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(even)::before {\n          animation: slideUp 5s ease-out infinite;\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(odd)::before {\n          animation: slideDown 5s ease-out infinite;\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(2)::before {\n          animation-delay: 0.286s;\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(3)::before {\n          animation-delay: 0.572s;\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(4)::before {\n          animation-delay: 0.858s;\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(5)::before {\n          animation-delay: 1.144s;\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(6)::before {\n          animation-delay: 1.43s;\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(7)::before {\n          animation-delay: 1.716s;\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(1),\n        .fwc-preloader .fwc-preloader-heart span:nth-child(7) {\n          height: calc(3.75 * var(--fwcu));\n          top: calc(2.5 * var(--fwcu));\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(2),\n        .fwc-preloader .fwc-preloader-heart span:nth-child(6) {\n          height: calc(7.5 * var(--fwcu));\n          top: calc(1.25 * var(--fwcu));\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(3),\n        .fwc-preloader .fwc-preloader-heart span:nth-child(5) {\n          height: calc(10 * var(--fwcu));\n          top: calc(1.25 * var(--fwcu));\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(odd)::before {\n          content: '';\n          position: absolute;\n          left: 0;\n          right: 0;\n          background: linear-gradient(\n            0deg,\n            var(--color-primary),\n            var(--color-primary-hover)\n          );\n          border-radius: calc(0.5 * var(--fwcu));\n          top: 0%;\n        }\n        .fwc-preloader .fwc-preloader-heart span:nth-child(even)::before {\n          content: '';\n          position: absolute;\n          left: 0;\n          right: 0;\n          background: linear-gradient(\n            180deg,\n            var(--color-primary),\n            var(--color-primary-hover)\n          );\n          border-radius: calc(0.5 * var(--fwcu));\n          bottom: 0%;\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        labelAriaValueText: {
          attribute: 'label-aria-value-text',
          type: String
        }
      };
    }
  }]);
  return FwcPreloaderComponent;
}(LitElement);
var FwcPreloader = /*#__PURE__*/function (_FwcBase14) {
  _inherits$1(FwcPreloader, _FwcBase14);
  var _super30 = _createSuper$8(FwcPreloader);
  function FwcPreloader() {
    _classCallCheck$1(this, FwcPreloader);
    return _super30.call(this, 'fwc-preloader', FwcPreloaderComponent);
  }
  return _createClass$1(FwcPreloader);
}(FwcBase$1);
// Used by: FwcExpandMultiItem
var ExpandCollapse = /*#__PURE__*/function () {
  function ExpandCollapse(content) {
    var _this47 = this;
    _classCallCheck$1(this, ExpandCollapse);
    this.content = content;
    this.drawer = content.firstElementChild;
    this.isExpanded = false;

    // when the panel closes
    this.content.addEventListener('transitionend', function () {
      if (!_this47.isExpanded) {
        // hides content from tab order when closed.
        _this47.drawer.style.display = 'none';
      }
    });
  }
  _createClass$1(ExpandCollapse, [{
    key: "_setPanelStyles",
    value: function _setPanelStyles(lock) {
      var element = this.content;
      this.drawer.style.display = 'block';
      // have the element transition to the height of its inner content
      element.style.height = lock ? 'auto' : "".concat(element.scrollHeight, "px");
      if (!lock) {
        element.addEventListener('transitionend', function handler() {
          element.style.height = 'auto';
          element.removeEventListener('transitionend', handler);
        });
      }
    }
  }, {
    key: "expandPanel",
    value: function expandPanel(lock) {
      this._setPanelStyles(lock);
      this.isExpanded = true;
    }
  }, {
    key: "collapsePanel",
    value: function collapsePanel() {
      var _this48 = this;
      var sectionHeight = this.content.scrollHeight;

      // temporarily disable all css transitions
      var elementTransition = this.content.style.transition;
      this.content.style.transition = '';
      this.isExpanded = false;

      // on the next frame (as soon as the previous style change has taken effect),
      // explicitly set the element's height to its current pixel height, so we
      // aren't transitioning out of 'auto'
      requestAnimationFrame(function () {
        _this48.content.style.height = "".concat(sectionHeight, "px");
        _this48.content.style.transition = elementTransition;

        // on the next frame (as soon as the previous style change has taken effect),
        requestAnimationFrame(function () {
          _this48.content.style.height = "".concat(0, "px");
        });
      });
    }
  }]);
  return ExpandCollapse;
}();
var FwcExpandComponent = /*#__PURE__*/function (_LitElement18) {
  _inherits$1(FwcExpandComponent, _LitElement18);
  var _super33 = _createSuper$8(FwcExpandComponent);
  function FwcExpandComponent() {
    var _this49;
    _classCallCheck$1(this, FwcExpandComponent);
    _this49 = _super33.call(this);
    _this49.config = fwcConfig$1;
    _this49.expanded = false;
    _this49.last = false;
    return _this49;
  }
  _createClass$1(FwcExpandComponent, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      var content = this.shadowRoot.querySelector('.fwc-expand-content');
      this.expandCollapse = new ExpandCollapse(content);
      if (this.expanded) {
        this._expandPanel(true);
      }
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldVal, newVal) {
      var _this50 = this;
      if (name === 'expanded') {
        setTimeout(function () {
          if (newVal === 'true') {
            _this50._expandPanel(true);
          } else {
            _this50._collapsePanel();
          }
        }, 0);
      }
      _get(_getPrototypeOf(FwcExpandComponent.prototype), "attributeChangedCallback", this).call(this, name, oldVal, newVal);
    }
  }, {
    key: "_collapsePanel",
    value: function _collapsePanel() {
      this.expandCollapse.collapsePanel();
    }
  }, {
    key: "_expandPanel",
    value: function _expandPanel(lock) {
      this.expandCollapse.expandPanel(lock);
    }
  }, {
    key: "expand",
    value: function expand() {
      this._expand();
    }
    // use to toggle outside of component
  }, {
    key: "_expand",
    value: function _expand() {
      if (this.expanded) {
        this._collapsePanel();
      } else {
        this._expandPanel();
      }
      this.expanded = !this.expanded;
      var event = new CustomEvent('fwc-expand-expanded', {
        detail: this.expanded,
        bubbles: true
      });
      this.dispatchEvent(event);
    }
  }, {
    key: "_buildLabel",
    value: function _buildLabel() {
      var label = this.label ? html(_templateObject89 || (_templateObject89 = _taggedTemplateLiteral(["<span class=\"fwc-h4 fwc-expand-label\">", "</span>"])), this.label) : html(_templateObject90 || (_templateObject90 = _taggedTemplateLiteral(["<slot name=\"fwc-expand-title\"></slot>"])));
      return label;
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject91 || (_templateObject91 = _taggedTemplateLiteral(["\n      <link\n        rel=\"stylesheet\"\n        href=\"", "fwc-assets/styles/typography.css\"\n      />\n      <div\n        class=\"", "\"\n      >\n        <div class=\"fwc-expand-header\">\n          <button\n            id=\"expandBtn_", "\"\n            class=\"fwc-expand-button\"\n            type=\"button\"\n            role=\"button\"\n            aria-controls=\"panel_", "\"\n            aria-label=\"", "\"\n            aria-expanded=\"", "\"\n            @click=", "\n          >\n            <svg\n              xmlns=\"http://www.w3.org/2000/svg\"\n              width=\"51\"\n              height=\"50\"\n              viewBox=\"0 0 50 50\"\n              class=\"fwc-expand-icon ", "\"\n              focusable=\"false\"\n            >\n              <polygon\n                points=\"2.719 39.66 0 36.941 23.641 13.3 25 12 26.359 13.3 50 36.941 47.281 39.66 25 17.378\"\n                transform=\"matrix(1 0 0 -1 0 51.66)\"\n              />\n            </svg>\n          </button>\n          ", "\n        </div>\n        <div class=\"fwc-expand-content ", "\">\n          <div\n            role=\"region\"\n            class=\"fwc-expand-drawer\"\n            id=\"panel_", "\"\n            aria-labelledby=\"expandBtn_", "\"\n          >\n            <slot></slot>\n          </div>\n        </div>\n      </div>\n    "])), this.config.assetsPath, this.noBorder ? '' : "fwc-expand-wrapper ".concat(this.last ? 'fwc-expand-last' : ''), this.id, this.id, this.labelAriaExpandBtn ? this.labelAriaExpandBtn : this.label, this.expanded, this._expand, this.expanded ? 'expanded' : '', this._buildLabel(), this.expanded ? 'expanded' : '', this.id, this.id);
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject92 || (_templateObject92 = _taggedTemplateLiteral(["\n        .fwc-expand-wrapper {\n          border-top: 1px solid var(--color-gray-four);\n        }\n        .fwc-expand-last {\n          border-bottom: 1px solid var(--color-gray-four);\n        }\n        .fwc-expand-header {\n          display: flex;\n          flex-direction: row;\n          align-items: flex-start;\n          padding: calc(4 * var(--fwcu)) calc(4 * var(--fwcu))\n            calc(4 * var(--fwcu)) calc(1.5 * var(--fwcu));\n        }\n        .fwc-expand-label {\n          color: var(--color-gray-one);\n          line-height: calc(3 * var(--fwcu));\n        }\n        .fwc-expand-button {\n          padding: 0;\n          border: none;\n          background: none;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          margin: 0;\n          margin: 0 calc(1.75 * var(--fwcu));\n          border-radius: 0;\n        }\n        .fwc-expand-button:hover {\n          cursor: pointer;\n        }\n        .fwc-expand-icon {\n          fill: var(--color-primary);\n          height: calc(3 * var(--fwcu));\n          width: calc(3 * var(--fwcu));\n        }\n        .fwc-expand-icon.expanded {\n          transform: rotateX(180deg);\n        }\n        .fwc-expand-content {\n          overflow: hidden;\n          transition: height 0.3s ease;\n          padding-right: calc(5 * var(--fwcu));\n          padding-left: calc(8 * var(--fwcu));\n          height: 0;\n        }\n        .fwc-expand-drawer {\n          display: none;\n          padding-bottom: calc(4 * var(--fwcu));\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        config: {
          type: Object
        },
        expanded: {
          type: Boolean
        },
        labelAriaExpandBtn: {
          attribute: 'label-aria-expand-btn',
          type: String
        },
        label: {
          type: String
        },
        last: {
          type: Boolean
        },
        noBorder: {
          attribute: 'no-border',
          type: Boolean
        }
      };
    }
  }]);
  return FwcExpandComponent;
}(LitElement);
var FwcExpand = /*#__PURE__*/function (_FwcBase16) {
  _inherits$1(FwcExpand, _FwcBase16);
  var _super34 = _createSuper$8(FwcExpand);
  function FwcExpand() {
    _classCallCheck$1(this, FwcExpand);
    return _super34.call(this, 'fwc-expand', FwcExpandComponent);
  }
  return _createClass$1(FwcExpand);
}(FwcBase$1);
var FwcExpandMultiComponent = /*#__PURE__*/function (_LitElement19) {
  _inherits$1(FwcExpandMultiComponent, _LitElement19);
  var _super35 = _createSuper$8(FwcExpandMultiComponent);
  function FwcExpandMultiComponent() {
    var _this51;
    _classCallCheck$1(this, FwcExpandMultiComponent);
    _this51 = _super35.call(this);
    _this51.slotItems = null;
    _this51.slotItemActiveIndex = null;
    // used for setting an index on <fwc-expand-multi-item>
    _this51.childIndexTracker = 0;
    return _this51;
  }
  _createClass$1(FwcExpandMultiComponent, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      // dispatch an event when the component has connected
      _get(_getPrototypeOf(FwcExpandMultiComponent.prototype), "connectedCallback", this).call(this);
      var componentName = this.tagName.toLowerCase();
      var event = new CustomEvent("".concat(componentName, "-connected"), {
        detail: this,
        bubbles: true
      });
      this.dispatchEvent(event);
    }
  }, {
    key: "firstUpdated",
    value: function firstUpdated() {
      // get slotted children
      this.slotItems = this._slottedChildren();
      if (this.slotItemActiveIndex) {
        this._expandSlotByActiveIndex();
      }
    }
  }, {
    key: "_expandSlotByActiveIndex",
    value: function _expandSlotByActiveIndex() {
      var _this52 = this;
      // expand a child by index
      this.slotItems.forEach(function (item, index) {
        if (_this52.slotItemActiveIndex === index) {
          item.expandPanel();
        } else {
          item.closePanel();
        }
      });
    }
  }, {
    key: "expandByIndex",
    value: function expandByIndex(index) {
      this.slotItemActiveIndex = index;
      if (this.slotItems) {
        this._expandSlotByActiveIndex();
      }
    }
  }, {
    key: "_slottedChildren",
    value: function _slottedChildren() {
      var slot = this.shadowRoot.querySelector('slot');
      var childNodes = slot.assignedNodes({
        flatten: true
      });
      return Array.prototype.filter.call(childNodes, function (node) {
        return node.nodeType === Node.ELEMENT_NODE;
      });
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject93 || (_templateObject93 = _taggedTemplateLiteral(["\n      <div class=\"fwc-expand-multi-wrapper\">\n        <slot></slot>\n      </div>\n    "])));
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject94 || (_templateObject94 = _taggedTemplateLiteral([""])))];
    }
  }]);
  return FwcExpandMultiComponent;
}(LitElement);
var FwcExpandMultiItemComponent = /*#__PURE__*/function (_LitElement20) {
  _inherits$1(FwcExpandMultiItemComponent, _LitElement20);
  var _super36 = _createSuper$8(FwcExpandMultiItemComponent);
  function FwcExpandMultiItemComponent() {
    var _this53;
    _classCallCheck$1(this, FwcExpandMultiItemComponent);
    _this53 = _super36.call(this);
    _this53.expanded = false;
    _this53.index = 0;
    return _this53;
  }
  _createClass$1(FwcExpandMultiItemComponent, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      var _this54 = this;
      var content = this.shadowRoot.querySelector('.fwc-expand-content');
      this.expandCollapse = new ExpandCollapse(content);

      // set the stored index from the parent and then increment it for next instance
      this.index = this.parentNode.childIndexTracker;
      this.parentNode.childIndexTracker += 1;

      // if the property is passed in
      if (this.expanded) {
        this.expandPanel(true);
      }
      this.parentNode.addEventListener('fwc-expand-multi-expanded', function (e) {
        // if the event is dispatched from a sibling component, close its panel
        if (e.target !== _this54) {
          _this54.closePanel();
          return;
        }

        // if the event is dispatched from itself, toggle the panel
        if (_this54.expanded) {
          _this54.closePanel();
        } else {
          _this54.expandPanel();
        }

        // stop the event from bubbling outside fwc-expand-multi
        e.cancelBubble = true;
      });
    }
  }, {
    key: "expandPanel",
    value: function expandPanel(lock) {
      this.setAttribute('expanded', 'true');
      this.expandCollapse.expandPanel(lock);
    }
  }, {
    key: "closePanel",
    value: function closePanel() {
      this.removeAttribute('expanded');
      this.expandCollapse.collapsePanel();
    }

    //TODO send index in details
    //Send on expandPanel
  }, {
    key: "_dispatchExpandEvent",
    value: function _dispatchExpandEvent() {
      var event = new CustomEvent('fwc-expand-multi-expanded', {
        detail: !this.expanded,
        bubbles: true,
        composed: false
      });
      this.dispatchEvent(event);
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject95 || (_templateObject95 = _taggedTemplateLiteral(["\n      <div class=\"fwc-expand-multi-item\">\n        <div class=\"fwc-expand-header\">\n          <button\n            class=\"fwc-expand-button\"\n            type=\"button\"\n            id=\"expand_", "\"\n            aria-expanded=\"", "\"\n            aria-controls=\"panel_", "\"\n            aria-label=\"", "\"\n            @click=", "\n          >\n            <svg\n              xmlns=\"http://www.w3.org/2000/svg\"\n              width=\"50\"\n              height=\"50\"\n              viewBox=\"0 0 50 50\"\n              class=\"fwc-expand-icon ", "\"\n              focusable=\"false\"\n            >\n              <polygon\n                points=\"2.719 39.66 0 36.941 23.641 13.3 25 12 26.359 13.3 50 36.941 47.281 39.66 25 17.378\"\n                transform=\"matrix(1 0 0 -1 0 51.66)\"\n              />\n            </svg>\n          </button>\n          <slot name=\"expand-header\"></slot>\n        </div>\n        <div class=\"fwc-expand-content\">\n          <div\n            class=\"fwc-expand-drawer\"\n            role=\"region\"\n            id=\"panel_", "\"\n            aria-labelledby=\"expand_", "\"\n            style=\"display: none;\"\n          >\n            <slot name=\"expand-panel\"></slot>\n          </div>\n        </div>\n      </div>\n    "])), this.index, this.expanded, this.index, this.expandButtonAriaLabel, this._dispatchExpandEvent, this.expanded ? 'expanded' : '', this.index, this.index);
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject96 || (_templateObject96 = _taggedTemplateLiteral(["\n        .fwc-expand-multi-item {\n        }\n        .fwc-expand-header {\n          position: relative;\n          padding: var(--fwcu);\n          display: flex;\n        }\n        .fwc-expand-button {\n          flex-basis: calc(3 * var(--fwcu));\n          border: none;\n          background: none;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          border-radius: 0;\n        }\n        .fwc-expand-icon {\n          height: calc(2 * var(--fwcu));\n          width: calc(2 * var(--fwcu));\n        }\n        .fwc-expand-icon.expanded {\n          transform: rotateX(180deg);\n        }\n        .fwc-expand-content {\n          overflow: hidden;\n          transition: height 0.3s ease 0s;\n          height: 0px;\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        expanded: {
          type: Boolean
        },
        expandButtonAriaLabel: {
          attribute: 'label-aria-expand-text',
          type: String
        }
      };
    }
  }]);
  return FwcExpandMultiItemComponent;
}(LitElement);
var FwcExpandMulti = /*#__PURE__*/function (_FwcBase17) {
  _inherits$1(FwcExpandMulti, _FwcBase17);
  var _super37 = _createSuper$8(FwcExpandMulti);
  function FwcExpandMulti() {
    var _this55;
    _classCallCheck$1(this, FwcExpandMulti);
    _this55 = _super37.call(this, 'fwc-expand-multi', FwcExpandMultiComponent);
    var FwcExpandMultiItem = new FwcBase$1('fwc-expand-multi-item', FwcExpandMultiItemComponent);
    FwcExpandMultiItem.build();
    return _this55;
  }
  return _createClass$1(FwcExpandMulti);
}(FwcBase$1);
var FwcExpandMobileColComponent = /*#__PURE__*/function (_LitElement21) {
  _inherits$1(FwcExpandMobileColComponent, _LitElement21);
  var _super38 = _createSuper$8(FwcExpandMobileColComponent);
  function FwcExpandMobileColComponent() {
    var _this56;
    _classCallCheck$1(this, FwcExpandMobileColComponent);
    _this56 = _super38.call(this);
    _this56.mobileTitle = '';
    _this56.horizontal = false;
    _this56.isExpanded = false;
    return _this56;
  }
  _createClass$1(FwcExpandMobileColComponent, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      if (this.horizontal) {
        var slotItems = this._getSlotted();
        slotItems.forEach(function (slotItem, i) {
          slotItem.setAttribute('horizontal', '');
        });
      }
    }
  }, {
    key: "_getSlotted",
    value: function _getSlotted() {
      var slot = this.shadowRoot.querySelector('slot');
      var childNodes = slot ? slot.assignedNodes({
        flatten: true
      }) : [];
      return Array.prototype.filter.call(childNodes, function (node) {
        return node.nodeType == Node.ELEMENT_NODE && node.nodeName === 'FWC-EXPAND-MOBILE-COL-ITEM';
      });
    }
  }, {
    key: "_mobileExpandToggle",
    value: function _mobileExpandToggle(e) {
      var slotItems = this._getSlotted();
      slotItems.forEach(function (slotItem, i) {
        if (slotItem.hasAttribute('expanded')) {
          slotItem.removeAttribute('expanded');
        } else {
          slotItem.setAttribute('expanded', '');
        }
      });
      this.classList.toggle('expanded');
      this.isExpanded = !this.isExpanded;
      // aria-expanded does not update without this?
      this.requestUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject97 || (_templateObject97 = _taggedTemplateLiteral(["\n      <div class=\"fwc-expand-mobile-col-wrapper\">\n        <div class=\"fwc-mobile-title\">\n          <span>", "</span>\n          <button\n            class=\"fwc-expand-icon\"\n            @click=\"", "\"\n            aria-expanded=\"", "\"\n            aria-label=\"", "\"\n          ></button>\n        </div>\n        <ul>\n          <slot class=\"", "\"></slot>\n        </ul>\n      </div>\n    "])), this.mobileTitle, this._mobileExpandToggle, this.isExpanded, this.mobileTitle, this.horizontal ? 'horizontal' : '');
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject98 || (_templateObject98 = _taggedTemplateLiteral(["\n        :host {\n          display: block;\n          width: 100%;\n          padding: calc(2 * var(--fwcu)) 0;\n        }\n        ul {\n          list-style-type: none;\n          margin: 0;\n          padding: 0;\n          background: transparent;\n          overflow: hidden;\n          transition: all 500ms ease;\n        }\n        .fwc-mobile-title {\n          font-size: var(--default-font-size);\n          color: var(--color-white);\n          justify-content: space-between;\n          display: none;\n        }\n        .fwc-expand-icon {\n          height: calc(2.75 * var(--fwcu));\n          width: calc(2.75 * var(--fwcu));\n          background: var(--color-white);\n          border-radius: 50%;\n          position: relative;\n          border: none;\n          display: none;\n        }\n        .horizontal {\n          display: flex;\n          flex-direction: row;\n        }\n        .fwc-expand-icon:before {\n          content: '';\n          position: absolute;\n          background: var(--color-black);\n          height: calc(0.25 * var(--fwcu));\n          width: calc(1.5 * var(--fwcu));\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          margin: auto;\n        }\n        .fwc-expand-icon:after {\n          content: '';\n          position: absolute;\n          background: var(--color-black);\n          height: calc(0.25 * var(--fwcu));\n          width: calc(1.5 * var(--fwcu));\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          margin: auto;\n          transform: rotate(90deg);\n          opacity: 1;\n          transition: opacity 500ms ease;\n        }\n        :host(.expanded) ul {\n          margin-top: calc(2 * var(--fwcu));\n        }\n        :host(.expanded) .fwc-expand-icon:after {\n          opacity: 0;\n        }\n        @media screen and (max-width: 900px) {\n          .fwc-expand-icon {\n            display: inline-block;\n          }\n          .fwc-mobile-title {\n            display: flex;\n          }\n          .horizontal {\n            display: flex;\n            flex-direction: column;\n          }\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        mobileTitle: {
          attribute: 'mobile-title',
          type: String
        },
        horizontal: {
          attribute: 'horizontal',
          type: Boolean
        }
      };
    }
  }]);
  return FwcExpandMobileColComponent;
}(LitElement);
var FwcExpandMobileColItemComponent = /*#__PURE__*/function (_LitElement22) {
  _inherits$1(FwcExpandMobileColItemComponent, _LitElement22);
  var _super39 = _createSuper$8(FwcExpandMobileColItemComponent);
  function FwcExpandMobileColItemComponent() {
    _classCallCheck$1(this, FwcExpandMobileColItemComponent);
    return _super39.call(this);
  }
  _createClass$1(FwcExpandMobileColItemComponent, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldVal, newVal) {
      _get(_getPrototypeOf(FwcExpandMobileColItemComponent.prototype), "attributeChangedCallback", this).call(this, name, oldVal, newVal);
      if (name === 'expanded') {
        var liElem = this.shadowRoot.querySelector('li');
        if (this.expanded) {
          liElem.classList.add('expanded');
        } else {
          liElem.classList.remove('expanded');
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject99 || (_templateObject99 = _taggedTemplateLiteral(["\n      <li class=\"list-item ", "\">\n        <span>\n          <slot></slot>\n        </span>\n      </li>\n    "])), this.horizontal ? 'horizontal' : '');
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject100 || (_templateObject100 = _taggedTemplateLiteral(["\n        :host {\n          display: block;\n          width: 100%;\n        }\n        ::slotted(*) {\n          color: var(--color-white) !important;\n        }\n        span {\n          color: var(--color-white);\n          text-decoration: none;\n          display: flex;\n          align-items: center;\n          position: absolute;\n          top: 0;\n          bottom: 0;\n          width: 100%;\n        }\n        li {\n          transition: all 0.5s cubic-bezier(0.36, 0, 0.44, 0.2);\n          position: relative;\n          overflow: hidden;\n          padding-top: calc(3.5 * var(--fwcu));\n          top: 0;\n        }\n        li.list-item {\n          margin-bottom: calc(var(--fwcu));\n        }\n        li.horizontal {\n          padding-top: calc(6.75 * var(--fwcu));\n          margin: 0 calc(var(--fwcu));\n        }\n        @media screen and (max-width: 900px) {\n          li,\n          li.horizontal {\n            padding-top: 0;\n            top: calc(-12.25 * var(--fwcu));\n          }\n          li.expanded,\n          li.expanded.horizontal {\n            padding-top: calc(6.75 * var(--fwcu));\n            top: 0;\n          }\n          span {\n            border-top: 1px solid rgba(var(--color-rgb-gray-five), 0.2);\n            padding-left: calc(2 * var(--fwcu));\n          }\n          li.list-item {\n            visibility: hidden;\n          }\n          li.list-item.expanded {\n            visibility: visible;\n          }\n          li.list-item {\n            margin-bottom: 0;\n          }\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        expanded: {
          type: Boolean
        },
        horizontal: {
          type: Boolean
        }
      };
    }
  }]);
  return FwcExpandMobileColItemComponent;
}(LitElement);
var FwcExpandMobileCol = /*#__PURE__*/function (_FwcBase18) {
  _inherits$1(FwcExpandMobileCol, _FwcBase18);
  var _super40 = _createSuper$8(FwcExpandMobileCol);
  function FwcExpandMobileCol() {
    var _this57;
    _classCallCheck$1(this, FwcExpandMobileCol);
    _this57 = _super40.call(this, 'fwc-expand-mobile-col', FwcExpandMobileColComponent);
    var FwcExpandMobilColItem = new FwcBase$1('fwc-expand-mobile-col-item', FwcExpandMobileColItemComponent);
    FwcExpandMobilColItem.build();
    return _this57;
  }
  return _createClass$1(FwcExpandMobileCol);
}(FwcBase$1);
var FwcFooterStickyComponent = /*#__PURE__*/function (_LitElement25) {
  _inherits$1(FwcFooterStickyComponent, _LitElement25);
  var _super44 = _createSuper$8(FwcFooterStickyComponent);
  function FwcFooterStickyComponent() {
    var _this61;
    _classCallCheck$1(this, FwcFooterStickyComponent);
    _this61 = _super44.call(this);
    _this61.left = false;
    return _this61;
  }
  _createClass$1(FwcFooterStickyComponent, [{
    key: "_onSlotChange",
    value: function _onSlotChange() {
      this._checkLeftSlot();
    }
  }, {
    key: "_checkLeftSlot",
    value: function _checkLeftSlot() {
      var slot = this.shadowRoot.querySelector('#leftSlot');
      var nodes = slot.assignedNodes();
      if (nodes.length) {
        this.left = true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject104 || (_templateObject104 = _taggedTemplateLiteral(["\n      <footer class=", ">\n        <slot\n          @slotchange=", "\n          id=\"leftSlot\"\n          name=\"fwc-footer-sticky-left\"\n        ></slot>\n        <slot id=\"rightSlot\" name=\"fwc-footer-sticky-right\"></slot>\n      </footer>\n    "])), "".concat(this.left ? 'space' : ''), this._onSlotChange);
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject105 || (_templateObject105 = _taggedTemplateLiteral(["\n        :host {\n          width: auto;\n          position: fixed;\n          background-color: var(--color-white);\n          border: 1px solid var(--color-gray-four);\n          left: 0;\n          right: 0;\n          bottom: 0;\n          z-index: 1;\n        }\n        footer {\n          display: flex;\n          align-items: center;\n          justify-content: flex-end;\n          min-height: calc(3 * var(--fwcu));\n          padding: calc(3 * var(--fwcu)) calc(1.5 * var(--fwcu));\n          max-width: calc(144 * var(--fwcu));\n          margin: 0 auto;\n        }\n        footer.space {\n          justify-content: space-between;\n        }\n\n        @media screen and (max-width: 600px) {\n          slot[name='fwc-footer-sticky-left'] {\n            display: none;\n          }\n          footer {\n            padding-right: calc(4 * var(--fwcu));\n            padding-left: calc(4 * var(--fwcu));\n          }\n          footer,\n          footer.space {\n            justify-content: center;\n          }\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        left: {
          type: Boolean
        }
      };
    }
  }]);
  return FwcFooterStickyComponent;
}(LitElement);
var FwcFooterSticky = /*#__PURE__*/function (_FwcBase20) {
  _inherits$1(FwcFooterSticky, _FwcBase20);
  var _super45 = _createSuper$8(FwcFooterSticky);
  function FwcFooterSticky() {
    _classCallCheck$1(this, FwcFooterSticky);
    return _super45.call(this, 'fwc-footer-sticky', FwcFooterStickyComponent);
  }
  return _createClass$1(FwcFooterSticky);
}(FwcBase$1);
var FwcIconTextComponent = /*#__PURE__*/function (_LitElement28) {
  _inherits$1(FwcIconTextComponent, _LitElement28);
  var _super50 = _createSuper$8(FwcIconTextComponent);
  function FwcIconTextComponent() {
    var _this64;
    _classCallCheck$1(this, FwcIconTextComponent);
    _this64 = _super50.call(this);
    _this64.iconTextItems = [];
    _this64.isAnimateEnabled = false;
    return _this64;
  }

  /** Checks if trigger-animate was updated to 'start' or already equal to 'start' */
  _createClass$1(FwcIconTextComponent, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldVal, newVal) {
      _get(_getPrototypeOf(FwcIconTextComponent.prototype), "attributeChangedCallback", this).call(this, name, oldVal, newVal);
      if (name === 'trigger-animate' && newVal === 'start') {
        if (oldVal) {
          this._startAnimation();
        } else {
          this.isAnimateEnabled = true;
        }
      }
    }

    /** Checks if isAnimateEnabled is true on page load and starts animation */
  }, {
    key: "firstUpdated",
    value: function firstUpdated() {
      this.iconTextItems = this._getSlottedChildren();
      if (this.isAnimateEnabled) {
        this._setAnimation();
      }
    }

    /** Dispatches an event when the component has rendered in the DOM */
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(FwcIconTextComponent.prototype), "connectedCallback", this).call(this);
      var componentName = this.tagName.toLowerCase();
      var event = new CustomEvent("".concat(componentName, "-connected"), {
        detail: this,
        bubbles: true
      });
      this.dispatchEvent(event);
    }

    /** Retrieves the slotted children in the view and condenses it into an array of elements */
  }, {
    key: "_getSlottedChildren",
    value: function _getSlottedChildren() {
      var slot = this.shadowRoot.querySelector('slot');
      var childNodes = slot.assignedNodes({
        flatten: true
      });
      return Array.prototype.filter.call(childNodes, function (node) {
        return node.nodeType === Node.ELEMENT_NODE && node.nodeName === 'FWC-ICON-TEXT-ITEM';
      });
    }

    /** Manually fires the animations on attribute change outside of lifecycle */
  }, {
    key: "_startAnimation",
    value: function _startAnimation() {
      if (this.iconTextItems) {
        this.iconTextItems.forEach(function (item, index) {
          item.setAnimation(true, index * 300);
          item.startAnimation();
        });
      }
    }

    /** Sets the animate bool to true on child iconText items that will animate after they finish loading */
  }, {
    key: "_setAnimation",
    value: function _setAnimation() {
      if (this.iconTextItems) {
        this.iconTextItems.forEach(function (item, index) {
          item.setAnimation(true, index * 300);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject114 || (_templateObject114 = _taggedTemplateLiteral([" <slot></slot> "])));
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        triggerAnimate: {
          attribute: 'trigger-animate',
          type: String
        }
      };
    }
  }]);
  return FwcIconTextComponent;
}(LitElement);
var FwcIconTextItemComponent = /*#__PURE__*/function (_LitElement29) {
  _inherits$1(FwcIconTextItemComponent, _LitElement29);
  var _super51 = _createSuper$8(FwcIconTextItemComponent);
  function FwcIconTextItemComponent() {
    var _this65;
    _classCallCheck$1(this, FwcIconTextItemComponent);
    _this65 = _super51.call(this);
    _this65.delay = 0;
    _this65.animate = false;
    return _this65;
  }

  /** Starts fade-up animation if 'animate' bool was already set to true by parent component */
  _createClass$1(FwcIconTextItemComponent, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      if (this.animate) {
        this.startAnimation();
      }
    }

    /** Set animate bool and the delay time on this iconText item */
  }, {
    key: "setAnimation",
    value: function setAnimation(val, delay) {
      this.animate = val;
      this.delay = delay;
    }

    /** Starts fade-up animation but also checks the parent container exists before animating */
  }, {
    key: "startAnimation",
    value: function startAnimation() {
      var iconText = this.shadowRoot.querySelector('.iconText');
      if (iconText) {
        setTimeout(function () {
          iconText.classList.add('animate');
        }, this.delay);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject115 || (_templateObject115 = _taggedTemplateLiteral(["\n      <div class=\"iconText\">\n        <div class=\"iconText-image\">\n          <slot name=\"fwc-icon-text-image\"></slot>\n        </div>\n        <div class=\"iconText-content\">\n          <slot name=\"fwc-icon-text-content\"></slot>\n        </div>\n      </div>\n    "])));
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject116 || (_templateObject116 = _taggedTemplateLiteral(["\n        @keyframes fadeInUp {\n          0% {\n            opacity: 0;\n            transform: translateY(90%);\n          }\n          50% {\n            opacity: 1;\n          }\n          100% {\n            transform: translateY(0);\n          }\n        }\n        .iconText {\n          position: relative;\n          display: flex;\n          flex-direction: row;\n          margin-bottom: calc(5 * var(--fwcu));\n          transform: translateY(90%);\n          opacity: 0;\n          align-items: flex-start;\n        }\n        .animate {\n          animation-name: fadeInUp;\n          animation-delay: 0ms;\n          animation-duration: 1s;\n          animation-timing-function: ease-out;\n          animation-fill-mode: both;\n          opacity: 1;\n        }\n        .iconText-image {\n          display: flex;\n          justify-content: flex-start;\n          opacity: 1;\n          width: calc(6.25 * var(--fwcu));\n          align-items: center;\n          flex: 1 0 auto;\n        }\n        .iconText-image ::slotted(img),\n        .iconText-image ::slotted(svg) {\n          width: calc(6.25 * var(--fwcu));\n          height: calc(6.25 * var(--fwcu));\n        }\n        .iconText-content {\n          flex: 50 0 0;\n          padding-left: calc(2.25 * var(--fwcu));\n        }\n        @media screen and (max-width: 600px) {\n          .iconText {\n            transform: none;\n            margin-bottom: calc(6 * var(--fwcu));\n            opacity: 1;\n            flex-direction: row-reverse;\n            align-items: center;\n          }\n          .iconText-content {\n            padding-right: calc(2 * var(--fwcu));\n          }\n          .animate {\n            animation-duration: 0s;\n          }\n          .iconText-image {\n            width: auto;\n          }\n          .iconText-image ::slotted(img),\n          .iconText-image ::slotted(svg) {\n            width: calc(11.5 * var(--fwcu));\n            height: calc(11.5 * var(--fwcu));\n          }\n        }\n        @media screen and (max-width: 900px) {\n          .iconText-image {\n            align-items: flex-start;\n          }\n        }\n      "])))];
    }
  }]);
  return FwcIconTextItemComponent;
}(LitElement);
var FwcIconText = /*#__PURE__*/function (_FwcBase23) {
  _inherits$1(FwcIconText, _FwcBase23);
  var _super52 = _createSuper$8(FwcIconText);
  function FwcIconText() {
    var _this66;
    _classCallCheck$1(this, FwcIconText);
    _this66 = _super52.call(this, 'fwc-icon-text', FwcIconTextComponent);
    var FwcIconTextItem = new FwcBase$1('fwc-icon-text-item', FwcIconTextItemComponent);
    FwcIconTextItem.build();
    return _this66;
  }
  return _createClass$1(FwcIconText);
}(FwcBase$1);
var FwcModalSlideComponent = /*#__PURE__*/function (_LitElement33) {
  _inherits$1(FwcModalSlideComponent, _LitElement33);
  var _super57 = _createSuper$8(FwcModalSlideComponent);
  function FwcModalSlideComponent() {
    var _this74;
    _classCallCheck$1(this, FwcModalSlideComponent);
    _this74 = _super57.call(this);
    _this74.open = false;
    _this74.full = false;
    _this74.callerId = null; // TODO: Remove
    _this74.direction = 'left';
    _this74.refocusElem = null;
    _this74.validDirections = ['left', 'right', 'top', 'bottom'];
    _this74.openByAttribute = false;
    _this74.labelAriaCloseBtn = 'Close Modal';
    _this74.preventOpenBySlotChange = false;
    return _this74;
  }
  _createClass$1(FwcModalSlideComponent, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      var _this75 = this;
      var modal = this.shadowRoot.querySelector('.fwc-modal-wrapper');

      // if an invalid direction is passed
      if (!this.validDirections.includes(this.direction)) {
        this.direction = 'left';
      }

      // set event listener to init focus trap after transition ends
      modal.addEventListener('transitionend', function (e) {
        if (_this75.open && e.propertyName !== 'opacity') {
          focusTrap(_this75);
        }
      });
      modal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          _this75._onClosePress();
        }
      });
    }
  }, {
    key: "updated",
    value: function updated(changedProperties) {
      var _this76 = this;
      changedProperties.forEach(function (oldValue, propName) {
        if (propName === 'openByAttribute') {
          _this76.preventOpenBySlotChange = _this76.openByAttribute;
        }
        if (propName === 'open') {
          _this76._toggleBodyScrollClass(oldValue !== undefined ? !oldValue : false);
        }
      });
    }
  }, {
    key: "_onSlotChange",
    value: function _onSlotChange() {
      var slot = this.shadowRoot.querySelector('slot');
      var slotNodes = slot.assignedNodes();

      // do not close the modal if slotted content updates, only if it is empty/removed
      if (this.open && slotNodes.length > 0) {
        return;
      }
      if (!this.preventOpenBySlotChange) {
        this._toggleModal();
      }
    }
  }, {
    key: "_toggleModal",
    value: function _toggleModal() {
      this.open = !this.open;
      this._refocusElem();
    }
  }, {
    key: "_toggleBodyScrollClass",
    value: function _toggleBodyScrollClass(isOpen) {
      if (isOpen) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    }
  }, {
    key: "_onClosePress",
    value: function _onClosePress() {
      var event = new CustomEvent('fwc-modal-close', {
        detail: this,
        bubbles: true
      });
      this.dispatchEvent(event);
      this._closeModal();
    }
  }, {
    key: "_closeModal",
    value: function _closeModal() {
      if (this.preventOpenBySlotChange) {
        this.open = false;
        this.removeAttribute('open');
        this._refocusElem();
        return;
      }
      if (this.open) {
        var slot = this.shadowRoot.querySelector('slot');
        var nodes = slot.assignedNodes();
        // remove everything inside the slot
        nodes.forEach(function (n) {
          n.parentNode.removeChild(n);
        });
      }
    }
  }, {
    key: "closeSlideModal",
    value: function closeSlideModal() {
      this._closeModal();
    }
  }, {
    key: "_refocusElem",
    value: function _refocusElem() {
      var _this77 = this;
      if (!this.open && this.refocusElem) {
        // Return focus to calling element
        setTimeout(function () {
          _this77.refocusElem.focus();
        }, 0);
      }
    }
  }, {
    key: "setReFocus",
    value: function setReFocus(elem) {
      this.refocusElem = elem;
    }
  }, {
    key: "resetModalFocusTrap",
    value: function resetModalFocusTrap() {
      resetFocusTrap();
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject135 || (_templateObject135 = _taggedTemplateLiteral(["\n      <div\n        class=\"fwc-modal-wrapper ", "\"\n        role=\"dialog\"\n        aria-modal=\"", "\"\n        aria-label=\"", "\"\n      >\n        <div class=\"fwc-modal-bg\"></div>\n        <div\n          class=\"fwc-modal-container ", " ", "\"\n        >\n          <button\n            type=\"button\"\n            class=\"fwc-modal-close\"\n            aria-label=\"", "\"\n            @click=\"", "\"\n          >\n            <svg\n              xmlns=\"http://www.w3.org/2000/svg\"\n              width=\"21\"\n              height=\"21\"\n              viewBox=\"0 0 50 50\"\n              focusable=\"false\"\n            >\n              <polygon\n                points=\"19.216 44.562 1.438 26.784 0 25.281 1.438 23.778 19.216 6 22.222 9.007 8.039 23.19 50 23.19 50 27.373 8.039 27.373 22.222 41.556\"\n              />\n            </svg>\n          </button>\n          <slot @slotchange=\"", "\"></slot>\n        </div>\n      </div>\n    "])), this.open ? 'open' : '', this.open, this.labelAriaModalHeader, this.direction, this.full ? 'full' : '', this.labelAriaCloseBtn, this._onClosePress, this._onSlotChange);
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject136 || (_templateObject136 = _taggedTemplateLiteral(["\n        .fwc-modal-wrapper {\n          position: fixed;\n          top: 0;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          z-index: 9999;\n          pointer-events: none;\n          width: 100%;\n          visibility: hidden;\n        }\n        .fwc-modal-wrapper.open {\n          pointer-events: all;\n          visibility: visible;\n        }\n        .fwc-modal-bg {\n          position: absolute;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n          background: rgba(var(--color-rgb-util-four), 0.9);\n          transition: opacity 250ms ease;\n          opacity: 0;\n          visibility: hidden;\n        }\n        .fwc-modal-wrapper.open .fwc-modal-bg {\n          opacity: 1;\n          visibility: visible;\n        }\n        .fwc-modal-container {\n          background: var(--color-white);\n          border: 1px solid var(--color-white);\n          width: 60%;\n          height: 100%;\n          position: absolute;\n          opacity: 0;\n          transition: all 350ms cubic-bezier(0.55, 0.085, 0.68, 0.53);\n          font-size: var(--default-font-size);\n          padding-top: calc(\n            9 * var(--fwcu)\n          ); /* 7.5height + 1.5top of close btn */\n          overflow-x: hidden;\n          overflow-y: auto;\n          -webkit-overflow-scrolling: touch;\n        }\n\n        .fwc-modal-container.open {\n          transition: all 350ms cubic-bezier(0.25, 0.46, 0.45, 0.94);\n        }\n\n        .fwc-modal-container.left {\n          left: -100%;\n          border-top-right-radius: var(--border-radius);\n          border-bottom-right-radius: var(--border-radius);\n        }\n        .fwc-modal-container.right {\n          right: -100%;\n          border-top-left-radius: var(--border-radius);\n          border-bottom-left-radius: var(--border-radius);\n        }\n        .fwc-modal-container.top {\n          top: -100%;\n          left: 0;\n          width: 100%;\n          height: 60%;\n          border-bottom-left-radius: var(--border-radius);\n          border-bottom-right-radius: var(--border-radius);\n        }\n        .fwc-modal-container.bottom {\n          bottom: -100%;\n          left: 0;\n          width: 100%;\n          height: 60%;\n          border-top-left-radius: var(--border-radius);\n          border-top-right-radius: var(--border-radius);\n        }\n        .fwc-modal-container.bottom.full,\n        .fwc-modal-container.top.full {\n          height: 100%;\n          border-radius: none;\n        }\n        .open .fwc-modal-container {\n          opacity: 1;\n        }\n        .open .fwc-modal-container.left {\n          left: 0%;\n        }\n        .open .fwc-modal-container.right {\n          right: 0%;\n        }\n        .open .fwc-modal-container.top {\n          top: 0%;\n        }\n        .open .fwc-modal-container.bottom {\n          bottom: 0%;\n        }\n\n        .fwc-modal-close {\n          background: var(--color-gray-five);\n          border: none;\n          cursor: pointer;\n          position: absolute;\n          top: calc(1.5 * var(--fwcu));\n          padding: calc(0.75 * var(--fwcu));\n          width: calc(7.5 * var(--fwcu));\n          height: calc(7.5 * var(--fwcu));\n          border-radius: var(--border-radius);\n        }\n\n        .fwc-modal-close svg {\n          fill: var(--color-primary);\n        }\n\n        .left .fwc-modal-close {\n          right: calc(1.5 * var(--fwcu));\n        }\n        .right .fwc-modal-close {\n          left: calc(1.5 * var(--fwcu));\n          transform: rotate(180deg);\n        }\n        .top .fwc-modal-close {\n          right: calc(1.5 * var(--fwcu));\n          transform: rotate(90deg);\n        }\n        .bottom .fwc-modal-close {\n          right: calc(1.5 * var(--fwcu));\n          transform: rotate(-90deg);\n        }\n\n        @media screen and (max-width: 900px) {\n          .fwc-modal-container.left,\n          .fwc-modal-container.right {\n            width: 95%;\n          }\n          .fwc-modal-container.top,\n          .fwc-modal-container.bottom {\n            height: 95%;\n          }\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        open: {
          type: Boolean
        },
        direction: {
          type: String
        },
        full: {
          type: Boolean
        },
        openByAttribute: {
          attribute: 'open-by-attribute',
          type: Boolean
        },
        labelAriaCloseBtn: {
          attribute: 'label-aria-close-button',
          type: String
        },
        labelAriaModalHeader: {
          attribute: 'label-aria-modal-header',
          type: String
        }
      };
    }
  }]);
  return FwcModalSlideComponent;
}(LitElement);
var FwcModalSlide = /*#__PURE__*/function (_FwcBase25) {
  _inherits$1(FwcModalSlide, _FwcBase25);
  var _super58 = _createSuper$8(FwcModalSlide);
  function FwcModalSlide() {
    _classCallCheck$1(this, FwcModalSlide);
    return _super58.call(this, 'fwc-modal-slide', FwcModalSlideComponent);
  }
  return _createClass$1(FwcModalSlide);
}(FwcBase$1);
var FwcModalBaseComponent = /*#__PURE__*/function (_LitElement36) {
  _inherits$1(FwcModalBaseComponent, _LitElement36);
  var _super63 = _createSuper$8(FwcModalBaseComponent);
  function FwcModalBaseComponent() {
    var _this82;
    _classCallCheck$1(this, FwcModalBaseComponent);
    _this82 = _super63.call(this);
    _this82._open = false;
    _this82._dispatchOpenName = 'fwc-modal-open';
    _this82._dispatchCloseName = 'fwc-modal-close';
    _this82.labelAria = '';
    _this82.disableBackdrop = 'false';
    _this82.disableEscapeKey = 'false';
    return _this82;
  }
  _createClass$1(FwcModalBaseComponent, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      var _this83 = this;
      // set event listener to dispatch event back to parent
      var modal = this.shadowRoot.querySelector('.fwc-modal-wrapper');
      modal.addEventListener('transitionend', function (e) {
        if (_this83._open && e.propertyName === 'opacity') {
          _this83._dispatch(_this83._dispatchOpenName);
        }
        if (!_this83._open && e.propertyName === 'opacity') {
          _this83._dispatch(_this83._dispatchCloseName);
        }
      });

      // handle background click close
      this.addEventListener('keydown', function (e) {
        return _this83._escapeClose(e);
      });
    }
  }, {
    key: "_escapeClose",
    value: function _escapeClose(e) {
      if (this.disableEscapeKey !== 'true' && (e.key === 'Escape' || e.key === 'Esc')) {
        this._closeModal();
      }
    }
  }, {
    key: "_dispatch",
    value: function _dispatch(name) {
      var event = new CustomEvent(name, {
        detail: this,
        bubbles: true,
        composed: true
      });
      this.dispatchEvent(event);
    }
  }, {
    key: "_onBackgroundPress",
    value: function _onBackgroundPress() {
      if (this.disableBackdrop !== 'true') {
        this._closeModal();
      }
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this._openModal();
    }
  }, {
    key: "_openModal",
    value: function _openModal() {
      var _this84 = this;
      setTimeout(function () {
        _this84._open = true;
        document.body.classList.add('no-scroll');
      }, 0);
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this._closeModal();
    }
  }, {
    key: "_closeModal",
    value: function _closeModal() {
      this._open = false;
      document.body.classList.remove('no-scroll');
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject144 || (_templateObject144 = _taggedTemplateLiteral(["\n      <div\n        class=\"fwc-modal-wrapper ", "\"\n        aria-modal=\"", "\"\n        role=\"dialog\"\n        aria-label=\"", "\"\n      >\n        <div class=\"fwc-modal-bg\" @click=\"", "\"></div>\n        <div class=\"fwc-modal-container\">\n          <slot></slot>\n        </div>\n      </div>\n    "])), this._open ? 'open' : '', this._open, this.labelAria, this._onBackgroundPress);
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject145 || (_templateObject145 = _taggedTemplateLiteral(["\n        .fwc-modal-wrapper {\n          position: fixed;\n          top: 0;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          align-items: center;\n          justify-content: center;\n          z-index: 9999;\n          pointer-events: none;\n          display: flex;\n          visibility: hidden;\n          transition: all 300ms ease;\n        }\n        .fwc-modal-wrapper.open {\n          pointer-events: all;\n          visibility: visible;\n        }\n        .fwc-modal-bg {\n          position: absolute;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n          background: rgba(var(--color-rgb-black), 0.6);\n          transition: opacity 300ms ease;\n          opacity: 0;\n          visibility: hidden;\n        }\n        .fwc-modal-wrapper.open .fwc-modal-bg {\n          opacity: 1;\n          visibility: visible;\n        }\n        .fwc-modal-container {\n          background: var(--color-white);\n          position: relative;\n          opacity: 0;\n          border-radius: var(--border-radius);\n          box-shadow: var(--box-shadow);\n          animation: fwcClose 0.3s ease-in-out forwards;\n          overflow: hidden;\n        }\n        .fwc-modal-wrapper.open .fwc-modal-container {\n          animation: fwcOpen 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55)\n            forwards;\n          opacity: 1;\n        }\n        @-webkit-keyframes fwcOpen {\n          0% {\n            transform: scale(0);\n            opacity: 0;\n          }\n          100% {\n            transform: scale(1);\n            opacity: 1;\n          }\n        }\n        @-webkit-keyframes fwcClose {\n          0% {\n            transform: scale(1);\n            opacity: 1;\n          }\n          100% {\n            transform: scale(0);\n            opacity: 0;\n          }\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        _open: {
          type: Boolean
        },
        labelAria: {
          attribute: 'label-aria',
          type: String
        },
        disableBackdrop: {
          attribute: 'disable-backdrop',
          type: String
        },
        disableEscapeKey: {
          attribute: 'disable-escape-key',
          type: String
        }
      };
    }
  }]);
  return FwcModalBaseComponent;
}(LitElement);
var FwcModalBase = /*#__PURE__*/function (_FwcBase28) {
  _inherits$1(FwcModalBase, _FwcBase28);
  var _super64 = _createSuper$8(FwcModalBase);
  function FwcModalBase() {
    _classCallCheck$1(this, FwcModalBase);
    return _super64.call(this, 'fwc-modal-base', FwcModalBaseComponent);
  }
  return _createClass$1(FwcModalBase);
}(FwcBase$1);
var FwcModalComponent = /*#__PURE__*/function (_LitElement37) {
  _inherits$1(FwcModalComponent, _LitElement37);
  var _super65 = _createSuper$8(FwcModalComponent);
  function FwcModalComponent() {
    var _this85;
    _classCallCheck$1(this, FwcModalComponent);
    _this85 = _super65.call(this);
    _this85.config = fwcConfig$1;
    _this85._fwcModalBase = new FwcModalBase();
    _this85._fwcModalBase.build();
    _this85._modalBaseElement = null;
    _this85.open = false;
    _this85.textHeader = '';
    _this85.textBody = '';
    _this85.refocusElem = null;
    _this85.openBySlot = false;
    _this85.labelAriaCloseBtn = 'Close Modal';
    _this85.disableBackdrop = 'false';
    _this85.disableEscapeKey = 'false';
    _this85._bodySlotChildren = 0;
    _this85._actionsSlotChildren = 0;
    return _this85;
  }
  _createClass$1(FwcModalComponent, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      var _this86 = this;
      this._modalBaseElement = this.shadowRoot.querySelector('fwc-modal-base');

      // grab the open/close event from fwc-modal-base and remove the slot items
      this.addEventListener('fwc-modal-open', function () {
        setTimeout(function () {
          focusTrap(_this86);
        }, 0);
      });
      this.addEventListener('fwc-modal-close', function () {
        if (_this86.openBySlot) {
          setTimeout(function () {
            var slot = _this86.shadowRoot.querySelector('slot');
            var nodes = slot.assignedNodes();
            if (nodes.length) {
              nodes.forEach(function (n) {
                n.parentNode.removeChild(n);
              });
            }
          }, 0);
        } else {
          _this86.removeAttribute('open');
        }
        setTimeout(function () {
          _this86._returnFocus();
        }, 0);
      });
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldVal, newVal) {
      var _this87 = this;
      if (name === 'open') {
        setTimeout(function () {
          if (_this87.open) {
            _this87._open();
          } else {
            _this87._close();
          }
        }, 0);
      }
      _get(_getPrototypeOf(FwcModalComponent.prototype), "attributeChangedCallback", this).call(this, name, oldVal, newVal);
    }
  }, {
    key: "_onSlotChange",
    value: function _onSlotChange() {
      var bodySlot = this.shadowRoot.querySelector('slot[name="body"]');
      var bodySlotNodes = bodySlot.assignedNodes();
      var actionsSlot = this.shadowRoot.querySelector('slot[name="actions"]');
      var actionsSlotNodes = actionsSlot.assignedNodes();
      this._bodySlotChildren = bodySlotNodes.length;
      this._actionsSlotChildren = actionsSlotNodes.length;

      // do not do anything on slotchange when opening by attribute
      if (!this.openBySlot) return;
      if (bodySlotNodes.length) {
        this._open();
      } else {
        this._close();
      }
    }
  }, {
    key: "_returnFocus",
    value: function _returnFocus() {
      if (this._refocusElem) {
        // Return focus to calling element
        this._refocusElem.focus();
      }
    }

    // a public func allowing projects to set the refocus element
  }, {
    key: "setReFocus",
    value: function setReFocus(elem) {
      this._refocusElem = elem;
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this._modalBaseElement.closeModal();
    }
  }, {
    key: "_close",
    value: function _close() {
      this.closeModal();
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this._modalBaseElement.openModal();
    }
  }, {
    key: "_open",
    value: function _open() {
      this.openModal();
    }
  }, {
    key: "resetModalFocusTrap",
    value: function resetModalFocusTrap() {
      resetFocusTrap();
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject146 || (_templateObject146 = _taggedTemplateLiteral(["\n      <link\n        rel=\"stylesheet\"\n        href=\"", "fwc-assets/styles/typography.css\"\n      />\n      <fwc-modal-base\n        disable-backdrop=\"", "\"\n        disable-escape-key=\"", "\"\n        label-aria=\"", "\"\n      >\n        <div class=\"fwc-modal-wrapper\">\n          <div class=\"fwc-modal-header\">\n            <h3 id=\"modalHeader\">", "</h3>\n            <button\n              type=\"button\"\n              class=\"fwc-modal-close\"\n              aria-label=\"", "\"\n              @click=\"", "\"\n            >\n              <svg\n                xmlns=\"http://www.w3.org/2000/svg\"\n                width=\"20\"\n                height=\"20\"\n                viewBox=\"0 0 50 50\"\n              >\n                <polygon\n                  points=\"3.523 50 0 46.477 21.477 25 0 3.523 3.523 0 25 21.477 46.477 0 50 3.523 28.523 25 50 46.477 46.477 50 25 28.523\"\n                />\n              </svg>\n            </button>\n          </div>\n\n          <div class=\"fwc-modal-body\">\n            <div class=\"", "\">\n              ", "\n            </div>\n            <slot name=\"body\" @slotchange=\"", "\"></slot>\n          </div>\n\n          <div\n            class=\"fwc-modal-actions ", "\"\n          >\n            <slot name=\"actions\" @slotchange=\"", "\"></slot>\n          </div>\n        </div>\n      </fwc-modal-base>\n    "])), this.config.assetsPath, this.disableBackdrop, this.disableEscapeKey, this.textHeader, this.textHeader, this.labelAriaCloseBtn, this._close, this._bodySlotChildren > 0 ? 'fwc-hide' : '', this.textBody, this._onSlotChange, this._actionsSlotChildren > 0 ? '' : 'fwc-hide', this._onSlotChange);
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject147 || (_templateObject147 = _taggedTemplateLiteral(["\n        .fwc-modal-wrapper {\n          width: 92vw;\n          max-width: calc(100 * var(--fwcu));\n        }\n        .fwc-modal-header {\n          background: linear-gradient(\n            180deg,\n            var(--color-white) 0%,\n            var(--color-gray-five) 100%\n          );\n          padding: calc(4 * var(--fwcu));\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          padding: calc(4 * var(--fwcu));\n          border-radius: var(--border-radius) var(--border-radius) 0 0;\n        }\n        h3 {\n          color: var(--color-gray-one);\n          margin: 0;\n          margin-right: calc(3 * var(--fwcu));\n        }\n        .fwc-modal-close {\n          background: transparent;\n          border: none;\n          cursor: pointer;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          padding: 0;\n          width: calc(3 * var(--fwcu));\n          height: calc(3 * var(--fwcu));\n        }\n        .fwc-modal-close svg {\n          fill: var(--color-gray-two);\n        }\n        .fwc-modal-body {\n          padding: calc(3 * var(--fwcu)) calc(4 * var(--fwcu)) 0\n            calc(4 * var(--fwcu));\n        }\n        .fwc-modal-actions {\n          display: flex;\n          justify-content: flex-end;\n          padding: calc(4 * var(--fwcu));\n        }\n        .fwc-hide {\n          display: none;\n        }\n        @media screen and (max-width: 600px) {\n          ::slotted([slot='actions']) {\n            display: flex;\n            justify-content: space-between;\n            width: 100%;\n          }\n          .fwc-modal-header {\n            align-items: flex-start;\n          }\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        config: {
          type: Object
        },
        open: {
          type: Boolean
        },
        textHeader: {
          attribute: 'text-header',
          type: String
        },
        textBody: {
          attribute: 'text-body',
          type: String
        },
        openBySlot: {
          attribute: 'open-by-slot',
          type: Boolean
        },
        labelAriaCloseBtn: {
          attribute: 'label-aria-close-btn',
          type: String
        },
        disableBackdrop: {
          attribute: 'disable-backdrop',
          type: String
        },
        disableEscapeKey: {
          attribute: 'disable-escape-key',
          type: String
        },
        // below are props added for watch/update, they are not an option to pass as attributes
        _bodySlotChildren: {
          type: Number
        },
        _actionsSlotChildren: {
          type: Number
        }
      };
    }
  }]);
  return FwcModalComponent;
}(LitElement);
var FwcModal = /*#__PURE__*/function (_FwcBase29) {
  _inherits$1(FwcModal, _FwcBase29);
  var _super66 = _createSuper$8(FwcModal);
  function FwcModal() {
    _classCallCheck$1(this, FwcModal);
    return _super66.call(this, 'fwc-modal', FwcModalComponent);
  }
  return _createClass$1(FwcModal);
}(FwcBase$1);
var FwcPaginationComponent = /*#__PURE__*/function (_LitElement40) {
  _inherits$1(FwcPaginationComponent, _LitElement40);
  var _super71 = _createSuper$8(FwcPaginationComponent);
  function FwcPaginationComponent() {
    var _this96;
    _classCallCheck$1(this, FwcPaginationComponent);
    _this96 = _super71.call(this);
    _this96.alignment = 'left';
    _this96.model = null;
    _this96.ariaLabels = {
      navLabel: 'Pagination',
      nextPageLabel: 'Next Page',
      prevPageLabel: 'Previous Page'
    };
    _this96.labelAriaNav = 'Pagination';
    _this96.labelAriaNext = 'Next Page';
    _this96.labelAriaPrev = 'Previous Page';
    _this96._viewMax = 5;
    _this96._viewMaxMobile = 3;
    _this96._startPage = 0;
    _this96._endPage = 5;
    _this96._pages = [];
    _this96._showNextBtn = true;
    _this96._showNextEllipsis = false;
    _this96._showPrevEllipsis = false;
    _this96._linkStart = 0;
    _this96._linkEnd = 0;
    _this96._totalPages = 0;
    _this96._mobileFlag = false;
    _this96._resizeObserver = null;
    return _this96;
  }
  _createClass$1(FwcPaginationComponent, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      // 508 keyboard, set active page
      this.shadowRoot.addEventListener('keydown', function (e) {
        var _this97 = this;
        var isArrowBtn = e.target.classList.contains('fwc-next') || e.target.classList.contains('fwc-prev');
        if (e.key === 'Enter' && !isArrowBtn) {
          // wait for dom to update
          setTimeout(function () {
            var host = _this97.getRootNode().host;
            host._setFocusOnCurrentElement();
          }, 100);
        }
      });
      this._screenResize();
      this._initPager();
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldVal, newVal) {
      _get(_getPrototypeOf(FwcPaginationComponent.prototype), "attributeChangedCallback", this).call(this, name, oldVal, newVal);
      if (name === 'model' && oldVal) {
        this._initPager();
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this._resizeObserver.disconnect();
      _get(_getPrototypeOf(FwcPaginationComponent.prototype), "disconnectedCallback", this).call(this);
    }
  }, {
    key: "_screenResize",
    value: function _screenResize() {
      var _this98 = this;
      this._resizeObserver = new ResizeObserver(function (entries) {
        if (entries[0].contentRect.width <= 600) {
          _this98._mobileFlag = true;
        } else {
          _this98._mobileFlag = false;
        }
        _this98._initPager();
      });
      this._resizeObserver.observe(document.querySelector('html'));
    }
  }, {
    key: "_initPager",
    value: function _initPager() {
      this._totalPages = this.model.totalPages;
      this._linkStart = this._startPage;
      this._linkEnd = this._totalPages > this._endPage ? this._endPage : this._totalPages;
      this._pages = [];
      for (var i = 0; i < this._totalPages; i++) {
        this._pages.push({
          id: i + 1
        });
      }
      this._slicer(this.model.activePage, false);
      this._updateNavButtons();
    }
  }, {
    key: "_thisPage",
    value: function _thisPage(page) {
      this._slicer(page.id, true, true);
    }
  }, {
    key: "_prevPage",
    value: function _prevPage() {
      if (this.model.activePage) {
        this._slicer(this.model.activePage - 1, true, false);
        // 508, reset focus to first item when prev arrow is hidden
        if (this.model.activePage === 1) {
          var btns = this.shadowRoot.querySelectorAll('.fwc-page-num');
          var first = btns[1];
          first.focus();
        }
      }
    }
  }, {
    key: "_nextPage",
    value: function _nextPage() {
      if (this.model.activePage) {
        this._slicer(this.model.activePage + 1, true, false);
        // 508, reset focus to last item when next arrow is hidden
        if (this.model.activePage === this._pages.length) {
          var btns = this.shadowRoot.querySelectorAll('.fwc-page-num');
          var last = btns[btns.length - 2];
          last.focus();
        }
      }
    }
  }, {
    key: "_getNextEllipsisStatus",
    value: function _getNextEllipsisStatus() {
      return this._linkEnd < this.model.totalPages;
    }
  }, {
    key: "_getPrevEllipsisStatus",
    value: function _getPrevEllipsisStatus(page) {
      if (!this._mobileFlag) {
        return page > 3 && this.model.totalPages > 5;
      }
      return page > 2 && this.model.totalPages > 5;
    }
  }, {
    key: "_getNextBtnStatus",
    value: function _getNextBtnStatus(page) {
      return page === this._pages.length ? false : true;
    }
  }, {
    key: "_updateNavButtons",
    value: function _updateNavButtons() {
      this._showNextBtn = this._getNextBtnStatus(this.model.activePage);
      this._showNextEllipsis = this._getNextEllipsisStatus();
      this._showPrevEllipsis = this._getPrevEllipsisStatus(this.model.activePage);
    }
  }, {
    key: "_slicer",
    value: function _slicer(next, emit, focus) {
      var _this99 = this;
      var half = Math.ceil(this._viewMax / 2);
      var pen = this._pages.length - 1;
      if (this._mobileFlag) {
        if (next >= 3) {
          this._linkStart = next - 2;
          this._linkEnd = next + 1;
          if (next >= this._pages.length) {
            this._linkStart = next - 3;
            this._linkEnd = next + 1;
          }
        } else {
          this._linkStart = 0;
          this._linkEnd = 3;
        }
      } else {
        // Keeps active page centered when half point is reached
        if (next >= half && next < pen) {
          this._linkStart = next - half;
          this._linkEnd = next + (half - 1);
        }
        // last
        if (next >= pen) {
          // console.log('this._pages.length', this._pages.length)
          // console.log('this._viewMax', this._viewMax)
          this._linkStart = this._pages.length - this._viewMax;
          this._linkEnd = this._pages.length;
        }
        //first
        if (next < this._viewMax && next < half) {
          this._linkStart = 0;
          this._linkEnd = this._viewMax;
        }
      }
      this.model.activePage = next;
      // trigger update on model
      this.model = _objectSpread$d({}, this.model);
      if (emit) {
        this._emitEvent(this.model);
      }
      if (focus) {
        setTimeout(function () {
          _this99._setFocusOnCurrentElement();
        }, 0);
      }
      this._updateNavButtons();
    }
  }, {
    key: "_setFocusOnCurrentElement",
    value: function _setFocusOnCurrentElement() {
      var page = this.shadowRoot.querySelector('.fwc-page-num.active');
      page.focus();
    }
  }, {
    key: "_emitEvent",
    value: function _emitEvent(model) {
      var event = new CustomEvent('fwc-pagination-update', {
        detail: model,
        bubbles: true
      });
      this.dispatchEvent(event);
    }
  }, {
    key: "render",
    value: function render() {
      var _this100 = this;
      return html(_templateObject152 || (_templateObject152 = _taggedTemplateLiteral(["\n      <nav\n        class=\"fwc-pagination fwc-page-align-", "\"\n        id=\"er-pagination-testing\"\n        role=\"navigation\"\n        aria-label=\"", "\"\n      >\n        <button\n          class=\"fwc-page-icon fwc-page-item fwc-prev\"\n          @click=\"", "\"\n          style=\"", "\"\n          aria-hidden=\"", "\"\n          aria-label=\"", "\"\n        >\n          <svg\n            xmlns=\"http://www.w3.org/2000/svg\"\n            width=\"20\"\n            height=\"20\"\n            viewBox=\"0 0 50 50\"\n            focusable=\"false\"\n          >\n            <polygon\n              points=\"2.719 39.66 0 36.941 23.641 13.3 25 12 26.359 13.3 50 36.941 47.281 39.66 25 17.378\"\n              transform=\"matrix(1 0 0 -1 0 51.66)\"\n            />\n          </svg>\n        </button>\n\n        <button\n          aria-label=\"go to page ", "\"\n          class=\"fwc-page-num fwc-page-item ", "\"\n          @click=\"", "\"\n        >\n          <span>", "</span>\n        </button>\n\n        <span\n          class=\"fwc-ellipsis fwc-page-item ", "\"\n          >...</span\n        >\n\n        ", "\n\n        <span\n          class=\"fwc-ellipsis fwc-page-item ", "\"\n          >...</span\n        >\n\n        <button\n          aria-label=\"go to page ", "\"\n          class=\"fwc-page-num fwc-page-item ", "\"\n          @click=\"", "\"\n        >\n          <span\n            >", "</span\n          >\n        </button>\n\n        <button\n          class=\"fwc-page-icon fwc-page-item fwc-next\"\n          @click=\"", "\"\n          style=\"", "\"\n          aria-hidden=\"", "\"\n          aria-label=\"", "\"\n        >\n          <svg\n            xmlns=\"http://www.w3.org/2000/svg\"\n            width=\"20\"\n            height=\"20\"\n            viewBox=\"0 0 50 50\"\n          >\n            <polygon\n              points=\"2.719 39.66 0 36.941 23.641 13.3 25 12 26.359 13.3 50 36.941 47.281 39.66 25 17.378\"\n              transform=\"matrix(1 0 0 -1 0 51.66)\"\n            />\n          </svg>\n        </button>\n      </nav>\n    "])), this.alignment, this.labelAriaNav, this._prevPage, this.model.activePage <= 1 ? 'visibility: hidden' : 'visibility: visible', this.model.activePage <= 1 ? true : false, this.labelAriaPrev, this._pages.length ? this._pages[0].id : '', this._showPrevEllipsis ? '' : 'hide', function () {
        return _this100._thisPage(_this100._pages[0]);
      }, this._pages.length ? this._pages[0].id : '', this._showPrevEllipsis ? '' : 'hide', this._pages.filter(function (page) {
        return _this100._linkStart < page.id && _this100._linkEnd >= page.id;
      }).map(function (page) {
        return html(_templateObject153 || (_templateObject153 = _taggedTemplateLiteral(["\n              <button\n                aria-label=\"go to page ", "\"\n                class=\"fwc-page-num fwc-page-item ", "\"\n                @click=\"", "\"\n                aria-current=", "\n              >\n                <span>", "</span>\n              </button>\n            "])), page.id, page.id === _this100.model.activePage ? 'active' : '', function () {
          return _this100._thisPage(page);
        }, page.id === _this100.model.activePage ? 'page' : false, page.id);
      }), this._showNextEllipsis ? '' : 'hide', this._pages.length ? this._pages[this._pages.length - 1].id : '', this._showNextEllipsis ? '' : 'hide', function () {
        return _this100._thisPage(_this100._pages[_this100._pages.length - 1]);
      }, this._pages.length ? this._pages[this._pages.length - 1].id : '', this._nextPage, this._showNextBtn && this._pages.length > 0 ? 'visibility: visible' : 'visibility: hidden', this._showNextBtn && this._pages.length > 0 ? false : true, this.labelAriaNext);
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject154 || (_templateObject154 = _taggedTemplateLiteral(["\n        .fwc-pagination {\n          display: flex;\n          flex-wrap: nowrap;\n        }\n        .fwc-page-align-center {\n          justify-content: flex-start;\n        }\n        .fwc-page-align-center {\n          justify-content: center;\n        }\n        .fwc-page-align-right {\n          justify-content: flex-end;\n        }\n        .fwc-page-item:nth-child(2),\n        .fwc-page-item:nth-last-child(2) {\n          background-color: transparent;\n          border-radius: initial;\n          border: 3px solid var(--color-gray-five);\n        }\n        @media screen and (max-width: 600px) {\n          span.fwc-ellipsis {\n            display: none;\n          }\n        }\n        .fwc-page-item {\n          flex: 0 0 auto;\n          width: calc(4.75 * var(--fwcu));\n          height: calc(4.75 * var(--fwcu));\n          padding: var(--fwcu);\n          margin-right: var(--fwcu);\n          border-radius: 50%;\n          text-decoration: none;\n          font-size: var(--default-font-size);\n        }\n        .fwc-page-num {\n          background: var(--color-gray-five);\n          text-decoration: none;\n          font-weight: 700;\n          border: none;\n        }\n        .fwc-page-num.active {\n          background: var(--color-primary);\n        }\n        @media only screen and (hover: hover) {\n          .fwc-page-num:hover {\n            background: var(--color-primary);\n          }\n          .fwc-page-num:hover > span {\n            color: var(--color-white);\n          }\n        }\n\n        .fwc-page-num > span {\n          color: var(--color-primary);\n        }\n        .fwc-page-num.active > span {\n          color: var(--color-white);\n        }\n\n        .fwc-page-icon {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          text-decoration: none;\n          background: none;\n          border: none;\n        }\n        .fwc-page-icon svg {\n          fill: var(--color-primary);\n        }\n        .fwc-prev {\n          margin-right: var(--fwcu);\n          margin-left: 0;\n          transform: rotate(90deg);\n        }\n        .fwc-next {\n          transform: rotate(-90deg);\n        }\n\n        .fwc-ellipsis {\n          display: flex;\n          justify-content: center;\n        }\n        .fwc-ellipsis span {\n          align-self: flex-end;\n        }\n        .hide {\n          display: none;\n          visibility: hidden;\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        alignment: {
          type: String
        },
        // left | center | right
        model: {
          type: Object
        },
        labelAriaNav: {
          attribute: 'label-aria-nav',
          type: String
        },
        labelAriaNext: {
          attribute: 'label-aria-next',
          type: String
        },
        labelAriaPrev: {
          attribute: 'label-aria-prev',
          type: String
        },
        _pages: {
          type: Array
        },
        _showPrevEllipsis: {},
        _showNextEllipsis: {},
        _showNextBtn: {},
        _linkStart: {
          type: Number
        },
        _linkEnd: {
          type: Number
        },
        _startPage: {
          type: Number
        },
        _endPage: {
          type: Number
        }
      };
    }
  }]);
  return FwcPaginationComponent;
}(LitElement);
var FwcPagination = /*#__PURE__*/function (_FwcBase32) {
  _inherits$1(FwcPagination, _FwcBase32);
  var _super72 = _createSuper$8(FwcPagination);
  function FwcPagination() {
    _classCallCheck$1(this, FwcPagination);
    return _super72.call(this, 'fwc-pagination', FwcPaginationComponent);
  }
  return _createClass$1(FwcPagination);
}(FwcBase$1);
var FwcPanelComponent = /*#__PURE__*/function (_LitElement41) {
  _inherits$1(FwcPanelComponent, _LitElement41);
  var _super73 = _createSuper$8(FwcPanelComponent);
  function FwcPanelComponent() {
    var _this101;
    _classCallCheck$1(this, FwcPanelComponent);
    _this101 = _super73.call(this);
    _this101.config = fwcConfig$1;
    _this101.labelMobileHeader = '';
    _this101.mobileView = new MobileView();
    _this101.mobileView.build();
    _this101.open = false;
    _this101.labelApplyBtn = 'Okay';
    _this101.labelCancelBtn = 'Cancel';
    _this101.labelResetBtn = 'Reset';
    _this101.reduceIndex = false;
    _this101.returnEl = null;
    _this101.hideFooter = false;
    return _this101;
  }
  _createClass$1(FwcPanelComponent, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      var _this102 = this;
      var panel = this.shadowRoot.querySelector('#Panel');
      panel.addEventListener('transitionend', function (e) {
        // set the focus trap inside the panel after open
        if (_this102.open && e.propertyName === 'opacity') {
          var ignoredFocusTrapSelectors = window.innerWidth <= breakpoints$1.sm ? ['.fwc-link-icon.hide-sm', '.fwc-panel-footer button'] : ['.fwc-link-icon.hide-lg', '.mobile-footer button'];
          setTimeout(function () {
            focusTrapCustomTabs(_this102, ignoredFocusTrapSelectors);
          }, 0);
        }
        // set the focus back to the open button on panel close
        if (!_this102.open && e.propertyName === 'opacity') {
          removeFocusTrapListener(_this102);
          _this102._returnFocus();
        }
      });

      // listen for Escape keydown
      this.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          _this102._closePanel();
        }
      });
      this.hideFooter = this._hideFooter();
    }
  }, {
    key: "_hideFooter",
    value: function _hideFooter() {
      return this.hideResetBtn && this.hideApplyBtn && this.hideCancelBtn;
    }
  }, {
    key: "setReturnEl",
    value: function setReturnEl(el) {
      this.returnEl = el;
    }
  }, {
    key: "togglePanel",
    value: function togglePanel() {
      var _this103 = this;
      this.open = !this.open;
      this._dispatchToggled();
      this._toggleBodyScrollClass();
      setTimeout(function () {
        _this103._setPanelPosition();
      }, 0);
    }
  }, {
    key: "_closePanel",
    value: function _closePanel() {
      this.open = false;
      this._toggleBodyScrollClass();
      this._returnFocus();
      this._clearPanelPosition();
    }
  }, {
    key: "_toggleBodyScrollClass",
    value: function _toggleBodyScrollClass() {
      if (this.open && window.innerWidth <= breakpoints$1.sm) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    }
  }, {
    key: "_returnFocus",
    value: function _returnFocus() {
      var _this104 = this;
      if (!this.open && this.returnEl) {
        setTimeout(function () {
          _this104.returnEl.focus();
        }, 0);
      }
    }

    // emit an event on hitting the apply button
  }, {
    key: "_dispatchApply",
    value: function _dispatchApply() {
      var applyEvent = new CustomEvent('fwc-panel-apply', {
        detail: this,
        bubbles: true
      });
      this.dispatchEvent(applyEvent);
      this._closePanel();
    }

    // emit an event on hitting the cancel button
  }, {
    key: "_dispatchCancel",
    value: function _dispatchCancel() {
      var cancelEvent = new CustomEvent('fwc-panel-cancel', {
        detail: this,
        bubbles: true
      });
      this.dispatchEvent(cancelEvent);
      this._closePanel();
    }

    // emit an event on hitting the reset button
  }, {
    key: "_dispatchReset",
    value: function _dispatchReset() {
      var resetEvent = new CustomEvent('fwc-panel-reset', {
        detail: this,
        bubbles: true
      });
      this.dispatchEvent(resetEvent);
    }
  }, {
    key: "_dispatchToggled",
    value: function _dispatchToggled() {
      var resetEvent = new CustomEvent('fwc-panel-toggled', {
        detail: this,
        bubbles: true
      });
      this.dispatchEvent(resetEvent);
    }
  }, {
    key: "_setPanelPosition",
    value: function _setPanelPosition() {
      var panel = this.shadowRoot.querySelector('#Panel');
      var viewportWidth = document.documentElement.clientWidth;
      if (this.open) {
        if (panel.getBoundingClientRect().right < viewportWidth) {
          // if rightmost right-side is can fit within viewport
          panel.style.left = 0;
        } else if (panel.getBoundingClientRect().right > viewportWidth) {
          // if rightmost right-side is beyond viewport
          panel.style.right = 0;
        }
      } else {
        this._clearPanelPosition();
      }
    }
  }, {
    key: "_clearPanelPosition",
    value: function _clearPanelPosition() {
      var panel = this.shadowRoot.querySelector('#Panel');
      panel.style.removeProperty('left');
      panel.style.removeProperty('right');
    }

    /** Stores svg htmlement for Restart icon */
  }, {
    key: "_getRestartSVG",
    value: function _getRestartSVG() {
      return html(_templateObject155 || (_templateObject155 = _taggedTemplateLiteral(["\n      <svg\n        xmlns=\"http://www.w3.org/2000/svg\"\n        width=\"50\"\n        height=\"50\"\n        viewBox=\"0 0 50 50\"\n        focusable=\"false\"\n      >\n        <path\n          d=\"M25,0 L25,4.16666667 C36.531575,4.16666667 45.8333333,13.468425 45.8333333,25 C45.8333333,36.531575 36.531575,45.8333333 25,45.8333333 C13.468425,45.8333333 4.16666667,36.531575 4.16666667,25 C4.16666667,18.1966146 7.47070417,12.1907563 12.5,8.3984375 L12.5,18.75 L16.6666667,18.75 L16.6666667,2.08333333 L0,2.08333333 L0,6.25 L8.52864583,6.25 C3.3203125,10.8317062 0,17.5374354 0,25 C0,38.7858083 11.2141938,50 25,50 C38.7858083,50 50,38.7858083 50,25 C50,11.2141938 38.7858083,0 25,0 Z\"\n        />\n      </svg>\n    "])));
    }
  }, {
    key: "_cancelButton",
    value: function _cancelButton(id, mobile) {
      if (!this.hideCancelBtn) {
        return html(_templateObject156 || (_templateObject156 = _taggedTemplateLiteral(["<button\n        id=", "\n        tabindex=\"1\"\n        class=", "\n        @click=\"", "\"\n        aria-label=\"", "\"\n      >\n        ", "\n      </button>"])), id ? id : 'PanelCancelBtn', mobile ? 'fwc-link' : 'fwc-btn fwc-btn-secondary', this._dispatchCancel, this.labelCancelBtn, this.labelCancelBtn);
      }
    }
  }, {
    key: "_applyButton",
    value: function _applyButton(id) {
      if (!this.hideApplyBtn) {
        return html(_templateObject157 || (_templateObject157 = _taggedTemplateLiteral(["<button\n        id=", "\n        tabindex=\"1\"\n        class=\"fwc-btn fwc-btn-primary\"\n        @click=\"", "\"\n        aria-label=\"", "\"\n      >\n        ", "\n      </button>"])), id ? id : 'PanelApplyBtn', this._dispatchApply, this.labelApplyBtn, this.labelApplyBtn);
      }
    }
  }, {
    key: "_resetButton",
    value: function _resetButton(hide) {
      if (!this.hideResetBtn) {
        return html(_templateObject158 || (_templateObject158 = _taggedTemplateLiteral(["\n        <a\n          href=\"javascript:void(0);\"\n          tabindex=\"1\"\n          class=\"fwc-link-icon left ", "\"\n          @click=\"", "\"\n          role=\"button\"\n          aria-label=\"", "\"\n        >\n          <span class=\"fwc-panel-restart\">", "</span>\n          <span>", "</span>\n        </a>\n      "])), hide, this._dispatchReset, this.labelResetBtn, this._getRestartSVG(), this.labelResetBtn);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject159 || (_templateObject159 = _taggedTemplateLiteral(["\n      <link\n        rel=\"stylesheet\"\n        href=\"", "fwc-assets/styles/buttons-links.css\"\n      />\n      <slot name=\"fwc-panel-action\" id=\"FwcActionSlot\"></slot>\n      <mobile-view\n        mobile-header-text=\"", "\"\n        ?open=", "\n        ?decrease-index-z=", "\n        ?hide-footer=", "\n        config=", "\n      >\n        <!-- mobile-view is a shared 'modal' overlay. Body slot is for both desktop and mobile. -->\n        <div class=\"fwc-panel-container\" slot=\"body\">\n          <div\n            id=\"Panel\"\n            aria-expanded=\"", "\"\n            class=\"fwc-panel-wrapper ", "\"\n          >\n            <div class=\"fwc-panel-content\">\n              <slot name=\"fwc-panel-content\" role=\"region\"></slot>\n              ", "\n            </div>\n\n            <div class=\"fwc-panel-footer ", "\">\n              ", "\n              <div class=\"fwc-panel-apply-cancel-wrapper\">\n                ", " ", "\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <!-- Mobile specific footer to allow for fixed design/position in mobile-view -->\n        <div class=\"mobile-view-footer-slot\" slot=\"mobile-actions\">\n          ", "\n          ", "\n        </div>\n      </mobile-view>\n    "])), this.config.assetsPath, this.labelMobileHeader, this.open, this.reduceIndex, this.hideFooter, JSON.stringify(this.config), this.open, this.open ? 'open' : '', this._resetButton('hide-lg'), this.hideFooter ? 'hide' : '', this._resetButton('hide-sm'), this._cancelButton(), this._applyButton(), this._cancelButton('#MobilePanelCancelBtn', true), this._applyButton('#MobilePanelApplyBtn'));
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, sharedMobileViewStyles, css$1(_templateObject160 || (_templateObject160 = _taggedTemplateLiteral(["\n        .fwc-panel-container {\n          position: relative;\n          height: 100%;\n        }\n        .fwc-panel-wrapper {\n          overflow: hidden;\n          opacity: 0;\n          height: 0;\n          visibility: hidden;\n          transition: opacity 200ms ease;\n          width: 0;\n        }\n        .fwc-panel-wrapper.open {\n          opacity: 1;\n          visibility: visible;\n          height: auto;\n          position: absolute;\n          top: calc(1.25 * var(--fwcu));\n          border: 1px solid var(--color-gray-four);\n          border-radius: var(--border-radius);\n          background-color: var(--color-white);\n          width: auto;\n          z-index: 1;\n        }\n        .fwc-panel-footer {\n          position: relative;\n          padding: calc(2.5 * var(--fwcu));\n          background-color: var(--color-white);\n          border-top: 1px solid var(--color-gray-six);\n          box-shadow: var(--box-shadow);\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n        }\n        .fwc-panel-footer.hide {\n          display: none;\n        }\n        .fwc-panel-apply-cancel-wrapper {\n          display: flex;\n          justify-content: space-between;\n          width: auto;\n        }\n        .fwc-panel-restart svg {\n          width: calc(1.5 * var(--fwcu));\n          height: calc(1.5 * var(--fwcu));\n          margin-right: calc(0.5 * var(--fwcu));\n          fill: var(--color-gray-three);\n          transform: rotateZ(90deg);\n        }\n        .fwc-panel-content {\n          padding: calc(2.5 * var(--fwcu));\n          height: auto;\n          max-height: calc(35.5 * var(--fwcu));\n          overflow-y: auto;\n          overflow-x: hidden;\n        }\n        .hide-sm {\n          display: block;\n        }\n        .hide-lg {\n          display: none;\n        }\n        .fwc-panel-reset-wrapper {\n          display: flex;\n          align-items: center;\n        }\n\n        @media screen and (max-width: 600px) {\n          .fwc-panel-content {\n            padding: calc(2 * var(--fwcu)) calc(4 * var(--fwcu)); /* Match mobile grid padding at 32px */\n            padding-bottom: calc(12 * var(--fwcu));\n            height: 100%;\n            max-height: none;\n          }\n          .fwc-panel-footer {\n            display: none;\n          }\n          .hide-sm {\n            display: none;\n          }\n          .hide-lg {\n            display: block;\n          }\n          .fwc-panel-wrapper.open {\n            position: relative;\n            top: 0;\n            border: none;\n            width: auto;\n            height: 100%;\n          }\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        config: {
          type: Object
        },
        open: {
          type: Boolean
        },
        text: {
          type: String
        },
        labelMobileHeader: {
          attribute: 'label-mobile-header',
          type: String
        },
        labelResetBtn: {
          attribute: 'label-reset-button',
          type: String
        },
        labelCancelBtn: {
          attribute: 'label-cancel-button',
          type: String
        },
        labelApplyBtn: {
          attribute: 'label-apply-button',
          type: String
        },
        hideApplyBtn: {
          attribute: 'hide-apply-button',
          type: Boolean
        },
        hideCancelBtn: {
          attribute: 'hide-cancel-button',
          type: Boolean
        },
        hideResetBtn: {
          attribute: 'hide-reset-button',
          type: Boolean
        },
        reduceIndex: {
          attribute: 'reduce-index',
          type: Boolean
        },
        hideFooter: {}
      };
    }
  }]);
  return FwcPanelComponent;
}(LitElement);
var FwcPanel = /*#__PURE__*/function (_FwcBase33) {
  _inherits$1(FwcPanel, _FwcBase33);
  var _super74 = _createSuper$8(FwcPanel);
  function FwcPanel() {
    _classCallCheck$1(this, FwcPanel);
    return _super74.call(this, 'fwc-panel', FwcPanelComponent);
  }
  return _createClass$1(FwcPanel);
}(FwcBase$1);
var FwcPanelNavComponent = /*#__PURE__*/function (_LitElement42) {
  _inherits$1(FwcPanelNavComponent, _LitElement42);
  var _super75 = _createSuper$8(FwcPanelNavComponent);
  function FwcPanelNavComponent() {
    var _this105;
    _classCallCheck$1(this, FwcPanelNavComponent);
    _this105 = _super75.call(this);
    _this105.controlElem = null;
    _this105.controlListener = false;
    _this105._focusReturn = true;
    _this105._open = false;
    _this105._panel = null;
    _this105._position = 'center';
    _this105._positionOrg = 'center';
    _this105._container = null;
    _this105.returnElem = null;
    _this105._togglePanel = _this105._togglePanel.bind(_assertThisInitialized(_this105));
    _this105._handlePanelClickOut = _this105._handlePanelClickOut.bind(_assertThisInitialized(_this105));
    return _this105;
  }
  _createClass$1(FwcPanelNavComponent, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(FwcPanelNavComponent.prototype), "connectedCallback", this).call(this);
      document.addEventListener('click', this._handlePanelClickOut);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      document.removeEventListener('click', this._handlePanelClickOut);
      _get(_getPrototypeOf(FwcPanelNavComponent.prototype), "disconnectedCallback", this).call(this);
    }
  }, {
    key: "firstUpdated",
    value: function firstUpdated() {
      var _this106 = this;
      this._panel = this.shadowRoot.getElementById('Panel');
      this._container = this.shadowRoot.getElementById('Container');
      this._positionOrg = this._position;
      this._panel.addEventListener('transitionend', function (e) {
        if (!_this106._open && e.propertyName === 'opacity') {
          _this106._returnFocus();
          _this106._clearPanelPosition();
        }
      });

      // listen for Escape keydown
      this.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          // other components listen for esacpe - stop this from bubbling up
          e.stopPropagation();
          _this106._closePanel();
        }
      });
    }
  }, {
    key: "setReturnElement",
    value: function setReturnElement(elem) {
      this.returnElem = elem;
    }
  }, {
    key: "togglePanel",
    value: function togglePanel() {
      this._togglePanel();
    }
  }, {
    key: "setControlElement",
    value: function () {
      var _setControlElement2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(elem) {
        var control;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this._setControlElement();
            case 2:
              control = _context2.sent;
              if (control) {
                this._initActionControl(elem);
              } else {
                console.error('Control element could not be set');
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function setControlElement(_x) {
        return _setControlElement2.apply(this, arguments);
      }
      return setControlElement;
    }()
  }, {
    key: "_setControlElement",
    value: function _setControlElement() {
      var _this107 = this;
      return new Promise(function (resolve, reject) {
        var counter = 0;
        var setControl = function setControl() {
          counter++;
          // wait for slotchange event to finish, then update
          if (_this107.controlListener) {
            resolve(true);
          } else if (counter >= 10) {
            reject(false);
          } else {
            setTimeout(function () {
              return setControl();
            }, 0);
          }
        };
        setControl();
      });
    }
  }, {
    key: "_setActiveControl",
    value: function _setActiveControl() {
      // use classes in buttons-links.css
      this.controlElem.classList.toggle('fwc-active');
      this.controlElem.setAttribute('aria-expanded', this._open);
    }
  }, {
    key: "_togglePanel",
    value: function _togglePanel() {
      var _this108 = this;
      this._open = !this._open;
      this._setActiveControl();
      this._dispatchToggled();
      if (this._open) {
        setTimeout(function () {
          _this108._panel.focus();
          _this108._setPanelPosition();
        }, 0);
      }
    }
  }, {
    key: "_closePanel",
    value: function _closePanel() {
      this._open = false;
      this._returnFocus();
    }
  }, {
    key: "_returnFocus",
    value: function _returnFocus() {
      if (!this._open && this._focusReturn) {
        // return focus to controlElem by default;
        var elem = this.returnElem ? this.returnElem : this.controlElem;
        setTimeout(function () {
          elem.focus();
        }, 0);
      }
      this._focusReturn = true;
    }

    // automatically assign first child of action slot to be control element
  }, {
    key: "_onActionSlotChange",
    value: function _onActionSlotChange() {
      var bodySlot = this.shadowRoot.getElementById('NavItemSlot');
      var bodySlotNodes = bodySlot.assignedNodes();
      // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
      if (bodySlotNodes[0].nodeType === 1) {
        var _iterator4 = _createForOfIteratorHelper$1(bodySlotNodes[0].childNodes),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var node = _step4.value;
            if (node.nodeType === 1) {
              this._initActionControl(node);
              break;
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }
  }, {
    key: "_handleFocusOut",
    value: function _handleFocusOut() {
      this._togglePanel();
    }
  }, {
    key: "_handlePanelClickOut",
    value: function _handlePanelClickOut(e) {
      if (!this.contains(e.target) && this._open) {
        this._focusReturn = false;
        this._togglePanel();
      }
    }
  }, {
    key: "_initActionControl",
    value: function _initActionControl(node) {
      if (this.controlElem && this.controlListener) {
        this.controlElem.removeEventListener('click', this._togglePanel);
      }
      this.controlElem = node;
      this.controlElem.setAttribute('aria-expanded', this._open);
      this.controlElem.addEventListener('click', this._togglePanel);
      this.controlListener = true;
    }
  }, {
    key: "_dispatchToggled",
    value: function _dispatchToggled() {
      var resetEvent = new CustomEvent('fwc-panel-toggled', {
        detail: this,
        bubbles: true
      });
      this.dispatchEvent(resetEvent);
    }
  }, {
    key: "_getControlCenter",
    value: function _getControlCenter() {
      var _container = this._container;
      return -(_container.getBoundingClientRect().width / 2 - this.getBoundingClientRect().width / 2) + 'px';
    }
  }, {
    key: "_setPanelPosition",
    value: function _setPanelPosition() {
      var _container = this._container;
      var sm = breakpoints$1.sm;
      if (window.innerWidth <= sm) {
        this._position = 'mobile';
        this.style.position = 'static';
        return;
      } else {
        this.style.position = 'relative';
        this._clearPanelPosition();
      }

      // center panel based on width of self and component
      if (this._open && this._position === 'center') {
        _container.style.left = this._getControlCenter();
      }
      if (this._open) {
        if (_container.getBoundingClientRect().left < 0) {
          this._clearPanelPosition();
          this._position = 'left';
        } else if (_container.getBoundingClientRect().right > window.innerWidth) {
          this._clearPanelPosition();
          this._position = 'right';
        }
      }
    }
  }, {
    key: "_clearPanelPosition",
    value: function _clearPanelPosition() {
      var _container = this._container;
      _container.style.removeProperty('left');
      _container.style.removeProperty('right');
      this._position = this._positionOrg;
    }
  }, {
    key: "_hiddenCloseTabIndex",
    value: function _hiddenCloseTabIndex() {
      if (this._open) {
        return html(_templateObject161 || (_templateObject161 = _taggedTemplateLiteral(["<span\n        class=\"tab-close sr-only\"\n        aria-hidden=\"true\"\n        @focus=", "\n        tabindex=\"0\"\n      ></span>"])), this._handleFocusOut);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject162 || (_templateObject162 = _taggedTemplateLiteral(["\n      <slot\n        id=\"NavItemSlot\"\n        name=\"nav-item\"\n        @slotchange=", "\n      ></slot>\n      ", "\n      <div\n        id=\"Container\"\n        class=\"container ", " ", "\"\n      >\n        <div id=\"Panel\" class=\"wrapper\" tabindex=\"0\">\n          <div class=\"content\">\n            <slot name=\"nav-content\" role=\"group\"></slot>\n          </div>\n        </div>\n      </div>\n      ", "\n    "])), this._onActionSlotChange, this._hiddenCloseTabIndex(), this._open ? 'open' : '', this._position, this._hiddenCloseTabIndex());
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject163 || (_templateObject163 = _taggedTemplateLiteral(["\n        :host {\n          position: relative;\n          width: max-content;\n        }\n        .container {\n          position: absolute;\n          margin-top: var(--fwcu);\n          width: max-content; /* allows auto width outside of parent */\n        }\n        .container.open {\n          min-width: 200px;\n        }\n        .container.right {\n          right: 0;\n        }\n        .container.left {\n          left: 0;\n        }\n        .container.mobile {\n          left: calc(4 * var(--fwcu));\n          right: calc(4 * var(--fwcu));\n          width: auto;\n        }\n\n        .wrapper {\n          position: relative;\n          opacity: 0;\n          height: 0;\n          width: 0;\n          z-index: 1;\n          visibility: hidden;\n          border: 1px solid var(--color-gray-four);\n          box-shadow: var(--box-shadow);\n          border-radius: var(--border-radius);\n          background-color: var(--color-white);\n          transition: opacity 200ms ease;\n        }\n        .container.open .wrapper {\n          opacity: 1;\n          visibility: visible;\n          height: auto;\n          width: auto;\n        }\n        .container.open .wrapper:focus {\n          outline: var(--fwc-focus);\n        }\n        .content {\n          padding: calc(2.5 * var(--fwcu));\n          height: auto;\n          max-height: calc(35.5 * var(--fwcu));\n          overflow-y: auto;\n          overflow-x: hidden;\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        _open: {},
        _position: {
          type: String
        }
      };
    }
  }]);
  return FwcPanelNavComponent;
}(LitElement);
var FwcPanelNav = /*#__PURE__*/function (_FwcBase34) {
  _inherits$1(FwcPanelNav, _FwcBase34);
  var _super76 = _createSuper$8(FwcPanelNav);
  function FwcPanelNav() {
    _classCallCheck$1(this, FwcPanelNav);
    return _super76.call(this, 'fwc-panel-nav', FwcPanelNavComponent);
  }
  return _createClass$1(FwcPanelNav);
}(FwcBase$1);
var FwcProgressLinearComponent = /*#__PURE__*/function (_LitElement43) {
  _inherits$1(FwcProgressLinearComponent, _LitElement43);
  var _super77 = _createSuper$8(FwcProgressLinearComponent);
  function FwcProgressLinearComponent() {
    var _this109;
    _classCallCheck$1(this, FwcProgressLinearComponent);
    _this109 = _super77.call(this);
    _this109.config = fwcConfig$1;
    _this109.steps = [];
    _this109.data = null;
    _this109.nonLinear = false;
    _this109.minimal = false;
    return _this109;
  }
  _createClass$1(FwcProgressLinearComponent, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      if (this.data && !this.minimal) {
        this._buildSteps();
      } else if (this.data && this.minimal) {
        this._buildStepsMinimal();
      }
    }
  }, {
    key: "updated",
    value: function updated(changedProperties) {
      var _this110 = this;
      changedProperties.forEach(function (oldValue, propName) {
        if (propName === 'data' && !_this110.minimal) {
          _this110._buildSteps();
        } else if (propName === 'data' && _this110.minimal) {
          _this110._buildStepsMinimal();
        }
      });
    }
  }, {
    key: "_buildSteps",
    value: function _buildSteps() {
      var _this111 = this;
      var steps = html(_templateObject164 || (_templateObject164 = _taggedTemplateLiteral(["", ""])), this.data.map(function (step) {
        return html(_templateObject165 || (_templateObject165 = _taggedTemplateLiteral(["\n        <li\n          class=\"fwc-prog-linear ", " \"\n          aria-label=\"", "\"\n        >\n          <div>\n            <div\n              class=\"check ", " ", "\"\n            >\n              ", "\n            </div>\n            <div\n              class=\"connector ", " ", "\"\n            ></div>\n          </div>\n          <dl>\n            <div class=\"fwc-prog-linear-header-flex\">\n              <dt>\n                <div\n                  class=\"fwc-h4 ", "\"\n                >\n                  ", "\n                </div>\n              </dt>\n              <dd>\n                ", "\n              </dd>\n            </div>\n            <dd><p class=\"fwc-prog-linear-date\">", "</p></dd>\n            <dd><p class=\"fwc-prog-linear-body\">", "</p></dd>\n          </dl>\n        </li>\n      "])), step.state === 'next' || _this111.nonLinear === true && step.state !== 'complete' ? 'fwc-prog-linear-next' : '', step.state !== 'complete' ? 'incomplete' : 'complete', step.state !== 'complete' ? '' : 'check-complete', step.state === 'next' && _this111.nonLinear === false ? 'check-in-progress' : '', _this111._drawCheckMark(), step.state !== 'complete' ? '' : 'connector-complete', _this111.nonLinear === true ? 'connector-non-linear' : '', step.state === 'complete' ? 'title-complete' : 'title-incomplete', step.title, Object.prototype.hasOwnProperty.call(step, 'badge') ? html(_templateObject166 || (_templateObject166 = _taggedTemplateLiteral(["<span class=\"fwc-badge ", "\">\n                      ", "\n                    </span>"])), step.badge.color, step.badge.label) : html(_templateObject167 || (_templateObject167 = _taggedTemplateLiteral([""]))), step.date, step.body);
      }));
      return this.steps = steps;
    }
  }, {
    key: "_buildStepsMinimal",
    value: function _buildStepsMinimal() {
      var _this112 = this;
      var steps = html(_templateObject168 || (_templateObject168 = _taggedTemplateLiteral(["", ""])), this.data.map(function (step) {
        return html(_templateObject169 || (_templateObject169 = _taggedTemplateLiteral(["\n        <li\n          class=\"fwc-prog-linear-min ", "\"\n          aria-label=\"", "\"\n        >\n          <div>\n            <div\n              class=\"check ", " ", "\"\n            >\n              ", "\n            </div>\n            <div\n              class=\"connector ", " ", "\"\n            ></div>\n          </div>\n          <dl>\n            <dt>\n              <strong>", "</strong>\n            </dt>\n            ", "\n            ", "\n            <p class=\"fwc-prog-linear-body-min\">", "</p>\n          </dl>\n        </li>\n      "])), step.state === 'next' || _this112.nonLinear === true && step.state !== 'complete' ? 'fwc-prog-linear-next' : '', step.state !== 'complete' ? 'incomplete' : 'complete', step.state !== 'complete' ? '' : 'check-complete', step.state === 'next' && _this112.nonLinear === false ? 'check-in-progress' : '', _this112._drawCheckMark(), step.state !== 'complete' ? '' : 'connector-complete', _this112.nonLinear === true ? 'connector-non-linear' : '', step.title, Object.prototype.hasOwnProperty.call(step, 'badge') ? html(_templateObject170 || (_templateObject170 = _taggedTemplateLiteral(["<dd>\n                  <span class=\"fwc-badge ", "\">\n                    ", "\n                  </span>\n                </dd>"])), step.badge.color, step.badge.label) : html(_templateObject171 || (_templateObject171 = _taggedTemplateLiteral([""]))), Object.prototype.hasOwnProperty.call(step, 'date') ? html(_templateObject172 || (_templateObject172 = _taggedTemplateLiteral(["<p class=\"fwc-prog-linear-date-min\">", "</p>"])), step.date) : html(_templateObject173 || (_templateObject173 = _taggedTemplateLiteral([""]))), step.body);
      }));
      return this.steps = steps;
    }
  }, {
    key: "_drawCheckMark",
    value: function _drawCheckMark() {
      return html(_templateObject174 || (_templateObject174 = _taggedTemplateLiteral(["\n      <svg\n        xmlns=\"http://www.w3.org/2000/svg\"\n        width=\"50\"\n        height=\"50\"\n        viewBox=\"0 0 50 50\"\n        focusable=\"false\"\n      >\n        <polygon\n          fill=\"#ffffff\"\n          points=\"40.771 7 19.443 26.724 9.229 17.197 0 26.109 18.365 43.545 19.443 44.5 20.519 43.545 50 15.912\"\n        />\n      </svg>\n    "])));
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject175 || (_templateObject175 = _taggedTemplateLiteral(["\n      <link\n        rel=\"stylesheet\"\n        href=\"", "fwc-assets/styles/components/fwc-badges.css\"\n      />\n      <link\n        rel=\"stylesheet\"\n        href=\"", "fwc-assets/styles/typography.css\"\n      />\n      <ol>\n        ", "\n      </ol>\n    "])), this.config.assetsPath, this.config.assetsPath, this.minimal ? this._buildStepsMinimal() : this._buildSteps());
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject176 || (_templateObject176 = _taggedTemplateLiteral(["\n        ol {\n          display: flex;\n          flex-direction: column;\n          margin: 0;\n          padding: 0;\n        }\n        li {\n          list-style: none;\n          display: flex;\n          align-items: stretch;\n        }\n        li:last-child .connector {\n          display: none;\n        }\n        li:last-child dl {\n          border: none;\n          margin-bottom: 0px;\n        }\n        li strong,\n        li dt,\n        li p,\n        li .fwc-prog-linear-body-min {\n          color: var(--color-gray-two);\n        }\n        li.fwc-prog-linear-next strong,\n        li.fwc-prog-linear-next p,\n        li.fwc-prog-linear-next .fwc-prog-linear-body-min {\n          color: var(--color-black);\n        }\n        .check {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          flex: 1 0 100%;\n          height: calc(2.5 * var(--fwcu));\n          width: calc(2.5 * var(--fwcu));\n          margin-top: calc(0.25 * var(--fwcu));\n          border-radius: 100%;\n          border: 2px solid var(--color-gray-four);\n        }\n        .check svg {\n          width: calc(1.5 * var(--fwcu));\n          height: calc(1.5 * var(--fwcu));\n          display: none;\n        }\n        .check.check-complete {\n          border: 1px solid var(--color-primary);\n          background: var(--color-primary);\n        }\n        .check.check-complete svg {\n          display: block;\n        }\n        .check.check-in-progress {\n          border: calc(0.25 * var(--fwcu)) solid var(--color-primary);\n        }\n        .connector {\n          width: calc(0.25 * var(--fwcu));\n          height: calc(100% - calc(4.5 * var(--fwcu)));\n          margin: var(--fwcu) 0 var(--fwcu) calc(1.25 * var(--fwcu));\n          padding: var(--fwcu) 0;\n          background: var(--color-gray-four);\n        }\n        .connector.connector-complete {\n          background: var(--color-primary);\n        }\n        .connector-non-linear {\n          visibility: hidden;\n          opacity: 0;\n        }\n        dl {\n          display: flex;\n          justify-content: space-between;\n          align-items: flex-start;\n          flex-wrap: wrap;\n          width: 100%;\n          margin: 0 0 calc(1.5 * var(--fwcu)) calc(3 * var(--fwcu));\n          font-size: var(--default-font-size);\n          border-bottom: 1px solid var(--color-gray-four, #cccccc);\n        }\n        dt {\n          width: 100%;\n          color: var(--color-gray-one);\n        }\n        dt p {\n          margin: 0px 0px calc(1.5 * var(--fwcu)) 0px;\n        }\n        dd {\n          margin-left: 0;\n        }\n        dd strong {\n          white-space: nowrap;\n          text-transform: uppercase;\n          color: #fff;\n          font-size: calc(1.25 * var(--fwcu));\n          border-radius: calc(0.25 * var(--fwcu));\n          line-height: 1;\n          padding: calc(0.25 * var(--fwcu)) var(--fwcu);\n          letter-spacing: 1px;\n        }\n        .fwc-prog-linear-header-flex {\n          width: 100%;\n          padding-right: calc(4 * var(--fwcu));\n          display: flex;\n          flex-direction: row;\n          justify-content: space-between;\n          margin-bottom: var(--fwcu);\n        }\n        .fwc-h4.title-complete {\n          font-weight: 500;\n          color: var(--color-gray-two);\n        }\n        .fwc-h4.title-incomplete {\n          font-weight: 600;\n          color: var(--color-gray-one);\n        }\n        .fwc-prog-linear-date {\n          margin-top: 0px;\n          margin-bottom: calc(1.5 * var(--fwcu));\n        }\n        .fwc-prog-linear-body {\n          margin-top: 0px;\n          padding-right: calc(4 * var(--fwcu));\n          margin-bottom: calc(4 * var(--fwcu));\n        }\n        .fwc-prog-linear dt {\n          max-width: 70%;\n        }\n        .fwc-prog-linear dl {\n          margin-bottom: calc(4 * var(--fwcu));\n        }\n        .fwc-prog-linear:last-child dl {\n          margin-bottom: 0px;\n        }\n        .fwc-prog-linear dd:nth-child(3) {\n          width: 100%;\n        }\n        .fwc-prog-linear-min dt {\n          max-width: 70%;\n        }\n        .fwc-prog-linear-min dl p {\n          width: 100%;\n        }\n        .fwc-prog-linear-min .fwc-prog-linear-body-min {\n          margin: calc(var(--fwcu)) 0px calc(1.5 * var(--fwcu)) 0px;\n        }\n        .fwc-prog-linear-min dl {\n          margin-bottom: calc(1.5 * var(--fwcu));\n          padding-right: calc(4 * var(--fwcu));\n        }\n        .fwc-prog-linear-date-min,\n        .fwc-prog-linear-min dt p {\n          margin: 0px;\n        }\n        .non-linear .check.check-in-progress {\n          border-color: var(--color-gray-four);\n        }\n        .non-linear-next .fwc-prog-linear-date,\n        .non-linear-next .fwc-prog-linear-body,\n        .non-linear-next .fwc-prog-linear-date-min,\n        .non-linear-next .fwc-prog-linear-body-min {\n          font-weight: bold;\n        }\n        @media screen and (max-width: 600px) {\n          .fwc-prog-linear-header-flex {\n            flex-direction: column;\n            margin-bottom: calc(1.5 * var(--fwcu));\n          }\n          .fwc-prog-linear-header-flex div:nth-child(2) {\n            margin-bottom: calc(1.75 * var(--fwcu));\n          }\n          .fwc-h4 {\n            margin-bottom: calc(3 * var(--fwcu));\n          }\n          p.fwc-prog-linear-date {\n            margin-bottom: 0px;\n          }\n          .fwc-prog-linear dl,\n          .fwc-prog-linear .fwc-prog-linear-body {\n            margin-bottom: calc(3 * var(--fwcu));\n          }\n          .fwc-prog-linear dt {\n            max-width: 100%;\n          }\n          .fwc-prog-linear-min dt {\n            flex: 2;\n            padding-right: calc(2 * var(--fwcu));\n          }\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        config: {
          type: Object
        },
        data: {
          type: Array
        },
        steps: {
          type: Array
        },
        nonLinear: {
          attribute: 'non-linear',
          type: Boolean
        },
        minimal: {
          attribute: 'minimal',
          type: Boolean
        }
      };
    }
  }]);
  return FwcProgressLinearComponent;
}(LitElement);
var FwcProgressLinear = /*#__PURE__*/function (_FwcBase35) {
  _inherits$1(FwcProgressLinear, _FwcBase35);
  var _super78 = _createSuper$8(FwcProgressLinear);
  function FwcProgressLinear() {
    _classCallCheck$1(this, FwcProgressLinear);
    return _super78.call(this, 'fwc-progress-linear', FwcProgressLinearComponent);
  }
  return _createClass$1(FwcProgressLinear);
}(FwcBase$1);
var FwcProgressStandardComponent = /*#__PURE__*/function (_LitElement44) {
  _inherits$1(FwcProgressStandardComponent, _LitElement44);
  var _super79 = _createSuper$8(FwcProgressStandardComponent);
  function FwcProgressStandardComponent() {
    var _this113;
    _classCallCheck$1(this, FwcProgressStandardComponent);
    _this113 = _super79.call(this);
    _this113.type = 'horizontal';
    _this113.steps = [];
    _this113.data = null;
    return _this113;
  }
  _createClass$1(FwcProgressStandardComponent, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      if (this.data) {
        this._buildSteps();
      }
    }
  }, {
    key: "updated",
    value: function updated(changedProperties) {
      var _this114 = this;
      changedProperties.forEach(function (oldValue, propName) {
        if (propName === 'data') {
          _this114._buildSteps();
        }
      });
    }
  }, {
    key: "_buildSteps",
    value: function _buildSteps() {
      var _this115 = this;
      var steps = html(_templateObject177 || (_templateObject177 = _taggedTemplateLiteral(["", ""])), this.data.map(function (step) {
        return html(_templateObject178 || (_templateObject178 = _taggedTemplateLiteral(["\n        <li aria-label=\"", "\">\n          <div class=", ">\n            ", "\n          </div>\n          <span class=", "></span>\n          <p>", "</p>\n        </li>\n      "])), step.complete ? 'complete' : 'incomplete', step.complete ? 'complete' : '', _this115._drawCheckMark(), step.complete ? 'complete' : '', step.label);
      }));
      this.steps = steps;
    }
  }, {
    key: "_drawCheckMark",
    value: function _drawCheckMark() {
      return html(_templateObject179 || (_templateObject179 = _taggedTemplateLiteral(["\n      <svg\n        xmlns=\"http://www.w3.org/2000/svg\"\n        width=\"50\"\n        height=\"50\"\n        viewBox=\"0 0 50 50\"\n        focusable=\"false\"\n      >\n        <polygon\n          fill=\"#ffffff\"\n          points=\"40.771 7 19.443 26.724 9.229 17.197 0 26.109 18.365 43.545 19.443 44.5 20.519 43.545 50 15.912\"\n        />\n      </svg>\n    "])));
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject180 || (_templateObject180 = _taggedTemplateLiteral(["\n      <ol class=\"", "\">\n        ", "\n      </ol>\n    "])), this.type === 'vertical' ? 'vert' : '', this.steps);
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject181 || (_templateObject181 = _taggedTemplateLiteral(["\n        :host {\n          display: inline;\n          color: var(--color-gray-two);\n        }\n        ol {\n          margin: 0;\n          padding: 0;\n          display: flex;\n          align-items: center;\n          justify-content: flex-start;\n          font-size: var(--default-font-size);\n          font-weight: bold;\n        }\n        li {\n          flex: 0 0 33%;\n          display: flex;\n          align-items: center;\n          position: relative;\n        }\n        li:last-child {\n          flex: 0 0 auto;\n        }\n        div {\n          height: calc(2.5 * var(--fwcu));\n          width: calc(2.5 * var(--fwcu));\n          background: white;\n          border: 2px solid var(--color-gray-four);\n          border-radius: 100%;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          flex: 0 0 auto;\n        }\n        div.complete {\n          background: var(--color-primary);\n          border-color: var(--color-primary);\n        }\n        li[aria-label='complete'] + li[aria-label='incomplete'] > div {\n          border: 2px solid var(--color-primary);\n        }\n        li[aria-label='incomplete']:first-of-type > div {\n          border: 2px solid var(--color-primary);\n        }\n        svg {\n          width: calc(1.5 * var(--fwcu));\n          height: calc(1.5 * var(--fwcu));\n          display: none;\n        }\n        div.complete svg {\n          display: inline;\n        }\n        span {\n          height: 2px;\n          display: block;\n          margin-left: calc(0.5 * var(--fwcu));\n          margin-right: calc(0.5 * var(--fwcu));\n          width: calc(100% - calc(3.5 * var(--fwcu)));\n          background: var(--color-gray-four);\n        }\n        span.complete {\n          background: var(--color-primary);\n        }\n        p {\n          position: absolute;\n          text-align: center;\n          width: calc(15.5 * var(--fwcu));\n          left: calc(-6.75 * var(--fwcu)); /*  15.5/2-1 */\n          top: 100%;\n          margin: 0;\n          padding-top: var(--fwcu);\n        }\n        li[aria-label='complete'] + li[aria-label='incomplete'] > p,\n        li[aria-label='incomplete']:first-of-type > p {\n          color: var(--color-gray-one);\n        }\n        /* vertical */\n        ol.vert {\n          flex-direction: column;\n          align-items: flex-start;\n          height: 100%;\n        }\n        ol.vert span {\n          width: calc(0.25 * var(--fwcu));\n          height: calc(100% - calc(3.75 * var(--fwcu)));\n          margin: calc(0.5 * var(--fwcu)) 0;\n          margin-left: calc(1.25 * var(--fwcu));\n          /* box-sizing: content-box; */\n        }\n        ol.vert li {\n          display: flex;\n          flex-direction: column;\n          align-items: flex-start;\n          justify-content: flex-start;\n          width: 100%;\n        }\n        ol.vert p {\n          top: 0;\n          bottom: calc(\n            50% - calc(1.5 * var(--fwcu))\n          ); /* centers border on vertical line, not parent. Takes into account half of check circle height) */\n          padding: 0;\n          width: calc(100% - calc(3 * var(--fwcu)));\n          left: calc(4 * var(--fwcu));\n          text-align: left;\n          border-bottom: 1px solid var(--color-gray-four, #cccccc);\n        }\n        ol.vert li:last-child p {\n          border-bottom: none;\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        type: {
          type: String
        },
        data: {
          type: Array
        },
        steps: {
          type: Array
        }
      };
    }
  }]);
  return FwcProgressStandardComponent;
}(LitElement);
var FwcProgressStandard = /*#__PURE__*/function (_FwcBase36) {
  _inherits$1(FwcProgressStandard, _FwcBase36);
  var _super80 = _createSuper$8(FwcProgressStandard);
  function FwcProgressStandard() {
    _classCallCheck$1(this, FwcProgressStandard);
    return _super80.call(this, 'fwc-progress-standard', FwcProgressStandardComponent);
  }
  return _createClass$1(FwcProgressStandard);
}(FwcBase$1);
var FwcTabsComponent = /*#__PURE__*/function (_LitElement46) {
  _inherits$1(FwcTabsComponent, _LitElement46);
  var _super83 = _createSuper$8(FwcTabsComponent);
  function FwcTabsComponent() {
    var _this120;
    _classCallCheck$1(this, FwcTabsComponent);
    _this120 = _super83.call(this);
    _this120.tabs = [];
    _this120.inline = false;
    _this120.size = 'lg';
    _this120._current = 0;
    return _this120;
  }
  _createClass$1(FwcTabsComponent, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      this._initActiveTab();
      this.size = this.tabsOnly ? 'lg' : this.size;
    }
  }, {
    key: "_initActiveTab",
    value: function _initActiveTab() {
      for (var i = 0; i < this.tabs.length; i++) {
        if (this.tabs[i].active) {
          this._current = i;
          break;
        }
      }
    }
  }, {
    key: "_onTabSelect",
    value: function _onTabSelect(tab) {
      if (this.tabs[tab].title !== this._current) {
        var _iterator5 = _createForOfIteratorHelper$1(this.tabs),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _tab = _step5.value;
            _tab.active = false;
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        this.tabs[tab].active = true;
        this._current = tab;
        this._emitEvent(this.tabs[tab]);
      }
    }
  }, {
    key: "_handleKeyDown",
    value: function _handleKeyDown(e) {
      switch (e.key) {
        case 'Right':
        case 'ArrowRight':
          e.preventDefault();
          e.stopPropagation();
          this._switchTab('next');
          break;
        case 'Left':
        case 'ArrowLeft':
          e.preventDefault();
          e.stopPropagation();
          this._switchTab('prev');
          break;
        case 'Home':
          this._onTabSelect(0);
          break;
        case 'End':
          this._onTabSelect(this.tabs.length - 1);
          break;
      }
    }
  }, {
    key: "_switchTab",
    value: function _switchTab(dir) {
      var end = this.tabs.length - 1;
      if (dir === 'next') {
        var next = this._current + 1;
        this._current = next > end ? 0 : next;
      } else {
        var prev = this._current - 1;
        this._current = prev < 0 ? end : prev;
      }
      var tab = this.shadowRoot.getElementById('fwc-TabBtn-' + this._current);
      this._onTabSelect(this._current);
      tab.focus();
    }
  }, {
    key: "_emitEvent",
    value: function _emitEvent(tab) {
      var event = new CustomEvent('fwc-tabs-clicked', {
        detail: tab,
        bubbles: true
      });
      this.dispatchEvent(event);
    }
  }, {
    key: "_buildSlots",
    value: function _buildSlots() {
      var _this121 = this;
      var slots = html(_templateObject187 || (_templateObject187 = _taggedTemplateLiteral(["", ""])), this.tabs.map(function (slot, i) {
        var slotID = slot.slotID ? slot.slotID : slot.title;
        return html(_templateObject188 || (_templateObject188 = _taggedTemplateLiteral(["\n        <div\n          class=\"slot-container ", "\"\n          id=", "\n        >\n          <slot\n            aria-labelledby=\"fwc-TabBtn-", "\"\n            role=\"tabpanel\"\n            id=\"fwc-TabBody-", "\"\n            name=\"fwc-tab-", "\"\n          ></slot>\n        </div>\n      "])), i === _this121._current ? 'selected' : '', _this121._current + '_' + i, i, i, slotID);
      }));
      return slots;
    }
  }, {
    key: "_buildTabs",
    value: function _buildTabs() {
      var _this122 = this;
      var tabs = html(_templateObject189 || (_templateObject189 = _taggedTemplateLiteral(["", ""])), this.tabs.map(function (tab, i) {
        var selected = i === _this122._current;
        return html(_templateObject190 || (_templateObject190 = _taggedTemplateLiteral(["\n        <button\n          tabindex=", "\n          id=\"fwc-TabBtn-", "\"\n          type=\"button\"\n          role=\"tab\"\n          aria-setsize=\"", "\"\n          aria-selected=\"", "\"\n          aria-controls=\"fwc-TabBody-", "\"\n          aria-label=\"", "\"\n          class=\"", "\"\n          @click=\"", "\"\n          @keydown=", "\n        >\n          ", "\n        </button>\n      "])), _this122._current === i ? 0 : -1, i, _this122.tabs.length, selected, i, tab.title, selected ? 'selected' : '', function () {
          return _this122._onTabSelect(i);
        }, _this122._handleKeyDown, tab.title);
      }));
      return tabs;
    }
  }, {
    key: "_slotContainer",
    value: function _slotContainer() {
      return html(_templateObject191 || (_templateObject191 = _taggedTemplateLiteral(["<section tabindex=\"0\">", "</section>"])), this._buildSlots());
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject192 || (_templateObject192 = _taggedTemplateLiteral(["\n      <div\n        role=\"tablist\"\n        aria-label=\"", "\"\n        class=\"", " ", "\"\n      >\n        ", "\n      </div>\n      ", "\n    "])), this.labelAriaTabList, this.inline ? 'inline' : '', this.size, this._buildTabs(), !this.tabsOnly ? this._slotContainer() : null);
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject193 || (_templateObject193 = _taggedTemplateLiteral(["\n        .slot-container {\n          display: none;\n        }\n        .slot-container.selected {\n          display: block;\n        }\n        :host > div {\n          display: flex;\n          align-items: stretch;\n          justify-content: flex-start;\n        }\n        :host > div.inline {\n          display: inline-flex;\n        }\n        section {\n          padding: calc(2 * var(--fwcu));\n          padding-top: calc(3 * var(--fwcu));\n        }\n        section:focus {\n          outline: var(--fwc-focus);\n        }\n        button {\n          flex: 1 1 auto;\n          background: white;\n          color: var(--color-primary);\n          border: 1px solid var(--color-gray-six);\n          border-right: 0px;\n          padding: calc(1.5 * var(--fwcu)) calc(2 * var(--fwcu));\n          line-height: 1;\n          margin: 0;\n          border-radius: 0;\n          cursor: pointer;\n          position: relative;\n          font-family: var(--font-sans-serif);\n          font-size: calc(2 * var(--fwcu));\n          font-weight: 600;\n          min-height: calc(5 * var(--fwcu));\n        }\n        button:first-child {\n          border-top-left-radius: var(--border-radius);\n          border-bottom-left-radius: var(--border-radius);\n        }\n        button:last-child {\n          border-right: 1px solid var(--color-gray-six);\n          border-top-right-radius: var(--border-radius);\n          border-bottom-right-radius: var(--border-radius);\n        }\n        button.selected {\n          background: var(--color-primary);\n          color: white;\n        }\n        button:hover:not(.selected) {\n          background-color: var(--color-primary-hover);\n          color: white;\n        }\n\n        .sm button {\n          font-size: calc(1.5 * var(--fwcu));\n          padding-top: calc(1 * var(--fwcu));\n          padding-bottom: calc(1 * var(--fwcu));\n          min-height: calc(3.75 * var(--fwcu));\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        _current: {},
        labelAriaTabList: {
          attribute: 'label-aria-tab-list',
          type: String
        },
        size: {
          type: String
        },
        // sm | lg
        tabs: {
          type: Array
        },
        inline: {
          type: Boolean
        },
        tabsOnly: {
          attribute: 'tabs-only',
          type: Boolean
        }
      };
    }
  }]);
  return FwcTabsComponent;
}(LitElement);
var FwcTabs = /*#__PURE__*/function (_FwcBase38) {
  _inherits$1(FwcTabs, _FwcBase38);
  var _super84 = _createSuper$8(FwcTabs);
  function FwcTabs() {
    _classCallCheck$1(this, FwcTabs);
    return _super84.call(this, 'fwc-tabs', FwcTabsComponent);
  }
  return _createClass$1(FwcTabs);
}(FwcBase$1);
var FwcTooltipComponent = /*#__PURE__*/function (_LitElement48) {
  _inherits$1(FwcTooltipComponent, _LitElement48);
  var _super87 = _createSuper$8(FwcTooltipComponent);
  function FwcTooltipComponent() {
    var _this125;
    _classCallCheck$1(this, FwcTooltipComponent);
    _this125 = _super87.call(this);
    _this125.show = false;
    _this125.icon = false;
    _this125.message = '';
    _this125.tip = '';
    _this125.term = '';
    _this125.position = {
      transform: 'translate(0,0)'
    };
    _this125._defaultSvg = '';
    _this125.labelAriaTipTerm = 'Tooltip:';
    _this125.mobileBreak = breakpoints$1.sm;
    _this125.isMobile = function () {
      return window.innerWidth <= _this125.mobileBreak;
    };
    _this125._handleWindowResize = debounce$2(function () {
      _this125.requestUpdate();
      _this125.updateComplete.then(function () {
        _this125._positionTooltip();
      });
    }, 250);
    _this125._handleScroll = debounce$2(function () {
      _this125.requestUpdate();
      _this125._positionTooltip();
    }, 150);
    return _this125;
  }
  _createClass$1(FwcTooltipComponent, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(FwcTooltipComponent.prototype), "connectedCallback", this).call(this);
      window.addEventListener('resize', this._handleWindowResize);
      window.addEventListener('scroll', this._handleScroll);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      window.removeEventListener('resize', this._handleWindowResize);
      window.removeEventListener('scroll', this._handleScroll);
      _get(_getPrototypeOf(FwcTooltipComponent.prototype), "disconnectedCallback", this).call(this);
    }
  }, {
    key: "firstUpdated",
    value: function firstUpdated() {
      this._positionTooltip();
      this.tip = this.message;
      this._setSvg();
    }
  }, {
    key: "_svg",
    value: function _svg() {
      return html(_templateObject199 || (_templateObject199 = _taggedTemplateLiteral(["\n      <svg\n        xmlns=\"http://www.w3.org/2000/svg\"\n        width=\"51\"\n        height=\"50\"\n        viewBox=\"0 0 51 50\"\n        focusable=\"false\"\n        aria-hidden=\"true\"\n      >\n        <path\n          d=\"M25,50 C11.2141927,50 0,38.7858073 0,25 C0,11.2141927 11.2141927,0 25,0 C38.7858073,0 50,11.2141927 50,25 C50,38.7858073 38.7858073,50 25,50 Z M25,45.8333333 C36.5315755,45.8333333 45.8333333,36.5315755 45.8333333,25 C45.8333333,13.4684245 36.5315755,4.16666667 25,4.16666667 C13.4684245,4.16666667 4.16666667,13.4684245 4.16666667,25 C4.16666667,36.5315755 13.4684245,45.8333333 25,45.8333333 Z M25,37.5 C20.4182943,37.5 16.6666667,33.7483724 16.6666667,29.1666667 L20.8333333,29.1666667 C20.8333333,31.4941406 22.672526,33.3333333 25,33.3333333 C27.327474,33.3333333 29.1666667,31.4941406 29.1666667,29.1666667 C29.1666667,27.5716146 28.141276,26.155599 26.6276042,25.6510417 L25.78125,25.390625 C24.0804036,24.8291016 22.9166667,23.2014974 22.9166667,21.4192708 L22.9166667,18.75 L27.0833333,18.75 L27.0833333,21.4192708 L27.9296875,21.6796875 C31.1360677,22.7457682 33.3333333,25.789388 33.3333333,29.1666667 C33.3333333,33.7483724 29.5817057,37.5 25,37.5 Z M22.9166667,16.6666667 L22.9166667,12.5 L27.0833333,12.5 L27.0833333,16.6666667 L22.9166667,16.6666667 Z\"\n          transform=\"matrix(1 0 0 -1 0 50)\"\n        />\n      </svg>\n    "])));
    }
  }, {
    key: "_setSvg",
    value: function _setSvg() {
      if (this._hasSlottedSvg() || !this.icon) {
        this._defaultSvg = '';
        return;
      }
      this._defaultSvg = this._svg();
    }
  }, {
    key: "_hasSlottedSvg",
    value: function _hasSlottedSvg() {
      var slot = this.shadowRoot.querySelector('slot');
      var childNodes = slot ? slot.assignedNodes({
        flatten: true
      }) : [];
      return Array.prototype.some.call(childNodes, function (node) {
        return node.nodeName === 'svg';
      });
    }
  }, {
    key: "_handleBlur",
    value: function _handleBlur() {
      if (this.show) {
        this._closeTooltip();
      }
    }
  }, {
    key: "_handleKeyDown",
    value: function _handleKeyDown(event) {
      switch (event.code) {
        case 'Escape':
          if (this.show) {
            this._closeTooltip();
          }
          break;
        case 'Enter':
        case 'Space':
          if (!this.show) {
            this._openTooltip();
          }
          break;
      }
    }
  }, {
    key: "_openTooltip",
    value: function _openTooltip() {
      this.tip = this.message;
      this._positionTooltip();
      this.show = true;
    }
  }, {
    key: "_closeTooltip",
    value: function _closeTooltip() {
      this.show = false;
      var event = new CustomEvent('fwc-tooltip-close', {
        detail: this,
        bubbles: false
      });
      this.dispatchEvent(event);
    }
  }, {
    key: "_positionTooltip",
    value: function _positionTooltip() {
      this.isMobile();
      var host = this.getBoundingClientRect();
      // need to figure out why the tip getBoundingClientRect is off when resizing screen from mobile to desktop
      var tip = this.shadowRoot.querySelector('.tip').getBoundingClientRect();
      var left = 0;
      var top = 0;
      top = host.top - tip.height - 10;
      left = host.right - host.width;
      if (top <= 0) {
        top = host.top + host.height + 10;
      }
      // if starting host point and tip width extends beyond window. subtract tip width and -40 more pxs
      if (host.left + tip.width > window.innerWidth) {
        left = window.innerWidth - tip.width - 40;
      }
      top = top + 'px';
      left = left + 'px';
      this.position.transform = "translate(".concat(left, ",").concat(top, ")");
      this.requestUpdate();
    }
  }, {
    key: "_toggleTooltip",
    value: function _toggleTooltip() {
      if (this.show) {
        this._closeTooltip();
      } else {
        this._openTooltip();
      }
    }
  }, {
    key: "_initTooltip",
    value: function _initTooltip() {
      return html(_templateObject200 || (_templateObject200 = _taggedTemplateLiteral([" <div\n      class=\"tip-container ", "\"\n      aria-hidden=\"", "\"\n    >\n      <div class=\"tip\" style=", ">\n        <span\n          id=\"TooltipDef\"\n          role=\"tooltip\"\n          aria-label=\"", " ", "\"\n          >", "</span\n        >\n      </div>\n    </div>"])), this.show ? 'show' : '', !this.show, styleMap(this.position), this.labelAriaTipTerm, this.tip, this.tip);
    }
  }, {
    key: "_tooltipBtn",
    value: function _tooltipBtn() {
      return html(_templateObject201 || (_templateObject201 = _taggedTemplateLiteral(["\n      <div\n        id=\"Tooltip\"\n        class=\"tip-btn ", " ", "\"\n        tabindex=\"", "\"\n        aria-describedby=\"TooltipDef\"\n        @click=", "\n        @keydown=", "\n        @blur=", "\n        aria-hidden=\"", "\"\n      >\n        <span class=\"", "\"\n          >", "</span\n        >\n        ", "\n        <!-- slot is used for custom svg -->\n        <slot></slot>\n      </div>\n    "])), this.light ? 'light' : '', this.disabled ? 'disabled' : '', this.disabled ? -1 : 0, this._toggleTooltip, this._handleKeyDown, this._handleBlur, this.disabled, this.icon || this._hasSlottedSvg() ? 'sr-only' : '', this.term, this._defaultSvg);
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject202 || (_templateObject202 = _taggedTemplateLiteral(["\n      ", "\n      <div\n        @click=", "\n        class=\"fwc-click-out ", "\"\n      ></div>\n      ", "\n    "])), this._tooltipBtn(), this._closeTooltip, this.show ? 'show' : '', this._initTooltip());
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles$1, css$1(_templateObject203 || (_templateObject203 = _taggedTemplateLiteral(["\n        :host {\n          display: inline-block;\n          width: auto;\n        }\n        :host *:not(h2) {\n          font-family: var(--font-sans-serif);\n        }\n        .hidden {\n          display: none;\n        }\n        section {\n          display: none;\n        }\n        h2 {\n          font-size: calc(3.25 * var(--fwcu));\n          font-family: var(--font-serif);\n          color: var(--color-gray-one);\n          margin-top: 0;\n          text-transform: capitalize;\n        }\n        .term {\n          display: inline;\n        }\n        .term span {\n          font-size: var(--default-font-size);\n          padding-right: calc(0.5 * var(--fwcu));\n        }\n        .tip {\n          opacity: 0;\n          border: 1px solid var(--color-primary);\n          border-radius: var(--border-radius);\n          padding: calc(2 * var(--fwcu));\n          max-width: calc(35 * var(--fwcu));\n          max-height: calc(18 * var(--fwcu));\n          background: white;\n          box-shadow: var(--box-shadow);\n          transition: all 500ms cubic-bezier(0.68, -0.55, 0.265, 1.55);\n        }\n        .tip span {\n          font-size: var(--default-font-size);\n          color: var(--color-gray-one);\n        }\n        .tip-container {\n          position: fixed;\n          display: inline;\n          top: 0;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          pointer-events: none;\n          z-index: 10;\n          overflow: hidden;\n        }\n        .tip-container.show {\n          overflow: visible;\n        }\n        .tip-container.show .tip {\n          opacity: 1;\n          pointer-events: all;\n        }\n        .tip-btn {\n          border: none;\n          background: none;\n          padding: 0;\n          cursor: pointer;\n          display: inline;\n        }\n        .tip-btn span {\n          color: var(--color-primary);\n          border-bottom: 1px dotted var(--color-primary);\n          font-size: var(--default-font-size);\n          font-weight: 600;\n        }\n\n        .tip-btn.light span {\n          color: var(--color-white);\n          border-bottom: 1px dotted var(--color-white);\n        }\n\n        .tip-btn svg,\n        ::slotted(svg) {\n          height: calc(1.75 * var(--fwcu));\n          width: calc(1.75 * var(--fwcu));\n          fill: var(--color-primary);\n        }\n        .tip-btn.light svg,\n        ::slotted(svg.light) {\n          fill: var(--color-white);\n        }\n\n        .fwc-click-out {\n          display: inline;\n          position: fixed;\n        }\n        .fwc-click-out.show {\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n          z-index: 1;\n        }\n        .disabled {\n          opacity: 0.3;\n          cursor: default;\n          pointer-events: none;\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        icon: {
          type: Boolean
        },
        position: {
          type: Object
        },
        message: {
          type: String
        },
        show: {
          type: Boolean
        },
        term: {
          type: String
        },
        disabled: {
          attribute: 'disabled',
          type: Boolean
        },
        light: {
          attribute: 'light',
          type: Boolean
        },
        labelAriaTipTerm: {
          attribute: 'label-aria-tip-term',
          type: String
        }
      };
    }
  }]);
  return FwcTooltipComponent;
}(LitElement);
var FwcTooltip = /*#__PURE__*/function (_FwcBase40) {
  _inherits$1(FwcTooltip, _FwcBase40);
  var _super88 = _createSuper$8(FwcTooltip);
  function FwcTooltip() {
    _classCallCheck$1(this, FwcTooltip);
    return _super88.call(this, 'fwc-tooltip', FwcTooltipComponent);
  }
  return _createClass$1(FwcTooltip);
}(FwcBase$1);

function ascending$1(a, b) {
  return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function descending(a, b) {
  return a == null || b == null ? NaN
    : b < a ? -1
    : b > a ? 1
    : b >= a ? 0
    : NaN;
}

function bisector(f) {
  let compare1, compare2, delta;

  // If an accessor is specified, promote it to a comparator. In this case we
  // can test whether the search value is (self-) comparable. We can’t do this
  // for a comparator (except for specific, known comparators) because we can’t
  // tell if the comparator is symmetric, and an asymmetric comparator can’t be
  // used to test whether a single value is comparable.
  if (f.length !== 2) {
    compare1 = ascending$1;
    compare2 = (d, x) => ascending$1(f(d), x);
    delta = (d, x) => f(d) - x;
  } else {
    compare1 = f === ascending$1 || f === descending ? f : zero$1;
    compare2 = f;
    delta = f;
  }

  function left(a, x, lo = 0, hi = a.length) {
    if (lo < hi) {
      if (compare1(x, x) !== 0) return hi;
      do {
        const mid = (lo + hi) >>> 1;
        if (compare2(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }

  function right(a, x, lo = 0, hi = a.length) {
    if (lo < hi) {
      if (compare1(x, x) !== 0) return hi;
      do {
        const mid = (lo + hi) >>> 1;
        if (compare2(a[mid], x) <= 0) lo = mid + 1;
        else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }

  function center(a, x, lo = 0, hi = a.length) {
    const i = left(a, x, lo, hi - 1);
    return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
  }

  return {left, center, right};
}

function zero$1() {
  return 0;
}

function number$3(x) {
  return x === null ? NaN : +x;
}

const ascendingBisect = bisector(ascending$1);
const bisectRight = ascendingBisect.right;
bisector(number$3).center;
var bisect = bisectRight;

function extent(values, valueof) {
  let min;
  let max;
  if (valueof === undefined) {
    for (const value of values) {
      if (value != null) {
        if (min === undefined) {
          if (value >= value) min = max = value;
        } else {
          if (min > value) min = value;
          if (max < value) max = value;
        }
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null) {
        if (min === undefined) {
          if (value >= value) min = max = value;
        } else {
          if (min > value) min = value;
          if (max < value) max = value;
        }
      }
    }
  }
  return [min, max];
}

class InternMap extends Map {
  constructor(entries, key = keyof) {
    super();
    Object.defineProperties(this, {_intern: {value: new Map()}, _key: {value: key}});
    if (entries != null) for (const [key, value] of entries) this.set(key, value);
  }
  get(key) {
    return super.get(intern_get(this, key));
  }
  has(key) {
    return super.has(intern_get(this, key));
  }
  set(key, value) {
    return super.set(intern_set(this, key), value);
  }
  delete(key) {
    return super.delete(intern_delete(this, key));
  }
}

function intern_get({_intern, _key}, value) {
  const key = _key(value);
  return _intern.has(key) ? _intern.get(key) : value;
}

function intern_set({_intern, _key}, value) {
  const key = _key(value);
  if (_intern.has(key)) return _intern.get(key);
  _intern.set(key, value);
  return value;
}

function intern_delete({_intern, _key}, value) {
  const key = _key(value);
  if (_intern.has(key)) {
    value = _intern.get(key);
    _intern.delete(key);
  }
  return value;
}

function keyof(value) {
  return value !== null && typeof value === "object" ? value.valueOf() : value;
}

const e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

function tickSpec(start, stop, count) {
  const step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log10(step)),
      error = step / Math.pow(10, power),
      factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1;
  let i1, i2, inc;
  if (power < 0) {
    inc = Math.pow(10, -power) / factor;
    i1 = Math.round(start * inc);
    i2 = Math.round(stop * inc);
    if (i1 / inc < start) ++i1;
    if (i2 / inc > stop) --i2;
    inc = -inc;
  } else {
    inc = Math.pow(10, power) * factor;
    i1 = Math.round(start / inc);
    i2 = Math.round(stop / inc);
    if (i1 * inc < start) ++i1;
    if (i2 * inc > stop) --i2;
  }
  if (i2 < i1 && 0.5 <= count && count < 2) return tickSpec(start, stop, count * 2);
  return [i1, i2, inc];
}

function ticks(start, stop, count) {
  stop = +stop, start = +start, count = +count;
  if (!(count > 0)) return [];
  if (start === stop) return [start];
  const reverse = stop < start, [i1, i2, inc] = reverse ? tickSpec(stop, start, count) : tickSpec(start, stop, count);
  if (!(i2 >= i1)) return [];
  const n = i2 - i1 + 1, ticks = new Array(n);
  if (reverse) {
    if (inc < 0) for (let i = 0; i < n; ++i) ticks[i] = (i2 - i) / -inc;
    else for (let i = 0; i < n; ++i) ticks[i] = (i2 - i) * inc;
  } else {
    if (inc < 0) for (let i = 0; i < n; ++i) ticks[i] = (i1 + i) / -inc;
    else for (let i = 0; i < n; ++i) ticks[i] = (i1 + i) * inc;
  }
  return ticks;
}

function tickIncrement(start, stop, count) {
  stop = +stop, start = +start, count = +count;
  return tickSpec(start, stop, count)[2];
}

function tickStep(start, stop, count) {
  stop = +stop, start = +start, count = +count;
  const reverse = stop < start, inc = reverse ? tickIncrement(stop, start, count) : tickIncrement(start, stop, count);
  return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}

function max$2(values, valueof) {
  let max;
  if (valueof === undefined) {
    for (const value of values) {
      if (value != null
          && (max < value || (max === undefined && value >= value))) {
        max = value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null
          && (max < value || (max === undefined && value >= value))) {
        max = value;
      }
    }
  }
  return max;
}

function range(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
}

function identity$3(x) {
  return x;
}

var top$1 = 1,
    right$1 = 2,
    bottom$1 = 3,
    left$1 = 4,
    epsilon$2 = 1e-6;

function translateX(x) {
  return "translate(" + x + ",0)";
}

function translateY(y) {
  return "translate(0," + y + ")";
}

function number$2(scale) {
  return d => +scale(d);
}

function center(scale, offset) {
  offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
  if (scale.round()) offset = Math.round(offset);
  return d => +scale(d) + offset;
}

function entering() {
  return !this.__axis;
}

function axis(orient, scale) {
  var tickArguments = [],
      tickValues = null,
      tickFormat = null,
      tickSizeInner = 6,
      tickSizeOuter = 6,
      tickPadding = 3,
      offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5,
      k = orient === top$1 || orient === left$1 ? -1 : 1,
      x = orient === left$1 || orient === right$1 ? "x" : "y",
      transform = orient === top$1 || orient === bottom$1 ? translateX : translateY;

  function axis(context) {
    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity$3) : tickFormat,
        spacing = Math.max(tickSizeInner, 0) + tickPadding,
        range = scale.range(),
        range0 = +range[0] + offset,
        range1 = +range[range.length - 1] + offset,
        position = (scale.bandwidth ? center : number$2)(scale.copy(), offset),
        selection = context.selection ? context.selection() : context,
        path = selection.selectAll(".domain").data([null]),
        tick = selection.selectAll(".tick").data(values, scale).order(),
        tickExit = tick.exit(),
        tickEnter = tick.enter().append("g").attr("class", "tick"),
        line = tick.select("line"),
        text = tick.select("text");

    path = path.merge(path.enter().insert("path", ".tick")
        .attr("class", "domain")
        .attr("stroke", "currentColor"));

    tick = tick.merge(tickEnter);

    line = line.merge(tickEnter.append("line")
        .attr("stroke", "currentColor")
        .attr(x + "2", k * tickSizeInner));

    text = text.merge(tickEnter.append("text")
        .attr("fill", "currentColor")
        .attr(x, k * spacing)
        .attr("dy", orient === top$1 ? "0em" : orient === bottom$1 ? "0.71em" : "0.32em"));

    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);

      tickExit = tickExit.transition(context)
          .attr("opacity", epsilon$2)
          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform"); });

      tickEnter
          .attr("opacity", epsilon$2)
          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset); });
    }

    tickExit.remove();

    path
        .attr("d", orient === left$1 || orient === right$1
            ? (tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1)
            : (tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1));

    tick
        .attr("opacity", 1)
        .attr("transform", function(d) { return transform(position(d) + offset); });

    line
        .attr(x + "2", k * tickSizeInner);

    text
        .attr(x, k * spacing)
        .text(format);

    selection.filter(entering)
        .attr("fill", "none")
        .attr("font-size", 10)
        .attr("font-family", "sans-serif")
        .attr("text-anchor", orient === right$1 ? "start" : orient === left$1 ? "end" : "middle");

    selection
        .each(function() { this.__axis = position; });
  }

  axis.scale = function(_) {
    return arguments.length ? (scale = _, axis) : scale;
  };

  axis.ticks = function() {
    return tickArguments = Array.from(arguments), axis;
  };

  axis.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : Array.from(_), axis) : tickArguments.slice();
  };

  axis.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : Array.from(_), axis) : tickValues && tickValues.slice();
  };

  axis.tickFormat = function(_) {
    return arguments.length ? (tickFormat = _, axis) : tickFormat;
  };

  axis.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
  };

  axis.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
  };

  axis.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
  };

  axis.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
  };

  axis.offset = function(_) {
    return arguments.length ? (offset = +_, axis) : offset;
  };

  return axis;
}

function axisBottom(scale) {
  return axis(bottom$1, scale);
}

function axisLeft(scale) {
  return axis(left$1, scale);
}

var noop$1 = {value: () => {}};

function dispatch$1() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _) || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames$1(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch$1.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames$1(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get$2(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set$1(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set$1(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get$2(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set$1(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop$1, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

var xhtml = "http://www.w3.org/1999/xhtml";

var namespaces = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};

function namespace(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name; // eslint-disable-line no-prototype-builtins
}

function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === xhtml && document.documentElement.namespaceURI === xhtml
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

function creator(name) {
  var fullname = namespace(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
}

function none$2() {}

function selector(selector) {
  return selector == null ? none$2 : function() {
    return this.querySelector(selector);
  };
}

function selection_select(select) {
  if (typeof select !== "function") select = selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new Selection$1(subgroups, this._parents);
}

// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function array$1(x) {
  return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}

function empty() {
  return [];
}

function selectorAll(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
}

function arrayAll(select) {
  return function() {
    return array$1(select.apply(this, arguments));
  };
}

function selection_selectAll(select) {
  if (typeof select === "function") select = arrayAll(select);
  else select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new Selection$1(subgroups, parents);
}

function matcher(selector) {
  return function() {
    return this.matches(selector);
  };
}

function childMatcher(selector) {
  return function(node) {
    return node.matches(selector);
  };
}

var find = Array.prototype.find;

function childFind(match) {
  return function() {
    return find.call(this.children, match);
  };
}

function childFirst() {
  return this.firstElementChild;
}

function selection_selectChild(match) {
  return this.select(match == null ? childFirst
      : childFind(typeof match === "function" ? match : childMatcher(match)));
}

var filter = Array.prototype.filter;

function children() {
  return Array.from(this.children);
}

function childrenFilter(match) {
  return function() {
    return filter.call(this.children, match);
  };
}

function selection_selectChildren(match) {
  return this.selectAll(match == null ? children
      : childrenFilter(typeof match === "function" ? match : childMatcher(match)));
}

function selection_filter(match) {
  if (typeof match !== "function") match = matcher(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Selection$1(subgroups, this._parents);
}

function sparse(update) {
  return new Array(update.length);
}

function selection_enter() {
  return new Selection$1(this._enter || this._groups.map(sparse), this._parents);
}

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};

function constant$2(x) {
  return function() {
    return x;
  };
}

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = new Map,
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
      if (nodeByKeyValue.has(keyValue)) {
        exit[i] = node;
      } else {
        nodeByKeyValue.set(keyValue, node);
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = key.call(parent, data[i], i, data) + "";
    if (node = nodeByKeyValue.get(keyValue)) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue.delete(keyValue);
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue.get(keyValues[i]) === node)) {
      exit[i] = node;
    }
  }
}

function datum(node) {
  return node.__data__;
}

function selection_data(value, key) {
  if (!arguments.length) return Array.from(this, datum);

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = constant$2(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = arraylike(value.call(parent, parent && parent.__data__, j, parents)),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new Selection$1(update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
}

// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function arraylike(data) {
  return typeof data === "object" && "length" in data
    ? data // Array, TypedArray, NodeList, array-like
    : Array.from(data); // Map, Set, iterable, string, or anything else
}

function selection_exit() {
  return new Selection$1(this._exit || this._groups.map(sparse), this._parents);
}

function selection_join(onenter, onupdate, onexit) {
  var enter = this.enter(), update = this, exit = this.exit();
  if (typeof onenter === "function") {
    enter = onenter(enter);
    if (enter) enter = enter.selection();
  } else {
    enter = enter.append(onenter + "");
  }
  if (onupdate != null) {
    update = onupdate(update);
    if (update) update = update.selection();
  }
  if (onexit == null) exit.remove(); else onexit(exit);
  return enter && update ? enter.merge(update).order() : update;
}

function selection_merge(context) {
  var selection = context.selection ? context.selection() : context;

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Selection$1(merges, this._parents);
}

function selection_order() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
}

function selection_sort(compare) {
  if (!compare) compare = ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new Selection$1(sortgroups, this._parents).order();
}

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function selection_call() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
}

function selection_nodes() {
  return Array.from(this);
}

function selection_node() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
}

function selection_size() {
  let size = 0;
  for (const node of this) ++size; // eslint-disable-line no-unused-vars
  return size;
}

function selection_empty() {
  return !this.node();
}

function selection_each(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
}

function attrRemove$1(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS$1(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant$1(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS$1(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction$1(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS$1(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

function selection_attr(name, value) {
  var fullname = namespace(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS$1 : attrRemove$1) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS$1 : attrFunction$1)
      : (fullname.local ? attrConstantNS$1 : attrConstant$1)))(fullname, value));
}

function defaultView(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
}

function styleRemove$1(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant$1(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction$1(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

function selection_style(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove$1 : typeof value === "function"
            ? styleFunction$1
            : styleConstant$1)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
}

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
}

function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

function selection_property(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
}

function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

function selection_classed(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
}

function textRemove() {
  this.textContent = "";
}

function textConstant$1(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction$1(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

function selection_text(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction$1
          : textConstant$1)(value))
      : this.node().textContent;
}

function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

function selection_html(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
}

function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

function selection_raise() {
  return this.each(raise);
}

function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

function selection_lower() {
  return this.each(lower);
}

function selection_append(name) {
  var create = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
}

function constantNull() {
  return null;
}

function selection_insert(name, before) {
  var create = typeof name === "function" ? name : creator(name),
      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
}

function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

function selection_remove() {
  return this.each(remove);
}

function selection_cloneShallow() {
  var clone = this.cloneNode(false), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

function selection_cloneDeep() {
  var clone = this.cloneNode(true), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

function selection_clone(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
}

function selection_datum(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
}

function contextListener(listener) {
  return function(event) {
    listener.call(this, event, this.__data__);
  };
}

function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, options) {
  return function() {
    var on = this.__on, o, listener = contextListener(value);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
        this.addEventListener(o.type, o.listener = listener, o.options = options);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, options);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, options: options};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

function selection_on(typename, value, options) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, options));
  return this;
}

function dispatchEvent(node, type, params) {
  var window = defaultView(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

function selection_dispatch(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
}

function* selection_iterator() {
  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) yield node;
    }
  }
}

var root = [null];

function Selection$1(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection$1([[document.documentElement]], root);
}

function selection_selection() {
  return this;
}

Selection$1.prototype = selection.prototype = {
  constructor: Selection$1,
  select: selection_select,
  selectAll: selection_selectAll,
  selectChild: selection_selectChild,
  selectChildren: selection_selectChildren,
  filter: selection_filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  join: selection_join,
  merge: selection_merge,
  selection: selection_selection,
  order: selection_order,
  sort: selection_sort,
  call: selection_call,
  nodes: selection_nodes,
  node: selection_node,
  size: selection_size,
  empty: selection_empty,
  each: selection_each,
  attr: selection_attr,
  style: selection_style,
  property: selection_property,
  classed: selection_classed,
  text: selection_text,
  html: selection_html,
  raise: selection_raise,
  lower: selection_lower,
  append: selection_append,
  insert: selection_insert,
  remove: selection_remove,
  clone: selection_clone,
  datum: selection_datum,
  on: selection_on,
  dispatch: selection_dispatch,
  [Symbol.iterator]: selection_iterator
};

function select(selector) {
  return typeof selector === "string"
      ? new Selection$1([[document.querySelector(selector)]], [document.documentElement])
      : new Selection$1([[selector]], root);
}

function sourceEvent(event) {
  let sourceEvent;
  while (sourceEvent = event.sourceEvent) event = sourceEvent;
  return event;
}

function pointer(event, node) {
  event = sourceEvent(event);
  if (node === undefined) node = event.currentTarget;
  if (node) {
    var svg = node.ownerSVGElement || node;
    if (svg.createSVGPoint) {
      var point = svg.createSVGPoint();
      point.x = event.clientX, point.y = event.clientY;
      point = point.matrixTransform(node.getScreenCTM().inverse());
      return [point.x, point.y];
    }
    if (node.getBoundingClientRect) {
      var rect = node.getBoundingClientRect();
      return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
    }
  }
  return [event.pageX, event.pageY];
}

function selectAll(selector) {
  return typeof selector === "string"
      ? new Selection$1([document.querySelectorAll(selector)], [document.documentElement])
      : new Selection$1([array$1(selector)], root);
}

function define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`),
    reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`),
    reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`),
    reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`),
    reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`),
    reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

define(Color, color, {
  copy(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHex8() {
  return this.rgb().formatHex8();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
      : null) // invalid hex
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

define(Rgb, rgb, extend(Color, {
  brighter(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}

function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}

function rgb_formatRgb() {
  const a = clampa(this.opacity);
  return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}

function clampa(opacity) {
  return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}

function clampi(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}

function hex(value) {
  value = clampi(value);
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hsl, hsl, extend(Color, {
  brighter(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
  }
}));

function clamph(value) {
  value = (value || 0) % 360;
  return value < 0 ? value + 360 : value;
}

function clampt(value) {
  return Math.max(0, Math.min(1, value || 0));
}

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

var constant$1 = x => () => x;

function linear$1(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : constant$1(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear$1(a, d) : constant$1(isNaN(a) ? b : a);
}

var interpolateRgb = (function rgbGamma(y) {
  var color = gamma(y);

  function rgb$1(start, end) {
    var r = color((start = rgb(start)).r, (end = rgb(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb$1.gamma = rgbGamma;

  return rgb$1;
})(1);

function numberArray(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}

function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = interpolate$1(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}

function date$1(a, b) {
  var d = new Date;
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}

function interpolateNumber(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}

function object(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = interpolate$1(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
}

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

function interpolateString(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: interpolateNumber(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
}

function interpolate$1(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? constant$1(b)
      : (t === "number" ? interpolateNumber
      : t === "string" ? ((c = color(b)) ? (b = c, interpolateRgb) : interpolateString)
      : b instanceof color ? interpolateRgb
      : b instanceof Date ? date$1
      : isNumberArray(b) ? numberArray
      : Array.isArray(b) ? genericArray
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
      : interpolateNumber)(a, b);
}

function interpolateRound(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
}

var degrees = 180 / Math.PI;

var identity$2 = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

function decompose(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
}

var svgNode;

/* eslint-disable no-undef */
function parseCss(value) {
  const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
  return m.isIdentity ? identity$2 : decompose(m.a, m.b, m.c, m.d, m.e, m.f);
}

function parseSvg(value) {
  if (value == null) return identity$2;
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return identity$2;
  value = value.matrix;
  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
}

function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: interpolateNumber(xa, xb)}, {i: i - 2, x: interpolateNumber(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: interpolateNumber(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: interpolateNumber(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: interpolateNumber(xa, xb)}, {i: i - 2, x: interpolateNumber(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");

var frame = 0, // is an animation frame pending?
    timeout$1 = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(undefined, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout$1 = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout$1) timeout$1 = clearTimeout(timeout$1);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout$1 = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}

function timeout(callback, delay, time) {
  var t = new Timer;
  delay = delay == null ? 0 : +delay;
  t.restart(elapsed => {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
}

var emptyOn = dispatch$1("start", "end", "cancel", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

function schedule(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
}

function init(node, id) {
  var schedule = get$1(node, id);
  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
  return schedule;
}

function set(node, id) {
  var schedule = get$1(node, id);
  if (schedule.state > STARTED) throw new Error("too late; already running");
  return schedule;
}

function get$1(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = timer(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return timeout(start);

      // Interrupt the active transition, if any.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions.
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("cancel", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    timeout(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(node, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}

function interrupt(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > STARTING && schedule.state < ENDING;
    schedule.state = ENDED;
    schedule.timer.stop();
    schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
}

function selection_interrupt(name) {
  return this.each(function() {
    interrupt(this, name);
  });
}

function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = set(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = set(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

function transition_tween(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = get$1(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
}

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = set(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return get$1(node, id).value[name];
  };
}

function interpolate(a, b) {
  var c;
  return (typeof b === "number" ? interpolateNumber
      : b instanceof color ? interpolateRgb
      : (c = color(b)) ? (b = c, interpolateRgb)
      : interpolateString)(a, b);
}

function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = this.getAttribute(name);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function attrConstantNS(fullname, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = this.getAttributeNS(fullname.space, fullname.local);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function attrFunction(name, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttribute(name);
    string0 = this.getAttribute(name);
    string1 = value1 + "";
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function attrFunctionNS(fullname, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    string0 = this.getAttributeNS(fullname.space, fullname.local);
    string1 = value1 + "";
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function transition_attr(name, value) {
  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate;
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, tweenValue(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname)
      : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
}

function attrInterpolate(name, i) {
  return function(t) {
    this.setAttribute(name, i.call(this, t));
  };
}

function attrInterpolateNS(fullname, i) {
  return function(t) {
    this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
  };
}

function attrTweenNS(fullname, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
    return t0;
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
    return t0;
  }
  tween._value = value;
  return tween;
}

function transition_attrTween(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = namespace(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
}

function delayFunction(id, value) {
  return function() {
    init(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    init(this, id).delay = value;
  };
}

function transition_delay(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : get$1(this.node(), id).delay;
}

function durationFunction(id, value) {
  return function() {
    set(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    set(this, id).duration = value;
  };
}

function transition_duration(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : get$1(this.node(), id).duration;
}

function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    set(this, id).ease = value;
  };
}

function transition_ease(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : get$1(this.node(), id).ease;
}

function easeVarying(id, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (typeof v !== "function") throw new Error;
    set(this, id).ease = v;
  };
}

function transition_easeVarying(value) {
  if (typeof value !== "function") throw new Error;
  return this.each(easeVarying(this._id, value));
}

function transition_filter(match) {
  if (typeof match !== "function") match = matcher(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Transition(subgroups, this._parents, this._name, this._id);
}

function transition_merge(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Transition(merges, this._parents, this._name, this._id);
}

function start$1(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start$1(name) ? init : set;
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

function transition_on(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? get$1(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
}

function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

function transition_remove() {
  return this.on("end.remove", removeFunction(this._id));
}

function transition_select(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        schedule(subgroup[i], name, id, i, subgroup, get$1(node, id));
      }
    }
  }

  return new Transition(subgroups, this._parents, name, id);
}

function transition_selectAll(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = get$1(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            schedule(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new Transition(subgroups, parents, name, id);
}

var Selection = selection.prototype.constructor;

function transition_selection() {
  return new Selection(this._groups, this._parents);
}

function styleNull(name, interpolate) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0 = styleValue(this, name),
        string1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, string10 = string1);
  };
}

function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = styleValue(this, name);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function styleFunction(name, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0 = styleValue(this, name),
        value1 = value(this),
        string1 = value1 + "";
    if (value1 == null) string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function styleMaybeRemove(id, name) {
  var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
  return function() {
    var schedule = set(this, id),
        on = schedule.on,
        listener = schedule.value[key] == null ? remove || (remove = styleRemove(name)) : undefined;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);

    schedule.on = on1;
  };
}

function transition_style(name, value, priority) {
  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate;
  return value == null ? this
      .styleTween(name, styleNull(name, i))
      .on("end.style." + name, styleRemove(name))
    : typeof value === "function" ? this
      .styleTween(name, styleFunction(name, i, tweenValue(this, "style." + name, value)))
      .each(styleMaybeRemove(this._id, name))
    : this
      .styleTween(name, styleConstant(name, i, value), priority)
      .on("end.style." + name, null);
}

function styleInterpolate(name, i, priority) {
  return function(t) {
    this.style.setProperty(name, i.call(this, t), priority);
  };
}

function styleTween(name, value, priority) {
  var t, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
    return t;
  }
  tween._value = value;
  return tween;
}

function transition_styleTween(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

function transition_text(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction(tweenValue(this, "text", value))
      : textConstant(value == null ? "" : value + ""));
}

function textInterpolate(i) {
  return function(t) {
    this.textContent = i.call(this, t);
  };
}

function textTween(value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
    return t0;
  }
  tween._value = value;
  return tween;
}

function transition_textTween(value) {
  var key = "text";
  if (arguments.length < 1) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, textTween(value));
}

function transition_transition() {
  var name = this._name,
      id0 = this._id,
      id1 = newId();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = get$1(node, id0);
        schedule(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new Transition(groups, this._parents, name, id1);
}

function transition_end() {
  var on0, on1, that = this, id = that._id, size = that.size();
  return new Promise(function(resolve, reject) {
    var cancel = {value: reject},
        end = {value: function() { if (--size === 0) resolve(); }};

    that.each(function() {
      var schedule = set(this, id),
          on = schedule.on;

      // If this node shared a dispatch with the previous node,
      // just assign the updated shared dispatch and we’re done!
      // Otherwise, copy-on-write.
      if (on !== on0) {
        on1 = (on0 = on).copy();
        on1._.cancel.push(cancel);
        on1._.interrupt.push(cancel);
        on1._.end.push(end);
      }

      schedule.on = on1;
    });

    // The selection was empty, resolve end immediately
    if (size === 0) resolve();
  });
}

var id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function newId() {
  return ++id;
}

var selection_prototype = selection.prototype;

Transition.prototype = {
  constructor: Transition,
  select: transition_select,
  selectAll: transition_selectAll,
  selectChild: selection_prototype.selectChild,
  selectChildren: selection_prototype.selectChildren,
  filter: transition_filter,
  merge: transition_merge,
  selection: transition_selection,
  transition: transition_transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: transition_attr,
  attrTween: transition_attrTween,
  style: transition_style,
  styleTween: transition_styleTween,
  text: transition_text,
  textTween: transition_textTween,
  remove: transition_remove,
  tween: transition_tween,
  delay: transition_delay,
  duration: transition_duration,
  ease: transition_ease,
  easeVarying: transition_easeVarying,
  end: transition_end,
  [Symbol.iterator]: selection_prototype[Symbol.iterator]
};

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: cubicInOut
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      throw new Error(`transition ${id} not found`);
    }
  }
  return timing;
}

function selection_transition(name) {
  var id,
      timing;

  if (name instanceof Transition) {
    id = name._id, name = name._name;
  } else {
    id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        schedule(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new Transition(groups, this._parents, name, id);
}

selection.prototype.interrupt = selection_interrupt;
selection.prototype.transition = selection_transition;

const pi$1 = Math.PI,
    tau$1 = 2 * pi$1,
    epsilon$1 = 1e-6,
    tauEpsilon = tau$1 - epsilon$1;

function append(strings) {
  this._ += strings[0];
  for (let i = 1, n = strings.length; i < n; ++i) {
    this._ += arguments[i] + strings[i];
  }
}

function appendRound(digits) {
  let d = Math.floor(digits);
  if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
  if (d > 15) return append;
  const k = 10 ** d;
  return function(strings) {
    this._ += strings[0];
    for (let i = 1, n = strings.length; i < n; ++i) {
      this._ += Math.round(arguments[i] * k) / k + strings[i];
    }
  };
}

class Path {
  constructor(digits) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
    this._append = digits == null ? append : appendRound(digits);
  }
  moveTo(x, y) {
    this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
  }
  closePath() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._append`Z`;
    }
  }
  lineTo(x, y) {
    this._append`L${this._x1 = +x},${this._y1 = +y}`;
  }
  quadraticCurveTo(x1, y1, x, y) {
    this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
  }
  bezierCurveTo(x1, y1, x2, y2, x, y) {
    this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
  }
  arcTo(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;

    // Is the radius negative? Error.
    if (r < 0) throw new Error(`negative radius: ${r}`);

    let x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._append`M${this._x1 = x1},${this._y1 = y1}`;
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon$1));

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$1) || !r) {
      this._append`L${this._x1 = x1},${this._y1 = y1}`;
    }

    // Otherwise, draw an arc!
    else {
      let x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi$1 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon$1) {
        this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
      }

      this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
    }
  }
  arc(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;

    // Is the radius negative? Error.
    if (r < 0) throw new Error(`negative radius: ${r}`);

    let dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._append`M${x0},${y0}`;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon$1 || Math.abs(this._y1 - y0) > epsilon$1) {
      this._append`L${x0},${y0}`;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau$1 + tau$1;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon$1) {
      this._append`A${r},${r},0,${+(da >= pi$1)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
  }
  rect(x, y, w, h) {
    this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
  }
  toString() {
    return this._;
  }
}

function formatDecimal(x) {
  return Math.abs(x = Math.round(x)) >= 1e21
      ? x.toLocaleString("en").replace(/,/g, "")
      : x.toString(10);
}

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}

function exponent(x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}

function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
}

function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}

// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};

// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function formatTrim(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

var prefixExponent;

function formatPrefixAuto(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

function formatRounded(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

var formatTypes = {
  "%": (x, p) => (x * 100).toFixed(p),
  "b": (x) => Math.round(x).toString(2),
  "c": (x) => x + "",
  "d": formatDecimal,
  "e": (x, p) => x.toExponential(p),
  "f": (x, p) => x.toFixed(p),
  "g": (x, p) => x.toPrecision(p),
  "o": (x) => Math.round(x).toString(8),
  "p": (x, p) => formatRounded(x * 100, p),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x) => Math.round(x).toString(16).toUpperCase(),
  "x": (x) => Math.round(x).toString(16)
};

function identity$1(x) {
  return x;
}

var map$1 = Array.prototype.map,
    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

function formatLocale$1(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? identity$1 : formatGroup(map$1.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? identity$1 : formatNumerals(map$1.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "−" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";

  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = formatTrim(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}

var locale$1;
var format$1;
var formatPrefix;

defaultLocale$1({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale$1(definition) {
  locale$1 = formatLocale$1(definition);
  format$1 = locale$1.format;
  formatPrefix = locale$1.formatPrefix;
  return locale$1;
}

function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}

function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}

function precisionRound(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent(max) - exponent(step)) + 1;
}

function initRange(domain, range) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.range(domain); break;
    default: this.range(range).domain(domain); break;
  }
  return this;
}

const implicit = Symbol("implicit");

function ordinal() {
  var index = new InternMap(),
      domain = [],
      range = [],
      unknown = implicit;

  function scale(d) {
    let i = index.get(d);
    if (i === undefined) {
      if (unknown !== implicit) return unknown;
      index.set(d, i = domain.push(d) - 1);
    }
    return range[i % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = new InternMap();
    for (const value of _) {
      if (index.has(value)) continue;
      index.set(value, domain.push(value) - 1);
    }
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal(domain, range).unknown(unknown);
  };

  initRange.apply(scale, arguments);

  return scale;
}

function band() {
  var scale = ordinal().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      r0 = 0,
      r1 = 1,
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = r1 < r0,
        start = reverse ? r1 : r0,
        stop = reverse ? r0 : r1;
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = range(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };

  scale.rangeRound = function(_) {
    return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band(domain(), [r0, r1])
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return initRange.apply(rescale(), arguments);
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point$2() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}

function constants(x) {
  return function() {
    return x;
  };
}

function number$1(x) {
  return +x;
}

var unit = [0, 1];

function identity(x) {
  return x;
}

function normalize(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : constants(isNaN(b) ? NaN : 0.5);
}

function clamper(a, b) {
  var t;
  if (a > b) t = a, a = b, b = t;
  return function(x) { return Math.max(a, Math.min(b, x)); };
}

// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
  else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = normalize(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = bisect(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp())
      .unknown(source.unknown());
}

function transformer() {
  var domain = unit,
      range = unit,
      interpolate = interpolate$1,
      transform,
      untransform,
      unknown,
      clamp = identity,
      piecewise,
      output,
      input;

  function rescale() {
    var n = Math.min(domain.length, range.length);
    if (clamp !== identity) clamp = clamper(domain[0], domain[n - 1]);
    piecewise = n > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
  }

  scale.invert = function(y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), interpolateNumber)))(y)));
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = Array.from(_, number$1), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = Array.from(_), interpolate = interpolateRound, rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = _ ? true : identity, rescale()) : clamp !== identity;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}

function continuous() {
  return transformer()(identity, identity);
}

function tickFormat(start, stop, count, specifier) {
  var step = tickStep(start, stop, count),
      precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format$1(specifier);
}

function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    var d = domain();
    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    
    while (maxIter-- > 0) {
      step = tickIncrement(start, stop, count);
      if (step === prestep) {
        d[i0] = start;
        d[i1] = stop;
        return domain(d);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = continuous();

  scale.copy = function() {
    return copy(scale, linear());
  };

  initRange.apply(scale, arguments);

  return linearish(scale);
}

function nice(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
}

const t0 = new Date, t1 = new Date;

function timeInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
  }

  interval.floor = (date) => {
    return floori(date = new Date(+date)), date;
  };

  interval.ceil = (date) => {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = (date) => {
    const d0 = interval(date), d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = (date, step) => {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = (start, stop, step) => {
    const range = [];
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    let previous;
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = (test) => {
    return timeInterval((date) => {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, (date, step) => {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = (start, end) => {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = (step) => {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? (d) => field(d) % step === 0
              : (d) => interval.count(0, d) % step === 0);
    };
  }

  return interval;
}

const millisecond = timeInterval(() => {
  // noop
}, (date, step) => {
  date.setTime(+date + step);
}, (start, end) => {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = (k) => {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return timeInterval((date) => {
    date.setTime(Math.floor(date / k) * k);
  }, (date, step) => {
    date.setTime(+date + step * k);
  }, (start, end) => {
    return (end - start) / k;
  });
};

millisecond.range;

const durationSecond = 1000;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;
const durationMonth = durationDay * 30;
const durationYear = durationDay * 365;

const second = timeInterval((date) => {
  date.setTime(date - date.getMilliseconds());
}, (date, step) => {
  date.setTime(+date + step * durationSecond);
}, (start, end) => {
  return (end - start) / durationSecond;
}, (date) => {
  return date.getUTCSeconds();
});

second.range;

const timeMinute = timeInterval((date) => {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
}, (date, step) => {
  date.setTime(+date + step * durationMinute);
}, (start, end) => {
  return (end - start) / durationMinute;
}, (date) => {
  return date.getMinutes();
});

timeMinute.range;

const utcMinute = timeInterval((date) => {
  date.setUTCSeconds(0, 0);
}, (date, step) => {
  date.setTime(+date + step * durationMinute);
}, (start, end) => {
  return (end - start) / durationMinute;
}, (date) => {
  return date.getUTCMinutes();
});

utcMinute.range;

const timeHour = timeInterval((date) => {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
}, (date, step) => {
  date.setTime(+date + step * durationHour);
}, (start, end) => {
  return (end - start) / durationHour;
}, (date) => {
  return date.getHours();
});

timeHour.range;

const utcHour = timeInterval((date) => {
  date.setUTCMinutes(0, 0, 0);
}, (date, step) => {
  date.setTime(+date + step * durationHour);
}, (start, end) => {
  return (end - start) / durationHour;
}, (date) => {
  return date.getUTCHours();
});

utcHour.range;

const timeDay = timeInterval(
  date => date.setHours(0, 0, 0, 0),
  (date, step) => date.setDate(date.getDate() + step),
  (start, end) => (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay,
  date => date.getDate() - 1
);

timeDay.range;

const utcDay = timeInterval((date) => {
  date.setUTCHours(0, 0, 0, 0);
}, (date, step) => {
  date.setUTCDate(date.getUTCDate() + step);
}, (start, end) => {
  return (end - start) / durationDay;
}, (date) => {
  return date.getUTCDate() - 1;
});

utcDay.range;

const unixDay = timeInterval((date) => {
  date.setUTCHours(0, 0, 0, 0);
}, (date, step) => {
  date.setUTCDate(date.getUTCDate() + step);
}, (start, end) => {
  return (end - start) / durationDay;
}, (date) => {
  return Math.floor(date / durationDay);
});

unixDay.range;

function timeWeekday(i) {
  return timeInterval((date) => {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, (date, step) => {
    date.setDate(date.getDate() + step * 7);
  }, (start, end) => {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}

const timeSunday = timeWeekday(0);
const timeMonday = timeWeekday(1);
const timeTuesday = timeWeekday(2);
const timeWednesday = timeWeekday(3);
const timeThursday = timeWeekday(4);
const timeFriday = timeWeekday(5);
const timeSaturday = timeWeekday(6);

timeSunday.range;
timeMonday.range;
timeTuesday.range;
timeWednesday.range;
timeThursday.range;
timeFriday.range;
timeSaturday.range;

function utcWeekday(i) {
  return timeInterval((date) => {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, (date, step) => {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, (start, end) => {
    return (end - start) / durationWeek;
  });
}

const utcSunday = utcWeekday(0);
const utcMonday = utcWeekday(1);
const utcTuesday = utcWeekday(2);
const utcWednesday = utcWeekday(3);
const utcThursday = utcWeekday(4);
const utcFriday = utcWeekday(5);
const utcSaturday = utcWeekday(6);

utcSunday.range;
utcMonday.range;
utcTuesday.range;
utcWednesday.range;
utcThursday.range;
utcFriday.range;
utcSaturday.range;

const timeMonth = timeInterval((date) => {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, (date, step) => {
  date.setMonth(date.getMonth() + step);
}, (start, end) => {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date) => {
  return date.getMonth();
});

timeMonth.range;

const utcMonth = timeInterval((date) => {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, (date, step) => {
  date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end) => {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date) => {
  return date.getUTCMonth();
});

utcMonth.range;

const timeYear = timeInterval((date) => {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, (date, step) => {
  date.setFullYear(date.getFullYear() + step);
}, (start, end) => {
  return end.getFullYear() - start.getFullYear();
}, (date) => {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
timeYear.every = (k) => {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : timeInterval((date) => {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, (date, step) => {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

timeYear.range;

const utcYear = timeInterval((date) => {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, (date, step) => {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end) => {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, (date) => {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = (k) => {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : timeInterval((date) => {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, (date, step) => {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

utcYear.range;

function ticker(year, month, week, day, hour, minute) {

  const tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function ticks(start, stop, count) {
    const reverse = stop < start;
    if (reverse) [start, stop] = [stop, start];
    const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
    const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
    return reverse ? ticks.reverse() : ticks;
  }

  function tickInterval(start, stop, count) {
    const target = Math.abs(stop - start) / count;
    const i = bisector(([,, step]) => step).right(tickIntervals, target);
    if (i === tickIntervals.length) return year.every(tickStep(start / durationYear, stop / durationYear, count));
    if (i === 0) return millisecond.every(Math.max(tickStep(start, stop, count), 1));
    const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
    return t.every(step);
  }

  return [ticks, tickInterval];
}

ticker(utcYear, utcMonth, utcSunday, unixDay, utcHour, utcMinute);
const [timeTicks, timeTickInterval] = ticker(timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute);

function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate(y, m, d) {
  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, undefined, 1),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? timeMonday.ceil(week) : timeMonday(week);
          week = timeDay.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return localDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  return new Map(names.map((name, i) => [name.toLowerCase(), i]));
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + timeDay.count(timeYear(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(timeSunday.count(timeYear(d) - 1, d), p, 2);
}

function dISO(d) {
  var day = d.getDay();
  return (day >= 4 || day === 0) ? timeThursday(d) : timeThursday.ceil(d);
}

function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad(timeThursday.count(timeYear(d), d) + (timeYear(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(timeMonday.count(timeYear(d) - 1, d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatYearISO(d, p) {
  d = dISO(d);
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? timeThursday(d) : timeThursday.ceil(d);
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + utcDay.count(utcYear(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(utcSunday.count(utcYear(d) - 1, d), p, 2);
}

function UTCdISO(d) {
  var day = d.getUTCDay();
  return (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
}

function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad(utcThursday.count(utcYear(d), d) + (utcYear(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(utcMonday.count(utcYear(d) - 1, d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}

var locale;
var timeFormat;
var timeParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = formatLocale(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  locale.utcFormat;
  locale.utcParse;
  return locale;
}

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
  var scale = continuous(),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval) {
    var d = domain();
    if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
    return interval ? domain(nice(d, interval)) : scale;
  };

  scale.copy = function() {
    return copy(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
  };

  return scale;
}

function time() {
  return initRange.apply(calendar(timeTicks, timeTickInterval, timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute, second, timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
}

function constant(x) {
  return function constant() {
    return x;
  };
}

const abs = Math.abs;
const atan2 = Math.atan2;
const cos = Math.cos;
const max$1 = Math.max;
const min$1 = Math.min;
const sin = Math.sin;
const sqrt = Math.sqrt;

const epsilon = 1e-12;
const pi = Math.PI;
const halfPi = pi / 2;
const tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

function withPath(shape) {
  let digits = 3;

  shape.digits = function(_) {
    if (!arguments.length) return digits;
    if (_ == null) {
      digits = null;
    } else {
      const d = Math.floor(_);
      if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
      digits = d;
    }
    return shape;
  };

  return () => new Path(digits);
}

function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = y32 * x10 - x32 * y10;
  if (t * t < epsilon) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * sqrt(max$1(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

function arc() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = constant(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null,
      path = withPath(arc);

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - halfPi,
        a1 = endAngle.apply(this, arguments) - halfPi,
        da = abs(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = path();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > epsilon)) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > tau - epsilon) {
      context.moveTo(r1 * cos(a0), r1 * sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon) {
        context.moveTo(r0 * cos(a1), r0 * sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
          rc = min$1(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > epsilon) {
        var p0 = asin(rp / r0 * sin(ap)),
            p1 = asin(rp / r1 * sin(ap));
        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * cos(a01),
          y01 = r1 * sin(a01),
          x10 = r0 * cos(a10),
          y10 = r0 * sin(a10);

      // Apply rounded corners?
      if (rc > epsilon) {
        var x11 = r1 * cos(a11),
            y11 = r1 * sin(a11),
            x00 = r0 * cos(a00),
            y00 = r0 * sin(a00),
            oc;

        // Restrict the corner radius according to the sector angle. If this
        // intersection fails, it’s probably because the arc is too small, so
        // disable the corner radius entirely.
        if (da < pi) {
          if (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
            var ax = x01 - oc[0],
                ay = y01 - oc[1],
                bx = x11 - oc[0],
                by = y11 - oc[1],
                kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
                lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
            rc0 = min$1(rc, (r0 - lc) / (kc - 1));
            rc1 = min$1(rc, (r1 - lc) / (kc + 1));
          } else {
            rc0 = rc1 = 0;
          }
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > epsilon)) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > epsilon) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > epsilon) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
    return [cos(a) * r, sin(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
}

function array(x) {
  return typeof x === "object" && "length" in x
    ? x // Array, TypedArray, NodeList, array-like
    : Array.from(x); // Map, Set, iterable, string, or anything else
}

function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // falls through
      default: this._context.lineTo(x, y); break;
    }
  }
};

function curveLinear(context) {
  return new Linear(context);
}

function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}

function line(x$1, y$1) {
  var defined = constant(true),
      context = null,
      curve = curveLinear,
      output = null,
      path = withPath(line);

  x$1 = typeof x$1 === "function" ? x$1 : (x$1 === undefined) ? x : constant(x$1);
  y$1 = typeof y$1 === "function" ? y$1 : (y$1 === undefined) ? y : constant(y$1);

  function line(data) {
    var i,
        n = (data = array(data)).length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x$1(d, i, data), +y$1(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant(+_), line) : x$1;
  };

  line.y = function(_) {
    return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant(+_), line) : y$1;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
}

function area(x0, y0, y1) {
  var x1 = null,
      defined = constant(true),
      context = null,
      curve = curveLinear,
      output = null,
      path = withPath(area);

  x0 = typeof x0 === "function" ? x0 : (x0 === undefined) ? x : constant(+x0);
  y0 = typeof y0 === "function" ? y0 : (y0 === undefined) ? constant(0) : constant(+y0);
  y1 = typeof y1 === "function" ? y1 : (y1 === undefined) ? y : constant(+y1);

  function area(data) {
    var i,
        j,
        k,
        n = (data = array(data)).length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return line().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
}

function point$1(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point$1(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // falls through
      default: point$1(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var cardinal = (function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0);

function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
};

(Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function none$1(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
}

function none(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
}

function stackValue(d, key) {
  return d[key];
}

function stackSeries(key) {
  const series = [];
  series.key = key;
  return series;
}

function stack() {
  var keys = constant([]),
      order = none,
      offset = none$1,
      value = stackValue;

  function stack(data) {
    var sz = Array.from(keys.apply(this, arguments), stackSeries),
        i, n = sz.length, j = -1,
        oz;

    for (const d of data) {
      for (i = 0, ++j; i < n; ++i) {
        (sz[i][j] = [0, +value(d, sz[i].key, j, data)]).data = d;
      }
    }

    for (i = 0, oz = array(order(sz)); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(Array.from(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? none : typeof _ === "function" ? _ : constant(Array.from(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? none$1 : _, stack) : offset;
  };

  return stack;
}

function Transform(k, x, y) {
  this.k = k;
  this.x = x;
  this.y = y;
}

Transform.prototype = {
  constructor: Transform,
  scale: function(k) {
    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
  },
  translate: function(x, y) {
    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
  },
  apply: function(point) {
    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
  },
  applyX: function(x) {
    return x * this.k + this.x;
  },
  applyY: function(y) {
    return y * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x) {
    return (x - this.x) / this.k;
  },
  invertY: function(y) {
    return (y - this.y) / this.k;
  },
  rescaleX: function(x) {
    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
  },
  rescaleY: function(y) {
    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};

new Transform(1, 0, 0);

Transform.prototype;

var _templateObject$1, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject22, _templateObject23, _templateObject24;
function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }
function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var sharedStyles = css$1(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n  :host {\n    display: block;\n    width: 100%;\n    line-height: var(--default-line-height);\n  }\n  .sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    margin: -1px;\n    padding: 0;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    border: 0;\n  }\n  button:focus,\n  a:focus,\n  .fwc-toggle input:focus + label,\n  .fwc-select-list select:focus,\n  .fwc-radio input:focus,\n  .fwc-input input:focus,\n  input:focus + label,\n  .fwc-checkbox input:focus + label:before,\n  .fwc-carousel-generic-wrapper .fwc-list-cont:focus,\n  div.tip-btn:focus {\n    outline: var(--fwc-focus);\n  }\n"])));
var FwcBase = /*#__PURE__*/function () {
  function FwcBase(name, component) {
    _classCallCheck$1(this, FwcBase);
    this.element = customElements.get(name);
    this.name = name;
    this.component = component;
  }
  _createClass$1(FwcBase, [{
    key: "build",
    value: function build() {
      if (!this.element) {
        customElements.define(this.name, this.component);
      }
    }
  }]);
  return FwcBase;
}();
function debounce$1(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
var breakpoints = {
  md: 900,
  sm: 600
};
var baseUnit = 8;
var fwcConfig = {
  assetsPath: '/'
};
var FwcChartBarCompareComponent = /*#__PURE__*/function (_LitElement3) {
  _inherits$1(FwcChartBarCompareComponent, _LitElement3);
  var _super5 = _createSuper$7(FwcChartBarCompareComponent);
  function FwcChartBarCompareComponent() {
    var _this8;
    _classCallCheck$1(this, FwcChartBarCompareComponent);
    _this8 = _super5.call(this);
    _this8.data;
    _this8.showChart;
    _this8._data = null;
    _this8._width = null;
    _this8._height = null;
    _this8._innerWidth = null;
    _this8._innerHeight = null;
    _this8._margin = {
      top: 20,
      right: 10,
      bottom: 20,
      left: 10
    };
    _this8._x0 = null; // using to defined domain
    _this8._x1 = null; // using to defined domain and range
    _this8._y = null;
    _this8._yAxisGrid = null;
    _this8._xAxisLabelList = [];
    _this8._svg = null;
    _this8._chart = null;
    _this8._xAxis = null;
    _this8._yAxis = null;
    _this8._barNames = null;
    _this8._xAxisLabel = null;
    _this8._stack = null;
    _this8._tooltip = null;
    _this8.yAxisLabelMaxWidth = 0;
    _this8._DELAY_BETWEEN_BAR_ANIMATIONS = 50;
    _this8._BAR_ANIMATION_DURATION = 200;
    _this8.valueKeys = null;
    _this8._handleWindowResize = debounce$1(function () {
      _this8.init();
    }, 250);
    return _this8;
  }
  _createClass$1(FwcChartBarCompareComponent, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      if (this.data && this.isValidData(this.data)) {
        this._data = this.data.graphData;
        this.prepData(this._data);
        this._xAxisLabelList = this.data.xAxisLabels;
      }
      this.init();
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldval, newval) {
      if (name === 'show-chart' && oldval) {
        this.showChart = JSON.parse(newval);
      }
      if (name === 'data' && oldval && this.showChart) {
        if (name === 'data') {
          this.data = [];
          this.data = JSON.parse(newval);
          this._data = this.data.graphData;
          this.prepData(this._data);
          this._xAxisLabelList = this.data.xAxisLabels;
        }
        this.init();
      }
      _get(_getPrototypeOf(FwcChartBarCompareComponent.prototype), "attributeChangedCallback", this).call(this, name, oldval, newval);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(FwcChartBarCompareComponent.prototype), "connectedCallback", this).call(this);
      window.addEventListener('resize', this._handleWindowResize);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      window.removeEventListener('resize', this._handleWindowResize);
      _get(_getPrototypeOf(FwcChartBarCompareComponent.prototype), "disconnectedCallback", this).call(this);
    }
  }, {
    key: "prepData",
    value: function prepData(obj) {
      var res = obj && obj.reduce(function (arr, o) {
        return Object.keys(o).reduce(function (a, k) {
          if (k !== 'element' && a.indexOf(k) == -1) a.push(k);
          return a;
        }, arr);
      }, []);
      this.valueKeys = res;
      this._stack = stack().keys(this.valueKeys);
    }
  }, {
    key: "init",
    value: function init() {
      if (this._svg) {
        this._svg.remove();
      }
      this.initDimensions();
      this.initScales();
      this.initSvg();
      this.attachToolTip();
      this.setDomain();
      this.drawAxis();
      this.drawChart();
    }
  }, {
    key: "initDimensions",
    value: function initDimensions() {
      this._width = this.clientWidth;
      var h = window.innerWidth > breakpoints.sm ? 0.6923 : 1.23;
      this._height = this._width * h;
      this._innerWidth = this._width - this._margin.left - this._margin.right;
      this._innerHeight = this._height - this._margin.top - this._margin.bottom;
      this._xAxisLabel = window.innerWidth > breakpoints.sm ? 'desktop' : 'mobile';
    }
  }, {
    key: "initScales",
    value: function initScales() {
      // x-axis domain defined below
      this._x0 = band().domain(this._xAxisLabelList.map(function (d) {
        return d;
      })).rangeRound([0, this._width - this._margin.right]).padding(0.5);

      // x-axis domain and range defined below
      this._x1 = band().rangeRound([0, this._x0.bandwidth()]).padding(0.5);

      //y position calculation function
      this._y = linear().range([this._innerHeight, 0]).nice();
    }
  }, {
    key: "initSvg",
    value: function initSvg() {
      var _this9 = this;
      this._svg = select(this.shadowRoot.getElementById('svg-wrapper')).append('svg').attr('class', 'chart').attr('width', this._width).attr('height', this._height).on('click', function () {
        // hide tool tip on mobile if clicking on svg background
        // we prevent the propagation from a click on a bar in drawChart()
        _this9._tooltip.style('display', 'none');
      });
      this._chart = this._svg.append('g');
      this._stack = stack().keys(this.valueKeys);
      var maxLabel = max$2(this._stack(this._data), function (d) {
        return max$2(d, function (d) {
          return d[1];
        });
      });
      var maxWidth;
      this._svg.append('text').text(maxLabel).each(function () {
        maxWidth = this.getBBox().width;
      }).remove();
      this.yAxisLabelMaxWidth = maxWidth;
    }
  }, {
    key: "attachToolTip",
    value: function attachToolTip() {
      this._tooltip = this._svg.append('g').attr('class', 'tool-tip').style('display', 'none');
      this._tooltip.append('polyline').attr('points', '0,0  0,110 47,110 57,120 67,110 114,110 114,0 0,0').attr('class', 'chart-polyline');
      this._tooltip.append('text').attr('class', 'key key1').attr('y', 24).attr('x', 55);
      this._tooltip.append('text').attr('class', 'keyVal value1').attr('y', 44).attr('x', 55);
      this._tooltip.append('text').attr('class', 'key key2').attr('y', 72).attr('x', 55);
      this._tooltip.append('text').attr('class', 'keyVal value2').attr('y', 92).attr('x', 55);
    }
  }, {
    key: "setDomain",
    value: function setDomain() {
      var _this10 = this;
      this._barNames = this.valueKeys;
      this._data.forEach(function (d) {
        d.element = _this10._barNames.map(function (name) {
          return {
            name: name,
            value: +d[name]
          };
        });
      });

      //use new array from just values for the bottom x-axis
      this._x0.domain(this._data.map(function (d, i) {
        return _this10._xAxisLabelList[i];
      }));

      //array of bar names value names, fitted in the available bottom categories (x0.bandwidth())
      this._x1.domain(this._barNames).rangeRound([0, this._x0.bandwidth()]);
      this._y.domain([0, max$2(this._data, function (d) {
        return max$2(d.element, function (d) {
          return d.value;
        });
      })]);
    }
  }, {
    key: "drawAxis",
    value: function drawAxis() {
      var _this11 = this;
      var xAxis = axisBottom(this._x0).tickSize(0).tickFormat(function (d) {
        // because we need to override the default x-axis labeling for d3
        // you are not allowed to have duplicates ('J' for June and July does not work), so we track them by id and then change the label here
        return _this11._xAxisLabelList.filter(function (data) {
          return data === d;
        }).reduce(function (tot, cur) {
          return _this11._xAxisLabel === 'desktop' ? cur : cur.charAt(0);
        }, '');
      });
      this._yAxis = axisLeft(this._y).tickSize(0).tickFormat(function (d) {
        return _this11._getFormattedCurrency(d);
      });
      var yAxisGrid = axisLeft(this._y).tickSize(-(this._width - (this.yAxisLabelMaxWidth + 40))).tickFormat('').ticks(10);
      this._xAxis = this._chart.append('g').classed('x-axis', true).attr('transform', 'translate(44,' + (this._innerHeight + 10) + ')').attr('aria-label', 'Range of the X-axis').call(xAxis);
      this._yAxis = this._chart.append('g').classed('y-axis', true).attr('transform', "translate(".concat(this.yAxisLabelMaxWidth + 10, ", 0)")).attr('aria-label', 'Range of the Y-axis').call(this._yAxis);
      this._yAxisGrid = this._chart.append('g').attr('transform', "translate(".concat(this.yAxisLabelMaxWidth + 35, ", 0)")).attr('class', 'y axis-grid').call(yAxisGrid);

      //remove domain lines
      this._xAxis.select('.domain').attr('stroke-width', 0);
      this._yAxis.select('.domain').attr('stroke-width', 0);
      this._yAxisGrid.select('.domain').attr('stroke-width', 0);
    }
  }, {
    key: "drawChart",
    value: function drawChart() {
      var _this12 = this;
      var layersBarArea = this._chart.append('g').classed('layers', true).attr('transform', 'translate(40,0)');
      var state = layersBarArea.selectAll('.state').data(this._data).enter().append('g').attr('class', 'state').attr('transform', function (d, i) {
        return 'translate(' + _this12._x0(_this12._xAxisLabelList[i]) + ',0)';
      });
      state.selectAll('rect').data(function (d) {
        return d.element;
      }).enter().append('rect').attr('class', 'chart-bar').on('mouseover', function () {
        _this12._tooltip.style('display', null);
      }).on('mouseout', function () {
        _this12._tooltip.style('display', 'none');
      }).on('mousemove', function (event, d) {
        var data = select(event.currentTarget.parentNode).datum().element;
        var xPosition = event.layerX - 58;
        var _d3$pointer = pointer(event),
          _d3$pointer2 = _slicedToArray$1(_d3$pointer, 2);
          _d3$pointer2[0];
          var y = _d3$pointer2[1];
        _this12._tooltip.attr('transform', 'translate(' + xPosition + ',' + (y - 120) + ')');
        data.map(function (d, idx) {
          _this12._tooltip.select(".key".concat(idx + 1)).text(d.name || 0);
          _this12._tooltip.select(".value".concat(idx + 1)).text(_this12._getFormattedCurrency(d.value));
        });
      }).on('click', function (e) {
        // because we want to grab the click on the svg bg to hide tooltip on mobile, see initSvg()
        // but here we stop it from bubbling cause we want the click on the rect bar
        e.stopPropagation();
      }).attr('x', function (d) {
        return _this12._x1(d.name) + 4;
      })
      //set height and y to initial values you can transition from
      .attr('height', 0).attr('y', this._innerHeight).attr('width', this._x1.bandwidth() + 2).transition().delay(function (d, i) {
        return i * _this12._DELAY_BETWEEN_BAR_ANIMATIONS;
      }).duration(this._BAR_ANIMATION_DURATION)
      // transition to values for y and height
      .attr('y', function (d) {
        return _this12._y(d.value || 0);
      }).attr('height', function (d) {
        return _this12._innerHeight - _this12._y(d.value || 0);
      });
    }

    /* c8 ignore next 34 */
  }, {
    key: "isValidData",
    value: function isValidData(obj) {
      var errors = false;
      try {
        if (obj.graphData && obj.graphData.length === 0) {
          errors = true;
          throw new Error("graphData is an empty array or is missing, valid numbers of labels allowed (1, 2 or 3)");
        }
      } catch (error) {
        console.error(error);
      }
      try {
        if (obj.graphData.length < 3 || obj.graphData.length > 12) {
          errors = true;
          throw new Error("the required number of bars for the chart: min = 3, max = 12, you passed in ".concat(obj.graphData.length));
        }
      } catch (error) {
        console.error(error);
      }
      return !errors;
    }

    //convert value into currency format
  }, {
    key: "_getFormattedCurrency",
    value: function _getFormattedCurrency(value) {
      if (!value) {
        return 0;
      }
      return value.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
      });
    }
  }, {
    key: "_getTotalValue",
    value: function _getTotalValue(obj) {
      var _this13 = this;
      var ele = {};
      obj && obj.map(function (item) {
        _this13.valueKeys.map(function (key) {
          return ele[key] = parseInt(ele[key] ? ele[key] : 0) + parseInt(item[key]);
        });
      });
      return ele;
    }
  }, {
    key: "_buildKeys",
    value: function _buildKeys() {
      var _this14 = this;
      this.prepData(this.data.graphData);
      var totalObj = this._getTotalValue(this.data.graphData);
      var keys = html(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", ""])), this.valueKeys && this.valueKeys.map(function (key) {
        return html(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral([" <div class=\"legend-item\">\n        <span>", "</span>\n        <div>", "</div>\n      </div>"])), key, _this14._getFormattedCurrency(totalObj[key]));
      }));
      return keys;
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      <div class=\"fwc-chart-bar-compare\">\n        <div class=\"legend\">\n          <div class=\"values\">", "</div>\n        </div>\n        <div id=\"svg-wrapper\"></div>\n      </div>\n    "])), this._buildKeys());
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles, css$1(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n        .fwc-chart-bar-compare {\n          display: block;\n          width: 100%;\n          position: relative;\n        }\n\n        .values {\n          display: flex;\n        }\n\n        .legend {\n          display: flex;\n          justify-content: space-between;\n        }\n\n        .legend-item span {\n          position: relative;\n          font-size: var(--default-font-size);\n          font-weight: 700;\n          padding: 0 calc(2.75 * var(--fwcu));\n        }\n        .legend-item div {\n          padding: 0 calc(2.75 * var(--fwcu));\n        }\n\n        .legend-item span:before {\n          content: '';\n          width: calc(1.5 * var(--fwcu));\n          height: calc(1.5 * var(--fwcu));\n          position: absolute;\n          left: 0;\n          top: 0;\n          bottom: 0;\n          margin: auto;\n          border-radius: 50%;\n        }\n        .chart-bar:nth-child(1) {\n          fill: var(--color-dviz-seven);\n        }\n        .chart-bar:nth-child(2) {\n          fill: var(--color-dviz-four);\n        }\n\n        .legend-item:nth-child(2) span:before {\n          background-color: var(--color-dviz-four);\n        }\n\n        .legend-item:nth-child(1) span:before {\n          background-color: var(--color-dviz-seven);\n        }\n\n        #svg-wrapper {\n          position: relative;\n          margin-top: calc(6.25 * var(--fwcu));\n        }\n\n        .chart-grid line {\n          stroke: lightgrey;\n          stroke-opacity: 0.7;\n          shape-rendering: crispEdges;\n        }\n\n        svg {\n          overflow: visible;\n        }\n\n        .x-axis,\n        .y-axis {\n          font-size: calc(1.5 * var(--fwcu));\n          font-family: var(--font-sans-serif);\n          font-weight: 700;\n          color: var(--color-gray-one);\n        }\n        .key {\n          text-anchor: middle;\n          font-size: calc(1.5 * var(--fwcu));\n        }\n        .keyVal {\n          text-anchor: middle;\n          font-size: var(--default-font-size);\n          font-weight: bold;\n        }\n        .axis-grid {\n          opacity: 0.1;\n          stroke-width: 0.5;\n        }\n        .chart-polyline {\n          fill: var(--color-white);\n          stroke: var(--color-primary);\n          stroke-width: 1px;\n          pointer-events: none;\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        data: {
          type: Array
        },
        showChart: {
          attribute: 'show-chart',
          type: Boolean
        }
      };
    }
  }]);
  return FwcChartBarCompareComponent;
}(LitElement);
var FwcChartBarCompare = /*#__PURE__*/function (_FwcBase3) {
  _inherits$1(FwcChartBarCompare, _FwcBase3);
  var _super6 = _createSuper$7(FwcChartBarCompare);
  function FwcChartBarCompare() {
    _classCallCheck$1(this, FwcChartBarCompare);
    return _super6.call(this, 'fwc-chart-bar-compare', FwcChartBarCompareComponent);
  }
  return _createClass$1(FwcChartBarCompare);
}(FwcBase);
var FwcChartDonutComponent = /*#__PURE__*/function (_LitElement5) {
  _inherits$1(FwcChartDonutComponent, _LitElement5);
  var _super9 = _createSuper$7(FwcChartDonutComponent);
  function FwcChartDonutComponent() {
    var _this21;
    _classCallCheck$1(this, FwcChartDonutComponent);
    _this21 = _super9.call(this);
    // TODO: This doesn't do anything
    _this21.animationDuration = 500;
    _this21.config = fwcConfig;
    _this21.text = '';
    _this21.percentages = [];
    _this21._percentages = [];
    _this21.labels = [];
    _this21.labelData = [];
    _this21.symbol = '';
    _this21.legend = 'Legend';
    _this21.legendHide = false;
    _this21.legendPos = 'bottom';
    _this21.tooltipLabel = 'Value';
    _this21.title = '';
    _this21.pi = Math.PI;
    _this21.size = 200;
    _this21.thickness = 8;
    _this21.radius = _this21.size / 2;
    _this21.innerRadius = _this21.radius - _this21.thickness;
    _this21.cfr = 360 / 100;
    _this21.start = 0;
    _this21.sum = 0;
    _this21._valueCount = 0;
    _this21._singleTrack = false;
    _this21._isEmpty = false;
    _this21._isPercentage = false;
    _this21._tooltip;
    _this21._svg;
    _this21._handleWindowResize = debounce$1(function () {
      _this21._initChart();
    }, 250);
    return _this21;
  }
  _createClass$1(FwcChartDonutComponent, [{
    key: "percentages",
    get: function get() {
      return this._percentages;
    },
    set: function set(val) {
      var oldVal = this._percentages;
      this._percentages = this._transformData(val);
      this.requestUpdate('prop', oldVal);
    }
  }, {
    key: "firstUpdated",
    value: function firstUpdated() {
      this.chartContainer = this.shadowRoot.querySelector('.fwc-donut-chart');
      this._initChart();
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(FwcChartDonutComponent.prototype), "connectedCallback", this).call(this);
      window.addEventListener('resize', this._handleWindowResize);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      window.removeEventListener('resize', this._handleWindowResize);
      _get(_getPrototypeOf(FwcChartDonutComponent.prototype), "disconnectedCallback", this).call(this);
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldval, newval) {
      if (name === 'percentages' && oldval) {
        this.percentages = JSON.parse(newval);
        this._initChart();
      }
      _get(_getPrototypeOf(FwcChartDonutComponent.prototype), "attributeChangedCallback", this).call(this, name, oldval, newval);
    }
  }, {
    key: "_transformData",
    value: function _transformData(data) {
      var transformed = [];
      this.labelData = [];
      this.sum = this._calcSum(data);
      this._valueCount = data.filter(function (val) {
        return val > 0;
      }).length;
      this._singleTrack = this._setSingleTrack(data);
      this._isPercentage = false;
      this._isEmpty = false;
      if (this._checkForEmpty(data)) {
        transformed = this._emptyChartConfig();
      } else if (data.length === 1) {
        transformed = this._singleValueConfig(data);
      } else {
        transformed = this._multiValueConfig(data);
      }
      return transformed;
    }
  }, {
    key: "_initChart",
    value: function _initChart() {
      var _this22 = this;
      // Update chart after DOM has fully updated.
      // Allows for correct position of tool-tip after layout has been changed
      // due to differences in sizing or position of legend.
      setTimeout(function () {
        if (_this22.isValidData()) {
          _this22.createSVGElement();
          _this22.createChart();
          _this22.attachToolTip();
        }
      }, 0);
    }
  }, {
    key: "_calcSum",
    value: function _calcSum(data) {
      return data.reduce(this._getSum, 0);
    }
  }, {
    key: "_getSum",
    value: function _getSum(total, num) {
      return total + num;
    }
  }, {
    key: "_checkForEmpty",
    value: function _checkForEmpty(val) {
      var empty = false;
      if (val.length < 1) {
        empty = true;
      }
      if (this.sum === 0) {
        empty = true;
      }
      if (this._valueCount.length < 1) {
        empty = true;
      }
      return empty;
    }
  }, {
    key: "_setSingleTrack",
    value: function _setSingleTrack(data) {
      var track = false;
      if (data.length === 1 && this.sum === 100) {
        track = true;
      }
      if (data.length > 1 && this._valueCount === 1) {
        track = true;
      }
      return track;
    }
  }, {
    key: "_emptyChartConfig",
    value: function _emptyChartConfig() {
      this._isEmpty = true;
      this._singleTrack = true;
      this.animationDuration = 0;
      return [100];
    }

    /* c8 ignore next 4 */
  }, {
    key: "_singleValueConfig",
    value: function _singleValueConfig(val) {
      if (val[0] > 100) {
        return val;
      }
      this._isPercentage = true;
      this.sum = 100;
      val[1] = this.sum - val[0];
      this.labelData = val;
      return val;
    }
  }, {
    key: "_multiValueConfig",
    value: function _multiValueConfig(data) {
      var sum = data.reduce(this._getSum, 0);
      var computed = data.map(function (val) {
        return Math.round(val * 100 / sum * 100) / 100;
      });
      this.labelData = this.symbol !== 'percent' ? data : computed;
      return computed;
    }

    /* eslint-disable no-console */
  }, {
    key: "isValidData",
    value: function isValidData() {
      var errors = false;
      try {
        if (this.percentages.length > 5) {
          errors = true;
          throw new Error("max of 5 values allowed to be based in to [percentages], you passed ".concat(this.percentages.length));
        }
      } catch (error) {
        console.error(error);
      }
      try {
        if (this.symbol !== null && this.symbol !== '' && this.symbol !== 'currency' && this.symbol !== 'percent' && this.symbol !== 'none') {
          errors = true;
          throw new Error("invalid string passed for [symbol], valid values are 'percent', currency' or 'none' you passed '".concat(this.symbol, "'"));
        }
      } catch (error) {
        console.error(error);
      }
      return !errors;
    }
    /* eslint-enable no-console */
  }, {
    key: "createSVGElement",
    value: function createSVGElement() {
      if (this._svg) {
        this._svg.remove();
      }
      this._svg = select(this.chartContainer).append('svg').attr('width', '100%').attr('preserveAspectRatio', 'xMinYMin meet').attr('viewBox', '-100 -100 200 200');
      return;
    }
  }, {
    key: "_setSymbol",
    value: function _setSymbol(val) {
      val = this._isEmpty ? 0 : val;
      switch (this.symbol) {
        case 'currency':
          val = '$' + val;
          break;
        case 'percent':
          val = val + '%';
          break;
      }
      return val;
    }
  }, {
    key: "_setLegendPos",
    value: function _setLegendPos() {
      var pos = '';
      switch (this.legendPos) {
        case 'right':
          pos = 'legend-right';
          break;
      }
      return pos;
    }
  }, {
    key: "createChart",
    value: function createChart() {
      var _this23 = this;
      var g = this._svg.append('g');
      var arc = this.initArc();
      var width = this.chartContainer.offsetWidth;
      this.percentages.forEach(function (v, x) {
        // don't build the track if the value is 0
        if (v === 0) {
          return;
        }
        var v1, v2;
        v1 = _this23.start;
        v2 = v1 + v;
        _this23.start = v2;
        var startAngle = _this23.cfr * v1 * (_this23.pi / 180);
        var endAngle = _this23.cfr * v2 * (_this23.pi / 180);

        // remove gaps when displaying an empty chart
        if (!_this23._singleTrack) {
          endAngle = endAngle - 0.03;
        }
        var track = g.append('g').attr('class', 'radial-progress-' + x);
        if (_this23._isPercentage && x === 1) {
          track.attr('class', 'empty radial-progress-' + x);
        }
        if (_this23._isEmpty) {
          track.attr('class', 'empty radial-progress-' + x);
        }
        track.append('path').on('mouseover', function (event) {
          var classNames = event.currentTarget.parentNode.className;
          var isEmpty = classNames.baseVal.indexOf('empty') > -1;
          if (!isEmpty) {
            _this23._tooltip.style('display', null);
          }
        }).on('mouseout', function () {
          _this23._tooltip.style('display', 'none');
        }).on('mousemove', function (event) {
          var xPosition = pointer(event)[0] / 100 * width / 2;
          var yPosition = pointer(event)[1] / 100 * width / 2;
          var value = _this23._setSymbol(_this23.labelData[x]);
          _this23._tooltip.style('transform', "translate(".concat(xPosition, "px, ").concat(yPosition, "px)"));
          _this23._tooltip.select('.donut-label').text(_this23.labels[x]);
          _this23._tooltip.select('.donut-value').text(value);
        }).datum({
          startAngle: startAngle,
          endAngle: endAngle
        }).transition().duration(_this23.animationDuration).attrTween('d', function (d) {
          var interpolate = interpolate$1(d.startAngle, d.endAngle);
          return function (t) {
            d.endAngle = interpolate(t);
            return arc(d);
          };
        });
      });
      if (this.text) {
        /* eslint-disable no-unused-vars */
        g.append('text').text(this.text).attr('class', 'fwc-h2 radial-text-total').attr('dy', baseUnit / 2 + 'px');
        g.append('text').text(this.title).attr('class', 'radial-text-title').attr('dy', baseUnit * 2.5 + 'px');
        /* eslint-enable no-unused-vars */
      }
    }
  }, {
    key: "attachToolTip",
    value: function attachToolTip() {
      this._tooltip = select(this.chartContainer).append('div').attr('class', 'tool-tip').style('display', 'none').html("\n        <div class=\"arrow_box\">\n          <div class=\"donut-title\">".concat(this.tooltipLabel, "</div>\n          <div class=\"donut-value\"></div>\n          <div class=\"donut-label\"></div>\n        </div>\n      "));
    }
  }, {
    key: "initArc",
    value: function initArc() {
      var arc$1 = arc();
      arc$1.innerRadius(this.innerRadius).outerRadius(this.radius);
      if (!this._singleTrack) {
        arc$1.cornerRadius(12);
      }
      return arc$1;
    }
  }, {
    key: "buildKeyChart",
    value: function buildKeyChart() {
      var _this24 = this;
      return html(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n      <div\n        class=\"legend ", " ", "\"\n      >\n        <div class=\"legend-title\">", "</div>\n        <dl>\n          ", "\n        </dl>\n      </div>\n    "])), this._setLegendPos(), this.legendHide ? 'hide' : '', this.legend, this.labels.map(function (item, i) {
        return html(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n              <div>\n                <dt>\n                  <span class=\"key\">\n                    <span class=\"key-color key-color-", "\"></span>\n                    ", "\n                  </span>\n                </dt>\n                <dd class=\"fwc-h5\">", "</dd>\n              </div>\n            "])), i, item, _this24._setSymbol(_this24.labelData[i]));
      }));
    }

    // Use of canvas is a hack 100% width and scale svg -->
    // http://nicolasgallagher.com/canvas-fix-svg-scaling-in-internet-explorer/ -->
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n      <link\n        rel=\"stylesheet\"\n        href=\"", "fwc-assets/styles/typography.css\"\n      />\n      <div class=\"wrapper ", "\">\n        <div class=\"container\">\n          <canvas width=\"200\" height=\"200\"></canvas>\n          <div class=\"fwc-donut-chart\" #chart></div>\n        </div>\n        ", "\n      </div>\n    "])), this.config.assetsPath, this._setLegendPos(), this.buildKeyChart());
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles, css$1(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n        :host {\n          color: var(--color-gray-one);\n        }\n        .wrapper.legend-right {\n          display: flex;\n          align-items: flex-start;\n        }\n        .legend-right .container,\n        .legend-right .legend {\n          flex: 1 1 auto;\n        }\n        .legend-right .legend {\n          margin-left: calc(2 * var(--fwcu));\n        }\n        .legend:not(.legend-right) {\n          margin-top: calc(2 * var(--fwcu));\n        }\n        .container {\n          position: relative;\n        }\n        .container svg {\n          position: absolute;\n          top: 0;\n          left: 0;\n          height: 100%;\n          width: 100%;\n          overflow: visible;\n        }\n        .chart-unit {\n          color: var(--color-gray-five);\n          margin: 0;\n        }\n        .chart-text {\n          color: var(--color-gray-four);\n        }\n        canvas {\n          display: block;\n          visibility: hidden;\n          width: 100%;\n          height: 100%;\n        }\n        .tool-tip {\n          position: absolute;\n          width: 0;\n          height: 0;\n          overflow: visible;\n          background-color: black;\n          top: 0;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          margin: auto;\n        }\n        .arrow_box {\n          position: absolute;\n          background: var(--color-white);\n          border: 1px solid var(--color-primary);\n          padding: calc(1.25 * var(--fwcu));\n          text-align: center;\n          width: 125px;\n          transform: translate(-50%, -115%);\n          left: 0;\n          top: 0;\n          border-radius: var(--border-radius);\n        }\n        .arrow_box::after {\n          top: calc(100% - 1px);\n          left: 50%;\n          content: '';\n          height: 0;\n          width: 0;\n          position: absolute;\n          border-left: calc(1.25 * var(--fwcu)) solid transparent;\n          border-right: calc(1.25 * var(--fwcu)) solid transparent;\n          border-top: calc(1.25 * var(--fwcu)) solid var(--color-white);\n          transform: translateX(-50%);\n        }\n        .arrow_box::before {\n          top: 100%;\n          left: 50%;\n          content: '';\n          height: 0;\n          width: 0;\n          position: absolute;\n          border-left: calc(1.25 * var(--fwcu)) solid transparent;\n          border-right: calc(1.25 * var(--fwcu)) solid transparent;\n          border-top: calc(1.25 * var(--fwcu)) solid var(--color-primary);\n          transform: translateX(-50%);\n        }\n        .donut-value {\n          font-weight: 700;\n          margin: calc(0.5 * var(--fwcu));\n          line-height: calc(2 * var(--fwcu));\n        }\n        .donut-label {\n          line-height: calc(2 * var(--fwcu));\n        }\n        .fwc-donut-chart {\n          position: absolute;\n          z-index: 1;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n        }\n        .fwc-donut-chart g.empty path {\n          fill: var(--color-gray-four);\n        }\n        .fwc-donut-chart .radial-progress-0 path {\n          fill: var(--color-dviz-seven);\n        }\n        .fwc-donut-chart .radial-progress-1 path {\n          fill: var(--color-dviz-one);\n        }\n        .fwc-donut-chart .radial-progress-2 path {\n          fill: var(--color-dviz-four);\n        }\n        .fwc-donut-chart .radial-progress-3 path {\n          fill: var(--color-dviz-eight);\n        }\n        .fwc-donut-chart .radial-progress-4 path {\n          fill: var(--color-dviz-five);\n        }\n        .legend {\n          width: 100%;\n        }\n        .legend .legend-title {\n          font-weight: 700;\n        }\n        .legend dl {\n          border-top: 1px solid var(--color-gray-four);\n        }\n        .legend dl div {\n          display: flex;\n          justify-content: space-between;\n          width: 100%;\n          overflow: visible;\n          border-bottom: 1px solid var(--color-gray-four);\n        }\n        .legend dl dt {\n          padding: calc(2.25 * var(--fwcu)) 0;\n          flex-grow: 0;\n          flex-shrink: 1;\n          flex-basis: calc(75% - (4.5 * var(--fwcu)));\n          text-overflow: ellipsis;\n          overflow: hidden;\n        }\n        .legend dl dd {\n          padding: calc(2.25 * var(--fwcu)) 0;\n          flex: 0 1 25%;\n          text-align: right;\n        }\n        .legend dl .key {\n          display: flex;\n        }\n        .legend .key-color {\n          height: calc(0.75 * var(--fwcu));\n          width: calc(4.25 * var(--fwcu));\n          margin-right: calc(1.75 * var(--fwcu));\n          display: inline-block;\n          border-radius: calc(0.75 * var(--fwcu));\n          position: relative;\n          top: calc(0.75 * var(--fwcu));\n        }\n        .legend dl .key-color-0 {\n          background-color: var(--color-dviz-seven);\n        }\n        .legend dl .key-color-1 {\n          background-color: var(--color-dviz-one);\n        }\n        .legend dl .key-color-2 {\n          background-color: var(--color-dviz-four);\n        }\n        .legend dl .key-color-3 {\n          background-color: var(--color-dviz-eight);\n        }\n        .legend dl .key-color-4 {\n          background-color: var(--color-dviz-five);\n        }\n        .legend dl .key-term {\n          flex: 1;\n        }\n        .radial-text-total {\n          fill: var(--color-gray-one);\n          text-anchor: middle;\n        }\n        .radial-text-title {\n          fill: var(--color-gray-two);\n          font-family: var(--font-sans-serif);\n          font-weight: 300;\n          text-anchor: middle;\n        }\n        .hide {\n          display: none;\n        }\n      "])))];
    }

    // TODO: Aria live / region, ets
  }, {
    key: "properties",
    get: function get() {
      return {
        config: {
          type: Object
        },
        labels: {
          type: Array
        },
        legend: {
          type: String
        },
        legendPos: {
          attribute: 'legend-pos',
          type: String
        },
        // bottom | right
        legendHide: {
          attribute: 'legend-hide',
          type: Boolean
        },
        percentages: {
          type: Array
        },
        symbol: {
          type: String
        },
        // currency | percent | none
        text: {
          type: String
        },
        title: {
          type: String
        },
        tooltipLabel: {
          attribute: 'tooltip-label',
          type: String
        }
      };
    }
  }]);
  return FwcChartDonutComponent;
}(LitElement);
var FwcChartDonut = /*#__PURE__*/function (_FwcBase5) {
  _inherits$1(FwcChartDonut, _FwcBase5);
  var _super10 = _createSuper$7(FwcChartDonut);
  function FwcChartDonut() {
    _classCallCheck$1(this, FwcChartDonut);
    return _super10.call(this, 'fwc-chart-donut', FwcChartDonutComponent);
  }
  return _createClass$1(FwcChartDonut);
}(FwcBase);
var FwcChartLineComponent = /*#__PURE__*/function (_LitElement7) {
  _inherits$1(FwcChartLineComponent, _LitElement7);
  var _super13 = _createSuper$7(FwcChartLineComponent);
  function FwcChartLineComponent() {
    var _this30;
    _classCallCheck$1(this, FwcChartLineComponent);
    _this30 = _super13.call(this);
    _this30.dataLineOne = [];
    _this30.dataLineTwo = [];
    _this30.dataLineThree = [];
    _this30.legend = [];
    _this30.labelHorizontal = '';
    _this30.labelVertical = '';
    _this30._data = [];
    _this30._margin = {
      top: 20,
      right: 20,
      bottom: 60,
      left: 60
    };
    _this30.width = 0;
    _this30._height = 0;
    _this30._chartOptions = {};
    _this30._element = null;
    _this30._svg = null;
    _this30._scaleHorizontal = 0;
    _this30._scaleVertical = 0;
    _this30._line = line().x(function (coordinates) {
      return _this30._scaleHorizontal(coordinates[0]);
    }).y(function (coordinates) {
      return _this30._scaleVertical(+coordinates[1]);
    }).curve(cardinal);
    return _this30;
  }
  _createClass$1(FwcChartLineComponent, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      this.initChart();
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldval, newval) {
      var _this31 = this;
      if (name === 'data-line-one' && oldval || name === 'data-line-two' && oldval || name === 'data-line-three' && oldval) {
        // need to wait til all attributes have changed
        setTimeout(function () {
          _this31.initChart();
        }, 0);
      }
      _get(_getPrototypeOf(FwcChartLineComponent.prototype), "attributeChangedCallback", this).call(this, name, oldval, newval);
    }
  }, {
    key: "initChart",
    value: function initChart() {
      this._prepData();
      /** Initialize height, width, element container, and scale functions. */
      this._initValues();
      /** Initialize the scaleLinear (or scaleTime) for horizontal/vertical axes. */
      this._initScales();
      /** Initialize parent svg to append line chart. */
      this._renderSvgContainer();
      /** Render line chart(s). */
      this._renderLineChart();
      /** Render horizontal/vertical axes. */
      this._renderAxes();
    }
  }, {
    key: "_prepData",
    value: function _prepData() {
      var _this32 = this;
      // we need to parse the date strings back to dates from the JSON.stringify
      this.dataLineOne = this.dataLineOne.map(function (val) {
        var isDate = _this32._isIsoDate(val[0]);
        return isDate ? [new Date(val[0]), val[1]] : val;
      });
      this.dataLineTwo = this.dataLineTwo.map(function (val) {
        var isDate = _this32._isIsoDate(val[0]);
        return isDate ? [new Date(val[0]), val[1]] : val;
      });
      this.dataLineThree = this.dataLineThree.map(function (val) {
        var isDate = _this32._isIsoDate(val[0]);
        return isDate ? [new Date(val[0]), val[1]] : val;
      });
    }

    /** Initializes various values for the rendering of the svg element. */
  }, {
    key: "_initValues",
    value: function _initValues() {
      this._element = this;
      this.width = this._element.offsetWidth;
      this.height = this._element.offsetWidth * 0.75;
      this._margin.left + this._margin.right;
      var verticalMargin = this._margin.top + this._margin.bottom;

      /** Add additional bottom margin for axis label. */
      if (this.labelHorizontal) {
        this._margin.bottom = 80;
      }

      /** Add additional left margin for axis label. */
      if (this.labelVertical) {
        this._margin.left = 80;
      }
      this.height = this.height - verticalMargin;
    }
  }, {
    key: "_initScales",
    value: function _initScales() {
      if (this.dataLineOne.length && this.dataLineOne[0][0] instanceof Date) {
        this._scaleHorizontal = time().range([0, this.width]);
      } else if (this.dataLineOne.length && typeof this.dataLineOne[0][0] === 'string') {
        this._scaleHorizontal = point$2().range([0, this.width]);
      } else {
        this._scaleHorizontal = linear().range([0, this.width]);
      }
      this._scaleVertical = linear().range([this.height, 0]);
    }
  }, {
    key: "_isIsoDate",
    value: function _isIsoDate(str) {
      if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false;
      var d = new Date(str);
      return d.toISOString() === str;
    }
  }, {
    key: "_renderSvgContainer",
    value: function _renderSvgContainer() {
      /** Build the svg parent container */
      if (this._svg) {
        this.shadowRoot.querySelector('svg#fwc-chart').remove();
      }
      this._svg = select(this.shadowRoot.querySelector('.fwc-svg-wrapper')).append('svg').attr('id', 'fwc-chart').attr('viewBox', "0 0 ".concat(this.width + this._margin.left + this._margin.right, " ").concat(this.height + this._margin.top + this._margin.bottom)).append('g').attr('transform', 'translate(' + this._margin.left + ',' + this._margin.top + ')');
    }

    /** Renders the line chart. */
  }, {
    key: "_renderLineChart",
    value: function _renderLineChart() {
      var _this33 = this;
      if (this.dataLineOne.length === 0) {
        console.error('ERROR: Chart data was not provided. *the attribute data-line-one is required.');
        this._renderErrorChart();
        return;
      }

      /** Min & Max to build the horizontal domain. */
      var horizontalMin = this.dataLineOne[0][0];
      var horizontalMax = this.dataLineOne[0][0];

      /** Min & Max to build the vertical domain. */
      var verticalMin = 0;
      var verticalMax = this.dataLineOne[0][1];
      [_toConsumableArray(this.dataLineOne), _toConsumableArray(this.dataLineTwo), _toConsumableArray(this.dataLineThree)].forEach(function (tupleList, index) {
        if (tupleList.length === 0) {
          return;
        }
        var horizontalDomains = [];
        /** Find min and max ranges from list of lines. */
        tupleList.forEach(function (tuple) {
          if (typeof tuple[0] === 'string') {
            horizontalDomains.push(tuple[0]);
          } else {
            if (tuple[0] < horizontalMin) {
              horizontalMin = tuple[0];
            }
            if (tuple[0] > horizontalMax) {
              horizontalMax = tuple[0];
            }
          }
          if (tuple[1] < verticalMin) {
            verticalMin = tuple[1];
          }
          if (tuple[1] > verticalMax) {
            verticalMax = tuple[1];
          }
        });
        if (horizontalDomains.length) {
          _this33.horizontalScaleType = 'POINT';
          _this33._scaleHorizontal.domain(_toConsumableArray(new Set(horizontalDomains)));
        } else {
          _this33.horizontalScaleType = '';
          /** Apply the scale to the horizontal domain. */
          _this33._scaleHorizontal.domain([horizontalMin, horizontalMax]);
        }
        /** Apply the scale to the vertical domain. */
        _this33._scaleVertical.domain([verticalMin, verticalMax]);
        /** Build the line graphs and attach. */
        _this33._svg.append('path').data([tupleList]).attr('data', tupleList).attr('class', 'line line-' + index).attr('d', _this33._line);
      });
    }

    /** Renders axis labels, axis ticks and scales the axis. */
  }, {
    key: "_renderAxes",
    value: function _renderAxes() {
      this._initHorizontalAxis();
      this._initVerticalAxis();

      /** Remove domain line from axes. */
      selectAll('.domain').remove();
    }

    /** Initialize the necessary styles and classes for the horizontal axis. */
  }, {
    key: "_initHorizontalAxis",
    value: function _initHorizontalAxis() {
      /** Build  the string to translate horizontal axis label. */
      var horizontalTransform = 'translate(' + this.width / 2 + ', ' + (this.height + this._margin.bottom - 10) + ')';

      /** Build the x-axis and label. */
      this._svg.append('g').attr('class', 'horizontal-axis').call(this.horizontalScaleType === 'POINT' ? axisBottom(this._scaleHorizontal).tickSizeInner(this.height).tickPadding(20) : axisBottom(this._scaleHorizontal).tickFormat(timeFormat('%m-%d')).tickSizeInner(this.height).tickPadding(20)).append('text').text(this.labelHorizontal).attr('class', 'horizontal-label').attr('transform', horizontalTransform);
      /** Attach classes to horizontal lines. */
      this._svg.selectAll('.horizontal-axis .tick > line').attr('class', 'axis-line');
    }

    /** Initialize the necessary styles and classes for the vertical axis. */
  }, {
    key: "_initVerticalAxis",
    value: function _initVerticalAxis() {
      /** Build the string to translate vertical axis label. */
      var verticalTransform = 'translate(' + -this._margin.left * 0.85 + ', ' + this.height / 2 + ') ' + 'rotate(-90)';

      /** Build the y-axis and label. */
      this._svg.append('g').attr('class', 'vertical-axis').call(axisLeft(this._scaleVertical).tickPadding(20)).append('text').text(this.labelVertical).attr('class', 'vertical-label').attr('transform', verticalTransform);

      /** Remove ticks on vertical axis. */
      this._svg.selectAll('.vertical-axis .tick > line').remove();
    }

    /** Render backup chart for when data is not provided as input. */
  }, {
    key: "_renderErrorChart",
    value: function _renderErrorChart() {
      /** Default scale for horizontal range. */
      this._scaleHorizontal.domain([0, 10]);

      /** Default scale for vertical range. */
      this._scaleVertical.domain([0, 10]);

      /** Build placeholder axes. */
      this._svg.append('g').attr('transform', 'translate(0, ' + this.height + ')').call(axisBottom(this._scaleHorizontal));
      this._svg.append('g').call(axisLeft(this._scaleVertical));
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n      <div class=\"fwc-legend\">\n        ", "\n      </div>\n      <div class=\"fwc-svg-wrapper\">\n        <!-- this canvas is a hack for svg auto height  -->\n        <!-- http://nicolasgallagher.com/canvas-fix-svg-scaling-in-internet-explorer/ -->\n        <canvas width=\"", "\" height=\"", "\"></canvas>\n      </div>\n    "])), this.legend.map(function (item, i) {
        return html(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n            <span class=\"fwc-legend-dot fwc-dot-", "\"></span>\n            <span class=\"fwc-legend-label\">", "</span>\n          "])), i, item);
      }), this.width, this.height);
    }
  }], [{
    key: "styles",
    get: function get() {
      return [sharedStyles, css$1(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n        .fwc-svg-wrapper {\n          position: relative;\n        }\n        .fwc-legend {\n          margin-bottom: calc(2 * var(--fwcu));\n        }\n        .fwc-legend-dot {\n          height: calc(1.25 * var(--fwcu));\n          width: calc(1.25 * var(--fwcu));\n          border: 1px solid transparent;\n          border-radius: 50%;\n          display: inline-block;\n          margin-right: var(--fwcu);\n        }\n        .fwc-legend-label {\n          display: inline-block;\n          margin-right: var(--fwcu);\n        }\n        .fwc-dot-0 {\n          background-color: var(--color-dviz-one);\n        }\n        .fwc-dot-1 {\n          background-color: var(--color-dviz-five);\n        }\n        .fwc-dot-2 {\n          background-color: var(--color-dviz-four);\n        }\n        .line {\n          fill: none;\n          stroke-width: calc(0.5 * var(--fwcu));\n        }\n        .line-0 {\n          stroke: var(--color-dviz-one);\n        }\n        .line-1 {\n          stroke: var(--color-dviz-five);\n        }\n        .line-2 {\n          stroke: var(--color-dviz-four);\n        }\n        .horizontal-label,\n        .vertical-label,\n        .horizontal-axis,\n        .vertical-axis {\n          font-size: var(--default-font-size);\n        }\n        .horizontal-label,\n        .vertical-label {\n          fill: var(--color-black);\n          text-anchor: middle;\n          font-weight: 600;\n        }\n        .axis-line {\n          stroke-opacity: 0.3;\n          stroke: var(--color-gray-four);\n          stroke-width: calc(0.25 * var(--fwcu));\n        }\n        .domain {\n          display: none;\n        }\n        canvas {\n          display: block;\n          visibility: hidden;\n          width: 100%;\n          height: 100%;\n        }\n        svg {\n          position: absolute;\n          top: 0;\n          left: 0;\n          height: 100%;\n          width: 100%;\n          overflow: visible;\n        }\n        @media screen and (max-width: 600px) {\n          .tick {\n            font-size: calc(1.25 * var(--fwcu));\n          }\n          .line {\n            stroke-width: calc(0.25 * var(--fwcu));\n          }\n          .fwc-legend-label {\n            font-size: calc(1.5 * var(--fwcu));\n          }\n        }\n      "])))];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        dataLineOne: {
          attribute: 'data-line-one',
          type: Array
        },
        dataLineTwo: {
          attribute: 'data-line-two',
          type: Array
        },
        dataLineThree: {
          attribute: 'data-line-three',
          type: Array
        },
        legend: {
          type: Array
        },
        labelHorizontal: {
          attribute: 'label-horizontal',
          type: String
        },
        labelVertical: {
          attribute: 'label-vertical',
          type: String
        },
        width: {},
        height: {}
      };
    }
  }]);
  return FwcChartLineComponent;
}(LitElement);
var FwcChartLine = /*#__PURE__*/function (_FwcBase7) {
  _inherits$1(FwcChartLine, _FwcBase7);
  var _super14 = _createSuper$7(FwcChartLine);
  function FwcChartLine() {
    _classCallCheck$1(this, FwcChartLine);
    return _super14.call(this, 'fwc-chart-line', FwcChartLineComponent);
  }
  return _createClass$1(FwcChartLine);
}(FwcBase);

var _templateObject;
css$1(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n  :host {\n    display: block;\n    width: 100%;\n    line-height: var(--default-line-height);\n  }\n  .sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    margin: -1px;\n    padding: 0;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    border: 0;\n  }\n  button:focus,\n  a:focus,\n  .fwc-toggle input:focus + label,\n  .fwc-select-list select:focus,\n  .fwc-radio input:focus,\n  .fwc-input input:focus,\n  input:focus + label,\n  .fwc-checkbox input:focus + label:before,\n  .fwc-carousel-generic-wrapper .fwc-list-cont:focus,\n  div.tip-btn:focus {\n    outline: var(--fwc-focus);\n  }\n"])));

function _EMOTION_STRINGIFIED_CSS_ERROR__$r() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssPreLoaderClass = process.env.NODE_ENV === "production" ? {
  name: "1on72ax-cssPreLoaderClass",
  styles: ".message{text-align:center;padding:15px;};label:cssPreLoaderClass;"
} : {
  name: "1on72ax-cssPreLoaderClass",
  styles: ".message{text-align:center;padding:15px;};label:cssPreLoaderClass;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlByZUxvYWRlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPNkIiLCJmaWxlIjoiUHJlTG9hZGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIHVzZUVmZmVjdCwgdXNlUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IGN4IGZyb20gJ2NsYXNzbmFtZXMnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgRndjUHJlbG9hZGVyIH0gZnJvbSAnLi4vbW90aWYtbGliJztcbmltcG9ydCB7IG5vZGUsIG9uZU9mVHlwZSwgc3RyaW5nIH0gZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgeyBtZXJnZVJlZnMgfSBmcm9tICcuLi91dGlscyc7XG5cbmNvbnN0IGNzc1ByZUxvYWRlckNsYXNzID0gY3NzYFxuICAubWVzc2FnZSB7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgIHBhZGRpbmc6IDE1cHg7XG4gIH1cbmA7XG5cbmV4cG9ydCBjb25zdCBQcmVMb2FkZXIgPSBmb3J3YXJkUmVmKChwcm9wcywgcmVmKSA9PiB7XG4gIGNvbnN0IHsgY2xhc3NOYW1lLCBtZXNzYWdlIH0gPSBwcm9wcztcbiAgY29uc3QgcHJlTG9hZGVyUmVmID0gdXNlUmVmKCk7XG4gIGNvbnN0IHByZUxvYWRlckNsYXNzID0gY3goJ3ByZWxvYWRlci13cmFwcGVyJywgY2xhc3NOYW1lKTtcblxuICB1c2VFZmZlY3QoKCkgPT4ge1xuICAgIGlmIChwcmVMb2FkZXJSZWYuY3VycmVudCkge1xuICAgICAgbmV3IEZ3Y1ByZWxvYWRlcihwcmVMb2FkZXJSZWYuY3VycmVudCkuYnVpbGQoKTtcbiAgICB9XG4gIH0sIFtdKTtcblxuICByZXR1cm4gKFxuICAgIDxkaXYgY3NzPXtjc3NQcmVMb2FkZXJDbGFzc30gY2xhc3NOYW1lPXtwcmVMb2FkZXJDbGFzc30+XG4gICAgICA8ZndjLXByZWxvYWRlciByZWY9e21lcmdlUmVmcyhwcmVMb2FkZXJSZWYsIHJlZil9IC8+XG4gICAgICB7bWVzc2FnZSAmJiA8ZGl2IGNsYXNzTmFtZT1cIm1lc3NhZ2VcIj57bWVzc2FnZX08L2Rpdj59XG4gICAgPC9kaXY+XG4gICk7XG59KTtcblxuUHJlTG9hZGVyLmRpc3BsYXlOYW1lID0gJ1ByZUxvYWRlcic7XG5QcmVMb2FkZXIucHJvcFR5cGVzID0ge1xuICBjbGFzc05hbWU6IHN0cmluZyxcbiAgbWVzc2FnZTogb25lT2ZUeXBlKFtzdHJpbmcsIG5vZGVdKSxcbn07XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$r
};
var PreLoader = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    message = props.message;
  var preLoaderRef = useRef();
  var preLoaderClass = cx('preloader-wrapper', className);
  useEffect(function () {
    if (preLoaderRef.current) {
      new FwcPreloader(preLoaderRef.current).build();
    }
  }, []);
  return jsx("div", {
    css: cssPreLoaderClass,
    className: preLoaderClass
  }, jsx("fwc-preloader", {
    ref: mergeRefs(preLoaderRef, ref)
  }), message && jsx("div", {
    className: "message"
  }, message));
});
PreLoader.displayName = 'PreLoader';
PreLoader.propTypes = {
  className: string,
  message: oneOfType([string, node$2])
};

var _excluded$z = ["assetsPath", "children", "className"];
var SBUIContext = /*#__PURE__*/createContext();
function useSBUIState() {
  var context = useContext(SBUIContext);
  return context || {};
}
function SBUIProvider(props) {
  var _props$assetsPath = props.assetsPath,
    assetsPath = _props$assetsPath === void 0 ? './' : _props$assetsPath,
    children = props.children,
    className = props.className,
    restProps = _objectWithoutProperties$1(props, _excluded$z);
  return jsx(SBUIContext.Provider, {
    value: {
      assetsPath: assetsPath
    }
  }, jsx("div", _extends$1({}, restProps, {
    className: cx('sbui-wrapper', className)
  }), children));
}
SBUIProvider.propTypes = {
  className: string,
  assetsPath: string,
  children: node$2
};

var ModalBody = function ModalBody(props) {
  return jsx("div", _extends$1({}, props, {
    className: cx('modal-body', props.className),
    slot: "body"
  }));
};
ModalBody.propTypes = {
  className: string
};
var ModalFooter = function ModalFooter(props) {
  return jsx("div", _extends$1({}, props, {
    className: cx('modal-footer', props.className),
    slot: "actions"
  }));
};
ModalFooter.propTypes = {
  className: string
};
var Modal = /*#__PURE__*/forwardRef(function (props, ref) {
  var _actionConfig$actionB, _actionConfig$actionB2;
  var children = props.children,
    actionConfig = props.actionConfig,
    _props$disableEscapeK = props.disableEscapeKey,
    disableEscapeKey = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
    _props$disableBackdro = props.disableBackdrop,
    disableBackdrop = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
    _props$onOpen = props.onOpen,
    onOpen = _props$onOpen === void 0 ? function () {} : _props$onOpen,
    _props$onClose = props.onClose,
    onClose = _props$onClose === void 0 ? function () {} : _props$onClose;
  var uiState = useSBUIState();
  var assetsPath = (uiState === null || uiState === void 0 ? void 0 : uiState.assetsPath) || './';
  var modalRef = useRef();
  var fwcModalProps = getFwcProps$1(props, {
    open: 'open',
    title: 'text-header',
    content: 'text-body'
  });
  var handleOpen = useCallback(function (event) {
    event.stopPropagation();
    onOpen === null || onOpen === void 0 ? void 0 : onOpen(event);
  }, [onOpen]);
  var handleClose = useCallback(function (event) {
    event.stopPropagation();
    onClose === null || onClose === void 0 ? void 0 : onClose(event);
  }, [onClose]);
  useEffect(function () {
    if (modalRef !== null && modalRef !== void 0 && modalRef.current) {
      new FwcModal(modalRef === null || modalRef === void 0 ? void 0 : modalRef.current).build();
    }
  }, []);
  useEffect(function () {
    var modalElement = null;
    if (modalRef !== null && modalRef !== void 0 && modalRef.current) {
      var _modalRef$current, _modalRef$current$add, _modalRef$current$add2, _modalRef$current2;
      (_modalRef$current = modalRef.current) === null || _modalRef$current === void 0 ? void 0 : (_modalRef$current$add = _modalRef$current.addEventListener) === null || _modalRef$current$add === void 0 ? void 0 : _modalRef$current$add.call(_modalRef$current, 'fwc-modal-open', handleOpen);
      (_modalRef$current$add2 = (_modalRef$current2 = modalRef.current).addEventListener) === null || _modalRef$current$add2 === void 0 ? void 0 : _modalRef$current$add2.call(_modalRef$current2, 'fwc-modal-close', handleClose);
      modalElement = modalRef === null || modalRef === void 0 ? void 0 : modalRef.current;
    }
    return function () {
      if (modalElement) {
        var _modalElement$removeE, _modalElement, _modalElement$removeE2, _modalElement2;
        (_modalElement$removeE = (_modalElement = modalElement).removeEventListener) === null || _modalElement$removeE === void 0 ? void 0 : _modalElement$removeE.call(_modalElement, 'fwc-modal-open', handleOpen);
        (_modalElement$removeE2 = (_modalElement2 = modalElement).removeEventListener) === null || _modalElement$removeE2 === void 0 ? void 0 : _modalElement$removeE2.call(_modalElement2, 'fwc-modal-close', handleClose);
      }
    };
  }, [handleClose, handleOpen]);
  return jsx("fwc-modal", _extends$1({}, fwcModalProps, {
    ref: mergeRefs(ref, modalRef),
    config: JSON.stringify({
      assetsPath: assetsPath
    }),
    "disable-backdrop": disableBackdrop ? 'true' : 'false',
    "disable-escape-key": disableEscapeKey ? 'true' : 'false'
  }), children, (actionConfig === null || actionConfig === void 0 ? void 0 : (_actionConfig$actionB = actionConfig.actionButtons) === null || _actionConfig$actionB === void 0 ? void 0 : _actionConfig$actionB.length) && jsx("div", {
    slot: "actions"
  }, actionConfig === null || actionConfig === void 0 ? void 0 : (_actionConfig$actionB2 = actionConfig.actionButtons) === null || _actionConfig$actionB2 === void 0 ? void 0 : _actionConfig$actionB2.map(function (action) {
    return jsx(Button, {
      key: (action === null || action === void 0 ? void 0 : action.id) || "modal-action-".concat(action === null || action === void 0 ? void 0 : action.label),
      btnType: (action === null || action === void 0 ? void 0 : action.type) || 'primary',
      id: (action === null || action === void 0 ? void 0 : action.id) || "modal-action-".concat(action === null || action === void 0 ? void 0 : action.label),
      onClick: function onClick(args) {
        var _actionConfig$actionH;
        actionConfig === null || actionConfig === void 0 ? void 0 : (_actionConfig$actionH = actionConfig.actionHandler) === null || _actionConfig$actionH === void 0 ? void 0 : _actionConfig$actionH.call(actionConfig, action === null || action === void 0 ? void 0 : action.label, args);
      }
    }, action === null || action === void 0 ? void 0 : action.label);
  })));
});
Modal.displayName = 'Modal';
Modal.Body = ModalBody;
Modal.Body.displayName = 'Modal.Body';
Modal.Footer = ModalFooter;
Modal.Footer.displayName = 'Modal.Footer';
Modal.propTypes = {
  id: string,
  className: string,
  open: bool,
  disableBackdrop: bool,
  disableEscapeKey: bool,
  title: string,
  content: string,
  children: node$2,
  onOpen: func,
  onClose: func,
  actionConfig: shape({
    actionHandler: func,
    actionButtons: arrayOf(shape({
      label: string.isRequired,
      type: oneOf(['primary', 'secondary']).isRequired,
      id: string
    }))
  })
};

var _excluded$y = ["children", "className", "type", "whiteBackground", "labelAriaCloseBtn", "onClose"];
var Alert = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    type = props.type,
    whiteBackground = props.whiteBackground,
    labelAriaCloseBtn = props.labelAriaCloseBtn,
    onClose = props.onClose,
    restProps = _objectWithoutProperties$1(props, _excluded$y);
  var alertRef = useRef();
  var alertClass = cx('alert-wrapper', className);
  var handleClose = useCallback(function (e) {
    return onClose === null || onClose === void 0 ? void 0 : onClose(e);
  }, [onClose]);
  useEffect(function () {
    if (alertRef.current) {
      new FwcAlert(alertRef.current).build();
    }
  }, []);
  useEffect(function () {
    var alertElement = null;
    if (alertRef.current) {
      alertRef.current.addEventListener('fwc-alert-closed', handleClose);
      alertElement = alertRef.current;
    }
    return function () {
      if (alertElement) {
        alertElement.removeEventListener('fwc-alert-closed', handleClose);
      }
    };
  }, [handleClose]);
  return (
    // We are wrapping <fwx-alert /> inside <div /> since ReactJS is giving below
    // Error :: Uncaught DOMException: Failed to execute 'removeChild' on 'Node':
    // The node to be removed is not a child of this node.
    jsx("div", {
      className: alertClass
    }, jsx("fwc-alert", _extends$1({}, restProps, {
      "class": "fwc-alert",
      type: type,
      "bg-color": whiteBackground ? 'white' : '',
      ref: mergeRefs(alertRef, ref),
      "label-aria-close-btn": labelAriaCloseBtn
    }), children))
  );
});
Alert.displayName = 'Alert';
Alert.propTypes = {
  className: string,
  type: oneOf(['info', 'urgent', 'success', 'error']),
  whiteBackground: bool,
  labelAriaCloseBtn: string,
  children: node$2,
  onClose: func
};

var htmlReactParser = {exports: {}};

var lib$2 = {};

var possibleStandardNamesOptimized$1 = {};

// An attribute in which the DOM/SVG standard name is the same as the React prop name (e.g., 'accept').
var SAME$1 = 0;
possibleStandardNamesOptimized$1.SAME = SAME$1;

// An attribute in which the React prop name is the camelcased version of the DOM/SVG standard name (e.g., 'acceptCharset').
var CAMELCASE$1 = 1;
possibleStandardNamesOptimized$1.CAMELCASE = CAMELCASE$1;

possibleStandardNamesOptimized$1.possibleStandardNames = {
  accept: 0,
  acceptCharset: 1,
  'accept-charset': 'acceptCharset',
  accessKey: 1,
  action: 0,
  allowFullScreen: 1,
  alt: 0,
  as: 0,
  async: 0,
  autoCapitalize: 1,
  autoComplete: 1,
  autoCorrect: 1,
  autoFocus: 1,
  autoPlay: 1,
  autoSave: 1,
  capture: 0,
  cellPadding: 1,
  cellSpacing: 1,
  challenge: 0,
  charSet: 1,
  checked: 0,
  children: 0,
  cite: 0,
  class: 'className',
  classID: 1,
  className: 1,
  cols: 0,
  colSpan: 1,
  content: 0,
  contentEditable: 1,
  contextMenu: 1,
  controls: 0,
  controlsList: 1,
  coords: 0,
  crossOrigin: 1,
  dangerouslySetInnerHTML: 1,
  data: 0,
  dateTime: 1,
  default: 0,
  defaultChecked: 1,
  defaultValue: 1,
  defer: 0,
  dir: 0,
  disabled: 0,
  disablePictureInPicture: 1,
  disableRemotePlayback: 1,
  download: 0,
  draggable: 0,
  encType: 1,
  enterKeyHint: 1,
  for: 'htmlFor',
  form: 0,
  formMethod: 1,
  formAction: 1,
  formEncType: 1,
  formNoValidate: 1,
  formTarget: 1,
  frameBorder: 1,
  headers: 0,
  height: 0,
  hidden: 0,
  high: 0,
  href: 0,
  hrefLang: 1,
  htmlFor: 1,
  httpEquiv: 1,
  'http-equiv': 'httpEquiv',
  icon: 0,
  id: 0,
  innerHTML: 1,
  inputMode: 1,
  integrity: 0,
  is: 0,
  itemID: 1,
  itemProp: 1,
  itemRef: 1,
  itemScope: 1,
  itemType: 1,
  keyParams: 1,
  keyType: 1,
  kind: 0,
  label: 0,
  lang: 0,
  list: 0,
  loop: 0,
  low: 0,
  manifest: 0,
  marginWidth: 1,
  marginHeight: 1,
  max: 0,
  maxLength: 1,
  media: 0,
  mediaGroup: 1,
  method: 0,
  min: 0,
  minLength: 1,
  multiple: 0,
  muted: 0,
  name: 0,
  noModule: 1,
  nonce: 0,
  noValidate: 1,
  open: 0,
  optimum: 0,
  pattern: 0,
  placeholder: 0,
  playsInline: 1,
  poster: 0,
  preload: 0,
  profile: 0,
  radioGroup: 1,
  readOnly: 1,
  referrerPolicy: 1,
  rel: 0,
  required: 0,
  reversed: 0,
  role: 0,
  rows: 0,
  rowSpan: 1,
  sandbox: 0,
  scope: 0,
  scoped: 0,
  scrolling: 0,
  seamless: 0,
  selected: 0,
  shape: 0,
  size: 0,
  sizes: 0,
  span: 0,
  spellCheck: 1,
  src: 0,
  srcDoc: 1,
  srcLang: 1,
  srcSet: 1,
  start: 0,
  step: 0,
  style: 0,
  summary: 0,
  tabIndex: 1,
  target: 0,
  title: 0,
  type: 0,
  useMap: 1,
  value: 0,
  width: 0,
  wmode: 0,
  wrap: 0,
  about: 0,
  accentHeight: 1,
  'accent-height': 'accentHeight',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 1,
  'alignment-baseline': 'alignmentBaseline',
  allowReorder: 1,
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 1,
  'arabic-form': 'arabicForm',
  ascent: 0,
  attributeName: 1,
  attributeType: 1,
  autoReverse: 1,
  azimuth: 0,
  baseFrequency: 1,
  baselineShift: 1,
  'baseline-shift': 'baselineShift',
  baseProfile: 1,
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 1,
  capHeight: 1,
  'cap-height': 'capHeight',
  clip: 0,
  clipPath: 1,
  'clip-path': 'clipPath',
  clipPathUnits: 1,
  clipRule: 1,
  'clip-rule': 'clipRule',
  color: 0,
  colorInterpolation: 1,
  'color-interpolation': 'colorInterpolation',
  colorInterpolationFilters: 1,
  'color-interpolation-filters': 'colorInterpolationFilters',
  colorProfile: 1,
  'color-profile': 'colorProfile',
  colorRendering: 1,
  'color-rendering': 'colorRendering',
  contentScriptType: 1,
  contentStyleType: 1,
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  datatype: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 1,
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 1,
  'dominant-baseline': 'dominantBaseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 1,
  elevation: 0,
  enableBackground: 1,
  'enable-background': 'enableBackground',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 1,
  fill: 0,
  fillOpacity: 1,
  'fill-opacity': 'fillOpacity',
  fillRule: 1,
  'fill-rule': 'fillRule',
  filter: 0,
  filterRes: 1,
  filterUnits: 1,
  floodOpacity: 1,
  'flood-opacity': 'floodOpacity',
  floodColor: 1,
  'flood-color': 'floodColor',
  focusable: 0,
  fontFamily: 1,
  'font-family': 'fontFamily',
  fontSize: 1,
  'font-size': 'fontSize',
  fontSizeAdjust: 1,
  'font-size-adjust': 'fontSizeAdjust',
  fontStretch: 1,
  'font-stretch': 'fontStretch',
  fontStyle: 1,
  'font-style': 'fontStyle',
  fontVariant: 1,
  'font-variant': 'fontVariant',
  fontWeight: 1,
  'font-weight': 'fontWeight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 1,
  'glyph-name': 'glyphName',
  glyphOrientationHorizontal: 1,
  'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
  glyphOrientationVertical: 1,
  'glyph-orientation-vertical': 'glyphOrientationVertical',
  glyphRef: 1,
  gradientTransform: 1,
  gradientUnits: 1,
  hanging: 0,
  horizAdvX: 1,
  'horiz-adv-x': 'horizAdvX',
  horizOriginX: 1,
  'horiz-origin-x': 'horizOriginX',
  ideographic: 0,
  imageRendering: 1,
  'image-rendering': 'imageRendering',
  in2: 0,
  in: 0,
  inlist: 0,
  intercept: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  k: 0,
  kernelMatrix: 1,
  kernelUnitLength: 1,
  kerning: 0,
  keyPoints: 1,
  keySplines: 1,
  keyTimes: 1,
  lengthAdjust: 1,
  letterSpacing: 1,
  'letter-spacing': 'letterSpacing',
  lightingColor: 1,
  'lighting-color': 'lightingColor',
  limitingConeAngle: 1,
  local: 0,
  markerEnd: 1,
  'marker-end': 'markerEnd',
  markerHeight: 1,
  markerMid: 1,
  'marker-mid': 'markerMid',
  markerStart: 1,
  'marker-start': 'markerStart',
  markerUnits: 1,
  markerWidth: 1,
  mask: 0,
  maskContentUnits: 1,
  maskUnits: 1,
  mathematical: 0,
  mode: 0,
  numOctaves: 1,
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 1,
  'overline-position': 'overlinePosition',
  overlineThickness: 1,
  'overline-thickness': 'overlineThickness',
  paintOrder: 1,
  'paint-order': 'paintOrder',
  panose1: 0,
  'panose-1': 'panose1',
  pathLength: 1,
  patternContentUnits: 1,
  patternTransform: 1,
  patternUnits: 1,
  pointerEvents: 1,
  'pointer-events': 'pointerEvents',
  points: 0,
  pointsAtX: 1,
  pointsAtY: 1,
  pointsAtZ: 1,
  prefix: 0,
  preserveAlpha: 1,
  preserveAspectRatio: 1,
  primitiveUnits: 1,
  property: 0,
  r: 0,
  radius: 0,
  refX: 1,
  refY: 1,
  renderingIntent: 1,
  'rendering-intent': 'renderingIntent',
  repeatCount: 1,
  repeatDur: 1,
  requiredExtensions: 1,
  requiredFeatures: 1,
  resource: 0,
  restart: 0,
  result: 0,
  results: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  security: 0,
  seed: 0,
  shapeRendering: 1,
  'shape-rendering': 'shapeRendering',
  slope: 0,
  spacing: 0,
  specularConstant: 1,
  specularExponent: 1,
  speed: 0,
  spreadMethod: 1,
  startOffset: 1,
  stdDeviation: 1,
  stemh: 0,
  stemv: 0,
  stitchTiles: 1,
  stopColor: 1,
  'stop-color': 'stopColor',
  stopOpacity: 1,
  'stop-opacity': 'stopOpacity',
  strikethroughPosition: 1,
  'strikethrough-position': 'strikethroughPosition',
  strikethroughThickness: 1,
  'strikethrough-thickness': 'strikethroughThickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 1,
  'stroke-dasharray': 'strokeDasharray',
  strokeDashoffset: 1,
  'stroke-dashoffset': 'strokeDashoffset',
  strokeLinecap: 1,
  'stroke-linecap': 'strokeLinecap',
  strokeLinejoin: 1,
  'stroke-linejoin': 'strokeLinejoin',
  strokeMiterlimit: 1,
  'stroke-miterlimit': 'strokeMiterlimit',
  strokeWidth: 1,
  'stroke-width': 'strokeWidth',
  strokeOpacity: 1,
  'stroke-opacity': 'strokeOpacity',
  suppressContentEditableWarning: 1,
  suppressHydrationWarning: 1,
  surfaceScale: 1,
  systemLanguage: 1,
  tableValues: 1,
  targetX: 1,
  targetY: 1,
  textAnchor: 1,
  'text-anchor': 'textAnchor',
  textDecoration: 1,
  'text-decoration': 'textDecoration',
  textLength: 1,
  textRendering: 1,
  'text-rendering': 'textRendering',
  to: 0,
  transform: 0,
  typeof: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 1,
  'underline-position': 'underlinePosition',
  underlineThickness: 1,
  'underline-thickness': 'underlineThickness',
  unicode: 0,
  unicodeBidi: 1,
  'unicode-bidi': 'unicodeBidi',
  unicodeRange: 1,
  'unicode-range': 'unicodeRange',
  unitsPerEm: 1,
  'units-per-em': 'unitsPerEm',
  unselectable: 0,
  vAlphabetic: 1,
  'v-alphabetic': 'vAlphabetic',
  values: 0,
  vectorEffect: 1,
  'vector-effect': 'vectorEffect',
  version: 0,
  vertAdvY: 1,
  'vert-adv-y': 'vertAdvY',
  vertOriginX: 1,
  'vert-origin-x': 'vertOriginX',
  vertOriginY: 1,
  'vert-origin-y': 'vertOriginY',
  vHanging: 1,
  'v-hanging': 'vHanging',
  vIdeographic: 1,
  'v-ideographic': 'vIdeographic',
  viewBox: 1,
  viewTarget: 1,
  visibility: 0,
  vMathematical: 1,
  'v-mathematical': 'vMathematical',
  vocab: 0,
  widths: 0,
  wordSpacing: 1,
  'word-spacing': 'wordSpacing',
  writingMode: 1,
  'writing-mode': 'writingMode',
  x1: 0,
  x2: 0,
  x: 0,
  xChannelSelector: 1,
  xHeight: 1,
  'x-height': 'xHeight',
  xlinkActuate: 1,
  'xlink:actuate': 'xlinkActuate',
  xlinkArcrole: 1,
  'xlink:arcrole': 'xlinkArcrole',
  xlinkHref: 1,
  'xlink:href': 'xlinkHref',
  xlinkRole: 1,
  'xlink:role': 'xlinkRole',
  xlinkShow: 1,
  'xlink:show': 'xlinkShow',
  xlinkTitle: 1,
  'xlink:title': 'xlinkTitle',
  xlinkType: 1,
  'xlink:type': 'xlinkType',
  xmlBase: 1,
  'xml:base': 'xmlBase',
  xmlLang: 1,
  'xml:lang': 'xmlLang',
  xmlns: 0,
  'xml:space': 'xmlSpace',
  xmlnsXlink: 1,
  'xmlns:xlink': 'xmlnsXlink',
  xmlSpace: 1,
  y1: 0,
  y2: 0,
  y: 0,
  yChannelSelector: 1,
  z: 0,
  zoomAndPan: 1
};

Object.defineProperty(lib$2, '__esModule', { value: true });

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// A reserved attribute.
// It is handled by React separately and shouldn't be written to the DOM.
var RESERVED = 0; // A simple string attribute.
// Attributes that aren't in the filter are presumed to have this type.

var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
// "enumerated" attributes with "true" and "false" as possible values.
// When true, it should be set to a "true" string.
// When false, it should be set to a "false" string.

var BOOLEANISH_STRING = 2; // A real boolean attribute.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.

var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
// For any other value, should be present with that value.

var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
// When falsy, it should be removed.

var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
// When falsy, it should be removed.

var POSITIVE_NUMERIC = 6;
function getPropertyInfo(name) {
  return properties.hasOwnProperty(name) ? properties[name] : null;
}

function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
  this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
  this.attributeName = attributeName;
  this.attributeNamespace = attributeNamespace;
  this.mustUseProperty = mustUseProperty;
  this.propertyName = name;
  this.type = type;
  this.sanitizeURL = sanitizeURL;
  this.removeEmptyString = removeEmptyString;
} // When adding attributes to this list, be sure to also add them to
// the `possibleStandardNames` module to ensure casing and incorrect
// name warnings.


var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.

var reservedProps = ['children', 'dangerouslySetInnerHTML', // TODO: This prevents the assignment of defaultValue to regular
// elements (not just inputs). Now that ReactDOMInput assigns to the
// defaultValue property -- do we need this?
'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
reservedProps.forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, RESERVED, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // A few React string attributes have a different name.
// This is a mapping from React prop names to the attribute names.

[['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      attributeName = _ref2[1];

  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are "enumerated" HTML attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).

['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are "enumerated" SVG attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
// Since these are SVG attributes, their attribute names are case-sensitive.

['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML boolean attributes.

['allowFullScreen', 'async', // Note: there is a special case that prevents it from being written to the DOM
// on the client side because the browsers are inconsistent. Instead we call focus().
'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'disableRemotePlayback', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless', // Microdata
'itemScope'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are the few React props that we set as DOM properties
// rather than attributes. These are all booleans.

['checked', // Note: `option.selected` is not updated if `select.multiple` is
// disabled with `removeAttribute`. We have special logic for handling this.
'multiple', 'muted', 'selected' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that are "overloaded booleans": they behave like
// booleans, but can also accept a string value.

['capture', 'download' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that must be positive numbers.

['cols', 'rows', 'size', 'span' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that must be numbers.

['rowSpan', 'start'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, NUMERIC, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
});
var CAMELIZE = /[\-\:]([a-z])/g;

var capitalize$1 = function capitalize(token) {
  return token[1].toUpperCase();
}; // This is a list of all SVG attributes that need special casing, namespacing,
// or boolean value assignment. Regular attributes that just accept strings
// and have the same names are omitted, just like in the HTML attribute filter.
// Some of these attributes can be hard to find. This list was created by
// scraping the MDN documentation.


['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize$1);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // String SVG attributes with the xlink namespace.

['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize$1);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/1999/xlink', false, // sanitizeURL
  false);
}); // String SVG attributes with the xml namespace.

['xml:base', 'xml:lang', 'xml:space' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize$1);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/XML/1998/namespace', false, // sanitizeURL
  false);
}); // These attribute exists both in HTML and SVG.
// The attribute name is case-sensitive in SVG so we can't just use
// the React name like we do for attributes that exist only in HTML.

['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These attributes accept URLs. These must not allow javascript: URLS.
// These will also need to accept Trusted Types object in the future.

var xlinkHref = 'xlinkHref';
properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, // mustUseProperty
'xlink:href', 'http://www.w3.org/1999/xlink', true, // sanitizeURL
false);
['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  true, // sanitizeURL
  true);
});

var _require = possibleStandardNamesOptimized$1,
    CAMELCASE = _require.CAMELCASE,
    SAME = _require.SAME,
    possibleStandardNamesOptimized = _require.possibleStandardNames;

var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
/**
 * Checks whether a property name is a custom attribute.
 *
 * @see {@link https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25}
 *
 * @param {string}
 * @return {boolean}
 */

var isCustomAttribute = RegExp.prototype.test.bind( // eslint-disable-next-line no-misleading-character-class
new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
var possibleStandardNames = Object.keys(possibleStandardNamesOptimized).reduce(function (accumulator, standardName) {
  var propName = possibleStandardNamesOptimized[standardName];

  if (propName === SAME) {
    accumulator[standardName] = standardName;
  } else if (propName === CAMELCASE) {
    accumulator[standardName.toLowerCase()] = standardName;
  } else {
    accumulator[standardName] = propName;
  }

  return accumulator;
}, {});

lib$2.BOOLEAN = BOOLEAN;
lib$2.BOOLEANISH_STRING = BOOLEANISH_STRING;
lib$2.NUMERIC = NUMERIC;
lib$2.OVERLOADED_BOOLEAN = OVERLOADED_BOOLEAN;
lib$2.POSITIVE_NUMERIC = POSITIVE_NUMERIC;
lib$2.RESERVED = RESERVED;
lib$2.STRING = STRING;
lib$2.getPropertyInfo = getPropertyInfo;
lib$2.isCustomAttribute = isCustomAttribute;
lib$2.possibleStandardNames = possibleStandardNames;

var cjs = {};

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;

var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;

// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;

// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';

// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';

/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */
var inlineStyleParser = function(style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (!style) return [];

  options = options || {};

  /**
   * Positional.
   */
  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */
  function position() {
    var start = { line: lineno, column: column };
    return function(node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string.
   */
  Position.prototype.content = style;

  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */
  function error(msg) {
    var err = new Error(
      options.source + ':' + lineno + ':' + column + ': ' + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;

    if (options.silent) ; else {
      throw err;
    }
  }

  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */
  function whitespace() {
    match(WHITESPACE_REGEX);
  }

  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */
  function comments(rules) {
    var c;
    rules = rules || [];
    while ((c = comment())) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;

    var i = 2;
    while (
      EMPTY_STRING != style.charAt(i) &&
      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
    ) {
      ++i;
    }
    i += 2;

    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }

    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;

    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }

  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */
  function declaration() {
    var pos = position();

    // prop
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();

    // :
    if (!match(COLON_REGEX)) return error("property missing ':'");

    // val
    var val = match(VALUE_REGEX);

    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim$1(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val
        ? trim$1(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
        : EMPTY_STRING
    });

    // ;
    match(SEMICOLON_REGEX);

    return ret;
  }

  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */
  function declarations() {
    var decls = [];

    comments(decls);

    // declarations
    var decl;
    while ((decl = declaration())) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }

    return decls;
  }

  whitespace();
  return declarations();
};

/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */
function trim$1(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}

var parse = inlineStyleParser;

/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */
function StyleToObject(style, iterator) {
  var output = null;
  if (!style || typeof style !== 'string') {
    return output;
  }

  var declaration;
  var declarations = parse(style);
  var hasIterator = typeof iterator === 'function';
  var property;
  var value;

  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration = declarations[i];
    property = declaration.property;
    value = declaration.value;

    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }

  return output;
}

var styleToObject = StyleToObject;

var utilities$4 = {};

utilities$4.__esModule = true;
utilities$4.camelCase = void 0;
var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9-]+$/;
var HYPHEN_REGEX = /-([a-z])/g;
var NO_HYPHEN_REGEX = /^[^-]+$/;
var VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
var skipCamelCase = function (property) {
    return !property ||
        NO_HYPHEN_REGEX.test(property) ||
        CUSTOM_PROPERTY_REGEX.test(property);
};
var capitalize = function (match, character) {
    return character.toUpperCase();
};
var trimHyphen = function (match, prefix) { return "".concat(prefix, "-"); };
var camelCase = function (property, options) {
    if (options === void 0) { options = {}; }
    if (skipCamelCase(property)) {
        return property;
    }
    property = property.toLowerCase();
    if (options.reactCompat) {
        property = property.replace(MS_VENDOR_PREFIX_REGEX, trimHyphen);
    }
    else {
        property = property.replace(VENDOR_PREFIX_REGEX, trimHyphen);
    }
    return property.replace(HYPHEN_REGEX, capitalize);
};
utilities$4.camelCase = camelCase;

(function (exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var style_to_object_1 = __importDefault(styleToObject);
var utilities_1 = utilities$4;
function StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') {
        return output;
    }
    (0, style_to_object_1["default"])(style, function (property, value) {
        if (property && value) {
            output[(0, utilities_1.camelCase)(property, options)] = value;
        }
    });
    return output;
}
exports["default"] = StyleToJS;
}(cjs));

var React$1 = React__default;
var styleToJS = cjs.default;

/**
 * Swap key with value in an object.
 *
 * @param {object} obj - The object.
 * @param {Function} [override] - The override method.
 * @returns - The inverted object.
 */
function invertObject(obj, override) {
  if (!obj || typeof obj !== 'object') {
    throw new TypeError('First argument must be an object');
  }

  var key;
  var value;
  var isOverridePresent = typeof override === 'function';
  var overrides = {};
  var result = {};

  for (key in obj) {
    value = obj[key];

    if (isOverridePresent) {
      overrides = override(key, value);
      if (overrides && overrides.length === 2) {
        result[overrides[0]] = overrides[1];
        continue;
      }
    }

    if (typeof value === 'string') {
      result[value] = key;
    }
  }

  return result;
}

/**
 * Check if a given tag is a custom component.
 *
 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
 *
 * @param {string} tagName - The name of the html tag.
 * @param {object} props - The props being passed to the element.
 * @returns - Whether tag is custom component.
 */
function isCustomComponent(tagName, props) {
  if (tagName.indexOf('-') === -1) {
    return props && typeof props.is === 'string';
  }

  switch (tagName) {
    // These are reserved SVG and MathML elements.
    // We don't mind this whitelist too much because we expect it to never grow.
    // The alternative is to track the namespace in a few places which is convoluted.
    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
    case 'annotation-xml':
    case 'color-profile':
    case 'font-face':
    case 'font-face-src':
    case 'font-face-uri':
    case 'font-face-format':
    case 'font-face-name':
    case 'missing-glyph':
      return false;
    default:
      return true;
  }
}

var styleToJSOptions = { reactCompat: true };

/**
 * Sets style prop.
 *
 * @param {null|undefined|string} style
 * @param {object} props
 */
function setStyleProp$1(style, props) {
  if (style === null || style === undefined) {
    return;
  }
  try {
    props.style = styleToJS(style, styleToJSOptions);
  } catch (err) {
    props.style = {};
  }
}

/**
 * @constant {boolean}
 * @see {@link https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html}
 */
var PRESERVE_CUSTOM_ATTRIBUTES = React$1.version.split('.')[0] >= 16;

// Taken from
// https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react-dom/src/client/validateDOMNesting.js#L213
var elementsWithNoTextChildren = new Set([
  'tr',
  'tbody',
  'thead',
  'tfoot',
  'colgroup',
  'table',
  'head',
  'html',
  'frameset'
]);

/**
 * Checks if the given node can contain text nodes
 *
 * @param {DomElement} node - Node.
 * @returns - Whether node can contain text nodes.
 */
function canTextBeChildOfNode$1(node) {
  return !elementsWithNoTextChildren.has(node.name);
}

var utilities$3 = {
  PRESERVE_CUSTOM_ATTRIBUTES: PRESERVE_CUSTOM_ATTRIBUTES,
  invertObject: invertObject,
  isCustomComponent: isCustomComponent,
  setStyleProp: setStyleProp$1,
  canTextBeChildOfNode: canTextBeChildOfNode$1,
  elementsWithNoTextChildren: elementsWithNoTextChildren
};

var reactProperty = lib$2;
var utilities$2 = utilities$3;

/**
 * Converts HTML/SVG DOM attributes to React props.
 *
 * @param {object} [attributes={}] - HTML/SVG DOM attributes.
 * @returns - React props.
 */
var attributesToProps$2 = function attributesToProps(attributes) {
  attributes = attributes || {};

  var valueOnlyInputs = {
    reset: true,
    submit: true
  };

  var attributeName;
  var attributeNameLowerCased;
  var attributeValue;
  var propName;
  var propertyInfo;
  var props = {};
  var inputIsValueOnly = attributes.type && valueOnlyInputs[attributes.type];

  for (attributeName in attributes) {
    attributeValue = attributes[attributeName];

    // ARIA (aria-*) or custom data (data-*) attribute
    if (reactProperty.isCustomAttribute(attributeName)) {
      props[attributeName] = attributeValue;
      continue;
    }

    // convert HTML/SVG attribute to React prop
    attributeNameLowerCased = attributeName.toLowerCase();
    propName = getPropName(attributeNameLowerCased);

    if (propName) {
      propertyInfo = reactProperty.getPropertyInfo(propName);

      // convert attribute to uncontrolled component prop (e.g., `value` to `defaultValue`)
      // https://reactjs.org/docs/uncontrolled-components.html
      if (
        (propName === 'checked' || propName === 'value') &&
        !inputIsValueOnly
      ) {
        propName = getPropName('default' + attributeNameLowerCased);
      }

      props[propName] = attributeValue;

      switch (propertyInfo && propertyInfo.type) {
        case reactProperty.BOOLEAN:
          props[propName] = true;
          break;
        case reactProperty.OVERLOADED_BOOLEAN:
          if (attributeValue === '') {
            props[propName] = true;
          }
          break;
      }
      continue;
    }

    // preserve custom attribute if React >=16
    if (utilities$2.PRESERVE_CUSTOM_ATTRIBUTES) {
      props[attributeName] = attributeValue;
    }
  }

  // transform inline style to object
  utilities$2.setStyleProp(attributes.style, props);

  return props;
};

/**
 * Gets prop name from lowercased attribute name.
 *
 * @param {string} attributeName - Lowercased attribute name.
 * @returns - Prop name.
 */
function getPropName(attributeName) {
  return reactProperty.possibleStandardNames[attributeName];
}

var React = React__default;
var attributesToProps$1 = attributesToProps$2;
var utilities$1 = utilities$3;

var setStyleProp = utilities$1.setStyleProp;
var canTextBeChildOfNode = utilities$1.canTextBeChildOfNode;

/**
 * Converts DOM nodes to JSX element(s).
 *
 * @param {DomElement[]} nodes - DOM nodes.
 * @param {object} [options={}] - Options.
 * @param {Function} [options.replace] - Replacer.
 * @param {object} [options.library] - Library (React, Preact, etc.).
 * @returns - String or JSX element(s).
 */
function domToReact$1(nodes, options) {
  options = options || {};

  var library = options.library || React;
  var cloneElement = library.cloneElement;
  var createElement = library.createElement;
  var isValidElement = library.isValidElement;

  var result = [];
  var node;
  var isWhitespace;
  var hasReplace = typeof options.replace === 'function';
  var replaceElement;
  var props;
  var children;
  var trim = options.trim;

  for (var i = 0, len = nodes.length; i < len; i++) {
    node = nodes[i];

    // replace with custom React element (if present)
    if (hasReplace) {
      replaceElement = options.replace(node);

      if (isValidElement(replaceElement)) {
        // set "key" prop for sibling elements
        // https://fb.me/react-warning-keys
        if (len > 1) {
          replaceElement = cloneElement(replaceElement, {
            key: replaceElement.key || i
          });
        }
        result.push(replaceElement);
        continue;
      }
    }

    if (node.type === 'text') {
      isWhitespace = !node.data.trim().length;

      if (isWhitespace && node.parent && !canTextBeChildOfNode(node.parent)) {
        // We have a whitespace node that can't be nested in its parent
        // so skip it
        continue;
      }

      if (trim && isWhitespace) {
        // Trim is enabled and we have a whitespace node
        // so skip it
        continue;
      }

      // We have a text node that's not whitespace and it can be nested
      // in its parent so add it to the results
      result.push(node.data);
      continue;
    }

    props = node.attribs;
    if (skipAttributesToProps(node)) {
      setStyleProp(props.style, props);
    } else if (props) {
      props = attributesToProps$1(props);
    }

    children = null;

    switch (node.type) {
      case 'script':
      case 'style':
        // prevent text in <script> or <style> from being escaped
        // https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
        if (node.children[0]) {
          props.dangerouslySetInnerHTML = {
            __html: node.children[0].data
          };
        }
        break;

      case 'tag':
        // setting textarea value in children is an antipattern in React
        // https://reactjs.org/docs/forms.html#the-textarea-tag
        if (node.name === 'textarea' && node.children[0]) {
          props.defaultValue = node.children[0].data;
        } else if (node.children && node.children.length) {
          // continue recursion of creating React elements (if applicable)
          children = domToReact$1(node.children, options);
        }
        break;

      // skip all other cases (e.g., comment)
      default:
        continue;
    }

    // set "key" prop for sibling elements
    // https://fb.me/react-warning-keys
    if (len > 1) {
      props.key = i;
    }

    result.push(createElement(node.name, props, children));
  }

  return result.length === 1 ? result[0] : result;
}

/**
 * Determines whether DOM element attributes should be transformed to props.
 * Web Components should not have their attributes transformed except for `style`.
 *
 * @param {DomElement} node
 * @returns - Whether node attributes should be converted to props.
 */
function skipAttributesToProps(node) {
  return (
    utilities$1.PRESERVE_CUSTOM_ATTRIBUTES &&
    node.type === 'tag' &&
    utilities$1.isCustomComponent(node.name, node.attribs)
  );
}

var domToReact_1 = domToReact$1;

var Parser$2 = {};

var Tokenizer$1 = {};

var decode_codepoint = {};

// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
Object.defineProperty(decode_codepoint, "__esModule", { value: true });
var decodeMap = new Map([
    [0, 65533],
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376],
]);
var fromCodePoint = 
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
String.fromCodePoint ||
    function (codePoint) {
        var output = "";
        if (codePoint > 0xffff) {
            codePoint -= 0x10000;
            output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
            codePoint = 0xdc00 | (codePoint & 0x3ff);
        }
        output += String.fromCharCode(codePoint);
        return output;
    };
function decodeCodePoint(codePoint) {
    var _a;
    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
        return "\uFFFD";
    }
    return fromCodePoint((_a = decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint);
}
decode_codepoint.default = decodeCodePoint;

var decode = {};

var decodeDataHtml = {};

Object.defineProperty(decodeDataHtml, "__esModule", { value: true });
// Generated using scripts/write-decode-map.ts
// prettier-ignore
decodeDataHtml.default = new Uint16Array([14866, 60, 237, 340, 721, 1312, 1562, 1654, 1838, 1957, 2183, 2239, 2301, 2958, 3037, 3893, 4123, 4298, 4330, 4801, 5191, 5395, 5752, 5903, 5943, 5972, 6050, 0, 0, 0, 0, 0, 0, 6135, 6565, 7422, 8183, 8738, 9242, 9503, 9938, 10189, 10573, 10637, 10715, 11950, 12246, 13539, 13950, 14445, 14533, 15364, 16514, 16980, 17390, 17763, 17849, 18036, 18125, 4096, 69, 77, 97, 98, 99, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 92, 100, 106, 115, 122, 137, 142, 151, 157, 163, 167, 182, 196, 204, 220, 229, 108, 105, 103, 33024, 198, 59, 32768, 198, 80, 33024, 38, 59, 32768, 38, 99, 117, 116, 101, 33024, 193, 59, 32768, 193, 114, 101, 118, 101, 59, 32768, 258, 512, 105, 121, 127, 134, 114, 99, 33024, 194, 59, 32768, 194, 59, 32768, 1040, 114, 59, 32896, 55349, 56580, 114, 97, 118, 101, 33024, 192, 59, 32768, 192, 112, 104, 97, 59, 32768, 913, 97, 99, 114, 59, 32768, 256, 100, 59, 32768, 10835, 512, 103, 112, 172, 177, 111, 110, 59, 32768, 260, 102, 59, 32896, 55349, 56632, 112, 108, 121, 70, 117, 110, 99, 116, 105, 111, 110, 59, 32768, 8289, 105, 110, 103, 33024, 197, 59, 32768, 197, 512, 99, 115, 209, 214, 114, 59, 32896, 55349, 56476, 105, 103, 110, 59, 32768, 8788, 105, 108, 100, 101, 33024, 195, 59, 32768, 195, 109, 108, 33024, 196, 59, 32768, 196, 2048, 97, 99, 101, 102, 111, 114, 115, 117, 253, 278, 282, 310, 315, 321, 327, 332, 512, 99, 114, 258, 267, 107, 115, 108, 97, 115, 104, 59, 32768, 8726, 583, 271, 274, 59, 32768, 10983, 101, 100, 59, 32768, 8966, 121, 59, 32768, 1041, 768, 99, 114, 116, 289, 296, 306, 97, 117, 115, 101, 59, 32768, 8757, 110, 111, 117, 108, 108, 105, 115, 59, 32768, 8492, 97, 59, 32768, 914, 114, 59, 32896, 55349, 56581, 112, 102, 59, 32896, 55349, 56633, 101, 118, 101, 59, 32768, 728, 99, 114, 59, 32768, 8492, 109, 112, 101, 113, 59, 32768, 8782, 3584, 72, 79, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 117, 368, 373, 380, 426, 461, 466, 487, 491, 495, 533, 593, 695, 701, 707, 99, 121, 59, 32768, 1063, 80, 89, 33024, 169, 59, 32768, 169, 768, 99, 112, 121, 387, 393, 419, 117, 116, 101, 59, 32768, 262, 512, 59, 105, 398, 400, 32768, 8914, 116, 97, 108, 68, 105, 102, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 32768, 8517, 108, 101, 121, 115, 59, 32768, 8493, 1024, 97, 101, 105, 111, 435, 441, 449, 454, 114, 111, 110, 59, 32768, 268, 100, 105, 108, 33024, 199, 59, 32768, 199, 114, 99, 59, 32768, 264, 110, 105, 110, 116, 59, 32768, 8752, 111, 116, 59, 32768, 266, 512, 100, 110, 471, 478, 105, 108, 108, 97, 59, 32768, 184, 116, 101, 114, 68, 111, 116, 59, 32768, 183, 114, 59, 32768, 8493, 105, 59, 32768, 935, 114, 99, 108, 101, 1024, 68, 77, 80, 84, 508, 513, 520, 526, 111, 116, 59, 32768, 8857, 105, 110, 117, 115, 59, 32768, 8854, 108, 117, 115, 59, 32768, 8853, 105, 109, 101, 115, 59, 32768, 8855, 111, 512, 99, 115, 539, 562, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 32768, 8754, 101, 67, 117, 114, 108, 121, 512, 68, 81, 573, 586, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 32768, 8221, 117, 111, 116, 101, 59, 32768, 8217, 1024, 108, 110, 112, 117, 602, 614, 648, 664, 111, 110, 512, 59, 101, 609, 611, 32768, 8759, 59, 32768, 10868, 768, 103, 105, 116, 621, 629, 634, 114, 117, 101, 110, 116, 59, 32768, 8801, 110, 116, 59, 32768, 8751, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 32768, 8750, 512, 102, 114, 653, 656, 59, 32768, 8450, 111, 100, 117, 99, 116, 59, 32768, 8720, 110, 116, 101, 114, 67, 108, 111, 99, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 32768, 8755, 111, 115, 115, 59, 32768, 10799, 99, 114, 59, 32896, 55349, 56478, 112, 512, 59, 67, 713, 715, 32768, 8915, 97, 112, 59, 32768, 8781, 2816, 68, 74, 83, 90, 97, 99, 101, 102, 105, 111, 115, 743, 758, 763, 768, 773, 795, 809, 821, 826, 910, 1295, 512, 59, 111, 748, 750, 32768, 8517, 116, 114, 97, 104, 100, 59, 32768, 10513, 99, 121, 59, 32768, 1026, 99, 121, 59, 32768, 1029, 99, 121, 59, 32768, 1039, 768, 103, 114, 115, 780, 786, 790, 103, 101, 114, 59, 32768, 8225, 114, 59, 32768, 8609, 104, 118, 59, 32768, 10980, 512, 97, 121, 800, 806, 114, 111, 110, 59, 32768, 270, 59, 32768, 1044, 108, 512, 59, 116, 815, 817, 32768, 8711, 97, 59, 32768, 916, 114, 59, 32896, 55349, 56583, 512, 97, 102, 831, 897, 512, 99, 109, 836, 891, 114, 105, 116, 105, 99, 97, 108, 1024, 65, 68, 71, 84, 852, 859, 877, 884, 99, 117, 116, 101, 59, 32768, 180, 111, 581, 864, 867, 59, 32768, 729, 98, 108, 101, 65, 99, 117, 116, 101, 59, 32768, 733, 114, 97, 118, 101, 59, 32768, 96, 105, 108, 100, 101, 59, 32768, 732, 111, 110, 100, 59, 32768, 8900, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 32768, 8518, 2113, 920, 0, 0, 0, 925, 946, 0, 1139, 102, 59, 32896, 55349, 56635, 768, 59, 68, 69, 931, 933, 938, 32768, 168, 111, 116, 59, 32768, 8412, 113, 117, 97, 108, 59, 32768, 8784, 98, 108, 101, 1536, 67, 68, 76, 82, 85, 86, 961, 978, 996, 1080, 1101, 1125, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 32768, 8751, 111, 1093, 985, 0, 0, 988, 59, 32768, 168, 110, 65, 114, 114, 111, 119, 59, 32768, 8659, 512, 101, 111, 1001, 1034, 102, 116, 768, 65, 82, 84, 1010, 1017, 1029, 114, 114, 111, 119, 59, 32768, 8656, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8660, 101, 101, 59, 32768, 10980, 110, 103, 512, 76, 82, 1041, 1068, 101, 102, 116, 512, 65, 82, 1049, 1056, 114, 114, 111, 119, 59, 32768, 10232, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 10234, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 10233, 105, 103, 104, 116, 512, 65, 84, 1089, 1096, 114, 114, 111, 119, 59, 32768, 8658, 101, 101, 59, 32768, 8872, 112, 1042, 1108, 0, 0, 1115, 114, 114, 111, 119, 59, 32768, 8657, 111, 119, 110, 65, 114, 114, 111, 119, 59, 32768, 8661, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 32768, 8741, 110, 1536, 65, 66, 76, 82, 84, 97, 1152, 1179, 1186, 1236, 1272, 1288, 114, 114, 111, 119, 768, 59, 66, 85, 1163, 1165, 1170, 32768, 8595, 97, 114, 59, 32768, 10515, 112, 65, 114, 114, 111, 119, 59, 32768, 8693, 114, 101, 118, 101, 59, 32768, 785, 101, 102, 116, 1315, 1196, 0, 1209, 0, 1220, 105, 103, 104, 116, 86, 101, 99, 116, 111, 114, 59, 32768, 10576, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10590, 101, 99, 116, 111, 114, 512, 59, 66, 1229, 1231, 32768, 8637, 97, 114, 59, 32768, 10582, 105, 103, 104, 116, 805, 1245, 0, 1256, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10591, 101, 99, 116, 111, 114, 512, 59, 66, 1265, 1267, 32768, 8641, 97, 114, 59, 32768, 10583, 101, 101, 512, 59, 65, 1279, 1281, 32768, 8868, 114, 114, 111, 119, 59, 32768, 8615, 114, 114, 111, 119, 59, 32768, 8659, 512, 99, 116, 1300, 1305, 114, 59, 32896, 55349, 56479, 114, 111, 107, 59, 32768, 272, 4096, 78, 84, 97, 99, 100, 102, 103, 108, 109, 111, 112, 113, 115, 116, 117, 120, 1344, 1348, 1354, 1363, 1386, 1391, 1396, 1405, 1413, 1460, 1475, 1483, 1514, 1527, 1531, 1538, 71, 59, 32768, 330, 72, 33024, 208, 59, 32768, 208, 99, 117, 116, 101, 33024, 201, 59, 32768, 201, 768, 97, 105, 121, 1370, 1376, 1383, 114, 111, 110, 59, 32768, 282, 114, 99, 33024, 202, 59, 32768, 202, 59, 32768, 1069, 111, 116, 59, 32768, 278, 114, 59, 32896, 55349, 56584, 114, 97, 118, 101, 33024, 200, 59, 32768, 200, 101, 109, 101, 110, 116, 59, 32768, 8712, 512, 97, 112, 1418, 1423, 99, 114, 59, 32768, 274, 116, 121, 1060, 1431, 0, 0, 1444, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 32768, 9723, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 32768, 9643, 512, 103, 112, 1465, 1470, 111, 110, 59, 32768, 280, 102, 59, 32896, 55349, 56636, 115, 105, 108, 111, 110, 59, 32768, 917, 117, 512, 97, 105, 1489, 1504, 108, 512, 59, 84, 1495, 1497, 32768, 10869, 105, 108, 100, 101, 59, 32768, 8770, 108, 105, 98, 114, 105, 117, 109, 59, 32768, 8652, 512, 99, 105, 1519, 1523, 114, 59, 32768, 8496, 109, 59, 32768, 10867, 97, 59, 32768, 919, 109, 108, 33024, 203, 59, 32768, 203, 512, 105, 112, 1543, 1549, 115, 116, 115, 59, 32768, 8707, 111, 110, 101, 110, 116, 105, 97, 108, 69, 59, 32768, 8519, 1280, 99, 102, 105, 111, 115, 1572, 1576, 1581, 1620, 1648, 121, 59, 32768, 1060, 114, 59, 32896, 55349, 56585, 108, 108, 101, 100, 1060, 1591, 0, 0, 1604, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 32768, 9724, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 32768, 9642, 1601, 1628, 0, 1633, 0, 0, 1639, 102, 59, 32896, 55349, 56637, 65, 108, 108, 59, 32768, 8704, 114, 105, 101, 114, 116, 114, 102, 59, 32768, 8497, 99, 114, 59, 32768, 8497, 3072, 74, 84, 97, 98, 99, 100, 102, 103, 111, 114, 115, 116, 1678, 1683, 1688, 1701, 1708, 1729, 1734, 1739, 1742, 1748, 1828, 1834, 99, 121, 59, 32768, 1027, 33024, 62, 59, 32768, 62, 109, 109, 97, 512, 59, 100, 1696, 1698, 32768, 915, 59, 32768, 988, 114, 101, 118, 101, 59, 32768, 286, 768, 101, 105, 121, 1715, 1721, 1726, 100, 105, 108, 59, 32768, 290, 114, 99, 59, 32768, 284, 59, 32768, 1043, 111, 116, 59, 32768, 288, 114, 59, 32896, 55349, 56586, 59, 32768, 8921, 112, 102, 59, 32896, 55349, 56638, 101, 97, 116, 101, 114, 1536, 69, 70, 71, 76, 83, 84, 1766, 1783, 1794, 1803, 1809, 1821, 113, 117, 97, 108, 512, 59, 76, 1775, 1777, 32768, 8805, 101, 115, 115, 59, 32768, 8923, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32768, 8807, 114, 101, 97, 116, 101, 114, 59, 32768, 10914, 101, 115, 115, 59, 32768, 8823, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 10878, 105, 108, 100, 101, 59, 32768, 8819, 99, 114, 59, 32896, 55349, 56482, 59, 32768, 8811, 2048, 65, 97, 99, 102, 105, 111, 115, 117, 1854, 1861, 1874, 1880, 1884, 1897, 1919, 1934, 82, 68, 99, 121, 59, 32768, 1066, 512, 99, 116, 1866, 1871, 101, 107, 59, 32768, 711, 59, 32768, 94, 105, 114, 99, 59, 32768, 292, 114, 59, 32768, 8460, 108, 98, 101, 114, 116, 83, 112, 97, 99, 101, 59, 32768, 8459, 833, 1902, 0, 1906, 102, 59, 32768, 8461, 105, 122, 111, 110, 116, 97, 108, 76, 105, 110, 101, 59, 32768, 9472, 512, 99, 116, 1924, 1928, 114, 59, 32768, 8459, 114, 111, 107, 59, 32768, 294, 109, 112, 533, 1940, 1950, 111, 119, 110, 72, 117, 109, 112, 59, 32768, 8782, 113, 117, 97, 108, 59, 32768, 8783, 3584, 69, 74, 79, 97, 99, 100, 102, 103, 109, 110, 111, 115, 116, 117, 1985, 1990, 1996, 2001, 2010, 2025, 2030, 2034, 2043, 2077, 2134, 2155, 2160, 2167, 99, 121, 59, 32768, 1045, 108, 105, 103, 59, 32768, 306, 99, 121, 59, 32768, 1025, 99, 117, 116, 101, 33024, 205, 59, 32768, 205, 512, 105, 121, 2015, 2022, 114, 99, 33024, 206, 59, 32768, 206, 59, 32768, 1048, 111, 116, 59, 32768, 304, 114, 59, 32768, 8465, 114, 97, 118, 101, 33024, 204, 59, 32768, 204, 768, 59, 97, 112, 2050, 2052, 2070, 32768, 8465, 512, 99, 103, 2057, 2061, 114, 59, 32768, 298, 105, 110, 97, 114, 121, 73, 59, 32768, 8520, 108, 105, 101, 115, 59, 32768, 8658, 837, 2082, 0, 2110, 512, 59, 101, 2086, 2088, 32768, 8748, 512, 103, 114, 2093, 2099, 114, 97, 108, 59, 32768, 8747, 115, 101, 99, 116, 105, 111, 110, 59, 32768, 8898, 105, 115, 105, 98, 108, 101, 512, 67, 84, 2120, 2127, 111, 109, 109, 97, 59, 32768, 8291, 105, 109, 101, 115, 59, 32768, 8290, 768, 103, 112, 116, 2141, 2146, 2151, 111, 110, 59, 32768, 302, 102, 59, 32896, 55349, 56640, 97, 59, 32768, 921, 99, 114, 59, 32768, 8464, 105, 108, 100, 101, 59, 32768, 296, 828, 2172, 0, 2177, 99, 121, 59, 32768, 1030, 108, 33024, 207, 59, 32768, 207, 1280, 99, 102, 111, 115, 117, 2193, 2206, 2211, 2217, 2232, 512, 105, 121, 2198, 2203, 114, 99, 59, 32768, 308, 59, 32768, 1049, 114, 59, 32896, 55349, 56589, 112, 102, 59, 32896, 55349, 56641, 820, 2222, 0, 2227, 114, 59, 32896, 55349, 56485, 114, 99, 121, 59, 32768, 1032, 107, 99, 121, 59, 32768, 1028, 1792, 72, 74, 97, 99, 102, 111, 115, 2253, 2258, 2263, 2269, 2283, 2288, 2294, 99, 121, 59, 32768, 1061, 99, 121, 59, 32768, 1036, 112, 112, 97, 59, 32768, 922, 512, 101, 121, 2274, 2280, 100, 105, 108, 59, 32768, 310, 59, 32768, 1050, 114, 59, 32896, 55349, 56590, 112, 102, 59, 32896, 55349, 56642, 99, 114, 59, 32896, 55349, 56486, 2816, 74, 84, 97, 99, 101, 102, 108, 109, 111, 115, 116, 2323, 2328, 2333, 2374, 2396, 2775, 2780, 2797, 2804, 2934, 2954, 99, 121, 59, 32768, 1033, 33024, 60, 59, 32768, 60, 1280, 99, 109, 110, 112, 114, 2344, 2350, 2356, 2360, 2370, 117, 116, 101, 59, 32768, 313, 98, 100, 97, 59, 32768, 923, 103, 59, 32768, 10218, 108, 97, 99, 101, 116, 114, 102, 59, 32768, 8466, 114, 59, 32768, 8606, 768, 97, 101, 121, 2381, 2387, 2393, 114, 111, 110, 59, 32768, 317, 100, 105, 108, 59, 32768, 315, 59, 32768, 1051, 512, 102, 115, 2401, 2702, 116, 2560, 65, 67, 68, 70, 82, 84, 85, 86, 97, 114, 2423, 2470, 2479, 2530, 2537, 2561, 2618, 2666, 2683, 2690, 512, 110, 114, 2428, 2441, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 32768, 10216, 114, 111, 119, 768, 59, 66, 82, 2451, 2453, 2458, 32768, 8592, 97, 114, 59, 32768, 8676, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8646, 101, 105, 108, 105, 110, 103, 59, 32768, 8968, 111, 838, 2485, 0, 2498, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 32768, 10214, 110, 805, 2503, 0, 2514, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10593, 101, 99, 116, 111, 114, 512, 59, 66, 2523, 2525, 32768, 8643, 97, 114, 59, 32768, 10585, 108, 111, 111, 114, 59, 32768, 8970, 105, 103, 104, 116, 512, 65, 86, 2546, 2553, 114, 114, 111, 119, 59, 32768, 8596, 101, 99, 116, 111, 114, 59, 32768, 10574, 512, 101, 114, 2566, 2591, 101, 768, 59, 65, 86, 2574, 2576, 2583, 32768, 8867, 114, 114, 111, 119, 59, 32768, 8612, 101, 99, 116, 111, 114, 59, 32768, 10586, 105, 97, 110, 103, 108, 101, 768, 59, 66, 69, 2604, 2606, 2611, 32768, 8882, 97, 114, 59, 32768, 10703, 113, 117, 97, 108, 59, 32768, 8884, 112, 768, 68, 84, 86, 2626, 2638, 2649, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 32768, 10577, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10592, 101, 99, 116, 111, 114, 512, 59, 66, 2659, 2661, 32768, 8639, 97, 114, 59, 32768, 10584, 101, 99, 116, 111, 114, 512, 59, 66, 2676, 2678, 32768, 8636, 97, 114, 59, 32768, 10578, 114, 114, 111, 119, 59, 32768, 8656, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8660, 115, 1536, 69, 70, 71, 76, 83, 84, 2716, 2730, 2741, 2750, 2756, 2768, 113, 117, 97, 108, 71, 114, 101, 97, 116, 101, 114, 59, 32768, 8922, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32768, 8806, 114, 101, 97, 116, 101, 114, 59, 32768, 8822, 101, 115, 115, 59, 32768, 10913, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 10877, 105, 108, 100, 101, 59, 32768, 8818, 114, 59, 32896, 55349, 56591, 512, 59, 101, 2785, 2787, 32768, 8920, 102, 116, 97, 114, 114, 111, 119, 59, 32768, 8666, 105, 100, 111, 116, 59, 32768, 319, 768, 110, 112, 119, 2811, 2899, 2904, 103, 1024, 76, 82, 108, 114, 2821, 2848, 2860, 2887, 101, 102, 116, 512, 65, 82, 2829, 2836, 114, 114, 111, 119, 59, 32768, 10229, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 10231, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 10230, 101, 102, 116, 512, 97, 114, 2868, 2875, 114, 114, 111, 119, 59, 32768, 10232, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 10234, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 10233, 102, 59, 32896, 55349, 56643, 101, 114, 512, 76, 82, 2911, 2922, 101, 102, 116, 65, 114, 114, 111, 119, 59, 32768, 8601, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8600, 768, 99, 104, 116, 2941, 2945, 2948, 114, 59, 32768, 8466, 59, 32768, 8624, 114, 111, 107, 59, 32768, 321, 59, 32768, 8810, 2048, 97, 99, 101, 102, 105, 111, 115, 117, 2974, 2978, 2982, 3007, 3012, 3022, 3028, 3033, 112, 59, 32768, 10501, 121, 59, 32768, 1052, 512, 100, 108, 2987, 2998, 105, 117, 109, 83, 112, 97, 99, 101, 59, 32768, 8287, 108, 105, 110, 116, 114, 102, 59, 32768, 8499, 114, 59, 32896, 55349, 56592, 110, 117, 115, 80, 108, 117, 115, 59, 32768, 8723, 112, 102, 59, 32896, 55349, 56644, 99, 114, 59, 32768, 8499, 59, 32768, 924, 2304, 74, 97, 99, 101, 102, 111, 115, 116, 117, 3055, 3060, 3067, 3089, 3201, 3206, 3874, 3880, 3889, 99, 121, 59, 32768, 1034, 99, 117, 116, 101, 59, 32768, 323, 768, 97, 101, 121, 3074, 3080, 3086, 114, 111, 110, 59, 32768, 327, 100, 105, 108, 59, 32768, 325, 59, 32768, 1053, 768, 103, 115, 119, 3096, 3160, 3194, 97, 116, 105, 118, 101, 768, 77, 84, 86, 3108, 3121, 3145, 101, 100, 105, 117, 109, 83, 112, 97, 99, 101, 59, 32768, 8203, 104, 105, 512, 99, 110, 3128, 3137, 107, 83, 112, 97, 99, 101, 59, 32768, 8203, 83, 112, 97, 99, 101, 59, 32768, 8203, 101, 114, 121, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 32768, 8203, 116, 101, 100, 512, 71, 76, 3168, 3184, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 32768, 8811, 101, 115, 115, 76, 101, 115, 115, 59, 32768, 8810, 76, 105, 110, 101, 59, 32768, 10, 114, 59, 32896, 55349, 56593, 1024, 66, 110, 112, 116, 3215, 3222, 3238, 3242, 114, 101, 97, 107, 59, 32768, 8288, 66, 114, 101, 97, 107, 105, 110, 103, 83, 112, 97, 99, 101, 59, 32768, 160, 102, 59, 32768, 8469, 3328, 59, 67, 68, 69, 71, 72, 76, 78, 80, 82, 83, 84, 86, 3269, 3271, 3293, 3312, 3352, 3430, 3455, 3551, 3589, 3625, 3678, 3821, 3861, 32768, 10988, 512, 111, 117, 3276, 3286, 110, 103, 114, 117, 101, 110, 116, 59, 32768, 8802, 112, 67, 97, 112, 59, 32768, 8813, 111, 117, 98, 108, 101, 86, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 32768, 8742, 768, 108, 113, 120, 3319, 3327, 3345, 101, 109, 101, 110, 116, 59, 32768, 8713, 117, 97, 108, 512, 59, 84, 3335, 3337, 32768, 8800, 105, 108, 100, 101, 59, 32896, 8770, 824, 105, 115, 116, 115, 59, 32768, 8708, 114, 101, 97, 116, 101, 114, 1792, 59, 69, 70, 71, 76, 83, 84, 3373, 3375, 3382, 3394, 3404, 3410, 3423, 32768, 8815, 113, 117, 97, 108, 59, 32768, 8817, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32896, 8807, 824, 114, 101, 97, 116, 101, 114, 59, 32896, 8811, 824, 101, 115, 115, 59, 32768, 8825, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32896, 10878, 824, 105, 108, 100, 101, 59, 32768, 8821, 117, 109, 112, 533, 3437, 3448, 111, 119, 110, 72, 117, 109, 112, 59, 32896, 8782, 824, 113, 117, 97, 108, 59, 32896, 8783, 824, 101, 512, 102, 115, 3461, 3492, 116, 84, 114, 105, 97, 110, 103, 108, 101, 768, 59, 66, 69, 3477, 3479, 3485, 32768, 8938, 97, 114, 59, 32896, 10703, 824, 113, 117, 97, 108, 59, 32768, 8940, 115, 1536, 59, 69, 71, 76, 83, 84, 3506, 3508, 3515, 3524, 3531, 3544, 32768, 8814, 113, 117, 97, 108, 59, 32768, 8816, 114, 101, 97, 116, 101, 114, 59, 32768, 8824, 101, 115, 115, 59, 32896, 8810, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32896, 10877, 824, 105, 108, 100, 101, 59, 32768, 8820, 101, 115, 116, 101, 100, 512, 71, 76, 3561, 3578, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 32896, 10914, 824, 101, 115, 115, 76, 101, 115, 115, 59, 32896, 10913, 824, 114, 101, 99, 101, 100, 101, 115, 768, 59, 69, 83, 3603, 3605, 3613, 32768, 8832, 113, 117, 97, 108, 59, 32896, 10927, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 8928, 512, 101, 105, 3630, 3645, 118, 101, 114, 115, 101, 69, 108, 101, 109, 101, 110, 116, 59, 32768, 8716, 103, 104, 116, 84, 114, 105, 97, 110, 103, 108, 101, 768, 59, 66, 69, 3663, 3665, 3671, 32768, 8939, 97, 114, 59, 32896, 10704, 824, 113, 117, 97, 108, 59, 32768, 8941, 512, 113, 117, 3683, 3732, 117, 97, 114, 101, 83, 117, 512, 98, 112, 3694, 3712, 115, 101, 116, 512, 59, 69, 3702, 3705, 32896, 8847, 824, 113, 117, 97, 108, 59, 32768, 8930, 101, 114, 115, 101, 116, 512, 59, 69, 3722, 3725, 32896, 8848, 824, 113, 117, 97, 108, 59, 32768, 8931, 768, 98, 99, 112, 3739, 3757, 3801, 115, 101, 116, 512, 59, 69, 3747, 3750, 32896, 8834, 8402, 113, 117, 97, 108, 59, 32768, 8840, 99, 101, 101, 100, 115, 1024, 59, 69, 83, 84, 3771, 3773, 3781, 3793, 32768, 8833, 113, 117, 97, 108, 59, 32896, 10928, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 8929, 105, 108, 100, 101, 59, 32896, 8831, 824, 101, 114, 115, 101, 116, 512, 59, 69, 3811, 3814, 32896, 8835, 8402, 113, 117, 97, 108, 59, 32768, 8841, 105, 108, 100, 101, 1024, 59, 69, 70, 84, 3834, 3836, 3843, 3854, 32768, 8769, 113, 117, 97, 108, 59, 32768, 8772, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32768, 8775, 105, 108, 100, 101, 59, 32768, 8777, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 32768, 8740, 99, 114, 59, 32896, 55349, 56489, 105, 108, 100, 101, 33024, 209, 59, 32768, 209, 59, 32768, 925, 3584, 69, 97, 99, 100, 102, 103, 109, 111, 112, 114, 115, 116, 117, 118, 3921, 3927, 3936, 3951, 3958, 3963, 3972, 3996, 4002, 4034, 4037, 4055, 4071, 4078, 108, 105, 103, 59, 32768, 338, 99, 117, 116, 101, 33024, 211, 59, 32768, 211, 512, 105, 121, 3941, 3948, 114, 99, 33024, 212, 59, 32768, 212, 59, 32768, 1054, 98, 108, 97, 99, 59, 32768, 336, 114, 59, 32896, 55349, 56594, 114, 97, 118, 101, 33024, 210, 59, 32768, 210, 768, 97, 101, 105, 3979, 3984, 3989, 99, 114, 59, 32768, 332, 103, 97, 59, 32768, 937, 99, 114, 111, 110, 59, 32768, 927, 112, 102, 59, 32896, 55349, 56646, 101, 110, 67, 117, 114, 108, 121, 512, 68, 81, 4014, 4027, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 32768, 8220, 117, 111, 116, 101, 59, 32768, 8216, 59, 32768, 10836, 512, 99, 108, 4042, 4047, 114, 59, 32896, 55349, 56490, 97, 115, 104, 33024, 216, 59, 32768, 216, 105, 573, 4060, 4067, 100, 101, 33024, 213, 59, 32768, 213, 101, 115, 59, 32768, 10807, 109, 108, 33024, 214, 59, 32768, 214, 101, 114, 512, 66, 80, 4085, 4109, 512, 97, 114, 4090, 4094, 114, 59, 32768, 8254, 97, 99, 512, 101, 107, 4101, 4104, 59, 32768, 9182, 101, 116, 59, 32768, 9140, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 32768, 9180, 2304, 97, 99, 102, 104, 105, 108, 111, 114, 115, 4141, 4150, 4154, 4159, 4163, 4166, 4176, 4198, 4284, 114, 116, 105, 97, 108, 68, 59, 32768, 8706, 121, 59, 32768, 1055, 114, 59, 32896, 55349, 56595, 105, 59, 32768, 934, 59, 32768, 928, 117, 115, 77, 105, 110, 117, 115, 59, 32768, 177, 512, 105, 112, 4181, 4194, 110, 99, 97, 114, 101, 112, 108, 97, 110, 101, 59, 32768, 8460, 102, 59, 32768, 8473, 1024, 59, 101, 105, 111, 4207, 4209, 4251, 4256, 32768, 10939, 99, 101, 100, 101, 115, 1024, 59, 69, 83, 84, 4223, 4225, 4232, 4244, 32768, 8826, 113, 117, 97, 108, 59, 32768, 10927, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 8828, 105, 108, 100, 101, 59, 32768, 8830, 109, 101, 59, 32768, 8243, 512, 100, 112, 4261, 4267, 117, 99, 116, 59, 32768, 8719, 111, 114, 116, 105, 111, 110, 512, 59, 97, 4278, 4280, 32768, 8759, 108, 59, 32768, 8733, 512, 99, 105, 4289, 4294, 114, 59, 32896, 55349, 56491, 59, 32768, 936, 1024, 85, 102, 111, 115, 4306, 4313, 4318, 4323, 79, 84, 33024, 34, 59, 32768, 34, 114, 59, 32896, 55349, 56596, 112, 102, 59, 32768, 8474, 99, 114, 59, 32896, 55349, 56492, 3072, 66, 69, 97, 99, 101, 102, 104, 105, 111, 114, 115, 117, 4354, 4360, 4366, 4395, 4417, 4473, 4477, 4481, 4743, 4764, 4776, 4788, 97, 114, 114, 59, 32768, 10512, 71, 33024, 174, 59, 32768, 174, 768, 99, 110, 114, 4373, 4379, 4383, 117, 116, 101, 59, 32768, 340, 103, 59, 32768, 10219, 114, 512, 59, 116, 4389, 4391, 32768, 8608, 108, 59, 32768, 10518, 768, 97, 101, 121, 4402, 4408, 4414, 114, 111, 110, 59, 32768, 344, 100, 105, 108, 59, 32768, 342, 59, 32768, 1056, 512, 59, 118, 4422, 4424, 32768, 8476, 101, 114, 115, 101, 512, 69, 85, 4433, 4458, 512, 108, 113, 4438, 4446, 101, 109, 101, 110, 116, 59, 32768, 8715, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 32768, 8651, 112, 69, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 32768, 10607, 114, 59, 32768, 8476, 111, 59, 32768, 929, 103, 104, 116, 2048, 65, 67, 68, 70, 84, 85, 86, 97, 4501, 4547, 4556, 4607, 4614, 4671, 4719, 4736, 512, 110, 114, 4506, 4519, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 32768, 10217, 114, 111, 119, 768, 59, 66, 76, 4529, 4531, 4536, 32768, 8594, 97, 114, 59, 32768, 8677, 101, 102, 116, 65, 114, 114, 111, 119, 59, 32768, 8644, 101, 105, 108, 105, 110, 103, 59, 32768, 8969, 111, 838, 4562, 0, 4575, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 32768, 10215, 110, 805, 4580, 0, 4591, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10589, 101, 99, 116, 111, 114, 512, 59, 66, 4600, 4602, 32768, 8642, 97, 114, 59, 32768, 10581, 108, 111, 111, 114, 59, 32768, 8971, 512, 101, 114, 4619, 4644, 101, 768, 59, 65, 86, 4627, 4629, 4636, 32768, 8866, 114, 114, 111, 119, 59, 32768, 8614, 101, 99, 116, 111, 114, 59, 32768, 10587, 105, 97, 110, 103, 108, 101, 768, 59, 66, 69, 4657, 4659, 4664, 32768, 8883, 97, 114, 59, 32768, 10704, 113, 117, 97, 108, 59, 32768, 8885, 112, 768, 68, 84, 86, 4679, 4691, 4702, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 32768, 10575, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10588, 101, 99, 116, 111, 114, 512, 59, 66, 4712, 4714, 32768, 8638, 97, 114, 59, 32768, 10580, 101, 99, 116, 111, 114, 512, 59, 66, 4729, 4731, 32768, 8640, 97, 114, 59, 32768, 10579, 114, 114, 111, 119, 59, 32768, 8658, 512, 112, 117, 4748, 4752, 102, 59, 32768, 8477, 110, 100, 73, 109, 112, 108, 105, 101, 115, 59, 32768, 10608, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8667, 512, 99, 104, 4781, 4785, 114, 59, 32768, 8475, 59, 32768, 8625, 108, 101, 68, 101, 108, 97, 121, 101, 100, 59, 32768, 10740, 3328, 72, 79, 97, 99, 102, 104, 105, 109, 111, 113, 115, 116, 117, 4827, 4842, 4849, 4856, 4889, 4894, 4949, 4955, 4967, 4973, 5059, 5065, 5070, 512, 67, 99, 4832, 4838, 72, 99, 121, 59, 32768, 1065, 121, 59, 32768, 1064, 70, 84, 99, 121, 59, 32768, 1068, 99, 117, 116, 101, 59, 32768, 346, 1280, 59, 97, 101, 105, 121, 4867, 4869, 4875, 4881, 4886, 32768, 10940, 114, 111, 110, 59, 32768, 352, 100, 105, 108, 59, 32768, 350, 114, 99, 59, 32768, 348, 59, 32768, 1057, 114, 59, 32896, 55349, 56598, 111, 114, 116, 1024, 68, 76, 82, 85, 4906, 4917, 4928, 4940, 111, 119, 110, 65, 114, 114, 111, 119, 59, 32768, 8595, 101, 102, 116, 65, 114, 114, 111, 119, 59, 32768, 8592, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8594, 112, 65, 114, 114, 111, 119, 59, 32768, 8593, 103, 109, 97, 59, 32768, 931, 97, 108, 108, 67, 105, 114, 99, 108, 101, 59, 32768, 8728, 112, 102, 59, 32896, 55349, 56650, 1091, 4979, 0, 0, 4983, 116, 59, 32768, 8730, 97, 114, 101, 1024, 59, 73, 83, 85, 4994, 4996, 5010, 5052, 32768, 9633, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 59, 32768, 8851, 117, 512, 98, 112, 5016, 5033, 115, 101, 116, 512, 59, 69, 5024, 5026, 32768, 8847, 113, 117, 97, 108, 59, 32768, 8849, 101, 114, 115, 101, 116, 512, 59, 69, 5043, 5045, 32768, 8848, 113, 117, 97, 108, 59, 32768, 8850, 110, 105, 111, 110, 59, 32768, 8852, 99, 114, 59, 32896, 55349, 56494, 97, 114, 59, 32768, 8902, 1024, 98, 99, 109, 112, 5079, 5102, 5155, 5158, 512, 59, 115, 5084, 5086, 32768, 8912, 101, 116, 512, 59, 69, 5093, 5095, 32768, 8912, 113, 117, 97, 108, 59, 32768, 8838, 512, 99, 104, 5107, 5148, 101, 101, 100, 115, 1024, 59, 69, 83, 84, 5120, 5122, 5129, 5141, 32768, 8827, 113, 117, 97, 108, 59, 32768, 10928, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 8829, 105, 108, 100, 101, 59, 32768, 8831, 84, 104, 97, 116, 59, 32768, 8715, 59, 32768, 8721, 768, 59, 101, 115, 5165, 5167, 5185, 32768, 8913, 114, 115, 101, 116, 512, 59, 69, 5176, 5178, 32768, 8835, 113, 117, 97, 108, 59, 32768, 8839, 101, 116, 59, 32768, 8913, 2816, 72, 82, 83, 97, 99, 102, 104, 105, 111, 114, 115, 5213, 5221, 5227, 5241, 5252, 5274, 5279, 5323, 5362, 5368, 5378, 79, 82, 78, 33024, 222, 59, 32768, 222, 65, 68, 69, 59, 32768, 8482, 512, 72, 99, 5232, 5237, 99, 121, 59, 32768, 1035, 121, 59, 32768, 1062, 512, 98, 117, 5246, 5249, 59, 32768, 9, 59, 32768, 932, 768, 97, 101, 121, 5259, 5265, 5271, 114, 111, 110, 59, 32768, 356, 100, 105, 108, 59, 32768, 354, 59, 32768, 1058, 114, 59, 32896, 55349, 56599, 512, 101, 105, 5284, 5300, 835, 5289, 0, 5297, 101, 102, 111, 114, 101, 59, 32768, 8756, 97, 59, 32768, 920, 512, 99, 110, 5305, 5315, 107, 83, 112, 97, 99, 101, 59, 32896, 8287, 8202, 83, 112, 97, 99, 101, 59, 32768, 8201, 108, 100, 101, 1024, 59, 69, 70, 84, 5335, 5337, 5344, 5355, 32768, 8764, 113, 117, 97, 108, 59, 32768, 8771, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32768, 8773, 105, 108, 100, 101, 59, 32768, 8776, 112, 102, 59, 32896, 55349, 56651, 105, 112, 108, 101, 68, 111, 116, 59, 32768, 8411, 512, 99, 116, 5383, 5388, 114, 59, 32896, 55349, 56495, 114, 111, 107, 59, 32768, 358, 5426, 5417, 5444, 5458, 5473, 0, 5480, 5485, 0, 0, 0, 0, 0, 5494, 5500, 5564, 5579, 0, 5726, 5732, 5738, 5745, 512, 99, 114, 5421, 5429, 117, 116, 101, 33024, 218, 59, 32768, 218, 114, 512, 59, 111, 5435, 5437, 32768, 8607, 99, 105, 114, 59, 32768, 10569, 114, 820, 5449, 0, 5453, 121, 59, 32768, 1038, 118, 101, 59, 32768, 364, 512, 105, 121, 5462, 5469, 114, 99, 33024, 219, 59, 32768, 219, 59, 32768, 1059, 98, 108, 97, 99, 59, 32768, 368, 114, 59, 32896, 55349, 56600, 114, 97, 118, 101, 33024, 217, 59, 32768, 217, 97, 99, 114, 59, 32768, 362, 512, 100, 105, 5504, 5548, 101, 114, 512, 66, 80, 5511, 5535, 512, 97, 114, 5516, 5520, 114, 59, 32768, 95, 97, 99, 512, 101, 107, 5527, 5530, 59, 32768, 9183, 101, 116, 59, 32768, 9141, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 32768, 9181, 111, 110, 512, 59, 80, 5555, 5557, 32768, 8899, 108, 117, 115, 59, 32768, 8846, 512, 103, 112, 5568, 5573, 111, 110, 59, 32768, 370, 102, 59, 32896, 55349, 56652, 2048, 65, 68, 69, 84, 97, 100, 112, 115, 5595, 5624, 5635, 5648, 5664, 5671, 5682, 5712, 114, 114, 111, 119, 768, 59, 66, 68, 5606, 5608, 5613, 32768, 8593, 97, 114, 59, 32768, 10514, 111, 119, 110, 65, 114, 114, 111, 119, 59, 32768, 8645, 111, 119, 110, 65, 114, 114, 111, 119, 59, 32768, 8597, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 32768, 10606, 101, 101, 512, 59, 65, 5655, 5657, 32768, 8869, 114, 114, 111, 119, 59, 32768, 8613, 114, 114, 111, 119, 59, 32768, 8657, 111, 119, 110, 97, 114, 114, 111, 119, 59, 32768, 8661, 101, 114, 512, 76, 82, 5689, 5700, 101, 102, 116, 65, 114, 114, 111, 119, 59, 32768, 8598, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8599, 105, 512, 59, 108, 5718, 5720, 32768, 978, 111, 110, 59, 32768, 933, 105, 110, 103, 59, 32768, 366, 99, 114, 59, 32896, 55349, 56496, 105, 108, 100, 101, 59, 32768, 360, 109, 108, 33024, 220, 59, 32768, 220, 2304, 68, 98, 99, 100, 101, 102, 111, 115, 118, 5770, 5776, 5781, 5785, 5798, 5878, 5883, 5889, 5895, 97, 115, 104, 59, 32768, 8875, 97, 114, 59, 32768, 10987, 121, 59, 32768, 1042, 97, 115, 104, 512, 59, 108, 5793, 5795, 32768, 8873, 59, 32768, 10982, 512, 101, 114, 5803, 5806, 59, 32768, 8897, 768, 98, 116, 121, 5813, 5818, 5866, 97, 114, 59, 32768, 8214, 512, 59, 105, 5823, 5825, 32768, 8214, 99, 97, 108, 1024, 66, 76, 83, 84, 5837, 5842, 5848, 5859, 97, 114, 59, 32768, 8739, 105, 110, 101, 59, 32768, 124, 101, 112, 97, 114, 97, 116, 111, 114, 59, 32768, 10072, 105, 108, 100, 101, 59, 32768, 8768, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 32768, 8202, 114, 59, 32896, 55349, 56601, 112, 102, 59, 32896, 55349, 56653, 99, 114, 59, 32896, 55349, 56497, 100, 97, 115, 104, 59, 32768, 8874, 1280, 99, 101, 102, 111, 115, 5913, 5919, 5925, 5930, 5936, 105, 114, 99, 59, 32768, 372, 100, 103, 101, 59, 32768, 8896, 114, 59, 32896, 55349, 56602, 112, 102, 59, 32896, 55349, 56654, 99, 114, 59, 32896, 55349, 56498, 1024, 102, 105, 111, 115, 5951, 5956, 5959, 5965, 114, 59, 32896, 55349, 56603, 59, 32768, 926, 112, 102, 59, 32896, 55349, 56655, 99, 114, 59, 32896, 55349, 56499, 2304, 65, 73, 85, 97, 99, 102, 111, 115, 117, 5990, 5995, 6000, 6005, 6014, 6027, 6032, 6038, 6044, 99, 121, 59, 32768, 1071, 99, 121, 59, 32768, 1031, 99, 121, 59, 32768, 1070, 99, 117, 116, 101, 33024, 221, 59, 32768, 221, 512, 105, 121, 6019, 6024, 114, 99, 59, 32768, 374, 59, 32768, 1067, 114, 59, 32896, 55349, 56604, 112, 102, 59, 32896, 55349, 56656, 99, 114, 59, 32896, 55349, 56500, 109, 108, 59, 32768, 376, 2048, 72, 97, 99, 100, 101, 102, 111, 115, 6066, 6071, 6078, 6092, 6097, 6119, 6123, 6128, 99, 121, 59, 32768, 1046, 99, 117, 116, 101, 59, 32768, 377, 512, 97, 121, 6083, 6089, 114, 111, 110, 59, 32768, 381, 59, 32768, 1047, 111, 116, 59, 32768, 379, 835, 6102, 0, 6116, 111, 87, 105, 100, 116, 104, 83, 112, 97, 99, 101, 59, 32768, 8203, 97, 59, 32768, 918, 114, 59, 32768, 8488, 112, 102, 59, 32768, 8484, 99, 114, 59, 32896, 55349, 56501, 5938, 6159, 6168, 6175, 0, 6214, 6222, 6233, 0, 0, 0, 0, 6242, 6267, 6290, 6429, 6444, 0, 6495, 6503, 6531, 6540, 0, 6547, 99, 117, 116, 101, 33024, 225, 59, 32768, 225, 114, 101, 118, 101, 59, 32768, 259, 1536, 59, 69, 100, 105, 117, 121, 6187, 6189, 6193, 6196, 6203, 6210, 32768, 8766, 59, 32896, 8766, 819, 59, 32768, 8767, 114, 99, 33024, 226, 59, 32768, 226, 116, 101, 33024, 180, 59, 32768, 180, 59, 32768, 1072, 108, 105, 103, 33024, 230, 59, 32768, 230, 512, 59, 114, 6226, 6228, 32768, 8289, 59, 32896, 55349, 56606, 114, 97, 118, 101, 33024, 224, 59, 32768, 224, 512, 101, 112, 6246, 6261, 512, 102, 112, 6251, 6257, 115, 121, 109, 59, 32768, 8501, 104, 59, 32768, 8501, 104, 97, 59, 32768, 945, 512, 97, 112, 6271, 6284, 512, 99, 108, 6276, 6280, 114, 59, 32768, 257, 103, 59, 32768, 10815, 33024, 38, 59, 32768, 38, 1077, 6295, 0, 0, 6326, 1280, 59, 97, 100, 115, 118, 6305, 6307, 6312, 6315, 6322, 32768, 8743, 110, 100, 59, 32768, 10837, 59, 32768, 10844, 108, 111, 112, 101, 59, 32768, 10840, 59, 32768, 10842, 1792, 59, 101, 108, 109, 114, 115, 122, 6340, 6342, 6345, 6349, 6391, 6410, 6422, 32768, 8736, 59, 32768, 10660, 101, 59, 32768, 8736, 115, 100, 512, 59, 97, 6356, 6358, 32768, 8737, 2098, 6368, 6371, 6374, 6377, 6380, 6383, 6386, 6389, 59, 32768, 10664, 59, 32768, 10665, 59, 32768, 10666, 59, 32768, 10667, 59, 32768, 10668, 59, 32768, 10669, 59, 32768, 10670, 59, 32768, 10671, 116, 512, 59, 118, 6397, 6399, 32768, 8735, 98, 512, 59, 100, 6405, 6407, 32768, 8894, 59, 32768, 10653, 512, 112, 116, 6415, 6419, 104, 59, 32768, 8738, 59, 32768, 197, 97, 114, 114, 59, 32768, 9084, 512, 103, 112, 6433, 6438, 111, 110, 59, 32768, 261, 102, 59, 32896, 55349, 56658, 1792, 59, 69, 97, 101, 105, 111, 112, 6458, 6460, 6463, 6469, 6472, 6476, 6480, 32768, 8776, 59, 32768, 10864, 99, 105, 114, 59, 32768, 10863, 59, 32768, 8778, 100, 59, 32768, 8779, 115, 59, 32768, 39, 114, 111, 120, 512, 59, 101, 6488, 6490, 32768, 8776, 113, 59, 32768, 8778, 105, 110, 103, 33024, 229, 59, 32768, 229, 768, 99, 116, 121, 6509, 6514, 6517, 114, 59, 32896, 55349, 56502, 59, 32768, 42, 109, 112, 512, 59, 101, 6524, 6526, 32768, 8776, 113, 59, 32768, 8781, 105, 108, 100, 101, 33024, 227, 59, 32768, 227, 109, 108, 33024, 228, 59, 32768, 228, 512, 99, 105, 6551, 6559, 111, 110, 105, 110, 116, 59, 32768, 8755, 110, 116, 59, 32768, 10769, 4096, 78, 97, 98, 99, 100, 101, 102, 105, 107, 108, 110, 111, 112, 114, 115, 117, 6597, 6602, 6673, 6688, 6701, 6707, 6768, 6773, 6891, 6898, 6999, 7023, 7309, 7316, 7334, 7383, 111, 116, 59, 32768, 10989, 512, 99, 114, 6607, 6652, 107, 1024, 99, 101, 112, 115, 6617, 6623, 6632, 6639, 111, 110, 103, 59, 32768, 8780, 112, 115, 105, 108, 111, 110, 59, 32768, 1014, 114, 105, 109, 101, 59, 32768, 8245, 105, 109, 512, 59, 101, 6646, 6648, 32768, 8765, 113, 59, 32768, 8909, 583, 6656, 6661, 101, 101, 59, 32768, 8893, 101, 100, 512, 59, 103, 6667, 6669, 32768, 8965, 101, 59, 32768, 8965, 114, 107, 512, 59, 116, 6680, 6682, 32768, 9141, 98, 114, 107, 59, 32768, 9142, 512, 111, 121, 6693, 6698, 110, 103, 59, 32768, 8780, 59, 32768, 1073, 113, 117, 111, 59, 32768, 8222, 1280, 99, 109, 112, 114, 116, 6718, 6731, 6738, 6743, 6749, 97, 117, 115, 512, 59, 101, 6726, 6728, 32768, 8757, 59, 32768, 8757, 112, 116, 121, 118, 59, 32768, 10672, 115, 105, 59, 32768, 1014, 110, 111, 117, 59, 32768, 8492, 768, 97, 104, 119, 6756, 6759, 6762, 59, 32768, 946, 59, 32768, 8502, 101, 101, 110, 59, 32768, 8812, 114, 59, 32896, 55349, 56607, 103, 1792, 99, 111, 115, 116, 117, 118, 119, 6789, 6809, 6834, 6850, 6872, 6879, 6884, 768, 97, 105, 117, 6796, 6800, 6805, 112, 59, 32768, 8898, 114, 99, 59, 32768, 9711, 112, 59, 32768, 8899, 768, 100, 112, 116, 6816, 6821, 6827, 111, 116, 59, 32768, 10752, 108, 117, 115, 59, 32768, 10753, 105, 109, 101, 115, 59, 32768, 10754, 1090, 6840, 0, 0, 6846, 99, 117, 112, 59, 32768, 10758, 97, 114, 59, 32768, 9733, 114, 105, 97, 110, 103, 108, 101, 512, 100, 117, 6862, 6868, 111, 119, 110, 59, 32768, 9661, 112, 59, 32768, 9651, 112, 108, 117, 115, 59, 32768, 10756, 101, 101, 59, 32768, 8897, 101, 100, 103, 101, 59, 32768, 8896, 97, 114, 111, 119, 59, 32768, 10509, 768, 97, 107, 111, 6905, 6976, 6994, 512, 99, 110, 6910, 6972, 107, 768, 108, 115, 116, 6918, 6927, 6935, 111, 122, 101, 110, 103, 101, 59, 32768, 10731, 113, 117, 97, 114, 101, 59, 32768, 9642, 114, 105, 97, 110, 103, 108, 101, 1024, 59, 100, 108, 114, 6951, 6953, 6959, 6965, 32768, 9652, 111, 119, 110, 59, 32768, 9662, 101, 102, 116, 59, 32768, 9666, 105, 103, 104, 116, 59, 32768, 9656, 107, 59, 32768, 9251, 770, 6981, 0, 6991, 771, 6985, 0, 6988, 59, 32768, 9618, 59, 32768, 9617, 52, 59, 32768, 9619, 99, 107, 59, 32768, 9608, 512, 101, 111, 7004, 7019, 512, 59, 113, 7009, 7012, 32896, 61, 8421, 117, 105, 118, 59, 32896, 8801, 8421, 116, 59, 32768, 8976, 1024, 112, 116, 119, 120, 7032, 7037, 7049, 7055, 102, 59, 32896, 55349, 56659, 512, 59, 116, 7042, 7044, 32768, 8869, 111, 109, 59, 32768, 8869, 116, 105, 101, 59, 32768, 8904, 3072, 68, 72, 85, 86, 98, 100, 104, 109, 112, 116, 117, 118, 7080, 7101, 7126, 7147, 7182, 7187, 7208, 7233, 7240, 7246, 7253, 7274, 1024, 76, 82, 108, 114, 7089, 7092, 7095, 7098, 59, 32768, 9559, 59, 32768, 9556, 59, 32768, 9558, 59, 32768, 9555, 1280, 59, 68, 85, 100, 117, 7112, 7114, 7117, 7120, 7123, 32768, 9552, 59, 32768, 9574, 59, 32768, 9577, 59, 32768, 9572, 59, 32768, 9575, 1024, 76, 82, 108, 114, 7135, 7138, 7141, 7144, 59, 32768, 9565, 59, 32768, 9562, 59, 32768, 9564, 59, 32768, 9561, 1792, 59, 72, 76, 82, 104, 108, 114, 7162, 7164, 7167, 7170, 7173, 7176, 7179, 32768, 9553, 59, 32768, 9580, 59, 32768, 9571, 59, 32768, 9568, 59, 32768, 9579, 59, 32768, 9570, 59, 32768, 9567, 111, 120, 59, 32768, 10697, 1024, 76, 82, 108, 114, 7196, 7199, 7202, 7205, 59, 32768, 9557, 59, 32768, 9554, 59, 32768, 9488, 59, 32768, 9484, 1280, 59, 68, 85, 100, 117, 7219, 7221, 7224, 7227, 7230, 32768, 9472, 59, 32768, 9573, 59, 32768, 9576, 59, 32768, 9516, 59, 32768, 9524, 105, 110, 117, 115, 59, 32768, 8863, 108, 117, 115, 59, 32768, 8862, 105, 109, 101, 115, 59, 32768, 8864, 1024, 76, 82, 108, 114, 7262, 7265, 7268, 7271, 59, 32768, 9563, 59, 32768, 9560, 59, 32768, 9496, 59, 32768, 9492, 1792, 59, 72, 76, 82, 104, 108, 114, 7289, 7291, 7294, 7297, 7300, 7303, 7306, 32768, 9474, 59, 32768, 9578, 59, 32768, 9569, 59, 32768, 9566, 59, 32768, 9532, 59, 32768, 9508, 59, 32768, 9500, 114, 105, 109, 101, 59, 32768, 8245, 512, 101, 118, 7321, 7326, 118, 101, 59, 32768, 728, 98, 97, 114, 33024, 166, 59, 32768, 166, 1024, 99, 101, 105, 111, 7343, 7348, 7353, 7364, 114, 59, 32896, 55349, 56503, 109, 105, 59, 32768, 8271, 109, 512, 59, 101, 7359, 7361, 32768, 8765, 59, 32768, 8909, 108, 768, 59, 98, 104, 7372, 7374, 7377, 32768, 92, 59, 32768, 10693, 115, 117, 98, 59, 32768, 10184, 573, 7387, 7399, 108, 512, 59, 101, 7392, 7394, 32768, 8226, 116, 59, 32768, 8226, 112, 768, 59, 69, 101, 7406, 7408, 7411, 32768, 8782, 59, 32768, 10926, 512, 59, 113, 7416, 7418, 32768, 8783, 59, 32768, 8783, 6450, 7448, 0, 7523, 7571, 7576, 7613, 0, 7618, 7647, 0, 0, 7764, 0, 0, 7779, 0, 0, 7899, 7914, 7949, 7955, 0, 8158, 0, 8176, 768, 99, 112, 114, 7454, 7460, 7509, 117, 116, 101, 59, 32768, 263, 1536, 59, 97, 98, 99, 100, 115, 7473, 7475, 7480, 7487, 7500, 7505, 32768, 8745, 110, 100, 59, 32768, 10820, 114, 99, 117, 112, 59, 32768, 10825, 512, 97, 117, 7492, 7496, 112, 59, 32768, 10827, 112, 59, 32768, 10823, 111, 116, 59, 32768, 10816, 59, 32896, 8745, 65024, 512, 101, 111, 7514, 7518, 116, 59, 32768, 8257, 110, 59, 32768, 711, 1024, 97, 101, 105, 117, 7531, 7544, 7552, 7557, 833, 7536, 0, 7540, 115, 59, 32768, 10829, 111, 110, 59, 32768, 269, 100, 105, 108, 33024, 231, 59, 32768, 231, 114, 99, 59, 32768, 265, 112, 115, 512, 59, 115, 7564, 7566, 32768, 10828, 109, 59, 32768, 10832, 111, 116, 59, 32768, 267, 768, 100, 109, 110, 7582, 7589, 7596, 105, 108, 33024, 184, 59, 32768, 184, 112, 116, 121, 118, 59, 32768, 10674, 116, 33280, 162, 59, 101, 7603, 7605, 32768, 162, 114, 100, 111, 116, 59, 32768, 183, 114, 59, 32896, 55349, 56608, 768, 99, 101, 105, 7624, 7628, 7643, 121, 59, 32768, 1095, 99, 107, 512, 59, 109, 7635, 7637, 32768, 10003, 97, 114, 107, 59, 32768, 10003, 59, 32768, 967, 114, 1792, 59, 69, 99, 101, 102, 109, 115, 7662, 7664, 7667, 7742, 7745, 7752, 7757, 32768, 9675, 59, 32768, 10691, 768, 59, 101, 108, 7674, 7676, 7680, 32768, 710, 113, 59, 32768, 8791, 101, 1074, 7687, 0, 0, 7709, 114, 114, 111, 119, 512, 108, 114, 7695, 7701, 101, 102, 116, 59, 32768, 8634, 105, 103, 104, 116, 59, 32768, 8635, 1280, 82, 83, 97, 99, 100, 7719, 7722, 7725, 7730, 7736, 59, 32768, 174, 59, 32768, 9416, 115, 116, 59, 32768, 8859, 105, 114, 99, 59, 32768, 8858, 97, 115, 104, 59, 32768, 8861, 59, 32768, 8791, 110, 105, 110, 116, 59, 32768, 10768, 105, 100, 59, 32768, 10991, 99, 105, 114, 59, 32768, 10690, 117, 98, 115, 512, 59, 117, 7771, 7773, 32768, 9827, 105, 116, 59, 32768, 9827, 1341, 7785, 7804, 7850, 0, 7871, 111, 110, 512, 59, 101, 7791, 7793, 32768, 58, 512, 59, 113, 7798, 7800, 32768, 8788, 59, 32768, 8788, 1086, 7809, 0, 0, 7820, 97, 512, 59, 116, 7814, 7816, 32768, 44, 59, 32768, 64, 768, 59, 102, 108, 7826, 7828, 7832, 32768, 8705, 110, 59, 32768, 8728, 101, 512, 109, 120, 7838, 7844, 101, 110, 116, 59, 32768, 8705, 101, 115, 59, 32768, 8450, 824, 7854, 0, 7866, 512, 59, 100, 7858, 7860, 32768, 8773, 111, 116, 59, 32768, 10861, 110, 116, 59, 32768, 8750, 768, 102, 114, 121, 7877, 7881, 7886, 59, 32896, 55349, 56660, 111, 100, 59, 32768, 8720, 33280, 169, 59, 115, 7892, 7894, 32768, 169, 114, 59, 32768, 8471, 512, 97, 111, 7903, 7908, 114, 114, 59, 32768, 8629, 115, 115, 59, 32768, 10007, 512, 99, 117, 7918, 7923, 114, 59, 32896, 55349, 56504, 512, 98, 112, 7928, 7938, 512, 59, 101, 7933, 7935, 32768, 10959, 59, 32768, 10961, 512, 59, 101, 7943, 7945, 32768, 10960, 59, 32768, 10962, 100, 111, 116, 59, 32768, 8943, 1792, 100, 101, 108, 112, 114, 118, 119, 7969, 7983, 7996, 8009, 8057, 8147, 8152, 97, 114, 114, 512, 108, 114, 7977, 7980, 59, 32768, 10552, 59, 32768, 10549, 1089, 7989, 0, 0, 7993, 114, 59, 32768, 8926, 99, 59, 32768, 8927, 97, 114, 114, 512, 59, 112, 8004, 8006, 32768, 8630, 59, 32768, 10557, 1536, 59, 98, 99, 100, 111, 115, 8022, 8024, 8031, 8044, 8049, 8053, 32768, 8746, 114, 99, 97, 112, 59, 32768, 10824, 512, 97, 117, 8036, 8040, 112, 59, 32768, 10822, 112, 59, 32768, 10826, 111, 116, 59, 32768, 8845, 114, 59, 32768, 10821, 59, 32896, 8746, 65024, 1024, 97, 108, 114, 118, 8066, 8078, 8116, 8123, 114, 114, 512, 59, 109, 8073, 8075, 32768, 8631, 59, 32768, 10556, 121, 768, 101, 118, 119, 8086, 8104, 8109, 113, 1089, 8093, 0, 0, 8099, 114, 101, 99, 59, 32768, 8926, 117, 99, 99, 59, 32768, 8927, 101, 101, 59, 32768, 8910, 101, 100, 103, 101, 59, 32768, 8911, 101, 110, 33024, 164, 59, 32768, 164, 101, 97, 114, 114, 111, 119, 512, 108, 114, 8134, 8140, 101, 102, 116, 59, 32768, 8630, 105, 103, 104, 116, 59, 32768, 8631, 101, 101, 59, 32768, 8910, 101, 100, 59, 32768, 8911, 512, 99, 105, 8162, 8170, 111, 110, 105, 110, 116, 59, 32768, 8754, 110, 116, 59, 32768, 8753, 108, 99, 116, 121, 59, 32768, 9005, 4864, 65, 72, 97, 98, 99, 100, 101, 102, 104, 105, 106, 108, 111, 114, 115, 116, 117, 119, 122, 8221, 8226, 8231, 8267, 8282, 8296, 8327, 8351, 8366, 8379, 8466, 8471, 8487, 8621, 8647, 8676, 8697, 8712, 8720, 114, 114, 59, 32768, 8659, 97, 114, 59, 32768, 10597, 1024, 103, 108, 114, 115, 8240, 8246, 8252, 8256, 103, 101, 114, 59, 32768, 8224, 101, 116, 104, 59, 32768, 8504, 114, 59, 32768, 8595, 104, 512, 59, 118, 8262, 8264, 32768, 8208, 59, 32768, 8867, 572, 8271, 8278, 97, 114, 111, 119, 59, 32768, 10511, 97, 99, 59, 32768, 733, 512, 97, 121, 8287, 8293, 114, 111, 110, 59, 32768, 271, 59, 32768, 1076, 768, 59, 97, 111, 8303, 8305, 8320, 32768, 8518, 512, 103, 114, 8310, 8316, 103, 101, 114, 59, 32768, 8225, 114, 59, 32768, 8650, 116, 115, 101, 113, 59, 32768, 10871, 768, 103, 108, 109, 8334, 8339, 8344, 33024, 176, 59, 32768, 176, 116, 97, 59, 32768, 948, 112, 116, 121, 118, 59, 32768, 10673, 512, 105, 114, 8356, 8362, 115, 104, 116, 59, 32768, 10623, 59, 32896, 55349, 56609, 97, 114, 512, 108, 114, 8373, 8376, 59, 32768, 8643, 59, 32768, 8642, 1280, 97, 101, 103, 115, 118, 8390, 8418, 8421, 8428, 8433, 109, 768, 59, 111, 115, 8398, 8400, 8415, 32768, 8900, 110, 100, 512, 59, 115, 8407, 8409, 32768, 8900, 117, 105, 116, 59, 32768, 9830, 59, 32768, 9830, 59, 32768, 168, 97, 109, 109, 97, 59, 32768, 989, 105, 110, 59, 32768, 8946, 768, 59, 105, 111, 8440, 8442, 8461, 32768, 247, 100, 101, 33280, 247, 59, 111, 8450, 8452, 32768, 247, 110, 116, 105, 109, 101, 115, 59, 32768, 8903, 110, 120, 59, 32768, 8903, 99, 121, 59, 32768, 1106, 99, 1088, 8478, 0, 0, 8483, 114, 110, 59, 32768, 8990, 111, 112, 59, 32768, 8973, 1280, 108, 112, 116, 117, 119, 8498, 8504, 8509, 8556, 8570, 108, 97, 114, 59, 32768, 36, 102, 59, 32896, 55349, 56661, 1280, 59, 101, 109, 112, 115, 8520, 8522, 8535, 8542, 8548, 32768, 729, 113, 512, 59, 100, 8528, 8530, 32768, 8784, 111, 116, 59, 32768, 8785, 105, 110, 117, 115, 59, 32768, 8760, 108, 117, 115, 59, 32768, 8724, 113, 117, 97, 114, 101, 59, 32768, 8865, 98, 108, 101, 98, 97, 114, 119, 101, 100, 103, 101, 59, 32768, 8966, 110, 768, 97, 100, 104, 8578, 8585, 8597, 114, 114, 111, 119, 59, 32768, 8595, 111, 119, 110, 97, 114, 114, 111, 119, 115, 59, 32768, 8650, 97, 114, 112, 111, 111, 110, 512, 108, 114, 8608, 8614, 101, 102, 116, 59, 32768, 8643, 105, 103, 104, 116, 59, 32768, 8642, 563, 8625, 8633, 107, 97, 114, 111, 119, 59, 32768, 10512, 1088, 8638, 0, 0, 8643, 114, 110, 59, 32768, 8991, 111, 112, 59, 32768, 8972, 768, 99, 111, 116, 8654, 8666, 8670, 512, 114, 121, 8659, 8663, 59, 32896, 55349, 56505, 59, 32768, 1109, 108, 59, 32768, 10742, 114, 111, 107, 59, 32768, 273, 512, 100, 114, 8681, 8686, 111, 116, 59, 32768, 8945, 105, 512, 59, 102, 8692, 8694, 32768, 9663, 59, 32768, 9662, 512, 97, 104, 8702, 8707, 114, 114, 59, 32768, 8693, 97, 114, 59, 32768, 10607, 97, 110, 103, 108, 101, 59, 32768, 10662, 512, 99, 105, 8725, 8729, 121, 59, 32768, 1119, 103, 114, 97, 114, 114, 59, 32768, 10239, 4608, 68, 97, 99, 100, 101, 102, 103, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 120, 8774, 8788, 8807, 8844, 8849, 8852, 8866, 8895, 8929, 8977, 8989, 9004, 9046, 9136, 9151, 9171, 9184, 9199, 512, 68, 111, 8779, 8784, 111, 116, 59, 32768, 10871, 116, 59, 32768, 8785, 512, 99, 115, 8793, 8801, 117, 116, 101, 33024, 233, 59, 32768, 233, 116, 101, 114, 59, 32768, 10862, 1024, 97, 105, 111, 121, 8816, 8822, 8835, 8841, 114, 111, 110, 59, 32768, 283, 114, 512, 59, 99, 8828, 8830, 32768, 8790, 33024, 234, 59, 32768, 234, 108, 111, 110, 59, 32768, 8789, 59, 32768, 1101, 111, 116, 59, 32768, 279, 59, 32768, 8519, 512, 68, 114, 8857, 8862, 111, 116, 59, 32768, 8786, 59, 32896, 55349, 56610, 768, 59, 114, 115, 8873, 8875, 8883, 32768, 10906, 97, 118, 101, 33024, 232, 59, 32768, 232, 512, 59, 100, 8888, 8890, 32768, 10902, 111, 116, 59, 32768, 10904, 1024, 59, 105, 108, 115, 8904, 8906, 8914, 8917, 32768, 10905, 110, 116, 101, 114, 115, 59, 32768, 9191, 59, 32768, 8467, 512, 59, 100, 8922, 8924, 32768, 10901, 111, 116, 59, 32768, 10903, 768, 97, 112, 115, 8936, 8941, 8960, 99, 114, 59, 32768, 275, 116, 121, 768, 59, 115, 118, 8950, 8952, 8957, 32768, 8709, 101, 116, 59, 32768, 8709, 59, 32768, 8709, 112, 512, 49, 59, 8966, 8975, 516, 8970, 8973, 59, 32768, 8196, 59, 32768, 8197, 32768, 8195, 512, 103, 115, 8982, 8985, 59, 32768, 331, 112, 59, 32768, 8194, 512, 103, 112, 8994, 8999, 111, 110, 59, 32768, 281, 102, 59, 32896, 55349, 56662, 768, 97, 108, 115, 9011, 9023, 9028, 114, 512, 59, 115, 9017, 9019, 32768, 8917, 108, 59, 32768, 10723, 117, 115, 59, 32768, 10865, 105, 768, 59, 108, 118, 9036, 9038, 9043, 32768, 949, 111, 110, 59, 32768, 949, 59, 32768, 1013, 1024, 99, 115, 117, 118, 9055, 9071, 9099, 9128, 512, 105, 111, 9060, 9065, 114, 99, 59, 32768, 8790, 108, 111, 110, 59, 32768, 8789, 1082, 9077, 0, 0, 9081, 109, 59, 32768, 8770, 97, 110, 116, 512, 103, 108, 9088, 9093, 116, 114, 59, 32768, 10902, 101, 115, 115, 59, 32768, 10901, 768, 97, 101, 105, 9106, 9111, 9116, 108, 115, 59, 32768, 61, 115, 116, 59, 32768, 8799, 118, 512, 59, 68, 9122, 9124, 32768, 8801, 68, 59, 32768, 10872, 112, 97, 114, 115, 108, 59, 32768, 10725, 512, 68, 97, 9141, 9146, 111, 116, 59, 32768, 8787, 114, 114, 59, 32768, 10609, 768, 99, 100, 105, 9158, 9162, 9167, 114, 59, 32768, 8495, 111, 116, 59, 32768, 8784, 109, 59, 32768, 8770, 512, 97, 104, 9176, 9179, 59, 32768, 951, 33024, 240, 59, 32768, 240, 512, 109, 114, 9189, 9195, 108, 33024, 235, 59, 32768, 235, 111, 59, 32768, 8364, 768, 99, 105, 112, 9206, 9210, 9215, 108, 59, 32768, 33, 115, 116, 59, 32768, 8707, 512, 101, 111, 9220, 9230, 99, 116, 97, 116, 105, 111, 110, 59, 32768, 8496, 110, 101, 110, 116, 105, 97, 108, 101, 59, 32768, 8519, 4914, 9262, 0, 9276, 0, 9280, 9287, 0, 0, 9318, 9324, 0, 9331, 0, 9352, 9357, 9386, 0, 9395, 9497, 108, 108, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 32768, 8786, 121, 59, 32768, 1092, 109, 97, 108, 101, 59, 32768, 9792, 768, 105, 108, 114, 9293, 9299, 9313, 108, 105, 103, 59, 32768, 64259, 1082, 9305, 0, 0, 9309, 103, 59, 32768, 64256, 105, 103, 59, 32768, 64260, 59, 32896, 55349, 56611, 108, 105, 103, 59, 32768, 64257, 108, 105, 103, 59, 32896, 102, 106, 768, 97, 108, 116, 9337, 9341, 9346, 116, 59, 32768, 9837, 105, 103, 59, 32768, 64258, 110, 115, 59, 32768, 9649, 111, 102, 59, 32768, 402, 833, 9361, 0, 9366, 102, 59, 32896, 55349, 56663, 512, 97, 107, 9370, 9375, 108, 108, 59, 32768, 8704, 512, 59, 118, 9380, 9382, 32768, 8916, 59, 32768, 10969, 97, 114, 116, 105, 110, 116, 59, 32768, 10765, 512, 97, 111, 9399, 9491, 512, 99, 115, 9404, 9487, 1794, 9413, 9443, 9453, 9470, 9474, 0, 9484, 1795, 9421, 9426, 9429, 9434, 9437, 0, 9440, 33024, 189, 59, 32768, 189, 59, 32768, 8531, 33024, 188, 59, 32768, 188, 59, 32768, 8533, 59, 32768, 8537, 59, 32768, 8539, 772, 9447, 0, 9450, 59, 32768, 8532, 59, 32768, 8534, 1285, 9459, 9464, 0, 0, 9467, 33024, 190, 59, 32768, 190, 59, 32768, 8535, 59, 32768, 8540, 53, 59, 32768, 8536, 775, 9478, 0, 9481, 59, 32768, 8538, 59, 32768, 8541, 56, 59, 32768, 8542, 108, 59, 32768, 8260, 119, 110, 59, 32768, 8994, 99, 114, 59, 32896, 55349, 56507, 4352, 69, 97, 98, 99, 100, 101, 102, 103, 105, 106, 108, 110, 111, 114, 115, 116, 118, 9537, 9547, 9575, 9582, 9595, 9600, 9679, 9684, 9694, 9700, 9705, 9725, 9773, 9779, 9785, 9810, 9917, 512, 59, 108, 9542, 9544, 32768, 8807, 59, 32768, 10892, 768, 99, 109, 112, 9554, 9560, 9572, 117, 116, 101, 59, 32768, 501, 109, 97, 512, 59, 100, 9567, 9569, 32768, 947, 59, 32768, 989, 59, 32768, 10886, 114, 101, 118, 101, 59, 32768, 287, 512, 105, 121, 9587, 9592, 114, 99, 59, 32768, 285, 59, 32768, 1075, 111, 116, 59, 32768, 289, 1024, 59, 108, 113, 115, 9609, 9611, 9614, 9633, 32768, 8805, 59, 32768, 8923, 768, 59, 113, 115, 9621, 9623, 9626, 32768, 8805, 59, 32768, 8807, 108, 97, 110, 116, 59, 32768, 10878, 1024, 59, 99, 100, 108, 9642, 9644, 9648, 9667, 32768, 10878, 99, 59, 32768, 10921, 111, 116, 512, 59, 111, 9655, 9657, 32768, 10880, 512, 59, 108, 9662, 9664, 32768, 10882, 59, 32768, 10884, 512, 59, 101, 9672, 9675, 32896, 8923, 65024, 115, 59, 32768, 10900, 114, 59, 32896, 55349, 56612, 512, 59, 103, 9689, 9691, 32768, 8811, 59, 32768, 8921, 109, 101, 108, 59, 32768, 8503, 99, 121, 59, 32768, 1107, 1024, 59, 69, 97, 106, 9714, 9716, 9719, 9722, 32768, 8823, 59, 32768, 10898, 59, 32768, 10917, 59, 32768, 10916, 1024, 69, 97, 101, 115, 9734, 9737, 9751, 9768, 59, 32768, 8809, 112, 512, 59, 112, 9743, 9745, 32768, 10890, 114, 111, 120, 59, 32768, 10890, 512, 59, 113, 9756, 9758, 32768, 10888, 512, 59, 113, 9763, 9765, 32768, 10888, 59, 32768, 8809, 105, 109, 59, 32768, 8935, 112, 102, 59, 32896, 55349, 56664, 97, 118, 101, 59, 32768, 96, 512, 99, 105, 9790, 9794, 114, 59, 32768, 8458, 109, 768, 59, 101, 108, 9802, 9804, 9807, 32768, 8819, 59, 32768, 10894, 59, 32768, 10896, 34304, 62, 59, 99, 100, 108, 113, 114, 9824, 9826, 9838, 9843, 9849, 9856, 32768, 62, 512, 99, 105, 9831, 9834, 59, 32768, 10919, 114, 59, 32768, 10874, 111, 116, 59, 32768, 8919, 80, 97, 114, 59, 32768, 10645, 117, 101, 115, 116, 59, 32768, 10876, 1280, 97, 100, 101, 108, 115, 9867, 9882, 9887, 9906, 9912, 833, 9872, 0, 9879, 112, 114, 111, 120, 59, 32768, 10886, 114, 59, 32768, 10616, 111, 116, 59, 32768, 8919, 113, 512, 108, 113, 9893, 9899, 101, 115, 115, 59, 32768, 8923, 108, 101, 115, 115, 59, 32768, 10892, 101, 115, 115, 59, 32768, 8823, 105, 109, 59, 32768, 8819, 512, 101, 110, 9922, 9932, 114, 116, 110, 101, 113, 113, 59, 32896, 8809, 65024, 69, 59, 32896, 8809, 65024, 2560, 65, 97, 98, 99, 101, 102, 107, 111, 115, 121, 9958, 9963, 10015, 10020, 10026, 10060, 10065, 10085, 10147, 10171, 114, 114, 59, 32768, 8660, 1024, 105, 108, 109, 114, 9972, 9978, 9982, 9988, 114, 115, 112, 59, 32768, 8202, 102, 59, 32768, 189, 105, 108, 116, 59, 32768, 8459, 512, 100, 114, 9993, 9998, 99, 121, 59, 32768, 1098, 768, 59, 99, 119, 10005, 10007, 10012, 32768, 8596, 105, 114, 59, 32768, 10568, 59, 32768, 8621, 97, 114, 59, 32768, 8463, 105, 114, 99, 59, 32768, 293, 768, 97, 108, 114, 10033, 10048, 10054, 114, 116, 115, 512, 59, 117, 10041, 10043, 32768, 9829, 105, 116, 59, 32768, 9829, 108, 105, 112, 59, 32768, 8230, 99, 111, 110, 59, 32768, 8889, 114, 59, 32896, 55349, 56613, 115, 512, 101, 119, 10071, 10078, 97, 114, 111, 119, 59, 32768, 10533, 97, 114, 111, 119, 59, 32768, 10534, 1280, 97, 109, 111, 112, 114, 10096, 10101, 10107, 10136, 10141, 114, 114, 59, 32768, 8703, 116, 104, 116, 59, 32768, 8763, 107, 512, 108, 114, 10113, 10124, 101, 102, 116, 97, 114, 114, 111, 119, 59, 32768, 8617, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8618, 102, 59, 32896, 55349, 56665, 98, 97, 114, 59, 32768, 8213, 768, 99, 108, 116, 10154, 10159, 10165, 114, 59, 32896, 55349, 56509, 97, 115, 104, 59, 32768, 8463, 114, 111, 107, 59, 32768, 295, 512, 98, 112, 10176, 10182, 117, 108, 108, 59, 32768, 8259, 104, 101, 110, 59, 32768, 8208, 5426, 10211, 0, 10220, 0, 10239, 10255, 10267, 0, 10276, 10312, 0, 0, 10318, 10371, 10458, 10485, 10491, 0, 10500, 10545, 10558, 99, 117, 116, 101, 33024, 237, 59, 32768, 237, 768, 59, 105, 121, 10226, 10228, 10235, 32768, 8291, 114, 99, 33024, 238, 59, 32768, 238, 59, 32768, 1080, 512, 99, 120, 10243, 10247, 121, 59, 32768, 1077, 99, 108, 33024, 161, 59, 32768, 161, 512, 102, 114, 10259, 10262, 59, 32768, 8660, 59, 32896, 55349, 56614, 114, 97, 118, 101, 33024, 236, 59, 32768, 236, 1024, 59, 105, 110, 111, 10284, 10286, 10300, 10306, 32768, 8520, 512, 105, 110, 10291, 10296, 110, 116, 59, 32768, 10764, 116, 59, 32768, 8749, 102, 105, 110, 59, 32768, 10716, 116, 97, 59, 32768, 8489, 108, 105, 103, 59, 32768, 307, 768, 97, 111, 112, 10324, 10361, 10365, 768, 99, 103, 116, 10331, 10335, 10357, 114, 59, 32768, 299, 768, 101, 108, 112, 10342, 10345, 10351, 59, 32768, 8465, 105, 110, 101, 59, 32768, 8464, 97, 114, 116, 59, 32768, 8465, 104, 59, 32768, 305, 102, 59, 32768, 8887, 101, 100, 59, 32768, 437, 1280, 59, 99, 102, 111, 116, 10381, 10383, 10389, 10403, 10409, 32768, 8712, 97, 114, 101, 59, 32768, 8453, 105, 110, 512, 59, 116, 10396, 10398, 32768, 8734, 105, 101, 59, 32768, 10717, 100, 111, 116, 59, 32768, 305, 1280, 59, 99, 101, 108, 112, 10420, 10422, 10427, 10444, 10451, 32768, 8747, 97, 108, 59, 32768, 8890, 512, 103, 114, 10432, 10438, 101, 114, 115, 59, 32768, 8484, 99, 97, 108, 59, 32768, 8890, 97, 114, 104, 107, 59, 32768, 10775, 114, 111, 100, 59, 32768, 10812, 1024, 99, 103, 112, 116, 10466, 10470, 10475, 10480, 121, 59, 32768, 1105, 111, 110, 59, 32768, 303, 102, 59, 32896, 55349, 56666, 97, 59, 32768, 953, 114, 111, 100, 59, 32768, 10812, 117, 101, 115, 116, 33024, 191, 59, 32768, 191, 512, 99, 105, 10504, 10509, 114, 59, 32896, 55349, 56510, 110, 1280, 59, 69, 100, 115, 118, 10521, 10523, 10526, 10531, 10541, 32768, 8712, 59, 32768, 8953, 111, 116, 59, 32768, 8949, 512, 59, 118, 10536, 10538, 32768, 8948, 59, 32768, 8947, 59, 32768, 8712, 512, 59, 105, 10549, 10551, 32768, 8290, 108, 100, 101, 59, 32768, 297, 828, 10562, 0, 10567, 99, 121, 59, 32768, 1110, 108, 33024, 239, 59, 32768, 239, 1536, 99, 102, 109, 111, 115, 117, 10585, 10598, 10603, 10609, 10615, 10630, 512, 105, 121, 10590, 10595, 114, 99, 59, 32768, 309, 59, 32768, 1081, 114, 59, 32896, 55349, 56615, 97, 116, 104, 59, 32768, 567, 112, 102, 59, 32896, 55349, 56667, 820, 10620, 0, 10625, 114, 59, 32896, 55349, 56511, 114, 99, 121, 59, 32768, 1112, 107, 99, 121, 59, 32768, 1108, 2048, 97, 99, 102, 103, 104, 106, 111, 115, 10653, 10666, 10680, 10685, 10692, 10697, 10702, 10708, 112, 112, 97, 512, 59, 118, 10661, 10663, 32768, 954, 59, 32768, 1008, 512, 101, 121, 10671, 10677, 100, 105, 108, 59, 32768, 311, 59, 32768, 1082, 114, 59, 32896, 55349, 56616, 114, 101, 101, 110, 59, 32768, 312, 99, 121, 59, 32768, 1093, 99, 121, 59, 32768, 1116, 112, 102, 59, 32896, 55349, 56668, 99, 114, 59, 32896, 55349, 56512, 5888, 65, 66, 69, 72, 97, 98, 99, 100, 101, 102, 103, 104, 106, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 10761, 10783, 10789, 10799, 10804, 10957, 11011, 11047, 11094, 11349, 11372, 11382, 11409, 11414, 11451, 11478, 11526, 11698, 11711, 11755, 11823, 11910, 11929, 768, 97, 114, 116, 10768, 10773, 10777, 114, 114, 59, 32768, 8666, 114, 59, 32768, 8656, 97, 105, 108, 59, 32768, 10523, 97, 114, 114, 59, 32768, 10510, 512, 59, 103, 10794, 10796, 32768, 8806, 59, 32768, 10891, 97, 114, 59, 32768, 10594, 4660, 10824, 0, 10830, 0, 10838, 0, 0, 0, 0, 0, 10844, 10850, 0, 10867, 10870, 10877, 0, 10933, 117, 116, 101, 59, 32768, 314, 109, 112, 116, 121, 118, 59, 32768, 10676, 114, 97, 110, 59, 32768, 8466, 98, 100, 97, 59, 32768, 955, 103, 768, 59, 100, 108, 10857, 10859, 10862, 32768, 10216, 59, 32768, 10641, 101, 59, 32768, 10216, 59, 32768, 10885, 117, 111, 33024, 171, 59, 32768, 171, 114, 2048, 59, 98, 102, 104, 108, 112, 115, 116, 10894, 10896, 10907, 10911, 10915, 10919, 10923, 10928, 32768, 8592, 512, 59, 102, 10901, 10903, 32768, 8676, 115, 59, 32768, 10527, 115, 59, 32768, 10525, 107, 59, 32768, 8617, 112, 59, 32768, 8619, 108, 59, 32768, 10553, 105, 109, 59, 32768, 10611, 108, 59, 32768, 8610, 768, 59, 97, 101, 10939, 10941, 10946, 32768, 10923, 105, 108, 59, 32768, 10521, 512, 59, 115, 10951, 10953, 32768, 10925, 59, 32896, 10925, 65024, 768, 97, 98, 114, 10964, 10969, 10974, 114, 114, 59, 32768, 10508, 114, 107, 59, 32768, 10098, 512, 97, 107, 10979, 10991, 99, 512, 101, 107, 10985, 10988, 59, 32768, 123, 59, 32768, 91, 512, 101, 115, 10996, 10999, 59, 32768, 10635, 108, 512, 100, 117, 11005, 11008, 59, 32768, 10639, 59, 32768, 10637, 1024, 97, 101, 117, 121, 11020, 11026, 11040, 11044, 114, 111, 110, 59, 32768, 318, 512, 100, 105, 11031, 11036, 105, 108, 59, 32768, 316, 108, 59, 32768, 8968, 98, 59, 32768, 123, 59, 32768, 1083, 1024, 99, 113, 114, 115, 11056, 11060, 11072, 11090, 97, 59, 32768, 10550, 117, 111, 512, 59, 114, 11067, 11069, 32768, 8220, 59, 32768, 8222, 512, 100, 117, 11077, 11083, 104, 97, 114, 59, 32768, 10599, 115, 104, 97, 114, 59, 32768, 10571, 104, 59, 32768, 8626, 1280, 59, 102, 103, 113, 115, 11105, 11107, 11228, 11231, 11250, 32768, 8804, 116, 1280, 97, 104, 108, 114, 116, 11119, 11136, 11157, 11169, 11216, 114, 114, 111, 119, 512, 59, 116, 11128, 11130, 32768, 8592, 97, 105, 108, 59, 32768, 8610, 97, 114, 112, 111, 111, 110, 512, 100, 117, 11147, 11153, 111, 119, 110, 59, 32768, 8637, 112, 59, 32768, 8636, 101, 102, 116, 97, 114, 114, 111, 119, 115, 59, 32768, 8647, 105, 103, 104, 116, 768, 97, 104, 115, 11180, 11194, 11204, 114, 114, 111, 119, 512, 59, 115, 11189, 11191, 32768, 8596, 59, 32768, 8646, 97, 114, 112, 111, 111, 110, 115, 59, 32768, 8651, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 32768, 8621, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 32768, 8907, 59, 32768, 8922, 768, 59, 113, 115, 11238, 11240, 11243, 32768, 8804, 59, 32768, 8806, 108, 97, 110, 116, 59, 32768, 10877, 1280, 59, 99, 100, 103, 115, 11261, 11263, 11267, 11286, 11298, 32768, 10877, 99, 59, 32768, 10920, 111, 116, 512, 59, 111, 11274, 11276, 32768, 10879, 512, 59, 114, 11281, 11283, 32768, 10881, 59, 32768, 10883, 512, 59, 101, 11291, 11294, 32896, 8922, 65024, 115, 59, 32768, 10899, 1280, 97, 100, 101, 103, 115, 11309, 11317, 11322, 11339, 11344, 112, 112, 114, 111, 120, 59, 32768, 10885, 111, 116, 59, 32768, 8918, 113, 512, 103, 113, 11328, 11333, 116, 114, 59, 32768, 8922, 103, 116, 114, 59, 32768, 10891, 116, 114, 59, 32768, 8822, 105, 109, 59, 32768, 8818, 768, 105, 108, 114, 11356, 11362, 11368, 115, 104, 116, 59, 32768, 10620, 111, 111, 114, 59, 32768, 8970, 59, 32896, 55349, 56617, 512, 59, 69, 11377, 11379, 32768, 8822, 59, 32768, 10897, 562, 11386, 11405, 114, 512, 100, 117, 11391, 11394, 59, 32768, 8637, 512, 59, 108, 11399, 11401, 32768, 8636, 59, 32768, 10602, 108, 107, 59, 32768, 9604, 99, 121, 59, 32768, 1113, 1280, 59, 97, 99, 104, 116, 11425, 11427, 11432, 11440, 11446, 32768, 8810, 114, 114, 59, 32768, 8647, 111, 114, 110, 101, 114, 59, 32768, 8990, 97, 114, 100, 59, 32768, 10603, 114, 105, 59, 32768, 9722, 512, 105, 111, 11456, 11462, 100, 111, 116, 59, 32768, 320, 117, 115, 116, 512, 59, 97, 11470, 11472, 32768, 9136, 99, 104, 101, 59, 32768, 9136, 1024, 69, 97, 101, 115, 11487, 11490, 11504, 11521, 59, 32768, 8808, 112, 512, 59, 112, 11496, 11498, 32768, 10889, 114, 111, 120, 59, 32768, 10889, 512, 59, 113, 11509, 11511, 32768, 10887, 512, 59, 113, 11516, 11518, 32768, 10887, 59, 32768, 8808, 105, 109, 59, 32768, 8934, 2048, 97, 98, 110, 111, 112, 116, 119, 122, 11543, 11556, 11561, 11616, 11640, 11660, 11667, 11680, 512, 110, 114, 11548, 11552, 103, 59, 32768, 10220, 114, 59, 32768, 8701, 114, 107, 59, 32768, 10214, 103, 768, 108, 109, 114, 11569, 11596, 11604, 101, 102, 116, 512, 97, 114, 11577, 11584, 114, 114, 111, 119, 59, 32768, 10229, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 10231, 97, 112, 115, 116, 111, 59, 32768, 10236, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 10230, 112, 97, 114, 114, 111, 119, 512, 108, 114, 11627, 11633, 101, 102, 116, 59, 32768, 8619, 105, 103, 104, 116, 59, 32768, 8620, 768, 97, 102, 108, 11647, 11651, 11655, 114, 59, 32768, 10629, 59, 32896, 55349, 56669, 117, 115, 59, 32768, 10797, 105, 109, 101, 115, 59, 32768, 10804, 562, 11671, 11676, 115, 116, 59, 32768, 8727, 97, 114, 59, 32768, 95, 768, 59, 101, 102, 11687, 11689, 11695, 32768, 9674, 110, 103, 101, 59, 32768, 9674, 59, 32768, 10731, 97, 114, 512, 59, 108, 11705, 11707, 32768, 40, 116, 59, 32768, 10643, 1280, 97, 99, 104, 109, 116, 11722, 11727, 11735, 11747, 11750, 114, 114, 59, 32768, 8646, 111, 114, 110, 101, 114, 59, 32768, 8991, 97, 114, 512, 59, 100, 11742, 11744, 32768, 8651, 59, 32768, 10605, 59, 32768, 8206, 114, 105, 59, 32768, 8895, 1536, 97, 99, 104, 105, 113, 116, 11768, 11774, 11779, 11782, 11798, 11817, 113, 117, 111, 59, 32768, 8249, 114, 59, 32896, 55349, 56513, 59, 32768, 8624, 109, 768, 59, 101, 103, 11790, 11792, 11795, 32768, 8818, 59, 32768, 10893, 59, 32768, 10895, 512, 98, 117, 11803, 11806, 59, 32768, 91, 111, 512, 59, 114, 11812, 11814, 32768, 8216, 59, 32768, 8218, 114, 111, 107, 59, 32768, 322, 34816, 60, 59, 99, 100, 104, 105, 108, 113, 114, 11841, 11843, 11855, 11860, 11866, 11872, 11878, 11885, 32768, 60, 512, 99, 105, 11848, 11851, 59, 32768, 10918, 114, 59, 32768, 10873, 111, 116, 59, 32768, 8918, 114, 101, 101, 59, 32768, 8907, 109, 101, 115, 59, 32768, 8905, 97, 114, 114, 59, 32768, 10614, 117, 101, 115, 116, 59, 32768, 10875, 512, 80, 105, 11890, 11895, 97, 114, 59, 32768, 10646, 768, 59, 101, 102, 11902, 11904, 11907, 32768, 9667, 59, 32768, 8884, 59, 32768, 9666, 114, 512, 100, 117, 11916, 11923, 115, 104, 97, 114, 59, 32768, 10570, 104, 97, 114, 59, 32768, 10598, 512, 101, 110, 11934, 11944, 114, 116, 110, 101, 113, 113, 59, 32896, 8808, 65024, 69, 59, 32896, 8808, 65024, 3584, 68, 97, 99, 100, 101, 102, 104, 105, 108, 110, 111, 112, 115, 117, 11978, 11984, 12061, 12075, 12081, 12095, 12100, 12104, 12170, 12181, 12188, 12204, 12207, 12223, 68, 111, 116, 59, 32768, 8762, 1024, 99, 108, 112, 114, 11993, 11999, 12019, 12055, 114, 33024, 175, 59, 32768, 175, 512, 101, 116, 12004, 12007, 59, 32768, 9794, 512, 59, 101, 12012, 12014, 32768, 10016, 115, 101, 59, 32768, 10016, 512, 59, 115, 12024, 12026, 32768, 8614, 116, 111, 1024, 59, 100, 108, 117, 12037, 12039, 12045, 12051, 32768, 8614, 111, 119, 110, 59, 32768, 8615, 101, 102, 116, 59, 32768, 8612, 112, 59, 32768, 8613, 107, 101, 114, 59, 32768, 9646, 512, 111, 121, 12066, 12072, 109, 109, 97, 59, 32768, 10793, 59, 32768, 1084, 97, 115, 104, 59, 32768, 8212, 97, 115, 117, 114, 101, 100, 97, 110, 103, 108, 101, 59, 32768, 8737, 114, 59, 32896, 55349, 56618, 111, 59, 32768, 8487, 768, 99, 100, 110, 12111, 12118, 12146, 114, 111, 33024, 181, 59, 32768, 181, 1024, 59, 97, 99, 100, 12127, 12129, 12134, 12139, 32768, 8739, 115, 116, 59, 32768, 42, 105, 114, 59, 32768, 10992, 111, 116, 33024, 183, 59, 32768, 183, 117, 115, 768, 59, 98, 100, 12155, 12157, 12160, 32768, 8722, 59, 32768, 8863, 512, 59, 117, 12165, 12167, 32768, 8760, 59, 32768, 10794, 564, 12174, 12178, 112, 59, 32768, 10971, 114, 59, 32768, 8230, 112, 108, 117, 115, 59, 32768, 8723, 512, 100, 112, 12193, 12199, 101, 108, 115, 59, 32768, 8871, 102, 59, 32896, 55349, 56670, 59, 32768, 8723, 512, 99, 116, 12212, 12217, 114, 59, 32896, 55349, 56514, 112, 111, 115, 59, 32768, 8766, 768, 59, 108, 109, 12230, 12232, 12240, 32768, 956, 116, 105, 109, 97, 112, 59, 32768, 8888, 97, 112, 59, 32768, 8888, 6144, 71, 76, 82, 86, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 108, 109, 111, 112, 114, 115, 116, 117, 118, 119, 12294, 12315, 12364, 12376, 12393, 12472, 12496, 12547, 12553, 12636, 12641, 12703, 12725, 12747, 12752, 12876, 12881, 12957, 13033, 13089, 13294, 13359, 13384, 13499, 512, 103, 116, 12299, 12303, 59, 32896, 8921, 824, 512, 59, 118, 12308, 12311, 32896, 8811, 8402, 59, 32896, 8811, 824, 768, 101, 108, 116, 12322, 12348, 12352, 102, 116, 512, 97, 114, 12329, 12336, 114, 114, 111, 119, 59, 32768, 8653, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8654, 59, 32896, 8920, 824, 512, 59, 118, 12357, 12360, 32896, 8810, 8402, 59, 32896, 8810, 824, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8655, 512, 68, 100, 12381, 12387, 97, 115, 104, 59, 32768, 8879, 97, 115, 104, 59, 32768, 8878, 1280, 98, 99, 110, 112, 116, 12404, 12409, 12415, 12420, 12452, 108, 97, 59, 32768, 8711, 117, 116, 101, 59, 32768, 324, 103, 59, 32896, 8736, 8402, 1280, 59, 69, 105, 111, 112, 12431, 12433, 12437, 12442, 12446, 32768, 8777, 59, 32896, 10864, 824, 100, 59, 32896, 8779, 824, 115, 59, 32768, 329, 114, 111, 120, 59, 32768, 8777, 117, 114, 512, 59, 97, 12459, 12461, 32768, 9838, 108, 512, 59, 115, 12467, 12469, 32768, 9838, 59, 32768, 8469, 836, 12477, 0, 12483, 112, 33024, 160, 59, 32768, 160, 109, 112, 512, 59, 101, 12489, 12492, 32896, 8782, 824, 59, 32896, 8783, 824, 1280, 97, 101, 111, 117, 121, 12507, 12519, 12525, 12540, 12544, 833, 12512, 0, 12515, 59, 32768, 10819, 111, 110, 59, 32768, 328, 100, 105, 108, 59, 32768, 326, 110, 103, 512, 59, 100, 12532, 12534, 32768, 8775, 111, 116, 59, 32896, 10861, 824, 112, 59, 32768, 10818, 59, 32768, 1085, 97, 115, 104, 59, 32768, 8211, 1792, 59, 65, 97, 100, 113, 115, 120, 12568, 12570, 12575, 12596, 12602, 12608, 12623, 32768, 8800, 114, 114, 59, 32768, 8663, 114, 512, 104, 114, 12581, 12585, 107, 59, 32768, 10532, 512, 59, 111, 12590, 12592, 32768, 8599, 119, 59, 32768, 8599, 111, 116, 59, 32896, 8784, 824, 117, 105, 118, 59, 32768, 8802, 512, 101, 105, 12613, 12618, 97, 114, 59, 32768, 10536, 109, 59, 32896, 8770, 824, 105, 115, 116, 512, 59, 115, 12631, 12633, 32768, 8708, 59, 32768, 8708, 114, 59, 32896, 55349, 56619, 1024, 69, 101, 115, 116, 12650, 12654, 12688, 12693, 59, 32896, 8807, 824, 768, 59, 113, 115, 12661, 12663, 12684, 32768, 8817, 768, 59, 113, 115, 12670, 12672, 12676, 32768, 8817, 59, 32896, 8807, 824, 108, 97, 110, 116, 59, 32896, 10878, 824, 59, 32896, 10878, 824, 105, 109, 59, 32768, 8821, 512, 59, 114, 12698, 12700, 32768, 8815, 59, 32768, 8815, 768, 65, 97, 112, 12710, 12715, 12720, 114, 114, 59, 32768, 8654, 114, 114, 59, 32768, 8622, 97, 114, 59, 32768, 10994, 768, 59, 115, 118, 12732, 12734, 12744, 32768, 8715, 512, 59, 100, 12739, 12741, 32768, 8956, 59, 32768, 8954, 59, 32768, 8715, 99, 121, 59, 32768, 1114, 1792, 65, 69, 97, 100, 101, 115, 116, 12767, 12772, 12776, 12781, 12785, 12853, 12858, 114, 114, 59, 32768, 8653, 59, 32896, 8806, 824, 114, 114, 59, 32768, 8602, 114, 59, 32768, 8229, 1024, 59, 102, 113, 115, 12794, 12796, 12821, 12842, 32768, 8816, 116, 512, 97, 114, 12802, 12809, 114, 114, 111, 119, 59, 32768, 8602, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8622, 768, 59, 113, 115, 12828, 12830, 12834, 32768, 8816, 59, 32896, 8806, 824, 108, 97, 110, 116, 59, 32896, 10877, 824, 512, 59, 115, 12847, 12850, 32896, 10877, 824, 59, 32768, 8814, 105, 109, 59, 32768, 8820, 512, 59, 114, 12863, 12865, 32768, 8814, 105, 512, 59, 101, 12871, 12873, 32768, 8938, 59, 32768, 8940, 105, 100, 59, 32768, 8740, 512, 112, 116, 12886, 12891, 102, 59, 32896, 55349, 56671, 33536, 172, 59, 105, 110, 12899, 12901, 12936, 32768, 172, 110, 1024, 59, 69, 100, 118, 12911, 12913, 12917, 12923, 32768, 8713, 59, 32896, 8953, 824, 111, 116, 59, 32896, 8949, 824, 818, 12928, 12931, 12934, 59, 32768, 8713, 59, 32768, 8951, 59, 32768, 8950, 105, 512, 59, 118, 12942, 12944, 32768, 8716, 818, 12949, 12952, 12955, 59, 32768, 8716, 59, 32768, 8958, 59, 32768, 8957, 768, 97, 111, 114, 12964, 12992, 12999, 114, 1024, 59, 97, 115, 116, 12974, 12976, 12983, 12988, 32768, 8742, 108, 108, 101, 108, 59, 32768, 8742, 108, 59, 32896, 11005, 8421, 59, 32896, 8706, 824, 108, 105, 110, 116, 59, 32768, 10772, 768, 59, 99, 101, 13006, 13008, 13013, 32768, 8832, 117, 101, 59, 32768, 8928, 512, 59, 99, 13018, 13021, 32896, 10927, 824, 512, 59, 101, 13026, 13028, 32768, 8832, 113, 59, 32896, 10927, 824, 1024, 65, 97, 105, 116, 13042, 13047, 13066, 13077, 114, 114, 59, 32768, 8655, 114, 114, 768, 59, 99, 119, 13056, 13058, 13062, 32768, 8603, 59, 32896, 10547, 824, 59, 32896, 8605, 824, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8603, 114, 105, 512, 59, 101, 13084, 13086, 32768, 8939, 59, 32768, 8941, 1792, 99, 104, 105, 109, 112, 113, 117, 13104, 13128, 13151, 13169, 13174, 13179, 13194, 1024, 59, 99, 101, 114, 13113, 13115, 13120, 13124, 32768, 8833, 117, 101, 59, 32768, 8929, 59, 32896, 10928, 824, 59, 32896, 55349, 56515, 111, 114, 116, 1086, 13137, 0, 0, 13142, 105, 100, 59, 32768, 8740, 97, 114, 97, 108, 108, 101, 108, 59, 32768, 8742, 109, 512, 59, 101, 13157, 13159, 32768, 8769, 512, 59, 113, 13164, 13166, 32768, 8772, 59, 32768, 8772, 105, 100, 59, 32768, 8740, 97, 114, 59, 32768, 8742, 115, 117, 512, 98, 112, 13186, 13190, 101, 59, 32768, 8930, 101, 59, 32768, 8931, 768, 98, 99, 112, 13201, 13241, 13254, 1024, 59, 69, 101, 115, 13210, 13212, 13216, 13219, 32768, 8836, 59, 32896, 10949, 824, 59, 32768, 8840, 101, 116, 512, 59, 101, 13226, 13229, 32896, 8834, 8402, 113, 512, 59, 113, 13235, 13237, 32768, 8840, 59, 32896, 10949, 824, 99, 512, 59, 101, 13247, 13249, 32768, 8833, 113, 59, 32896, 10928, 824, 1024, 59, 69, 101, 115, 13263, 13265, 13269, 13272, 32768, 8837, 59, 32896, 10950, 824, 59, 32768, 8841, 101, 116, 512, 59, 101, 13279, 13282, 32896, 8835, 8402, 113, 512, 59, 113, 13288, 13290, 32768, 8841, 59, 32896, 10950, 824, 1024, 103, 105, 108, 114, 13303, 13307, 13315, 13319, 108, 59, 32768, 8825, 108, 100, 101, 33024, 241, 59, 32768, 241, 103, 59, 32768, 8824, 105, 97, 110, 103, 108, 101, 512, 108, 114, 13330, 13344, 101, 102, 116, 512, 59, 101, 13338, 13340, 32768, 8938, 113, 59, 32768, 8940, 105, 103, 104, 116, 512, 59, 101, 13353, 13355, 32768, 8939, 113, 59, 32768, 8941, 512, 59, 109, 13364, 13366, 32768, 957, 768, 59, 101, 115, 13373, 13375, 13380, 32768, 35, 114, 111, 59, 32768, 8470, 112, 59, 32768, 8199, 2304, 68, 72, 97, 100, 103, 105, 108, 114, 115, 13403, 13409, 13415, 13420, 13426, 13439, 13446, 13476, 13493, 97, 115, 104, 59, 32768, 8877, 97, 114, 114, 59, 32768, 10500, 112, 59, 32896, 8781, 8402, 97, 115, 104, 59, 32768, 8876, 512, 101, 116, 13431, 13435, 59, 32896, 8805, 8402, 59, 32896, 62, 8402, 110, 102, 105, 110, 59, 32768, 10718, 768, 65, 101, 116, 13453, 13458, 13462, 114, 114, 59, 32768, 10498, 59, 32896, 8804, 8402, 512, 59, 114, 13467, 13470, 32896, 60, 8402, 105, 101, 59, 32896, 8884, 8402, 512, 65, 116, 13481, 13486, 114, 114, 59, 32768, 10499, 114, 105, 101, 59, 32896, 8885, 8402, 105, 109, 59, 32896, 8764, 8402, 768, 65, 97, 110, 13506, 13511, 13532, 114, 114, 59, 32768, 8662, 114, 512, 104, 114, 13517, 13521, 107, 59, 32768, 10531, 512, 59, 111, 13526, 13528, 32768, 8598, 119, 59, 32768, 8598, 101, 97, 114, 59, 32768, 10535, 9252, 13576, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 13579, 0, 13596, 13617, 13653, 13659, 13673, 13695, 13708, 0, 0, 13713, 13750, 0, 13788, 13794, 0, 13815, 13890, 13913, 13937, 13944, 59, 32768, 9416, 512, 99, 115, 13583, 13591, 117, 116, 101, 33024, 243, 59, 32768, 243, 116, 59, 32768, 8859, 512, 105, 121, 13600, 13613, 114, 512, 59, 99, 13606, 13608, 32768, 8858, 33024, 244, 59, 32768, 244, 59, 32768, 1086, 1280, 97, 98, 105, 111, 115, 13627, 13632, 13638, 13642, 13646, 115, 104, 59, 32768, 8861, 108, 97, 99, 59, 32768, 337, 118, 59, 32768, 10808, 116, 59, 32768, 8857, 111, 108, 100, 59, 32768, 10684, 108, 105, 103, 59, 32768, 339, 512, 99, 114, 13663, 13668, 105, 114, 59, 32768, 10687, 59, 32896, 55349, 56620, 1600, 13680, 0, 0, 13684, 0, 13692, 110, 59, 32768, 731, 97, 118, 101, 33024, 242, 59, 32768, 242, 59, 32768, 10689, 512, 98, 109, 13699, 13704, 97, 114, 59, 32768, 10677, 59, 32768, 937, 110, 116, 59, 32768, 8750, 1024, 97, 99, 105, 116, 13721, 13726, 13741, 13746, 114, 114, 59, 32768, 8634, 512, 105, 114, 13731, 13735, 114, 59, 32768, 10686, 111, 115, 115, 59, 32768, 10683, 110, 101, 59, 32768, 8254, 59, 32768, 10688, 768, 97, 101, 105, 13756, 13761, 13766, 99, 114, 59, 32768, 333, 103, 97, 59, 32768, 969, 768, 99, 100, 110, 13773, 13779, 13782, 114, 111, 110, 59, 32768, 959, 59, 32768, 10678, 117, 115, 59, 32768, 8854, 112, 102, 59, 32896, 55349, 56672, 768, 97, 101, 108, 13800, 13804, 13809, 114, 59, 32768, 10679, 114, 112, 59, 32768, 10681, 117, 115, 59, 32768, 8853, 1792, 59, 97, 100, 105, 111, 115, 118, 13829, 13831, 13836, 13869, 13875, 13879, 13886, 32768, 8744, 114, 114, 59, 32768, 8635, 1024, 59, 101, 102, 109, 13845, 13847, 13859, 13864, 32768, 10845, 114, 512, 59, 111, 13853, 13855, 32768, 8500, 102, 59, 32768, 8500, 33024, 170, 59, 32768, 170, 33024, 186, 59, 32768, 186, 103, 111, 102, 59, 32768, 8886, 114, 59, 32768, 10838, 108, 111, 112, 101, 59, 32768, 10839, 59, 32768, 10843, 768, 99, 108, 111, 13896, 13900, 13908, 114, 59, 32768, 8500, 97, 115, 104, 33024, 248, 59, 32768, 248, 108, 59, 32768, 8856, 105, 573, 13917, 13924, 100, 101, 33024, 245, 59, 32768, 245, 101, 115, 512, 59, 97, 13930, 13932, 32768, 8855, 115, 59, 32768, 10806, 109, 108, 33024, 246, 59, 32768, 246, 98, 97, 114, 59, 32768, 9021, 5426, 13972, 0, 14013, 0, 14017, 14053, 0, 14058, 14086, 0, 0, 14107, 14199, 0, 14202, 0, 0, 14229, 14425, 0, 14438, 114, 1024, 59, 97, 115, 116, 13981, 13983, 13997, 14009, 32768, 8741, 33280, 182, 59, 108, 13989, 13991, 32768, 182, 108, 101, 108, 59, 32768, 8741, 1082, 14003, 0, 0, 14007, 109, 59, 32768, 10995, 59, 32768, 11005, 59, 32768, 8706, 121, 59, 32768, 1087, 114, 1280, 99, 105, 109, 112, 116, 14028, 14033, 14038, 14043, 14046, 110, 116, 59, 32768, 37, 111, 100, 59, 32768, 46, 105, 108, 59, 32768, 8240, 59, 32768, 8869, 101, 110, 107, 59, 32768, 8241, 114, 59, 32896, 55349, 56621, 768, 105, 109, 111, 14064, 14074, 14080, 512, 59, 118, 14069, 14071, 32768, 966, 59, 32768, 981, 109, 97, 116, 59, 32768, 8499, 110, 101, 59, 32768, 9742, 768, 59, 116, 118, 14092, 14094, 14103, 32768, 960, 99, 104, 102, 111, 114, 107, 59, 32768, 8916, 59, 32768, 982, 512, 97, 117, 14111, 14132, 110, 512, 99, 107, 14117, 14128, 107, 512, 59, 104, 14123, 14125, 32768, 8463, 59, 32768, 8462, 118, 59, 32768, 8463, 115, 2304, 59, 97, 98, 99, 100, 101, 109, 115, 116, 14152, 14154, 14160, 14163, 14168, 14179, 14182, 14188, 14193, 32768, 43, 99, 105, 114, 59, 32768, 10787, 59, 32768, 8862, 105, 114, 59, 32768, 10786, 512, 111, 117, 14173, 14176, 59, 32768, 8724, 59, 32768, 10789, 59, 32768, 10866, 110, 33024, 177, 59, 32768, 177, 105, 109, 59, 32768, 10790, 119, 111, 59, 32768, 10791, 59, 32768, 177, 768, 105, 112, 117, 14208, 14216, 14221, 110, 116, 105, 110, 116, 59, 32768, 10773, 102, 59, 32896, 55349, 56673, 110, 100, 33024, 163, 59, 32768, 163, 2560, 59, 69, 97, 99, 101, 105, 110, 111, 115, 117, 14249, 14251, 14254, 14258, 14263, 14336, 14348, 14367, 14413, 14418, 32768, 8826, 59, 32768, 10931, 112, 59, 32768, 10935, 117, 101, 59, 32768, 8828, 512, 59, 99, 14268, 14270, 32768, 10927, 1536, 59, 97, 99, 101, 110, 115, 14283, 14285, 14293, 14302, 14306, 14331, 32768, 8826, 112, 112, 114, 111, 120, 59, 32768, 10935, 117, 114, 108, 121, 101, 113, 59, 32768, 8828, 113, 59, 32768, 10927, 768, 97, 101, 115, 14313, 14321, 14326, 112, 112, 114, 111, 120, 59, 32768, 10937, 113, 113, 59, 32768, 10933, 105, 109, 59, 32768, 8936, 105, 109, 59, 32768, 8830, 109, 101, 512, 59, 115, 14343, 14345, 32768, 8242, 59, 32768, 8473, 768, 69, 97, 115, 14355, 14358, 14362, 59, 32768, 10933, 112, 59, 32768, 10937, 105, 109, 59, 32768, 8936, 768, 100, 102, 112, 14374, 14377, 14402, 59, 32768, 8719, 768, 97, 108, 115, 14384, 14390, 14396, 108, 97, 114, 59, 32768, 9006, 105, 110, 101, 59, 32768, 8978, 117, 114, 102, 59, 32768, 8979, 512, 59, 116, 14407, 14409, 32768, 8733, 111, 59, 32768, 8733, 105, 109, 59, 32768, 8830, 114, 101, 108, 59, 32768, 8880, 512, 99, 105, 14429, 14434, 114, 59, 32896, 55349, 56517, 59, 32768, 968, 110, 99, 115, 112, 59, 32768, 8200, 1536, 102, 105, 111, 112, 115, 117, 14457, 14462, 14467, 14473, 14480, 14486, 114, 59, 32896, 55349, 56622, 110, 116, 59, 32768, 10764, 112, 102, 59, 32896, 55349, 56674, 114, 105, 109, 101, 59, 32768, 8279, 99, 114, 59, 32896, 55349, 56518, 768, 97, 101, 111, 14493, 14513, 14526, 116, 512, 101, 105, 14499, 14508, 114, 110, 105, 111, 110, 115, 59, 32768, 8461, 110, 116, 59, 32768, 10774, 115, 116, 512, 59, 101, 14520, 14522, 32768, 63, 113, 59, 32768, 8799, 116, 33024, 34, 59, 32768, 34, 5376, 65, 66, 72, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 110, 111, 112, 114, 115, 116, 117, 120, 14575, 14597, 14603, 14608, 14775, 14829, 14865, 14901, 14943, 14966, 15000, 15139, 15159, 15176, 15182, 15236, 15261, 15267, 15309, 15352, 15360, 768, 97, 114, 116, 14582, 14587, 14591, 114, 114, 59, 32768, 8667, 114, 59, 32768, 8658, 97, 105, 108, 59, 32768, 10524, 97, 114, 114, 59, 32768, 10511, 97, 114, 59, 32768, 10596, 1792, 99, 100, 101, 110, 113, 114, 116, 14623, 14637, 14642, 14650, 14672, 14679, 14751, 512, 101, 117, 14628, 14632, 59, 32896, 8765, 817, 116, 101, 59, 32768, 341, 105, 99, 59, 32768, 8730, 109, 112, 116, 121, 118, 59, 32768, 10675, 103, 1024, 59, 100, 101, 108, 14660, 14662, 14665, 14668, 32768, 10217, 59, 32768, 10642, 59, 32768, 10661, 101, 59, 32768, 10217, 117, 111, 33024, 187, 59, 32768, 187, 114, 2816, 59, 97, 98, 99, 102, 104, 108, 112, 115, 116, 119, 14703, 14705, 14709, 14720, 14723, 14727, 14731, 14735, 14739, 14744, 14748, 32768, 8594, 112, 59, 32768, 10613, 512, 59, 102, 14714, 14716, 32768, 8677, 115, 59, 32768, 10528, 59, 32768, 10547, 115, 59, 32768, 10526, 107, 59, 32768, 8618, 112, 59, 32768, 8620, 108, 59, 32768, 10565, 105, 109, 59, 32768, 10612, 108, 59, 32768, 8611, 59, 32768, 8605, 512, 97, 105, 14756, 14761, 105, 108, 59, 32768, 10522, 111, 512, 59, 110, 14767, 14769, 32768, 8758, 97, 108, 115, 59, 32768, 8474, 768, 97, 98, 114, 14782, 14787, 14792, 114, 114, 59, 32768, 10509, 114, 107, 59, 32768, 10099, 512, 97, 107, 14797, 14809, 99, 512, 101, 107, 14803, 14806, 59, 32768, 125, 59, 32768, 93, 512, 101, 115, 14814, 14817, 59, 32768, 10636, 108, 512, 100, 117, 14823, 14826, 59, 32768, 10638, 59, 32768, 10640, 1024, 97, 101, 117, 121, 14838, 14844, 14858, 14862, 114, 111, 110, 59, 32768, 345, 512, 100, 105, 14849, 14854, 105, 108, 59, 32768, 343, 108, 59, 32768, 8969, 98, 59, 32768, 125, 59, 32768, 1088, 1024, 99, 108, 113, 115, 14874, 14878, 14885, 14897, 97, 59, 32768, 10551, 100, 104, 97, 114, 59, 32768, 10601, 117, 111, 512, 59, 114, 14892, 14894, 32768, 8221, 59, 32768, 8221, 104, 59, 32768, 8627, 768, 97, 99, 103, 14908, 14934, 14938, 108, 1024, 59, 105, 112, 115, 14918, 14920, 14925, 14931, 32768, 8476, 110, 101, 59, 32768, 8475, 97, 114, 116, 59, 32768, 8476, 59, 32768, 8477, 116, 59, 32768, 9645, 33024, 174, 59, 32768, 174, 768, 105, 108, 114, 14950, 14956, 14962, 115, 104, 116, 59, 32768, 10621, 111, 111, 114, 59, 32768, 8971, 59, 32896, 55349, 56623, 512, 97, 111, 14971, 14990, 114, 512, 100, 117, 14977, 14980, 59, 32768, 8641, 512, 59, 108, 14985, 14987, 32768, 8640, 59, 32768, 10604, 512, 59, 118, 14995, 14997, 32768, 961, 59, 32768, 1009, 768, 103, 110, 115, 15007, 15123, 15127, 104, 116, 1536, 97, 104, 108, 114, 115, 116, 15022, 15039, 15060, 15086, 15099, 15111, 114, 114, 111, 119, 512, 59, 116, 15031, 15033, 32768, 8594, 97, 105, 108, 59, 32768, 8611, 97, 114, 112, 111, 111, 110, 512, 100, 117, 15050, 15056, 111, 119, 110, 59, 32768, 8641, 112, 59, 32768, 8640, 101, 102, 116, 512, 97, 104, 15068, 15076, 114, 114, 111, 119, 115, 59, 32768, 8644, 97, 114, 112, 111, 111, 110, 115, 59, 32768, 8652, 105, 103, 104, 116, 97, 114, 114, 111, 119, 115, 59, 32768, 8649, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 32768, 8605, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 32768, 8908, 103, 59, 32768, 730, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 32768, 8787, 768, 97, 104, 109, 15146, 15151, 15156, 114, 114, 59, 32768, 8644, 97, 114, 59, 32768, 8652, 59, 32768, 8207, 111, 117, 115, 116, 512, 59, 97, 15168, 15170, 32768, 9137, 99, 104, 101, 59, 32768, 9137, 109, 105, 100, 59, 32768, 10990, 1024, 97, 98, 112, 116, 15191, 15204, 15209, 15229, 512, 110, 114, 15196, 15200, 103, 59, 32768, 10221, 114, 59, 32768, 8702, 114, 107, 59, 32768, 10215, 768, 97, 102, 108, 15216, 15220, 15224, 114, 59, 32768, 10630, 59, 32896, 55349, 56675, 117, 115, 59, 32768, 10798, 105, 109, 101, 115, 59, 32768, 10805, 512, 97, 112, 15241, 15253, 114, 512, 59, 103, 15247, 15249, 32768, 41, 116, 59, 32768, 10644, 111, 108, 105, 110, 116, 59, 32768, 10770, 97, 114, 114, 59, 32768, 8649, 1024, 97, 99, 104, 113, 15276, 15282, 15287, 15290, 113, 117, 111, 59, 32768, 8250, 114, 59, 32896, 55349, 56519, 59, 32768, 8625, 512, 98, 117, 15295, 15298, 59, 32768, 93, 111, 512, 59, 114, 15304, 15306, 32768, 8217, 59, 32768, 8217, 768, 104, 105, 114, 15316, 15322, 15328, 114, 101, 101, 59, 32768, 8908, 109, 101, 115, 59, 32768, 8906, 105, 1024, 59, 101, 102, 108, 15338, 15340, 15343, 15346, 32768, 9657, 59, 32768, 8885, 59, 32768, 9656, 116, 114, 105, 59, 32768, 10702, 108, 117, 104, 97, 114, 59, 32768, 10600, 59, 32768, 8478, 6706, 15391, 15398, 15404, 15499, 15516, 15592, 0, 15606, 15660, 0, 0, 15752, 15758, 0, 15827, 15863, 15886, 16000, 16006, 16038, 16086, 0, 16467, 0, 0, 16506, 99, 117, 116, 101, 59, 32768, 347, 113, 117, 111, 59, 32768, 8218, 2560, 59, 69, 97, 99, 101, 105, 110, 112, 115, 121, 15424, 15426, 15429, 15441, 15446, 15458, 15463, 15482, 15490, 15495, 32768, 8827, 59, 32768, 10932, 833, 15434, 0, 15437, 59, 32768, 10936, 111, 110, 59, 32768, 353, 117, 101, 59, 32768, 8829, 512, 59, 100, 15451, 15453, 32768, 10928, 105, 108, 59, 32768, 351, 114, 99, 59, 32768, 349, 768, 69, 97, 115, 15470, 15473, 15477, 59, 32768, 10934, 112, 59, 32768, 10938, 105, 109, 59, 32768, 8937, 111, 108, 105, 110, 116, 59, 32768, 10771, 105, 109, 59, 32768, 8831, 59, 32768, 1089, 111, 116, 768, 59, 98, 101, 15507, 15509, 15512, 32768, 8901, 59, 32768, 8865, 59, 32768, 10854, 1792, 65, 97, 99, 109, 115, 116, 120, 15530, 15535, 15556, 15562, 15566, 15572, 15587, 114, 114, 59, 32768, 8664, 114, 512, 104, 114, 15541, 15545, 107, 59, 32768, 10533, 512, 59, 111, 15550, 15552, 32768, 8600, 119, 59, 32768, 8600, 116, 33024, 167, 59, 32768, 167, 105, 59, 32768, 59, 119, 97, 114, 59, 32768, 10537, 109, 512, 105, 110, 15578, 15584, 110, 117, 115, 59, 32768, 8726, 59, 32768, 8726, 116, 59, 32768, 10038, 114, 512, 59, 111, 15597, 15600, 32896, 55349, 56624, 119, 110, 59, 32768, 8994, 1024, 97, 99, 111, 121, 15614, 15619, 15632, 15654, 114, 112, 59, 32768, 9839, 512, 104, 121, 15624, 15629, 99, 121, 59, 32768, 1097, 59, 32768, 1096, 114, 116, 1086, 15640, 0, 0, 15645, 105, 100, 59, 32768, 8739, 97, 114, 97, 108, 108, 101, 108, 59, 32768, 8741, 33024, 173, 59, 32768, 173, 512, 103, 109, 15664, 15681, 109, 97, 768, 59, 102, 118, 15673, 15675, 15678, 32768, 963, 59, 32768, 962, 59, 32768, 962, 2048, 59, 100, 101, 103, 108, 110, 112, 114, 15698, 15700, 15705, 15715, 15725, 15735, 15739, 15745, 32768, 8764, 111, 116, 59, 32768, 10858, 512, 59, 113, 15710, 15712, 32768, 8771, 59, 32768, 8771, 512, 59, 69, 15720, 15722, 32768, 10910, 59, 32768, 10912, 512, 59, 69, 15730, 15732, 32768, 10909, 59, 32768, 10911, 101, 59, 32768, 8774, 108, 117, 115, 59, 32768, 10788, 97, 114, 114, 59, 32768, 10610, 97, 114, 114, 59, 32768, 8592, 1024, 97, 101, 105, 116, 15766, 15788, 15796, 15808, 512, 108, 115, 15771, 15783, 108, 115, 101, 116, 109, 105, 110, 117, 115, 59, 32768, 8726, 104, 112, 59, 32768, 10803, 112, 97, 114, 115, 108, 59, 32768, 10724, 512, 100, 108, 15801, 15804, 59, 32768, 8739, 101, 59, 32768, 8995, 512, 59, 101, 15813, 15815, 32768, 10922, 512, 59, 115, 15820, 15822, 32768, 10924, 59, 32896, 10924, 65024, 768, 102, 108, 112, 15833, 15839, 15857, 116, 99, 121, 59, 32768, 1100, 512, 59, 98, 15844, 15846, 32768, 47, 512, 59, 97, 15851, 15853, 32768, 10692, 114, 59, 32768, 9023, 102, 59, 32896, 55349, 56676, 97, 512, 100, 114, 15868, 15882, 101, 115, 512, 59, 117, 15875, 15877, 32768, 9824, 105, 116, 59, 32768, 9824, 59, 32768, 8741, 768, 99, 115, 117, 15892, 15921, 15977, 512, 97, 117, 15897, 15909, 112, 512, 59, 115, 15903, 15905, 32768, 8851, 59, 32896, 8851, 65024, 112, 512, 59, 115, 15915, 15917, 32768, 8852, 59, 32896, 8852, 65024, 117, 512, 98, 112, 15927, 15952, 768, 59, 101, 115, 15934, 15936, 15939, 32768, 8847, 59, 32768, 8849, 101, 116, 512, 59, 101, 15946, 15948, 32768, 8847, 113, 59, 32768, 8849, 768, 59, 101, 115, 15959, 15961, 15964, 32768, 8848, 59, 32768, 8850, 101, 116, 512, 59, 101, 15971, 15973, 32768, 8848, 113, 59, 32768, 8850, 768, 59, 97, 102, 15984, 15986, 15996, 32768, 9633, 114, 566, 15991, 15994, 59, 32768, 9633, 59, 32768, 9642, 59, 32768, 9642, 97, 114, 114, 59, 32768, 8594, 1024, 99, 101, 109, 116, 16014, 16019, 16025, 16031, 114, 59, 32896, 55349, 56520, 116, 109, 110, 59, 32768, 8726, 105, 108, 101, 59, 32768, 8995, 97, 114, 102, 59, 32768, 8902, 512, 97, 114, 16042, 16053, 114, 512, 59, 102, 16048, 16050, 32768, 9734, 59, 32768, 9733, 512, 97, 110, 16058, 16081, 105, 103, 104, 116, 512, 101, 112, 16067, 16076, 112, 115, 105, 108, 111, 110, 59, 32768, 1013, 104, 105, 59, 32768, 981, 115, 59, 32768, 175, 1280, 98, 99, 109, 110, 112, 16096, 16221, 16288, 16291, 16295, 2304, 59, 69, 100, 101, 109, 110, 112, 114, 115, 16115, 16117, 16120, 16125, 16137, 16143, 16154, 16160, 16166, 32768, 8834, 59, 32768, 10949, 111, 116, 59, 32768, 10941, 512, 59, 100, 16130, 16132, 32768, 8838, 111, 116, 59, 32768, 10947, 117, 108, 116, 59, 32768, 10945, 512, 69, 101, 16148, 16151, 59, 32768, 10955, 59, 32768, 8842, 108, 117, 115, 59, 32768, 10943, 97, 114, 114, 59, 32768, 10617, 768, 101, 105, 117, 16173, 16206, 16210, 116, 768, 59, 101, 110, 16181, 16183, 16194, 32768, 8834, 113, 512, 59, 113, 16189, 16191, 32768, 8838, 59, 32768, 10949, 101, 113, 512, 59, 113, 16201, 16203, 32768, 8842, 59, 32768, 10955, 109, 59, 32768, 10951, 512, 98, 112, 16215, 16218, 59, 32768, 10965, 59, 32768, 10963, 99, 1536, 59, 97, 99, 101, 110, 115, 16235, 16237, 16245, 16254, 16258, 16283, 32768, 8827, 112, 112, 114, 111, 120, 59, 32768, 10936, 117, 114, 108, 121, 101, 113, 59, 32768, 8829, 113, 59, 32768, 10928, 768, 97, 101, 115, 16265, 16273, 16278, 112, 112, 114, 111, 120, 59, 32768, 10938, 113, 113, 59, 32768, 10934, 105, 109, 59, 32768, 8937, 105, 109, 59, 32768, 8831, 59, 32768, 8721, 103, 59, 32768, 9834, 3328, 49, 50, 51, 59, 69, 100, 101, 104, 108, 109, 110, 112, 115, 16322, 16327, 16332, 16337, 16339, 16342, 16356, 16368, 16382, 16388, 16394, 16405, 16411, 33024, 185, 59, 32768, 185, 33024, 178, 59, 32768, 178, 33024, 179, 59, 32768, 179, 32768, 8835, 59, 32768, 10950, 512, 111, 115, 16347, 16351, 116, 59, 32768, 10942, 117, 98, 59, 32768, 10968, 512, 59, 100, 16361, 16363, 32768, 8839, 111, 116, 59, 32768, 10948, 115, 512, 111, 117, 16374, 16378, 108, 59, 32768, 10185, 98, 59, 32768, 10967, 97, 114, 114, 59, 32768, 10619, 117, 108, 116, 59, 32768, 10946, 512, 69, 101, 16399, 16402, 59, 32768, 10956, 59, 32768, 8843, 108, 117, 115, 59, 32768, 10944, 768, 101, 105, 117, 16418, 16451, 16455, 116, 768, 59, 101, 110, 16426, 16428, 16439, 32768, 8835, 113, 512, 59, 113, 16434, 16436, 32768, 8839, 59, 32768, 10950, 101, 113, 512, 59, 113, 16446, 16448, 32768, 8843, 59, 32768, 10956, 109, 59, 32768, 10952, 512, 98, 112, 16460, 16463, 59, 32768, 10964, 59, 32768, 10966, 768, 65, 97, 110, 16473, 16478, 16499, 114, 114, 59, 32768, 8665, 114, 512, 104, 114, 16484, 16488, 107, 59, 32768, 10534, 512, 59, 111, 16493, 16495, 32768, 8601, 119, 59, 32768, 8601, 119, 97, 114, 59, 32768, 10538, 108, 105, 103, 33024, 223, 59, 32768, 223, 5938, 16538, 16552, 16557, 16579, 16584, 16591, 0, 16596, 16692, 0, 0, 0, 0, 0, 16731, 16780, 0, 16787, 16908, 0, 0, 0, 16938, 1091, 16543, 0, 0, 16549, 103, 101, 116, 59, 32768, 8982, 59, 32768, 964, 114, 107, 59, 32768, 9140, 768, 97, 101, 121, 16563, 16569, 16575, 114, 111, 110, 59, 32768, 357, 100, 105, 108, 59, 32768, 355, 59, 32768, 1090, 111, 116, 59, 32768, 8411, 108, 114, 101, 99, 59, 32768, 8981, 114, 59, 32896, 55349, 56625, 1024, 101, 105, 107, 111, 16604, 16641, 16670, 16684, 835, 16609, 0, 16624, 101, 512, 52, 102, 16614, 16617, 59, 32768, 8756, 111, 114, 101, 59, 32768, 8756, 97, 768, 59, 115, 118, 16631, 16633, 16638, 32768, 952, 121, 109, 59, 32768, 977, 59, 32768, 977, 512, 99, 110, 16646, 16665, 107, 512, 97, 115, 16652, 16660, 112, 112, 114, 111, 120, 59, 32768, 8776, 105, 109, 59, 32768, 8764, 115, 112, 59, 32768, 8201, 512, 97, 115, 16675, 16679, 112, 59, 32768, 8776, 105, 109, 59, 32768, 8764, 114, 110, 33024, 254, 59, 32768, 254, 829, 16696, 16701, 16727, 100, 101, 59, 32768, 732, 101, 115, 33536, 215, 59, 98, 100, 16710, 16712, 16723, 32768, 215, 512, 59, 97, 16717, 16719, 32768, 8864, 114, 59, 32768, 10801, 59, 32768, 10800, 116, 59, 32768, 8749, 768, 101, 112, 115, 16737, 16741, 16775, 97, 59, 32768, 10536, 1024, 59, 98, 99, 102, 16750, 16752, 16757, 16762, 32768, 8868, 111, 116, 59, 32768, 9014, 105, 114, 59, 32768, 10993, 512, 59, 111, 16767, 16770, 32896, 55349, 56677, 114, 107, 59, 32768, 10970, 97, 59, 32768, 10537, 114, 105, 109, 101, 59, 32768, 8244, 768, 97, 105, 112, 16793, 16798, 16899, 100, 101, 59, 32768, 8482, 1792, 97, 100, 101, 109, 112, 115, 116, 16813, 16868, 16873, 16876, 16883, 16889, 16893, 110, 103, 108, 101, 1280, 59, 100, 108, 113, 114, 16828, 16830, 16836, 16850, 16853, 32768, 9653, 111, 119, 110, 59, 32768, 9663, 101, 102, 116, 512, 59, 101, 16844, 16846, 32768, 9667, 113, 59, 32768, 8884, 59, 32768, 8796, 105, 103, 104, 116, 512, 59, 101, 16862, 16864, 32768, 9657, 113, 59, 32768, 8885, 111, 116, 59, 32768, 9708, 59, 32768, 8796, 105, 110, 117, 115, 59, 32768, 10810, 108, 117, 115, 59, 32768, 10809, 98, 59, 32768, 10701, 105, 109, 101, 59, 32768, 10811, 101, 122, 105, 117, 109, 59, 32768, 9186, 768, 99, 104, 116, 16914, 16926, 16931, 512, 114, 121, 16919, 16923, 59, 32896, 55349, 56521, 59, 32768, 1094, 99, 121, 59, 32768, 1115, 114, 111, 107, 59, 32768, 359, 512, 105, 111, 16942, 16947, 120, 116, 59, 32768, 8812, 104, 101, 97, 100, 512, 108, 114, 16956, 16967, 101, 102, 116, 97, 114, 114, 111, 119, 59, 32768, 8606, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8608, 4608, 65, 72, 97, 98, 99, 100, 102, 103, 104, 108, 109, 111, 112, 114, 115, 116, 117, 119, 17016, 17021, 17026, 17043, 17057, 17072, 17095, 17110, 17119, 17139, 17172, 17187, 17202, 17290, 17330, 17336, 17365, 17381, 114, 114, 59, 32768, 8657, 97, 114, 59, 32768, 10595, 512, 99, 114, 17031, 17039, 117, 116, 101, 33024, 250, 59, 32768, 250, 114, 59, 32768, 8593, 114, 820, 17049, 0, 17053, 121, 59, 32768, 1118, 118, 101, 59, 32768, 365, 512, 105, 121, 17062, 17069, 114, 99, 33024, 251, 59, 32768, 251, 59, 32768, 1091, 768, 97, 98, 104, 17079, 17084, 17090, 114, 114, 59, 32768, 8645, 108, 97, 99, 59, 32768, 369, 97, 114, 59, 32768, 10606, 512, 105, 114, 17100, 17106, 115, 104, 116, 59, 32768, 10622, 59, 32896, 55349, 56626, 114, 97, 118, 101, 33024, 249, 59, 32768, 249, 562, 17123, 17135, 114, 512, 108, 114, 17128, 17131, 59, 32768, 8639, 59, 32768, 8638, 108, 107, 59, 32768, 9600, 512, 99, 116, 17144, 17167, 1088, 17150, 0, 0, 17163, 114, 110, 512, 59, 101, 17156, 17158, 32768, 8988, 114, 59, 32768, 8988, 111, 112, 59, 32768, 8975, 114, 105, 59, 32768, 9720, 512, 97, 108, 17177, 17182, 99, 114, 59, 32768, 363, 33024, 168, 59, 32768, 168, 512, 103, 112, 17192, 17197, 111, 110, 59, 32768, 371, 102, 59, 32896, 55349, 56678, 1536, 97, 100, 104, 108, 115, 117, 17215, 17222, 17233, 17257, 17262, 17280, 114, 114, 111, 119, 59, 32768, 8593, 111, 119, 110, 97, 114, 114, 111, 119, 59, 32768, 8597, 97, 114, 112, 111, 111, 110, 512, 108, 114, 17244, 17250, 101, 102, 116, 59, 32768, 8639, 105, 103, 104, 116, 59, 32768, 8638, 117, 115, 59, 32768, 8846, 105, 768, 59, 104, 108, 17270, 17272, 17275, 32768, 965, 59, 32768, 978, 111, 110, 59, 32768, 965, 112, 97, 114, 114, 111, 119, 115, 59, 32768, 8648, 768, 99, 105, 116, 17297, 17320, 17325, 1088, 17303, 0, 0, 17316, 114, 110, 512, 59, 101, 17309, 17311, 32768, 8989, 114, 59, 32768, 8989, 111, 112, 59, 32768, 8974, 110, 103, 59, 32768, 367, 114, 105, 59, 32768, 9721, 99, 114, 59, 32896, 55349, 56522, 768, 100, 105, 114, 17343, 17348, 17354, 111, 116, 59, 32768, 8944, 108, 100, 101, 59, 32768, 361, 105, 512, 59, 102, 17360, 17362, 32768, 9653, 59, 32768, 9652, 512, 97, 109, 17370, 17375, 114, 114, 59, 32768, 8648, 108, 33024, 252, 59, 32768, 252, 97, 110, 103, 108, 101, 59, 32768, 10663, 3840, 65, 66, 68, 97, 99, 100, 101, 102, 108, 110, 111, 112, 114, 115, 122, 17420, 17425, 17437, 17443, 17613, 17617, 17623, 17667, 17672, 17678, 17693, 17699, 17705, 17711, 17754, 114, 114, 59, 32768, 8661, 97, 114, 512, 59, 118, 17432, 17434, 32768, 10984, 59, 32768, 10985, 97, 115, 104, 59, 32768, 8872, 512, 110, 114, 17448, 17454, 103, 114, 116, 59, 32768, 10652, 1792, 101, 107, 110, 112, 114, 115, 116, 17469, 17478, 17485, 17494, 17515, 17526, 17578, 112, 115, 105, 108, 111, 110, 59, 32768, 1013, 97, 112, 112, 97, 59, 32768, 1008, 111, 116, 104, 105, 110, 103, 59, 32768, 8709, 768, 104, 105, 114, 17501, 17505, 17508, 105, 59, 32768, 981, 59, 32768, 982, 111, 112, 116, 111, 59, 32768, 8733, 512, 59, 104, 17520, 17522, 32768, 8597, 111, 59, 32768, 1009, 512, 105, 117, 17531, 17537, 103, 109, 97, 59, 32768, 962, 512, 98, 112, 17542, 17560, 115, 101, 116, 110, 101, 113, 512, 59, 113, 17553, 17556, 32896, 8842, 65024, 59, 32896, 10955, 65024, 115, 101, 116, 110, 101, 113, 512, 59, 113, 17571, 17574, 32896, 8843, 65024, 59, 32896, 10956, 65024, 512, 104, 114, 17583, 17589, 101, 116, 97, 59, 32768, 977, 105, 97, 110, 103, 108, 101, 512, 108, 114, 17600, 17606, 101, 102, 116, 59, 32768, 8882, 105, 103, 104, 116, 59, 32768, 8883, 121, 59, 32768, 1074, 97, 115, 104, 59, 32768, 8866, 768, 101, 108, 114, 17630, 17648, 17654, 768, 59, 98, 101, 17637, 17639, 17644, 32768, 8744, 97, 114, 59, 32768, 8891, 113, 59, 32768, 8794, 108, 105, 112, 59, 32768, 8942, 512, 98, 116, 17659, 17664, 97, 114, 59, 32768, 124, 59, 32768, 124, 114, 59, 32896, 55349, 56627, 116, 114, 105, 59, 32768, 8882, 115, 117, 512, 98, 112, 17685, 17689, 59, 32896, 8834, 8402, 59, 32896, 8835, 8402, 112, 102, 59, 32896, 55349, 56679, 114, 111, 112, 59, 32768, 8733, 116, 114, 105, 59, 32768, 8883, 512, 99, 117, 17716, 17721, 114, 59, 32896, 55349, 56523, 512, 98, 112, 17726, 17740, 110, 512, 69, 101, 17732, 17736, 59, 32896, 10955, 65024, 59, 32896, 8842, 65024, 110, 512, 69, 101, 17746, 17750, 59, 32896, 10956, 65024, 59, 32896, 8843, 65024, 105, 103, 122, 97, 103, 59, 32768, 10650, 1792, 99, 101, 102, 111, 112, 114, 115, 17777, 17783, 17815, 17820, 17826, 17829, 17842, 105, 114, 99, 59, 32768, 373, 512, 100, 105, 17788, 17809, 512, 98, 103, 17793, 17798, 97, 114, 59, 32768, 10847, 101, 512, 59, 113, 17804, 17806, 32768, 8743, 59, 32768, 8793, 101, 114, 112, 59, 32768, 8472, 114, 59, 32896, 55349, 56628, 112, 102, 59, 32896, 55349, 56680, 59, 32768, 8472, 512, 59, 101, 17834, 17836, 32768, 8768, 97, 116, 104, 59, 32768, 8768, 99, 114, 59, 32896, 55349, 56524, 5428, 17871, 17891, 0, 17897, 0, 17902, 17917, 0, 0, 17920, 17935, 17940, 17945, 0, 0, 17977, 17992, 0, 18008, 18024, 18029, 768, 97, 105, 117, 17877, 17881, 17886, 112, 59, 32768, 8898, 114, 99, 59, 32768, 9711, 112, 59, 32768, 8899, 116, 114, 105, 59, 32768, 9661, 114, 59, 32896, 55349, 56629, 512, 65, 97, 17906, 17911, 114, 114, 59, 32768, 10234, 114, 114, 59, 32768, 10231, 59, 32768, 958, 512, 65, 97, 17924, 17929, 114, 114, 59, 32768, 10232, 114, 114, 59, 32768, 10229, 97, 112, 59, 32768, 10236, 105, 115, 59, 32768, 8955, 768, 100, 112, 116, 17951, 17956, 17970, 111, 116, 59, 32768, 10752, 512, 102, 108, 17961, 17965, 59, 32896, 55349, 56681, 117, 115, 59, 32768, 10753, 105, 109, 101, 59, 32768, 10754, 512, 65, 97, 17981, 17986, 114, 114, 59, 32768, 10233, 114, 114, 59, 32768, 10230, 512, 99, 113, 17996, 18001, 114, 59, 32896, 55349, 56525, 99, 117, 112, 59, 32768, 10758, 512, 112, 116, 18012, 18018, 108, 117, 115, 59, 32768, 10756, 114, 105, 59, 32768, 9651, 101, 101, 59, 32768, 8897, 101, 100, 103, 101, 59, 32768, 8896, 2048, 97, 99, 101, 102, 105, 111, 115, 117, 18052, 18068, 18081, 18087, 18092, 18097, 18103, 18109, 99, 512, 117, 121, 18058, 18065, 116, 101, 33024, 253, 59, 32768, 253, 59, 32768, 1103, 512, 105, 121, 18073, 18078, 114, 99, 59, 32768, 375, 59, 32768, 1099, 110, 33024, 165, 59, 32768, 165, 114, 59, 32896, 55349, 56630, 99, 121, 59, 32768, 1111, 112, 102, 59, 32896, 55349, 56682, 99, 114, 59, 32896, 55349, 56526, 512, 99, 109, 18114, 18118, 121, 59, 32768, 1102, 108, 33024, 255, 59, 32768, 255, 2560, 97, 99, 100, 101, 102, 104, 105, 111, 115, 119, 18145, 18152, 18166, 18171, 18186, 18191, 18196, 18204, 18210, 18216, 99, 117, 116, 101, 59, 32768, 378, 512, 97, 121, 18157, 18163, 114, 111, 110, 59, 32768, 382, 59, 32768, 1079, 111, 116, 59, 32768, 380, 512, 101, 116, 18176, 18182, 116, 114, 102, 59, 32768, 8488, 97, 59, 32768, 950, 114, 59, 32896, 55349, 56631, 99, 121, 59, 32768, 1078, 103, 114, 97, 114, 114, 59, 32768, 8669, 112, 102, 59, 32896, 55349, 56683, 99, 114, 59, 32896, 55349, 56527, 512, 106, 110, 18221, 18224, 59, 32768, 8205, 106, 59, 32768, 8204]);

var decodeDataXml = {};

Object.defineProperty(decodeDataXml, "__esModule", { value: true });
// Generated using scripts/write-decode-map.ts
// prettier-ignore
decodeDataXml.default = new Uint16Array([1024, 97, 103, 108, 113, 9, 23, 27, 31, 1086, 15, 0, 0, 19, 112, 59, 32768, 38, 111, 115, 59, 32768, 39, 116, 59, 32768, 62, 116, 59, 32768, 60, 117, 111, 116, 59, 32768, 34]);

(function (exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeXML = exports.decodeHTMLStrict = exports.decodeHTML = exports.determineBranch = exports.JUMP_OFFSET_BASE = exports.BinTrieFlags = exports.xmlDecodeTree = exports.htmlDecodeTree = void 0;
var decode_data_html_1 = __importDefault(decodeDataHtml);
exports.htmlDecodeTree = decode_data_html_1.default;
var decode_data_xml_1 = __importDefault(decodeDataXml);
exports.xmlDecodeTree = decode_data_xml_1.default;
var decode_codepoint_1 = __importDefault(decode_codepoint);
var BinTrieFlags;
(function (BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["HAS_VALUE"] = 32768] = "HAS_VALUE";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 32512] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["MULTI_BYTE"] = 128] = "MULTI_BYTE";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})(BinTrieFlags = exports.BinTrieFlags || (exports.BinTrieFlags = {}));
exports.JUMP_OFFSET_BASE = 48 /* ZERO */ - 1;
function getDecoder(decodeTree) {
    return function decodeHTMLBinary(str, strict) {
        var ret = "";
        var lastIdx = 0;
        var strIdx = 0;
        while ((strIdx = str.indexOf("&", strIdx)) >= 0) {
            ret += str.slice(lastIdx, strIdx);
            lastIdx = strIdx;
            // Skip the "&"
            strIdx += 1;
            // If we have a numeric entity, handle this separately.
            if (str.charCodeAt(strIdx) === 35 /* NUM */) {
                // Skip the leading "&#". For hex entities, also skip the leading "x".
                var start = strIdx + 1;
                var base = 10;
                var cp = str.charCodeAt(start);
                if ((cp | 32 /* To_LOWER_BIT */) === 120 /* LOWER_X */) {
                    base = 16;
                    strIdx += 1;
                    start += 1;
                }
                while (((cp = str.charCodeAt(++strIdx)) >= 48 /* ZERO */ &&
                    cp <= 57 /* NINE */) ||
                    (base === 16 &&
                        (cp | 32 /* To_LOWER_BIT */) >= 97 /* LOWER_A */ &&
                        (cp | 32 /* To_LOWER_BIT */) <= 102 /* LOWER_F */))
                    ;
                if (start !== strIdx) {
                    var entity = str.substring(start, strIdx);
                    var parsed = parseInt(entity, base);
                    if (str.charCodeAt(strIdx) === 59 /* SEMI */) {
                        strIdx += 1;
                    }
                    else if (strict) {
                        continue;
                    }
                    ret += decode_codepoint_1.default(parsed);
                    lastIdx = strIdx;
                }
                continue;
            }
            var result = null;
            var excess = 1;
            var treeIdx = 0;
            var current = decodeTree[treeIdx];
            for (; strIdx < str.length; strIdx++, excess++) {
                treeIdx = determineBranch(decodeTree, current, treeIdx + 1, str.charCodeAt(strIdx));
                if (treeIdx < 0)
                    break;
                current = decodeTree[treeIdx];
                // If the branch is a value, store it and continue
                if (current & BinTrieFlags.HAS_VALUE) {
                    // If we have a legacy entity while parsing strictly, just skip the number of bytes
                    if (strict && str.charCodeAt(strIdx) !== 59 /* SEMI */) {
                        // No need to consider multi-byte values, as the legacy entity is always a single byte
                        treeIdx += 1;
                    }
                    else {
                        // If this is a surrogate pair, combine the higher bits from the node with the next byte
                        result =
                            current & BinTrieFlags.MULTI_BYTE
                                ? String.fromCharCode(decodeTree[++treeIdx], decodeTree[++treeIdx])
                                : String.fromCharCode(decodeTree[++treeIdx]);
                        excess = 0;
                    }
                }
            }
            if (result != null) {
                ret += result;
                lastIdx = strIdx - excess + 1;
            }
        }
        return ret + str.slice(lastIdx);
    };
}
function determineBranch(decodeTree, current, nodeIdx, char) {
    if (current <= 128) {
        return char === current ? nodeIdx : -1;
    }
    var branchCount = (current & BinTrieFlags.BRANCH_LENGTH) >> 8;
    if (branchCount === 0) {
        return -1;
    }
    if (branchCount === 1) {
        return char === decodeTree[nodeIdx] ? nodeIdx + 1 : -1;
    }
    var jumpOffset = current & BinTrieFlags.JUMP_TABLE;
    if (jumpOffset) {
        var value = char - exports.JUMP_OFFSET_BASE - jumpOffset;
        return value < 0 || value > branchCount
            ? -1
            : decodeTree[nodeIdx + value] - 1;
    }
    // Binary search for the character.
    var lo = nodeIdx;
    var hi = lo + branchCount - 1;
    while (lo <= hi) {
        var mid = (lo + hi) >>> 1;
        var midVal = decodeTree[mid];
        if (midVal < char) {
            lo = mid + 1;
        }
        else if (midVal > char) {
            hi = mid - 1;
        }
        else {
            return decodeTree[mid + branchCount];
        }
    }
    return -1;
}
exports.determineBranch = determineBranch;
var htmlDecoder = getDecoder(decode_data_html_1.default);
var xmlDecoder = getDecoder(decode_data_xml_1.default);
function decodeHTML(str) {
    return htmlDecoder(str, false);
}
exports.decodeHTML = decodeHTML;
function decodeHTMLStrict(str) {
    return htmlDecoder(str, true);
}
exports.decodeHTMLStrict = decodeHTMLStrict;
function decodeXML(str) {
    return xmlDecoder(str, true);
}
exports.decodeXML = decodeXML;
}(decode));

var __importDefault$1 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Tokenizer$1, "__esModule", { value: true });
var decode_codepoint_1 = __importDefault$1(decode_codepoint);
var decode_1 = decode;
function isWhitespace(c) {
    return (c === 32 /* Space */ ||
        c === 10 /* NewLine */ ||
        c === 9 /* Tab */ ||
        c === 12 /* FormFeed */ ||
        c === 13 /* CarriageReturn */);
}
function isEndOfTagSection(c) {
    return c === 47 /* Slash */ || c === 62 /* Gt */ || isWhitespace(c);
}
function isNumber(c) {
    return c >= 48 /* Zero */ && c <= 57 /* Nine */;
}
function isASCIIAlpha(c) {
    return ((c >= 97 /* LowerA */ && c <= 122 /* LowerZ */) ||
        (c >= 65 /* UpperA */ && c <= 90 /* UpperZ */));
}
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */
var Sequences = {
    Cdata: new Uint16Array([0x43, 0x44, 0x41, 0x54, 0x41, 0x5b]),
    CdataEnd: new Uint16Array([0x5d, 0x5d, 0x3e]),
    CommentEnd: new Uint16Array([0x2d, 0x2d, 0x3e]),
    ScriptEnd: new Uint16Array([
        0x3c, 0x2f, 0x73, 0x63, 0x72, 0x69, 0x70, 0x74,
    ]),
    StyleEnd: new Uint16Array([0x3c, 0x2f, 0x73, 0x74, 0x79, 0x6c, 0x65]),
    TitleEnd: new Uint16Array([0x3c, 0x2f, 0x74, 0x69, 0x74, 0x6c, 0x65]), // `</title`
};
var Tokenizer = /** @class */ (function () {
    function Tokenizer(_a, cbs) {
        var _b = _a.xmlMode, xmlMode = _b === void 0 ? false : _b, _c = _a.decodeEntities, decodeEntities = _c === void 0 ? true : _c;
        this.cbs = cbs;
        /** The current state the tokenizer is in. */
        this._state = 1 /* Text */;
        /** The read buffer. */
        this.buffer = "";
        /** The beginning of the section that is currently being read. */
        this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */
        this._index = 0;
        /**
         * Data that has already been processed will be removed from the buffer occasionally.
         * `_bufferOffset` keeps track of how many characters have been removed, to make sure position information is accurate.
         */
        this.bufferOffset = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */
        this.baseState = 1 /* Text */;
        /** For special parsing behavior inside of script and style tags. */
        this.isSpecial = false;
        /** Indicates whether the tokenizer has been paused. */
        this.running = true;
        /** Indicates whether the tokenizer has finished running / `.end` has been called. */
        this.ended = false;
        this.sequenceIndex = 0;
        this.trieIndex = 0;
        this.trieCurrent = 0;
        this.trieResult = null;
        this.entityExcess = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityTrie = xmlMode ? decode_1.xmlDecodeTree : decode_1.htmlDecodeTree;
    }
    Tokenizer.prototype.reset = function () {
        this._state = 1 /* Text */;
        this.buffer = "";
        this.sectionStart = 0;
        this._index = 0;
        this.bufferOffset = 0;
        this.baseState = 1 /* Text */;
        this.currentSequence = undefined;
        this.running = true;
        this.ended = false;
    };
    Tokenizer.prototype.write = function (chunk) {
        if (this.ended)
            return this.cbs.onerror(Error(".write() after done!"));
        this.buffer += chunk;
        this.parse();
    };
    Tokenizer.prototype.end = function (chunk) {
        if (this.ended)
            return this.cbs.onerror(Error(".end() after done!"));
        if (chunk)
            this.write(chunk);
        this.ended = true;
        if (this.running)
            this.finish();
    };
    Tokenizer.prototype.pause = function () {
        this.running = false;
    };
    Tokenizer.prototype.resume = function () {
        this.running = true;
        if (this._index < this.buffer.length) {
            this.parse();
        }
        if (this.ended) {
            this.finish();
        }
    };
    /**
     * The start of the current section.
     */
    Tokenizer.prototype.getAbsoluteSectionStart = function () {
        return this.sectionStart + this.bufferOffset;
    };
    /**
     * The current index within all of the written data.
     */
    Tokenizer.prototype.getAbsoluteIndex = function () {
        return this.bufferOffset + this._index;
    };
    Tokenizer.prototype.stateText = function (c) {
        if (c === 60 /* Lt */ ||
            (!this.decodeEntities && this.fastForwardTo(60 /* Lt */))) {
            if (this._index > this.sectionStart) {
                this.cbs.ontext(this.getSection());
            }
            this._state = 2 /* BeforeTagName */;
            this.sectionStart = this._index;
        }
        else if (this.decodeEntities && c === 38 /* Amp */) {
            this._state = 25 /* BeforeEntity */;
        }
    };
    Tokenizer.prototype.stateSpecialStartSequence = function (c) {
        var isEnd = this.sequenceIndex === this.currentSequence.length;
        var isMatch = isEnd
            ? // If we are at the end of the sequence, make sure the tag name has ended
                isEndOfTagSection(c)
            : // Otherwise, do a case-insensitive comparison
                (c | 0x20) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) {
            this.isSpecial = false;
        }
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this._state = 3 /* InTagName */;
        this.stateInTagName(c);
    };
    /** Look for an end tag. For <title> tags, also decode entities. */
    Tokenizer.prototype.stateInSpecialTag = function (c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === 62 /* Gt */ || isWhitespace(c)) {
                var endOfText = this._index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    // Spoof the index so that reported locations match up.
                    var actualIndex = this._index;
                    this._index = endOfText;
                    this.cbs.ontext(this.getSection());
                    this._index = actualIndex;
                }
                this.isSpecial = false;
                this.sectionStart = endOfText + 2; // Skip over the `</`
                this.stateInClosingTagName(c);
                return; // We are done; skip the rest of the function.
            }
            this.sequenceIndex = 0;
        }
        if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) {
            this.sequenceIndex += 1;
        }
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === Sequences.TitleEnd) {
                // We have to parse entities in <title> tags.
                if (this.decodeEntities && c === 38 /* Amp */) {
                    this._state = 25 /* BeforeEntity */;
                }
            }
            else if (this.fastForwardTo(60 /* Lt */)) {
                // Outside of <title> tags, we can fast-forward.
                this.sequenceIndex = 1;
            }
        }
        else {
            // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
            this.sequenceIndex = Number(c === 60 /* Lt */);
        }
    };
    Tokenizer.prototype.stateCDATASequence = function (c) {
        if (c === Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === Sequences.Cdata.length) {
                this._state = 21 /* InCommentLike */;
                this.currentSequence = Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this._index + 1;
            }
        }
        else {
            this.sequenceIndex = 0;
            this._state = 16 /* InDeclaration */;
            this.stateInDeclaration(c); // Reconsume the character
        }
    };
    /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */
    Tokenizer.prototype.fastForwardTo = function (c) {
        while (++this._index < this.buffer.length) {
            if (this.buffer.charCodeAt(this._index) === c) {
                return true;
            }
        }
        /*
         * We increment the index at the end of the `parse` loop,
         * so set it to `buffer.length - 1` here.
         *
         * TODO: Refactor `parse` to increment index before calling states.
         */
        this._index = this.buffer.length - 1;
        return false;
    };
    /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */
    Tokenizer.prototype.stateInCommentLike = function (c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                // Remove 2 trailing chars
                var section = this.buffer.slice(this.sectionStart, this._index - 2);
                if (this.currentSequence === Sequences.CdataEnd) {
                    this.cbs.oncdata(section);
                }
                else {
                    this.cbs.oncomment(section);
                }
                this.sequenceIndex = 0;
                this.sectionStart = this._index + 1;
                this._state = 1 /* Text */;
            }
        }
        else if (this.sequenceIndex === 0) {
            // Fast-forward to the first character of the sequence
            if (this.fastForwardTo(this.currentSequence[0])) {
                this.sequenceIndex = 1;
            }
        }
        else if (c !== this.currentSequence[this.sequenceIndex - 1]) {
            // Allow long sequences, eg. --->, ]]]>
            this.sequenceIndex = 0;
        }
    };
    /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */
    Tokenizer.prototype.isTagStartChar = function (c) {
        return this.xmlMode ? !isEndOfTagSection(c) : isASCIIAlpha(c);
    };
    Tokenizer.prototype.startSpecial = function (sequence, offset) {
        this.isSpecial = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
        this._state = 23 /* SpecialStartSequence */;
    };
    Tokenizer.prototype.stateBeforeTagName = function (c) {
        if (c === 33 /* ExclamationMark */) {
            this._state = 15 /* BeforeDeclaration */;
            this.sectionStart = this._index + 1;
        }
        else if (c === 63 /* Questionmark */) {
            this._state = 17 /* InProcessingInstruction */;
            this.sectionStart = this._index + 1;
        }
        else if (this.isTagStartChar(c)) {
            var lower = c | 0x20;
            this.sectionStart = this._index;
            if (!this.xmlMode && lower === Sequences.TitleEnd[2]) {
                this.startSpecial(Sequences.TitleEnd, 3);
            }
            else {
                this._state =
                    !this.xmlMode && lower === Sequences.ScriptEnd[2]
                        ? 22 /* BeforeSpecialS */
                        : 3 /* InTagName */;
            }
        }
        else if (c === 47 /* Slash */) {
            this._state = 5 /* BeforeClosingTagName */;
        }
        else {
            this._state = 1 /* Text */;
            this.stateText(c);
        }
    };
    Tokenizer.prototype.stateInTagName = function (c) {
        if (isEndOfTagSection(c)) {
            this.cbs.onopentagname(this.getSection());
            this.sectionStart = -1;
            this._state = 8 /* BeforeAttributeName */;
            this.stateBeforeAttributeName(c);
        }
    };
    Tokenizer.prototype.stateBeforeClosingTagName = function (c) {
        if (isWhitespace(c)) ;
        else if (c === 62 /* Gt */) {
            this._state = 1 /* Text */;
        }
        else {
            this._state = this.isTagStartChar(c)
                ? 6 /* InClosingTagName */
                : 20 /* InSpecialComment */;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateInClosingTagName = function (c) {
        if (c === 62 /* Gt */ || isWhitespace(c)) {
            this.cbs.onclosetag(this.getSection());
            this.sectionStart = -1;
            this._state = 7 /* AfterClosingTagName */;
            this.stateAfterClosingTagName(c);
        }
    };
    Tokenizer.prototype.stateAfterClosingTagName = function (c) {
        // Skip everything until ">"
        if (c === 62 /* Gt */ || this.fastForwardTo(62 /* Gt */)) {
            this._state = 1 /* Text */;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateBeforeAttributeName = function (c) {
        if (c === 62 /* Gt */) {
            this.cbs.onopentagend();
            if (this.isSpecial) {
                this._state = 24 /* InSpecialTag */;
                this.sequenceIndex = 0;
            }
            else {
                this._state = 1 /* Text */;
            }
            this.baseState = this._state;
            this.sectionStart = this._index + 1;
        }
        else if (c === 47 /* Slash */) {
            this._state = 4 /* InSelfClosingTag */;
        }
        else if (!isWhitespace(c)) {
            this._state = 9 /* InAttributeName */;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateInSelfClosingTag = function (c) {
        if (c === 62 /* Gt */) {
            this.cbs.onselfclosingtag();
            this._state = 1 /* Text */;
            this.baseState = 1 /* Text */;
            this.sectionStart = this._index + 1;
            this.isSpecial = false; // Reset special state, in case of self-closing special tags
        }
        else if (!isWhitespace(c)) {
            this._state = 8 /* BeforeAttributeName */;
            this.stateBeforeAttributeName(c);
        }
    };
    Tokenizer.prototype.stateInAttributeName = function (c) {
        if (c === 61 /* Eq */ || isEndOfTagSection(c)) {
            this.cbs.onattribname(this.getSection());
            this.sectionStart = -1;
            this._state = 10 /* AfterAttributeName */;
            this.stateAfterAttributeName(c);
        }
    };
    Tokenizer.prototype.stateAfterAttributeName = function (c) {
        if (c === 61 /* Eq */) {
            this._state = 11 /* BeforeAttributeValue */;
        }
        else if (c === 47 /* Slash */ || c === 62 /* Gt */) {
            this.cbs.onattribend(undefined);
            this._state = 8 /* BeforeAttributeName */;
            this.stateBeforeAttributeName(c);
        }
        else if (!isWhitespace(c)) {
            this.cbs.onattribend(undefined);
            this._state = 9 /* InAttributeName */;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateBeforeAttributeValue = function (c) {
        if (c === 34 /* DoubleQuote */) {
            this._state = 12 /* InAttributeValueDq */;
            this.sectionStart = this._index + 1;
        }
        else if (c === 39 /* SingleQuote */) {
            this._state = 13 /* InAttributeValueSq */;
            this.sectionStart = this._index + 1;
        }
        else if (!isWhitespace(c)) {
            this.sectionStart = this._index;
            this._state = 14 /* InAttributeValueNq */;
            this.stateInAttributeValueNoQuotes(c); // Reconsume token
        }
    };
    Tokenizer.prototype.handleInAttributeValue = function (c, quote) {
        if (c === quote ||
            (!this.decodeEntities && this.fastForwardTo(quote))) {
            this.cbs.onattribdata(this.getSection());
            this.sectionStart = -1;
            this.cbs.onattribend(String.fromCharCode(quote));
            this._state = 8 /* BeforeAttributeName */;
        }
        else if (this.decodeEntities && c === 38 /* Amp */) {
            this.baseState = this._state;
            this._state = 25 /* BeforeEntity */;
        }
    };
    Tokenizer.prototype.stateInAttributeValueDoubleQuotes = function (c) {
        this.handleInAttributeValue(c, 34 /* DoubleQuote */);
    };
    Tokenizer.prototype.stateInAttributeValueSingleQuotes = function (c) {
        this.handleInAttributeValue(c, 39 /* SingleQuote */);
    };
    Tokenizer.prototype.stateInAttributeValueNoQuotes = function (c) {
        if (isWhitespace(c) || c === 62 /* Gt */) {
            this.cbs.onattribdata(this.getSection());
            this.sectionStart = -1;
            this.cbs.onattribend(null);
            this._state = 8 /* BeforeAttributeName */;
            this.stateBeforeAttributeName(c);
        }
        else if (this.decodeEntities && c === 38 /* Amp */) {
            this.baseState = this._state;
            this._state = 25 /* BeforeEntity */;
        }
    };
    Tokenizer.prototype.stateBeforeDeclaration = function (c) {
        if (c === 91 /* OpeningSquareBracket */) {
            this._state = 19 /* CDATASequence */;
            this.sequenceIndex = 0;
        }
        else {
            this._state =
                c === 45 /* Dash */
                    ? 18 /* BeforeComment */
                    : 16 /* InDeclaration */;
        }
    };
    Tokenizer.prototype.stateInDeclaration = function (c) {
        if (c === 62 /* Gt */ || this.fastForwardTo(62 /* Gt */)) {
            this.cbs.ondeclaration(this.getSection());
            this._state = 1 /* Text */;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateInProcessingInstruction = function (c) {
        if (c === 62 /* Gt */ || this.fastForwardTo(62 /* Gt */)) {
            this.cbs.onprocessinginstruction(this.getSection());
            this._state = 1 /* Text */;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateBeforeComment = function (c) {
        if (c === 45 /* Dash */) {
            this._state = 21 /* InCommentLike */;
            this.currentSequence = Sequences.CommentEnd;
            // Allow short comments (eg. <!-->)
            this.sequenceIndex = 2;
            this.sectionStart = this._index + 1;
        }
        else {
            this._state = 16 /* InDeclaration */;
        }
    };
    Tokenizer.prototype.stateInSpecialComment = function (c) {
        if (c === 62 /* Gt */ || this.fastForwardTo(62 /* Gt */)) {
            this.cbs.oncomment(this.getSection());
            this._state = 1 /* Text */;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateBeforeSpecialS = function (c) {
        var lower = c | 0x20;
        if (lower === Sequences.ScriptEnd[3]) {
            this.startSpecial(Sequences.ScriptEnd, 4);
        }
        else if (lower === Sequences.StyleEnd[3]) {
            this.startSpecial(Sequences.StyleEnd, 4);
        }
        else {
            this._state = 3 /* InTagName */;
            this.stateInTagName(c); // Consume the token again
        }
    };
    Tokenizer.prototype.stateBeforeEntity = function (c) {
        // Start excess with 1 to include the '&'
        this.entityExcess = 1;
        if (c === 35 /* Num */) {
            this._state = 26 /* BeforeNumericEntity */;
        }
        else if (c === 38 /* Amp */) ;
        else {
            this.trieIndex = 0;
            this.trieCurrent = this.entityTrie[0];
            this.trieResult = null;
            this._state = 27 /* InNamedEntity */;
            this.stateInNamedEntity(c);
        }
    };
    Tokenizer.prototype.stateInNamedEntity = function (c) {
        this.entityExcess += 1;
        this.trieIndex = (0, decode_1.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
        if (this.trieIndex < 0) {
            this.emitNamedEntity();
            this._index--;
            return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        // If the branch is a value, store it and continue
        if (this.trieCurrent & decode_1.BinTrieFlags.HAS_VALUE) {
            // If we have a legacy entity while parsing strictly, just skip the number of bytes
            if (!this.allowLegacyEntity() && c !== 59 /* Semi */) {
                // No need to consider multi-byte values, as the legacy entity is always a single byte
                this.trieIndex += 1;
            }
            else {
                // Add 1 as we have already incremented the excess
                var entityStart = this._index - this.entityExcess + 1;
                if (entityStart > this.sectionStart) {
                    this.emitPartial(this.buffer.substring(this.sectionStart, entityStart));
                }
                // If this is a surrogate pair, combine the higher bits from the node with the next byte
                this.trieResult =
                    this.trieCurrent & decode_1.BinTrieFlags.MULTI_BYTE
                        ? String.fromCharCode(this.entityTrie[++this.trieIndex], this.entityTrie[++this.trieIndex])
                        : String.fromCharCode(this.entityTrie[++this.trieIndex]);
                this.entityExcess = 0;
                this.sectionStart = this._index + 1;
            }
        }
    };
    Tokenizer.prototype.emitNamedEntity = function () {
        if (this.trieResult) {
            this.emitPartial(this.trieResult);
        }
        this._state = this.baseState;
    };
    Tokenizer.prototype.stateBeforeNumericEntity = function (c) {
        if ((c | 0x20) === 120 /* LowerX */) {
            this.entityExcess++;
            this._state = 29 /* InHexEntity */;
        }
        else {
            this._state = 28 /* InNumericEntity */;
            this.stateInNumericEntity(c);
        }
    };
    Tokenizer.prototype.decodeNumericEntity = function (base, strict) {
        var entityStart = this._index - this.entityExcess - 1;
        var numberStart = entityStart + 2 + (base >> 4);
        if (numberStart !== this._index) {
            // Emit leading data if any
            if (entityStart > this.sectionStart) {
                this.emitPartial(this.buffer.substring(this.sectionStart, entityStart));
            }
            // Parse entity
            var entity = this.buffer.substring(numberStart, this._index);
            var parsed = parseInt(entity, base);
            this.emitPartial((0, decode_codepoint_1.default)(parsed));
            this.sectionStart = this._index + Number(strict);
        }
        this._state = this.baseState;
    };
    Tokenizer.prototype.stateInNumericEntity = function (c) {
        if (c === 59 /* Semi */) {
            this.decodeNumericEntity(10, true);
        }
        else if (!isNumber(c)) {
            if (this.allowLegacyEntity()) {
                this.decodeNumericEntity(10, false);
            }
            else {
                this._state = this.baseState;
            }
            this._index--;
        }
        else {
            this.entityExcess++;
        }
    };
    Tokenizer.prototype.stateInHexEntity = function (c) {
        if (c === 59 /* Semi */) {
            this.decodeNumericEntity(16, true);
        }
        else if ((c < 97 /* LowerA */ || c > 102 /* LowerF */) &&
            (c < 65 /* UpperA */ || c > 70 /* UpperF */) &&
            !isNumber(c)) {
            if (this.allowLegacyEntity()) {
                this.decodeNumericEntity(16, false);
            }
            else {
                this._state = this.baseState;
            }
            this._index--;
        }
        else {
            this.entityExcess++;
        }
    };
    Tokenizer.prototype.allowLegacyEntity = function () {
        return (!this.xmlMode &&
            (this.baseState === 1 /* Text */ ||
                this.baseState === 24 /* InSpecialTag */));
    };
    /**
     * Remove data that has already been consumed from the buffer.
     */
    Tokenizer.prototype.cleanup = function () {
        // If we are inside of text, emit what we already have.
        if (this.running &&
            this.sectionStart !== this._index &&
            (this._state === 1 /* Text */ ||
                (this._state === 24 /* InSpecialTag */ &&
                    this.sequenceIndex === 0))) {
            // TODO: We could emit attribute data here as well.
            this.cbs.ontext(this.buffer.substr(this.sectionStart));
            this.sectionStart = this._index;
        }
        var start = this.sectionStart < 0 ? this._index : this.sectionStart;
        this.buffer =
            start === this.buffer.length ? "" : this.buffer.substr(start);
        this._index -= start;
        this.bufferOffset += start;
        if (this.sectionStart > 0) {
            this.sectionStart = 0;
        }
    };
    Tokenizer.prototype.shouldContinue = function () {
        return this._index < this.buffer.length && this.running;
    };
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */
    Tokenizer.prototype.parse = function () {
        while (this.shouldContinue()) {
            var c = this.buffer.charCodeAt(this._index);
            if (this._state === 1 /* Text */) {
                this.stateText(c);
            }
            else if (this._state === 23 /* SpecialStartSequence */) {
                this.stateSpecialStartSequence(c);
            }
            else if (this._state === 24 /* InSpecialTag */) {
                this.stateInSpecialTag(c);
            }
            else if (this._state === 19 /* CDATASequence */) {
                this.stateCDATASequence(c);
            }
            else if (this._state === 12 /* InAttributeValueDq */) {
                this.stateInAttributeValueDoubleQuotes(c);
            }
            else if (this._state === 9 /* InAttributeName */) {
                this.stateInAttributeName(c);
            }
            else if (this._state === 21 /* InCommentLike */) {
                this.stateInCommentLike(c);
            }
            else if (this._state === 20 /* InSpecialComment */) {
                this.stateInSpecialComment(c);
            }
            else if (this._state === 8 /* BeforeAttributeName */) {
                this.stateBeforeAttributeName(c);
            }
            else if (this._state === 3 /* InTagName */) {
                this.stateInTagName(c);
            }
            else if (this._state === 6 /* InClosingTagName */) {
                this.stateInClosingTagName(c);
            }
            else if (this._state === 2 /* BeforeTagName */) {
                this.stateBeforeTagName(c);
            }
            else if (this._state === 10 /* AfterAttributeName */) {
                this.stateAfterAttributeName(c);
            }
            else if (this._state === 13 /* InAttributeValueSq */) {
                this.stateInAttributeValueSingleQuotes(c);
            }
            else if (this._state === 11 /* BeforeAttributeValue */) {
                this.stateBeforeAttributeValue(c);
            }
            else if (this._state === 5 /* BeforeClosingTagName */) {
                this.stateBeforeClosingTagName(c);
            }
            else if (this._state === 7 /* AfterClosingTagName */) {
                this.stateAfterClosingTagName(c);
            }
            else if (this._state === 22 /* BeforeSpecialS */) {
                this.stateBeforeSpecialS(c);
            }
            else if (this._state === 14 /* InAttributeValueNq */) {
                this.stateInAttributeValueNoQuotes(c);
            }
            else if (this._state === 4 /* InSelfClosingTag */) {
                this.stateInSelfClosingTag(c);
            }
            else if (this._state === 16 /* InDeclaration */) {
                this.stateInDeclaration(c);
            }
            else if (this._state === 15 /* BeforeDeclaration */) {
                this.stateBeforeDeclaration(c);
            }
            else if (this._state === 18 /* BeforeComment */) {
                this.stateBeforeComment(c);
            }
            else if (this._state === 17 /* InProcessingInstruction */) {
                this.stateInProcessingInstruction(c);
            }
            else if (this._state === 27 /* InNamedEntity */) {
                this.stateInNamedEntity(c);
            }
            else if (this._state === 25 /* BeforeEntity */) {
                this.stateBeforeEntity(c);
            }
            else if (this._state === 29 /* InHexEntity */) {
                this.stateInHexEntity(c);
            }
            else if (this._state === 28 /* InNumericEntity */) {
                this.stateInNumericEntity(c);
            }
            else {
                // `this._state === State.BeforeNumericEntity`
                this.stateBeforeNumericEntity(c);
            }
            this._index++;
        }
        this.cleanup();
    };
    Tokenizer.prototype.finish = function () {
        if (this._state === 27 /* InNamedEntity */) {
            this.emitNamedEntity();
        }
        // If there is remaining data, emit it in a reasonable way
        if (this.sectionStart < this._index) {
            this.handleTrailingData();
        }
        this.cbs.onend();
    };
    /** Handle any trailing data. */
    Tokenizer.prototype.handleTrailingData = function () {
        var data = this.buffer.substr(this.sectionStart);
        if (this._state === 21 /* InCommentLike */) {
            if (this.currentSequence === Sequences.CdataEnd) {
                this.cbs.oncdata(data);
            }
            else {
                this.cbs.oncomment(data);
            }
        }
        else if (this._state === 28 /* InNumericEntity */ &&
            this.allowLegacyEntity()) {
            this.decodeNumericEntity(10, false);
            // All trailing data will have been consumed
        }
        else if (this._state === 29 /* InHexEntity */ &&
            this.allowLegacyEntity()) {
            this.decodeNumericEntity(16, false);
            // All trailing data will have been consumed
        }
        else if (this._state === 3 /* InTagName */ ||
            this._state === 8 /* BeforeAttributeName */ ||
            this._state === 11 /* BeforeAttributeValue */ ||
            this._state === 10 /* AfterAttributeName */ ||
            this._state === 9 /* InAttributeName */ ||
            this._state === 13 /* InAttributeValueSq */ ||
            this._state === 12 /* InAttributeValueDq */ ||
            this._state === 14 /* InAttributeValueNq */ ||
            this._state === 6 /* InClosingTagName */) ;
        else {
            this.cbs.ontext(data);
        }
    };
    Tokenizer.prototype.getSection = function () {
        return this.buffer.substring(this.sectionStart, this._index);
    };
    Tokenizer.prototype.emitPartial = function (value) {
        if (this.baseState !== 1 /* Text */ &&
            this.baseState !== 24 /* InSpecialTag */) {
            this.cbs.onattribdata(value);
        }
        else {
            this.cbs.ontext(value);
        }
    };
    return Tokenizer;
}());
Tokenizer$1.default = Tokenizer;

var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Parser$2, "__esModule", { value: true });
Parser$2.Parser = void 0;
var Tokenizer_1 = __importDefault(Tokenizer$1);
var formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea",
]);
var pTag = new Set(["p"]);
var tableSectionTags = new Set(["thead", "tbody"]);
var ddtTags = new Set(["dd", "dt"]);
var rtpTags = new Set(["rt", "rp"]);
var openImpliesClose = new Map([
    ["tr", new Set(["tr", "th", "td"])],
    ["th", new Set(["th"])],
    ["td", new Set(["thead", "th", "td"])],
    ["body", new Set(["head", "link", "script"])],
    ["li", new Set(["li"])],
    ["p", pTag],
    ["h1", pTag],
    ["h2", pTag],
    ["h3", pTag],
    ["h4", pTag],
    ["h5", pTag],
    ["h6", pTag],
    ["select", formTags],
    ["input", formTags],
    ["output", formTags],
    ["button", formTags],
    ["datalist", formTags],
    ["textarea", formTags],
    ["option", new Set(["option"])],
    ["optgroup", new Set(["optgroup", "option"])],
    ["dd", ddtTags],
    ["dt", ddtTags],
    ["address", pTag],
    ["article", pTag],
    ["aside", pTag],
    ["blockquote", pTag],
    ["details", pTag],
    ["div", pTag],
    ["dl", pTag],
    ["fieldset", pTag],
    ["figcaption", pTag],
    ["figure", pTag],
    ["footer", pTag],
    ["form", pTag],
    ["header", pTag],
    ["hr", pTag],
    ["main", pTag],
    ["nav", pTag],
    ["ol", pTag],
    ["pre", pTag],
    ["section", pTag],
    ["table", pTag],
    ["ul", pTag],
    ["rt", rtpTags],
    ["rp", rtpTags],
    ["tbody", tableSectionTags],
    ["tfoot", tableSectionTags],
]);
var voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr",
]);
var foreignContextElements = new Set(["math", "svg"]);
var htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title",
]);
var reNameEnd = /\s|\//;
var Parser$1 = /** @class */ (function () {
    function Parser(cbs, options) {
        if (options === void 0) { options = {}; }
        var _a, _b, _c, _d, _e;
        this.options = options;
        /** The start index of the last event. */
        this.startIndex = 0;
        /** The end index of the last event. */
        this.endIndex = 0;
        /**
         * Store the start index of the current open tag,
         * so we can update the start index for attributes.
         */
        this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.foreignContext = [];
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
        this.lowerCaseAttributeNames =
            (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : Tokenizer_1.default)(this.options, this);
        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 ? void 0 : _e.call(_d, this);
    }
    // Tokenizer event handlers
    /** @internal */
    Parser.prototype.ontext = function (data) {
        var _a, _b;
        var idx = this.tokenizer.getAbsoluteIndex();
        this.endIndex = idx - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, data);
        this.startIndex = idx;
    };
    Parser.prototype.isVoidElement = function (name) {
        return !this.options.xmlMode && voidElements.has(name);
    };
    /** @internal */
    Parser.prototype.onopentagname = function (name) {
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        this.emitOpenTag(name);
    };
    Parser.prototype.emitOpenTag = function (name) {
        var _a, _b, _c, _d;
        this.openTagStart = this.startIndex;
        this.tagname = name;
        var impliesClose = !this.options.xmlMode && openImpliesClose.get(name);
        if (impliesClose) {
            while (this.stack.length > 0 &&
                impliesClose.has(this.stack[this.stack.length - 1])) {
                var el = this.stack.pop();
                (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, el, true);
            }
        }
        if (!this.isVoidElement(name)) {
            this.stack.push(name);
            if (foreignContextElements.has(name)) {
                this.foreignContext.push(true);
            }
            else if (htmlIntegrationElements.has(name)) {
                this.foreignContext.push(false);
            }
        }
        (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 ? void 0 : _d.call(_c, name);
        if (this.cbs.onopentag)
            this.attribs = {};
    };
    Parser.prototype.endOpenTag = function (isImplied) {
        var _a, _b;
        this.startIndex = this.openTagStart;
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 ? void 0 : _b.call(_a, this.tagname, this.attribs, isImplied);
            this.attribs = null;
        }
        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) {
            this.cbs.onclosetag(this.tagname, true);
        }
        this.tagname = "";
    };
    /** @internal */
    Parser.prototype.onopentagend = function () {
        this.endOpenTag(false);
        // Set `startIndex` for next node
        this.startIndex = this.endIndex + 1;
    };
    /** @internal */
    Parser.prototype.onclosetag = function (name) {
        var _a, _b, _c, _d, _e, _f;
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        if (foreignContextElements.has(name) ||
            htmlIntegrationElements.has(name)) {
            this.foreignContext.pop();
        }
        if (!this.isVoidElement(name)) {
            var pos = this.stack.lastIndexOf(name);
            if (pos !== -1) {
                if (this.cbs.onclosetag) {
                    var count = this.stack.length - pos;
                    while (count--) {
                        // We know the stack has sufficient elements.
                        this.cbs.onclosetag(this.stack.pop(), count !== 0);
                    }
                }
                else
                    this.stack.length = pos;
            }
            else if (!this.options.xmlMode && name === "p") {
                this.emitOpenTag(name);
                this.closeCurrentTag(true);
            }
        }
        else if (!this.options.xmlMode && name === "br") {
            // We can't go through `emitOpenTag` here, as `br` would be implicitly closed.
            (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 ? void 0 : _b.call(_a, name);
            (_d = (_c = this.cbs).onopentag) === null || _d === void 0 ? void 0 : _d.call(_c, name, {}, true);
            (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 ? void 0 : _f.call(_e, name, false);
        }
        // Set `startIndex` for next node
        this.startIndex = this.endIndex + 1;
    };
    /** @internal */
    Parser.prototype.onselfclosingtag = function () {
        if (this.options.xmlMode ||
            this.options.recognizeSelfClosing ||
            this.foreignContext[this.foreignContext.length - 1]) {
            this.closeCurrentTag(false);
            // Set `startIndex` for next node
            this.startIndex = this.endIndex + 1;
        }
        else {
            // Ignore the fact that the tag is self-closing.
            this.onopentagend();
        }
    };
    Parser.prototype.closeCurrentTag = function (isOpenImplied) {
        var _a, _b;
        var name = this.tagname;
        this.endOpenTag(isOpenImplied);
        // Self-closing tags will be on the top of the stack
        if (this.stack[this.stack.length - 1] === name) {
            // If the opening tag isn't implied, the closing tag has to be implied.
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, name, !isOpenImplied);
            this.stack.pop();
        }
    };
    /** @internal */
    Parser.prototype.onattribname = function (name) {
        this.startIndex = this.tokenizer.getAbsoluteSectionStart();
        if (this.lowerCaseAttributeNames) {
            name = name.toLowerCase();
        }
        this.attribname = name;
    };
    /** @internal */
    Parser.prototype.onattribdata = function (value) {
        this.attribvalue += value;
    };
    /** @internal */
    Parser.prototype.onattribend = function (quote) {
        var _a, _b;
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 ? void 0 : _b.call(_a, this.attribname, this.attribvalue, quote);
        if (this.attribs &&
            !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) {
            this.attribs[this.attribname] = this.attribvalue;
        }
        this.attribname = "";
        this.attribvalue = "";
    };
    Parser.prototype.getInstructionName = function (value) {
        var idx = value.search(reNameEnd);
        var name = idx < 0 ? value : value.substr(0, idx);
        if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        return name;
    };
    /** @internal */
    Parser.prototype.ondeclaration = function (value) {
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        if (this.cbs.onprocessinginstruction) {
            var name_1 = this.getInstructionName(value);
            this.cbs.onprocessinginstruction("!" + name_1, "!" + value);
        }
        // Set `startIndex` for next node
        this.startIndex = this.endIndex + 1;
    };
    /** @internal */
    Parser.prototype.onprocessinginstruction = function (value) {
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        if (this.cbs.onprocessinginstruction) {
            var name_2 = this.getInstructionName(value);
            this.cbs.onprocessinginstruction("?" + name_2, "?" + value);
        }
        // Set `startIndex` for next node
        this.startIndex = this.endIndex + 1;
    };
    /** @internal */
    Parser.prototype.oncomment = function (value) {
        var _a, _b, _c, _d;
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 ? void 0 : _b.call(_a, value);
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 ? void 0 : _d.call(_c);
        // Set `startIndex` for next node
        this.startIndex = this.endIndex + 1;
    };
    /** @internal */
    Parser.prototype.oncdata = function (value) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        if (this.options.xmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 ? void 0 : _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 ? void 0 : _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 ? void 0 : _f.call(_e);
        }
        else {
            (_h = (_g = this.cbs).oncomment) === null || _h === void 0 ? void 0 : _h.call(_g, "[CDATA[" + value + "]]");
            (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 ? void 0 : _k.call(_j);
        }
        // Set `startIndex` for next node
        this.startIndex = this.endIndex + 1;
    };
    /** @internal */
    Parser.prototype.onerror = function (err) {
        var _a, _b;
        (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, err);
    };
    /** @internal */
    Parser.prototype.onend = function () {
        var _a, _b;
        if (this.cbs.onclosetag) {
            // Set the end index for all remaining tags
            this.endIndex = this.startIndex;
            for (var i = this.stack.length; i > 0; this.cbs.onclosetag(this.stack[--i], true))
                ;
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */
    Parser.prototype.reset = function () {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack = [];
        this.startIndex = 0;
        this.endIndex = 0;
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 ? void 0 : _d.call(_c, this);
    };
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */
    Parser.prototype.parseComplete = function (data) {
        this.reset();
        this.end(data);
    };
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */
    Parser.prototype.write = function (chunk) {
        this.tokenizer.write(chunk);
    };
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */
    Parser.prototype.end = function (chunk) {
        this.tokenizer.end(chunk);
    };
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */
    Parser.prototype.pause = function () {
        this.tokenizer.pause();
    };
    /**
     * Resumes parsing after `pause` was called.
     */
    Parser.prototype.resume = function () {
        this.tokenizer.resume();
    };
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */
    Parser.prototype.parseChunk = function (chunk) {
        this.write(chunk);
    };
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */
    Parser.prototype.done = function (chunk) {
        this.end(chunk);
    };
    return Parser;
}());
Parser$2.Parser = Parser$1;

var lib$1 = {};

var lib = {};

(function (exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
/** Types of elements found in htmlparser2's DOM */
var ElementType;
(function (ElementType) {
    /** Type for the root element of a document */
    ElementType["Root"] = "root";
    /** Type for Text */
    ElementType["Text"] = "text";
    /** Type for <? ... ?> */
    ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */
    ElementType["Comment"] = "comment";
    /** Type for <script> tags */
    ElementType["Script"] = "script";
    /** Type for <style> tags */
    ElementType["Style"] = "style";
    /** Type for Any tag */
    ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */
    ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */
    ElementType["Doctype"] = "doctype";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */
function isTag(elem) {
    return (elem.type === ElementType.Tag ||
        elem.type === ElementType.Script ||
        elem.type === ElementType.Style);
}
exports.isTag = isTag;
// Exports for backwards compatibility
/** Type for the root element of a document */
exports.Root = ElementType.Root;
/** Type for Text */
exports.Text = ElementType.Text;
/** Type for <? ... ?> */
exports.Directive = ElementType.Directive;
/** Type for <!-- ... --> */
exports.Comment = ElementType.Comment;
/** Type for <script> tags */
exports.Script = ElementType.Script;
/** Type for <style> tags */
exports.Style = ElementType.Style;
/** Type for Any tag */
exports.Tag = ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */
exports.CDATA = ElementType.CDATA;
/** Type for <!doctype ...> */
exports.Doctype = ElementType.Doctype;
}(lib));

var node = {};

var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(node, "__esModule", { value: true });
node.cloneNode = node.hasChildren = node.isDocument = node.isDirective = node.isComment = node.isText = node.isCDATA = node.isTag = node.Element = node.Document = node.NodeWithChildren = node.ProcessingInstruction = node.Comment = node.Text = node.DataNode = node.Node = void 0;
var domelementtype_1 = lib;
var nodeTypes = new Map([
    [domelementtype_1.ElementType.Tag, 1],
    [domelementtype_1.ElementType.Script, 1],
    [domelementtype_1.ElementType.Style, 1],
    [domelementtype_1.ElementType.Directive, 1],
    [domelementtype_1.ElementType.Text, 3],
    [domelementtype_1.ElementType.CDATA, 4],
    [domelementtype_1.ElementType.Comment, 8],
    [domelementtype_1.ElementType.Root, 9],
]);
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */
var Node$1 = /** @class */ (function () {
    /**
     *
     * @param type The type of the node.
     */
    function Node(type) {
        this.type = type;
        /** Parent of the node */
        this.parent = null;
        /** Previous sibling */
        this.prev = null;
        /** Next sibling */
        this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
        this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
        this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "nodeType", {
        // Read-only aliases
        /**
         * [DOM spec](https://dom.spec.whatwg.org/#dom-node-nodetype)-compatible
         * node {@link type}.
         */
        get: function () {
            var _a;
            return (_a = nodeTypes.get(this.type)) !== null && _a !== void 0 ? _a : 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.parent;
        },
        set: function (parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.prev;
        },
        set: function (prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.next;
        },
        set: function (next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */
    Node.prototype.cloneNode = function (recursive) {
        if (recursive === void 0) { recursive = false; }
        return cloneNode(this, recursive);
    };
    return Node;
}());
node.Node = Node$1;
/**
 * A node that contains some data.
 */
var DataNode = /** @class */ (function (_super) {
    __extends(DataNode, _super);
    /**
     * @param type The type of the node
     * @param data The content of the data node
     */
    function DataNode(type, data) {
        var _this = _super.call(this, type) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.data;
        },
        set: function (data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}(Node$1));
node.DataNode = DataNode;
/**
 * Text within the document.
 */
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text(data) {
        return _super.call(this, domelementtype_1.ElementType.Text, data) || this;
    }
    return Text;
}(DataNode));
node.Text = Text;
/**
 * Comments within the document.
 */
var Comment = /** @class */ (function (_super) {
    __extends(Comment, _super);
    function Comment(data) {
        return _super.call(this, domelementtype_1.ElementType.Comment, data) || this;
    }
    return Comment;
}(DataNode));
node.Comment = Comment;
/**
 * Processing instructions, including doc types.
 */
var ProcessingInstruction = /** @class */ (function (_super) {
    __extends(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, domelementtype_1.ElementType.Directive, data) || this;
        _this.name = name;
        return _this;
    }
    return ProcessingInstruction;
}(DataNode));
node.ProcessingInstruction = ProcessingInstruction;
/**
 * A `Node` that can have children.
 */
var NodeWithChildren = /** @class */ (function (_super) {
    __extends(NodeWithChildren, _super);
    /**
     * @param type Type of the node.
     * @param children Children of the node. Only certain node types can have children.
     */
    function NodeWithChildren(type, children) {
        var _this = _super.call(this, type) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function () {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        /** Last child of the node. */
        get: function () {
            return this.children.length > 0
                ? this.children[this.children.length - 1]
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.children;
        },
        set: function (children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}(Node$1));
node.NodeWithChildren = NodeWithChildren;
/**
 * The root node of the document.
 */
var Document = /** @class */ (function (_super) {
    __extends(Document, _super);
    function Document(children) {
        return _super.call(this, domelementtype_1.ElementType.Root, children) || this;
    }
    return Document;
}(NodeWithChildren));
node.Document = Document;
/**
 * An element within the DOM.
 */
var Element$1 = /** @class */ (function (_super) {
    __extends(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */
    function Element(name, attribs, children, type) {
        if (children === void 0) { children = []; }
        if (type === void 0) { type = name === "script"
            ? domelementtype_1.ElementType.Script
            : name === "style"
                ? domelementtype_1.ElementType.Style
                : domelementtype_1.ElementType.Tag; }
        var _this = _super.call(this, type, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        return _this;
    }
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.name;
        },
        set: function (name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function () {
            var _this = this;
            return Object.keys(this.attribs).map(function (name) {
                var _a, _b;
                return ({
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name],
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}(NodeWithChildren));
node.Element = Element$1;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */
function isTag(node) {
    return (0, domelementtype_1.isTag)(node);
}
node.isTag = isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */
function isCDATA(node) {
    return node.type === domelementtype_1.ElementType.CDATA;
}
node.isCDATA = isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */
function isText(node) {
    return node.type === domelementtype_1.ElementType.Text;
}
node.isText = isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */
function isComment(node) {
    return node.type === domelementtype_1.ElementType.Comment;
}
node.isComment = isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDirective(node) {
    return node.type === domelementtype_1.ElementType.Directive;
}
node.isDirective = isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDocument(node) {
    return node.type === domelementtype_1.ElementType.Root;
}
node.isDocument = isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `NodeWithChildren` (has children), `false` otherwise.
 */
function hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
node.hasChildren = hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */
function cloneNode(node, recursive) {
    if (recursive === void 0) { recursive = false; }
    var result;
    if (isText(node)) {
        result = new Text(node.data);
    }
    else if (isComment(node)) {
        result = new Comment(node.data);
    }
    else if (isTag(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_1 = new Element$1(node.name, __assign({}, node.attribs), children);
        children.forEach(function (child) { return (child.parent = clone_1); });
        if (node.namespace != null) {
            clone_1.namespace = node.namespace;
        }
        if (node["x-attribsNamespace"]) {
            clone_1["x-attribsNamespace"] = __assign({}, node["x-attribsNamespace"]);
        }
        if (node["x-attribsPrefix"]) {
            clone_1["x-attribsPrefix"] = __assign({}, node["x-attribsPrefix"]);
        }
        result = clone_1;
    }
    else if (isCDATA(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_2 = new NodeWithChildren(domelementtype_1.ElementType.CDATA, children);
        children.forEach(function (child) { return (child.parent = clone_2); });
        result = clone_2;
    }
    else if (isDocument(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_3 = new Document(children);
        children.forEach(function (child) { return (child.parent = clone_3); });
        if (node["x-mode"]) {
            clone_3["x-mode"] = node["x-mode"];
        }
        result = clone_3;
    }
    else if (isDirective(node)) {
        var instruction = new ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    }
    else {
        throw new Error("Not implemented yet: ".concat(node.type));
    }
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) {
        result.sourceCodeLocation = node.sourceCodeLocation;
    }
    return result;
}
node.cloneNode = cloneNode;
function cloneChildren(childs) {
    var children = childs.map(function (child) { return cloneNode(child, true); });
    for (var i = 1; i < children.length; i++) {
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomHandler = void 0;
var domelementtype_1 = lib;
var node_1 = node;
__exportStar(node, exports);
var reWhitespace = /\s+/g;
// Default options
var defaultOpts = {
    normalizeWhitespace: false,
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false,
};
var DomHandler = /** @class */ (function () {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */
    function DomHandler(callback, options, elementCB) {
        /** The elements of the DOM */
        this.dom = [];
        /** The root element for the DOM */
        this.root = new node_1.Document(this.dom);
        /** Indicated whether parsing has been completed. */
        this.done = false;
        /** Stack of open tags. */
        this.tagStack = [this.root];
        /** A data node that is still being written to. */
        this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */
        this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function (parser) {
        this.parser = parser;
    };
    // Resets the handler back to starting state
    DomHandler.prototype.onreset = function () {
        this.dom = [];
        this.root = new node_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
    };
    // Signals the handler that parsing is done
    DomHandler.prototype.onend = function () {
        if (this.done)
            return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function (error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function () {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) {
            elem.endIndex = this.parser.endIndex;
        }
        if (this.elementCB)
            this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function (name, attribs) {
        var type = this.options.xmlMode ? domelementtype_1.ElementType.Tag : undefined;
        var element = new node_1.Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function (data) {
        var normalizeWhitespace = this.options.normalizeWhitespace;
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
            if (normalizeWhitespace) {
                lastNode.data = (lastNode.data + data).replace(reWhitespace, " ");
            }
            else {
                lastNode.data += data;
            }
            if (this.options.withEndIndices) {
                lastNode.endIndex = this.parser.endIndex;
            }
        }
        else {
            if (normalizeWhitespace) {
                data = data.replace(reWhitespace, " ");
            }
            var node = new node_1.Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function (data) {
        if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new node_1.Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function () {
        var text = new node_1.Text("");
        var node = new node_1.NodeWithChildren(domelementtype_1.ElementType.CDATA, [text]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function (name, data) {
        var node = new node_1.ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function (error) {
        if (typeof this.callback === "function") {
            this.callback(error, this.dom);
        }
        else if (error) {
            throw error;
        }
    };
    DomHandler.prototype.addNode = function (node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) {
            node.startIndex = this.parser.startIndex;
        }
        if (this.options.withEndIndices) {
            node.endIndex = this.parser.endIndex;
        }
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}());
exports.DomHandler = DomHandler;
exports.default = DomHandler;
}(lib$1));

/**
 * Sets root parent to null.
 *
 * @param  {Array<Comment|Element|ProcessingInstruction|Text>} nodes
 * @return {Array<Comment|Element|ProcessingInstruction|Text>}
 */

function unsetRootParent$1(nodes) {
  for (var index = 0, len = nodes.length; index < len; index++) {
    var node = nodes[index];
    node.parent = null;
  }
  return nodes;
}

var utilities = {
  unsetRootParent: unsetRootParent$1
};

var Parser = Parser$2.Parser;
var DomHandler = lib$1.DomHandler;

var unsetRootParent = utilities.unsetRootParent;

/**
 * Parses HTML string to DOM nodes in Node.js.
 *
 * This is the same method as `require('htmlparser2').parseDOM`
 * https://github.com/fb55/htmlparser2/blob/v6.0.0/src/index.ts#L29-L41
 *
 * @param  {string}            html      - HTML markup.
 * @param  {DomHandlerOptions} [options] - Parser options (https://github.com/fb55/domhandler/tree/v4.0.0#readme).
 * @return {Array<Comment|Element|ProcessingInstruction|Text>} - DOM nodes.
 */
function HTMLDOMParser(html, options) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string.');
  }

  if (html === '') {
    return [];
  }

  var handler = new DomHandler(undefined, options);
  new Parser(handler, options).end(html);
  return unsetRootParent(handler.dom);
}

var htmlToDom = HTMLDOMParser;

/**
 * When running on Node.js, use the server parser.
 * When bundling for the browser, use the client parser.
 *
 * @see {@link https://github.com/substack/node-browserify#browser-field}
 */

var htmlDomParser = htmlToDom;

var domToReact = domToReact_1;
var attributesToProps = attributesToProps$2;
var htmlToDOM = htmlDomParser;

// support backwards compatibility for ES Module
htmlToDOM =
  /* istanbul ignore next */
  typeof htmlToDOM.default === 'function' ? htmlToDOM.default : htmlToDOM;

var domParserOptions = { lowerCaseAttributeNames: false };

/**
 * Converts HTML string to React elements.
 *
 * @param {string} html - HTML string.
 * @param {object} [options] - Parser options.
 * @param {object} [options.htmlparser2] - htmlparser2 options.
 * @param {object} [options.library] - Library for React, Preact, etc.
 * @param {Function} [options.replace] - Replace method.
 * @returns {JSX.Element|JSX.Element[]|string} - React element(s), empty array, or string.
 */
function HTMLReactParser(html, options) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }
  if (html === '') {
    return [];
  }
  options = options || {};
  return domToReact(
    htmlToDOM(html, options.htmlparser2 || domParserOptions),
    options
  );
}

HTMLReactParser.domToReact = domToReact;
HTMLReactParser.htmlToDOM = htmlToDOM;
HTMLReactParser.attributesToProps = attributesToProps;
HTMLReactParser.Element = lib$1.Element;

// support CommonJS and ES Modules
htmlReactParser.exports = HTMLReactParser;
htmlReactParser.exports.default = HTMLReactParser;

var HTMLReactParser$1 = htmlReactParser.exports;

HTMLReactParser$1.domToReact;
HTMLReactParser$1.htmlToDOM;
HTMLReactParser$1.attributesToProps;
HTMLReactParser$1.Element;

var _excluded$x = ["className", "align", "titlePrefixIcon", "title", "children"];
var cssInfoBanner = function cssInfoBanner(align) {
  return /*#__PURE__*/css("width:100%;padding:15px;color:#ffffff;background-color:#37475a;.info-title{display:flex;margin:0 auto;justify-content:", align === 'right' ? 'flex-end' : align === 'center' ? 'center' : 'flex-start', ";max-width:calc(144 * var(--fwcu));.icon{font-size:16px;margin-right:10px;}}.info-body{margin:0 auto;text-align:", align, ";max-width:calc(144 * var(--fwcu));};label:cssInfoBanner;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};
var InfoBanner = function InfoBanner(props) {
  var className = props.className,
    _props$align = props.align,
    align = _props$align === void 0 ? 'center' : _props$align,
    titlePrefixIcon = props.titlePrefixIcon,
    title = props.title,
    children = props.children,
    restProps = _objectWithoutProperties$1(props, _excluded$x);
  var infoBannerClass = cx(className);
  return jsx("div", _extends$1({}, restProps, {
    css: cssInfoBanner(align),
    className: infoBannerClass
  }), jsx("div", {
    className: "info-title"
  }, titlePrefixIcon && jsx("span", {
    className: "icon"
  }, titlePrefixIcon), typeof title === 'string' ? HTMLReactParser$1(title) : title), jsx("div", {
    className: "info-body"
  }, typeof children === 'string' ? HTMLReactParser$1(children) : children));
};
InfoBanner.propTypes = {
  className: string,
  titlePrefixIcon: node$2,
  title: node$2,
  children: node$2,
  align: oneOf(['left', 'center', 'right'])
};

function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$c(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var NOTIFICATION_LIMIT = 20;
var ActionType = {
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  UPDATE_NOTIFICATION: 'UPDATE_NOTIFICATION',
  UPSERT_NOTIFICATION: 'UPSERT_NOTIFICATION',
  DISMISS_NOTIFICATION: 'DISMISS_NOTIFICATION',
  REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
  START_PAUSE: 'START_PAUSE',
  END_PAUSE: 'END_PAUSE'
};
var notificationTimeouts = new Map();
var addToRemoveQueue = function addToRemoveQueue(notificationId) {
  if (notificationTimeouts.has(notificationId)) {
    return;
  }
  var timeout = setTimeout(function () {
    notificationTimeouts["delete"](notificationId);
    dispatch({
      type: ActionType.REMOVE_NOTIFICATION,
      notificationId: notificationId
    });
  }, 1000);
  notificationTimeouts.set(notificationId, timeout);
};
var clearFromRemoveQueue = function clearFromRemoveQueue(notificationId) {
  var timeout = notificationTimeouts.get(notificationId);
  if (timeout) {
    clearTimeout(timeout);
  }
};
var reducer$1 = function reducer(state, action) {
  switch (action.type) {
    case ActionType.ADD_NOTIFICATION:
      return _objectSpread$c(_objectSpread$c({}, state), {}, {
        notifications: [action.notification].concat(_toConsumableArray(state.notifications)).slice(0, NOTIFICATION_LIMIT)
      });
    case ActionType.UPDATE_NOTIFICATION:
      //  ! Side effects !
      if (action.notification.id) {
        clearFromRemoveQueue(action.notification.id);
      }
      return _objectSpread$c(_objectSpread$c({}, state), {}, {
        notifications: state.notifications.map(function (t) {
          return t.id === action.notification.id ? _objectSpread$c(_objectSpread$c({}, t), action.notification) : t;
        })
      });
    case ActionType.UPSERT_NOTIFICATION:
      {
        var notification = action.notification;
        return state.notifications.find(function (t) {
          return t.id === notification.id;
        }) ? reducer(state, {
          type: ActionType.UPDATE_NOTIFICATION,
          notification: notification
        }) : reducer(state, {
          type: ActionType.ADD_NOTIFICATION,
          notification: notification
        });
      }
    case ActionType.DISMISS_NOTIFICATION:
      {
        var notificationId = action.notificationId;

        // ! Side effects ! - This could be execrated into a dismissNotification() action, but I'll keep it here for simplicity
        if (notificationId) {
          addToRemoveQueue(notificationId);
        } else {
          state.notifications.forEach(function (notification) {
            addToRemoveQueue(notification.id);
          });
        }
        return _objectSpread$c(_objectSpread$c({}, state), {}, {
          notifications: state.notifications.map(function (n) {
            return n.id === notificationId || notificationId === undefined ? _objectSpread$c(_objectSpread$c({}, n), {}, {
              visible: false
            }) : n;
          })
        });
      }
    case ActionType.REMOVE_NOTIFICATION:
      if (action.notificationId === undefined) {
        return _objectSpread$c(_objectSpread$c({}, state), {}, {
          notifications: []
        });
      }
      return _objectSpread$c(_objectSpread$c({}, state), {}, {
        notifications: state.notifications.filter(function (n) {
          return n.id !== action.notificationId;
        })
      });
    case ActionType.START_PAUSE:
      return _objectSpread$c(_objectSpread$c({}, state), {}, {
        pausedAt: action.time
      });
    case ActionType.END_PAUSE:
      {
        var diff = action.time - (state.pausedAt || 0);
        return _objectSpread$c(_objectSpread$c({}, state), {}, {
          pausedAt: undefined,
          notifications: state.notifications.map(function (n) {
            return _objectSpread$c(_objectSpread$c({}, n), {}, {
              pauseDuration: n.pauseDuration + diff
            });
          })
        });
      }
  }
};
var listeners = [];
var memoryState = {
  notifications: [],
  pausedAt: undefined
};
var dispatch = function dispatch(action) {
  memoryState = reducer$1(memoryState, action);
  listeners.forEach(function (listener) {
    listener(memoryState);
  });
};
var defaultTimeouts = {
  info: 4000,
  error: 4000,
  success: 2000,
  urgent: 4000
};
var useStore = function useStore(notificationOptions) {
  var _useState = useState(memoryState),
    _useState2 = _slicedToArray$1(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    listeners.push(setState);
    return function () {
      var index = listeners.indexOf(setState);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, [state]);
  var mergedNotifications = state.notifications.map(function (t) {
    var _notificationOptions$;
    return _objectSpread$c(_objectSpread$c(_objectSpread$c(_objectSpread$c({}, notificationOptions), notificationOptions === null || notificationOptions === void 0 ? void 0 : notificationOptions[t === null || t === void 0 ? void 0 : t.type]), t), {}, {
      duration: t.duration || (notificationOptions === null || notificationOptions === void 0 ? void 0 : (_notificationOptions$ = notificationOptions[t === null || t === void 0 ? void 0 : t.type]) === null || _notificationOptions$ === void 0 ? void 0 : _notificationOptions$.duration) || (notificationOptions === null || notificationOptions === void 0 ? void 0 : notificationOptions.duration) || (defaultTimeouts === null || defaultTimeouts === void 0 ? void 0 : defaultTimeouts[t.type])
    });
  });
  return _objectSpread$c(_objectSpread$c({}, state), {}, {
    notifications: mergedNotifications
  });
};

function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$b(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var genId = function () {
  var count = 0;
  return function () {
    return (++count).toString();
  };
}();
var createNotification = function createNotification(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
  var opts = arguments.length > 2 ? arguments[2] : undefined;
  return _objectSpread$b(_objectSpread$b({
    createdAt: Date.now(),
    visible: true,
    type: type,
    ariaProps: {
      role: 'status',
      'aria-live': 'polite'
    },
    message: message,
    pauseDuration: 0
  }, opts), {}, {
    id: (opts === null || opts === void 0 ? void 0 : opts.id) || genId()
  });
};
var createHandler = function createHandler(type) {
  return function (message, options) {
    var notification = createNotification(message, type, options);
    dispatch({
      type: ActionType.UPSERT_NOTIFICATION,
      notification: notification
    });
    return notification.id;
  };
};
var notify = function notify(message, opts) {
  return createHandler('info')(message, opts);
};
notify.info = createHandler('info');
notify.urgent = createHandler('urgent');
notify.success = createHandler('success');
notify.error = createHandler('error');
notify.dismiss = function (notificationId) {
  return dispatch({
    type: ActionType.DISMISS_NOTIFICATION,
    notificationId: notificationId
  });
};
notify.remove = function (notificationId) {
  return dispatch({
    type: ActionType.REMOVE_NOTIFICATION,
    notificationId: notificationId
  });
};

var useNotifier = function useNotifier(notificationOptions) {
  var _useStore = useStore(notificationOptions),
    notifications = _useStore.notifications,
    pausedAt = _useStore.pausedAt;
  useEffect(function () {
    if (pausedAt) {
      return;
    }
    var now = Date.now();
    var timeouts = notifications.map(function (n) {
      if (n.duration === Infinity) {
        return;
      }
      var durationLeft = (n.duration || 0) + n.pauseDuration - (now - n.createdAt);
      if (durationLeft < 0) {
        if (n.visible) {
          notify.dismiss(n.id);
        }
        return;
      }
      return setTimeout(function () {
        return notify.dismiss(n.id);
      }, durationLeft);
    });
    return function () {
      timeouts.forEach(function (timeout) {
        return timeout && clearTimeout(timeout);
      });
    };
  }, [notifications, pausedAt]);
  var handlers = useMemo(function () {
    return {
      startPause: function startPause() {
        dispatch({
          type: ActionType.START_PAUSE,
          time: Date.now()
        });
      },
      endPause: function endPause() {
        if (pausedAt) {
          dispatch({
            type: ActionType.END_PAUSE,
            time: Date.now()
          });
        }
      }
    };
  }, [pausedAt]);
  return {
    notifications: notifications,
    handlers: handlers
  };
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$q() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssNotifier = process.env.NODE_ENV === "production" ? {
  name: "1mt5o8s-cssNotifier",
  styles: "background-color:#fff;label:cssNotifier;"
} : {
  name: "1mt5o8s-cssNotifier",
  styles: "background-color:#fff;label:cssNotifier;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$q
};
var Notifier = function Notifier(props) {
  var _ref = props || {},
    className = _ref.className,
    _ref$notificationOpti = _ref.notificationOptions,
    notificationOptions = _ref$notificationOpti === void 0 ? {
      success: {
        duration: 4000
      },
      error: {
        duration: 4000
      },
      info: {
        duration: 4000
      },
      urgent: {
        duration: 4000
      }
    } : _ref$notificationOpti;
  var notifierClass = cx('notifier', className);
  var _useNotifier = useNotifier(notificationOptions),
    notifications = _useNotifier.notifications,
    handlers = _useNotifier.handlers;
  var handleClose = function handleClose(e) {
    var _e$detail;
    notify.dismiss(e === null || e === void 0 ? void 0 : (_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.id);
  };
  return jsx("div", {
    css: cssNotifier,
    className: notifierClass,
    onMouseEnter: handlers.startPause,
    onMouseLeave: handlers.endPause
  }, notifications.map(function (toast) {
    return jsx(Alert, {
      key: toast.id,
      id: toast.id,
      area: "global",
      type: toast.type,
      onClose: handleClose
    }, toast.message);
  }));
};
Notifier.propTypes = {
  className: string,
  notificationOptions: shape({
    success: shape({
      duration: number$4
    }),
    error: shape({
      duration: number$4
    }),
    info: shape({
      duration: number$4
    }),
    urgent: shape({
      duration: number$4
    })
  })
};

var css_248z$7 = "/*\n    Style only for Motif Input\n    Dependencies: vars.css\n*/\n\n/* TODO: Inactive States */\n\n.fwc-label,\n.fwc-input .fwc-label,\n.fwc-textarea .fwc-label,\n.fwc-label span {\n  display: block;\n  padding: 0;\n  border: none;\n  margin-bottom: calc(0.5 * var(--fwcu));\n  color: var(--color-gray-one);\n  font-weight: bold;\n  line-height: var(--default-line-height);\n}\n\n.fwc-input input {\n  font-size: calc(2 * var(--fwcu));\n  border: 1px solid var(--color-gray-six);\n  border-radius: var(--border-radius);\n  box-shadow: var(--box-shadow-light);\n  color: var(--color-gray-one);\n  padding: calc(0.5 * var(--fwcu)) calc(2 * var(--fwcu));\n  height: calc(5 * var(--fwcu));\n  width: 100%;\n}\n\n.fwc-input input::placeholder {\n  color: var(--color-gray-two);\n}\n\n/* Error State */\n\n.fwc-input input[aria-invalid='true'],\n.fwc-textarea textarea[aria-invalid='true'] {\n  border-color: var(--color-alert-error);\n}\n\n.fwc-input span[role='alert'],\n.fwc-textarea span[role='alert'] {\n  color: var(--color-alert-error);\n  display: flex;\n  align-items: center;\n  padding-top: var(--fwcu);\n}\n\n.fwc-input span[role='alert']::before,\n.fwc-textarea span[role='alert']::before {\n  color: var(--color-alert-error);\n  font-size: calc(var(--default-font-size));\n}\n\n/* Disabled State */\n\n.fwc-input.fwc-disabled .fwc-label,\n.fwc-textarea.fwc-disabled .fwc-label {\n  opacity: var(--disabled-opacity);\n}\n\n.fwc-input.fwc-disabled input:disabled,\n.fwc-textarea.fwc-disabled textarea:disabled {\n  border-color: rgba(var(--color-rgb-gray-three), var(--disabled-opacity));\n  background-color: rgba(var(--color-rgb-white), var(--disabled-opacity));\n}\n\n/** Input with icon */\n\n.fwc-input.fwc-input-icon .fwc-icon {\n  position: absolute;\n  padding: calc(1.25 * var(--fwcu));\n  font-size: calc(2.5 * var(--fwcu));\n  padding-top: calc(1.25 * var(--fwcu));\n}\n\n.fwc-input.fwc-input-icon input {\n  padding-left: calc(5 * var(--fwcu));\n}\n\n.fwc-input.fwc-input-icon .fwc-icon {\n  color: var(--color-gray-one);\n}\n\n/** Search input with animation */\n\n.fwc-input-search {\n  display: flex;\n  align-items: center;\n}\n\n.fwc-input-search:not(.active) input {\n  transition: all 200ms ease-out;\n  width: calc(10 * var(--fwcu));\n}\n\n.fwc-input-search.active input {\n  transition: all 200ms ease-in;\n  width: calc(22.5 * var(--fwcu));\n}\n\n.fwc-input-search input {\n  background: transparent;\n  border: none;\n  outline: none;\n  box-shadow: none;\n  height: auto;\n  caret-color: var(--color-white);\n  color: var(--color-white);\n  padding-left: calc(1 * var(--fwcu));\n}\n\n.fwc-input-search input::placeholder {\n  color: var(--color-white);\n}\n\n.fwc-input-search.fwc-icon-search {\n  position: absolute;\n  left: 0;\n  top: calc(0.5 * var(--fwcu));\n}\n\n.fwc-input-search.active {\n  background-color: var(--color-primary-hover);\n  transition: 200ms all ease-out;\n  outline: var(--fwc-focus);\n}\n\n.fwc-input-search {\n  padding: calc(0.5 * var(--fwcu)) calc(2 * var(--fwcu));\n  background-color: transparent;\n  border-radius: calc(4 * var(--fwcu));\n  color: var(--color-white);\n  transition: 200ms all ease-in;\n  font-weight: 600;\n}\n\n.fwc-input input:focus,\ninput:focus + .fwc-label,\ntextarea:focus {\n  outline: var(--fwc-focus);\n}\n\n/* Typeahead empty state */\n\n.fwc-typeahead-empty {\n  padding: calc(1.5 * var(--fwcu));\n  color: var(--color-gray-two);\n}\n\n/** Textarea **/\n\n.fwc-textarea textarea {\n  border-radius: calc(var(--fwcu));\n  border: 1px solid rgb(234, 234, 234);\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);\n  padding: calc(1.25 * var(--fwcu)) 0px 0px calc(1.5 * var(--fwcu));\n  font-size: calc(1.75 * var(--fwcu));\n  width: 100%;\n  height: calc(16 * var(--fwcu));\n}\n\n.fwc-textarea textarea::placeholder {\n  color: var(--color-gray-two);\n  height: calc(2.75 * var(--fwcu));\n  line-height: calc(2.75 * var(--fwcu));\n}\n";
styleInject(css_248z$7);

var _excluded$w = ["label", "id", "name", "type", "value", "disabled", "prefix", "suffix", "touched", "helperText", "layout", "className"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$p() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssInputHorizontal = process.env.NODE_ENV === "production" ? {
  name: "15gafnv-cssInputHorizontal",
  styles: "display:flex;flex-flow:row nowrap;margin-bottom:20px;.field-label{width:30%;margin-top:10px;margin-right:10px;text-align:right;label{font-weight:bold;}}.field-control{width:70%;}@media screen and (max-width: 420px){flex-flow:column wrap;.field-label{width:100%;margin-top:0px;margin-right:0px;text-align:start;}.field-control{width:100%;}};label:cssInputHorizontal;"
} : {
  name: "15gafnv-cssInputHorizontal",
  styles: "display:flex;flex-flow:row nowrap;margin-bottom:20px;.field-label{width:30%;margin-top:10px;margin-right:10px;text-align:right;label{font-weight:bold;}}.field-control{width:70%;}@media screen and (max-width: 420px){flex-flow:column wrap;.field-label{width:100%;margin-top:0px;margin-right:0px;text-align:start;}.field-control{width:100%;}};label:cssInputHorizontal;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$p
};
var cssInputVertical = process.env.NODE_ENV === "production" ? {
  name: "1pzpkpv-cssInputVertical",
  styles: "display:flex;flex-flow:column wrap;margin-bottom:20px;.field-label{label{font-weight:bold;}};label:cssInputVertical;"
} : {
  name: "1pzpkpv-cssInputVertical",
  styles: "display:flex;flex-flow:column wrap;margin-bottom:20px;.field-label{label{font-weight:bold;}};label:cssInputVertical;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$p
};
var cssInput = function cssInput(prefix, suffix) {
  return /*#__PURE__*/css("&.fwc-disabled{.field-label{opacity:calc(var(--disabled-opacity) + 0.2);}.field-control{.prefix,.suffix,input,input::placeholder{opacity:calc(var(--disabled-opacity) + 0.4);}input[aria-invalid='true']{border-color:var(--color-alert-error);}}}&.fwc-input-icon{input{padding-left:", prefix ? 'calc(5 * var(--fwcu))' : 'calc(2 * var(--fwcu))', ";padding-right:", suffix ? 'calc(5 * var(--fwcu))' : 'calc(2 * var(--fwcu))', ";}.field-control{position:relative;.las,.lar,.lab{position:absolute;padding:calc(1 * var(--fwcu));font-size:calc(3.05 * var(--fwcu));}.las.prefix,.lar.prefix,.lab.prefix{left:0;}.las.suffix,.lar.suffix,.lab.suffix{right:0;}.action{color:var(--color-primary);cursor:pointer;}}};label:cssInput;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};
var Input = /*#__PURE__*/forwardRef(function (props, ref) {
  var _prefix$props, _suffix$props;
  var label = props.label,
    id = props.id,
    name = props.name,
    _props$type = props.type,
    type = _props$type === void 0 ? 'text' : _props$type,
    value = props.value,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    prefix = props.prefix,
    suffix = props.suffix,
    touched = props.touched,
    helperText = props.helperText,
    _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'vertical' : _props$layout,
    className = props.className,
    restProps = _objectWithoutProperties$1(props, _excluded$w);
  var _useState = useState(false),
    _useState2 = _slicedToArray$1(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var inputDivClass = cx({
    'fwc-input': true,
    'field-input': true,
    'fwc-disabled': disabled,
    'fwc-input-icon': prefix || suffix || type === 'password'
  }, className);
  var toggleVisible = function toggleVisible() {
    return setIsVisible(function (old) {
      return !old;
    });
  };
  return jsx("div", {
    className: inputDivClass,
    css: [cssInput(prefix, suffix), layout === 'vertical' ? cssInputVertical : cssInputHorizontal, ";label:Input;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")]
  }, label && jsx("div", {
    className: "field-label"
  }, jsx("label", {
    htmlFor: id || name
  }, label)), jsx("div", {
    className: "field-control"
  }, prefix && /*#__PURE__*/isValidElement(prefix) && /*#__PURE__*/cloneElement(prefix, {
    className: "".concat((prefix === null || prefix === void 0 ? void 0 : (_prefix$props = prefix.props) === null || _prefix$props === void 0 ? void 0 : _prefix$props.className) || '', " prefix")
  }), jsx("input", _extends$1({}, restProps, {
    ref: ref,
    id: id || name,
    name: name
  }, value !== undefined || value !== null ? {
    value: value
  } : {}, {
    type: isVisible ? 'text' : type,
    disabled: disabled,
    "aria-invalid": touched && !!helperText
  })), type !== 'password' && suffix && /*#__PURE__*/isValidElement(suffix) && /*#__PURE__*/cloneElement(suffix, {
    className: "".concat((suffix === null || suffix === void 0 ? void 0 : (_suffix$props = suffix.props) === null || _suffix$props === void 0 ? void 0 : _suffix$props.className) || '', " suffix")
  }), type === 'password' && jsx(Icon, {
    las: true,
    name: isVisible ? 'eye-slash' : 'eye',
    className: "suffix action",
    onClick: toggleVisible
  }), jsx(HelperMessage, {
    touched: touched,
    helperText: helperText
  })));
});
Input.displayName = 'Input';
Input.propTypes = {
  id: string,
  type: string,
  className: string,
  layout: oneOf(['vertical', 'horizontal']),
  label: string,
  name: string,
  disabled: bool,
  prefix: node$2,
  suffix: node$2,
  touched: bool,
  value: string,
  placeholder: string,
  helperText: oneOfType([string, node$2, arrayOf(node$2)])
};

var _excluded$v = ["direction", "width", "height", "src", "containerClass"];
var cssImageContainer = function cssImageContainer(width, height) {
  return /*#__PURE__*/css("position:relative;overflow:hidden;width:", width, ";height:", height, ";text-align:center;;label:cssImageContainer;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};
var cssImageSlides = function cssImageSlides(direction) {
  return /*#__PURE__*/css("position:absolute;left:", direction === 'leftToRight' ? '-100%' : direction === 'rightToLeft' ? '100%' : 'inherit', ";top:", direction === 'bottomToTop' ? '100%' : direction === 'topToBottom' ? '-100%' : 'inherit', ";animation:slide 0.5s forwards;animation-delay:2s;animation-duration:4s;@keyframes slide{100%{top:", ['bottomToTop', 'topToBottom'].includes(direction) ? 0 : 'inherit', ";left:", ['leftToRight', 'rightToLeft'].includes(direction) ? 0 : 'inherit', ";}};label:cssImageSlides;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};
var Image = function Image(props) {
  var _props$direction = props.direction,
    direction = _props$direction === void 0 ? null : _props$direction,
    _props$width = props.width,
    width = _props$width === void 0 ? 'auto' : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 'auto' : _props$height,
    src = props.src,
    containerClass = props.containerClass,
    rest = _objectWithoutProperties$1(props, _excluded$v);
  if (direction) {
    var wrapperClass = cx('image-wrapper', containerClass);
    return jsx("div", {
      className: wrapperClass,
      css: cssImageContainer(width, height)
    }, jsx("img", _extends$1({}, rest, {
      src: src,
      width: width,
      height: height,
      css: cssImageSlides(direction)
    })));
  }
  return jsx("img", _extends$1({}, rest, {
    src: src,
    width: width,
    height: height
  }));
};
Image.propTypes = {
  src: string,
  width: string,
  height: string,
  direction: oneOf(['leftToRight', 'rightToLeft', 'bottomToTop', 'topToBottom']),
  containerClass: string
};

var Tooltip = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    children = props.children;
  var toolTipRef = useRef();
  var fwcTooltipProps = getFwcProps$1(props, {
    icon: 'icon',
    light: 'light',
    disabled: 'disabled',
    labelAriaTipTerm: 'label-aria-tip-term',
    term: 'term',
    message: 'message'
  });
  useEffect(function () {
    if (toolTipRef.current) {
      new FwcTooltip(toolTipRef.current).build();
    }
  }, []);
  return jsx("fwc-tooltip", _extends$1({}, fwcTooltipProps, {
    "class": cx('fwc-tooltip', className),
    ref: mergeRefs(toolTipRef, ref)
  }), children);
});
Tooltip.displayName = 'Tooltip';
Tooltip.propTypes = {
  className: string,
  term: string,
  message: string,
  icon: bool,
  light: bool,
  disabled: bool,
  labelAriaTipTerm: string,
  children: node$2
};

var css_248z$6 = ".fwc-badge {\n  font-size: calc(1.25 * var(--fwcu));\n  text-align: center;\n  padding: calc(0.5 * var(--fwcu)) var(--fwcu);\n  color: var(--color-white);\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  border-radius: calc(0.25 * var(--border-radius));\n  font-weight: 700;\n  display: inline-block;\n  line-height: 1;\n}\n\n.fwc-badge.info {\n  background-color: var(--color-alert-info);\n}\n\n.fwc-badge.success {\n  background-color: var(--color-alert-success);\n}\n\n.fwc-badge.warning {\n  background-color: var(--color-alert-warning);\n}\n\n.fwc-badge.urgent {\n  background-color: var(--color-alert-error);\n}\n\n.fwc-badge.gray {\n  background-color: var(--color-gray-five);\n}\n\n.fwc-badge.white {\n  background-color: var(--color-white);\n}\n\n.fwc-badge.warning,\n.fwc-badge.gray,\n.fwc-badge.white {\n  color: var(--color-gray-one);\n}\n";
styleInject(css_248z$6);

var _excluded$u = ["type", "className", "children"];
var Badge = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$type = props.type,
    type = _props$type === void 0 ? 'info' : _props$type,
    className = props.className,
    _props$children = props.children,
    children = _props$children === void 0 ? '' : _props$children,
    restProps = _objectWithoutProperties$1(props, _excluded$u);
  var badgeClass = cx('fwc-badge', type, className);
  return jsx("span", _extends$1({}, restProps, {
    className: badgeClass,
    ref: ref
  }), children);
});
Badge.displayName = 'Badge';
Badge.propTypes = {
  className: string,
  type: oneOf(['success', 'info', 'warning', 'urgent', 'gray', 'white']),
  children: string
};

var css_248z$5 = ".fwc-header-page-slotted,\n.fwc-header-label .fwc-label {\n  color: var(--color-white);\n}\n.fwc-header-page-slotted .fwc-row {\n  width: 100%;\n}\n.fwc-header-page-slotted .fwc-header-page-sub {\n  font-size: calc(2 * var(--fwcu));\n  margin-top: var(--fwcu);\n}\n";
styleInject(css_248z$5);

var _excluded$t = ["title", "className", "children"];
var PageHeader = /*#__PURE__*/forwardRef(function (props, ref) {
  var title = props.title,
    className = props.className,
    children = props.children,
    restProps = _objectWithoutProperties$1(props, _excluded$t);
  var pageHeaderRef = useRef();
  var uiState = useSBUIState();
  var assetsPath = (uiState === null || uiState === void 0 ? void 0 : uiState.assetsPath) || './';
  var pageHeaderClass = cx({
    'fwc-header-page-slotted': Children.count(children)
  }, className);
  useEffect(function () {
    if (pageHeaderRef.current) {
      new FwcHeaderPage(pageHeaderRef.current).build();
    }
  }, []);
  return jsx("fwc-header-page", _extends$1({}, restProps, {
    title: title,
    ref: mergeRefs(pageHeaderRef, ref),
    config: JSON.stringify({
      assetsPath: assetsPath
    }),
    "class": pageHeaderClass
  }), children);
});
PageHeader.displayName = 'PageHeader';
PageHeader.propTypes = {
  title: string,
  className: string,
  children: node$2
};

var _excluded$s = ["value"],
  _excluded2$6 = ["value", "className", "inline", "children"];
function Tab(props) {
  var value = props.value,
    restProps = _objectWithoutProperties$1(props, _excluded$s);
  return jsx("div", _extends$1({}, restProps, {
    className: cx('fwc-tab-item', props.className),
    slot: "fwc-tab-".concat(value),
    label: null
  }));
}
Tab.propTypes = {
  value: string,
  label: string,
  className: string
};
var Tabs = /*#__PURE__*/forwardRef(function (props, ref) {
  var value = props.value,
    className = props.className,
    inline = props.inline,
    children = props.children,
    restProps = _objectWithoutProperties$1(props, _excluded2$6);
  var tabsRef = useRef();
  var tabs = useMemo(function () {
    return parseTabList(children, 'Tab').map(function (item) {
      return {
        slotID: item.value,
        title: item.label,
        active: item.value === value
      };
    });
  }, [value, children]);
  useEffect(function () {
    if (tabsRef.current) {
      new FwcTabs(tabsRef.current).build();
    }
  }, []);
  useEffect(function () {
    var tabElement = null;
    if (tabsRef.current) {
      new FwcTabs(tabsRef.current).build();
      tabsRef.current.addEventListener('fwc-tabs-clicked', handleTabClick);
      tabElement = tabsRef.current;
    }
    return function () {
      if (tabElement) {
        tabElement.removeEventListener('fwc-tabs-clicked', handleTabClick);
      }
    };
  }, [handleTabClick]);
  useEffect(function () {
    var _tabs$find;
    // set current tab as per value
    var newActiveTab = (tabs === null || tabs === void 0 ? void 0 : (_tabs$find = tabs.find(function (t) {
      return t.slotID === value;
    })) === null || _tabs$find === void 0 ? void 0 : _tabs$find.title) || tabsRef.current.current;
    tabsRef.current.current = newActiveTab;
  }, [value, tabs]);
  var handleTabClick = useCallback(function (e) {
    var _tabs$find2, _props$onChange, _e$detail;
    // Issue in @anthem/fwc tabs component
    // FWCTabs are un-controlled component, so in-order to make it controlled.
    // we are changing the active tab when ever value props are changed not on tab click.
    // ----------------------------------------------------------------------------------------
    // When 'fwc-tabs-clicked' event is faired, <fwc-tab /> is setting selected tab as current.
    // So we have to stop this action. so we are setting back to previous selected tab.
    var oldActiveTab = (tabs === null || tabs === void 0 ? void 0 : (_tabs$find2 = tabs.find(function (t) {
      return t.slotID === value;
    })) === null || _tabs$find2 === void 0 ? void 0 : _tabs$find2.title) || tabsRef.current.current;
    tabsRef.current.current = oldActiveTab;
    (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, e === null || e === void 0 ? void 0 : (_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.slotID);
  }, []);
  return jsx("fwc-tabs", _extends$1({}, restProps, inline ? {
    inline: true
  } : {}, {
    "class": cx('fwc-tabs', className),
    ref: mergeRefs(tabsRef, ref),
    tabs: JSON.stringify(tabs)
  }), children);
});
Tabs.displayName = 'Tab';
Tabs.Tab = Tab;
Tabs.Tab.displayName = 'Tab';
Tabs.propTypes = {
  inline: bool,
  size: oneOf(['sm', 'lg']),
  value: string,
  className: string,
  ariaLabelTabList: array$2,
  children: node$2,
  onChange: func
};

var _excluded$r = ["value", "name", "useConditionalRendering"];
var TabPanel = function TabPanel(props) {
  var value = props.value,
    name = props.name,
    useConditionalRendering = props.useConditionalRendering,
    restProps = _objectWithoutProperties$1(props, _excluded$r);
  if (useConditionalRendering && value !== name) {
    return null;
  }
  return jsx("div", _extends$1({
    role: "tabpanel"
  }, restProps, {
    hidden: !useConditionalRendering ? value !== name : false
  }));
};
TabPanel.propTypes = {
  name: string,
  value: string,
  useConditionalRendering: bool,
  children: node$2
};

var _excluded$q = ["label", "value", "className", "activeTab", "disabled"],
  _excluded2$5 = ["value", "className", "onChange", "children"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$o() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssArrowTabs = process.env.NODE_ENV === "production" ? {
  name: "e0vaw2-cssArrowTabs",
  styles: "border-bottom:10px solid var(--color-primary);text-align:center;.arrow-tab{display:inline-block;position:relative;cursor:pointer;text-align:center;background-color:var(--color-white);border:var(--color-white);padding:18px 14px;font-family:var(--font-sans-serif);font-size:16px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:normal;text-align:center;color:var(--color-gray-one);}.arrow-tab+.arrow-tab{margin:0 0 0 48px;}.arrow-tab:focus{outline:none;font-weight:bold;}.arrow-tab:hover{font-weight:bold;}.arrow-tab.active{font-weight:bold;}.arrow-tab.active:after{content:' ';position:absolute;border:solid 0px transparent;border-width:10px;top:58px;left:50%;margin-left:-10px;border-color:var(--color-white) transparent transparent transparent;}.arrow-tab.disabled,.arrow-tab.disabled:hover,.arrow-tab.disabled:focus{cursor:not-allowed;font-weight:normal;color:var(--color-gray-three);};label:cssArrowTabs;"
} : {
  name: "e0vaw2-cssArrowTabs",
  styles: "border-bottom:10px solid var(--color-primary);text-align:center;.arrow-tab{display:inline-block;position:relative;cursor:pointer;text-align:center;background-color:var(--color-white);border:var(--color-white);padding:18px 14px;font-family:var(--font-sans-serif);font-size:16px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:normal;text-align:center;color:var(--color-gray-one);}.arrow-tab+.arrow-tab{margin:0 0 0 48px;}.arrow-tab:focus{outline:none;font-weight:bold;}.arrow-tab:hover{font-weight:bold;}.arrow-tab.active{font-weight:bold;}.arrow-tab.active:after{content:' ';position:absolute;border:solid 0px transparent;border-width:10px;top:58px;left:50%;margin-left:-10px;border-color:var(--color-white) transparent transparent transparent;}.arrow-tab.disabled,.arrow-tab.disabled:hover,.arrow-tab.disabled:focus{cursor:not-allowed;font-weight:normal;color:var(--color-gray-three);};label:cssArrowTabs;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$o
};
var ArrowTab = function ArrowTab(props) {
  var label = props.label,
    value = props.value,
    className = props.className,
    activeTab = props.activeTab,
    disabled = props.disabled,
    restProps = _objectWithoutProperties$1(props, _excluded$q);
  var tabClass = cx({
    'arrow-tab': true,
    active: !disabled && activeTab === value,
    disabled: disabled,
    className: className
  });
  return jsx("button", _extends$1({
    role: "tab"
  }, restProps, {
    type: "button",
    name: value,
    className: tabClass,
    disabled: disabled
  }), props !== null && props !== void 0 && props.children ? props === null || props === void 0 ? void 0 : props.children : label);
};
ArrowTab.propTypes = {
  className: string,
  activeTab: string,
  label: string,
  value: string,
  disabled: bool,
  children: node$2
};
var ArrowTabs = function ArrowTabs(props) {
  var value = props.value,
    className = props.className,
    onChange = props.onChange,
    children = props.children,
    restProps = _objectWithoutProperties$1(props, _excluded2$5);
  var handleTabChange = function handleTabChange(e) {
    onChange === null || onChange === void 0 ? void 0 : onChange(e.target.name);
  };
  return jsx("div", _extends$1({}, restProps, {
    css: cssArrowTabs,
    className: cx('arrow-tabs', className)
  }), React__default.Children.map(children, function (child) {
    var _child$type;
    if ((child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) !== 'ArrowTabs.Tab') {
      console.error("Warning ArrowTabs has children that aren't ArrowTabs.Tab components");
      return null;
    }
    return /*#__PURE__*/React__default.cloneElement(child, {
      activeTab: value,
      onClick: handleTabChange
    });
  }));
};
ArrowTabs.Tab = ArrowTab;
ArrowTabs.Tab.displayName = 'ArrowTabs.Tab';
ArrowTabs.propTypes = {
  className: string,
  value: string,
  children: node$2,
  onChange: func
};

var _excluded$p = ["label", "value", "className", "activeTab", "disabled"],
  _excluded2$4 = ["value", "secondary", "className", "onChange", "children"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$n() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssBorderTabs = process.env.NODE_ENV === "production" ? {
  name: "12bmf7r-cssBorderTabs",
  styles: "&.secondary{border-bottom:1px solid var(--color-gray-four);.border-tab{border-bottom:none;}}.border-tab{display:inline-block;position:relative;cursor:pointer;text-align:center;background-color:var(--color-white);border:var(--color-white);padding:8px 18px;font-family:var(--font-sans-serif);font-size:16px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:normal;text-align:center;color:var(--color-gray-one);border-bottom:2px solid var(--color-gray-four);}.border-tab+.border-tab{margin:0 0 0 12px;}.border-tab.active,.border-tab:hover,.border-tab:focus{outline:none;font-weight:bold;}.border-tab.active{border-bottom:2px solid var(--color-primary);}.border-tab.disabled,.border-tab.disabled:hover,.border-tab.disabled:focus{cursor:not-allowed;font-weight:normal;color:rgb(var(--color-rgb-gray-three));};label:cssBorderTabs;"
} : {
  name: "12bmf7r-cssBorderTabs",
  styles: "&.secondary{border-bottom:1px solid var(--color-gray-four);.border-tab{border-bottom:none;}}.border-tab{display:inline-block;position:relative;cursor:pointer;text-align:center;background-color:var(--color-white);border:var(--color-white);padding:8px 18px;font-family:var(--font-sans-serif);font-size:16px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:normal;text-align:center;color:var(--color-gray-one);border-bottom:2px solid var(--color-gray-four);}.border-tab+.border-tab{margin:0 0 0 12px;}.border-tab.active,.border-tab:hover,.border-tab:focus{outline:none;font-weight:bold;}.border-tab.active{border-bottom:2px solid var(--color-primary);}.border-tab.disabled,.border-tab.disabled:hover,.border-tab.disabled:focus{cursor:not-allowed;font-weight:normal;color:rgb(var(--color-rgb-gray-three));};label:cssBorderTabs;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$n
};
var BorderTab = function BorderTab(props) {
  var label = props.label,
    value = props.value,
    className = props.className,
    activeTab = props.activeTab,
    disabled = props.disabled,
    restProps = _objectWithoutProperties$1(props, _excluded$p);
  var tabClass = cx({
    'border-tab': true,
    active: !disabled && activeTab === value,
    disabled: disabled,
    className: className
  });
  return jsx("button", _extends$1({
    role: "tab"
  }, restProps, {
    type: "button",
    name: value,
    className: tabClass,
    disabled: disabled
  }), props !== null && props !== void 0 && props.children ? props === null || props === void 0 ? void 0 : props.children : label);
};
BorderTab.propTypes = {
  className: string,
  activeTab: string,
  label: string,
  value: string,
  disabled: bool,
  children: node$2
};
var BorderTabs = function BorderTabs(props) {
  var value = props.value,
    _props$secondary = props.secondary,
    secondary = _props$secondary === void 0 ? false : _props$secondary,
    className = props.className,
    onChange = props.onChange,
    children = props.children,
    restProps = _objectWithoutProperties$1(props, _excluded2$4);
  var handleTabChange = function handleTabChange(e) {
    onChange === null || onChange === void 0 ? void 0 : onChange(e.target.name);
  };
  return jsx("div", _extends$1({}, restProps, {
    css: cssBorderTabs,
    className: cx('border-tabs', {
      secondary: secondary
    }, className)
  }), React__default.Children.map(children, function (child) {
    var _child$type;
    if ((child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) !== 'BorderTabs.Tab') {
      console.error("Warning BorderTabs has children that aren't BorderTabs.Tab components");
      return null;
    }
    return /*#__PURE__*/React__default.cloneElement(child, {
      activeTab: value,
      onClick: handleTabChange
    });
  }));
};
BorderTabs.Tab = BorderTab;
BorderTabs.Tab.displayName = 'BorderTabs.Tab';
BorderTabs.propTypes = {
  className: string,
  secondary: bool,
  value: string,
  children: node$2,
  onChange: func
};

var _excluded$o = ["data", "align", "className", "activeStep", "vertical"];
var cssStepper = function cssStepper(stepCount, align) {
  return /*#__PURE__*/css("margin-bottom:4em;margin-top:2em;padding:0em 2em;display:flex;justify-content:", align || 'flex-start', ";.stepper-content{max-width:", stepCount * 10, "em;width:100%;};label:cssStepper;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};
var overrideStyle = "\n  ol > li {\n    flex: inherit;\n    flex-grow: 1;\n  }\n\n  ol > li:last-child {\n    flex: 0 0 auto;\n  }\n";
var Stepper = /*#__PURE__*/forwardRef(function (props, ref) {
  var stepperRef = useRef();
  var stepperCustomStyle = useRef(document.createElement('style'));
  var _ref = props || {},
    data = _ref.data,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'start' : _ref$align,
    className = _ref.className,
    _ref$activeStep = _ref.activeStep,
    activeStep = _ref$activeStep === void 0 ? 0 : _ref$activeStep,
    _ref$vertical = _ref.vertical,
    vertical = _ref$vertical === void 0 ? false : _ref$vertical,
    restProps = _objectWithoutProperties$1(_ref, _excluded$o);
  var stepperData = useMemo(function () {
    return data.map(function (step, idx) {
      return {
        label: step.label,
        complete: idx <= activeStep
      };
    });
  }, [data, activeStep]);
  useEffect(function () {
    if (stepperRef.current) {
      new FwcProgressStandard(stepperRef.current).build();
      var stepperShadowDOM = stepperRef.current.shadowRoot;
      stepperCustomStyle.current.innerHTML = overrideStyle;
      setTimeout(function () {
        stepperShadowDOM.appendChild(stepperCustomStyle.current);
      }, 0);
    }
  }, []);
  return jsx("div", {
    css: !vertical && cssStepper(data.length, align),
    className: cx('stepper-wrapper', className)
  }, jsx("div", {
    className: "stepper-content"
  }, jsx("fwc-progress-standard", _extends$1({}, restProps, {
    ref: mergeRefs(stepperRef, ref),
    type: vertical ? 'vertical' : '',
    data: JSON.stringify(stepperData)
  }))));
});
Stepper.displayName = 'Stepper';
Stepper.propTypes = {
  vertical: bool,
  className: string,
  activeStep: number$4,
  align: oneOf(['start', 'center', 'end']),
  data: arrayOf(shape({
    label: string
  }))
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$m() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssFlowFooter = process.env.NODE_ENV === "production" ? {
  name: "13d2d5j-cssFlowFooter",
  styles: "padding:34px 0px;text-align:right;.flow-btn{width:168px;height:45px;}.flow-link{padding:0px 5px;margin:0px 24px;};label:cssFlowFooter;"
} : {
  name: "13d2d5j-cssFlowFooter",
  styles: "padding:34px 0px;text-align:right;.flow-btn{width:168px;height:45px;}.flow-link{padding:0px 5px;margin:0px 24px;};label:cssFlowFooter;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
};
var isClassComponent = function isClassComponent(component) {
  var _component$prototype;
  return typeof component === 'function' && !!(component !== null && component !== void 0 && (_component$prototype = component.prototype) !== null && _component$prototype !== void 0 && _component$prototype.isReactComponent);
};
var ComponentNotFound = function ComponentNotFound() {
  return jsx("div", null, "Component is not found!!!");
};
var FlowContext = /*#__PURE__*/createContext();
var fetchStageInfo = function fetchStageInfo(url, body) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  }).then(function (res) {
    return res.json();
  });
};

// ------------------------------------------
// Start :: Components Functions
// ------------------------------------------

// ------------------------------------------
// End :: Components Functions
// ------------------------------------------

// ------------------------------------------
// Start :: FlowProvider Component
// ------------------------------------------
function FlowProvider(props) {
  var url = props.url,
    _props$componentsMap = props.componentsMap,
    componentsMap = _props$componentsMap === void 0 ? {} : _props$componentsMap,
    _props$hideStepper = props.hideStepper,
    hideStepper = _props$hideStepper === void 0 ? false : _props$hideStepper,
    _props$hideNavigation = props.hideNavigation,
    hideNavigation = _props$hideNavigation === void 0 ? false : _props$hideNavigation,
    onCancel = props.onCancel,
    onCompleted = props.onCompleted;
  var activeFlowRef = useRef();
  var _useState = useState({}),
    _useState2 = _slicedToArray$1(_useState, 2),
    activeFlowState = _useState2[0],
    setActiveFlowState = _useState2[1];
  var _useState3 = useState('loading'),
    _useState4 = _slicedToArray$1(_useState3, 2),
    initialCompStatus = _useState4[0],
    setInitialCompStatus = _useState4[1];
  var _useState5 = useState('success'),
    _useState6 = _slicedToArray$1(_useState5, 2),
    nextCompStatus = _useState6[0],
    setNextCompStatus = _useState6[1];
  var _useState7 = useState('success'),
    _useState8 = _slicedToArray$1(_useState7, 2),
    previousCompStatus = _useState8[0],
    setPreviousCompStatus = _useState8[1];
  var _useState9 = useState('success'),
    _useState10 = _slicedToArray$1(_useState9, 2),
    saveAndExitCompStatus = _useState10[0],
    setSaveAndExitCompStatus = _useState10[1];
  useEffect(function () {
    setInitialCompStatus('loading');
    fetchStageInfo(url, {}).then(function (res) {
      setInitialCompStatus('success');
      setActiveFlowState(res);
      return res;
    })["catch"](function () {
      setInitialCompStatus('error');
    });
  }, [url]);
  var _onPrevious = useCallback(function () {
    var body = {
      stage: activeFlowState === null || activeFlowState === void 0 ? void 0 : activeFlowState.previous
    };
    setPreviousCompStatus('loading');
    fetchStageInfo(url, body).then(function (res) {
      setPreviousCompStatus('success');
      setActiveFlowState(res);
      return res;
    })["catch"](function () {
      setPreviousCompStatus('error');
    });
  }, [url, activeFlowState === null || activeFlowState === void 0 ? void 0 : activeFlowState.previous]);
  var _onNext = useCallback(function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var body = {
      data: data,
      stage: activeFlowState === null || activeFlowState === void 0 ? void 0 : activeFlowState.next
    };
    setNextCompStatus('loading');
    fetchStageInfo(url, body).then(function (res) {
      var hasNextFlow = Boolean(activeFlowState === null || activeFlowState === void 0 ? void 0 : activeFlowState.next);
      setNextCompStatus('success');
      if (!hasNextFlow) {
        onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(res);
      } else {
        setActiveFlowState(res);
      }
      return res;
    })["catch"](function () {
      setNextCompStatus('error');
    });
  }, [url, activeFlowState === null || activeFlowState === void 0 ? void 0 : activeFlowState.next, onCompleted]);
  var _onSaveAndExit = useCallback(function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var body = {
      data: data,
      stage: activeFlowState === null || activeFlowState === void 0 ? void 0 : activeFlowState.next
    };
    setSaveAndExitCompStatus('loading');
    fetchStageInfo(url, body).then(function (res) {
      setSaveAndExitCompStatus('success');
      onCancel === null || onCancel === void 0 ? void 0 : onCancel();
      return res;
    })["catch"](function () {
      setSaveAndExitCompStatus('error');
    });
  }, [url, activeFlowState === null || activeFlowState === void 0 ? void 0 : activeFlowState.next, onCancel]);
  var _handleOnFlowCancel = useCallback(function () {
    onCancel === null || onCancel === void 0 ? void 0 : onCancel();
  }, [onCancel]);
  var _handleOnFlowSaveAndExit = useCallback(function () {
    if (activeFlowRef.current) {
      var _activeFlowRef$curren, _activeFlowRef$curren2;
      var data = ((_activeFlowRef$curren = activeFlowRef.current) === null || _activeFlowRef$curren === void 0 ? void 0 : (_activeFlowRef$curren2 = _activeFlowRef$curren.getComponentData) === null || _activeFlowRef$curren2 === void 0 ? void 0 : _activeFlowRef$curren2.call(_activeFlowRef$curren)) || {};
      _onSaveAndExit(data);
    } else {
      _onSaveAndExit();
    }
  }, [activeFlowRef, _onSaveAndExit]);
  var _handleOnFlowNext = useCallback(function () {
    if (activeFlowRef.current) {
      if (activeFlowRef.current.isValid()) {
        var data = activeFlowRef.current.getComponentData();
        _onNext(data);
      }
    } else {
      _onNext();
    }
  }, [activeFlowRef, _onNext]);
  var flowBag = useMemo(function () {
    var next = activeFlowState.next,
      previous = activeFlowState.previous,
      _activeFlowState$comp = activeFlowState.componentProps,
      componentProps = _activeFlowState$comp === void 0 ? {} : _activeFlowState$comp;
    return {
      activeFlowRef: activeFlowRef,
      componentProps: componentProps,
      hasNext: Boolean(next),
      hasBack: Boolean(previous),
      onNext: _onNext,
      onPrevious: _onPrevious,
      onSaveAndExit: _onSaveAndExit
    };
  }, [activeFlowRef, activeFlowState, _onNext, _onPrevious, _onSaveAndExit]);
  var stepper = (activeFlowState === null || activeFlowState === void 0 ? void 0 : activeFlowState.stepper) || {};
  var activeFlowKey = (activeFlowState === null || activeFlowState === void 0 ? void 0 : activeFlowState.current) || '';
  var ActiveComponent = (componentsMap === null || componentsMap === void 0 ? void 0 : componentsMap[activeFlowKey]) || ComponentNotFound;
  return jsx(FlowContext.Provider, {
    value: flowBag
  }, initialCompStatus === 'loading' && jsx(PreLoader, null), initialCompStatus === 'error' && jsx("div", null, "Unable to load the page "), initialCompStatus === 'success' && jsx(Suspense, {
    fallback: jsx(PreLoader, null)
  }, !hideStepper && jsx(Stepper, {
    align: "center",
    activeStep: (stepper === null || stepper === void 0 ? void 0 : stepper.activeStep) || 0,
    data: (stepper === null || stepper === void 0 ? void 0 : stepper.options) || []
  }), isClassComponent(ActiveComponent) ? jsx(ActiveComponent, {
    ref: activeFlowRef
  }) : jsx(ActiveComponent, null), !hideNavigation && jsx("div", {
    css: cssFlowFooter,
    className: "flow-footer"
  }, jsx(Button, {
    id: "flow-cancel",
    className: "flow-link",
    btnType: "link",
    onClick: _handleOnFlowCancel
  }, "Cancel"), flowBag.hasBack && jsx(Button, {
    id: "flow-save",
    className: "flow-link",
    btnType: "link",
    disabled: saveAndExitCompStatus === 'loading',
    loading: saveAndExitCompStatus === 'loading',
    onClick: _handleOnFlowSaveAndExit
  }, 'Save & Exit'), flowBag.hasBack && jsx(Button, {
    id: "flow-back",
    className: "flow-btn",
    btnType: "secondary",
    disabled: previousCompStatus === 'loading',
    loading: previousCompStatus === 'loading',
    onClick: _onPrevious
  }, "Back"), jsx(Button, {
    id: "flow-next",
    className: "flow-btn",
    disabled: nextCompStatus === 'loading',
    loading: nextCompStatus === 'loading',
    onClick: _handleOnFlowNext
  }, flowBag.hasNext ? 'Continue' : 'Submit'))));
}
FlowProvider.propTypes = {
  url: string,
  componentsMap: object$1,
  hideStepper: bool,
  hideNavigation: bool,
  onCompleted: func,
  onCancel: func
};

// ------------------------------------------
// End :: FlowProvider Component
// ------------------------------------------

function useFlowState() {
  var context = useContext(FlowContext);
  if (context === undefined) {
    throw new Error('useFlowState must be used within a FlowProvider');
  }
  return context;
}

var css_248z$4 = "a.fwc-link-large {\n  font-size: calc(2 * var(--fwcu));\n  font-family: var(--font-sans-serif);\n  font-weight: bold;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: calc(2.25 * var(--fwcu)) calc(3 * var(--fwcu));\n  background-color: var(--color-gray-five);\n  border-radius: var(--fwcu);\n  text-decoration: none;\n}\na.fwc-link-large span {\n  color: var(--color-primary);\n}\na.fwc-link-large span:not(.fwc-icon) {\n  padding-right: calc(3 * var(--fwcu));\n}\na.fwc-link-description {\n  display: block;\n  border: solid 1px rgba(var(--color-rgb-black), 0.1);\n  border-radius: var(--fwcu);\n  background-color: var(--color-white);\n  padding: calc(3 * var(--fwcu));\n  text-decoration: none;\n}\na.fwc-link-description span {\n  color: var(--color-primary);\n  font-family: var(--font-sans-serif);\n  font-size: calc(2.25 * var(--fwcu));\n  font-weight: bold;\n  line-height: calc(3 * var(--fwcu));\n  display: block;\n  margin-bottom: var(--fwcu);\n}\na.fwc-link-description p {\n  color: var(--color-gray-one);\n  font-family: var(--font-sans-serif);\n  font-weight: normal;\n}\na.fwc-link-pdf {\n  justify-content: flex-start;\n  align-items: center;\n  border: solid 1px rgba(var(--color-rgb-black), 0.1);\n  background-color: var(--color-white);\n  padding: calc(2 * var(--fwcu));\n}\na.fwc-link-pdf span.fwc-icon {\n  margin-right: calc(2 * var(--fwcu));\n}\na.fwc-link-description:hover,\na.fwc-link-large:hover {\n  box-shadow: var(--box-shadow);\n  transition: box-shadow 0.3s ease-in-out;\n}\na.fwc-link-description:hover span {\n  text-decoration: underline;\n}\na.fwc-link-pdf a.fwc-icon-pdf:before,\na.fwc-link-large a.fwc-icon-angle:before {\n  font-size: calc(3 * var(--fwcu));\n}\n";
styleInject(css_248z$4);

var _excluded$n = ["href", "children", "linkType", "className"];
var LargeLink = function LargeLink(props) {
  var _cx;
  var href = props.href,
    children = props.children,
    _props$linkType = props.linkType,
    linkType = _props$linkType === void 0 ? 'large' : _props$linkType,
    className = props.className,
    restProps = _objectWithoutProperties$1(props, _excluded$n);
  var _linkType = linkType === 'pdf' ? 'large' : linkType;
  var largeLinkClass = cx('large-link', (_cx = {}, _defineProperty$1(_cx, "fwc-link-".concat(_linkType), !!_linkType), _defineProperty$1(_cx, 'fwc-link-pdf', linkType === 'pdf'), _cx), className);
  return jsx("a", _extends$1({}, restProps, {
    href: href,
    className: largeLinkClass
  }), linkType === 'pdf' && jsx(Icon, {
    name: "pdf"
  }), children, linkType === 'large' && jsx(Icon, {
    name: "angle"
  }));
};
LargeLink.propTypes = {
  href: string,
  linkType: oneOf(['large', 'description', 'pdf']),
  children: node$2,
  className: string
};

var css_248z$3 = "/*\n    Style only for Motif Toggle\n    Dependencies: vars.css\n*/\n\n/* TODO: Inactive States */\n\n.fwc-toggle {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.fwc-toggle input[type='checkbox'] {\n  position: absolute;\n  left: -9999px;\n}\n\n.fwc-toggle label {\n  width: calc(5 * var(--fwcu));\n  height: calc(2.5 * var(--fwcu));\n  background-color: var(--color-gray-four);\n  color: var(--color-gray-one);\n  font-weight: 400;\n  border-radius: calc(2.25 * var(--fwcu));\n  cursor: pointer;\n  position: relative;\n  text-align: left;\n  margin: 0px;\n}\n\n.fwc-toggle label:before {\n  width: calc(2.25 * var(--fwcu));\n  height: calc(2.25 * var(--fwcu));\n  background-color: white;\n  border-radius: 100%;\n  margin-left: calc(0.075 * var(--fwcu));\n  content: ' ';\n  position: absolute;\n  top: 1px;\n  transition: margin 200ms ease;\n}\n\n.fwc-toggle span {\n  position: absolute;\n  top: calc(-0.25 * var(--fwcu));\n  bottom: 0;\n  left: calc(100% + (1.5 * var(--fwcu)));\n  white-space: nowrap;\n}\n\n.fwc-toggle input[type='checkbox']:checked + label {\n  background-color: var(--color-primary);\n}\n\n.fwc-toggle input[type='checkbox']:checked + label::before {\n  margin-left: calc(2.5 * var(--fwcu));\n}\n\n.fwc-toggle input:focus + label {\n  outline: var(--fwc-focus);\n}\n\n.fwc-toggle input:disabled,\n.fwc-toggle input:disabled + label {\n  opacity: 0.3;\n  cursor: default;\n  pointer-events: none;\n}\n";
styleInject(css_248z$3);

var _excluded$m = ["id", "name", "value", "label", "className", "disabled", "checked"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$l() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssToggle = process.env.NODE_ENV === "production" ? {
  name: "15wh0ij-cssToggle",
  styles: "padding:2px;&.fwc-toggle-disabled{.toggle-label{opacity:calc(var(--disabled-opacity) + 0.2);}};label:cssToggle;"
} : {
  name: "15wh0ij-cssToggle",
  styles: "padding:2px;&.fwc-toggle-disabled{.toggle-label{opacity:calc(var(--disabled-opacity) + 0.2);}};label:cssToggle;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRvZ2dsZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNcUIiLCJmaWxlIjoiVG9nZ2xlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgY3ggZnJvbSAnY2xhc3NuYW1lcyc7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBzdHJpbmcsIGJvb2wsIGFueSB9IGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0ICcuLi8uLi9wdWJsaWMvZndjLWFzc2V0cy9zdHlsZXMvY29tcG9uZW50cy9md2MtdG9nZ2xlLmNzcyc7XG5cbmNvbnN0IGNzc1RvZ2dsZSA9IGNzc2BcbiAgcGFkZGluZzogMnB4O1xuICAmLmZ3Yy10b2dnbGUtZGlzYWJsZWQge1xuICAgIC50b2dnbGUtbGFiZWwge1xuICAgICAgb3BhY2l0eTogY2FsYyh2YXIoLS1kaXNhYmxlZC1vcGFjaXR5KSArIDAuMik7XG4gICAgfVxuICB9XG5gO1xuXG5leHBvcnQgY29uc3QgVG9nZ2xlID0gZm9yd2FyZFJlZigocHJvcHMsIHJlZikgPT4ge1xuICBjb25zdCB7XG4gICAgaWQsXG4gICAgbmFtZSxcbiAgICB2YWx1ZSxcbiAgICBsYWJlbCxcbiAgICBjbGFzc05hbWUsXG4gICAgZGlzYWJsZWQgPSBmYWxzZSxcbiAgICBjaGVja2VkID0gZmFsc2UsXG4gICAgLi4ucmVzdFByb3BzXG4gIH0gPSBwcm9wcztcbiAgY29uc3QgdG9nZ2xlRGl2Q2xhc3MgPSBjeChcbiAgICAnZndjLXRvZ2dsZScsXG4gICAgeyAnZndjLXRvZ2dsZS1kaXNhYmxlZCc6IGRpc2FibGVkIH0sXG4gICAgY2xhc3NOYW1lLFxuICApO1xuICByZXR1cm4gKFxuICAgIDxkaXYgY2xhc3NOYW1lPXt0b2dnbGVEaXZDbGFzc30gY3NzPXtjc3NUb2dnbGV9PlxuICAgICAgPGlucHV0XG4gICAgICAgIHsuLi5yZXN0UHJvcHN9XG4gICAgICAgIHJlZj17cmVmfVxuICAgICAgICB0eXBlPVwiY2hlY2tib3hcIlxuICAgICAgICBuYW1lPXtuYW1lfVxuICAgICAgICB2YWx1ZT17dmFsdWV9XG4gICAgICAgIGlkPXtpZCB8fCBuYW1lfVxuICAgICAgICBkaXNhYmxlZD17ZGlzYWJsZWR9XG4gICAgICAgIGNoZWNrZWQ9e2NoZWNrZWR9XG4gICAgICAvPlxuICAgICAgPGxhYmVsIGNsYXNzTmFtZT1cInRvZ2dsZS1sYWJlbFwiIGh0bWxGb3I9e2lkIHx8IG5hbWV9PlxuICAgICAgICA8c3Bhbj57bGFiZWx9PC9zcGFuPlxuICAgICAgPC9sYWJlbD5cbiAgICA8L2Rpdj5cbiAgKTtcbn0pO1xuXG5Ub2dnbGUuZGlzcGxheU5hbWUgPSAnVG9nZ2xlJztcblRvZ2dsZS5wcm9wVHlwZXMgPSB7XG4gIGlkOiBzdHJpbmcsXG4gIHZhbHVlOiBhbnksXG4gIG5hbWU6IHN0cmluZyxcbiAgbGFiZWw6IHN0cmluZyxcbiAgY2xhc3NOYW1lOiBzdHJpbmcsXG4gIGRpc2FibGVkOiBib29sLFxuICBjaGVja2VkOiBib29sLFxufTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$l
};
var Toggle = /*#__PURE__*/forwardRef(function (props, ref) {
  var id = props.id,
    name = props.name,
    value = props.value,
    label = props.label,
    className = props.className,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$checked = props.checked,
    checked = _props$checked === void 0 ? false : _props$checked,
    restProps = _objectWithoutProperties$1(props, _excluded$m);
  var toggleDivClass = cx('fwc-toggle', {
    'fwc-toggle-disabled': disabled
  }, className);
  return jsx("div", {
    className: toggleDivClass,
    css: cssToggle
  }, jsx("input", _extends$1({}, restProps, {
    ref: ref,
    type: "checkbox",
    name: name,
    value: value,
    id: id || name,
    disabled: disabled,
    checked: checked
  })), jsx("label", {
    className: "toggle-label",
    htmlFor: id || name
  }, jsx("span", null, label)));
});
Toggle.displayName = 'Toggle';
Toggle.propTypes = {
  id: string,
  value: any,
  name: string,
  label: string,
  className: string,
  disabled: bool,
  checked: bool
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$k() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssToggleGroupHorizontal = function cssToggleGroupHorizontal(toggleLayout) {
  return /*#__PURE__*/css("flex-flow:row nowrap;.field-label{width:40%;margin-top:", toggleLayout === 'row' ? '5px' : '2px', ";margin-right:15px;text-align:right;}.field-control{width:70%;display:flex;margin-top:5px;flex-flow:", toggleLayout, " wrap;}@media screen and (max-width: 420px){flex-flow:column wrap;.field-label{width:100%;margin-top:0px;margin-right:0px;text-align:start;}.field-control{width:100%;}};label:cssToggleGroupHorizontal;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};
var cssToggleGroupVertical = function cssToggleGroupVertical(toggleLayout) {
  return /*#__PURE__*/css("flex-flow:column wrap;.field-control{display:flex;flex-flow:", toggleLayout, " wrap;};label:cssToggleGroupVertical;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};
var cssToggleGroup = process.env.NODE_ENV === "production" ? {
  name: "jhejui-cssToggleGroup",
  styles: "display:flex;flex-flow:column wrap;margin-bottom:20px;.field-label{label{font-weight:bold;}}.field-control{.fwc-toggle{width:auto;}};label:cssToggleGroup;"
} : {
  name: "jhejui-cssToggleGroup",
  styles: "display:flex;flex-flow:column wrap;margin-bottom:20px;.field-label{label{font-weight:bold;}}.field-control{.fwc-toggle{width:auto;}};label:cssToggleGroup;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$k
};
function ToggleGroup(props) {
  var _props$label = props.label,
    label = _props$label === void 0 ? '' : _props$label,
    _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'vertical' : _props$layout,
    name = props.name,
    _props$value = props.value,
    value = _props$value === void 0 ? [] : _props$value,
    _props$touched = props.touched,
    touched = _props$touched === void 0 ? false : _props$touched,
    _props$helperText = props.helperText,
    helperText = _props$helperText === void 0 ? '' : _props$helperText,
    _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    className = props.className,
    _props$tLayout = props.tLayout,
    tLayout = _props$tLayout === void 0 ? 'column' : _props$tLayout,
    onChange = props.onChange;
  var handleChange = useCallback(function (e) {
    var _e$target, _newValues;
    var newValues = _toConsumableArray(value || []);
    var newVal = (e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value) || '';
    if ((_newValues = newValues) !== null && _newValues !== void 0 && _newValues.includes(newVal)) {
      var _newValues2;
      newValues = (_newValues2 = newValues) === null || _newValues2 === void 0 ? void 0 : _newValues2.filter(function (val) {
        return val !== newVal;
      });
    } else {
      newValues = [].concat(_toConsumableArray(newValues), [newVal]);
    }
    onChange(e, newValues);
  }, [value, onChange]);
  return jsx("div", {
    css: [cssToggleGroup, layout === 'vertical' ? cssToggleGroupVertical(tLayout) : cssToggleGroupHorizontal(tLayout), ";label:ToggleGroup;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRvZ2dsZUdyb3VwLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW9HTSIsImZpbGUiOiJUb2dnbGVHcm91cC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyB1c2VDYWxsYmFjayB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7XG4gIGJvb2wsXG4gIHN0cmluZyxcbiAgYXJyYXlPZixcbiAgc2hhcGUsXG4gIG9uZU9mVHlwZSxcbiAgZnVuYyxcbiAgb25lT2YsXG4gIG5vZGUsXG4gIGFycmF5LFxufSBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBjeCBmcm9tICdjbGFzc25hbWVzJztcblxuaW1wb3J0IHsgVG9nZ2xlIH0gZnJvbSAnLi9Ub2dnbGUnO1xuaW1wb3J0IHsgQ29sIH0gZnJvbSAnLi4vR3JpZCc7XG5pbXBvcnQgeyBIZWxwZXJNZXNzYWdlIH0gZnJvbSAnLi4vSGVscGVyTWVzc2FnZSc7XG5cbmNvbnN0IGNzc1RvZ2dsZUdyb3VwSG9yaXpvbnRhbCA9IHRvZ2dsZUxheW91dCA9PiBjc3NgXG4gIGZsZXgtZmxvdzogcm93IG5vd3JhcDtcbiAgLmZpZWxkLWxhYmVsIHtcbiAgICB3aWR0aDogNDAlO1xuICAgIG1hcmdpbi10b3A6ICR7dG9nZ2xlTGF5b3V0ID09PSAncm93JyA/ICc1cHgnIDogJzJweCd9O1xuICAgIG1hcmdpbi1yaWdodDogMTVweDtcbiAgICB0ZXh0LWFsaWduOiByaWdodDtcbiAgfVxuICAuZmllbGQtY29udHJvbCB7XG4gICAgd2lkdGg6IDcwJTtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIG1hcmdpbi10b3A6IDVweDtcbiAgICBmbGV4LWZsb3c6ICR7dG9nZ2xlTGF5b3V0fSB3cmFwO1xuICB9XG5cbiAgQG1lZGlhIHNjcmVlbiBhbmQgKG1heC13aWR0aDogNDIwcHgpIHtcbiAgICBmbGV4LWZsb3c6IGNvbHVtbiB3cmFwO1xuICAgIC5maWVsZC1sYWJlbCB7XG4gICAgICB3aWR0aDogMTAwJTtcbiAgICAgIG1hcmdpbi10b3A6IDBweDtcbiAgICAgIG1hcmdpbi1yaWdodDogMHB4O1xuICAgICAgdGV4dC1hbGlnbjogc3RhcnQ7XG4gICAgfVxuICAgIC5maWVsZC1jb250cm9sIHtcbiAgICAgIHdpZHRoOiAxMDAlO1xuICAgIH1cbiAgfVxuYDtcblxuY29uc3QgY3NzVG9nZ2xlR3JvdXBWZXJ0aWNhbCA9IHRvZ2dsZUxheW91dCA9PiBjc3NgXG4gIGZsZXgtZmxvdzogY29sdW1uIHdyYXA7XG4gIC5maWVsZC1jb250cm9sIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZmxvdzogJHt0b2dnbGVMYXlvdXR9IHdyYXA7XG4gIH1cbmA7XG5cbmNvbnN0IGNzc1RvZ2dsZUdyb3VwID0gY3NzYFxuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWZsb3c6IGNvbHVtbiB3cmFwO1xuICBtYXJnaW4tYm90dG9tOiAyMHB4O1xuICAuZmllbGQtbGFiZWwge1xuICAgIGxhYmVsIHtcbiAgICAgIGZvbnQtd2VpZ2h0OiBib2xkO1xuICAgIH1cbiAgfVxuICAuZmllbGQtY29udHJvbCB7XG4gICAgLmZ3Yy10b2dnbGUge1xuICAgICAgd2lkdGg6IGF1dG87XG4gICAgfVxuICB9XG5gO1xuXG5leHBvcnQgZnVuY3Rpb24gVG9nZ2xlR3JvdXAocHJvcHMpIHtcbiAgY29uc3Qge1xuICAgIGxhYmVsID0gJycsXG4gICAgbGF5b3V0ID0gJ3ZlcnRpY2FsJyxcbiAgICBuYW1lLFxuICAgIHZhbHVlID0gW10sXG4gICAgdG91Y2hlZCA9IGZhbHNlLFxuICAgIGhlbHBlclRleHQgPSAnJyxcbiAgICBvcHRpb25zID0gW10sXG4gICAgY2xhc3NOYW1lLFxuICAgIHRMYXlvdXQgPSAnY29sdW1uJyxcbiAgICBvbkNoYW5nZSxcbiAgfSA9IHByb3BzO1xuICBjb25zdCBoYW5kbGVDaGFuZ2UgPSB1c2VDYWxsYmFjayhcbiAgICBlID0+IHtcbiAgICAgIGxldCBuZXdWYWx1ZXMgPSBbLi4uKHZhbHVlIHx8IFtdKV07XG4gICAgICBjb25zdCBuZXdWYWwgPSBlPy50YXJnZXQ/LnZhbHVlIHx8ICcnO1xuICAgICAgaWYgKG5ld1ZhbHVlcz8uaW5jbHVkZXMobmV3VmFsKSkge1xuICAgICAgICBuZXdWYWx1ZXMgPSBuZXdWYWx1ZXM/LmZpbHRlcih2YWwgPT4gdmFsICE9PSBuZXdWYWwpO1xuICAgICAgfSBlbHNlIHtcbiAgICAgICAgbmV3VmFsdWVzID0gWy4uLm5ld1ZhbHVlcywgbmV3VmFsXTtcbiAgICAgIH1cbiAgICAgIG9uQ2hhbmdlKGUsIG5ld1ZhbHVlcyk7XG4gICAgfSxcbiAgICBbdmFsdWUsIG9uQ2hhbmdlXSxcbiAgKTtcbiAgcmV0dXJuIChcbiAgICA8ZGl2XG4gICAgICBjc3M9e1tcbiAgICAgICAgY3NzVG9nZ2xlR3JvdXAsXG4gICAgICAgIGxheW91dCA9PT0gJ3ZlcnRpY2FsJ1xuICAgICAgICAgID8gY3NzVG9nZ2xlR3JvdXBWZXJ0aWNhbCh0TGF5b3V0KVxuICAgICAgICAgIDogY3NzVG9nZ2xlR3JvdXBIb3Jpem9udGFsKHRMYXlvdXQpLFxuICAgICAgXX1cbiAgICAgIGNsYXNzTmFtZT17Y3goJ2ZpZWxkLXRvZ2dsZS1ncm91cCcsIGNsYXNzTmFtZSl9XG4gICAgPlxuICAgICAge2xhYmVsICYmIChcbiAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJmaWVsZC1sYWJlbFwiPlxuICAgICAgICAgIDxsYWJlbD57bGFiZWx9PC9sYWJlbD5cbiAgICAgICAgPC9kaXY+XG4gICAgICApfVxuICAgICAgPGRpdiBjbGFzc05hbWU9XCJmaWVsZC1jb250cm9sXCI+XG4gICAgICAgIHtvcHRpb25zPy5tYXAob3B0ID0+IChcbiAgICAgICAgICA8Q29sXG4gICAgICAgICAgICBrZXk9e29wdD8udmFsdWV9XG4gICAgICAgICAgICB7Li4uKHRMYXlvdXQgPT09ICdyb3cnID8geyBsZzogJzMnLCBtZDogJzQnLCBzbTogJzYnIH0gOiB7fSl9XG4gICAgICAgICAgPlxuICAgICAgICAgICAgPFRvZ2dsZVxuICAgICAgICAgICAgICB7Li4ub3B0fVxuICAgICAgICAgICAgICBuYW1lPXtuYW1lfVxuICAgICAgICAgICAgICBpZD17YHRvZ2dsZS1ncm91cC0ke29wdD8udmFsdWV9YH1cbiAgICAgICAgICAgICAgY2hlY2tlZD17dmFsdWU/LmluY2x1ZGVzKG9wdD8udmFsdWUpIHx8IGZhbHNlfVxuICAgICAgICAgICAgICBvbkNoYW5nZT17aGFuZGxlQ2hhbmdlfVxuICAgICAgICAgICAgICBvbkJsdXI9e3Byb3BzLm9uQmx1cn1cbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgPC9Db2w+XG4gICAgICAgICkpfVxuXG4gICAgICAgIDxIZWxwZXJNZXNzYWdlIHRvdWNoZWQ9e3RvdWNoZWR9IGhlbHBlclRleHQ9e2hlbHBlclRleHR9IC8+XG4gICAgICA8L2Rpdj5cbiAgICA8L2Rpdj5cbiAgKTtcbn1cblxuVG9nZ2xlR3JvdXAucHJvcFR5cGVzID0ge1xuICBjbGFzc05hbWU6IHN0cmluZyxcbiAgbGF5b3V0OiBvbmVPZihbJ3ZlcnRpY2FsJywgJ2hvcml6b250YWwnXSksXG4gIHRMYXlvdXQ6IG9uZU9mKFsncm93JywgJ2NvbHVtbiddKSxcbiAgbGFiZWw6IHN0cmluZyxcbiAgbmFtZTogc3RyaW5nLFxuICB2YWx1ZTogYXJyYXksXG4gIHRvdWNoZWQ6IGJvb2wsXG4gIGhlbHBlclRleHQ6IG9uZU9mVHlwZShbc3RyaW5nLCBub2RlLCBhcnJheU9mKG5vZGUpXSksXG4gIG9wdGlvbnM6IGFycmF5T2Yoc2hhcGUoeyBsYWJlbDogc3RyaW5nLCB2YWx1ZTogc3RyaW5nLCBkaXNhYmxlZDogYm9vbCB9KSksXG4gIG9uQ2hhbmdlOiBmdW5jLFxuICBvbkJsdXI6IGZ1bmMsXG59O1xuIl19 */")],
    className: cx('field-toggle-group', className)
  }, label && jsx("div", {
    className: "field-label"
  }, jsx("label", null, label)), jsx("div", {
    className: "field-control"
  }, options === null || options === void 0 ? void 0 : options.map(function (opt) {
    return jsx(Col, _extends$1({
      key: opt === null || opt === void 0 ? void 0 : opt.value
    }, tLayout === 'row' ? {
      lg: '3',
      md: '4',
      sm: '6'
    } : {}), jsx(Toggle, _extends$1({}, opt, {
      name: name,
      id: "toggle-group-".concat(opt === null || opt === void 0 ? void 0 : opt.value),
      checked: (value === null || value === void 0 ? void 0 : value.includes(opt === null || opt === void 0 ? void 0 : opt.value)) || false,
      onChange: handleChange,
      onBlur: props.onBlur
    })));
  }), jsx(HelperMessage, {
    touched: touched,
    helperText: helperText
  })));
}
ToggleGroup.propTypes = {
  className: string,
  layout: oneOf(['vertical', 'horizontal']),
  tLayout: oneOf(['row', 'column']),
  label: string,
  name: string,
  value: array$2,
  touched: bool,
  helperText: oneOfType([string, node$2, arrayOf(node$2)]),
  options: arrayOf(shape({
    label: string,
    value: string,
    disabled: bool
  })),
  onChange: func,
  onBlur: func
};

var css_248z$2 = ".fwc-celebratory-template {\n  display: flex;\n  justify-content: center;\n  position: relative;\n  z-index: 1;\n}\n\n.fwc-celebratory-template ul {\n  background: var(--color-white);\n  box-shadow: var(--box-shadow);\n  padding: 0 calc(3 * var(--fwcu));\n  border-radius: var(--border-radius);\n  border: 1px solid var(--color-gray-five);\n  list-style-type: none;\n  margin: 0;\n}\n\n@media screen and (max-width: 600px) {\n  .fwc-celebratory-template ul {\n    padding: 0 calc(1.5 * var(--fwcu));\n  }\n  .fwc-celebratory-template img {\n    width: calc(10 * var(--fwcu));\n  }\n}\n\n.fwc-celebratory-template li {\n  display: flex;\n  border-bottom: 1px solid var(--color-gray-four);\n  padding: calc(3 * var(--fwcu)) 0;\n}\n\n.fwc-celebratory-template li:last-child {\n  border-bottom: none;\n}\n\n.fwc-celebratory-template li > div {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  font-size: calc(2.25 * var(--fwcu));\n  color: var(--color-gray-one);\n  margin-left: calc(1.5 * var(--fwcu));\n  padding-right: calc(3 * var(--fwcu));\n}\n\n@media screen and (max-width: 600px) {\n  .fwc-celebratory-template li > div {\n    padding-right: 0;\n  }\n}\n\n.fwc-celebratory-template li > div span {\n  display: block;\n  margin: calc(0.5 * var(--fwcu)) 0;\n}\n\n@media screen and (max-width: 600px) {\n  .fwc-celebratory-buttons button.fwc-btn-primary,\n  .fwc-celebratory-buttons button.fwc-btn-secondary {\n    margin: 0 0 var(--fwcu);\n    width: 100%;\n  }\n}\n\n/* Slide in modal sticky footer start */\n\n.fwc-modal-slide-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.slide-modal-content {\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  flex: 1;\n  height: 100%;\n}\n\n.fwc-modal-slide-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: calc(3 * var(--fwcu));\n  border-top:1px solid var(--color-gray-five);\n  box-shadow: 0px -1px 4px 1px rgba(var(--color-rgb-black), .05);\n}\n";
styleInject(css_248z$2);

function ModalSlideBody(props) {
  return jsx("div", _extends$1({}, props, {
    className: cx('slide-modal-content', props.className)
  }));
}
ModalSlideBody.propTypes = {
  className: string
};
function ModalSlideFooter(props) {
  return jsx("div", _extends$1({}, props, {
    className: cx('fwc-modal-slide-footer', props.className)
  }));
}
ModalSlideFooter.propTypes = {
  className: string
};
var ModalSlide = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$onClose = props.onClose,
    onClose = _props$onClose === void 0 ? function () {} : _props$onClose,
    children = props.children;
  var modalSlideRef = useRef();
  var uiState = useSBUIState();
  var assetsPath = (uiState === null || uiState === void 0 ? void 0 : uiState.assetsPath) || './';
  var fwcModalSlideProps = getFwcProps$1(props, {
    open: 'open',
    full: 'full',
    direction: 'direction',
    openByAttribute: 'open-by-attribute',
    labelAriaCloseBtn: 'label-aria-close-button',
    labelAriaModalHeader: 'label-aria-modal-header'
  }, {
    direction: 'left'
  });
  var handleClose = useCallback(function (event) {
    event.stopPropagation();
    onClose === null || onClose === void 0 ? void 0 : onClose(event);
  }, [onClose]);
  useEffect(function () {
    if (modalSlideRef !== null && modalSlideRef !== void 0 && modalSlideRef.current) {
      new FwcModalSlide(modalSlideRef.current).build();
    }
  }, []);
  useEffect(function () {
    var modalSlideElement = null;
    if (modalSlideRef !== null && modalSlideRef !== void 0 && modalSlideRef.current) {
      var _modalSlideRef$curren;
      new FwcModalSlide(modalSlideRef === null || modalSlideRef === void 0 ? void 0 : modalSlideRef.current).build();
      modalSlideRef === null || modalSlideRef === void 0 ? void 0 : (_modalSlideRef$curren = modalSlideRef.current) === null || _modalSlideRef$curren === void 0 ? void 0 : _modalSlideRef$curren.addEventListener('fwc-modal-close', handleClose);
      modalSlideElement = modalSlideRef === null || modalSlideRef === void 0 ? void 0 : modalSlideRef.current;
    }
    return function () {
      if (modalSlideElement) {
        modalSlideElement.removeEventListener('fwc-modal-close', handleClose);
      }
    };
  }, [handleClose]);
  return jsx("fwc-modal-slide", _extends$1({}, fwcModalSlideProps, {
    config: JSON.stringify({
      assetsPath: assetsPath
    }),
    ref: mergeRefs(ref, modalSlideRef),
    "open-by-attribute": true
  }), jsx("div", {
    className: "fwc-modal-slide-container"
  }, children));
});
ModalSlide.displayName = 'ModalSlide';

// To get the body content of modal slide
ModalSlide.Body = ModalSlideBody;
ModalSlide.Body.displayName = 'ModalSlide.Body';

// To get the footer part of Modal slide
ModalSlide.Footer = ModalSlideFooter;
ModalSlide.Footer.displayName = 'ModalSlide.Footer';
ModalSlide.propTypes = {
  open: bool,
  className: string,
  direction: oneOf(['top', 'bottom', 'left', 'right']),
  full: bool,
  labelAriaCloseBtn: string,
  labelAriaModalHeader: string,
  onClose: func,
  children: node$2
};

var Pagination = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    totalPages = props.totalPages,
    activePage = props.activePage,
    onChange = props.onChange;
  var paginationRef = useRef();
  var fwcPaginationProps = getFwcProps$1(props, {
    labelAriaNav: 'label-aria-nav',
    labelAriaNext: 'label-aria-next',
    labelAriaPrev: 'label-aria-prev',
    align: 'alignment'
  }, {
    labelAriaNav: 'Pagination',
    labelAriaNext: 'Next Page',
    labelAriaPrev: 'Previous Page'
  });
  var updatePagination = useCallback(function (e) {
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  }, [onChange]);
  useEffect(function () {
    if (paginationRef !== null && paginationRef !== void 0 && paginationRef.current) {
      new FwcPagination(paginationRef === null || paginationRef === void 0 ? void 0 : paginationRef.current).build();
    }
  }, []);
  useEffect(function () {
    var paginationElement = null;
    if (paginationRef !== null && paginationRef !== void 0 && paginationRef.current) {
      var _paginationRef$curren, _paginationRef$curren2;
      new FwcPagination(paginationRef.current).build();
      (_paginationRef$curren = (_paginationRef$curren2 = paginationRef.current).addEventListener) === null || _paginationRef$curren === void 0 ? void 0 : _paginationRef$curren.call(_paginationRef$curren2, 'fwc-pagination-update', updatePagination);
      paginationElement = paginationRef.current;
    }
    return function () {
      if (paginationElement) {
        var _paginationElement$re, _paginationElement;
        (_paginationElement$re = (_paginationElement = paginationElement).removeEventListener) === null || _paginationElement$re === void 0 ? void 0 : _paginationElement$re.call(_paginationElement, 'fwc-pagination-update', updatePagination);
      }
    };
  }, [updatePagination]);
  return jsx("fwc-pagination", _extends$1({}, fwcPaginationProps, {
    "class": cx('fwc-pagination', className),
    ref: mergeRefs(paginationRef, ref),
    model: JSON.stringify({
      totalPages: totalPages,
      activePage: activePage
    })
  }));
});
Pagination.displayName = 'Pagination';
Pagination.propTypes = {
  className: string,
  align: oneOf(['left', 'center', 'right']),
  labelAriaNav: string,
  labelAriaNext: string,
  labelAriaPrev: string,
  totalPages: number$4,
  activePage: number$4,
  onChange: func
};

var css_248z$1 = "/* Regular list structure\n   <ul>\n    <li></li>\n    <li>\n     <ul>\n      <li></li>\n    </ul>\n  </ul>\n*/\n.fwc-list {\n  padding-left: calc(2 * var(--fwcu));\n}\n.fwc-list li {\n  margin-bottom: calc(2 * var(--fwcu));\n  list-style-type: disc;\n}\n.fwc-list li::marker {\n  color: var(--color-gray-three);\n  font-size: 90%;\n}\n.fwc-list > li::marker {\n  background: var(--color-gray-three);\n}\n.fwc-list ul {\n  margin-top: calc(2 * var(--fwcu));\n}\n.fwc-list > li > ul {\n  padding: 0;\n  padding-left: calc(2 * var(--fwcu));\n}\n.fwc-list > li > ul > li {\n  list-style-type: circle;\n}\n.fwc-list-generic li {\n  margin-bottom: var(--fwcu);\n}\n/*\n  Keeping CSS, but will not show in documentation\n  Flexing li for alignment of dot breaks sublists and any other content inside li\n  Use fwc-list for all non-icon lists\n*/\n.fwc-list-dot li {\n  display: flex;\n  align-items: flex-start;\n  color: var(--color-gray-one);\n  letter-spacing: 0;\n  margin-bottom: calc(2 * var(--fwcu));\n}\n.fwc-list-dot li::before {\n  margin-right: var(--fwcu);\n  font-size: calc(3 * var(--fwcu));\n  content: ' \\B7 ';\n  display: inline-block;\n  color: var(--color-gray-three);\n}\n/* List with icon */\n.fwc-list-check li {\n  display: flex;\n  align-items: flex-start;\n  font-size: calc(2.25 * var(--fwcu));\n  line-height: calc(3 * var(--fwcu));\n  color: var(--color-gray-one);\n  margin-bottom: calc(2 * var(--fwcu));\n}\n.fwc-list-check li::before {\n  margin-right: calc(0.5 * var(--fwcu));\n  font-size: calc(3 * var(--fwcu));\n  content: '\\e922';\n  font-family: 'fwc-motif-icons';\n  display: inline-block;\n  color: var(--color-util-two);\n}\n";
styleInject(css_248z$1);

var _excluded$l = ["className", "type"];
function ListItem(props) {
  return jsx("li", _extends$1({}, props, {
    className: cx('fwc-list-item', props.className)
  }));
}
ListItem.propTypes = {
  className: string
};
function List(props) {
  var className = props.className,
    _props$type = props.type,
    type = _props$type === void 0 ? 'default' : _props$type,
    restProps = _objectWithoutProperties$1(props, _excluded$l);
  var listClass = cx({
    'fwc-list-generic': type === 'default',
    'fwc-list': type === 'list',
    'fwc-list-dot': type === 'dot',
    'fwc-list-check': type === 'checked'
  }, className);
  return jsx("ul", _extends$1({}, restProps, {
    className: listClass
  }));
}
List.Item = ListItem;
List.Item.displayName = 'List.Item';
List.propTypes = {
  className: string,
  type: oneOf(['default', 'dot', 'checked'])
};

var _excluded$k = ["className", "isFlipped", "flipDirection", "flipSpeed", "children"];
var cssFlipCard = function cssFlipCard(flipSpeed) {
  return /*#__PURE__*/css("perspective:1000px;transform-style:preserve-3d;.flip-card-flipper{width:100%;height:100%;position:relative;transition:", flipSpeed, "s;transform-style:preserve-3d;.flip-card-front,.flip-card-back{left:0;top:0;height:100%;width:100%;position:absolute;backface-visibility:hidden;transition:", flipSpeed, "s;transform-style:preserve-3d;}}&.horizontal{.flip-card-front{z-index:2;transform:rotateY(0deg);}.flip-card-back{transform:rotateY(-180deg);}&:hover{.flip-card-front{transform:rotateY(180deg);}.flip-card-back{transform:rotateY(0deg);}}&.flipped{.flip-card-front{transform:rotateY(180deg);}.flip-card-back{transform:rotateY(0deg);}}}&.vertical{.flip-card-front{z-index:2;transform:rotateX(0deg);}.flip-card-back{transform:rotateX(-180deg);}&.flipped{.flip-card-front{transform:rotateX(180deg);}.flip-card-back{transform:rotateX(0deg);}}&.hover{.flip-card-front{transform:rotateX(180deg);}.flip-card-back{transform:rotateX(0deg);}}};label:cssFlipCard;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};
var FlipCardFront = function FlipCardFront(props) {
  return jsx("div", _extends$1({}, props, {
    tabIndex: -1,
    className: cx('flip-card-front', props.className)
  }));
};
FlipCardFront.propTypes = {
  className: string
};
var FlipCardBack = function FlipCardBack(props) {
  return jsx("div", _extends$1({}, props, {
    tabIndex: -1,
    className: cx('flip-card-back', props.className)
  }));
};
FlipCardBack.propTypes = {
  className: string
};
var FlipCard = /*#__PURE__*/forwardRef(function (props, ref) {
  var _cx;
  var className = props.className,
    _props$isFlipped = props.isFlipped,
    isFlipped = _props$isFlipped === void 0 ? false : _props$isFlipped,
    _props$flipDirection = props.flipDirection,
    flipDirection = _props$flipDirection === void 0 ? 'horizontal' : _props$flipDirection,
    _props$flipSpeed = props.flipSpeed,
    flipSpeed = _props$flipSpeed === void 0 ? '0.6' : _props$flipSpeed,
    children = props.children,
    rest = _objectWithoutProperties$1(props, _excluded$k);
  var flipCardClass = cx((_cx = {
    'flip-card': true,
    flipped: isFlipped
  }, _defineProperty$1(_cx, flipDirection, flipDirection), _defineProperty$1(_cx, className, className), _cx), className);
  return jsx("div", _extends$1({}, rest, {
    ref: ref,
    css: cssFlipCard(flipSpeed),
    tabIndex: 0,
    className: flipCardClass
  }), jsx("div", {
    className: "flip-card-flipper"
  }, children));
});
FlipCard.displayName = 'FlipCard';
FlipCard.Front = FlipCardFront;
FlipCard.Front.displayName = 'FlipCard.Front';
FlipCard.Back = FlipCardBack;
FlipCard.Back.displayName = 'FlipCard.Back';
FlipCard.propTypes = {
  className: string,
  isFlipped: bool,
  flipSpeed: string,
  flipDirection: oneOf(['horizontal', 'vertical']),
  children: node$2
};

var css_248z = ".fwc-table-overflow {\n  overflow-x: auto;\n  /* Wrapper for table to scroll in when it can't shrink any further */\n  /* Not required */\n}\n.fwc-table {\n  border-spacing: 0;\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: calc(2.5 * var(--fwcu));\n  background-color: transparent;\n}\n.fwc-table tr:first-child th:first-child {\n  border-top-left-radius: var(--border-radius);\n}\n.fwc-table tr:first-child th:last-child {\n  border-top-right-radius: var(--border-radius);\n}\n.fwc-table tr:last-child td:first-child {\n  border-bottom-left-radius: var(--border-radius);\n}\n.fwc-table tr:last-child td:last-child {\n  border-bottom-right-radius: var(--border-radius);\n}\n.fwc-table th {\n  text-align: left;\n}\n.fwc-table th,\n.fwc-table td {\n  padding: var(--fwcu) calc(4 * var(--fwcu));\n}\n.fwc-table th {\n  background: var(--color-gray-six);\n  color: var(--color-gray-two);\n  font-weight: bold;\n  text-transform: uppercase;\n}\n.fwc-table td {\n  font-size: calc(2 * var(--fwcu));\n  font-weight: 400;\n  color: var(--color-gray-one);\n}\n.fwc-table td {\n  border-right: 1px solid var(--color-gray-six);\n}\n.fwc-table td:first-child {\n  border-left: 1px solid var(--color-gray-six);\n}\n.fwc-table tr:last-child td {\n  border-bottom: 1px solid var(--color-gray-six);\n}\n.fwc-table.no-cell-borders td {\n  border-right: 0px;\n}\n.fwc-table.no-cell-borders td:last-child {\n  border-right: 1px solid var(--color-gray-six);\n}\n.fwc-table tr {\n  background: var(--color-white);\n}\n.fwc-table tr:nth-child(2n + 2) {\n  background: var(--color-gray-five);\n}\n.fwc-table .fwc-text-right {\n  text-align: right;\n}\n.fwc-table .fwc-text-center {\n  text-align: center;\n}\n.fwc-table-extensive .hide-lg {\n  display: none;\n}\n.fwc-table button.fwc-icon-caret-filled {\n  font-size: calc(1.25 * var(--fwcu));\n  border: none;\n  padding: 0;\n  margin: 0;\n  margin-left: var(--fwcu);\n  color: var(--color-gray-one);\n  transform: rotate(0deg);\n  transition: transform 250ms ease;\n  background: transparent;\n}\n.fwc-table button.fwc-icon-caret-filled:hover {\n  cursor: pointer;\n}\n.fwc-table button.fwc-icon-caret-filled.descending {\n  transform: rotate(180deg);\n}\n@media screen and (max-width: 600px) {\n  /** Overrides for base .fwc-table styles */\n  .fwc-table td,\n  .fwc-table th {\n    padding: var(--fwcu) calc(2 * var(--fwcu));\n  }\n  .fwc-table.fwc-table-extensive td {\n    border: none;\n    padding: 0 calc(2 * var(--fwcu));\n  }\n  .fwc-table.fwc-table-extensive tr:last-child td {\n    border: none;\n  }\n  .fwc-table.fwc-table-extensive tr:nth-child(2n + 2) {\n    background: var(--color-white);\n  }\n  .fwc-table.fwc-table-extensive tr:last-child td:first-child {\n    border-bottom-left-radius: 0;\n  }\n\n  .fwc-table-extensive table,\n  .fwc-table-extensive thead,\n  .fwc-table-extensive tbody,\n  .fwc-table-extensive th,\n  .fwc-table-extensive td,\n  .fwc-table-extensive tr {\n    display: block;\n    font-size: calc(1.75 * var(--fwcu));\n  }\n  .fwc-table-extensive .hide-lg {\n    display: block;\n    padding: 0 calc(2 * var(--fwcu));\n    font-weight: bold;\n  }\n  .fwc-table-extensive tbody tr td:nth-child(2) {\n    /** Styles for the first visible \"header\" on mobile view */\n    padding-top: calc(3 * var(--fwcu));\n    padding-bottom: calc(0.5 * var(--fwcu));\n  }\n  .fwc-table-extensive tbody tr td:last-child {\n    padding-bottom: calc(3 * var(--fwcu));\n  }\n  .fwc-table-extensive ul li:last-child {\n    margin-bottom: 0;\n  }\n  .fwc-table-extensive td.table-data-bm {\n    padding-bottom: calc(3 * var(--fwcu));\n  }\n  .fwc-table-extensive thead tr {\n    /** Hide table headers visually but leave on the page for accessibility */\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n  .fwc-table-extensive tbody tr {\n    margin-bottom: calc(1.5 * var(--fwcu));\n    border-radius: var(--border-radius);\n    border: 1px solid var(--color-gray-six);\n  }\n  .fwc-table-extensive tbody tr td:first-child {\n    border-top-left-radius: var(--border-radius);\n    border-top-right-radius: var(--border-radius);\n    background-color: var(--color-gray-six);\n    color: var(--color-gray-two);\n    padding: calc(1.5 * var(--fwcu));\n  }\n  .fwc-table-extensive td {\n    border-bottom: 1px solid var(--color-gray-six);\n    position: relative;\n    white-space: normal;\n    text-align: left;\n  }\n  .fwc-table-extensive td:first-child {\n    padding-left: calc(1.5 * var(--fwcu));\n  }\n}\n";
styleInject(css_248z);

var _excluded$j = ["extensive", "overflow", "noBorders", "data", "columns", "sortBy", "sortOrder", "className"];
function Table(props) {
  var extensive = props.extensive,
    overflow = props.overflow,
    noBorders = props.noBorders,
    data = props.data,
    columns = props.columns,
    sortBy = props.sortBy,
    sortOrder = props.sortOrder,
    className = props.className,
    restProps = _objectWithoutProperties$1(props, _excluded$j);
  var tableClass = cx(_defineProperty$1({
    'fwc-table': true,
    'fwc-table-extensive': extensive,
    'no-cell-borders': noBorders
  }, className, !!className));
  var sortOrderClass = cx({
    'fwc-icon': true,
    'fwc-icon-caret-filled': true,
    descending: sortOrder === 'descend'
  });
  var sortFunction = function sortFunction(col) {
    var _props$onSortChange;
    var details = {
      column: col === null || col === void 0 ? void 0 : col.key,
      sortOrder: sortOrder
    };
    (_props$onSortChange = props.onSortChange) === null || _props$onSortChange === void 0 ? void 0 : _props$onSortChange.call(props, details);
  };
  return jsx("div", {
    className: cx('table-wrapper', {
      'fwc-table-overflow': overflow
    })
  }, jsx("table", _extends$1({}, restProps, {
    className: cx(tableClass)
  }), ((columns === null || columns === void 0 ? void 0 : columns.length) || (data === null || data === void 0 ? void 0 : data.length)) > 0 ? jsx(React__default.Fragment, null, jsx("thead", null, jsx("tr", null, columns === null || columns === void 0 ? void 0 : columns.map(function (col) {
    return jsx("th", {
      key: col === null || col === void 0 ? void 0 : col.key,
      scope: "col",
      className: col !== null && col !== void 0 && col.textAlign ? "fwc-text-".concat(col === null || col === void 0 ? void 0 : col.textAlign) : '',
      onClick: function onClick() {
        return sortFunction(col);
      }
    }, jsx("span", null, col === null || col === void 0 ? void 0 : col.title), sortOrder && (col === null || col === void 0 ? void 0 : col.key) === sortBy && jsx("button", {
      className: sortOrderClass
    }));
  }))), jsx("tbody", null, data === null || data === void 0 ? void 0 : data.map(function (row) {
    return jsx("tr", {
      key: row === null || row === void 0 ? void 0 : row.key
    }, columns === null || columns === void 0 ? void 0 : columns.map(function (col) {
      var _col$render;
      return jsx("td", {
        key: col === null || col === void 0 ? void 0 : col.key,
        className: col !== null && col !== void 0 && col.textAlign ? "fwc-text-".concat(col === null || col === void 0 ? void 0 : col.textAlign) : ''
      }, (col === null || col === void 0 ? void 0 : (_col$render = col.render) === null || _col$render === void 0 ? void 0 : _col$render.call(col, row === null || row === void 0 ? void 0 : row[col === null || col === void 0 ? void 0 : col.key], row)) || (row === null || row === void 0 ? void 0 : row[col === null || col === void 0 ? void 0 : col.key]));
    }));
  }))) : props.children));
}
Table.propTypes = {
  extensive: bool,
  overflow: bool,
  noBorders: bool,
  className: string,
  columns: arrayOf(shape({
    key: oneOfType([string, number$4]),
    title: any,
    textAlign: oneOf(['left', 'center', 'right']),
    render: func
  })),
  data: array$2,
  sortBy: string,
  sortOrder: oneOf(['ascend', 'descend']),
  noBorder: bool,
  onSortChange: func,
  children: node$2
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$j() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssCheckboxContent = process.env.NODE_ENV === "production" ? {
  name: "s9j6a7-cssCheckboxContent",
  styles: ".selectAllOption{margin-bottom:20px;padding-bottom:20px;border-bottom:1px solid #ccc;}.allOptions{display:flex;flex-flow:row wrap;.option{width:33%;margin:2px 0px;.fwc-checkbox label{padding:2px;}}@media screen and (max-width: 600px){.option{width:50%;}}@media screen and (max-width: 420px){.option{width:100%;}}};label:cssCheckboxContent;"
} : {
  name: "s9j6a7-cssCheckboxContent",
  styles: ".selectAllOption{margin-bottom:20px;padding-bottom:20px;border-bottom:1px solid #ccc;}.allOptions{display:flex;flex-flow:row wrap;.option{width:33%;margin:2px 0px;.fwc-checkbox label{padding:2px;}}@media screen and (max-width: 600px){.option{width:50%;}}@media screen and (max-width: 420px){.option{width:100%;}}};label:cssCheckboxContent;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$j
};
var CheckboxContent = function CheckboxContent(props) {
  var options = props.options,
    onSelectAll = props.onSelectAll,
    onSelectOption = props.onSelectOption;
  return jsx("div", {
    css: cssCheckboxContent
  }, jsx("div", {
    className: "selectAllOption"
  }, jsx(Checkbox, {
    label: "Select All",
    value: "selectAll",
    name: "selectAll",
    checked: !options.some(function (opt) {
      return !(opt !== null && opt !== void 0 && opt.checked || false);
    }),
    onChange: onSelectAll
  })), jsx("div", {
    className: "allOptions"
  }, options.map(function (opt) {
    return jsx("div", {
      className: "option",
      key: opt.value
    }, jsx(Checkbox, {
      disabled: (opt === null || opt === void 0 ? void 0 : opt.disabled) || false,
      label: opt.label,
      value: opt.value,
      name: "option".concat(opt.value),
      checked: opt === null || opt === void 0 ? void 0 : opt.checked,
      onChange: function onChange(e) {
        return onSelectOption(e, opt);
      }
    }));
  })));
};
CheckboxContent.propTypes = {
  options: array$2,
  onSelectAll: func,
  onSelectOption: func
};

var _excluded$i = ["type", "children", "hideIcon", "iconRender", "onIconClick"];
var cssChip = function cssChip(type, hideIcon) {
  return /*#__PURE__*/css("background-color:var(--color-", type, ");border-radius:16px;padding:5px ", hideIcon ? '10px' : '5px', " 5px 10px;color:", type === 'primary' ? 'white' : 'var(--color-primary)', ";margin:2px;&:hover{background-color:var(--color-", type, "-hover);}&.chip.secondary{border:1px solid var(--color-primary);}.fwc-icon{font-size:calc(100% - 2px);}.chip-action-icon{padding:0px 5px;cursor:pointer;};label:cssChip;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};
var Chip = function Chip(props) {
  var _props$type = props.type,
    type = _props$type === void 0 ? 'primary' : _props$type,
    children = props.children,
    _props$hideIcon = props.hideIcon,
    hideIcon = _props$hideIcon === void 0 ? false : _props$hideIcon,
    iconRender = props.iconRender,
    onIconClick = props.onIconClick,
    rest = _objectWithoutProperties$1(props, _excluded$i);
  var chipClass = cx('chip', type);
  return jsx("span", _extends$1({}, rest, {
    css: cssChip(type, hideIcon),
    className: chipClass
  }), children, !hideIcon && jsx("span", {
    className: "chip-action-icon",
    onClick: onIconClick
  }, iconRender ? iconRender : jsx(Icon, {
    name: "delete"
  })));
};
Chip.propTypes = {
  type: oneOf(['primary', 'secondary']),
  iconRender: oneOfType([string, node$2]),
  hideIcon: bool,
  children: node$2,
  onIconClick: func
};

var _excluded$h = ["onClick", "onRemoveOption", "options", "inputGroupText"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$i() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssMultiSelectControl = process.env.NODE_ENV === "production" ? {
  name: "13w5bw-cssMultiSelectControl",
  styles: "position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%;border-radius:8px;box-shadow:var(--box-shadow-light);&:focus-within{outline:var(--fwc-focus);.filterActionSelect:focus{outline:none;}}.inputGroupText{display:flex;align-items:center;padding:0px 15px;font-weight:400;line-height:1.5;color:#212529;text-align:center;white-space:nowrap;background-color:#ffffff;border:1px solid var(--color-gray-six);border-top-left-radius:8px;border-bottom-left-radius:8px;font-weight:bold;border-right:none;}.filterActionSelect{position:relative;flex:1 1 auto;width:1%;min-width:0;border-top-left-radius:0px;border-bottom-left-radius:0px;text-align:left;border:1px solid var(--color-gray-six);background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZD0iTTAsMTIuOCBDMCwxNC41NjczMTEyIDEuNDMyNjg4OCwxNiAzLjIsMTYgTDMuMiwxNiBMMCwxNiBaIE0xNiwxMi44IEwxNiwxNiBMMTIuOCwxNiBDMTQuNTY3MzExMiwxNiAxNiwxNC41NjczMTEyIDE2LDEyLjggTDE2LDEyLjggWiBNMTYsMy4yIEMxNiwxLjQzMjY4ODggMTQuNTY3MzExMiwwIDEyLjgsMCBMMTIuOCwwIEwxNiwwIFogTTAsMCBMMy4yLDAgQzEuNDMyNjg4OCwwIDAsMS40MzI2ODg4IDAsMy4yIEwwLDMuMiBMMCwwIFoiLz4KICAgIDxwYXRoIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTkuNjQ1NDgzMzkgOS42TDYuNCA5LjZDNi4yMzAyNjE0NCA5LjYgNi4wNjc0NzQ5NCA5LjY2NzQyODM4IDUuOTQ3NDUxNjUgOS43ODc0NTE2NSA1LjcxMDY3MDYyIDEwLjAyNDIzMjcgNS42OTgyMDg0NSAxMC40MDAzODc2IDUuOTEwMDY1MTggMTAuNjUxODM5Nkw1Ljk0NzQ1MTY1IDEwLjY5MjU0ODQgNy41NzAxOTMzNCAxMi4zMTUyOUM3LjgwNjk3NDQgMTIuNTUyMDcxMSA4LjE4MzEyOTM0IDEyLjU2NDUzMzIgOC40MzQ1ODEzMSAxMi4zNTI2NzY1TDguNDc1MjkwMDUgMTIuMzE1MjkgMTAuMDk4MDMxNyAxMC42OTI1NDg0QzEwLjIxODA1NSAxMC41NzI1MjUxIDEwLjI4NTQ4MzQgMTAuNDA5NzM4NiAxMC4yODU0ODM0IDEwLjI0IDEwLjI4NTQ4MzQgOS45MDI2MDQyMiAxMC4wMjQ0MDI1IDkuNjI2MTg3MTcgOS42OTMyNDczNiA5LjYwMTc1NTQyTDkuNjQ1NDgzMzkgOS42ek04LjQ3NTI5MDA1IDMuMzg3NDUxNjVDOC4yMzg1MDg5OSAzLjE1MDY3MDYxIDcuODYyMzU0MDggMy4xMzgyMDg0NSA3LjYxMDkwMjA4IDMuMzUwMDY1MThMNy41NzAxOTMzNCAzLjM4NzQ1MTY1IDUuOTQ3NDUxNjUgNS4wMTAxOTMzNEM1LjgyNzQyODM4IDUuMTMwMjE2NjQgNS43NiA1LjI5MzAwMzE0IDUuNzYgNS40NjI3NDE3IDUuNzYgNS44MDAxMzc0NyA2LjAyMTA4MDkgNi4wNzY1NTQ1MyA2LjM1MjIzNjA2IDYuMTAwOTg2MjdMNi40IDYuMTAyNzQxNyA5LjY0NTQ4MzM5IDYuMTAyNzQxN0M5LjgxNTIyMTk1IDYuMTAyNzQxNyA5Ljk3ODAwODQ1IDYuMDM1MzEzMzEgMTAuMDk4MDMxNyA1LjkxNTI5MDA1IDEwLjMzNDgxMjggNS42Nzg1MDg5OSAxMC4zNDcyNzQ5IDUuMzAyMzU0MDggMTAuMTM1NDE4MiA1LjA1MDkwMjA4TDEwLjA5ODAzMTcgNS4wMTAxOTMzNCA4LjQ3NTI5MDA1IDMuMzg3NDUxNjV6Ii8+CiAgPC9nPgo8L3N2Zz4K),linear-gradient(var(--color-primary), var(--color-primary));background-size:calc(2 * var(--fwcu)) calc(2 * var(--fwcu));background-repeat:no-repeat;background-position:right 10px center;min-height:calc(5 * var(--fwcu));height:auto;padding:5px 30px 5px 5px;&.noInputGroup{border-top-left-radius:8px;border-bottom-left-radius:8px;}.displaySelectedOptions{display:flex;flex-flow:row wrap;line-height:0.5;font-weight:400;.optionPill{line-height:16px;}}};label:cssMultiSelectControl;"
} : {
  name: "13w5bw-cssMultiSelectControl",
  styles: "position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%;border-radius:8px;box-shadow:var(--box-shadow-light);&:focus-within{outline:var(--fwc-focus);.filterActionSelect:focus{outline:none;}}.inputGroupText{display:flex;align-items:center;padding:0px 15px;font-weight:400;line-height:1.5;color:#212529;text-align:center;white-space:nowrap;background-color:#ffffff;border:1px solid var(--color-gray-six);border-top-left-radius:8px;border-bottom-left-radius:8px;font-weight:bold;border-right:none;}.filterActionSelect{position:relative;flex:1 1 auto;width:1%;min-width:0;border-top-left-radius:0px;border-bottom-left-radius:0px;text-align:left;border:1px solid var(--color-gray-six);background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZD0iTTAsMTIuOCBDMCwxNC41NjczMTEyIDEuNDMyNjg4OCwxNiAzLjIsMTYgTDMuMiwxNiBMMCwxNiBaIE0xNiwxMi44IEwxNiwxNiBMMTIuOCwxNiBDMTQuNTY3MzExMiwxNiAxNiwxNC41NjczMTEyIDE2LDEyLjggTDE2LDEyLjggWiBNMTYsMy4yIEMxNiwxLjQzMjY4ODggMTQuNTY3MzExMiwwIDEyLjgsMCBMMTIuOCwwIEwxNiwwIFogTTAsMCBMMy4yLDAgQzEuNDMyNjg4OCwwIDAsMS40MzI2ODg4IDAsMy4yIEwwLDMuMiBMMCwwIFoiLz4KICAgIDxwYXRoIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTkuNjQ1NDgzMzkgOS42TDYuNCA5LjZDNi4yMzAyNjE0NCA5LjYgNi4wNjc0NzQ5NCA5LjY2NzQyODM4IDUuOTQ3NDUxNjUgOS43ODc0NTE2NSA1LjcxMDY3MDYyIDEwLjAyNDIzMjcgNS42OTgyMDg0NSAxMC40MDAzODc2IDUuOTEwMDY1MTggMTAuNjUxODM5Nkw1Ljk0NzQ1MTY1IDEwLjY5MjU0ODQgNy41NzAxOTMzNCAxMi4zMTUyOUM3LjgwNjk3NDQgMTIuNTUyMDcxMSA4LjE4MzEyOTM0IDEyLjU2NDUzMzIgOC40MzQ1ODEzMSAxMi4zNTI2NzY1TDguNDc1MjkwMDUgMTIuMzE1MjkgMTAuMDk4MDMxNyAxMC42OTI1NDg0QzEwLjIxODA1NSAxMC41NzI1MjUxIDEwLjI4NTQ4MzQgMTAuNDA5NzM4NiAxMC4yODU0ODM0IDEwLjI0IDEwLjI4NTQ4MzQgOS45MDI2MDQyMiAxMC4wMjQ0MDI1IDkuNjI2MTg3MTcgOS42OTMyNDczNiA5LjYwMTc1NTQyTDkuNjQ1NDgzMzkgOS42ek04LjQ3NTI5MDA1IDMuMzg3NDUxNjVDOC4yMzg1MDg5OSAzLjE1MDY3MDYxIDcuODYyMzU0MDggMy4xMzgyMDg0NSA3LjYxMDkwMjA4IDMuMzUwMDY1MThMNy41NzAxOTMzNCAzLjM4NzQ1MTY1IDUuOTQ3NDUxNjUgNS4wMTAxOTMzNEM1LjgyNzQyODM4IDUuMTMwMjE2NjQgNS43NiA1LjI5MzAwMzE0IDUuNzYgNS40NjI3NDE3IDUuNzYgNS44MDAxMzc0NyA2LjAyMTA4MDkgNi4wNzY1NTQ1MyA2LjM1MjIzNjA2IDYuMTAwOTg2MjdMNi40IDYuMTAyNzQxNyA5LjY0NTQ4MzM5IDYuMTAyNzQxN0M5LjgxNTIyMTk1IDYuMTAyNzQxNyA5Ljk3ODAwODQ1IDYuMDM1MzEzMzEgMTAuMDk4MDMxNyA1LjkxNTI5MDA1IDEwLjMzNDgxMjggNS42Nzg1MDg5OSAxMC4zNDcyNzQ5IDUuMzAyMzU0MDggMTAuMTM1NDE4MiA1LjA1MDkwMjA4TDEwLjA5ODAzMTcgNS4wMTAxOTMzNCA4LjQ3NTI5MDA1IDMuMzg3NDUxNjV6Ii8+CiAgPC9nPgo8L3N2Zz4K),linear-gradient(var(--color-primary), var(--color-primary));background-size:calc(2 * var(--fwcu)) calc(2 * var(--fwcu));background-repeat:no-repeat;background-position:right 10px center;min-height:calc(5 * var(--fwcu));height:auto;padding:5px 30px 5px 5px;&.noInputGroup{border-top-left-radius:8px;border-bottom-left-radius:8px;}.displaySelectedOptions{display:flex;flex-flow:row wrap;line-height:0.5;font-weight:400;.optionPill{line-height:16px;}}};label:cssMultiSelectControl;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
};
var MultiSelectControl$1 = function MultiSelectControl(props) {
  var onClick = props.onClick,
    onRemoveOption = props.onRemoveOption,
    options = props.options,
    inputGroupText = props.inputGroupText,
    restProps = _objectWithoutProperties$1(props, _excluded$h);
  var handleRemoveClick = function handleRemoveClick(event, value) {
    event.preventDefault();
    event.stopPropagation();
    onRemoveOption === null || onRemoveOption === void 0 ? void 0 : onRemoveOption(value);
  };
  return jsx("div", {
    css: cssMultiSelectControl
  }, inputGroupText && jsx("span", {
    className: "inputGroupText"
  }, inputGroupText), jsx(Button, _extends$1({}, restProps, {
    btnType: "secondary",
    className: "filterActionSelect ".concat(!inputGroupText ? 'noInputGroup' : ''),
    onClick: onClick
  }), jsx("div", {
    className: "displaySelectedOptions"
  }, options.map(function (opt) {
    return jsx(Chip, {
      className: "optionPill",
      key: opt.value,
      onIconClick: function onIconClick(e) {
        return handleRemoveClick(e, opt.value);
      }
    }, opt.label);
  }))));
};
MultiSelectControl$1.propTypes = {
  inputGroupText: string,
  options: array$2,
  onClick: func,
  onRemoveOption: func
};

var _excluded$g = ["defaultValue", "value", "options", "onChange", "prefixText", "labelMobileHeader", "labelApplyButton", "labelCancelButton", "labelResetButton", "hideCancelButton", "hideResetButton"];
function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$a(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var overrideStyles$6 = "\n  .fwc-panel-container .fwc-panel-wrapper {\n    width: 100%;\n  }\n  .fwc-panel-container .fwc-panel-footer {\n    box-shadow: rgb(50 50 50 / 10%) 0px -4px 3px 0px;\n    z-index: 3;\n  }\n  .fwc-panel-apply-cancel-wrapper {\n    margin-left: auto;\n  }\n";
var getDisplayedOptions = function getDisplayedOptions(options, selectedValues) {
  return options.map(function (opt) {
    var isChecked = selectedValues.some(function (dv) {
      return dv.value === opt.value;
    });
    var option = _objectSpread$a(_objectSpread$a({}, opt), {}, {
      checked: isChecked
    });
    return option;
  });
};
var getCommonSelectedOptions = function getCommonSelectedOptions(options, bufferOptions) {
  return options.map(function (opt) {
    if (bufferOptions.find(function (bopt) {
      return bopt.value === opt.value;
    })) {
      var option = bufferOptions.find(function (dv) {
        return dv.value === opt.value;
      });
      return _objectSpread$a(_objectSpread$a({}, opt), {}, {
        checked: option.checked
      });
    }
    return opt;
  });
};

// Main Component
// -----------------------------------------------------
function MultiSelectCheckbox(props) {
  var _props$defaultValue = props.defaultValue,
    defaultValue = _props$defaultValue === void 0 ? [] : _props$defaultValue,
    _props$value = props.value,
    value = _props$value === void 0 ? [] : _props$value,
    _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    onChange = props.onChange,
    prefixText = props.prefixText,
    _props$labelMobileHea = props.labelMobileHeader,
    labelMobileHeader = _props$labelMobileHea === void 0 ? 'Select Options' : _props$labelMobileHea,
    _props$labelApplyButt = props.labelApplyButton,
    labelApplyButton = _props$labelApplyButt === void 0 ? 'Apply' : _props$labelApplyButt,
    _props$labelCancelBut = props.labelCancelButton,
    labelCancelButton = _props$labelCancelBut === void 0 ? 'Cancel' : _props$labelCancelBut,
    _props$labelResetButt = props.labelResetButton,
    labelResetButton = _props$labelResetButt === void 0 ? 'Reset' : _props$labelResetButt,
    _props$hideCancelButt = props.hideCancelButton,
    hideCancelButton = _props$hideCancelButt === void 0 ? false : _props$hideCancelButt,
    _props$hideResetButto = props.hideResetButton,
    hideResetButton = _props$hideResetButto === void 0 ? false : _props$hideResetButto,
    rest = _objectWithoutProperties$1(props, _excluded$g);
  var filterPanelRef = useRef();
  var multiSelectCheckboxCustomStyle = useRef(document.createElement('style'));
  var uiState = useSBUIState();
  var assetsPath = (uiState === null || uiState === void 0 ? void 0 : uiState.assetsPath) || './';
  var _useState = useState([]),
    _useState2 = _slicedToArray$1(_useState, 2),
    displayedOptions = _useState2[0],
    setDisplayedOPtions = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray$1(_useState3, 2),
    bufferOptions = _useState4[0],
    setBufferOptions = _useState4[1];
  var handlePanelApply = useCallback(function (e) {
    e.preventDefault();
    var values = getCommonSelectedOptions(displayedOptions, bufferOptions).filter(function (opt) {
      return opt.checked;
    });
    setBufferOptions([]);
    onChange === null || onChange === void 0 ? void 0 : onChange(values);
  }, [onChange, bufferOptions, displayedOptions]);
  var handlePanelCancel = useCallback(function (e) {
    e.preventDefault();
    setBufferOptions([]);
  }, []);
  var handlePanelReset = useCallback(function (e) {
    e.preventDefault();
    var defaultSelectedOptions = getDisplayedOptions(options, defaultValue);
    setDisplayedOPtions(defaultSelectedOptions);
    setBufferOptions([]);
    onChange === null || onChange === void 0 ? void 0 : onChange(defaultValue);
  }, [onChange, defaultValue, options]);
  var handleActionOnChange = function handleActionOnChange() {
    filterPanelRef.current.togglePanel();
  };
  var handleRemoveOption = function handleRemoveOption(value) {
    var selectedOptions = displayedOptions.filter(function (opt) {
      return opt.checked && opt.value !== value;
    });
    onChange === null || onChange === void 0 ? void 0 : onChange(selectedOptions);
  };
  var handleSelectAll = function handleSelectAll(event) {
    var commonSelectedOptions = getCommonSelectedOptions(displayedOptions, bufferOptions);
    setBufferOptions(commonSelectedOptions.map(function (opt) {
      return _objectSpread$a(_objectSpread$a({}, opt), {}, {
        checked: event.target.checked
      });
    }));
  };
  var handleSelectOption = function handleSelectOption(event, option) {
    var value = event.target.value || '';
    setBufferOptions(function (old) {
      if (old.some(function (opt) {
        return opt.value === value;
      })) {
        return old.map(function (opt) {
          return opt.value === value ? _objectSpread$a(_objectSpread$a({}, opt), {}, {
            checked: !(opt !== null && opt !== void 0 && opt.checked || false)
          }) : opt;
        });
      }
      return [].concat(_toConsumableArray(old), [_objectSpread$a(_objectSpread$a({}, option), {}, {
        checked: !(option !== null && option !== void 0 && option.checked || false)
      })]);
    });
  };
  useEffect(function () {
    if (displayedOptions.length === 0) {
      var defaultOption = getDisplayedOptions(options, [].concat(_toConsumableArray(value || []), _toConsumableArray(defaultValue || [])));
      setDisplayedOPtions(defaultOption);
    } else {
      var _defaultOption = getDisplayedOptions(options, value);
      setDisplayedOPtions(_defaultOption);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue, value, options]);
  useEffect(function () {
    if (filterPanelRef.current) {
      new FwcPanel(filterPanelRef.current).build();
      var filterPanelShadowDOM = filterPanelRef.current.shadowRoot;
      multiSelectCheckboxCustomStyle.current.innerHTML = overrideStyles$6;
      setTimeout(function () {
        filterPanelShadowDOM.appendChild(multiSelectCheckboxCustomStyle.current);
      }, 0);
    }
  }, []);
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(e) {
      if (filterPanelRef.current.__open) {
        if (filterPanelRef.current && !filterPanelRef.current.contains(e.target)) {
          filterPanelRef.current.togglePanel();
        }
      }
    };
    document.addEventListener('click', handleClickOutside, false);
    document.addEventListener('touchstart', handleClickOutside, false);
    return function () {
      document.removeEventListener('click', handleClickOutside, false);
      document.removeEventListener('touchstart', handleClickOutside, false);
    };
  }, []);
  useEffect(function () {
    var filterPanelElement = null;
    if (filterPanelRef !== null && filterPanelRef !== void 0 && filterPanelRef.current) {
      filterPanelRef.current.addEventListener('fwc-panel-apply', handlePanelApply);
      filterPanelRef.current.addEventListener('fwc-panel-cancel', handlePanelCancel);
      filterPanelRef.current.addEventListener('fwc-panel-reset', handlePanelReset);
      filterPanelElement = filterPanelRef.current;
    }
    return function () {
      if (filterPanelElement) {
        filterPanelElement.removeEventListener('fwc-panel-apply', handlePanelApply);
        filterPanelElement.removeEventListener('fwc-panel-cancel', handlePanelCancel);
        filterPanelElement.removeEventListener('fwc-panel-reset', handlePanelReset);
      }
    };
  }, [handlePanelApply, handlePanelCancel, handlePanelReset]);
  return jsx("fwc-panel", _extends$1({}, rest, hideCancelButton ? {
    'hide-cancel-button': true
  } : {}, hideResetButton ? {
    'hide-reset-button': true
  } : {}, {
    config: JSON.stringify({
      assetsPath: assetsPath
    }),
    "label-mobile-header": labelMobileHeader,
    "label-reset-button": labelResetButton,
    "label-cancel-button": labelCancelButton,
    "label-apply-button": labelApplyButton,
    ref: filterPanelRef
  }), jsx("div", {
    slot: "fwc-panel-action"
  }, jsx(MultiSelectControl$1, {
    inputGroupText: prefixText,
    options: displayedOptions.filter(function (opt) {
      return opt.checked;
    }),
    onClick: handleActionOnChange,
    onRemoveOption: handleRemoveOption
  })), jsx("div", {
    slot: "fwc-panel-content"
  }, jsx(CheckboxContent, {
    options: getCommonSelectedOptions(displayedOptions, bufferOptions),
    onSelectAll: handleSelectAll,
    onSelectOption: handleSelectOption
  })));
}
MultiSelectCheckbox.propTypes = {
  prefixText: string,
  defaultValue: array$2,
  value: array$2,
  options: array$2,
  labelMobileHeader: string,
  labelApplyButton: string,
  labelCancelButton: string,
  labelResetButton: string,
  hideCancelButton: bool,
  hideResetButton: bool,
  onChange: func
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$h() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssDatePickerHorizontal = process.env.NODE_ENV === "production" ? {
  name: "1bohkrf-cssDatePickerHorizontal",
  styles: "display:flex;flex-flow:row nowrap;.field-label{width:30%;margin-top:10px;margin-right:10px;text-align:right;}.field-control{width:70%;}@media screen and (max-width: 420px){flex-flow:column wrap;.field-label{width:100%;margin-top:0px;margin-right:0px;text-align:start;}.field-control{width:100%;}};label:cssDatePickerHorizontal;"
} : {
  name: "1bohkrf-cssDatePickerHorizontal",
  styles: "display:flex;flex-flow:row nowrap;.field-label{width:30%;margin-top:10px;margin-right:10px;text-align:right;}.field-control{width:70%;}@media screen and (max-width: 420px){flex-flow:column wrap;.field-label{width:100%;margin-top:0px;margin-right:0px;text-align:start;}.field-control{width:100%;}};label:cssDatePickerHorizontal;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$h
};
var cssDatePickerVertical = process.env.NODE_ENV === "production" ? {
  name: "1yj2ua8-cssDatePickerVertical",
  styles: "display:flex;flex-flow:column wrap;label:cssDatePickerVertical;"
} : {
  name: "1yj2ua8-cssDatePickerVertical",
  styles: "display:flex;flex-flow:column wrap;label:cssDatePickerVertical;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$h
};
var cssDatePicker = process.env.NODE_ENV === "production" ? {
  name: "b55zdx-cssDatePicker",
  styles: "margin-bottom:20px;.field-label{.datepicker-label{font-weight:bold;}}&.date-picker-disabled{.field-label{opacity:calc(var(--disabled-opacity) + 0.2);}};label:cssDatePicker;"
} : {
  name: "b55zdx-cssDatePicker",
  styles: "margin-bottom:20px;.field-label{.datepicker-label{font-weight:bold;}}&.date-picker-disabled{.field-label{opacity:calc(var(--disabled-opacity) + 0.2);}};label:cssDatePicker;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$h
};
var overrideStyles$5 = "\n  .fwc-date-picker-wrapper .fwc-input label.fwc-label {\n    display: none;\n  }\n\n  .fwc-date-picker-wrapper\n    .fwc-date-picker-input\n    input:disabled[aria-invalid='true'] {\n    border-color: var(--color-alert-error);\n  }\n\n  .fwc-date-picker-wrapper .fwc-date-picker-input input:disabled {\n    opacity: calc(var(--disabled-opacity) + 0.4);\n    border-color: rgba(var(--color-rgb-gray-three), var(--disabled-opacity));\n    background-color: rgba(var(--color-rgb-white), var(--disabled-opacity));\n  }\n\n  .fwc-date-picker-wrapper .fwc-date-picker-input button:disabled {\n    opacity: calc(var(--disabled-opacity) + 0.4);\n  }\n";
var getFwcProps = function getFwcProps(props, keysMap) {
  var fwcProps = {};
  Object.keys(keysMap).forEach(function (key) {
    var value = props[key];
    if (value) {
      var fwcKey = keysMap[key];
      fwcProps[fwcKey] = JSON.stringify(value);
    }
  });
  return fwcProps;
};
var isDateChanged = function isDateChanged(oldDate, newDate) {
  var _Date, _Date$setHours, _Date2, _Date2$setHours;
  var fromDate = (_Date = new Date(oldDate)) === null || _Date === void 0 ? void 0 : (_Date$setHours = _Date.setHours) === null || _Date$setHours === void 0 ? void 0 : _Date$setHours.call(_Date, 0, 0, 0, 0);
  var toDate = (_Date2 = new Date(newDate)) === null || _Date2 === void 0 ? void 0 : (_Date2$setHours = _Date2.setHours) === null || _Date2$setHours === void 0 ? void 0 : _Date2$setHours.call(_Date2, 0, 0, 0, 0);
  return fromDate !== toDate;
};
var DatePicker = /*#__PURE__*/forwardRef(function (props, ref) {
  var id = props.id,
    className = props.className,
    name = props.name,
    label = props.label,
    _props$value = props.value,
    value = _props$value === void 0 ? null : _props$value,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? 'MM/DD/YYYY' : _props$placeholder,
    disabled = props.disabled,
    touched = props.touched,
    _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'vertical' : _props$layout,
    helperText = props.helperText,
    onFocus = props.onFocus,
    onChange = props.onChange,
    onBlur = props.onBlur;
  var calendarRef = useRef();
  var dataPickerCustomStyle = useRef(document.createElement('style'));
  var uiState = useSBUIState();
  var assetsPath = (uiState === null || uiState === void 0 ? void 0 : uiState.assetsPath) || './';
  var selectDivClass = cx('date-picker-field', {
    'date-picker-disabled': disabled
  }, className);
  var _useState = useState(value),
    _useState2 = _slicedToArray$1(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var datePickerProps = getFwcProps(props, {
    dayNames: 'day-names',
    dateRange: 'date-range',
    monthNames: 'month-names',
    disabledDates: 'disabled-dates',
    ariaLabelNext: 'label-aria-next',
    ariaLabelDayNames: 'label-aria-day-names',
    ariaLabelCalendarIcon: 'label-aria-calendar-icon',
    ariaLabelMobileApply: 'label-aria-mobile-apply',
    ariaLabelMobileCancel: 'label-aria-mobile-cancel',
    ariaLabelPrevious: 'label-aria-previous',
    mobileCancelLabel: 'btn-mobile-cancel',
    mobileApplyLabel: 'btn-mobile-apply',
    inValidErrorLabel: 'error-invalid-label',
    disabledErrorLabel: 'error-disabled-label',
    disabled: 'disabled'
  });
  var handleDatePickerFocus = useCallback(function (e) {
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
  }, [onFocus]);
  var handleDatePickerBlur = useCallback(function (e) {
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e, name);
  }, [name, onBlur]);
  var handleClearInputValue = useCallback(function (inputValue) {
    var _calendarRef$current;
    var documentFragment = calendarRef === null || calendarRef === void 0 ? void 0 : (_calendarRef$current = calendarRef.current) === null || _calendarRef$current === void 0 ? void 0 : _calendarRef$current.renderRoot;
    if (documentFragment) {
      var inputElement = documentFragment === null || documentFragment === void 0 ? void 0 : documentFragment.getElementById('SelectedDateInput');
      if (inputElement !== null && inputElement !== void 0 && inputElement.value && !inputValue) {
        inputElement.value = '';
      }
    }
  }, []);
  var handleDatePickerChange = useCallback(function (e) {
    var newValue = e === null || e === void 0 ? void 0 : e.detail;
    if (isDateChanged(inputValue, newValue)) {
      var _Date3, _calendarRef$current2, _calendarRef$current3, _calendarRef$current4, _calendarRef$current5;
      var newDate = (_Date3 = new Date(newValue)) === null || _Date3 === void 0 ? void 0 : _Date3.setHours(0, 0, 0, 0);
      var minDate = (_calendarRef$current2 = calendarRef.current) === null || _calendarRef$current2 === void 0 ? void 0 : (_calendarRef$current3 = _calendarRef$current2._calendarMinDate) === null || _calendarRef$current3 === void 0 ? void 0 : _calendarRef$current3.getTime();
      var maxDate = (_calendarRef$current4 = calendarRef.current) === null || _calendarRef$current4 === void 0 ? void 0 : (_calendarRef$current5 = _calendarRef$current4._calendarMaxDate) === null || _calendarRef$current5 === void 0 ? void 0 : _calendarRef$current5.getTime();
      if (newDate >= minDate && newDate <= maxDate) {
        setInputValue(newValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(e, newValue, name);
      } else {
        setInputValue(null);
        onChange === null || onChange === void 0 ? void 0 : onChange(e, null, name);
        handleClearInputValue(null);
      }
    }
  }, [inputValue, name, onChange, handleClearInputValue]);
  var handleDatePickerError = useCallback(function (e) {
    setInputValue(null);
    onChange === null || onChange === void 0 ? void 0 : onChange(e, null, name);
  }, [name, onChange]);
  var handleInputChange = function handleInputChange(e) {
    if (!e.target.value) {
      var _calendarRef$current6;
      calendarRef === null || calendarRef === void 0 ? void 0 : (_calendarRef$current6 = calendarRef.current) === null || _calendarRef$current6 === void 0 ? void 0 : _calendarRef$current6._emitSelectedEvent(undefined);
    }
  };
  useEffect(function () {
    if (isDateChanged(value, inputValue)) {
      setInputValue(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  useEffect(function () {
    if (calendarRef.current) {
      new FwcDatePicker(calendarRef.current).build();
      calendarRef.current._setMinMaxDates();
      var calendarShadowDOM = calendarRef.current.shadowRoot;
      dataPickerCustomStyle.current.innerHTML = overrideStyles$5;
      setTimeout(function () {
        calendarShadowDOM.appendChild(dataPickerCustomStyle.current);
      }, 0);
    }
  }, []);
  useEffect(function () {
    if (calendarRef.current) {
      var _calendarRef$current7, _calendarRef$current8;
      (_calendarRef$current7 = calendarRef.current) === null || _calendarRef$current7 === void 0 ? void 0 : (_calendarRef$current8 = _calendarRef$current7._setMinMaxDates) === null || _calendarRef$current8 === void 0 ? void 0 : _calendarRef$current8.call(_calendarRef$current7);
    }
  }, [props.dateRange]);
  useEffect(function () {
    handleClearInputValue(inputValue);
  }, [inputValue, handleClearInputValue]);
  useEffect(function () {
    var inputElement = null;
    if (calendarRef.current) {
      var _calendarRef$current$, _inputElement;
      inputElement = (_calendarRef$current$ = calendarRef.current.renderRoot) === null || _calendarRef$current$ === void 0 ? void 0 : _calendarRef$current$.getElementById('SelectedDateInput');
      (_inputElement = inputElement) === null || _inputElement === void 0 ? void 0 : _inputElement.addEventListener('change', handleInputChange);
    }
    return function () {
      if (inputElement) {
        var _inputElement2;
        (_inputElement2 = inputElement) === null || _inputElement2 === void 0 ? void 0 : _inputElement2.removeEventListener('change', handleInputChange);
      }
    };
  });
  useEffect(function () {
    setTimeout(function () {
      var _calendarRef$current$2, _calendarRef$current$3;
      (_calendarRef$current$2 = calendarRef.current.renderRoot) === null || _calendarRef$current$2 === void 0 ? void 0 : (_calendarRef$current$3 = _calendarRef$current$2.getElementById('SelectedDateInput')) === null || _calendarRef$current$3 === void 0 ? void 0 : _calendarRef$current$3.setAttribute('placeholder', placeholder);
    }, 0);
  }, [placeholder]);
  useEffect(function () {
    var datePickerElement = null;
    if (calendarRef.current) {
      calendarRef.current.addEventListener('fwc-date-picker-focus', handleDatePickerFocus);
      calendarRef.current.addEventListener('fwc-date-picker-selected', handleDatePickerChange);
      calendarRef.current.addEventListener('fwc-date-picker-blur', handleDatePickerBlur);
      calendarRef.current.addEventListener('fwc-date-picker-error', handleDatePickerError);
      datePickerElement = calendarRef.current;
    }
    return function () {
      if (datePickerElement) {
        datePickerElement.removeEventListener('fwc-date-picker-focus', handleDatePickerFocus);
        datePickerElement.removeEventListener('fwc-date-picker-selected', handleDatePickerChange);
        datePickerElement.removeEventListener('fwc-date-picker-blur', handleDatePickerBlur);
        datePickerElement.removeEventListener('fwc-date-picker-error', handleDatePickerError);
      }
    };
  }, [handleDatePickerFocus, handleDatePickerChange, handleDatePickerBlur, handleDatePickerError]);
  return jsx("div", {
    className: selectDivClass,
    css: [cssDatePicker, layout === 'vertical' ? cssDatePickerVertical : cssDatePickerHorizontal, ";label:DatePicker;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")]
  }, label && jsx("div", {
    className: "field-label"
  }, jsx("label", {
    className: "datepicker-label",
    htmlFor: id || name
  }, label)), jsx("div", {
    className: "field-control"
  }, jsx("fwc-date-picker", _extends$1({}, datePickerProps, touched && helperText ? {
    invalid: true
  } : {}, inputValue ? {
    'show-date': true
  } : {}, {
    "start-date": inputValue,
    ref: mergeRefs(calendarRef, ref),
    config: JSON.stringify({
      assetsPath: assetsPath
    })
  })), jsx(HelperMessage, {
    touched: touched,
    helperText: helperText
  })));
});
DatePicker.displayName = 'DatePicker';
DatePicker.propTypes = {
  id: string,
  name: string,
  className: string,
  touched: bool,
  layout: oneOf(['vertical', 'horizontal']),
  helperText: oneOfType([string, node$2, arrayOf(node$2)]),
  /**
   * Sets the label, defaults to <b>Select a Date</b>.
   */
  label: string,
  /**
   * set the value, defaults is <b>null</b>.
   */
  value: instanceOf(Date),
  /**
   * set the placeholder, defaults is <b>"MM/DD/YYYY"</b>.
   */
  placeholder: string,
  /**
   * set the disabled, defaults is <b>false</b>.
   */
  disabled: bool,
  /**
   * An option to set the aria-label on the calendar icon inside the input field.
   * Default is <b>Toggle Calendar</b>.
   */
  ariaLabelCalendarIcon: string,
  /**
   * An option to set the aria-label on the mobile apply button.
   * Default is <b>Apply</b>
   */
  ariaLabelMobileApply: string,
  /**
   * An option to set the aria-label on the mobile cancel button.
   * Default is <b>Cancel</b>
   */
  ariaLabelMobileCancel: string,
  /**
   * An option to set the aria-label on the next calendar arrow button.
   * default is <b>Next Month</b>
   */
  ariaLabelNext: string,
  /**
   * An option to set the aria-label on the previous calendar arrow button.
   * default is <b>Previous Month</b>
   */
  ariaLabelPrevious: string,
  /**
   * Sets value of Apply button in mobile view. Default is <b>Apply</b>
   */
  mobileApplyLabel: string,
  /**
   * Sets value of Cancel button in mobile view. Default is <b>Cancel</b>
   */
  mobileCancelLabel: string,
  /**
   * Sets value of the error message sent in fwc-date-picker-error when an disabled date is set.
   * Default value is 'Disabled Date'
   */
  disabledErrorLabel: string,
  /**
   * Sets value of the error message sent in fwc-date-picker-error when an invalid date is set.
   * Default value is 'Invalid Date'
   */
  inValidErrorLabel: string,
  /**
   * An array of strings for the aria-label on the <th>, Su - Sa.
   * Default is <b>['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ]</b>
   */
  ariaLabelDayNames: arrayOf(string),
  /**
   * An array of days allowing control of the names in the calendar <th>, Su - Sa.
   * Default is <b>['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']</b>
   */
  dayNames: arrayOf(string),
  /**
   * An array of month names allowing control of the names at the top of the calendar, Jan - Dec.
   * Default is <b>[ 'January','February','March','April','May','June','July','August','September','October','November','December']</b>
   */
  monthNames: arrayOf(any),
  /**
   * An array of js dates to be disabled.
   * Default is <b>[]</b>
   */
  disabledDates: arrayOf(any),
  /**
   * A start and end Date, [startDate, endDate].
   * Default is <b>[null, null]</b>
   */
  dateRange: arrayOf(string),
  // functions
  onFocus: func,
  onChange: func,
  onBlur: func
};

var MediaImgCardActions = function MediaImgCardActions(props) {
  return jsx(React__default.Fragment, null, React__default.Children.map(props.children, function (child) {
    return /*#__PURE__*/React__default.cloneElement(child, {
      slot: 'links'
    });
  }));
};
MediaImgCardActions.propTypes = {
  children: node$2
};
var MediaImgCardBody = function MediaImgCardBody(props) {
  return jsx("p", _extends$1({}, props, {
    slot: "body"
  }));
};
// --------------------------------------------

// Main Component
// --------------------------------------------
var MediaImgCard = /*#__PURE__*/forwardRef(function (props, ref) {
  var showBookmark = props.showBookmark,
    isBookmarkChecked = props.isBookmarkChecked,
    image = props.image,
    onBookmarkClick = props.onBookmarkClick,
    children = props.children;
  var mediaImageRef = useRef();
  var uiState = useSBUIState();
  var assetsPath = (uiState === null || uiState === void 0 ? void 0 : uiState.assetsPath) || './';
  var fwcCardMediaImageProps = getFwcProps$1(props, {
    badge: 'badge',
    badgeClass: 'badge-class',
    ariaLabelBookmark: 'label-aria-bookmark',
    title: 'title',
    size: 'size'
  }, {
    size: 'sm',
    ariaLabelBookmark: 'Bookmark'
  });
  var handleImageBookmark = useCallback(function (e) {
    onBookmarkClick === null || onBookmarkClick === void 0 ? void 0 : onBookmarkClick(e);
  }, [onBookmarkClick]);
  useEffect(function () {
    if (mediaImageRef.current) {
      new FwcCardMediaImage(mediaImageRef.current).build();
    }
  }, []);
  useEffect(function () {
    var imageElement = null;
    if (mediaImageRef.current) {
      mediaImageRef.current.addEventListener('fwc-card-media-image-bookmark', handleImageBookmark);
      imageElement = mediaImageRef.current;
    }
    return function () {
      if (imageElement) {
        imageElement.removeEventListener('fwc-card-media-image-bookmark', handleImageBookmark);
      }
    };
  }, [handleImageBookmark]);
  return jsx("fwc-card-media-image", _extends$1({}, fwcCardMediaImageProps, showBookmark ? {
    bookmark: isBookmarkChecked ? 'checked' : 'unchecked'
  } : {}, {
    ref: mergeRefs(mediaImageRef, ref),
    config: JSON.stringify({
      assetsPath: assetsPath
    }),
    image: JSON.stringify(image)
  }), React__default.Children.map(children, function (child) {
    var _child$type, _child$type2;
    if ((child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'MediaImgCard.Actions') {
      return child;
    }
    if ((child === null || child === void 0 ? void 0 : (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) === 'MediaImgCard.Body') {
      return child;
    }
    console.error("Warning MediaImgCard has children that aren't MediaImgCard.Actions or MediaImgCard.Body components");
    return null;
  }));
});
MediaImgCard.displayName = 'MediaImgCard';
MediaImgCard.Actions = MediaImgCardActions;
MediaImgCard.Actions.displayName = 'MediaImgCard.Actions';
MediaImgCard.Body = MediaImgCardBody;
MediaImgCard.Body.displayName = 'MediaImgCard.Body';
MediaImgCard.propTypes = {
  badge: oneOfType([string, node$2]),
  badgeClass: string,
  title: string,
  showBookmark: bool,
  isBookmarkChecked: bool,
  ariaLabelBookmark: string,
  image: shape({
    source: arrayOf(shape({
      srcset: array$2,
      media: string,
      type: string
    })),
    img: shape({
      src: string,
      alt: string,
      width: string,
      height: string
    })
  }),
  size: oneOf(['sm', 'md', 'lg', 'full']),
  children: node$2,
  onBookmarkClick: func
};

function FilterPanelAction(props) {
  return jsx("div", _extends$1({}, props, {
    className: "fwc-panel-action ".concat(props.className || ''),
    slot: "fwc-panel-action"
  }));
}
FilterPanelAction.propTypes = {
  className: string
};
function FilterPanelContent(props) {
  return jsx("div", _extends$1({}, props, {
    className: "fwc-panel-content ".concat(props.className || ''),
    slot: "fwc-panel-content"
  }));
}
FilterPanelContent.propTypes = {
  className: string
};

// Main Component
// -----------------------------------------------------
var FilterPanel = /*#__PURE__*/forwardRef(function (props, ref) {
  var onApply = props.onApply,
    onCancel = props.onCancel,
    onReset = props.onReset,
    onToggle = props.onToggle,
    children = props.children;
  var filterPanelRef = useRef();
  var uiState = useSBUIState();
  var assetsPath = (uiState === null || uiState === void 0 ? void 0 : uiState.assetsPath) || './';
  var fwcPanelProps = getFwcProps$1(props, {
    id: 'id',
    open: 'open',
    className: 'class',
    labelMobileHeader: 'label-mobile-header',
    labelApplyButton: 'label-apply-button',
    labelResetButton: 'label-reset-button',
    labelCancelButton: 'label-cancel-button',
    hideApplyButton: 'hide-apply-button',
    hideCancelButton: 'hide-cancel-button',
    hideResetButton: 'hide-reset-button'
  }, {
    open: false,
    labelMobileHeader: 'Select Filter(s)',
    labelApplyButton: 'Apply Filters',
    labelCancelButton: 'Close',
    labelResetButton: 'Reset Filters',
    hideApplyButton: false,
    hideCancelButton: false,
    hideResetButton: false
  });
  var handlePanelApply = useCallback(function (event) {
    onToggle === null || onToggle === void 0 ? void 0 : onToggle(event);
    onApply === null || onApply === void 0 ? void 0 : onApply(event);
  }, [onToggle, onApply]);
  var handlePanelCancel = useCallback(function (event) {
    onToggle === null || onToggle === void 0 ? void 0 : onToggle(event);
    onCancel === null || onCancel === void 0 ? void 0 : onCancel(event);
  }, [onToggle, onCancel]);
  var handlePanelReset = useCallback(function (event) {
    onToggle === null || onToggle === void 0 ? void 0 : onToggle(event);
    onReset === null || onReset === void 0 ? void 0 : onReset(event);
  }, [onToggle, onReset]);
  var handlePanelToggle = useCallback(function (event) {
    onToggle === null || onToggle === void 0 ? void 0 : onToggle(event, true);
  }, [onToggle]);
  useEffect(function () {
    if (filterPanelRef.current) {
      new FwcPanel(filterPanelRef.current).build();
    }
  }, []);
  useEffect(function () {
    var filterPanelElement = null;
    if (filterPanelRef.current) {
      filterPanelRef.current.addEventListener('fwc-panel-apply', handlePanelApply);
      filterPanelRef.current.addEventListener('fwc-panel-cancel', handlePanelCancel);
      filterPanelRef.current.addEventListener('fwc-panel-reset', handlePanelReset);
      filterPanelRef.current.addEventListener('fwc-panel-toggled', handlePanelToggle);
      filterPanelElement = filterPanelRef.current;
    }
    return function () {
      if (filterPanelElement) {
        filterPanelElement.removeEventListener('fwc-panel-apply', handlePanelApply);
        filterPanelElement.removeEventListener('fwc-panel-cancel', handlePanelCancel);
        filterPanelElement.removeEventListener('fwc-panel-reset', handlePanelReset);
        filterPanelElement.removeEventListener('fwc-panel-toggle', handlePanelToggle);
      }
    };
  }, [handlePanelToggle, handlePanelApply, handlePanelCancel, handlePanelReset]);
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(e) {
      if (filterPanelRef.current.__open) {
        if (filterPanelRef.current && !filterPanelRef.current.contains(e.target)) {
          filterPanelRef.current.togglePanel();
        }
      }
    };
    document.addEventListener('click', handleClickOutside, false);
    document.addEventListener('touchstart', handleClickOutside, false);
    return function () {
      document.removeEventListener('click', handleClickOutside, false);
      document.removeEventListener('touchstart', handleClickOutside, false);
    };
  }, []);
  return jsx("fwc-panel", _extends$1({}, fwcPanelProps, {
    ref: mergeRefs(filterPanelRef, ref),
    config: JSON.stringify({
      assetsPath: assetsPath
    })
  }), React__default.Children.map(children, function (child) {
    var _child$type, _child$type2;
    if ((child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'FilterPanel.Action') {
      return child;
    }
    if ((child === null || child === void 0 ? void 0 : (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) === 'FilterPanel.Content') {
      return child;
    }
    console.error("Warning FilterPanel has children that aren't FilterPanel.Action or FilterPanel.Content components");
    return null;
  }));
});
FilterPanel.displayName = 'FilterPanel';
FilterPanel.Action = FilterPanelAction;
FilterPanel.Action.displayName = 'FilterPanel.Action';
FilterPanel.Content = FilterPanelContent;
FilterPanel.Content.displayName = 'FilterPanel.Content';
FilterPanel.propTypes = {
  open: bool,
  className: string,
  labelMobileHeader: string,
  labelApplyButton: string,
  labelCancelButton: string,
  labelResetButton: string,
  hideApplyButton: bool,
  hideCancelButton: bool,
  hideResetButton: bool,
  onApply: func,
  onCancel: func,
  onReset: func,
  onToggle: func,
  children: node$2
};

var ArrowRenderer = function ArrowRenderer(_ref) {
  var secondary = _ref.secondary,
    searchIcon = _ref.searchIcon,
    onMouseDown = _ref.onMouseDown;
  if (searchIcon) {
    return jsx("span", {
      className: "Select-arrow-search"
    }, jsx(Icon, {
      name: "search"
    }));
  }
  if (secondary) {
    return jsx("img", {
      alt: "arrowIcon",
      className: "Select-arrow-secondary",
      src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZD0iTTAsMTIuOCBDMCwxNC41NjczMTEyIDEuNDMyNjg4OCwxNiAzLjIsMTYgTDMuMiwxNiBMMCwxNiBaIE0xNiwxMi44IEwxNiwxNiBMMTIuOCwxNiBDMTQuNTY3MzExMiwxNiAxNiwxNC41NjczMTEyIDE2LDEyLjggTDE2LDEyLjggWiBNMTYsMy4yIEMxNiwxLjQzMjY4ODggMTQuNTY3MzExMiwwIDEyLjgsMCBMMTIuOCwwIEwxNiwwIFogTTAsMCBMMy4yLDAgQzEuNDMyNjg4OCwwIDAsMS40MzI2ODg4IDAsMy4yIEwwLDMuMiBMMCwwIFoiLz4KICAgIDxwYXRoIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTkuNjQ1NDgzMzkgOS42TDYuNCA5LjZDNi4yMzAyNjE0NCA5LjYgNi4wNjc0NzQ5NCA5LjY2NzQyODM4IDUuOTQ3NDUxNjUgOS43ODc0NTE2NSA1LjcxMDY3MDYyIDEwLjAyNDIzMjcgNS42OTgyMDg0NSAxMC40MDAzODc2IDUuOTEwMDY1MTggMTAuNjUxODM5Nkw1Ljk0NzQ1MTY1IDEwLjY5MjU0ODQgNy41NzAxOTMzNCAxMi4zMTUyOUM3LjgwNjk3NDQgMTIuNTUyMDcxMSA4LjE4MzEyOTM0IDEyLjU2NDUzMzIgOC40MzQ1ODEzMSAxMi4zNTI2NzY1TDguNDc1MjkwMDUgMTIuMzE1MjkgMTAuMDk4MDMxNyAxMC42OTI1NDg0QzEwLjIxODA1NSAxMC41NzI1MjUxIDEwLjI4NTQ4MzQgMTAuNDA5NzM4NiAxMC4yODU0ODM0IDEwLjI0IDEwLjI4NTQ4MzQgOS45MDI2MDQyMiAxMC4wMjQ0MDI1IDkuNjI2MTg3MTcgOS42OTMyNDczNiA5LjYwMTc1NTQyTDkuNjQ1NDgzMzkgOS42ek04LjQ3NTI5MDA1IDMuMzg3NDUxNjVDOC4yMzg1MDg5OSAzLjE1MDY3MDYxIDcuODYyMzU0MDggMy4xMzgyMDg0NSA3LjYxMDkwMjA4IDMuMzUwMDY1MThMNy41NzAxOTMzNCAzLjM4NzQ1MTY1IDUuOTQ3NDUxNjUgNS4wMTAxOTMzNEM1LjgyNzQyODM4IDUuMTMwMjE2NjQgNS43NiA1LjI5MzAwMzE0IDUuNzYgNS40NjI3NDE3IDUuNzYgNS44MDAxMzc0NyA2LjAyMTA4MDkgNi4wNzY1NTQ1MyA2LjM1MjIzNjA2IDYuMTAwOTg2MjdMNi40IDYuMTAyNzQxNyA5LjY0NTQ4MzM5IDYuMTAyNzQxN0M5LjgxNTIyMTk1IDYuMTAyNzQxNyA5Ljk3ODAwODQ1IDYuMDM1MzEzMzEgMTAuMDk4MDMxNyA1LjkxNTI5MDA1IDEwLjMzNDgxMjggNS42Nzg1MDg5OSAxMC4zNDcyNzQ5IDUuMzAyMzU0MDggMTAuMTM1NDE4MiA1LjA1MDkwMjA4TDEwLjA5ODAzMTcgNS4wMTAxOTMzNCA4LjQ3NTI5MDA1IDMuMzg3NDUxNjV6Ii8+CiAgPC9nPgo8L3N2Zz4K"
    });
  }
  return jsx("span", {
    // css={cssArrowRenderer}
    className: "Select-arrow",
    onMouseDown: onMouseDown
  });
};
ArrowRenderer.propTypes = {
  searchIcon: bool,
  secondary: bool,
  onMouseDown: func
};

var AutosizeInput$1 = {};

Object.defineProperty(AutosizeInput$1, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = React__default;

var _react2 = _interopRequireDefault(_react);

var _propTypes = PropTypes;

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	_createClass(AutosizeInput, null, [{
		key: 'getDerivedStateFromProps',
		value: function getDerivedStateFromProps(props, state) {
			var id = props.id;

			return id !== state.prevId ? { inputId: id || generateId(), prevId: id } : null;
		}
	}]);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId(),
			prevId: props.id
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

var _default = AutosizeInput$1.default = AutosizeInput;

var lodash = {exports: {}};

/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

(function (module, exports) {
(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined$1;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined$1) {
        result = result === undefined$1 ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined$1 : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined$1,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined$1,
        symIterator = Symbol ? Symbol.iterator : undefined$1,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined$1,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1,
        symbolToString = symbolProto ? symbolProto.toString : undefined$1;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined$1;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined$1;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined$1 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined$1) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined$1) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined$1 : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined$1;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined$1 && !eq(object[key], value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined$1 : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined$1) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined$1) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined$1) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined$1 : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined$1 && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined$1, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined$1
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined$1 || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined$1;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined$1 ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined$1;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined$1 : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined$1 && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined$1
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined$1 && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined$1;

          if (newValue === undefined$1) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined$1;

      var isCommon = newValue === undefined$1;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined$1;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
          if (newValue === undefined$1) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined$1;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined$1,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined$1;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined$1 ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined$1,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined$1,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined$1;

        if (newValue === undefined$1) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined$1,
            guard = length > 2 ? sources[2] : undefined$1;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined$1;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined$1 : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined$1;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined$1,
            args, holders, undefined$1, undefined$1, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined$1;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined$1;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined$1 : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined$1 && other === undefined$1) {
          return defaultValue;
        }
        if (value !== undefined$1) {
          result = value;
        }
        if (other !== undefined$1) {
          if (result === undefined$1) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined$1 ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined$1;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined$1 ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined$1,
          newHoldersRight = isCurry ? undefined$1 : holders,
          newPartials = isCurry ? partials : undefined$1,
          newPartialsRight = isCurry ? undefined$1 : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined$1, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined$1;
      }
      ary = ary === undefined$1 ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined$1 ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined$1;
      }
      var data = isBindKey ? undefined$1 : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined$1
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined$1, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined$1 ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined$1 : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined$1;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined$1) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined$1
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined$1, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined$1;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined$1;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined$1,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined$1 || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined$1 ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined$1, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined$1 ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined$1)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined$1, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined$1;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined$1;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined$1, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined$1;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined$1;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined$1, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined$1 ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return (array && array.length) ? baseUniq(array, undefined$1, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined$1, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined$1;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined$1;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined$1
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined$1);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined$1) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined$1 : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined$1;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined$1
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined$1 : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined$1 : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined$1;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined$1;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined$1 || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined$1;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined$1;
        return result;
      }

      function cancel() {
        if (timerId !== undefined$1) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined$1;
      }

      function flush() {
        return timerId === undefined$1 ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined$1) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined$1) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined$1 ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      var result = customizer ? customizer(value, other) : undefined$1;
      return result === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined$1;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined$1;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined$1 ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined$1, customDefaultsMerge);
      return apply(mergeWith, undefined$1, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined$1 : baseGet(object, path);
      return result === undefined$1 ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined$1;
      }
      while (++index < length) {
        var value = object == null ? undefined$1 : object[toKey(path[index])];
        if (value === undefined$1) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined$1) {
        upper = lower;
        lower = undefined$1;
      }
      if (upper !== undefined$1) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined$1) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined$1) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined$1;
      }
      if (floating === undefined$1) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined$1;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined$1;
        }
      }
      if (lower === undefined$1 && upper === undefined$1) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined$1) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined$1
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined$1;
      }
      limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined$1;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined$1, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined$1) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined$1 ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined$1 : pattern;

      if (pattern === undefined$1) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined$1, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined$1 : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined$1;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined$1;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined$1;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined$1;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined$1) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined$1 });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined$1
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(commonjsGlobal));
}(lodash, lodash.exports));

function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }
function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Value = /*#__PURE__*/function (_React$Component) {
  _inherits$1(Value, _React$Component);
  var _super = _createSuper$6(Value);
  function Value(props) {
    var _this;
    _classCallCheck$1(this, Value);
    _this = _super.call(this, props);
    _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_this));
    _this.onRemove = _this.onRemove.bind(_assertThisInitialized(_this));
    _this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_assertThisInitialized(_this));
    _this.handleTouchMove = _this.handleTouchMove.bind(_assertThisInitialized(_this));
    _this.handleTouchStart = _this.handleTouchStart.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass$1(Value, [{
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      if (event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      if (this.props.onClick) {
        event.stopPropagation();
        this.props.onClick(this.props.value, event);
        return;
      }
      if (this.props.value.href) {
        event.stopPropagation();
      }
    }
  }, {
    key: "onRemove",
    value: function onRemove(event) {
      event.preventDefault();
      event.stopPropagation();
      this.props.onRemove(this.props.value);
    }
  }, {
    key: "handleTouchEndRemove",
    value: function handleTouchEndRemove(event) {
      // Check if the view is being dragged, In this case
      // we don't want to fire the click event (because the user only wants to scroll)
      if (this.dragging) return;

      // Fire the mouse events
      this.onRemove(event);
    }
  }, {
    key: "handleTouchMove",
    value: function handleTouchMove() {
      // Set a flag that the view is being dragged
      this.dragging = true;
    }
  }, {
    key: "handleTouchStart",
    value: function handleTouchStart() {
      // Set a flag that the view is not being dragged
      this.dragging = false;
    }
  }, {
    key: "renderRemoveIcon",
    value: function renderRemoveIcon() {
      if (this.props.disabled || !this.props.onRemove) return;
      return jsx("span", {
        className: "Select-value-icon",
        "aria-hidden": "true",
        onMouseDown: this.onRemove,
        onTouchEnd: this.handleTouchEndRemove,
        onTouchStart: this.handleTouchStart,
        onTouchMove: this.handleTouchMove
      }, jsx(Icon, {
        name: "delete"
      }));
    }
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      var className = 'Select-value-label';
      return this.props.onClick || this.props.value.href ? jsx("a", {
        className: className,
        href: this.props.value.href,
        target: this.props.value.target,
        onMouseDown: this.handleMouseDown,
        onTouchEnd: this.handleMouseDown
      }, this.props.children) : jsx("span", {
        className: className,
        role: "option",
        "aria-selected": "true",
        id: this.props.id
      }, this.props.children);
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", {
        className: cx('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
        style: this.props.value.style,
        title: this.props.value.title
      }, this.renderLabel(), this.renderRemoveIcon());
    }
  }]);
  return Value;
}(React__default.Component);
Value.propTypes = {
  children: node$2,
  disabled: bool,
  // disabled prop passed to ReactSelect
  id: string,
  // Unique id for the value - used for aria
  onClick: func,
  // method to handle click on value label
  onRemove: func,
  // method to handle removal of the value
  value: object$1.isRequired // the option object for this value
};

var ClearRenderer = function ClearRenderer() {
  return jsx("span", {
    // css={cssClearRenderer}
    className: "Select-clear"
  }, jsx(Icon, {
    name: "delete"
  }));
};

var blockEvent = function blockEvent(event) {
  event.preventDefault();
  event.stopPropagation();
  if (event.target.tagName !== 'A' || !('href' in event.target)) {
    return;
  }
  if (event.target.target) {
    window.open(event.target.href, event.target.target);
  } else {
    window.location.href = event.target.href;
  }
};

var map = [{
  base: 'A',
  letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
}, {
  base: 'AA',
  letters: /[\uA732]/g
}, {
  base: 'AE',
  letters: /[\u00C6\u01FC\u01E2]/g
}, {
  base: 'AO',
  letters: /[\uA734]/g
}, {
  base: 'AU',
  letters: /[\uA736]/g
}, {
  base: 'AV',
  letters: /[\uA738\uA73A]/g
}, {
  base: 'AY',
  letters: /[\uA73C]/g
}, {
  base: 'B',
  letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
}, {
  base: 'C',
  letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
}, {
  base: 'D',
  letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
}, {
  base: 'DZ',
  letters: /[\u01F1\u01C4]/g
}, {
  base: 'Dz',
  letters: /[\u01F2\u01C5]/g
}, {
  base: 'E',
  letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
}, {
  base: 'F',
  letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
}, {
  base: 'G',
  letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
}, {
  base: 'H',
  letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
}, {
  base: 'I',
  letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
}, {
  base: 'J',
  letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
}, {
  base: 'K',
  letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
}, {
  base: 'L',
  letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
}, {
  base: 'LJ',
  letters: /[\u01C7]/g
}, {
  base: 'Lj',
  letters: /[\u01C8]/g
}, {
  base: 'M',
  letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
}, {
  base: 'N',
  letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
}, {
  base: 'NJ',
  letters: /[\u01CA]/g
}, {
  base: 'Nj',
  letters: /[\u01CB]/g
}, {
  base: 'O',
  letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
}, {
  base: 'OI',
  letters: /[\u01A2]/g
}, {
  base: 'OO',
  letters: /[\uA74E]/g
}, {
  base: 'OU',
  letters: /[\u0222]/g
}, {
  base: 'P',
  letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
}, {
  base: 'Q',
  letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
}, {
  base: 'R',
  letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
}, {
  base: 'S',
  letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
}, {
  base: 'T',
  letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
}, {
  base: 'TZ',
  letters: /[\uA728]/g
}, {
  base: 'U',
  letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
}, {
  base: 'V',
  letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
}, {
  base: 'VY',
  letters: /[\uA760]/g
}, {
  base: 'W',
  letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
}, {
  base: 'X',
  letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
}, {
  base: 'Y',
  letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
}, {
  base: 'Z',
  letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
}, {
  base: 'a',
  letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
}, {
  base: 'aa',
  letters: /[\uA733]/g
}, {
  base: 'ae',
  letters: /[\u00E6\u01FD\u01E3]/g
}, {
  base: 'ao',
  letters: /[\uA735]/g
}, {
  base: 'au',
  letters: /[\uA737]/g
}, {
  base: 'av',
  letters: /[\uA739\uA73B]/g
}, {
  base: 'ay',
  letters: /[\uA73D]/g
}, {
  base: 'b',
  letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
}, {
  base: 'c',
  letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
}, {
  base: 'd',
  letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
}, {
  base: 'dz',
  letters: /[\u01F3\u01C6]/g
}, {
  base: 'e',
  letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
}, {
  base: 'f',
  letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
}, {
  base: 'g',
  letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
}, {
  base: 'h',
  letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
}, {
  base: 'hv',
  letters: /[\u0195]/g
}, {
  base: 'i',
  letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
}, {
  base: 'j',
  letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
}, {
  base: 'k',
  letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
}, {
  base: 'l',
  letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
}, {
  base: 'lj',
  letters: /[\u01C9]/g
}, {
  base: 'm',
  letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
}, {
  base: 'n',
  letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
}, {
  base: 'nj',
  letters: /[\u01CC]/g
}, {
  base: 'o',
  letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
}, {
  base: 'oi',
  letters: /[\u01A3]/g
}, {
  base: 'ou',
  letters: /[\u0223]/g
}, {
  base: 'oo',
  letters: /[\uA74F]/g
}, {
  base: 'p',
  letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
}, {
  base: 'q',
  letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
}, {
  base: 'r',
  letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
}, {
  base: 's',
  letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
}, {
  base: 't',
  letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
}, {
  base: 'tz',
  letters: /[\uA729]/g
}, {
  base: 'u',
  letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
}, {
  base: 'v',
  letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
}, {
  base: 'vy',
  letters: /[\uA761]/g
}, {
  base: 'w',
  letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
}, {
  base: 'x',
  letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
}, {
  base: 'y',
  letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
}, {
  base: 'z',
  letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
}];
var stripDiacritics = function stripDiacritics(str) {
  for (var i = 0; i < map.length; i++) {
    str = str.replace(map[i].letters, map[i].base);
  }
  return str;
};

var isValid = function isValid(value) {
  return typeof value !== 'undefined' && value !== null && value !== '';
};
var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};
var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
  if (props.ignoreAccents) {
    filterValue = stripDiacritics(filterValue);
  }
  if (props.ignoreCase) {
    filterValue = filterValue.toLowerCase();
  }
  if (props.trimFilter) {
    filterValue = trim(filterValue);
  }
  if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
    return i[props.valueKey];
  });
  return options.filter(function (option) {
    if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
    if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
    if (!filterValue) return true;
    var value = option[props.valueKey];
    var label = option[props.labelKey];
    var hasValue = isValid(value);
    var hasLabel = isValid(label);
    if (!hasValue && !hasLabel) {
      return false;
    }
    var valueTest = hasValue ? String(value) : null;
    var labelTest = hasLabel ? String(label) : null;
    if (props.ignoreAccents) {
      if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
      if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
    }
    if (props.ignoreCase) {
      if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
      if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
    }
    return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
  });
};

function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }
function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Option = /*#__PURE__*/function (_React$Component) {
  _inherits$1(Option, _React$Component);
  var _super = _createSuper$5(Option);
  function Option(props) {
    var _this;
    _classCallCheck$1(this, Option);
    _this = _super.call(this, props);
    _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_this));
    _this.handleMouseEnter = _this.handleMouseEnter.bind(_assertThisInitialized(_this));
    _this.handleMouseMove = _this.handleMouseMove.bind(_assertThisInitialized(_this));
    _this.handleTouchStart = _this.handleTouchStart.bind(_assertThisInitialized(_this));
    _this.handleTouchEnd = _this.handleTouchEnd.bind(_assertThisInitialized(_this));
    _this.handleTouchMove = _this.handleTouchMove.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    _this.optionRef = /*#__PURE__*/React__default.createRef();
    return _this;
  }
  _createClass$1(Option, [{
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      event.preventDefault();
      event.stopPropagation();
      this.props.onSelect(this.props.option, event);
    }
  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter(event) {
      this.onFocus(event);
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      this.onFocus(event);
    }
  }, {
    key: "handleTouchEnd",
    value: function handleTouchEnd(event) {
      // Check if the view is being dragged, In this case
      // we don't want to fire the click event (because the user only wants to scroll)
      if (this.dragging) return;
      this.handleMouseDown(event);
    }
  }, {
    key: "handleTouchMove",
    value: function handleTouchMove() {
      // Set a flag that the view is being dragged
      this.dragging = true;
    }
  }, {
    key: "handleTouchStart",
    value: function handleTouchStart() {
      // Set a flag that the view is not being dragged
      this.dragging = false;
    }
  }, {
    key: "onFocus",
    value: function onFocus(event) {
      if (!this.props.isFocused) {
        this.props.onFocus(this.props.option, event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        option = _this$props.option,
        instancePrefix = _this$props.instancePrefix,
        optionIndex = _this$props.optionIndex;
      var className = cx(this.props.className, option.className);
      return option.disabled ? jsx("div", {
        ref: this.props.optionRef,
        className: className,
        onMouseDown: blockEvent,
        onClick: blockEvent
      }, this.props.children) : jsx("div", {
        ref: this.props.optionRef,
        className: className,
        style: option.style,
        role: "option",
        "aria-label": option.label,
        onMouseDown: this.handleMouseDown,
        onMouseEnter: this.handleMouseEnter,
        onMouseMove: this.handleMouseMove,
        onTouchStart: this.handleTouchStart,
        onTouchMove: this.handleTouchMove,
        onTouchEnd: this.handleTouchEnd,
        id: "".concat(instancePrefix, "-option-").concat(optionIndex),
        title: option.title
      }, this.props.children);
    }
  }]);
  return Option;
}(React__default.Component);
Option.propTypes = {
  optionRef: any,
  children: node$2,
  className: string,
  // className (based on mouse position)
  instancePrefix: string.isRequired,
  // unique prefix for the ids (used for aria)
  isDisabled: bool,
  // the option is disabled
  isFocused: bool,
  // the option is focused
  isSelected: bool,
  // the option is selected
  onFocus: func,
  // method to handle mouseEnter on option element
  onSelect: func,
  // method to handle click on option element
  onUnfocus: func,
  // method to handle mouseLeave on option element
  option: object$1.isRequired,
  // object that is base for that option
  optionIndex: number$4 // index of the option, used to generate unique ids for aria
};

var MenuRenderer = function MenuRenderer(props) {
  var focusedOption = props.focusedOption,
    focusOption = props.focusOption,
    inputValue = props.inputValue,
    instancePrefix = props.instancePrefix,
    onFocus = props.onFocus,
    onSelect = props.onSelect,
    optionClassName = props.optionClassName,
    optionRenderer = props.optionRenderer,
    options = props.options,
    onOptionRef = props.onOptionRef,
    removeValue = props.removeValue,
    selectValue = props.selectValue,
    valueArray = props.valueArray,
    valueKey = props.valueKey;
  // const Option = optionComponent;
  return options.map(function (option, i) {
    var isSelected = valueArray && valueArray.some(function (x) {
      return x[valueKey] === option[valueKey];
    });
    var isFocused = option === focusedOption;
    var optionClass = cx(optionClassName, {
      'Select-option': true,
      'is-selected': isSelected,
      'is-focused': isFocused,
      'is-disabled': option.disabled
    });
    return jsx(Option
    // css={cssMenuRenderer}
    , {
      className: optionClass,
      focusOption: focusOption,
      inputValue: inputValue,
      instancePrefix: instancePrefix,
      isDisabled: option.disabled,
      isFocused: isFocused,
      isSelected: isSelected,
      key: "option-".concat(i, "-").concat(option[valueKey]),
      onFocus: onFocus,
      onSelect: onSelect,
      option: option,
      optionIndex: i,
      optionRef: function optionRef(ref) {
        onOptionRef(ref, isFocused);
      },
      removeValue: removeValue,
      selectValue: selectValue
    }, optionRenderer(option, i, inputValue));
  });
};
MenuRenderer.propTypes = {
  focusOption: func,
  focusedOption: object$1,
  inputValue: string,
  instancePrefix: string,
  onFocus: func,
  onOptionRef: func,
  onSelect: func,
  optionClassName: string,
  optionComponent: func,
  optionRenderer: func,
  options: array$2,
  removeValue: func,
  selectValue: func,
  valueArray: array$2,
  valueKey: string
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$g() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssSelect = process.env.NODE_ENV === "production" ? {
  name: "b5v490-cssSelect",
  styles: "position:relative;box-sizing:border-box;input::-ms-clear,input::-ms-reveal,input::-webkit-contacts-auto-fill-button,input::-webkit-credentials-auto-fill-button{display:none!important;}div,input,span{box-sizing:border-box;}&.is-disabled{.Select-control{background-color:#f9f9f9;}.Select-control{background-color:#f9f9f9;}.Select-arrow-zone{cursor:default;pointer-events:none;opacity:0.35;}}&.is-disabled>.Select-control{background-color:#f9f9f9;}&.is-disabled>.Select-control:hover{box-shadow:none;}&.is-open>.Select-control{background:#fff;}&.is-open>.Select-control .Select-arrow{top:-2px;border-color:transparent transparent var(--color-primary);border-width:0 5px 5px;}&.is-searchable.is-open>.Select-control{cursor:text;}&.is-searchable.is-focused:not(.is-open)>.Select-control{cursor:text;}&.is-focused>.Select-control{background:#fff;}&.is-focused>.Select-control{outline:var(--fwc-focus);box-shadow:inset 0 1px 1px rgba(0, 0, 0, 0.075),0 0 0 3px rgba(0, 126, 255, 0.1);background:#fff;}&.has-value.is-clearable.Select--single>.Select-control .Select-value{padding-right:42px;}&.has-value.Select--single>.Select-control .Select-value .Select-value-label,&.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label{color:#333;}&.has-value.Select--single>.Select-control .Select-value a.Select-value-label,&.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none;}&.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover,&.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,&.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,&.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus{color:#007eff;outline:none;text-decoration:underline;}&.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,&.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus{background:#fff;}&.has-value.is-pseudo-focused .Select-input{opacity:0;}&.is-open .Select-arrow,.Select-arrow-zone:hover>.Select-arrow{border-top-color:#666;}.Select--rtl{direction:rtl;text-align:right;}.Select-control{background-color:#fff;cursor:default;display:table;border-spacing:0;border-collapse:separate;outline:none;overflow:hidden;position:relative;width:100%;font-size:calc(2 * var(--fwcu));border:1px solid var(--color-gray-six);border-radius:var(--border-radius);box-shadow:var(--box-shadow-light);color:var(--color-gray-one);height:calc(5 * var(--fwcu));}.Select-control:hover{box-shadow:0 1px 0 rgba(0, 0, 0, 0.06);}.Select-control .Select-input:focus{outline:none;background:#fff;}.Select-placeholder,&.Select--single>.Select-control .Select-value{bottom:0;color:#aaa;left:0;line-height:38px;padding-left:15px;padding-right:15px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:calc(2 * var(--fwcu));color:var(--color-gray-two);}.Select-input{height:38px;padding-left:15px;padding-right:15px;vertical-align:middle;font-size:calc(2 * var(--fwcu));visibility:visible;color:rgb(51, 51, 51);flex:1 1 auto;display:inline-grid;grid-area:1/1/2/3;grid-template-columns:0px min-content;box-sizing:border-box;}.Select-input>input{width:100%;background:none transparent;border:0 none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;line-height:20px;padding:10px 0 10px;-webkit-appearance:none;visibility:visible;color:rgb(51, 51, 51);flex:1 1 auto;display:inline-grid;grid-area:1/1/2/3;grid-template-columns:0px min-content;box-sizing:border-box;}&.is-focused .Select-input>input{cursor:text;}&.has-value.is-pseudo-focused .Select-input{opacity:0;}.Select-control:not(.is-searchable)>.Select-input{outline:none;}.Select-loading-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:16px;}.Select-loading{-webkit-animation:Select-animation-spin 400ms infinite linear;-o-animation:Select-animation-spin 400ms infinite linear;animation:Select-animation-spin 400ms infinite linear;width:16px;height:16px;box-sizing:border-box;border-radius:50%;border:2px solid #ccc;border-right-color:#333;display:inline-block;position:relative;vertical-align:middle;}.Select-prefix-icon{padding:5px 10px;display:table-cell;text-align:center;vertical-align:middle;width:36px;}&.Select .has-prefix-icon{.Select-value{left:36px;padding-left:0px;}.Select-placeholder{left:36px;padding-left:0px;}.Select-input{padding-left:0px;}}&.Select--multi .has-prefix-icon{.Select-placeholder{left:36px;padding-left:0px;}.Select-input{margin-left:0px;}}.Select-clear-zone{-webkit-animation:Select-animation-fadeIn 200ms;-o-animation:Select-animation-fadeIn 200ms;animation:Select-animation-fadeIn 200ms;color:#999;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:17px;}.Select-clear-zone:hover{color:#d0021b;}.Select-clear{display:inline-block;font-size:14px;line-height:1;}&.Select--multi .Select-clear-zone{width:17px;}.Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:25px;padding:0px 10px;}.Select-arrow-zone.secondary-arrow{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;padding:0px 10px;width:36px;}.Select-arrow-zone.secondary-arrow .Select-arrow-secondary{background:var(--color-primary);}.Select--rtl .Select-arrow-zone{padding-right:0;padding-left:5px;}.Select-arrow{border-color:var(--color-primary) transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0;position:relative;}.Select-control>*:last-child{padding-right:10px;}&.Select--multi .Select-multi-value-wrapper{display:inline-block;}.Select-aria-only{position:absolute;display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0, 0, 0, 0);overflow:hidden;float:left;}@keyframes Select-animation-fadeIn{from{opacity:0;}to{opacity:1;}}.Select-menu-outer{border-radius:4px;background-color:#fff;border:1px solid #ccc;border-top-color:#e6e6e6;box-shadow:0 1px 0 rgba(0, 0, 0, 0.06);box-sizing:border-box;margin-top:5px;max-height:200px;position:absolute;left:0;top:100%;width:100%;z-index:1;-webkit-overflow-scrolling:touch;}.Select-menu{max-height:198px;overflow-y:auto;}.Select-option{box-sizing:border-box;background-color:#fff;color:var(--color-gray-two);cursor:pointer;display:block;padding:8px 10px;}.Select-option:first-of-type{border-top-right-radius:4px;border-top-left-radius:4px;}.Select-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px;}.Select-option.is-selected.is-focused,.Select-option.is-selected{background-color:var(--color-primary);color:#fff;}.Select-option.is-focused{background-color:#deebff;color:#333;}.Select-option.is-disabled{color:#cccccc;cursor:default;}.Select-noresults{box-sizing:border-box;cursor:default;display:block;padding:8px 10px;color:var(--color-gray-two);}&.Select--multi .Select-input{vertical-align:middle;margin-left:15px;padding:0;}&.Select--multi:not(.is-searchable) .Select-input{height:calc(4.5 * var(--fwcu));}&.Select--multi.is-searchable .Select-input{vertical-align:inherit;margin-left:15px;padding:0;}&.Select--multi.Select--rtl .Select-input{margin-left:0;margin-right:10px;}&.Select--multi.has-value .Select-input{margin-left:5px;}&.Select--multi .Select-value{background-color:var(--color-primary);border-radius:16px;color:#ffffff;display:inline-block;margin-left:5px;margin-top:5px;line-height:14px;padding:5px 10px;}&.Select--multi .Select-value-icon,&.Select--multi .Select-value-label{display:inline-block;vertical-align:initial;}&.Select--multi .Select-value-label{border-bottom-right-radius:16px;border-top-right-radius:16px;cursor:default;}&.Select--multi a.Select-value-label{color:#fff;cursor:pointer;text-decoration:none;line-height:inherit;}&.Select--multi a.Select-value-label:hover{text-decoration:underline;}&.Select--multi .Select-value-icon{cursor:pointer;border-bottom-right-radius:16px;border-top-right-radius:16px;padding-left:5px;font-size:12px;}&.Select--multi .Select-value:hover,&.Select--multi .Select-value:focus{background-color:var(--color-primary-hover);}&.Select--multi .Select-value:active{background-color:var(--color-primary-hover);}&.Select--multi.Select--rtl .Select-value{margin-left:0;margin-right:5px;}&.Select--multi.Select--rtl .Select-value-icon{border-right:none;border-left:1px solid #c2e0ff;border-left:1px solid rgba(0, 126, 255, 0.24);}&.Select--multi.is-disabled .Select-input{vertical-align:top;height:38px;}&.Select--multi.is-disabled .Select-value{background-color:#fcfcfc;border:1px solid #e3e3e3;color:#333;margin-top:6px;padding:5px 10px;}&.Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e3e3e3;}&.Select--multi.is-disabled .Select-value-icon:hover,&.Select--multi.is-disabled .Select-value-icon:focus,&.Select--multi.is-disabled .Select-value-icon:active{background-color:#fcfcfc;}@keyframes Select-animation-spin{to{transform:rotate(1turn);}}@-webkit-keyframes Select-animation-spin{to{-webkit-transform:rotate(1turn);}};label:cssSelect;"
} : {
  name: "b5v490-cssSelect",
  styles: "position:relative;box-sizing:border-box;input::-ms-clear,input::-ms-reveal,input::-webkit-contacts-auto-fill-button,input::-webkit-credentials-auto-fill-button{display:none!important;}div,input,span{box-sizing:border-box;}&.is-disabled{.Select-control{background-color:#f9f9f9;}.Select-control{background-color:#f9f9f9;}.Select-arrow-zone{cursor:default;pointer-events:none;opacity:0.35;}}&.is-disabled>.Select-control{background-color:#f9f9f9;}&.is-disabled>.Select-control:hover{box-shadow:none;}&.is-open>.Select-control{background:#fff;}&.is-open>.Select-control .Select-arrow{top:-2px;border-color:transparent transparent var(--color-primary);border-width:0 5px 5px;}&.is-searchable.is-open>.Select-control{cursor:text;}&.is-searchable.is-focused:not(.is-open)>.Select-control{cursor:text;}&.is-focused>.Select-control{background:#fff;}&.is-focused>.Select-control{outline:var(--fwc-focus);box-shadow:inset 0 1px 1px rgba(0, 0, 0, 0.075),0 0 0 3px rgba(0, 126, 255, 0.1);background:#fff;}&.has-value.is-clearable.Select--single>.Select-control .Select-value{padding-right:42px;}&.has-value.Select--single>.Select-control .Select-value .Select-value-label,&.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label{color:#333;}&.has-value.Select--single>.Select-control .Select-value a.Select-value-label,&.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none;}&.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover,&.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,&.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,&.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus{color:#007eff;outline:none;text-decoration:underline;}&.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,&.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus{background:#fff;}&.has-value.is-pseudo-focused .Select-input{opacity:0;}&.is-open .Select-arrow,.Select-arrow-zone:hover>.Select-arrow{border-top-color:#666;}.Select--rtl{direction:rtl;text-align:right;}.Select-control{background-color:#fff;cursor:default;display:table;border-spacing:0;border-collapse:separate;outline:none;overflow:hidden;position:relative;width:100%;font-size:calc(2 * var(--fwcu));border:1px solid var(--color-gray-six);border-radius:var(--border-radius);box-shadow:var(--box-shadow-light);color:var(--color-gray-one);height:calc(5 * var(--fwcu));}.Select-control:hover{box-shadow:0 1px 0 rgba(0, 0, 0, 0.06);}.Select-control .Select-input:focus{outline:none;background:#fff;}.Select-placeholder,&.Select--single>.Select-control .Select-value{bottom:0;color:#aaa;left:0;line-height:38px;padding-left:15px;padding-right:15px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:calc(2 * var(--fwcu));color:var(--color-gray-two);}.Select-input{height:38px;padding-left:15px;padding-right:15px;vertical-align:middle;font-size:calc(2 * var(--fwcu));visibility:visible;color:rgb(51, 51, 51);flex:1 1 auto;display:inline-grid;grid-area:1/1/2/3;grid-template-columns:0px min-content;box-sizing:border-box;}.Select-input>input{width:100%;background:none transparent;border:0 none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;line-height:20px;padding:10px 0 10px;-webkit-appearance:none;visibility:visible;color:rgb(51, 51, 51);flex:1 1 auto;display:inline-grid;grid-area:1/1/2/3;grid-template-columns:0px min-content;box-sizing:border-box;}&.is-focused .Select-input>input{cursor:text;}&.has-value.is-pseudo-focused .Select-input{opacity:0;}.Select-control:not(.is-searchable)>.Select-input{outline:none;}.Select-loading-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:16px;}.Select-loading{-webkit-animation:Select-animation-spin 400ms infinite linear;-o-animation:Select-animation-spin 400ms infinite linear;animation:Select-animation-spin 400ms infinite linear;width:16px;height:16px;box-sizing:border-box;border-radius:50%;border:2px solid #ccc;border-right-color:#333;display:inline-block;position:relative;vertical-align:middle;}.Select-prefix-icon{padding:5px 10px;display:table-cell;text-align:center;vertical-align:middle;width:36px;}&.Select .has-prefix-icon{.Select-value{left:36px;padding-left:0px;}.Select-placeholder{left:36px;padding-left:0px;}.Select-input{padding-left:0px;}}&.Select--multi .has-prefix-icon{.Select-placeholder{left:36px;padding-left:0px;}.Select-input{margin-left:0px;}}.Select-clear-zone{-webkit-animation:Select-animation-fadeIn 200ms;-o-animation:Select-animation-fadeIn 200ms;animation:Select-animation-fadeIn 200ms;color:#999;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:17px;}.Select-clear-zone:hover{color:#d0021b;}.Select-clear{display:inline-block;font-size:14px;line-height:1;}&.Select--multi .Select-clear-zone{width:17px;}.Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:25px;padding:0px 10px;}.Select-arrow-zone.secondary-arrow{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;padding:0px 10px;width:36px;}.Select-arrow-zone.secondary-arrow .Select-arrow-secondary{background:var(--color-primary);}.Select--rtl .Select-arrow-zone{padding-right:0;padding-left:5px;}.Select-arrow{border-color:var(--color-primary) transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0;position:relative;}.Select-control>*:last-child{padding-right:10px;}&.Select--multi .Select-multi-value-wrapper{display:inline-block;}.Select-aria-only{position:absolute;display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0, 0, 0, 0);overflow:hidden;float:left;}@keyframes Select-animation-fadeIn{from{opacity:0;}to{opacity:1;}}.Select-menu-outer{border-radius:4px;background-color:#fff;border:1px solid #ccc;border-top-color:#e6e6e6;box-shadow:0 1px 0 rgba(0, 0, 0, 0.06);box-sizing:border-box;margin-top:5px;max-height:200px;position:absolute;left:0;top:100%;width:100%;z-index:1;-webkit-overflow-scrolling:touch;}.Select-menu{max-height:198px;overflow-y:auto;}.Select-option{box-sizing:border-box;background-color:#fff;color:var(--color-gray-two);cursor:pointer;display:block;padding:8px 10px;}.Select-option:first-of-type{border-top-right-radius:4px;border-top-left-radius:4px;}.Select-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px;}.Select-option.is-selected.is-focused,.Select-option.is-selected{background-color:var(--color-primary);color:#fff;}.Select-option.is-focused{background-color:#deebff;color:#333;}.Select-option.is-disabled{color:#cccccc;cursor:default;}.Select-noresults{box-sizing:border-box;cursor:default;display:block;padding:8px 10px;color:var(--color-gray-two);}&.Select--multi .Select-input{vertical-align:middle;margin-left:15px;padding:0;}&.Select--multi:not(.is-searchable) .Select-input{height:calc(4.5 * var(--fwcu));}&.Select--multi.is-searchable .Select-input{vertical-align:inherit;margin-left:15px;padding:0;}&.Select--multi.Select--rtl .Select-input{margin-left:0;margin-right:10px;}&.Select--multi.has-value .Select-input{margin-left:5px;}&.Select--multi .Select-value{background-color:var(--color-primary);border-radius:16px;color:#ffffff;display:inline-block;margin-left:5px;margin-top:5px;line-height:14px;padding:5px 10px;}&.Select--multi .Select-value-icon,&.Select--multi .Select-value-label{display:inline-block;vertical-align:initial;}&.Select--multi .Select-value-label{border-bottom-right-radius:16px;border-top-right-radius:16px;cursor:default;}&.Select--multi a.Select-value-label{color:#fff;cursor:pointer;text-decoration:none;line-height:inherit;}&.Select--multi a.Select-value-label:hover{text-decoration:underline;}&.Select--multi .Select-value-icon{cursor:pointer;border-bottom-right-radius:16px;border-top-right-radius:16px;padding-left:5px;font-size:12px;}&.Select--multi .Select-value:hover,&.Select--multi .Select-value:focus{background-color:var(--color-primary-hover);}&.Select--multi .Select-value:active{background-color:var(--color-primary-hover);}&.Select--multi.Select--rtl .Select-value{margin-left:0;margin-right:5px;}&.Select--multi.Select--rtl .Select-value-icon{border-right:none;border-left:1px solid #c2e0ff;border-left:1px solid rgba(0, 126, 255, 0.24);}&.Select--multi.is-disabled .Select-input{vertical-align:top;height:38px;}&.Select--multi.is-disabled .Select-value{background-color:#fcfcfc;border:1px solid #e3e3e3;color:#333;margin-top:6px;padding:5px 10px;}&.Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e3e3e3;}&.Select--multi.is-disabled .Select-value-icon:hover,&.Select--multi.is-disabled .Select-value-icon:focus,&.Select--multi.is-disabled .Select-value-icon:active{background-color:#fcfcfc;}@keyframes Select-animation-spin{to{transform:rotate(1turn);}}@-webkit-keyframes Select-animation-spin{to{-webkit-transform:rotate(1turn);}};label:cssSelect;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNlbGVjdG9yLnN0eWxlcy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFNEIiLCJmaWxlIjoic2VsZWN0b3Iuc3R5bGVzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5leHBvcnQgY29uc3QgY3NzU2VsZWN0ID0gY3NzYFxuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG5cbiAgaW5wdXQ6Oi1tcy1jbGVhcixcbiAgaW5wdXQ6Oi1tcy1yZXZlYWwsXG4gIGlucHV0Ojotd2Via2l0LWNvbnRhY3RzLWF1dG8tZmlsbC1idXR0b24sXG4gIGlucHV0Ojotd2Via2l0LWNyZWRlbnRpYWxzLWF1dG8tZmlsbC1idXR0b24ge1xuICAgIGRpc3BsYXk6IG5vbmUgIWltcG9ydGFudDtcbiAgfVxuXG4gIGRpdixcbiAgaW5wdXQsXG4gIHNwYW4ge1xuICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIH1cblxuICAmLmlzLWRpc2FibGVkIHtcbiAgICAuU2VsZWN0LWNvbnRyb2wge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogI2Y5ZjlmOTtcbiAgICB9XG4gICAgLlNlbGVjdC1jb250cm9sIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICNmOWY5Zjk7XG4gICAgfVxuICAgIC5TZWxlY3QtYXJyb3ctem9uZSB7XG4gICAgICBjdXJzb3I6IGRlZmF1bHQ7XG4gICAgICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgICAgIG9wYWNpdHk6IDAuMzU7XG4gICAgfVxuICB9XG4gICYuaXMtZGlzYWJsZWQgPiAuU2VsZWN0LWNvbnRyb2wge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICNmOWY5Zjk7XG4gIH1cbiAgJi5pcy1kaXNhYmxlZCA+IC5TZWxlY3QtY29udHJvbDpob3ZlciB7XG4gICAgYm94LXNoYWRvdzogbm9uZTtcbiAgfVxuICAmLmlzLW9wZW4gPiAuU2VsZWN0LWNvbnRyb2wge1xuICAgIGJhY2tncm91bmQ6ICNmZmY7XG4gIH1cbiAgJi5pcy1vcGVuID4gLlNlbGVjdC1jb250cm9sIC5TZWxlY3QtYXJyb3cge1xuICAgIHRvcDogLTJweDtcbiAgICBib3JkZXItY29sb3I6IHRyYW5zcGFyZW50IHRyYW5zcGFyZW50IHZhcigtLWNvbG9yLXByaW1hcnkpO1xuICAgIGJvcmRlci13aWR0aDogMCA1cHggNXB4O1xuICB9XG4gICYuaXMtc2VhcmNoYWJsZS5pcy1vcGVuID4gLlNlbGVjdC1jb250cm9sIHtcbiAgICBjdXJzb3I6IHRleHQ7XG4gIH1cbiAgJi5pcy1zZWFyY2hhYmxlLmlzLWZvY3VzZWQ6bm90KC5pcy1vcGVuKSA+IC5TZWxlY3QtY29udHJvbCB7XG4gICAgY3Vyc29yOiB0ZXh0O1xuICB9XG4gICYuaXMtZm9jdXNlZCA+IC5TZWxlY3QtY29udHJvbCB7XG4gICAgYmFja2dyb3VuZDogI2ZmZjtcbiAgfVxuICAmLmlzLWZvY3VzZWQgPiAuU2VsZWN0LWNvbnRyb2wge1xuICAgIG91dGxpbmU6IHZhcigtLWZ3Yy1mb2N1cyk7XG4gICAgLyogYm9yZGVyOiA0cHggc29saWQgcmdiYSh2YXIoLS1jb2xvci1yZ2ItcHJpbWFyeS1ob3ZlciksIDAuNik7ICovXG4gICAgYm94LXNoYWRvdzogaW5zZXQgMCAxcHggMXB4IHJnYmEoMCwgMCwgMCwgMC4wNzUpLFxuICAgICAgMCAwIDAgM3B4IHJnYmEoMCwgMTI2LCAyNTUsIDAuMSk7XG4gICAgYmFja2dyb3VuZDogI2ZmZjtcbiAgfVxuICAmLmhhcy12YWx1ZS5pcy1jbGVhcmFibGUuU2VsZWN0LS1zaW5nbGUgPiAuU2VsZWN0LWNvbnRyb2wgLlNlbGVjdC12YWx1ZSB7XG4gICAgcGFkZGluZy1yaWdodDogNDJweDtcbiAgfVxuICAmLmhhcy12YWx1ZS5TZWxlY3QtLXNpbmdsZVxuICAgID4gLlNlbGVjdC1jb250cm9sXG4gICAgLlNlbGVjdC12YWx1ZVxuICAgIC5TZWxlY3QtdmFsdWUtbGFiZWwsXG4gICYuaGFzLXZhbHVlLmlzLXBzZXVkby1mb2N1c2VkLlNlbGVjdC0tc2luZ2xlXG4gICAgPiAuU2VsZWN0LWNvbnRyb2xcbiAgICAuU2VsZWN0LXZhbHVlXG4gICAgLlNlbGVjdC12YWx1ZS1sYWJlbCB7XG4gICAgY29sb3I6ICMzMzM7XG4gIH1cbiAgJi5oYXMtdmFsdWUuU2VsZWN0LS1zaW5nbGVcbiAgICA+IC5TZWxlY3QtY29udHJvbFxuICAgIC5TZWxlY3QtdmFsdWVcbiAgICBhLlNlbGVjdC12YWx1ZS1sYWJlbCxcbiAgJi5oYXMtdmFsdWUuaXMtcHNldWRvLWZvY3VzZWQuU2VsZWN0LS1zaW5nbGVcbiAgICA+IC5TZWxlY3QtY29udHJvbFxuICAgIC5TZWxlY3QtdmFsdWVcbiAgICBhLlNlbGVjdC12YWx1ZS1sYWJlbCB7XG4gICAgY3Vyc29yOiBwb2ludGVyO1xuICAgIHRleHQtZGVjb3JhdGlvbjogbm9uZTtcbiAgfVxuICAmLmhhcy12YWx1ZS5TZWxlY3QtLXNpbmdsZVxuICAgID4gLlNlbGVjdC1jb250cm9sXG4gICAgLlNlbGVjdC12YWx1ZVxuICAgIGEuU2VsZWN0LXZhbHVlLWxhYmVsOmhvdmVyLFxuICAmLmhhcy12YWx1ZS5pcy1wc2V1ZG8tZm9jdXNlZC5TZWxlY3QtLXNpbmdsZVxuICAgID4gLlNlbGVjdC1jb250cm9sXG4gICAgLlNlbGVjdC12YWx1ZVxuICAgIGEuU2VsZWN0LXZhbHVlLWxhYmVsOmhvdmVyLFxuICAmLmhhcy12YWx1ZS5TZWxlY3QtLXNpbmdsZVxuICAgID4gLlNlbGVjdC1jb250cm9sXG4gICAgLlNlbGVjdC12YWx1ZVxuICAgIGEuU2VsZWN0LXZhbHVlLWxhYmVsOmZvY3VzLFxuICAmLmhhcy12YWx1ZS5pcy1wc2V1ZG8tZm9jdXNlZC5TZWxlY3QtLXNpbmdsZVxuICAgID4gLlNlbGVjdC1jb250cm9sXG4gICAgLlNlbGVjdC12YWx1ZVxuICAgIGEuU2VsZWN0LXZhbHVlLWxhYmVsOmZvY3VzIHtcbiAgICBjb2xvcjogIzAwN2VmZjtcbiAgICBvdXRsaW5lOiBub25lO1xuICAgIHRleHQtZGVjb3JhdGlvbjogdW5kZXJsaW5lO1xuICB9XG4gICYuaGFzLXZhbHVlLlNlbGVjdC0tc2luZ2xlXG4gICAgPiAuU2VsZWN0LWNvbnRyb2xcbiAgICAuU2VsZWN0LXZhbHVlXG4gICAgYS5TZWxlY3QtdmFsdWUtbGFiZWw6Zm9jdXMsXG4gICYuaGFzLXZhbHVlLmlzLXBzZXVkby1mb2N1c2VkLlNlbGVjdC0tc2luZ2xlXG4gICAgPiAuU2VsZWN0LWNvbnRyb2xcbiAgICAuU2VsZWN0LXZhbHVlXG4gICAgYS5TZWxlY3QtdmFsdWUtbGFiZWw6Zm9jdXMge1xuICAgIGJhY2tncm91bmQ6ICNmZmY7XG4gIH1cbiAgJi5oYXMtdmFsdWUuaXMtcHNldWRvLWZvY3VzZWQgLlNlbGVjdC1pbnB1dCB7XG4gICAgb3BhY2l0eTogMDtcbiAgfVxuICAmLmlzLW9wZW4gLlNlbGVjdC1hcnJvdyxcbiAgLlNlbGVjdC1hcnJvdy16b25lOmhvdmVyID4gLlNlbGVjdC1hcnJvdyB7XG4gICAgYm9yZGVyLXRvcC1jb2xvcjogIzY2NjtcbiAgfVxuICAuU2VsZWN0LS1ydGwge1xuICAgIGRpcmVjdGlvbjogcnRsO1xuICAgIHRleHQtYWxpZ246IHJpZ2h0O1xuICB9XG4gIC5TZWxlY3QtY29udHJvbCB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogI2ZmZjtcbiAgICBjdXJzb3I6IGRlZmF1bHQ7XG4gICAgZGlzcGxheTogdGFibGU7XG4gICAgYm9yZGVyLXNwYWNpbmc6IDA7XG4gICAgYm9yZGVyLWNvbGxhcHNlOiBzZXBhcmF0ZTtcbiAgICBvdXRsaW5lOiBub25lO1xuICAgIG92ZXJmbG93OiBoaWRkZW47XG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIGZvbnQtc2l6ZTogY2FsYygyICogdmFyKC0tZndjdSkpO1xuICAgIGJvcmRlcjogMXB4IHNvbGlkIHZhcigtLWNvbG9yLWdyYXktc2l4KTtcbiAgICBib3JkZXItcmFkaXVzOiB2YXIoLS1ib3JkZXItcmFkaXVzKTtcbiAgICBib3gtc2hhZG93OiB2YXIoLS1ib3gtc2hhZG93LWxpZ2h0KTtcbiAgICBjb2xvcjogdmFyKC0tY29sb3ItZ3JheS1vbmUpO1xuICAgIGhlaWdodDogY2FsYyg1ICogdmFyKC0tZndjdSkpO1xuICB9XG4gIC5TZWxlY3QtY29udHJvbDpob3ZlciB7XG4gICAgYm94LXNoYWRvdzogMCAxcHggMCByZ2JhKDAsIDAsIDAsIDAuMDYpO1xuICB9XG4gIC5TZWxlY3QtY29udHJvbCAuU2VsZWN0LWlucHV0OmZvY3VzIHtcbiAgICBvdXRsaW5lOiBub25lO1xuICAgIGJhY2tncm91bmQ6ICNmZmY7XG4gIH1cbiAgLlNlbGVjdC1wbGFjZWhvbGRlcixcbiAgJi5TZWxlY3QtLXNpbmdsZSA+IC5TZWxlY3QtY29udHJvbCAuU2VsZWN0LXZhbHVlIHtcbiAgICBib3R0b206IDA7XG4gICAgY29sb3I6ICNhYWE7XG4gICAgbGVmdDogMDtcbiAgICBsaW5lLWhlaWdodDogMzhweDtcbiAgICBwYWRkaW5nLWxlZnQ6IDE1cHg7XG4gICAgcGFkZGluZy1yaWdodDogMTVweDtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgcmlnaHQ6IDA7XG4gICAgdG9wOiAwO1xuICAgIG1heC13aWR0aDogMTAwJTtcbiAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuICAgIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gICAgZm9udC1zaXplOiBjYWxjKDIgKiB2YXIoLS1md2N1KSk7XG4gICAgY29sb3I6IHZhcigtLWNvbG9yLWdyYXktdHdvKTtcbiAgfVxuICAuU2VsZWN0LWlucHV0IHtcbiAgICBoZWlnaHQ6IDM4cHg7XG4gICAgcGFkZGluZy1sZWZ0OiAxNXB4O1xuICAgIHBhZGRpbmctcmlnaHQ6IDE1cHg7XG4gICAgdmVydGljYWwtYWxpZ246IG1pZGRsZTtcbiAgICBmb250LXNpemU6IGNhbGMoMiAqIHZhcigtLWZ3Y3UpKTtcbiAgICB2aXNpYmlsaXR5OiB2aXNpYmxlO1xuICAgIGNvbG9yOiByZ2IoNTEsIDUxLCA1MSk7XG4gICAgZmxleDogMSAxIGF1dG87XG4gICAgZGlzcGxheTogaW5saW5lLWdyaWQ7XG4gICAgZ3JpZC1hcmVhOiAxIC8gMSAvIDIgLyAzO1xuICAgIGdyaWQtdGVtcGxhdGUtY29sdW1uczogMHB4IG1pbi1jb250ZW50O1xuICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIH1cbiAgLlNlbGVjdC1pbnB1dCA+IGlucHV0IHtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBiYWNrZ3JvdW5kOiBub25lIHRyYW5zcGFyZW50O1xuICAgIGJvcmRlcjogMCBub25lO1xuICAgIGJveC1zaGFkb3c6IG5vbmU7XG4gICAgY3Vyc29yOiBkZWZhdWx0O1xuICAgIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgICBmb250LWZhbWlseTogaW5oZXJpdDtcbiAgICBmb250LXNpemU6IGluaGVyaXQ7XG4gICAgbWFyZ2luOiAwO1xuICAgIG91dGxpbmU6IG5vbmU7XG4gICAgbGluZS1oZWlnaHQ6IDIwcHg7XG4gICAgLyogRm9yIElFIDggY29tcGF0aWJpbGl0eSAqL1xuICAgIHBhZGRpbmc6IDEwcHggMCAxMHB4O1xuICAgIC8qIEZvciBJRSA4IGNvbXBhdGliaWxpdHkgKi9cbiAgICAtd2Via2l0LWFwcGVhcmFuY2U6IG5vbmU7XG4gICAgdmlzaWJpbGl0eTogdmlzaWJsZTtcbiAgICBjb2xvcjogcmdiKDUxLCA1MSwgNTEpO1xuICAgIGZsZXg6IDEgMSBhdXRvO1xuICAgIGRpc3BsYXk6IGlubGluZS1ncmlkO1xuICAgIGdyaWQtYXJlYTogMSAvIDEgLyAyIC8gMztcbiAgICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IDBweCBtaW4tY29udGVudDtcbiAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICB9XG4gICYuaXMtZm9jdXNlZCAuU2VsZWN0LWlucHV0ID4gaW5wdXQge1xuICAgIGN1cnNvcjogdGV4dDtcbiAgfVxuICAmLmhhcy12YWx1ZS5pcy1wc2V1ZG8tZm9jdXNlZCAuU2VsZWN0LWlucHV0IHtcbiAgICBvcGFjaXR5OiAwO1xuICB9XG4gIC5TZWxlY3QtY29udHJvbDpub3QoLmlzLXNlYXJjaGFibGUpID4gLlNlbGVjdC1pbnB1dCB7XG4gICAgb3V0bGluZTogbm9uZTtcbiAgfVxuICAuU2VsZWN0LWxvYWRpbmctem9uZSB7XG4gICAgY3Vyc29yOiBwb2ludGVyO1xuICAgIGRpc3BsYXk6IHRhYmxlLWNlbGw7XG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICB2ZXJ0aWNhbC1hbGlnbjogbWlkZGxlO1xuICAgIHdpZHRoOiAxNnB4O1xuICB9XG4gIC5TZWxlY3QtbG9hZGluZyB7XG4gICAgLXdlYmtpdC1hbmltYXRpb246IFNlbGVjdC1hbmltYXRpb24tc3BpbiA0MDBtcyBpbmZpbml0ZSBsaW5lYXI7XG4gICAgLW8tYW5pbWF0aW9uOiBTZWxlY3QtYW5pbWF0aW9uLXNwaW4gNDAwbXMgaW5maW5pdGUgbGluZWFyO1xuICAgIGFuaW1hdGlvbjogU2VsZWN0LWFuaW1hdGlvbi1zcGluIDQwMG1zIGluZmluaXRlIGxpbmVhcjtcbiAgICB3aWR0aDogMTZweDtcbiAgICBoZWlnaHQ6IDE2cHg7XG4gICAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgICBib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgYm9yZGVyOiAycHggc29saWQgI2NjYztcbiAgICBib3JkZXItcmlnaHQtY29sb3I6ICMzMzM7XG4gICAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICB2ZXJ0aWNhbC1hbGlnbjogbWlkZGxlO1xuICB9XG5cbiAgLlNlbGVjdC1wcmVmaXgtaWNvbiB7XG4gICAgcGFkZGluZzogNXB4IDEwcHg7XG4gICAgZGlzcGxheTogdGFibGUtY2VsbDtcbiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gICAgdmVydGljYWwtYWxpZ246IG1pZGRsZTtcbiAgICB3aWR0aDogMzZweDtcbiAgfVxuXG4gICYuU2VsZWN0IC5oYXMtcHJlZml4LWljb24ge1xuICAgIC5TZWxlY3QtdmFsdWUge1xuICAgICAgbGVmdDogMzZweDtcbiAgICAgIHBhZGRpbmctbGVmdDogMHB4O1xuICAgIH1cbiAgICAuU2VsZWN0LXBsYWNlaG9sZGVyIHtcbiAgICAgIGxlZnQ6IDM2cHg7XG4gICAgICBwYWRkaW5nLWxlZnQ6IDBweDtcbiAgICB9XG4gICAgLlNlbGVjdC1pbnB1dCB7XG4gICAgICBwYWRkaW5nLWxlZnQ6IDBweDtcbiAgICB9XG4gIH1cbiAgJi5TZWxlY3QtLW11bHRpIC5oYXMtcHJlZml4LWljb24ge1xuICAgIC5TZWxlY3QtcGxhY2Vob2xkZXIge1xuICAgICAgbGVmdDogMzZweDtcbiAgICAgIHBhZGRpbmctbGVmdDogMHB4O1xuICAgIH1cbiAgICAuU2VsZWN0LWlucHV0IHtcbiAgICAgIG1hcmdpbi1sZWZ0OiAwcHg7XG4gICAgfVxuICB9XG5cbiAgLlNlbGVjdC1jbGVhci16b25lIHtcbiAgICAtd2Via2l0LWFuaW1hdGlvbjogU2VsZWN0LWFuaW1hdGlvbi1mYWRlSW4gMjAwbXM7XG4gICAgLW8tYW5pbWF0aW9uOiBTZWxlY3QtYW5pbWF0aW9uLWZhZGVJbiAyMDBtcztcbiAgICBhbmltYXRpb246IFNlbGVjdC1hbmltYXRpb24tZmFkZUluIDIwMG1zO1xuICAgIGNvbG9yOiAjOTk5O1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgICBkaXNwbGF5OiB0YWJsZS1jZWxsO1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gICAgdmVydGljYWwtYWxpZ246IG1pZGRsZTtcbiAgICB3aWR0aDogMTdweDtcbiAgfVxuICAuU2VsZWN0LWNsZWFyLXpvbmU6aG92ZXIge1xuICAgIGNvbG9yOiAjZDAwMjFiO1xuICB9XG4gIC5TZWxlY3QtY2xlYXIge1xuICAgIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgICBmb250LXNpemU6IDE0cHg7XG4gICAgbGluZS1oZWlnaHQ6IDE7XG4gIH1cbiAgJi5TZWxlY3QtLW11bHRpIC5TZWxlY3QtY2xlYXItem9uZSB7XG4gICAgd2lkdGg6IDE3cHg7XG4gIH1cbiAgLlNlbGVjdC1hcnJvdy16b25lIHtcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgZGlzcGxheTogdGFibGUtY2VsbDtcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgIHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7XG4gICAgd2lkdGg6IDI1cHg7XG4gICAgcGFkZGluZzogMHB4IDEwcHg7XG4gIH1cblxuICAuU2VsZWN0LWFycm93LXpvbmUuc2Vjb25kYXJ5LWFycm93IHtcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgZGlzcGxheTogdGFibGUtY2VsbDtcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgIHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7XG4gICAgcGFkZGluZzogMHB4IDEwcHg7XG4gICAgd2lkdGg6IDM2cHg7XG4gIH1cblxuICAuU2VsZWN0LWFycm93LXpvbmUuc2Vjb25kYXJ5LWFycm93IC5TZWxlY3QtYXJyb3ctc2Vjb25kYXJ5IHtcbiAgICBiYWNrZ3JvdW5kOiB2YXIoLS1jb2xvci1wcmltYXJ5KTtcbiAgfVxuXG4gIC5TZWxlY3QtLXJ0bCAuU2VsZWN0LWFycm93LXpvbmUge1xuICAgIHBhZGRpbmctcmlnaHQ6IDA7XG4gICAgcGFkZGluZy1sZWZ0OiA1cHg7XG4gIH1cbiAgLlNlbGVjdC1hcnJvdyB7XG4gICAgYm9yZGVyLWNvbG9yOiB2YXIoLS1jb2xvci1wcmltYXJ5KSB0cmFuc3BhcmVudCB0cmFuc3BhcmVudDtcbiAgICBib3JkZXItc3R5bGU6IHNvbGlkO1xuICAgIGJvcmRlci13aWR0aDogNXB4IDVweCAyLjVweDtcbiAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gICAgaGVpZ2h0OiAwO1xuICAgIHdpZHRoOiAwO1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgfVxuICAuU2VsZWN0LWNvbnRyb2wgPiAqOmxhc3QtY2hpbGQge1xuICAgIHBhZGRpbmctcmlnaHQ6IDEwcHg7XG4gIH1cbiAgJi5TZWxlY3QtLW11bHRpIC5TZWxlY3QtbXVsdGktdmFsdWUtd3JhcHBlciB7XG4gICAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICB9XG4gIC5TZWxlY3QtYXJpYS1vbmx5IHtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICAgIGhlaWdodDogMXB4O1xuICAgIHdpZHRoOiAxcHg7XG4gICAgbWFyZ2luOiAtMXB4O1xuICAgIGNsaXA6IHJlY3QoMCwgMCwgMCwgMCk7XG4gICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgICBmbG9hdDogbGVmdDtcbiAgfVxuICBAa2V5ZnJhbWVzIFNlbGVjdC1hbmltYXRpb24tZmFkZUluIHtcbiAgICBmcm9tIHtcbiAgICAgIG9wYWNpdHk6IDA7XG4gICAgfVxuICAgIHRvIHtcbiAgICAgIG9wYWNpdHk6IDE7XG4gICAgfVxuICB9XG4gIC5TZWxlY3QtbWVudS1vdXRlciB7XG4gICAgYm9yZGVyLXJhZGl1czogNHB4O1xuICAgIGJhY2tncm91bmQtY29sb3I6ICNmZmY7XG4gICAgYm9yZGVyOiAxcHggc29saWQgI2NjYztcbiAgICBib3JkZXItdG9wLWNvbG9yOiAjZTZlNmU2O1xuICAgIGJveC1zaGFkb3c6IDAgMXB4IDAgcmdiYSgwLCAwLCAwLCAwLjA2KTtcbiAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICAgIG1hcmdpbi10b3A6IDVweDtcbiAgICBtYXgtaGVpZ2h0OiAyMDBweDtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgbGVmdDogMDtcbiAgICB0b3A6IDEwMCU7XG4gICAgd2lkdGg6IDEwMCU7XG4gICAgei1pbmRleDogMTtcbiAgICAtd2Via2l0LW92ZXJmbG93LXNjcm9sbGluZzogdG91Y2g7XG4gIH1cbiAgLlNlbGVjdC1tZW51IHtcbiAgICBtYXgtaGVpZ2h0OiAxOThweDtcbiAgICBvdmVyZmxvdy15OiBhdXRvO1xuICB9XG4gIC5TZWxlY3Qtb3B0aW9uIHtcbiAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICAgIGJhY2tncm91bmQtY29sb3I6ICNmZmY7XG4gICAgY29sb3I6IHZhcigtLWNvbG9yLWdyYXktdHdvKTtcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgZGlzcGxheTogYmxvY2s7XG4gICAgcGFkZGluZzogOHB4IDEwcHg7XG4gICAgLyogZm9udC1zaXplOiAxNnB4OyAqL1xuICB9XG4gIC5TZWxlY3Qtb3B0aW9uOmZpcnN0LW9mLXR5cGUge1xuICAgIGJvcmRlci10b3AtcmlnaHQtcmFkaXVzOiA0cHg7XG4gICAgYm9yZGVyLXRvcC1sZWZ0LXJhZGl1czogNHB4O1xuICB9XG4gIC5TZWxlY3Qtb3B0aW9uOmxhc3QtY2hpbGQge1xuICAgIGJvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOiA0cHg7XG4gICAgYm9yZGVyLWJvdHRvbS1sZWZ0LXJhZGl1czogNHB4O1xuICB9XG4gIC5TZWxlY3Qtb3B0aW9uLmlzLXNlbGVjdGVkLmlzLWZvY3VzZWQsXG4gIC5TZWxlY3Qtb3B0aW9uLmlzLXNlbGVjdGVkIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1jb2xvci1wcmltYXJ5KTtcbiAgICBjb2xvcjogI2ZmZjtcbiAgfVxuICAuU2VsZWN0LW9wdGlvbi5pcy1mb2N1c2VkIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZGVlYmZmO1xuICAgIGNvbG9yOiAjMzMzO1xuICB9XG4gIC5TZWxlY3Qtb3B0aW9uLmlzLWRpc2FibGVkIHtcbiAgICBjb2xvcjogI2NjY2NjYztcbiAgICBjdXJzb3I6IGRlZmF1bHQ7XG4gIH1cbiAgLlNlbGVjdC1ub3Jlc3VsdHMge1xuICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gICAgY3Vyc29yOiBkZWZhdWx0O1xuICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgIHBhZGRpbmc6IDhweCAxMHB4O1xuICAgIGNvbG9yOiB2YXIoLS1jb2xvci1ncmF5LXR3byk7XG4gICAgLyogZm9udC1zaXplOiAxNnB4OyAqL1xuICB9XG4gICYuU2VsZWN0LS1tdWx0aSAuU2VsZWN0LWlucHV0IHtcbiAgICB2ZXJ0aWNhbC1hbGlnbjogbWlkZGxlO1xuICAgIG1hcmdpbi1sZWZ0OiAxNXB4O1xuICAgIHBhZGRpbmc6IDA7XG4gIH1cblxuICAmLlNlbGVjdC0tbXVsdGk6bm90KC5pcy1zZWFyY2hhYmxlKSAuU2VsZWN0LWlucHV0IHtcbiAgICBoZWlnaHQ6IGNhbGMoNC41ICogdmFyKC0tZndjdSkpO1xuICB9XG5cbiAgJi5TZWxlY3QtLW11bHRpLmlzLXNlYXJjaGFibGUgLlNlbGVjdC1pbnB1dCB7XG4gICAgdmVydGljYWwtYWxpZ246IGluaGVyaXQ7XG4gICAgbWFyZ2luLWxlZnQ6IDE1cHg7XG4gICAgcGFkZGluZzogMDtcbiAgfVxuXG4gICYuU2VsZWN0LS1tdWx0aS5TZWxlY3QtLXJ0bCAuU2VsZWN0LWlucHV0IHtcbiAgICBtYXJnaW4tbGVmdDogMDtcbiAgICBtYXJnaW4tcmlnaHQ6IDEwcHg7XG4gIH1cbiAgJi5TZWxlY3QtLW11bHRpLmhhcy12YWx1ZSAuU2VsZWN0LWlucHV0IHtcbiAgICBtYXJnaW4tbGVmdDogNXB4O1xuICB9XG4gICYuU2VsZWN0LS1tdWx0aSAuU2VsZWN0LXZhbHVlIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1jb2xvci1wcmltYXJ5KTtcbiAgICBib3JkZXItcmFkaXVzOiAxNnB4O1xuICAgIGNvbG9yOiAjZmZmZmZmO1xuICAgIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgICAvKiBmb250LXNpemU6IDE2cHg7ICovXG4gICAgbWFyZ2luLWxlZnQ6IDVweDtcbiAgICBtYXJnaW4tdG9wOiA1cHg7XG4gICAgbGluZS1oZWlnaHQ6IDE0cHg7XG4gICAgcGFkZGluZzogNXB4IDEwcHg7XG4gIH1cbiAgJi5TZWxlY3QtLW11bHRpIC5TZWxlY3QtdmFsdWUtaWNvbixcbiAgJi5TZWxlY3QtLW11bHRpIC5TZWxlY3QtdmFsdWUtbGFiZWwge1xuICAgIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgICB2ZXJ0aWNhbC1hbGlnbjogaW5pdGlhbDtcbiAgfVxuICAmLlNlbGVjdC0tbXVsdGkgLlNlbGVjdC12YWx1ZS1sYWJlbCB7XG4gICAgYm9yZGVyLWJvdHRvbS1yaWdodC1yYWRpdXM6IDE2cHg7XG4gICAgYm9yZGVyLXRvcC1yaWdodC1yYWRpdXM6IDE2cHg7XG4gICAgY3Vyc29yOiBkZWZhdWx0O1xuICB9XG4gICYuU2VsZWN0LS1tdWx0aSBhLlNlbGVjdC12YWx1ZS1sYWJlbCB7XG4gICAgY29sb3I6ICNmZmY7XG4gICAgY3Vyc29yOiBwb2ludGVyO1xuICAgIHRleHQtZGVjb3JhdGlvbjogbm9uZTtcbiAgICBsaW5lLWhlaWdodDogaW5oZXJpdDtcbiAgfVxuICAmLlNlbGVjdC0tbXVsdGkgYS5TZWxlY3QtdmFsdWUtbGFiZWw6aG92ZXIge1xuICAgIHRleHQtZGVjb3JhdGlvbjogdW5kZXJsaW5lO1xuICB9XG4gICYuU2VsZWN0LS1tdWx0aSAuU2VsZWN0LXZhbHVlLWljb24ge1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgICBib3JkZXItYm90dG9tLXJpZ2h0LXJhZGl1czogMTZweDtcbiAgICBib3JkZXItdG9wLXJpZ2h0LXJhZGl1czogMTZweDtcbiAgICBwYWRkaW5nLWxlZnQ6IDVweDtcbiAgICBmb250LXNpemU6IDEycHg7XG4gIH1cbiAgJi5TZWxlY3QtLW11bHRpIC5TZWxlY3QtdmFsdWU6aG92ZXIsXG4gICYuU2VsZWN0LS1tdWx0aSAuU2VsZWN0LXZhbHVlOmZvY3VzIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1jb2xvci1wcmltYXJ5LWhvdmVyKTtcbiAgfVxuICAmLlNlbGVjdC0tbXVsdGkgLlNlbGVjdC12YWx1ZTphY3RpdmUge1xuICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLWNvbG9yLXByaW1hcnktaG92ZXIpO1xuICB9XG4gICYuU2VsZWN0LS1tdWx0aS5TZWxlY3QtLXJ0bCAuU2VsZWN0LXZhbHVlIHtcbiAgICBtYXJnaW4tbGVmdDogMDtcbiAgICBtYXJnaW4tcmlnaHQ6IDVweDtcbiAgfVxuICAmLlNlbGVjdC0tbXVsdGkuU2VsZWN0LS1ydGwgLlNlbGVjdC12YWx1ZS1pY29uIHtcbiAgICBib3JkZXItcmlnaHQ6IG5vbmU7XG4gICAgYm9yZGVyLWxlZnQ6IDFweCBzb2xpZCAjYzJlMGZmO1xuICAgIC8qIEZhbGxiYWNrIGNvbG9yIGZvciBJRSA4ICovXG4gICAgYm9yZGVyLWxlZnQ6IDFweCBzb2xpZCByZ2JhKDAsIDEyNiwgMjU1LCAwLjI0KTtcbiAgfVxuICAmLlNlbGVjdC0tbXVsdGkuaXMtZGlzYWJsZWQgLlNlbGVjdC1pbnB1dCB7XG4gICAgdmVydGljYWwtYWxpZ246IHRvcDtcbiAgICBoZWlnaHQ6IDM4cHg7XG4gIH1cblxuICAmLlNlbGVjdC0tbXVsdGkuaXMtZGlzYWJsZWQgLlNlbGVjdC12YWx1ZSB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogI2ZjZmNmYztcbiAgICBib3JkZXI6IDFweCBzb2xpZCAjZTNlM2UzO1xuICAgIGNvbG9yOiAjMzMzO1xuICAgIG1hcmdpbi10b3A6IDZweDtcbiAgICBwYWRkaW5nOiA1cHggMTBweDtcbiAgfVxuICAmLlNlbGVjdC0tbXVsdGkuaXMtZGlzYWJsZWQgLlNlbGVjdC12YWx1ZS1pY29uIHtcbiAgICBjdXJzb3I6IG5vdC1hbGxvd2VkO1xuICAgIGJvcmRlci1yaWdodDogMXB4IHNvbGlkICNlM2UzZTM7XG4gIH1cbiAgJi5TZWxlY3QtLW11bHRpLmlzLWRpc2FibGVkIC5TZWxlY3QtdmFsdWUtaWNvbjpob3ZlcixcbiAgJi5TZWxlY3QtLW11bHRpLmlzLWRpc2FibGVkIC5TZWxlY3QtdmFsdWUtaWNvbjpmb2N1cyxcbiAgJi5TZWxlY3QtLW11bHRpLmlzLWRpc2FibGVkIC5TZWxlY3QtdmFsdWUtaWNvbjphY3RpdmUge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICNmY2ZjZmM7XG4gIH1cbiAgQGtleWZyYW1lcyBTZWxlY3QtYW5pbWF0aW9uLXNwaW4ge1xuICAgIHRvIHtcbiAgICAgIHRyYW5zZm9ybTogcm90YXRlKDF0dXJuKTtcbiAgICB9XG4gIH1cbiAgQC13ZWJraXQta2V5ZnJhbWVzIFNlbGVjdC1hbmltYXRpb24tc3BpbiB7XG4gICAgdG8ge1xuICAgICAgLXdlYmtpdC10cmFuc2Zvcm06IHJvdGF0ZSgxdHVybik7XG4gICAgfVxuICB9XG5gO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
};

var PrefixRenderer = function PrefixRenderer() {
  return jsx("span", {
    className: "Select-prefix-icon"
  }, jsx(Icon, {
    name: "search"
  }));
};
PrefixRenderer.propTypes = {};

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$9(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }
function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var stringifyValue = function stringifyValue(value) {
  return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};
var instanceId = 1;
var shouldShowValue = function shouldShowValue(state, props) {
  var inputValue = state.inputValue,
    isPseudoFocused = state.isPseudoFocused,
    isFocused = state.isFocused;
  var onSelectResetsInput = props.onSelectResetsInput;
  if (!inputValue) return true;
  if (!onSelectResetsInput) {
    return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
  }
  return false;
};
var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
  var inputValue = state.inputValue,
    isPseudoFocused = state.isPseudoFocused,
    isFocused = state.isFocused;
  var onSelectResetsInput = props.onSelectResetsInput;
  return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object} props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
  var valueType = _typeof(value);
  if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
  var options = props.options,
    valueKey = props.valueKey;
  if (!options) return;
  for (var i = 0; i < options.length; i++) {
    if (String(options[i][valueKey]) === String(value)) return options[i];
  }
};
var handleRequired = function handleRequired(value, multi) {
  if (!value) return true;
  return multi ? value.length === 0 : Object.keys(value).length === 0;
};
var defaultProps$5 = {
  displayPrefixIcon: false,
  secondaryArrow: false,
  arrowRenderer: ArrowRenderer,
  autosize: true,
  backspaceRemoves: true,
  backspaceToRemoveMessage: 'Press backspace to remove {label}',
  clearable: true,
  clearAllText: 'Clear all',
  clearValueText: 'Clear value',
  closeOnSelect: true,
  deleteRemoves: true,
  delimiter: ',',
  disabled: false,
  escapeClearsValue: true,
  filterOptions: filterOptions,
  ignoreAccents: true,
  ignoreCase: true,
  inputProps: {},
  isLoading: false,
  joinValues: false,
  labelKey: 'label',
  matchPos: 'any',
  matchProp: 'any',
  menuBuffer: 0,
  multi: false,
  noResultsText: 'No results found',
  onBlurResetsInput: true,
  onCloseResetsInput: true,
  onSelectResetsInput: true,
  openOnClick: true,
  pageSize: 5,
  placeholder: 'Select...',
  removeSelected: true,
  required: false,
  scrollMenuIntoView: true,
  searchable: true,
  simpleValue: false,
  tabSelectsValue: true,
  trimFilter: true,
  valueKey: 'value',
  focusDefaultOption: true
};
var SelectorComponent = /*#__PURE__*/function (_React$Component) {
  _inherits$1(SelectorComponent, _React$Component);
  var _super = _createSuper$4(SelectorComponent);
  function SelectorComponent(props) {
    var _this;
    _classCallCheck$1(this, SelectorComponent);
    _this = _super.call(this, props);
    ['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
      return _this[fn] = _this[fn].bind(_assertThisInitialized(_this));
    });
    _this.state = {
      inputValue: '',
      isFocused: false,
      isOpen: false,
      isPseudoFocused: false,
      required: false
    };
    _this.wrapperRef = /*#__PURE__*/React__default.createRef();
    _this.menuContainerRef = /*#__PURE__*/React__default.createRef();
    _this.menuRef = /*#__PURE__*/React__default.createRef();
    // this.focusedRef = React.createRef();
    _this.inputRef = /*#__PURE__*/React__default.createRef();
    _this.valueRef = /*#__PURE__*/React__default.createRef();
    _this.controlRef = /*#__PURE__*/React__default.createRef();
    _this._initialMount();
    return _this;
  }
  _createClass$1(SelectorComponent, [{
    key: "_initialMount",
    value: function _initialMount() {
      this._instancePrefix = "react-select-".concat(this.props.instanceId || ++instanceId, "-");
      var valueArray = this.getValueArray(this.props.value);
      if (this.props.required) {
        this.setState({
          required: handleRequired(valueArray[0], this.props.multi)
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
        console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
      }
      if (this.props.autoFocus || this.props.autofocus) {
        this.focus();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var valueArray = this.getValueArray(nextProps.value, nextProps);
      if (nextProps.required) {
        this.setState({
          required: handleRequired(valueArray[0], nextProps.multi)
        });
      } else if (this.props.required) {
        // Used to be required but it's not any more
        this.setState({
          required: false
        });
      }
      if (this.state.inputValue && !lodash.exports.isEqual(this.props.value, nextProps.value) && nextProps.onSelectResetsInput) {
        this.setState({
          inputValue: this.handleInputValueChange('')
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // focus to the selected option
      if (this.menuRef.current && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
        var focusedOptionNode = this.focused;
        var menuNode = this.menuRef.current;
        var scrollTop = menuNode.scrollTop;
        var scrollBottom = scrollTop + menuNode.offsetHeight;
        var optionTop = focusedOptionNode.offsetTop;
        var optionBottom = optionTop + focusedOptionNode.offsetHeight;
        if (scrollTop > optionTop || scrollBottom < optionBottom) {
          menuNode.scrollTop = focusedOptionNode.offsetTop;
        }

        // We still set hasScrolledToOption to true even if we didn't
        // actually need to scroll, as we've still confirmed that the
        // option is in view.
        this.hasScrolledToOption = true;
      } else if (!this.state.isOpen) {
        this.hasScrolledToOption = false;
      }
      if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menuRef.current) {
        var _focusedDOM$getBoundi;
        this._scrollToFocusedOptionOnUpdate = false;
        var focusedDOM = this.focused;
        var menuDOM = this.menuRef.current;
        var focusedRect = focusedDOM === null || focusedDOM === void 0 ? void 0 : (_focusedDOM$getBoundi = focusedDOM.getBoundingClientRect) === null || _focusedDOM$getBoundi === void 0 ? void 0 : _focusedDOM$getBoundi.call(focusedDOM);
        var menuRect = menuDOM.getBoundingClientRect();
        if ((focusedRect === null || focusedRect === void 0 ? void 0 : focusedRect.bottom) > menuRect.bottom) {
          menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
        } else if ((focusedRect === null || focusedRect === void 0 ? void 0 : focusedRect.top) < menuRect.top) {
          menuDOM.scrollTop = focusedDOM.offsetTop;
        }
      }
      if (this.props.scrollMenuIntoView && this.menuContainerRef.current) {
        var menuContainerRect = this.menuContainerRef.current.getBoundingClientRect();
        if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
          window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
        }
      }
      if (prevProps.disabled !== this.props.disabled) {
        this.setState({
          isFocused: false
        }); // eslint-disable-line react/no-did-update-set-state
        this.closeMenu();
      }
      if (prevState.isOpen !== this.state.isOpen) {
        this.toggleTouchOutsideEvent(this.state.isOpen);
        var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
        handler && handler();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.toggleTouchOutsideEvent(false);
    }
  }, {
    key: "toggleTouchOutsideEvent",
    value: function toggleTouchOutsideEvent(enabled) {
      var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
      var pref = document.addEventListener ? '' : 'on';
      document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
      document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
    }
  }, {
    key: "handleTouchOutside",
    value: function handleTouchOutside(event) {
      // handle touch outside on ios to dismiss menu
      if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
        this.closeMenu();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      if (!this.inputRef.current) return;
      this.inputRef.current.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.current.blur();
    }
  }, {
    key: "handleTouchMove",
    value: function handleTouchMove() {
      // Set a flag that the view is being dragged
      this.dragging = true;
    }
  }, {
    key: "handleTouchStart",
    value: function handleTouchStart() {
      // Set a flag that the view is not being dragged
      this.dragging = false;
    }
  }, {
    key: "handleTouchEnd",
    value: function handleTouchEnd(event) {
      // Check if the view is being dragged, In this case
      // we don't want to fire the click event (because the user only wants to scroll)
      if (this.dragging) return;

      // Fire the mouse events
      this.handleMouseDown(event);
    }
  }, {
    key: "handleTouchEndClearValue",
    value: function handleTouchEndClearValue(event) {
      // Check if the view is being dragged, In this case
      // we don't want to fire the click event (because the user only wants to scroll)
      if (this.dragging) return;

      // Clear the value
      this.clearValue(event);
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      // if the event was triggered by a mousedown and not the primary
      // button, or if the component is disabled, ignore it.
      if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      if (event.target.tagName === 'INPUT') {
        if (!this.state.isFocused) {
          this._openAfterFocus = this.props.openOnClick;
          this.focus();
        } else if (!this.state.isOpen) {
          this.setState({
            isOpen: true,
            isPseudoFocused: false,
            focusedOption: null
          });
        }
        return;
      }

      // prevent default event handlers
      event.preventDefault();

      // for the non-searchable select, toggle the menu
      if (!this.props.searchable) {
        // This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
        this.focus();
        return this.setState({
          isOpen: !this.state.isOpen,
          focusedOption: null
        });
      }
      if (this.state.isFocused) {
        // On iOS, we can get into a state where we think the input is focused but it isn't really,
        // since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
        // Call focus() again here to be safe.
        this.focus();
        var input = this.inputRef.current;
        var toOpen = true;
        if (typeof input.getInput === 'function') {
          // Get the actual DOM input if the ref is an <AutosizeInput /> component
          input = input.getInput();
        }

        // clears the value so that the cursor will be at the end of input when the component re-renders
        input.value = '';
        if (this._focusAfterClear) {
          toOpen = false;
          this._focusAfterClear = false;
        }

        // if the input is focused, ensure the menu is open
        this.setState({
          isOpen: toOpen,
          isPseudoFocused: false,
          focusedOption: null
        });
      } else {
        // otherwise, focus the input and open the menu
        this._openAfterFocus = this.props.openOnClick;
        this.focus();
        this.setState({
          focusedOption: null
        });
      }
    }
  }, {
    key: "handleMouseDownOnArrow",
    value: function handleMouseDownOnArrow(event) {
      // if the event was triggered by a mousedown and not the primary
      // button, or if the component is disabled, ignore it.
      if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      if (this.state.isOpen) {
        // prevent default event handlers
        event.stopPropagation();
        event.preventDefault();
        // close the menu
        this.closeMenu();
      } else {
        // If the menu isn't open, let the event bubble to the main handleMouseDown
        this.setState({
          isOpen: true
        });
      }
    }
  }, {
    key: "handleMouseDownOnMenu",
    value: function handleMouseDownOnMenu(event) {
      // if the event was triggered by a mousedown and not the primary
      // button, or if the component is disabled, ignore it.
      if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      this._openAfterFocus = true;
      this.focus();
    }
  }, {
    key: "closeMenu",
    value: function closeMenu() {
      if (this.props.onCloseResetsInput) {
        this.setState({
          inputValue: this.handleInputValueChange(''),
          isOpen: false,
          isPseudoFocused: this.state.isFocused && !this.props.multi
        });
      } else {
        this.setState({
          isOpen: false,
          isPseudoFocused: this.state.isFocused && !this.props.multi
        });
      }
      this.hasScrolledToOption = false;
    }
  }, {
    key: "handleInputFocus",
    value: function handleInputFocus(event) {
      if (this.props.disabled) return;
      var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
      toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

      if (this.props.onFocus) {
        this.props.onFocus(event);
      }
      this.setState({
        isFocused: true,
        isOpen: !!toOpen
      });
      this._focusAfterClear = false;
      this._openAfterFocus = false;
    }
  }, {
    key: "handleInputBlur",
    value: function handleInputBlur(event) {
      // The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
      if (this.menuRef.current && (this.menuRef.current === document.activeElement || this.menuRef.current.contains(document.activeElement))) {
        this.focus();
        return;
      }
      if (this.props.onBlur) {
        this.props.onBlur(event);
      }
      var onBlurredState = {
        isFocused: false,
        isOpen: false,
        isPseudoFocused: false
      };
      if (this.props.onBlurResetsInput) {
        onBlurredState.inputValue = this.handleInputValueChange('');
      }
      this.setState(onBlurredState);
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var newInputValue = event.target.value;
      if (this.state.inputValue !== event.target.value) {
        newInputValue = this.handleInputValueChange(newInputValue);
      }
      this.setState({
        inputValue: newInputValue,
        isOpen: true,
        isPseudoFocused: false
      });
    }
  }, {
    key: "setInputValue",
    value: function setInputValue(newValue) {
      if (this.props.onInputChange) {
        var nextState = this.props.onInputChange(newValue);
        if (nextState != null && _typeof(nextState) !== 'object') {
          newValue = '' + nextState;
        }
      }
      this.setState({
        inputValue: newValue
      });
    }
  }, {
    key: "handleInputValueChange",
    value: function handleInputValueChange(newValue) {
      if (this.props.onInputChange) {
        var nextState = this.props.onInputChange(newValue);
        // Note: != used deliberately here to catch undefined and null
        if (nextState != null && _typeof(nextState) !== 'object') {
          newValue = '' + nextState;
        }
      }
      return newValue;
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (this.props.disabled) return;
      if (typeof this.props.onInputKeyDown === 'function') {
        this.props.onInputKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      }
      switch (event.keyCode) {
        case 8:
          // backspace
          if (!this.state.inputValue && this.props.backspaceRemoves) {
            event.preventDefault();
            this.popValue();
          }
          break;
        case 9:
          // tab
          if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
            break;
          }
          event.preventDefault();
          this.selectFocusedOption();
          break;
        case 13:
          // enter
          event.preventDefault();
          event.stopPropagation();
          if (this.state.isOpen) {
            this.selectFocusedOption();
          } else {
            this.focusNextOption();
          }
          break;
        case 27:
          // escape
          event.preventDefault();
          if (this.state.isOpen) {
            this.closeMenu();
            event.stopPropagation();
          } else if (this.props.clearable && this.props.escapeClearsValue) {
            this.clearValue(event);
            event.stopPropagation();
          }
          break;
        case 32:
          // space
          if (this.props.searchable) {
            break;
          }
          event.preventDefault();
          if (!this.state.isOpen) {
            this.focusNextOption();
            break;
          }
          event.stopPropagation();
          this.selectFocusedOption();
          break;
        case 38:
          // up
          event.preventDefault();
          this.focusPreviousOption();
          break;
        case 40:
          // down
          event.preventDefault();
          this.focusNextOption();
          break;
        case 33:
          // page up
          event.preventDefault();
          this.focusPageUpOption();
          break;
        case 34:
          // page down
          event.preventDefault();
          this.focusPageDownOption();
          break;
        case 35:
          // end key
          if (event.shiftKey) {
            break;
          }
          event.preventDefault();
          this.focusEndOption();
          break;
        case 36:
          // home key
          if (event.shiftKey) {
            break;
          }
          event.preventDefault();
          this.focusStartOption();
          break;
        case 46:
          // delete
          if (!this.state.inputValue && this.props.deleteRemoves) {
            event.preventDefault();
            this.popValue();
          }
          break;
      }
    }
  }, {
    key: "handleValueClick",
    value: function handleValueClick(option, event) {
      if (!this.props.onValueClick) return;
      this.props.onValueClick(option, event);
    }
  }, {
    key: "handleMenuScroll",
    value: function handleMenuScroll(event) {
      if (!this.props.onMenuScrollToBottom) return;
      var target = event.target;
      if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
        this.props.onMenuScrollToBottom();
      }
    }
  }, {
    key: "getOptionLabel",
    value: function getOptionLabel(op) {
      return op[this.props.labelKey];
    }

    /**
     * Turns a value into an array from the given options
     * @param {String|Number|Array} value		- the value of the select input
     * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
     * @returns	{Array}	the value of the select represented in an array
     */
  }, {
    key: "getValueArray",
    value: function getValueArray(value) {
      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      /** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
      var props = _typeof(nextProps) === 'object' ? nextProps : this.props;
      if (props.multi) {
        if (typeof value === 'string') {
          value = value.split(props.delimiter);
        }
        if (!Array.isArray(value)) {
          if (value === null || value === undefined) return [];
          value = [value];
        }
        return value.map(function (value) {
          return expandValue(value, props);
        }).filter(function (i) {
          return i;
        });
      }
      var expandedValue = expandValue(value, props);
      return expandedValue ? [expandedValue] : [];
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      var _this2 = this;
      if (this.props.autoBlur) {
        this.blurInput();
      }
      if (this.props.required) {
        var required = handleRequired(value, this.props.multi);
        this.setState({
          required: required
        });
      }
      if (this.props.simpleValue && value) {
        value = this.props.multi ? value.map(function (i) {
          return i[_this2.props.valueKey];
        }).join(this.props.delimiter) : value[this.props.valueKey];
      }
      if (this.props.onChange) {
        this.props.onChange(value);
      }
    }
  }, {
    key: "selectValue",
    value: function selectValue(value) {
      var _this3 = this;
      // NOTE: we actually add/set the value in a callback to make sure the
      // input value is empty to avoid styling issues in Chrome
      if (this.props.closeOnSelect) {
        this.hasScrolledToOption = false;
      }
      var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
      if (this.props.multi) {
        this.setState({
          focusedIndex: null,
          inputValue: this.handleInputValueChange(updatedValue),
          isOpen: !this.props.closeOnSelect
        }, function () {
          var valueArray = _this3.getValueArray(_this3.props.value);
          if (valueArray.some(function (i) {
            return i[_this3.props.valueKey] === value[_this3.props.valueKey];
          })) {
            _this3.removeValue(value);
          } else {
            _this3.addValue(value);
          }
        });
      } else {
        this.setState({
          inputValue: this.handleInputValueChange(updatedValue),
          isOpen: !this.props.closeOnSelect,
          isPseudoFocused: this.state.isFocused
        }, function () {
          _this3.setValue(value);
        });
      }
    }
  }, {
    key: "addValue",
    value: function addValue(value) {
      var valueArray = this.getValueArray(this.props.value);
      var visibleOptions = this._visibleOptions.filter(function (val) {
        return !val.disabled;
      });
      var lastValueIndex = visibleOptions.indexOf(value);
      this.setValue(valueArray.concat(value));
      if (!this.props.closeOnSelect) {
        return;
      }
      if (visibleOptions.length - 1 === lastValueIndex) {
        // the last option was selected; focus the second-last one
        this.focusOption(visibleOptions[lastValueIndex - 1]);
      } else if (visibleOptions.length > lastValueIndex) {
        // focus the option below the selected one
        this.focusOption(visibleOptions[lastValueIndex + 1]);
      }
    }
  }, {
    key: "popValue",
    value: function popValue() {
      var valueArray = this.getValueArray(this.props.value);
      if (!valueArray.length) return;
      if (valueArray[valueArray.length - 1].clearableValue === false) return;
      this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
    }
  }, {
    key: "removeValue",
    value: function removeValue(value) {
      var _this4 = this;
      var valueArray = this.getValueArray(this.props.value);
      this.setValue(valueArray.filter(function (i) {
        return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
      }));
      this.focus();
    }
  }, {
    key: "clearValue",
    value: function clearValue(event) {
      // if the event was triggered by a mousedown and not the primary
      // button, ignore it.
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      event.preventDefault();
      this.setValue(this.getResetValue());
      this.setState({
        inputValue: this.handleInputValueChange(''),
        isOpen: false
      }, this.focus);
      this._focusAfterClear = true;
    }
  }, {
    key: "getResetValue",
    value: function getResetValue() {
      if (this.props.resetValue !== undefined) {
        return this.props.resetValue;
      } else if (this.props.multi) {
        return [];
      } else {
        return null;
      }
    }
  }, {
    key: "focusOption",
    value: function focusOption(option) {
      this.setState({
        focusedOption: option
      });
    }
  }, {
    key: "focusNextOption",
    value: function focusNextOption() {
      this.focusAdjacentOption('next');
    }
  }, {
    key: "focusPreviousOption",
    value: function focusPreviousOption() {
      this.focusAdjacentOption('previous');
    }
  }, {
    key: "focusPageUpOption",
    value: function focusPageUpOption() {
      this.focusAdjacentOption('page_up');
    }
  }, {
    key: "focusPageDownOption",
    value: function focusPageDownOption() {
      this.focusAdjacentOption('page_down');
    }
  }, {
    key: "focusStartOption",
    value: function focusStartOption() {
      this.focusAdjacentOption('start');
    }
  }, {
    key: "focusEndOption",
    value: function focusEndOption() {
      this.focusAdjacentOption('end');
    }
  }, {
    key: "focusAdjacentOption",
    value: function focusAdjacentOption(dir) {
      var options = this._visibleOptions.map(function (option, index) {
        return {
          option: option,
          index: index
        };
      }).filter(function (option) {
        return !option.option.disabled;
      });
      this._scrollToFocusedOptionOnUpdate = true;
      if (!this.state.isOpen) {
        var newState = {
          focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
          isOpen: true
        };
        if (this.props.onSelectResetsInput) {
          newState.inputValue = '';
        }
        this.setState(newState);
        return;
      }
      if (!options.length) return;
      var focusedIndex = -1;
      for (var i = 0; i < options.length; i++) {
        if (this._focusedOption === options[i].option) {
          focusedIndex = i;
          break;
        }
      }
      if (dir === 'next' && focusedIndex !== -1) {
        focusedIndex = (focusedIndex + 1) % options.length;
      } else if (dir === 'previous') {
        if (focusedIndex > 0) {
          focusedIndex = focusedIndex - 1;
        } else {
          focusedIndex = options.length - 1;
        }
      } else if (dir === 'start') {
        focusedIndex = 0;
      } else if (dir === 'end') {
        focusedIndex = options.length - 1;
      } else if (dir === 'page_up') {
        var potentialIndex = focusedIndex - this.props.pageSize;
        if (potentialIndex < 0) {
          focusedIndex = 0;
        } else {
          focusedIndex = potentialIndex;
        }
      } else if (dir === 'page_down') {
        var _potentialIndex = focusedIndex + this.props.pageSize;
        if (_potentialIndex > options.length - 1) {
          focusedIndex = options.length - 1;
        } else {
          focusedIndex = _potentialIndex;
        }
      }
      if (focusedIndex === -1) {
        focusedIndex = 0;
      }
      this.setState({
        focusedIndex: options[focusedIndex].index,
        focusedOption: options[focusedIndex].option
      });
    }
  }, {
    key: "getFocusedOption",
    value: function getFocusedOption() {
      return this._focusedOption;
    }
  }, {
    key: "selectFocusedOption",
    value: function selectFocusedOption() {
      if (this._focusedOption) {
        return this.selectValue(this._focusedOption);
      }
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      if (!this.props.isLoading) return;
      return jsx("span", {
        className: "Select-loading-zone",
        "aria-hidden": "true"
      }, jsx("span", {
        className: "Select-loading"
      }));
    }
  }, {
    key: "renderValue",
    value: function renderValue(valueArray, isOpen) {
      var _this5 = this;
      var renderLabel = this.props.valueRenderer || this.getOptionLabel;
      // let ValueComponent = this.props.valueComponent;
      if (!valueArray.length) {
        var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
        return showPlaceholder ? jsx("div", {
          className: "Select-placeholder"
        }, this.props.placeholder) : null;
      }
      var onClick = this.props.onValueClick ? this.handleValueClick : null;
      if (this.props.multi) {
        return valueArray.map(function (value, i) {
          return jsx(Value, {
            disabled: _this5.props.disabled || value.clearableValue === false,
            id: "".concat(_this5._instancePrefix, "-value-").concat(i),
            instancePrefix: _this5._instancePrefix,
            key: "value-".concat(i, "-").concat(value[_this5.props.valueKey]),
            onClick: onClick,
            onRemove: _this5.removeValue,
            placeholder: _this5.props.placeholder,
            value: value,
            values: valueArray
          }, renderLabel(value, i), jsx("span", {
            className: "Select-aria-only"
          }, "\xA0"));
        });
      } else if (shouldShowValue(this.state, this.props)) {
        if (isOpen) onClick = null;
        return jsx(Value, {
          disabled: this.props.disabled,
          id: "".concat(this._instancePrefix, "-value-item"),
          instancePrefix: this._instancePrefix,
          onClick: onClick,
          placeholder: this.props.placeholder,
          value: valueArray[0]
        }, renderLabel(valueArray[0]));
      }
    }
  }, {
    key: "renderInput",
    value: function renderInput(valueArray, focusedOptionIndex) {
      var _cx;
      var className = cx('Select-input', this.props.inputProps.className);
      var isOpen = this.state.isOpen;
      var ariaOwns = cx((_cx = {}, _defineProperty$1(_cx, "".concat(this._instancePrefix, "-list"), isOpen), _defineProperty$1(_cx, "".concat(this._instancePrefix, "-backspace-remove-message"), this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _cx));
      var value = this.state.inputValue;
      if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
        // it hides input value when it is not focused and was not reset on select
        value = '';
      }
      var inputProps = _objectSpread$9(_objectSpread$9({}, this.props.inputProps), {}, {
        'aria-activedescendant': isOpen ? "".concat(this._instancePrefix, "-option-").concat(focusedOptionIndex) : "".concat(this._instancePrefix, "-value"),
        'aria-describedby': this.props['aria-describedby'],
        'aria-expanded': '' + isOpen,
        'aria-haspopup': '' + isOpen,
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby'],
        'aria-owns': ariaOwns,
        id: "".concat(this._instancePrefix, "-input"),
        onBlur: this.handleInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.handleInputFocus,
        ref: this.inputRef,
        role: 'combobox',
        required: this.state.required,
        tabIndex: this.props.tabIndex,
        value: value
      });
      if (this.props.inputRenderer) {
        return this.props.inputRenderer(inputProps);
      }
      if (this.props.disabled || !this.props.searchable) {
        var divProps = _extends$1({}, (_objectDestructuringEmpty(this.props.inputProps), this.props.inputProps));
        var _ariaOwns = cx(_defineProperty$1({}, "".concat(this._instancePrefix, "-list"), isOpen));
        return jsx("div", _extends$1({}, divProps, {
          "aria-expanded": isOpen,
          "aria-owns": _ariaOwns,
          "aria-activedescendant": isOpen ? "".concat(this._instancePrefix, "-option-").concat(focusedOptionIndex) : "".concat(this._instancePrefix, "-value"),
          "aria-disabled": '' + this.props.disabled,
          "aria-label": this.props['aria-label'],
          "aria-labelledby": this.props['aria-labelledby'],
          className: className,
          onBlur: this.handleInputBlur,
          onFocus: this.handleInputFocus,
          ref: this.inputRef,
          role: "combobox",
          style: {
            border: 0,
            width: 1,
            display: 'inline-block'
          },
          tabIndex: this.props.tabIndex || 0
        }));
      }
      if (this.props.autosize) {
        return jsx(_default, _extends$1({
          id: this.props.id
        }, inputProps, {
          className: className,
          minWidth: "5",
          inputStyle: {
            fontSize: 16
          }
        }));
      }
      return jsx("div", {
        className: className,
        key: "input-wrap",
        style: {
          display: 'inline-block'
        }
      }, jsx("input", _extends$1({
        id: this.props.id
      }, inputProps)));
    }
  }, {
    key: "renderClear",
    value: function renderClear() {
      var valueArray = this.getValueArray(this.props.value);
      if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
      var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
      return jsx("span", {
        "aria-label": ariaLabel,
        className: "Select-clear-zone",
        onMouseDown: this.clearValue,
        onTouchEnd: this.handleTouchEndClearValue,
        onTouchMove: this.handleTouchMove,
        onTouchStart: this.handleTouchStart,
        title: ariaLabel
      }, jsx(ClearRenderer, null));
    }
  }, {
    key: "renderArrow",
    value: function renderArrow() {
      if (!this.props.arrowRenderer) return;
      var onMouseDown = this.handleMouseDownOnArrow;
      var isOpen = this.state.isOpen;
      var arrow = this.props.arrowRenderer({
        onMouseDown: onMouseDown,
        isOpen: isOpen,
        secondary: this.props.secondaryArrow,
        searchIcon: this.props.showSearchIcon
      });
      if (!arrow) {
        return null;
      }
      return jsx("span", {
        className: cx('Select-arrow-zone', {
          'secondary-arrow': this.props.secondaryArrow,
          'search-icon': this.props.showSearchIcon
        }),
        onMouseDown: onMouseDown
      }, arrow);
    }
  }, {
    key: "filterOptions",
    value: function filterOptions$1(excludeOptions) {
      var filterValue = this.state.inputValue;
      var options = this.props.options || [];
      if (this.props.filterOptions) {
        // Maintain backwards compatibility with boolean attribute
        var filterOptions$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;
        return filterOptions$1(options, filterValue, excludeOptions, {
          filterOption: this.props.filterOption,
          ignoreAccents: this.props.ignoreAccents,
          ignoreCase: this.props.ignoreCase,
          labelKey: this.props.labelKey,
          matchPos: this.props.matchPos,
          matchProp: this.props.matchProp,
          trimFilter: this.props.trimFilter,
          valueKey: this.props.valueKey
        });
      } else {
        return options;
      }
    }
  }, {
    key: "onOptionRef",
    value: function onOptionRef(ref, isFocused) {
      if (isFocused) {
        this.focused = ref;
      }
    }
  }, {
    key: "renderMenu",
    value: function renderMenu(options, valueArray, focusedOption) {
      if (options && options.length) {
        var menuProps = {
          focusedOption: focusedOption,
          onOptionRef: this.onOptionRef,
          focusOption: this.focusOption,
          inputValue: this.state.inputValue,
          instancePrefix: this._instancePrefix,
          labelKey: this.props.labelKey,
          onFocus: this.focusOption,
          onSelect: this.selectValue,
          optionClassName: this.props.optionClassName,
          optionRenderer: this.props.optionRenderer || this.getOptionLabel,
          options: options,
          removeValue: this.removeValue,
          selectValue: this.selectValue,
          valueArray: valueArray,
          valueKey: this.props.valueKey
        };
        var MenuComponent = MenuRenderer;
        return jsx(MenuComponent, menuProps);
      } else if (this.props.noResultsText) {
        return jsx("div", {
          className: "Select-noresults"
        }, this.props.noResultsText);
      } else {
        return null;
      }
    }
  }, {
    key: "renderHiddenField",
    value: function renderHiddenField(valueArray) {
      var _this6 = this;
      if (!this.props.name) return;
      if (this.props.joinValues) {
        var value = valueArray.map(function (i) {
          return stringifyValue(i[_this6.props.valueKey]);
        }).join(this.props.delimiter);
        return jsx("input", {
          disabled: this.props.disabled,
          name: this.props.name,
          ref: this.valueRef,
          type: "hidden",
          value: value
        });
      }
      return valueArray.map(function (item, index) {
        return jsx("input", {
          disabled: _this6.props.disabled,
          key: "hidden.".concat(index),
          name: _this6.props.name,
          ref: "value".concat(index),
          type: "hidden",
          value: stringifyValue(item[_this6.props.valueKey])
        });
      });
    }
  }, {
    key: "getFocusableOptionIndex",
    value: function getFocusableOptionIndex(selectedOption) {
      var options = this._visibleOptions;
      if (!options.length) return null;
      var valueKey = this.props.valueKey;
      var focusedOption = this.state.focusedOption || selectedOption;
      if (focusedOption && !focusedOption.disabled) {
        var focusedOptionIndex = -1;
        options.some(function (option, index) {
          var isOptionEqual = option[valueKey] === focusedOption[valueKey];
          if (isOptionEqual) {
            focusedOptionIndex = index;
          }
          return isOptionEqual;
        });
        if (focusedOptionIndex !== -1) {
          return focusedOptionIndex;
        }
      }
      if (this.props.focusDefaultOption) {
        for (var i = 0; i < options.length; i++) {
          if (!options[i].disabled) return i;
        }
      }
      return null;
    }
  }, {
    key: "renderOuter",
    value: function renderOuter(options, valueArray, focusedOption) {
      var menu = this.renderMenu(options, valueArray, focusedOption);
      if (!menu) {
        return null;
      }
      return jsx("div", {
        ref: this.menuContainerRef,
        className: "Select-menu-outer",
        style: this.props.menuContainerStyle
      }, jsx("div", {
        className: "Select-menu",
        id: "".concat(this._instancePrefix, "-list"),
        onMouseDown: this.handleMouseDownOnMenu,
        onScroll: this.handleMenuScroll,
        ref: this.menuRef,
        role: "listbox",
        style: this.props.menuStyle,
        tabIndex: -1
      }, menu));
    }
  }, {
    key: "render",
    value: function render() {
      var valueArray = this.getValueArray(this.props.value);
      var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
      var isOpen = this.state.isOpen;
      if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
      var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
      var focusedOption = null;
      if (focusedOptionIndex !== null) {
        focusedOption = this._focusedOption = options[focusedOptionIndex];
      } else {
        focusedOption = this._focusedOption = null;
      }
      var className = cx('Select', this.props.className, {
        'has-value': valueArray.length,
        'is-clearable': this.props.clearable,
        'is-disabled': this.props.disabled,
        'is-focused': this.state.isFocused,
        'is-loading': this.props.isLoading,
        'is-open': isOpen,
        'is-pseudo-focused': this.state.isPseudoFocused,
        'is-searchable': this.props.searchable,
        'Select--multi': this.props.multi,
        'Select--single': !this.props.multi
      });
      var removeMessage = null;
      if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
        removeMessage = jsx("span", {
          id: "".concat(this._instancePrefix, "-backspace-remove-message"),
          className: "Select-aria-only",
          "aria-live": "assertive"
        }, this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey]));
      }
      return jsx("div", {
        css: cssSelect,
        ref: this.wrapperRef,
        className: className,
        style: this.props.wrapperStyle
      }, this.renderHiddenField(valueArray), jsx("div", {
        ref: this.controlRef,
        className: "Select-control",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleMouseDown,
        onTouchEnd: this.handleTouchEnd,
        onTouchMove: this.handleTouchMove,
        onTouchStart: this.handleTouchStart,
        style: this.props.style
      }, this.props.displayPrefixIcon && jsx(PrefixRenderer, null), jsx("div", {
        className: cx('Select-multi-value-wrapper', {
          'has-prefix-icon': this.props.displayPrefixIcon
        }),
        id: "".concat(this._instancePrefix, "-value")
      }, this.renderValue(valueArray, isOpen), this.renderInput(valueArray, focusedOptionIndex)), removeMessage, this.renderLoading(), this.renderClear(), this.renderArrow()), isOpen ? this.renderOuter(options, valueArray, focusedOption) : null);
    }
  }]);
  return SelectorComponent;
}(React__default.Component);
SelectorComponent.propTypes = {
  displayPrefixIcon: bool,
  secondaryArrow: bool,
  showSearchIcon: bool,
  'aria-describedby': string,
  // html id(s) of element(s) that should be used to describe this input (for assistive tech)
  'aria-label': string,
  // aria label (for assistive tech)
  'aria-labelledby': string,
  // html id of an element that should be used as the label (for assistive tech)
  arrowRenderer: func,
  // create the drop-down caret element
  autoBlur: bool,
  // automatically blur the component when an option is selected
  autoFocus: bool,
  // autofocus the component on mount
  autofocus: bool,
  // deprecated; use autoFocus instead
  autosize: bool,
  // whether to enable autosizing or not
  backspaceRemoves: bool,
  // whether backspace removes an item if there is no text input
  backspaceToRemoveMessage: string,
  // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
  className: string,
  // className for the outer element
  clearAllText: oneOfType([string, node$2]),
  // title for the "clear" control when multi: true
  clearValueText: oneOfType([string, node$2]),
  // title for the "clear" control
  clearable: bool,
  // should it be possible to reset value
  closeOnSelect: bool,
  // whether to close the menu when a value is selected
  deleteRemoves: bool,
  // whether delete removes an item if there is no text input
  delimiter: string,
  // delimiter to use to join multiple values for the hidden field value
  disabled: bool,
  // whether the Select is disabled or not
  escapeClearsValue: bool,
  // whether escape clears the value when the menu is closed
  filterOption: func,
  // method to filter a single option (option, filterString)
  filterOptions: any,
  // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
  id: string,
  // html id to set on the input element for accessibility or tests
  ignoreAccents: bool,
  // whether to strip diacritics when filtering
  ignoreCase: bool,
  // whether to perform case-insensitive filtering
  inputProps: object$1,
  // custom attributes for the Input
  inputRenderer: func,
  // returns a custom input component
  instanceId: string,
  // set the components instanceId
  isLoading: bool,
  // whether the Select is loading externally or not (such as options being loaded)
  joinValues: bool,
  // joins multiple values into a single form field with the delimiter (legacy mode)
  labelKey: string,
  // path of the label value in option objects
  matchPos: string,
  // (any|start) match the start or entire string when filtering
  matchProp: string,
  // (any|label|value) which option property to filter on
  menuBuffer: number$4,
  // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
  menuContainerStyle: object$1,
  // optional style to apply to the menu container
  menuStyle: object$1,
  // optional style to apply to the menu
  multi: bool,
  // multi-value input
  name: string,
  // generates a hidden <input /> tag with this field name for html forms
  noResultsText: oneOfType([string, node$2]),
  // placeholder displayed when there are no matching search results
  onBlur: func,
  // onBlur handler: function (event) {}
  onBlurResetsInput: bool,
  // whether input is cleared on blur
  onChange: func,
  // onChange handler: function (newValue) {}
  onClose: func,
  // fires when the menu is closed
  onCloseResetsInput: bool,
  // whether input is cleared when menu is closed through the arrow
  onFocus: func,
  // onFocus handler: function (event) {}
  onInputChange: func,
  // onInputChange handler: function (inputValue) {}
  onInputKeyDown: func,
  // input keyDown handler: function (event) {}
  onMenuScrollToBottom: func,
  // fires when the menu is scrolled to the bottom; can be used to paginate options
  onOpen: func,
  // fires when the menu is opened
  onSelectResetsInput: bool,
  // whether input is cleared on select (works only for multiselect)
  onValueClick: func,
  // onClick handler for value labels: function (value, event) {}
  openOnClick: bool,
  // boolean to control opening the menu when the control is clicked
  openOnFocus: bool,
  // always open options menu on focus
  optionClassName: string,
  // additional class(es) to apply to the <Option /> elements
  optionComponent: func,
  // option component to render in dropdown
  optionRenderer: func,
  // optionRenderer: function (option) {}
  options: array$2,
  // array of options
  pageSize: number$4,
  // number of entries to page when using page up/down keys
  placeholder: oneOfType([string, node$2]),
  // field placeholder, displayed when there's no value
  removeSelected: bool,
  // whether the selected option is removed from the dropdown on multi selects
  required: bool,
  // applies HTML5 required attribute when needed
  resetValue: any,
  // value to use when you clear the control
  scrollMenuIntoView: bool,
  // boolean to enable the viewport to shift so that the full menu fully visible when engaged
  searchable: bool,
  // whether to enable searching feature or not
  simpleValue: bool,
  // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
  style: object$1,
  // optional style to apply to the control
  tabIndex: oneOfType([string, number$4]),
  // optional tab index of the control
  tabSelectsValue: bool,
  // whether to treat tabbing out while focused to be value selection
  trimFilter: bool,
  // whether to trim whitespace around filter value
  value: any,
  // initial field value
  // valueComponent: func, // value component to render
  valueKey: string,
  // path of the label value in option objects
  valueRenderer: func,
  // valueRenderer: function (option) {}
  wrapperStyle: object$1,
  // optional style to apply to the component wrapper
  focusDefaultOption: bool
};
var Selector = function Selector(rawProps) {
  var props = _objectSpread$9(_objectSpread$9({}, defaultProps$5), rawProps);
  return jsx(SelectorComponent, props);
};
Selector.propTypes = {
  displayPrefixIcon: bool,
  secondaryArrow: bool,
  showSearchIcon: bool,
  'aria-describedby': string,
  // html id(s) of element(s) that should be used to describe this input (for assistive tech)
  'aria-label': string,
  // aria label (for assistive tech)
  'aria-labelledby': string,
  // html id of an element that should be used as the label (for assistive tech)
  arrowRenderer: func,
  // create the drop-down caret element
  autoBlur: bool,
  // automatically blur the component when an option is selected
  autoFocus: bool,
  // autofocus the component on mount
  autofocus: bool,
  // deprecated; use autoFocus instead
  autosize: bool,
  // whether to enable autosizing or not
  backspaceRemoves: bool,
  // whether backspace removes an item if there is no text input
  backspaceToRemoveMessage: string,
  // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
  className: string,
  // className for the outer element
  clearAllText: oneOfType([string, node$2]),
  // title for the "clear" control when multi: true
  clearValueText: oneOfType([string, node$2]),
  // title for the "clear" control
  clearable: bool,
  // should it be possible to reset value
  closeOnSelect: bool,
  // whether to close the menu when a value is selected
  deleteRemoves: bool,
  // whether delete removes an item if there is no text input
  delimiter: string,
  // delimiter to use to join multiple values for the hidden field value
  disabled: bool,
  // whether the Select is disabled or not
  escapeClearsValue: bool,
  // whether escape clears the value when the menu is closed
  filterOption: func,
  // method to filter a single option (option, filterString)
  filterOptions: any,
  // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
  id: string,
  // html id to set on the input element for accessibility or tests
  ignoreAccents: bool,
  // whether to strip diacritics when filtering
  ignoreCase: bool,
  // whether to perform case-insensitive filtering
  inputProps: object$1,
  // custom attributes for the Input
  inputRenderer: func,
  // returns a custom input component
  instanceId: string,
  // set the components instanceId
  isLoading: bool,
  // whether the Select is loading externally or not (such as options being loaded)
  joinValues: bool,
  // joins multiple values into a single form field with the delimiter (legacy mode)
  labelKey: string,
  // path of the label value in option objects
  matchPos: string,
  // (any|start) match the start or entire string when filtering
  matchProp: string,
  // (any|label|value) which option property to filter on
  menuBuffer: number$4,
  // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
  menuContainerStyle: object$1,
  // optional style to apply to the menu container
  menuStyle: object$1,
  // optional style to apply to the menu
  multi: bool,
  // multi-value input
  name: string,
  // generates a hidden <input /> tag with this field name for html forms
  noResultsText: oneOfType([string, node$2]),
  // placeholder displayed when there are no matching search results
  onBlur: func,
  // onBlur handler: function (event) {}
  onBlurResetsInput: bool,
  // whether input is cleared on blur
  onChange: func,
  // onChange handler: function (newValue) {}
  onClose: func,
  // fires when the menu is closed
  onCloseResetsInput: bool,
  // whether input is cleared when menu is closed through the arrow
  onFocus: func,
  // onFocus handler: function (event) {}
  onInputChange: func,
  // onInputChange handler: function (inputValue) {}
  onInputKeyDown: func,
  // input keyDown handler: function (event) {}
  onMenuScrollToBottom: func,
  // fires when the menu is scrolled to the bottom; can be used to paginate options
  onOpen: func,
  // fires when the menu is opened
  onSelectResetsInput: bool,
  // whether input is cleared on select (works only for multiselect)
  onValueClick: func,
  // onClick handler for value labels: function (value, event) {}
  openOnClick: bool,
  // boolean to control opening the menu when the control is clicked
  openOnFocus: bool,
  // always open options menu on focus
  optionClassName: string,
  // additional class(es) to apply to the <Option /> elements
  optionComponent: func,
  // option component to render in dropdown
  optionRenderer: func,
  // optionRenderer: function (option) {}
  options: array$2,
  // array of options
  pageSize: number$4,
  // number of entries to page when using page up/down keys
  placeholder: oneOfType([string, node$2]),
  // field placeholder, displayed when there's no value
  removeSelected: bool,
  // whether the selected option is removed from the dropdown on multi selects
  required: bool,
  // applies HTML5 required attribute when needed
  resetValue: any,
  // value to use when you clear the control
  scrollMenuIntoView: bool,
  // boolean to enable the viewport to shift so that the full menu fully visible when engaged
  searchable: bool,
  // whether to enable searching feature or not
  simpleValue: bool,
  // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
  style: object$1,
  // optional style to apply to the control
  tabIndex: oneOfType([string, number$4]),
  // optional tab index of the control
  tabSelectsValue: bool,
  // whether to treat tabbing out while focused to be value selection
  trimFilter: bool,
  // whether to trim whitespace around filter value
  value: any,
  // initial field value
  // valueComponent: func, // value component to render
  valueKey: string,
  // path of the label value in option objects
  valueRenderer: func,
  // valueRenderer: function (option) {}
  wrapperStyle: object$1,
  // optional style to apply to the component wrapper
  focusDefaultOption: bool
};

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }
function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var defaultCache = {};
var defaultChildren$2 = function defaultChildren(props) {
  return jsx(Selector, props);
};
var defaultProps$4 = {
  autoLoad: true,
  cache: defaultCache,
  children: defaultChildren$2,
  ignoreAccents: true,
  ignoreCase: true,
  loadingPlaceholder: 'Loading...',
  options: [],
  searchPromptText: 'Type to search'
};
var AsyncSelect = /*#__PURE__*/function (_React$Component) {
  _inherits$1(AsyncSelect, _React$Component);
  var _super = _createSuper$3(AsyncSelect);
  function AsyncSelect(props) {
    var _this;
    _classCallCheck$1(this, AsyncSelect);
    _this = _super.call(this, props);
    _this._cache = props.cache === defaultCache ? {} : props.cache;
    _this.state = {
      inputValue: '',
      isLoading: false,
      options: props.options
    };
    _this.onInputChange = _this.onInputChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass$1(AsyncSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var autoLoad = this.props.autoLoad;
      if (autoLoad) {
        this.loadOptions('');
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.options !== this.props.options) {
        this.setState({
          options: nextProps.options
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._callback = null;
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(inputValue) {
      var _this2 = this;
      var loadOptions = this.props.loadOptions;
      var cache = this._cache;
      if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
        this._callback = null;
        this.setState({
          isLoading: false,
          options: cache[inputValue]
        });
        return;
      }
      var callback = function callback(error, data) {
        var options = data && data.options || [];
        if (cache) {
          cache[inputValue] = options;
        }
        if (callback === _this2._callback) {
          _this2._callback = null;
          _this2.setState({
            isLoading: false,
            options: options
          });
        }
      };

      // Ignore all but the most recent request
      this._callback = callback;
      var promise = loadOptions(inputValue, callback);
      if (promise) {
        promise.then(function (data) {
          return callback(null, data);
        })["catch"](function (error) {
          return callback();
        });
      }
      if (this._callback && !this.state.isLoading) {
        this.setState({
          isLoading: true
        });
      }
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(inputValue) {
      var _this$props = this.props,
        ignoreAccents = _this$props.ignoreAccents,
        ignoreCase = _this$props.ignoreCase,
        onInputChange = _this$props.onInputChange;
      var newInputValue = inputValue;
      if (onInputChange) {
        var value = onInputChange(newInputValue);
        // Note: != used deliberately here to catch undefined and null
        if (value != null && _typeof(value) !== 'object') {
          newInputValue = '' + value;
        }
      }
      var transformedInputValue = newInputValue;
      if (ignoreAccents) {
        transformedInputValue = stripDiacritics(transformedInputValue);
      }
      if (ignoreCase) {
        transformedInputValue = transformedInputValue.toLowerCase();
      }
      this.setState({
        inputValue: newInputValue
      });
      this.loadOptions(transformedInputValue);

      // Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
      return newInputValue;
    }
  }, {
    key: "noResultsText",
    value: function noResultsText() {
      var _this$props2 = this.props,
        loadingPlaceholder = _this$props2.loadingPlaceholder,
        noResultsText = _this$props2.noResultsText,
        searchPromptText = _this$props2.searchPromptText;
      var _this$state = this.state,
        inputValue = _this$state.inputValue,
        isLoading = _this$state.isLoading;
      if (isLoading) {
        return loadingPlaceholder;
      }
      if (inputValue && noResultsText) {
        return noResultsText;
      }
      return searchPromptText;
    }
  }, {
    key: "focus",
    value: function focus() {
      this.select.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props3 = this.props,
        children = _this$props3.children,
        loadingPlaceholder = _this$props3.loadingPlaceholder,
        placeholder = _this$props3.placeholder;
      var _this$state2 = this.state,
        isLoading = _this$state2.isLoading,
        options = _this$state2.options;
      var props = {
        noResultsText: this.noResultsText(),
        placeholder: isLoading ? loadingPlaceholder : placeholder,
        options: isLoading && loadingPlaceholder ? [] : options,
        ref: function ref(_ref) {
          return _this3.select = _ref;
        }
      };
      return children(_objectSpread$8(_objectSpread$8(_objectSpread$8({}, this.props), props), {}, {
        isLoading: isLoading,
        onInputChange: this.onInputChange
      }));
    }
  }]);
  return AsyncSelect;
}(React__default.Component);
AsyncSelect.propTypes = {
  autoLoad: bool.isRequired,
  // automatically call the `loadOptions` prop on-mount; defaults to true
  cache: any,
  // object to use to cache results; set to null/false to disable caching
  children: func.isRequired,
  // Child function responsible for creating the inner Select component; (props: Object): element
  ignoreAccents: bool,
  // strip diacritics when filtering; defaults to true
  ignoreCase: bool,
  // perform case-insensitive filtering; defaults to true
  loadOptions: func.isRequired,
  // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
  loadingPlaceholder: oneOfType([
  // replaces the placeholder while options are loading
  string, node$2]),
  multi: bool,
  // multi-value input
  noResultsText: oneOfType([
  // field noResultsText, displayed when no options come back from the server
  string, node$2]),
  onChange: func,
  // onChange handler: function (newValue) {}
  onInputChange: func,
  // optional for keeping track of what is being typed
  options: array$2.isRequired,
  // array of options
  placeholder: oneOfType([
  // field placeholder, displayed when there's no value (shared with Select)
  string, node$2]),
  searchPromptText: oneOfType([
  // label to prompt for search input
  string, node$2]),
  value: any // initial field value
};

var Async = function Async(rawProps) {
  var props = _objectSpread$8(_objectSpread$8({}, defaultProps$4), rawProps);
  return jsx(AsyncSelect, props);
};
Async.propTypes = {
  autoLoad: bool.isRequired,
  // automatically call the `loadOptions` prop on-mount; defaults to true
  cache: any,
  // object to use to cache results; set to null/false to disable caching
  children: func.isRequired,
  // Child function responsible for creating the inner Select component; (props: Object): element
  ignoreAccents: bool,
  // strip diacritics when filtering; defaults to true
  ignoreCase: bool,
  // perform case-insensitive filtering; defaults to true
  loadOptions: func.isRequired,
  // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
  loadingPlaceholder: oneOfType([
  // replaces the placeholder while options are loading
  string, node$2]),
  multi: bool,
  // multi-value input
  noResultsText: oneOfType([
  // field noResultsText, displayed when no options come back from the server
  string, node$2]),
  onChange: func,
  // onChange handler: function (newValue) {}
  onInputChange: func,
  // optional for keeping track of what is being typed
  options: array$2.isRequired,
  // array of options
  placeholder: oneOfType([
  // field placeholder, displayed when there's no value (shared with Select)
  string, node$2]),
  searchPromptText: oneOfType([
  // label to prompt for search input
  string, node$2]),
  value: any // initial field value
};

var _excluded$f = ["ref"];
function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }
function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var defaultChildren$1 = function defaultChildren(props) {
  return jsx(Selector, props);
};
var isOptionUnique = function isOptionUnique(_ref) {
  var option = _ref.option,
    options = _ref.options,
    labelKey = _ref.labelKey,
    valueKey = _ref.valueKey;
  if (!options || !options.length) {
    return true;
  }
  return options.filter(function (existingOption) {
    return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
  }).length === 0;
};
var isValidNewOption = function isValidNewOption(_ref2) {
  var label = _ref2.label;
  return !!label;
};
var newOptionCreator = function newOptionCreator(_ref3) {
  var label = _ref3.label,
    labelKey = _ref3.labelKey,
    valueKey = _ref3.valueKey;
  var option = {};
  option[valueKey] = label;
  option[labelKey] = label;
  option.className = 'Select-create-option-placeholder';
  return option;
};
var promptTextCreator = function promptTextCreator(label) {
  return "Create option \"".concat(label, "\"");
};
var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref4) {
  var keyCode = _ref4.keyCode;
  switch (keyCode) {
    case 9: // TAB
    case 13: // ENTER
    case 188:
      // COMMA
      return true;
    default:
      return false;
  }
};
var defaultProps$3 = {
  filterOptions: filterOptions,
  isOptionUnique: isOptionUnique,
  isValidNewOption: isValidNewOption,
  menuRenderer: MenuRenderer,
  newOptionCreator: newOptionCreator,
  promptTextCreator: promptTextCreator,
  shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
  showNewOptionAtTop: true
};
var CreatableComponent = /*#__PURE__*/function (_React$Component) {
  _inherits$1(CreatableComponent, _React$Component);
  var _super = _createSuper$2(CreatableComponent);
  function CreatableComponent(props, context) {
    var _this;
    _classCallCheck$1(this, CreatableComponent);
    _this = _super.call(this, props, context);
    _this.filterOptions = _this.filterOptions.bind(_assertThisInitialized(_this));
    _this.menuRenderer = _this.menuRenderer.bind(_assertThisInitialized(_this));
    _this.onInputKeyDown = _this.onInputKeyDown.bind(_assertThisInitialized(_this));
    _this.onInputChange = _this.onInputChange.bind(_assertThisInitialized(_this));
    _this.onOptionSelect = _this.onOptionSelect.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass$1(CreatableComponent, [{
    key: "createNewOption",
    value: function createNewOption() {
      var _this$props = this.props,
        isValidNewOption = _this$props.isValidNewOption,
        newOptionCreator = _this$props.newOptionCreator,
        onNewOptionClick = _this$props.onNewOptionClick,
        _this$props$options = _this$props.options,
        options = _this$props$options === void 0 ? [] : _this$props$options;
      if (isValidNewOption({
        label: this.inputValue
      })) {
        var option = newOptionCreator({
          label: this.inputValue,
          labelKey: this.labelKey,
          valueKey: this.valueKey
        });
        var _isOptionUnique = this.isOptionUnique({
          option: option,
          options: options
        });

        // Don't add the same option twice.
        if (_isOptionUnique) {
          if (onNewOptionClick) {
            onNewOptionClick(option);
          } else {
            options.unshift(option);
            this.select.selectValue(option);
          }
        }
      }
    }
  }, {
    key: "filterOptions",
    value: function filterOptions() {
      var _this$props2 = this.props,
        filterOptions = _this$props2.filterOptions,
        isValidNewOption = _this$props2.isValidNewOption,
        promptTextCreator = _this$props2.promptTextCreator,
        showNewOptionAtTop = _this$props2.showNewOptionAtTop;

      // TRICKY Check currently selected options as well.
      // Don't display a create-prompt for a value that's selected.
      // This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
      var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
      var filteredOptions = filterOptions.apply(void 0, arguments) || [];
      if (isValidNewOption({
        label: this.inputValue
      })) {
        var _newOptionCreator = this.props.newOptionCreator;
        var option = _newOptionCreator({
          label: this.inputValue,
          labelKey: this.labelKey,
          valueKey: this.valueKey
        });

        // TRICKY Compare to all options (not just filtered options) in case option has already been selected).
        // For multi-selects, this would remove it from the filtered list.
        var _isOptionUnique2 = this.isOptionUnique({
          option: option,
          options: excludeOptions.concat(filteredOptions)
        });
        if (_isOptionUnique2) {
          var prompt = promptTextCreator(this.inputValue);
          this._createPlaceholderOption = _newOptionCreator({
            label: prompt,
            labelKey: this.labelKey,
            valueKey: this.valueKey
          });
          if (showNewOptionAtTop) {
            filteredOptions.unshift(this._createPlaceholderOption);
          } else {
            filteredOptions.push(this._createPlaceholderOption);
          }
        }
      }
      return filteredOptions;
    }
  }, {
    key: "isOptionUnique",
    value: function isOptionUnique(_ref5) {
      var option = _ref5.option,
        options = _ref5.options;
      var isOptionUnique = this.props.isOptionUnique;
      options = options || this.props.options;
      return isOptionUnique({
        labelKey: this.labelKey,
        option: option,
        options: options,
        valueKey: this.valueKey
      });
    }
  }, {
    key: "menuRenderer",
    value: function menuRenderer(params) {
      var menuRenderer = this.props.menuRenderer;
      return menuRenderer(_objectSpread$7(_objectSpread$7({}, params), {}, {
        onSelect: this.onOptionSelect,
        selectValue: this.onOptionSelect
      }));
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(input) {
      var onInputChange = this.props.onInputChange;

      // This value may be needed in between Select mounts (when this.select is null)
      this.inputValue = input;
      if (onInputChange) {
        this.inputValue = onInputChange(input);
      }
      return this.inputValue;
    }
  }, {
    key: "onInputKeyDown",
    value: function onInputKeyDown(event) {
      var _this$props3 = this.props,
        shouldKeyDownEventCreateNewOption = _this$props3.shouldKeyDownEventCreateNewOption,
        onInputKeyDown = _this$props3.onInputKeyDown;
      var focusedOption = this.select.getFocusedOption();
      if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
        this.createNewOption();

        // Prevent decorated Select from doing anything additional with this keyDown event
        event.preventDefault();
      } else if (onInputKeyDown) {
        onInputKeyDown(event);
      }
    }
  }, {
    key: "onOptionSelect",
    value: function onOptionSelect(option) {
      if (option === this._createPlaceholderOption) {
        this.createNewOption();
      } else {
        this.select.selectValue(option);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.select.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        refProp = _this$props4.ref,
        restProps = _objectWithoutProperties$1(_this$props4, _excluded$f);
      var children = this.props.children;

      // We can't use destructuring default values to set the children,
      // because it won't apply work if `children` is null. A falsy check is
      // more reliable in real world use-cases.
      if (!children) {
        children = defaultChildren$1;
      }
      var props = _objectSpread$7(_objectSpread$7({}, restProps), {}, {
        allowCreate: true,
        filterOptions: this.filterOptions,
        menuRenderer: this.menuRenderer,
        onInputChange: this.onInputChange,
        onInputKeyDown: this.onInputKeyDown,
        ref: function ref(_ref6) {
          _this2.select = _ref6;

          // These values may be needed in between Select mounts (when this.select is null)
          if (_ref6) {
            _this2.labelKey = _ref6.props.labelKey;
            _this2.valueKey = _ref6.props.valueKey;
          }
          if (refProp) {
            refProp(_ref6);
          }
        }
      });
      return children(props);
    }
  }]);
  return CreatableComponent;
}(React__default.Component);
CreatableComponent.propTypes = {
  // Child function responsible for creating the inner Select component
  // This component can be used to compose HOCs (eg Creatable and Async)
  // (props: Object): element
  children: func,
  // See Select.filterOptions
  filterOptions: any,
  // Searches for any matching option within the set of options.
  // This function prevents duplicate options from being created.
  // ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
  isOptionUnique: func,
  // Determines if the current input text represents a valid option.
  // ({ label: string }): boolean
  isValidNewOption: func,
  // See Select.menuRenderer
  menuRenderer: any,
  // Factory to create new option.
  // ({ label: string, labelKey: string, valueKey: string }): Object
  newOptionCreator: func,
  // input change handler: function (inputValue) {}
  onInputChange: func,
  // input keyDown handler: function (event) {}
  onInputKeyDown: func,
  // new option click handler: function (option) {}
  onNewOptionClick: func,
  // See Select.options
  options: array$2,
  // Creates prompt/placeholder option text.
  // (filterText: string): string
  promptTextCreator: func,
  ref: func,
  // Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
  shouldKeyDownEventCreateNewOption: func,
  // Where to show prompt/placeholder option text.
  // true: new option prompt at top of list (default)
  // false: new option prompt at bottom of list
  showNewOptionAtTop: bool
};
var Creatable = function Creatable(rawProps) {
  var props = _objectSpread$7(_objectSpread$7({}, defaultProps$3), rawProps);
  return jsx(CreatableComponent, props);
};

// Default prop methods
Creatable.isOptionUnique = isOptionUnique;
Creatable.isValidNewOption = isValidNewOption;
Creatable.newOptionCreator = newOptionCreator;
Creatable.promptTextCreator = promptTextCreator;
Creatable.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
Creatable.propTypes = {
  // Child function responsible for creating the inner Select component
  // This component can be used to compose HOCs (eg Creatable and Async)
  // (props: Object): element
  children: func,
  // See Select.filterOptions
  filterOptions: any,
  // Searches for any matching option within the set of options.
  // This function prevents duplicate options from being created.
  // ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
  isOptionUnique: func,
  // Determines if the current input text represents a valid option.
  // ({ label: string }): boolean
  isValidNewOption: func,
  // See Select.menuRenderer
  menuRenderer: any,
  // Factory to create new option.
  // ({ label: string, labelKey: string, valueKey: string }): Object
  newOptionCreator: func,
  // input change handler: function (inputValue) {}
  onInputChange: func,
  // input keyDown handler: function (event) {}
  onInputKeyDown: func,
  // new option click handler: function (option) {}
  onNewOptionClick: func,
  // See Select.options
  options: array$2,
  // Creates prompt/placeholder option text.
  // (filterText: string): string
  promptTextCreator: func,
  ref: func,
  // Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
  shouldKeyDownEventCreateNewOption: func,
  // Where to show prompt/placeholder option text.
  // true: new option prompt at top of list (default)
  // false: new option prompt at bottom of list
  showNewOptionAtTop: bool
};

var _excluded$e = ["ref"],
  _excluded2$3 = ["ref"];
function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var defaultChildren = function defaultChildren(props) {
  return jsx(Selector, props);
};
var defaultProps$2 = {
  children: defaultChildren
};
var AsyncCreatableComponent = /*#__PURE__*/function (_React$Component) {
  _inherits$1(AsyncCreatableComponent, _React$Component);
  var _super = _createSuper$1(AsyncCreatableComponent);
  function AsyncCreatableComponent() {
    _classCallCheck$1(this, AsyncCreatableComponent);
    return _super.apply(this, arguments);
  }
  _createClass$1(AsyncCreatableComponent, [{
    key: "focus",
    value: function focus() {
      this.select.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      return jsx(Async, this.props, function (_ref) {
        var ref = _ref.ref,
          asyncProps = _objectWithoutProperties$1(_ref, _excluded$e);
        var asyncRef = ref;
        return jsx(Creatable, asyncProps, function (_ref2) {
          var ref = _ref2.ref,
            creatableProps = _objectWithoutProperties$1(_ref2, _excluded2$3);
          var creatableRef = ref;
          return _this.props.children(_objectSpread$6(_objectSpread$6({}, creatableProps), {}, {
            ref: function ref(select) {
              creatableRef(select);
              asyncRef(select);
              _this.select = select;
            }
          }));
        });
      });
    }
  }]);
  return AsyncCreatableComponent;
}(React__default.Component);
AsyncCreatableComponent.propTypes = {
  // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
  children: func.isRequired
};
var AsyncCreatable = function AsyncCreatable(rawProps) {
  var props = _objectSpread$6(_objectSpread$6({}, defaultProps$2), rawProps);
  return jsx(AsyncCreatableComponent, props);
};
AsyncCreatable.propTypes = {
  // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
  children: func.isRequired
};

Selector.Async = Async;
Selector.AsyncCreatable = AsyncCreatable;
Selector.Creatable = Creatable;
Selector.Value = Value;
Selector.Option = Option;

var _excluded$d = ["showAt", "label"];
var BackToTop = /*#__PURE__*/forwardRef(function (props, ref) {
  var backToTopRef = useRef();
  var _props$showAt = props.showAt,
    showAt = _props$showAt === void 0 ? '200' : _props$showAt,
    _props$label = props.label,
    label = _props$label === void 0 ? 'Back To Top' : _props$label,
    rest = _objectWithoutProperties$1(props, _excluded$d);
  useEffect(function () {
    if (backToTopRef.current) {
      new FwcBackToTop(backToTopRef.current).build();
    }
  }, []);
  return jsx("fwc-back-to-top", _extends$1({}, rest, {
    ref: mergeRefs(backToTopRef, ref),
    "label-btn": label,
    "show-button-at-px": showAt
  }));
});
BackToTop.displayName = 'BackToTop';
BackToTop.propTypes = {
  label: string,
  showAt: string
};

var _excluded$c = ["data", "barsMarginBottom", "noWrap", "customColors"];
var overrideStyles$4 = function overrideStyles(config) {
  var barMarginBottom = config.barMarginBottom,
    noWrap = config.noWrap,
    _config$customColors = config.customColors,
    customColors = _config$customColors === void 0 ? [] : _config$customColors;
  return "\n    .fwc-cb-flex {\n      margin-bottom: ".concat(barMarginBottom || 10, "px;\n    }\n\n    @media screen and (max-width: 900px) {\n      .fwc-cb-flex {\n        flex-direction: ").concat(noWrap ? 'row' : 'column', ";\n      }\n    }\n\n    .fwc-cb-flex .fwc-cb-bar {\n      background-color: ").concat((customColors === null || customColors === void 0 ? void 0 : customColors[0]) || 'var(--color-dviz-one)', ";\n    }\n    dl .fwc-cb-flex:nth-of-type(2n) .fwc-cb-container .fwc-cb-bar {\n      background-color: ").concat((customColors === null || customColors === void 0 ? void 0 : customColors[1]) || 'var(--color-dviz-four)', ";\n    }\n    dl .fwc-cb-flex:nth-of-type(3n) .fwc-cb-container .fwc-cb-bar {\n      background-color: ").concat((customColors === null || customColors === void 0 ? void 0 : customColors[2]) || 'var(--color-dviz-eight)', ";\n    }\n    dl .fwc-cb-flex:nth-of-type(4n) .fwc-cb-container .fwc-cb-bar {\n      background-color: ").concat((customColors === null || customColors === void 0 ? void 0 : customColors[3]) || 'var(--color-dviz-seven)', ";\n    }\n  ");
};
var ProgressBars = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    _props$barsMarginBott = props.barsMarginBottom,
    barsMarginBottom = _props$barsMarginBott === void 0 ? 10 : _props$barsMarginBott,
    _props$noWrap = props.noWrap,
    noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
    _props$customColors = props.customColors,
    customColors = _props$customColors === void 0 ? [] : _props$customColors,
    rest = _objectWithoutProperties$1(props, _excluded$c);
  var progressBarsRef = useRef();
  var progressBarsCustomStyle = useRef(document.createElement('style'));
  useEffect(function () {
    new FwcBars(progressBarsRef.current).build();
  }, []);
  useEffect(function () {
    if (progressBarsRef.current) {
      var progressBarShadowDOM = progressBarsRef.current.shadowRoot;
      progressBarsCustomStyle.current.innerHTML = overrideStyles$4({
        barsMarginBottom: barsMarginBottom,
        noWrap: noWrap,
        customColors: customColors
      });
      setTimeout(function () {
        progressBarShadowDOM.appendChild(progressBarsCustomStyle.current);
      }, 0);
    }
  }, [barsMarginBottom, noWrap, customColors]);
  return jsx("fwc-bars", _extends$1({}, rest, {
    ref: mergeRefs(progressBarsRef, ref),
    bars: JSON.stringify(data)
  }));
});
ProgressBars.displayName = 'ProgressBars';
ProgressBars.propTypes = {
  noWrap: bool,
  barsMarginBottom: number$4,
  data: arrayOf(shape({
    title: string,
    value: number$4,
    max: number$4
  })),
  customColors: arrayOf(string)
};

var CarouselItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children;
  return jsx("fwc-carousel-generic-item", {
    ref: ref
  }, children);
});
CarouselItem.displayName = 'Carousel.Item';
CarouselItem.propTypes = {
  children: node$2
};
var Carousel = /*#__PURE__*/forwardRef(function (props, ref) {
  var onNextClick = props.onNextClick,
    onPreviousClick = props.onPreviousClick,
    onAnimationEnd = props.onAnimationEnd,
    children = props.children;
  var carouselRef = useRef();
  var uiState = useSBUIState();
  var assetsPath = (uiState === null || uiState === void 0 ? void 0 : uiState.assetsPath) || './';
  var fwcCarouselProps = getFwcProps$1(props, {
    id: 'id',
    ariaLabel: 'label-aria',
    ariaLabelPrevBtn: 'label-aria-prev-btn',
    ariaLabelNextBtn: 'label-aria-next-btn',
    dataAnalyticsNextBtn: 'data-analytics-next-btn',
    dataAnalyticsPrevBtn: 'data-analytics-prev-btn'
  }, {
    ariaLabel: 'Carousel',
    ariaLabelNextBtn: 'Next Slide',
    ariaLabelPrevBtn: 'Previous Slide'
  });
  useEffect(function () {
    if (carouselRef.current) {
      new FwcCarouselGeneric(carouselRef.current).build();
    }
  }, []);
  var handleNextClick = function handleNextClick(e) {
    onNextClick === null || onNextClick === void 0 ? void 0 : onNextClick(e);
  };
  var handlePreviousClick = function handlePreviousClick(e) {
    onPreviousClick === null || onPreviousClick === void 0 ? void 0 : onPreviousClick(e);
  };
  var handleAnimationEnd = function handleAnimationEnd(e) {
    onAnimationEnd === null || onAnimationEnd === void 0 ? void 0 : onAnimationEnd(e);
  };
  useEffect(function () {
    var carouselElement = null;
    if (carouselRef.current) {
      carouselRef.current.addEventListener('fwc-carousel-generic-next', handleNextClick);
      carouselRef.current.addEventListener('fwc-carousel-generic-prev', handlePreviousClick);
      carouselRef.current.addEventListener('fwc-carousel-generic-animation-end', handleAnimationEnd);
      carouselElement = carouselRef.current;
    }
    return function () {
      if (carouselElement) {
        carouselElement.removeEventListener('fwc-carousel-generic-next', handleNextClick);
        carouselElement.removeEventListener('fwc-carousel-generic-prev', handlePreviousClick);
        carouselElement.removeEventListener('fwc-carousel-generic-animation-end', handleAnimationEnd);
      }
    };
  }, []);
  return jsx("fwc-carousel-generic", _extends$1({}, fwcCarouselProps, {
    config: JSON.stringify({
      assetsPath: assetsPath
    }),
    ref: mergeRefs(carouselRef, ref)
  }), React__default.Children.map(children, function (child) {
    var _child$type;
    if ((child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'Carousel.Item') {
      return child;
    }
    console.error("Warning Carousel has children that aren't Carousel.Item components");
    return null;
  }));
});
Carousel.displayName = 'Carousel';
Carousel.Item = CarouselItem;
Carousel.Item.displayName = 'Carousel.Item';
Carousel.propTypes = {
  /**
   * **Available Methods**
   * <br />
   * **ref.current.nextSlide()**: Public method for transitioning to the next set of carousel item(s).
   * <br />
   * **ref.current.prevSlide()**: Public method for transitioning to the previous set of carousel item(s).
   * <br />
   * **ref.current.slideToId()**: Public method for transitioning to the first set of carousel item (using ID).
   */
  ref: any,
  /**
   * Aria label for the Carousel
   */
  ariaLabel: string,
  /**
   * The aria label for the next button.
   */
  ariaLabelNextBtn: string,
  /**
   * The aria label for the previous button.
   */
  ariaLabelPrevBtn: string,
  /**
   * The data analytics for previous button.
   */
  dataAnalyticsPrevBtn: string,
  /**
   * The data analytics for next button.
   */
  dataAnalyticsNextBtn: string,
  children: node$2,
  /**
   * Fires an event when the next button is clicked.
   */
  onNextClick: func,
  /**
   * Fires an event when the next previous button is clicked.
   */
  onPreviousClick: func,
  /**
   * Fires when the carousel animation completes.
   */
  onAnimationEnd: func
};

var _excluded$b = ["className", "children"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$f() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref = process.env.NODE_ENV === "production" ? {
  name: "13tu3kl-ExpandHeader",
  styles: "width:100%;label:ExpandHeader;"
} : {
  name: "13tu3kl-ExpandHeader",
  styles: "width:100%;label:ExpandHeader;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
};
var ExpandHeader = function ExpandHeader(_ref2) {
  var className = _ref2.className,
    children = _ref2.children,
    props = _objectWithoutProperties$1(_ref2, _excluded$b);
  return jsx("div", _extends$1({}, props, {
    css: _ref,
    className: cx('expand-header', className),
    slot: "fwc-expand-title"
  }), children);
};
ExpandHeader.propTypes = {
  className: string,
  children: node$2
};
var ExpandContent = function ExpandContent(props) {
  return jsx("div", _extends$1({}, props, {
    className: cx('expand-content', props.className)
  }));
};
ExpandContent.propTypes = {
  className: string
};
var overrideStyles$3 = function overrideStyles(config) {
  var _config$noContentBlue = config.noContentBlueBG,
    noContentBlueBG = _config$noContentBlue === void 0 ? false : _config$noContentBlue,
    _config$secondary = config.secondary,
    secondary = _config$secondary === void 0 ? false : _config$secondary,
    borderTop = config.borderTop;
  return "\n    .fwc-expand-wrapper {\n      border-top: ".concat(borderTop ? '1px solid var(--color-gray-four)' : 'none', " !important;\n    }\n\n    .fwc-expand-wrapper {\n      border-top: ").concat(borderTop ? '1px solid var(--color-gray-four)' : 'none', "\n    }\n\n    .fwc-expand-wrapper .fwc-expand-header {\n      background: ").concat(secondary ? '#f7f7f7' : 'inherit', ";\n      padding: calc(4 * var(--fwcu)) calc(1.5 * var(--fwcu))\n        calc(4 * var(--fwcu)) calc(1.5 * var(--fwcu));\n    }\n\n    .fwc-expand-wrapper .fwc-expand-content {\n      padding: 0;\n      background-image: ").concat(noContentBlueBG ? 'inherit' : 'linear-gradient(to right, #58abdf 1%, #286ce2)', " ;\n    }\n\n    .fwc-expand-wrapper .fwc-expand-drawer {\n      padding: 32px;\n    }\n  ");
};
var Expand = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$borderTop = props.borderTop,
    borderTop = _props$borderTop === void 0 ? false : _props$borderTop,
    _props$secondary = props.secondary,
    secondary = _props$secondary === void 0 ? false : _props$secondary,
    _props$noContentBlueB = props.noContentBlueBG,
    noContentBlueBG = _props$noContentBlueB === void 0 ? false : _props$noContentBlueB,
    onExpanded = props.onExpanded,
    children = props.children;
  var expandRef = useRef();
  var expandCustomStyle = useRef(document.createElement('style'));
  var uiState = useSBUIState();
  var assetsPath = (uiState === null || uiState === void 0 ? void 0 : uiState.assetsPath) || './';
  var fwcExpandProps = getFwcProps$1(props, {
    id: 'id',
    title: 'label',
    expanded: 'expanded',
    borderBottom: 'last',
    ariaLabelExpandBtn: 'label-aria-expand-btn'
  });
  useEffect(function () {
    if (expandRef.current) {
      new FwcExpand(expandRef.current).build();
    }
  }, []);
  var handleOnExpanded = useCallback(function (e) {
    onExpanded === null || onExpanded === void 0 ? void 0 : onExpanded(e);
  }, [onExpanded]);
  useEffect(function () {
    var expandElement = null;
    if (expandRef.current) {
      expandRef.current.addEventListener('fwc-expand-expanded', handleOnExpanded);
      expandElement = expandRef.current;
    }
    return function () {
      if (expandElement) {
        expandElement.removeEventListener('fwc-expand-expanded', handleOnExpanded);
      }
    };
  }, [handleOnExpanded]);
  useEffect(function () {
    if (expandRef.current) {
      var expandShadowDOM = expandRef.current.shadowRoot;
      expandCustomStyle.current.innerHTML = overrideStyles$3({
        noContentBlueBG: noContentBlueBG,
        secondary: secondary,
        borderTop: borderTop
      });
      setTimeout(function () {
        expandShadowDOM.appendChild(expandCustomStyle.current);
      }, 0);
    }
  }, [noContentBlueBG, secondary, borderTop]);
  return jsx("fwc-expand", _extends$1({}, fwcExpandProps, {
    ref: mergeRefs(expandRef, ref),
    config: JSON.stringify({
      assetsPath: assetsPath
    })
  }), React__default.Children.map(children, function (child) {
    var _child$type, _child$type2;
    if ((child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'Expand.Header') {
      return child;
    }
    if ((child === null || child === void 0 ? void 0 : (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) === 'Expand.Content') {
      return child;
    }
    console.error("Warning Expand has children that aren't Expand.Header or Expand.Content components");
    return null;
  }));
});
Expand.displayName = 'Expand';
Expand.Header = ExpandHeader;
Expand.Header.displayName = 'Expand.Header';
Expand.Content = ExpandContent;
Expand.Content.displayName = 'Expand.Content';
Expand.propTypes = {
  id: string,
  ref: any,
  expanded: bool,
  borderTop: bool,
  bottomBoarder: bool,
  title: string,
  ariaLabelExpandBtn: string,
  children: node$2,
  secondary: bool,
  noContentBlueBG: bool,
  onExpanded: func
};

var StickyFooterLeft = function StickyFooterLeft(props) {
  return jsx("div", _extends$1({}, props, {
    className: cx('sticky-footer-left', props.className),
    slot: "fwc-footer-sticky-left"
  }));
};
StickyFooterLeft.propTypes = {
  className: string
};
var StickyFooterRight = function StickyFooterRight(props) {
  return jsx("div", _extends$1({}, props, {
    className: cx('sticky-footer-right', props.className),
    slot: "fwc-footer-sticky-right"
  }));
};
StickyFooterRight.propTypes = {
  className: string
};
var StickyFooter = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children;
  var stickyFooterRef = useRef();
  useEffect(function () {
    if (stickyFooterRef.current) {
      new FwcFooterSticky(stickyFooterRef.current).build();
    }
  }, []);
  return jsx("fwc-footer-sticky", {
    ref: mergeRefs(stickyFooterRef, ref)
  }, React__default.Children.map(children, function (child) {
    var _child$type, _child$type2;
    if ((child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'StickyFooter.Left') {
      return child;
    }
    if ((child === null || child === void 0 ? void 0 : (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) === 'StickyFooter.Right') {
      return child;
    }
    console.error("Warning StickyFooter has children that aren't StickyFooter.Left or StickyFooter.Right components");
    return null;
  }));
});
StickyFooter.displayName = 'StickyFooter';
StickyFooter.Left = StickyFooterLeft;
StickyFooter.Left.displayName = 'StickyFooter.Left';
StickyFooter.Right = StickyFooterRight;
StickyFooter.Right.displayName = 'StickyFooter.Right';
StickyFooter.propTypes = {
  children: node$2
};

var IconTextMedia = function IconTextMedia(props) {
  return jsx("div", _extends$1({}, props, {
    className: cx('icon-text-item-media', props.className),
    slot: "fwc-icon-text-image"
  }));
};
IconTextMedia.propTypes = {
  className: string
};
var IconTextContent = function IconTextContent(props) {
  return jsx("div", _extends$1({}, props, {
    className: cx('fwc-icon-text-container', props.className),
    slot: "fwc-icon-text-content"
  }));
};
IconTextContent.propTypes = {
  className: string
};
var IconTextItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _cx;
  var _ref$lg = _ref.lg,
    lg = _ref$lg === void 0 ? '4' : _ref$lg,
    md = _ref.md,
    sm = _ref.sm,
    _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? false : _ref$bottomMargin,
    className = _ref.className,
    children = _ref.children;
  var iconItemClass = cx("fwc-col-".concat(lg), (_cx = {}, _defineProperty$1(_cx, "md-".concat(md), !!md), _defineProperty$1(_cx, "sm-".concat(sm), !!sm), _defineProperty$1(_cx, 'fwc-col-bm', bottomMargin), _cx), className);
  return jsx("fwc-icon-text-item", {
    key: "1",
    "class": iconItemClass,
    ref: ref
  }, React__default.Children.map(children, function (child) {
    var _child$type, _child$type2;
    if ((child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'IconText.Media') {
      return child;
    }
    if ((child === null || child === void 0 ? void 0 : (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) === 'IconText.Content') {
      return child;
    }
    console.error("Warning IconText.Item has children that aren't IconText.Media or IconText.Content components");
    return null;
  }));
});
var columns = ['1', 1, '2', 2, '3', 3, '4', 4, '5', 5, '6', 6, '7', 7, '8', 8, '9', 9, '10', 10, '11', 11, '12', 12];
IconTextItem.displayName = 'IconText.Item';
IconTextItem.propTypes = {
  className: string,
  children: node$2,
  bottomMargin: bool,
  lg: oneOf(columns),
  md: oneOf(columns),
  sm: oneOf(columns)
};
var IconText = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    _ref2$alignItems = _ref2.alignItems,
    alignItems = _ref2$alignItems === void 0 ? 'start' : _ref2$alignItems,
    _ref2$justifyContent = _ref2.justifyContent,
    justifyContent = _ref2$justifyContent === void 0 ? 'start' : _ref2$justifyContent,
    _ref2$bottomMargin = _ref2.bottomMargin,
    bottomMargin = _ref2$bottomMargin === void 0 ? false : _ref2$bottomMargin,
    _ref2$wrap = _ref2.wrap,
    wrap = _ref2$wrap === void 0 ? false : _ref2$wrap,
    _ref2$animationStatus = _ref2.animationStatus,
    animationStatus = _ref2$animationStatus === void 0 ? 'start' : _ref2$animationStatus,
    children = _ref2.children;
  var iconTextRef = useRef();
  var iconTextClass = cx(_defineProperty$1({
    'fwc-row': true,
    'fwc-row-wrap': wrap,
    'fwc-row-bm': bottomMargin,
    'j-center': justifyContent === 'center',
    'j-end': justifyContent === 'end',
    'a-start': alignItems === 'start',
    'a-center': alignItems === 'center',
    'a-end': alignItems === 'end',
    'a-stretch': alignItems === 'stretch'
  }, className, className));
  useEffect(function () {
    if (iconTextRef.current) {
      new FwcIconText(iconTextRef.current).build();
    }
  }, []);
  return jsx("fwc-icon-text", {
    ref: mergeRefs(iconTextRef, ref),
    "class": iconTextClass,
    "trigger-animate": animationStatus
  }, React__default.Children.map(children, function (child) {
    var _child$type3;
    if ((child === null || child === void 0 ? void 0 : (_child$type3 = child.type) === null || _child$type3 === void 0 ? void 0 : _child$type3.displayName) === 'IconText.Item') {
      return child;
    }
    console.error("Warning IconText has children that aren't IconText.Item components");
    return null;
  }));
});
IconText.displayName = 'IconText';
IconText.propTypes = {
  animationStatus: oneOf(['start', 'hold']),
  wrap: bool,
  bottomMargin: bool,
  alignItems: oneOf(['start', 'center', 'end', 'stretch']),
  justifyContent: oneOf(['start', 'center', 'end']),
  className: string,
  children: node$2
};

// Child Item
IconText.Item = IconTextItem;
IconText.Item.displayName = 'IconText.Item';
IconText.Media = IconTextMedia;
IconText.Media.displayName = 'IconText.Media';
IconText.Content = IconTextContent;
IconText.Content.displayName = 'IconText.Content';

var isArray$1 = isArray_1,
    isSymbol = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$1(value, object) {
  if (isArray$1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey$1;

var isArray = isArray_1,
    isKey = _isKey,
    stringToPath = _stringToPath,
    toString = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$1(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

var _castPath = castPath$1;

var castPath = _castPath,
    toKey = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$1(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet$1;

var baseGet = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get;

var _excluded$a = ["children"],
  _excluded2$2 = ["contentValue", "children"],
  _excluded3$1 = ["labelDisplayName", "contentDisplayName", "data", "label", "path", "value", "children", "direction"];
var DetailsFieldLabel = function DetailsFieldLabel(props) {
  var children = props.children,
    rest = _objectWithoutProperties$1(props, _excluded$a);
  return jsx("div", _extends$1({}, rest, {
    className: "details-field-label"
  }), children);
};
DetailsFieldLabel.propTypes = {
  children: node$2
};
var DetailsFieldContent = function DetailsFieldContent(props) {
  var contentValue = props.contentValue,
    children = props.children,
    rest = _objectWithoutProperties$1(props, _excluded2$2);
  return jsx("div", _extends$1({}, rest, {
    className: "details-field-content"
  }), typeof children === 'function' ? children(contentValue) : children);
};
DetailsFieldContent.propTypes = {
  contentValue: node$2,
  children: node$2
};
var cssDetailsField = function cssDetailsField(config) {
  var direction = config.direction;
  var isRow = ['row', 'row-together', 'row-corners'].includes(direction);
  var isTogether = direction === 'row-together';
  var isCorners = direction === 'row-corners';
  return /*#__PURE__*/css("display:flex;flex-flow:", isRow ? 'row' : 'column', " nowrap;.details-field-label{line-height:1.83;font-size:", isRow ? 14 : 12, "px;font-weight:bold;color:var(--color-gray-one);margin-bottom:2px;flex:", isRow ? 1 : 'inherit', ";text-align:", isTogether ? 'right' : 'left', ";margin-right:", isTogether ? '5px' : '0px', ";}.details-field-content{margin-top:2px;font-size:16px;letter-spacing:normal;color:var(--color-gray-one);flex:", isRow ? 1 : 'inherit', ";text-align:left;text-align:", isCorners ? 'right' : 'left', ";margin-left:", isTogether ? '5px' : '0px', ";};label:cssDetailsField;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};
var DetailsField = function DetailsField(props) {
  var _props$labelDisplayNa = props.labelDisplayName,
    labelDisplayName = _props$labelDisplayNa === void 0 ? 'DetailsField.Label' : _props$labelDisplayNa,
    _props$contentDisplay = props.contentDisplayName,
    contentDisplayName = _props$contentDisplay === void 0 ? 'DetailsField.Content' : _props$contentDisplay,
    _props$data = props.data,
    data = _props$data === void 0 ? {} : _props$data,
    label = props.label,
    path = props.path,
    value = props.value,
    children = props.children,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'column' : _props$direction,
    restProps = _objectWithoutProperties$1(props, _excluded3$1);
  var contentValue = useMemo(function () {
    var val = path ? get_1(data, path, value) : value;
    return [null, undefined, ''].includes(val) ? '—' : val;
  }, [path, data, value]);
  var isLabelExists = useMemo(function () {
    return toArray(children).some(function (node) {
      var _node$type;
      return (node === null || node === void 0 ? void 0 : (_node$type = node.type) === null || _node$type === void 0 ? void 0 : _node$type.displayName) === labelDisplayName;
    });
  }, [children, labelDisplayName]);
  var isContentExists = useMemo(function () {
    return toArray(children).some(function (node) {
      var _node$type2;
      return (node === null || node === void 0 ? void 0 : (_node$type2 = node.type) === null || _node$type2 === void 0 ? void 0 : _node$type2.displayName) === contentDisplayName;
    });
  }, [children, contentDisplayName]);
  var isHavingChildren = useMemo(function () {
    if (typeof children === 'function') {
      return true;
    }
    return Children.count(children) > 0;
  }, [children]);
  return jsx("div", _extends$1({}, restProps, {
    css: cssDetailsField({
      direction: direction
    }),
    className: "details-field"
  }), !isLabelExists && jsx(DetailsFieldLabel, null, label), !isHavingChildren && jsx(DetailsFieldContent, null, contentValue), toArray(children).map(function (child) {
    var _child$type, _child$type2;
    if ((child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === labelDisplayName) {
      return child;
    }
    if ((child === null || child === void 0 ? void 0 : (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) === contentDisplayName) {
      return child;
    }
    return null;
  }), typeof children === 'function' ? jsx(DetailsFieldContent, null, children(contentValue)) : Children.count(children) === 0 || isLabelExists || isContentExists ? null : jsx(DetailsFieldContent, null, children));
};
DetailsField.propTypes = {
  data: shape({}),
  label: node$2,
  value: node$2,
  path: string,
  direction: oneOf(['column', 'row', 'row-together', 'row-corners']),
  labelDisplayName: string,
  contentDisplayName: string,
  children: node$2
};
DetailsField.Label = DetailsFieldLabel;
DetailsField.Label.displayName = 'DetailsField.Label';
DetailsField.Content = DetailsFieldContent;
DetailsField.Content.displayName = 'DetailsField.Content';

var DetailsContext = /*#__PURE__*/createContext();
function useDetailsState() {
  var context = useContext(DetailsContext);
  return context || {};
}
function DetailsProvider(props) {
  var _props$data = props.data,
    data = _props$data === void 0 ? {} : _props$data,
    children = props.children;
  return jsx(DetailsContext.Provider, {
    value: {
      data: data
    }
  }, children);
}
DetailsProvider.propTypes = {
  data: shape({}),
  children: node$2
};

var _excluded$9 = ["data", "gridGap", "minCellWidth"];
var DetailsGridFieldLabel = function DetailsGridFieldLabel(props) {
  return jsx(DetailsFieldLabel, props);
};
var DetailsGridFieldContent = function DetailsGridFieldContent(props) {
  return jsx(DetailsFieldContent, props);
};
var DetailsGridField = function DetailsGridField(props) {
  var _useDetailsState = useDetailsState(),
    _useDetailsState$data = _useDetailsState.data,
    data = _useDetailsState$data === void 0 ? {} : _useDetailsState$data;
  return jsx(DetailsField, _extends$1({}, props, {
    data: data,
    labelDisplayName: "DetailsGrid.FieldLabel",
    contentDisplayName: "DetailsGrid.FieldContent"
  }));
};
var cssGridContainer$1 = function cssGridContainer(minCellWidth, gridGap) {
  return /*#__PURE__*/css("display:grid;grid-gap:", gridGap || 24, "px;grid-template-columns:repeat(auto-fit, minmax(", minCellWidth, "px, 1fr));;label:cssGridContainer;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};
var DetailsGrid = function DetailsGrid(props) {
  var _props$data = props.data,
    data = _props$data === void 0 ? {} : _props$data,
    _props$gridGap = props.gridGap,
    gridGap = _props$gridGap === void 0 ? 24 : _props$gridGap,
    _props$minCellWidth = props.minCellWidth,
    minCellWidth = _props$minCellWidth === void 0 ? 140 : _props$minCellWidth,
    restProps = _objectWithoutProperties$1(props, _excluded$9);
  return jsx(DetailsProvider, {
    data: data
  }, jsx("div", _extends$1({}, restProps, {
    className: "details-grid-container",
    css: cssGridContainer$1(minCellWidth, gridGap)
  })));
};
DetailsGrid.propTypes = {
  minCellWidth: number$4,
  data: shape({}),
  gridGap: number$4
};
DetailsGrid.Field = DetailsGridField;
DetailsGrid.Field.displayName = 'DetailsGrid.Field';
DetailsGrid.FieldLabel = DetailsGridFieldLabel;
DetailsGrid.FieldLabel.displayName = 'DetailsGrid.FieldLabel';
DetailsGrid.FieldContent = DetailsGridFieldContent;
DetailsGrid.FieldContent.displayName = 'DetailsGrid.FieldContent';

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked, or until the next browser frame is drawn. The debounced function
 * comes with a `cancel` method to cancel delayed `func` invocations and a
 * `flush` method to immediately invoke them. Provide `options` to indicate
 * whether `func` should be invoked on the leading and/or trailing edge of the
 * `wait` timeout. The `func` is invoked with the last arguments provided to the
 * debounced function. Subsequent calls to the debounced function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * If `wait` is omitted in an environment with `requestAnimationFrame`, `func`
 * invocation will be deferred until the next frame is drawn (typically about
 * 16ms).
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `debounce` and `throttle`.
 *
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0]
 *  The number of milliseconds to delay; if omitted, `requestAnimationFrame` is
 *  used (if available, otherwise it will be setTimeout(...,0)).
 * @param {Object} [options={}] The options object.
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.leading=false]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {number} [options.maxWait]
 *  Specify invoking on the trailing edge of the timeout.
 * @param {boolean} [options.trailing=true]
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * const resizeHandler = useDebouncedCallback(calculateLayout, 150);
 * window.addEventListener('resize', resizeHandler)
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * const clickHandler = useDebouncedCallback(sendMail, 300, {
 *   leading: true,
 *   trailing: false,
 * })
 * <button onClick={clickHandler}>click me</button>
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * const debounced = useDebouncedCallback(batchLog, 250, { 'maxWait': 1000 })
 * const source = new EventSource('/stream')
 * source.addEventListener('message', debounced)
 *
 * // Cancel the trailing debounced invocation.
 * window.addEventListener('popstate', debounced.cancel)
 *
 * // Check for pending invocations.
 * const status = debounced.pending() ? "Pending..." : "Ready"
 */
function useDebouncedCallback(func, wait, options) {
  var _this = this;
  var lastCallTime = useRef(null);
  var lastInvokeTime = useRef(0);
  var timerId = useRef(null);
  var lastArgs = useRef([]);
  var lastThis = useRef();
  var result = useRef();
  var funcRef = useRef(func);
  var mounted = useRef(true);
  funcRef.current = func;
  // Bypass `requestAnimationFrame` by explicitly setting `wait=0`.
  var useRAF = !wait && wait !== 0 && typeof window !== 'undefined';
  if (typeof func !== 'function') {
    throw new TypeError('Expected a function');
  }
  wait = +wait || 0;
  options = options || {};
  var leading = !!options.leading;
  var trailing = 'trailing' in options ? !!options.trailing : true; // `true` by default
  var maxing = ('maxWait' in options);
  var maxWait = maxing ? Math.max(+options.maxWait || 0, wait) : null;
  useEffect(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []);
  // You may have a question, why we have so many code under the useMemo definition.
  //
  // This was made as we want to escape from useCallback hell and
  // not to initialize a number of functions each time useDebouncedCallback is called.
  //
  // It means that we have less garbage for our GC calls which improves performance.
  // Also, it makes this library smaller.
  //
  // And the last reason, that the code without lots of useCallback with deps is easier to read.
  // You have only one place for that.
  var debounced = useMemo(function () {
    var invokeFunc = function invokeFunc(time) {
      var args = lastArgs.current;
      var thisArg = lastThis.current;
      lastArgs.current = lastThis.current = null;
      lastInvokeTime.current = time;
      return result.current = funcRef.current.apply(thisArg, args);
    };
    var startTimer = function startTimer(pendingFunc, wait) {
      if (useRAF) cancelAnimationFrame(timerId.current);
      timerId.current = useRAF ? requestAnimationFrame(pendingFunc) : setTimeout(pendingFunc, wait);
    };
    var shouldInvoke = function shouldInvoke(time) {
      if (!mounted.current) return false;
      var timeSinceLastCall = time - lastCallTime.current;
      var timeSinceLastInvoke = time - lastInvokeTime.current;
      // Either this is the first call, activity has stopped and we're at the
      // trailing edge, the system time has gone backwards and we're treating
      // it as the trailing edge, or we've hit the `maxWait` limit.
      return !lastCallTime.current || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    };
    var trailingEdge = function trailingEdge(time) {
      timerId.current = null;
      // Only invoke if we have `lastArgs` which means `func` has been
      // debounced at least once.
      if (trailing && lastArgs.current) {
        return invokeFunc(time);
      }
      lastArgs.current = lastThis.current = null;
      return result.current;
    };
    var timerExpired = function timerExpired() {
      var time = Date.now();
      if (shouldInvoke(time)) {
        return trailingEdge(time);
      }
      // https://github.com/xnimorz/use-debounce/issues/97
      if (!mounted.current) {
        return;
      }
      // Remaining wait calculation
      var timeSinceLastCall = time - lastCallTime.current;
      var timeSinceLastInvoke = time - lastInvokeTime.current;
      var timeWaiting = wait - timeSinceLastCall;
      var remainingWait = maxing ? Math.min(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
      // Restart the timer
      startTimer(timerExpired, remainingWait);
    };
    var func = function func() {
      var time = Date.now();
      var isInvoking = shouldInvoke(time);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      lastArgs.current = args;
      lastThis.current = _this;
      lastCallTime.current = time;
      if (isInvoking) {
        if (!timerId.current && mounted.current) {
          // Reset any `maxWait` timer.
          lastInvokeTime.current = lastCallTime.current;
          // Start the timer for the trailing edge.
          startTimer(timerExpired, wait);
          // Invoke the leading edge.
          return leading ? invokeFunc(lastCallTime.current) : result.current;
        }
        if (maxing) {
          // Handle invocations in a tight loop.
          startTimer(timerExpired, wait);
          return invokeFunc(lastCallTime.current);
        }
      }
      if (!timerId.current) {
        startTimer(timerExpired, wait);
      }
      return result.current;
    };
    func.cancel = function () {
      if (timerId.current) {
        useRAF ? cancelAnimationFrame(timerId.current) : clearTimeout(timerId.current);
      }
      lastInvokeTime.current = 0;
      lastArgs.current = lastCallTime.current = lastThis.current = timerId.current = null;
    };
    func.isPending = function () {
      return !!timerId.current;
    };
    func.flush = function () {
      return !timerId.current ? result.current : trailingEdge(Date.now());
    };
    return func;
  }, [leading, maxing, wait, maxWait, trailing, useRAF]);
  return debounced;
}

function valueEquality(left, right) {
  return left === right;
}
function adjustFunctionValueOfSetState(value) {
  return typeof value === 'function' ? function () {
    return value;
  } : value;
}
function useStateIgnoreCallback(initialState) {
  var _useState = useState(adjustFunctionValueOfSetState(initialState)),
    _useState2 = _slicedToArray$1(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var setStateIgnoreCallback = useCallback(function (value) {
    return setState(adjustFunctionValueOfSetState(value));
  }, []);
  return [state, setStateIgnoreCallback];
}
function useDebounce(value, delay, options) {
  var eq = options && options.equalityFn || valueEquality;
  var _useStateIgnoreCallba = useStateIgnoreCallback(value),
    _useStateIgnoreCallba2 = _slicedToArray$1(_useStateIgnoreCallba, 2),
    state = _useStateIgnoreCallba2[0],
    dispatch = _useStateIgnoreCallba2[1];
  var debounced = useDebouncedCallback(useCallback(function (value) {
    return dispatch(value);
  }, [dispatch]), delay, options);
  var previousValue = useRef(value);
  if (!eq(previousValue.current, value)) {
    debounced(value);
    previousValue.current = value;
  }
  return [state, debounced];
}

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var BREAKPOINTS = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400
};
var getDeviceModes = function getDeviceModes(breakpoints, width) {
  return {
    isSmallMobileMode: width < breakpoints.sm,
    isMobileMode: width >= breakpoints.sm && width < breakpoints.md,
    isTabletMode: width >= breakpoints.md && width < breakpoints.lg,
    isDesktopMode: width >= breakpoints.lg && width < breakpoints.xl,
    isLargeDesktopMode: width >= breakpoints.xl && width < breakpoints.xxl,
    isXLargeDesktopMode: width > breakpoints.xxl
  };
};
var useWindowSize = function useWindowSize() {
  var breakpoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var _useState = useState({
      width: window.innerWidth,
      height: window.innerHeight
    }),
    _useState2 = _slicedToArray$1(_useState, 2),
    windowSize = _useState2[0],
    setWindowSize = _useState2[1];
  var _breakpoints = useMemo(function () {
    return _objectSpread$5(_objectSpread$5({}, BREAKPOINTS), breakpoints || {});
  }, [breakpoints]);
  var _useDebounce = useDebounce(windowSize, debounce),
    _useDebounce2 = _slicedToArray$1(_useDebounce, 1),
    debounceWindowSize = _useDebounce2[0];
  var resizeHandler = useCallback(function () {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }, []);
  useEffect(function () {
    window.addEventListener('resize', resizeHandler);
    return function () {
      window.removeEventListener('resize', resizeHandler);
    };
  }, [resizeHandler]);
  return useMemo(function () {
    return _objectSpread$5(_objectSpread$5({}, debounceWindowSize), getDeviceModes(_breakpoints, debounceWindowSize.width));
  }, [_breakpoints, debounceWindowSize]);
};

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function on(obj) {
  if (obj && obj.addEventListener) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    obj.addEventListener.apply(obj, args);
  }
}
function off(obj) {
  if (obj && obj.removeEventListener) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    obj.removeEventListener.apply(obj, args);
  }
}
var defaultEvents = ['mousedown', 'touchstart'];
var useClickAway = function useClickAway(ref, onClickAway) {
  var events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultEvents;
  var savedCallback = useRef(onClickAway);
  useEffect(function () {
    savedCallback.current = onClickAway;
  }, [onClickAway]);
  useEffect(function () {
    var handler = function handler(event) {
      var el = ref.current;
      el && !el.contains(event.target) && savedCallback.current(event);
    };
    var _iterator = _createForOfIteratorHelper(events),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var eventName = _step.value;
        on(document, eventName, handler);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return function () {
      var _iterator2 = _createForOfIteratorHelper(events),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var eventName = _step2.value;
          off(document, eventName, handler);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    };
  }, [events, ref]);
};

var _excluded$8 = ["hideCompareGridAt", "children"];
var transposeChildren = function transposeChildren(children) {
  var _parentNodes$, _parentNodes$$props;
  var resultNodes = [];
  var parentNodes = toArray(children);
  var firstChildChildrenCount = Children.count((_parentNodes$ = parentNodes[0]) === null || _parentNodes$ === void 0 ? void 0 : (_parentNodes$$props = _parentNodes$.props) === null || _parentNodes$$props === void 0 ? void 0 : _parentNodes$$props.children);
  var _loop = function _loop(nodeIdx) {
    var res = [];
    parentNodes.forEach(function (parentChild) {
      var childNodes = toArray(parentChild.props.children);
      if (childNodes[nodeIdx]) res.push(childNodes[nodeIdx]);
    });
    resultNodes.push(res);
  };
  for (var nodeIdx = 0; nodeIdx < firstChildChildrenCount; nodeIdx++) {
    _loop(nodeIdx);
  }
  return resultNodes;
};
var CompareGridItem = function CompareGridItem(props) {
  var _props$fullWidth = props.fullWidth,
    fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
    _props$hideAtCompare = props.hideAtCompare,
    hideAtCompare = _props$hideAtCompare === void 0 ? false : _props$hideAtCompare;
  return jsx("div", _extends$1({}, props, {
    className: cx('compare-grid-item', props.className, {
      full: fullWidth,
      hide: hideAtCompare
    })
  }));
};
CompareGridItem.propTypes = {
  className: string,
  fullWidth: bool,
  hideAtCompare: bool
};
var CompareGridSection = function CompareGridSection(props) {
  return jsx("div", _extends$1({}, props, {
    className: cx('compare-grid-section', props.className)
  }));
};
CompareGridSection.propTypes = {
  className: string
};
var cssGridContainer = function cssGridContainer(count) {
  return /*#__PURE__*/css("display:grid;grid-template-columns:repeat(", count, ", 1fr);.compare-grid-item.full{grid-column:1/span ", count, ";}.compare-grid-item.hide{display:none;};label:cssGridContainer;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbXBhcmVHcmlkLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTBEcUMiLCJmaWxlIjoiQ29tcGFyZUdyaWQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHtcbiAgQ2hpbGRyZW4sXG4gIHVzZU1lbW8sXG4gIHVzZVN0YXRlLFxuICB1c2VSZWYsXG4gIHVzZUVmZmVjdCxcbiAgdXNlQ2FsbGJhY2ssXG59IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCBjeCBmcm9tICdjbGFzc25hbWVzJztcbmltcG9ydCB7IHRvQXJyYXkgfSBmcm9tICcuLi91dGlscyc7XG5pbXBvcnQgeyBib29sLCBub2RlLCBudW1iZXIsIHN0cmluZyB9IGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IHsgdXNlRGVib3VuY2VkQ2FsbGJhY2sgfSBmcm9tICcuLi9Ib29rcyc7XG5cbmNvbnN0IHRyYW5zcG9zZUNoaWxkcmVuID0gY2hpbGRyZW4gPT4ge1xuICBjb25zdCByZXN1bHROb2RlcyA9IFtdO1xuICBjb25zdCBwYXJlbnROb2RlcyA9IHRvQXJyYXkoY2hpbGRyZW4pO1xuICBjb25zdCBmaXJzdENoaWxkQ2hpbGRyZW5Db3VudCA9IENoaWxkcmVuLmNvdW50KFxuICAgIHBhcmVudE5vZGVzWzBdPy5wcm9wcz8uY2hpbGRyZW4sXG4gICk7XG4gIGZvciAobGV0IG5vZGVJZHggPSAwOyBub2RlSWR4IDwgZmlyc3RDaGlsZENoaWxkcmVuQ291bnQ7IG5vZGVJZHgrKykge1xuICAgIGxldCByZXMgPSBbXTtcbiAgICBwYXJlbnROb2Rlcy5mb3JFYWNoKHBhcmVudENoaWxkID0+IHtcbiAgICAgIGNvbnN0IGNoaWxkTm9kZXMgPSB0b0FycmF5KHBhcmVudENoaWxkLnByb3BzLmNoaWxkcmVuKTtcbiAgICAgIGlmIChjaGlsZE5vZGVzW25vZGVJZHhdKSByZXMucHVzaChjaGlsZE5vZGVzW25vZGVJZHhdKTtcbiAgICB9KTtcbiAgICByZXN1bHROb2Rlcy5wdXNoKHJlcyk7XG4gIH1cbiAgcmV0dXJuIHJlc3VsdE5vZGVzO1xufTtcblxuZXhwb3J0IGNvbnN0IENvbXBhcmVHcmlkSXRlbSA9IHByb3BzID0+IHtcbiAgY29uc3QgeyBmdWxsV2lkdGggPSBmYWxzZSwgaGlkZUF0Q29tcGFyZSA9IGZhbHNlIH0gPSBwcm9wcztcbiAgcmV0dXJuIChcbiAgICA8ZGl2XG4gICAgICB7Li4ucHJvcHN9XG4gICAgICBjbGFzc05hbWU9e2N4KCdjb21wYXJlLWdyaWQtaXRlbScsIHByb3BzLmNsYXNzTmFtZSwge1xuICAgICAgICBmdWxsOiBmdWxsV2lkdGgsXG4gICAgICAgIGhpZGU6IGhpZGVBdENvbXBhcmUsXG4gICAgICB9KX1cbiAgICAvPlxuICApO1xufTtcblxuQ29tcGFyZUdyaWRJdGVtLnByb3BUeXBlcyA9IHtcbiAgY2xhc3NOYW1lOiBzdHJpbmcsXG4gIGZ1bGxXaWR0aDogYm9vbCxcbiAgaGlkZUF0Q29tcGFyZTogYm9vbCxcbn07XG5cbmV4cG9ydCBjb25zdCBDb21wYXJlR3JpZFNlY3Rpb24gPSBwcm9wcyA9PiAoXG4gIDxkaXYgey4uLnByb3BzfSBjbGFzc05hbWU9e2N4KCdjb21wYXJlLWdyaWQtc2VjdGlvbicsIHByb3BzLmNsYXNzTmFtZSl9IC8+XG4pO1xuXG5Db21wYXJlR3JpZFNlY3Rpb24ucHJvcFR5cGVzID0ge1xuICBjbGFzc05hbWU6IHN0cmluZyxcbn07XG5cbmNvbnN0IGNzc0dyaWRDb250YWluZXIgPSBjb3VudCA9PiBjc3NgXG4gIGRpc3BsYXk6IGdyaWQ7XG4gIGdyaWQtdGVtcGxhdGUtY29sdW1uczogcmVwZWF0KCR7Y291bnR9LCAxZnIpO1xuXG4gIC5jb21wYXJlLWdyaWQtaXRlbS5mdWxsIHtcbiAgICBncmlkLWNvbHVtbjogMSAvIHNwYW4gJHtjb3VudH07XG4gIH1cblxuICAuY29tcGFyZS1ncmlkLWl0ZW0uaGlkZSB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxuYDtcblxuZXhwb3J0IGNvbnN0IENvbXBhcmVHcmlkID0gcHJvcHMgPT4ge1xuICBjb25zdCB7IGhpZGVDb21wYXJlR3JpZEF0ID0gNjAwLCBjaGlsZHJlbiwgLi4ucmVzdFByb3BzIH0gPSBwcm9wcztcbiAgY29uc3QgY29udGFpbmVyUmVmID0gdXNlUmVmKCk7XG4gIGNvbnN0IFtkaW1lbnNpb25zLCBzZXREaW1lbnNpb25zXSA9IHVzZVN0YXRlKHsgd2lkdGg6IDEyMDAgfSk7XG4gIGNvbnN0IGRlYm91bmNlZFNldERpbWVuc2lvbnMgPSB1c2VEZWJvdW5jZWRDYWxsYmFjayhcbiAgICB3aWR0aCA9PiBzZXREaW1lbnNpb25zKHsgd2lkdGggfSksXG4gICAgNTAwLFxuICApO1xuXG4gIGNvbnN0IGNvdW50ID0gdXNlTWVtbygoKSA9PiBDaGlsZHJlbi5jb3VudChjaGlsZHJlbiksIFtjaGlsZHJlbl0pO1xuXG4gIGNvbnN0IHNob3dDb21wYXJlR3JpZCA9IHVzZU1lbW8oXG4gICAgKCkgPT4gZGltZW5zaW9ucy53aWR0aCA+IGhpZGVDb21wYXJlR3JpZEF0LFxuICAgIFtkaW1lbnNpb25zLndpZHRoLCBoaWRlQ29tcGFyZUdyaWRBdF0sXG4gICk7XG5cbiAgY29uc3QgcmVzaXplSGFuZGxlciA9IHVzZUNhbGxiYWNrKCgpID0+IHtcbiAgICBkZWJvdW5jZWRTZXREaW1lbnNpb25zKFxuICAgICAgY29udGFpbmVyUmVmPy5jdXJyZW50Py5vZmZzZXRXaWR0aCB8fCBkaW1lbnNpb25zLndpZHRoLFxuICAgICk7XG4gIH0sIFtkZWJvdW5jZWRTZXREaW1lbnNpb25zLCBkaW1lbnNpb25zLndpZHRoXSk7XG5cbiAgdXNlRWZmZWN0KCgpID0+IHtcbiAgICB3aW5kb3cuYWRkRXZlbnRMaXN0ZW5lcigncmVzaXplJywgcmVzaXplSGFuZGxlcik7XG4gICAgcmV0dXJuICgpID0+IHtcbiAgICAgIHdpbmRvdy5yZW1vdmVFdmVudExpc3RlbmVyKCdyZXNpemUnLCByZXNpemVIYW5kbGVyKTtcbiAgICB9O1xuICB9LCBbcmVzaXplSGFuZGxlcl0pO1xuXG4gIHVzZUVmZmVjdCgoKSA9PiB7XG4gICAgLy8gSWYgcGFyZW50IGRpdiBpcyBoaWRkZW4sIHRoZW4gd2lkdGggaXMgY29taW5nIGFzICcwJ1xuICAgIC8vIEluIHRoYXQgY2FzZSB1c2UgcHJldmlvdXMvZGVmYXVsdCB3aWR0aCBpbiB0aGUgc3RhdGUuXG4gICAgc2V0RGltZW5zaW9ucyhvbGQgPT4gKHtcbiAgICAgIHdpZHRoOiBjb250YWluZXJSZWY/LmN1cnJlbnQ/Lm9mZnNldFdpZHRoIHx8IG9sZC53aWR0aCxcbiAgICB9KSk7XG4gIH0sIFtdKTtcblxuICByZXR1cm4gKFxuICAgIDxkaXZcbiAgICAgIHsuLi5yZXN0UHJvcHN9XG4gICAgICBjc3M9e3Nob3dDb21wYXJlR3JpZCA/IGNzc0dyaWRDb250YWluZXIoY291bnQpIDogbnVsbH1cbiAgICAgIHJlZj17Y29udGFpbmVyUmVmfVxuICAgID5cbiAgICAgIHtzaG93Q29tcGFyZUdyaWQgPyB0cmFuc3Bvc2VDaGlsZHJlbihjaGlsZHJlbikgOiBjaGlsZHJlbn1cbiAgICA8L2Rpdj5cbiAgKTtcbn07XG5cbkNvbXBhcmVHcmlkLlNlY3Rpb24gPSBDb21wYXJlR3JpZFNlY3Rpb247XG5Db21wYXJlR3JpZC5TZWN0aW9uLmRpc3BsYXlOYW1lID0gJ0NvbXBhcmVHcmlkLlNlY3Rpb24nO1xuXG5Db21wYXJlR3JpZC5JdGVtID0gQ29tcGFyZUdyaWRJdGVtO1xuQ29tcGFyZUdyaWQuSXRlbS5kaXNwbGF5TmFtZSA9ICdDb21wYXJlR3JpZC5JdGVtJztcblxuQ29tcGFyZUdyaWQucHJvcFR5cGVzID0ge1xuICBjaGlsZHJlbjogbm9kZSxcbiAgaGlkZUNvbXBhcmVHcmlkQXQ6IG51bWJlcixcbn07XG4iXX0= */"));
};
var CompareGrid = function CompareGrid(props) {
  var _props$hideCompareGri = props.hideCompareGridAt,
    hideCompareGridAt = _props$hideCompareGri === void 0 ? 600 : _props$hideCompareGri,
    children = props.children,
    restProps = _objectWithoutProperties$1(props, _excluded$8);
  var containerRef = useRef();
  var _useState = useState({
      width: 1200
    }),
    _useState2 = _slicedToArray$1(_useState, 2),
    dimensions = _useState2[0],
    setDimensions = _useState2[1];
  var debouncedSetDimensions = useDebouncedCallback(function (width) {
    return setDimensions({
      width: width
    });
  }, 500);
  var count = useMemo(function () {
    return Children.count(children);
  }, [children]);
  var showCompareGrid = useMemo(function () {
    return dimensions.width > hideCompareGridAt;
  }, [dimensions.width, hideCompareGridAt]);
  var resizeHandler = useCallback(function () {
    var _containerRef$current;
    debouncedSetDimensions((containerRef === null || containerRef === void 0 ? void 0 : (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetWidth) || dimensions.width);
  }, [debouncedSetDimensions, dimensions.width]);
  useEffect(function () {
    window.addEventListener('resize', resizeHandler);
    return function () {
      window.removeEventListener('resize', resizeHandler);
    };
  }, [resizeHandler]);
  useEffect(function () {
    // If parent div is hidden, then width is coming as '0'
    // In that case use previous/default width in the state.
    setDimensions(function (old) {
      var _containerRef$current2;
      return {
        width: (containerRef === null || containerRef === void 0 ? void 0 : (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.offsetWidth) || old.width
      };
    });
  }, []);
  return jsx("div", _extends$1({}, restProps, {
    css: showCompareGrid ? cssGridContainer(count) : null,
    ref: containerRef
  }), showCompareGrid ? transposeChildren(children) : children);
};
CompareGrid.Section = CompareGridSection;
CompareGrid.Section.displayName = 'CompareGrid.Section';
CompareGrid.Item = CompareGridItem;
CompareGrid.Item.displayName = 'CompareGrid.Item';
CompareGrid.propTypes = {
  children: node$2,
  hideCompareGridAt: number$4
};

var LinearProgress = /*#__PURE__*/forwardRef(function (props, ref) {
  var progressLinearRef = useRef();
  var uiState = useSBUIState();
  var assetsPath = (uiState === null || uiState === void 0 ? void 0 : uiState.assetsPath) || './';
  var _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data;
  var fwcProps = getFwcProps$1(props, {
    nonLinear: 'non-linear',
    minimal: 'minimal'
  });
  useEffect(function () {
    if (progressLinearRef.current) {
      new FwcProgressLinear(progressLinearRef.current).build();
    }
  }, []);
  return jsx("fwc-progress-linear", _extends$1({}, fwcProps, {
    config: JSON.stringify({
      assetsPath: assetsPath
    }),
    ref: mergeRefs(progressLinearRef, ref),
    data: JSON.stringify(data)
  }));
});
LinearProgress.displayName = 'LinearProgress';
LinearProgress.propTypes = {
  id: string,
  className: string,
  data: arrayOf(shape({
    title: string,
    date: string,
    body: string,
    state: oneOf(['next', 'incomplete', 'complete']),
    /**
     * The text for the badge on the far right.
     */
    badge: shape({
      label: string,
      color: oneOf(['success', 'info', 'warning', 'urgent', 'gray', 'white'])
    })
  })),
  nonLinear: bool,
  minimal: bool
};

var _excluded$7 = ["data", "xAxisLabelKey", "barDataKeys"];
var BarChart = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    xAxisLabelKey = props.xAxisLabelKey,
    _props$barDataKeys = props.barDataKeys,
    barDataKeys = _props$barDataKeys === void 0 ? [] : _props$barDataKeys,
    restProps = _objectWithoutProperties$1(props, _excluded$7);
  var barChartRef = useRef();
  var chartData = useMemo(function () {
    var result = {
      graphData: [],
      xAxisLabels: []
    };
    data === null || data === void 0 ? void 0 : data.forEach(function (record) {
      var compareRecord = {};
      barDataKeys === null || barDataKeys === void 0 ? void 0 : barDataKeys.forEach(function (item) {
        var labelKey = item.label || item.dataKey;
        compareRecord[labelKey] = record[item.dataKey];
      });
      result.graphData.push(compareRecord);
      result.xAxisLabels.push(record[xAxisLabelKey]);
    });
    return result;
  }, [data, barDataKeys, xAxisLabelKey]);
  useEffect(function () {
    if (barChartRef.current) {
      new FwcChartBarCompare(barChartRef.current).build();
    }
  }, []);
  return jsx("fwc-chart-bar-compare", _extends$1({}, restProps, {
    data: JSON.stringify(chartData),
    ref: mergeRefs(barChartRef, ref),
    "show-chart": true
  }));
});
BarChart.displayName = 'BarChart';
BarChart.propTypes = {
  /**
   * Data source array
   */
  data: array$2.isRequired,
  /**
   * Key from data array that should be used for xAxis
   */
  xAxisLabelKey: string.isRequired,
  /**
   * Key from data array that should be used for picking graph bar size and custom label to show in chart
   */
  barDataKeys: arrayOf(shape({
    label: string,
    dataKey: string.isRequired
  }).isRequired).isRequired,
  ref: any
};

/**
 * Check if the provided file type should be accepted by the input with accept attribute.
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Input#attr-accept
 *
 * Inspired by https://github.com/enyo/dropzone
 *
 * @param file {File} https://developer.mozilla.org/en-US/docs/Web/API/File
 * @param acceptedFiles {string}
 * @returns {boolean}
 */

function accepts (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();
      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }
      return mimeType === validType;
    });
  }
  return true;
}

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// Error codes
var FILE_INVALID_TYPE = 'file-invalid-type';
var FILE_TOO_LARGE = 'file-too-large';
var FILE_TOO_SMALL = 'file-too-small';
var TOO_MANY_FILES = 'too-many-files';

// File Errors
var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(', ')) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? 'byte' : 'bytes')
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? 'byte' : 'bytes')
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: 'Too many files'
};

// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
function fileAccepted(file, accept) {
  var isAcceptable = file.type === 'application/x-moz-file' || accepts(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }
  return [true, null];
}
function isDefined(value) {
  return value !== undefined && value !== null;
}
function allFilesAccepted(_ref) {
  var files = _ref.files,
    accept = _ref.accept,
    minSize = _ref.minSize,
    maxSize = _ref.maxSize,
    multiple = _ref.multiple,
    maxFiles = _ref.maxFiles;
  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }
  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
      _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1),
      accepted = _fileAccepted2[0];
    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
      _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1),
      sizeMatch = _fileMatchSize2[0];
    return accepted && sizeMatch;
  });
}

// React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble
function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === 'function') {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== 'undefined') {
    return event.cancelBubble;
  }
  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  }
  // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}

// allow the entire document to be a drag target
function onDocumentDragOver(event) {
  event.preventDefault();
}
function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}
function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}
function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}

/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */
function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }
      return isPropagationStopped(event);
    });
  };
}

/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */
function canUseFileSystemAccessAPI() {
  return 'showOpenFilePicker' in window;
}

/**
 * filePickerOptionsTypes returns the {types} option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 * based on the accept attr (see https://github.com/react-dropzone/attr-accept)
 * E.g: converts ['image/*', 'text/*'] to {'image/*': [], 'text/*': []}
 * @param {string|string[]} accept
 */
function filePickerOptionsTypes(accept) {
  accept = typeof accept === 'string' ? accept.split(',') : accept;
  return [{
    description: 'everything',
    // TODO: Need to handle filtering more elegantly than this!
    accept: Array.isArray(accept) ?
    // Accept just MIME types as per spec
    // NOTE: accept can be https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers
    accept.filter(function (item) {
      return item === 'audio/*' || item === 'video/*' || item === 'image/*' || item === 'text/*' || /\w+\/[-+.\w]+/g.test(item);
    }).reduce(function (a, b) {
      return _objectSpread$4(_objectSpread$4({}, a), {}, _defineProperty$1({}, b, []));
    }, {}) : {}
  }];
}

/**
 * Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is an abort exception.
 */
function isAbort(v) {
  return v instanceof DOMException && (v.name === 'AbortError' || v.code === v.ABORT_ERR);
}

/**
 * Check if v is a security error.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is a security error.
 */
function isSecurityError(v) {
  return v instanceof DOMException && (v.name === 'SecurityError' || v.code === v.SECURITY_ERR);
}

var COMMON_MIME_TYPES = new Map([
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
['aac', 'audio/aac'], ['abw', 'application/x-abiword'], ['arc', 'application/x-freearc'], ['avif', 'image/avif'], ['avi', 'video/x-msvideo'], ['azw', 'application/vnd.amazon.ebook'], ['bin', 'application/octet-stream'], ['bmp', 'image/bmp'], ['bz', 'application/x-bzip'], ['bz2', 'application/x-bzip2'], ['cda', 'application/x-cdf'], ['csh', 'application/x-csh'], ['css', 'text/css'], ['csv', 'text/csv'], ['doc', 'application/msword'], ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'], ['eot', 'application/vnd.ms-fontobject'], ['epub', 'application/epub+zip'], ['gz', 'application/gzip'], ['gif', 'image/gif'], ['htm', 'text/html'], ['html', 'text/html'], ['ico', 'image/vnd.microsoft.icon'], ['ics', 'text/calendar'], ['jar', 'application/java-archive'], ['jpeg', 'image/jpeg'], ['jpg', 'image/jpeg'], ['js', 'text/javascript'], ['json', 'application/json'], ['jsonld', 'application/ld+json'], ['mid', 'audio/midi'], ['midi', 'audio/midi'], ['mjs', 'text/javascript'], ['mp3', 'audio/mpeg'], ['mp4', 'video/mp4'], ['mpeg', 'video/mpeg'], ['mpkg', 'application/vnd.apple.installer+xml'], ['odp', 'application/vnd.oasis.opendocument.presentation'], ['ods', 'application/vnd.oasis.opendocument.spreadsheet'], ['odt', 'application/vnd.oasis.opendocument.text'], ['oga', 'audio/ogg'], ['ogv', 'video/ogg'], ['ogx', 'application/ogg'], ['opus', 'audio/opus'], ['otf', 'font/otf'], ['png', 'image/png'], ['pdf', 'application/pdf'], ['php', 'application/x-httpd-php'], ['ppt', 'application/vnd.ms-powerpoint'], ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'], ['rar', 'application/vnd.rar'], ['rtf', 'application/rtf'], ['sh', 'application/x-sh'], ['svg', 'image/svg+xml'], ['swf', 'application/x-shockwave-flash'], ['tar', 'application/x-tar'], ['tif', 'image/tiff'], ['tiff', 'image/tiff'], ['ts', 'video/mp2t'], ['ttf', 'font/ttf'], ['txt', 'text/plain'], ['vsd', 'application/vnd.visio'], ['wav', 'audio/wav'], ['weba', 'audio/webm'], ['webm', 'video/webm'], ['webp', 'image/webp'], ['woff', 'font/woff'], ['woff2', 'font/woff2'], ['xhtml', 'application/xhtml+xml'], ['xls', 'application/vnd.ms-excel'], ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'], ['xml', 'application/xml'], ['xul', 'application/vnd.mozilla.xul+xml'], ['zip', 'application/zip'], ['7z', 'application/x-7z-compressed'],
// Others
['mkv', 'video/x-matroska'], ['mov', 'video/quicktime'], ['msg', 'application/vnd.ms-outlook']]);
function withMimeType(file) {
  var name = file.name;
  var hasExtension = name && name.lastIndexOf('.') !== -1;
  if (hasExtension && !file.type) {
    var ext = name.split('.').pop().toLowerCase();
    var type = COMMON_MIME_TYPES.get(ext);
    if (type) {
      Object.defineProperty(file, 'type', {
        value: type,
        writable: false,
        configurable: false,
        enumerable: true
      });
    }
  }
  return file;
}
function toFileWithPath(file, path) {
  var f = withMimeType(file);
  if (typeof f.path !== 'string') {
    // on electron, path is already set to the absolute path
    var webkitRelativePath = file.webkitRelativePath;
    Object.defineProperty(f, 'path', {
      value: typeof path === 'string' ? path :
      // If <input webkitdirectory> is set,
      // the File will have a {webkitRelativePath} property
      // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
      typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
      writable: false,
      configurable: false,
      enumerable: true
    });
  }
  return f;
}

var FILES_TO_IGNORE = [
// Thumbnail cache files for macOS and Windows
'.DS_Store', 'Thumbs.db' // Windows
];

function isDataTransfer(value) {
  return isObject(value.dataTransfer);
}
function isChangeEvt(value) {
  return isObject(value) && isObject(value.target);
}
function isObject(v) {
  return _typeof(v) === 'object' && v !== null;
}
function getInputFiles(evt) {
  return fromList(evt.target.files).map(function (file) {
    return toFileWithPath(file);
  });
}

// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(_x) {
  return _getFsHandleFiles.apply(this, arguments);
}
function _getFsHandleFiles() {
  _getFsHandleFiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(handles) {
    var files;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return Promise.all(handles.map(function (h) {
            return h.getFile();
          }));
        case 2:
          files = _context2.sent;
          return _context2.abrupt("return", files.map(function (file) {
            return toFileWithPath(file);
          }));
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getFsHandleFiles.apply(this, arguments);
}
function getDataTransferFiles(_x2, _x3) {
  return _getDataTransferFiles.apply(this, arguments);
}
function _getDataTransferFiles() {
  _getDataTransferFiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dt, type) {
    var items, files;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!(dt === null)) {
            _context3.next = 2;
            break;
          }
          return _context3.abrupt("return", []);
        case 2:
          if (!dt.items) {
            _context3.next = 10;
            break;
          }
          items = fromList(dt.items).filter(function (item) {
            return item.kind === 'file';
          }); // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
          // only 'dragstart' and 'drop' has access to the data (source node)
          if (!(type !== 'drop')) {
            _context3.next = 6;
            break;
          }
          return _context3.abrupt("return", items);
        case 6:
          _context3.next = 8;
          return Promise.all(items.map(toFilePromises));
        case 8:
          files = _context3.sent;
          return _context3.abrupt("return", noIgnoredFiles(flatten(files)));
        case 10:
          return _context3.abrupt("return", noIgnoredFiles(fromList(dt.files).map(function (file) {
            return toFileWithPath(file);
          })));
        case 11:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _getDataTransferFiles.apply(this, arguments);
}
function noIgnoredFiles(files) {
  return files.filter(function (file) {
    return FILES_TO_IGNORE.indexOf(file.name) === -1;
  });
}

// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
  if (items === null) {
    return [];
  }
  var files = [];
  // tslint:disable: prefer-for-of
  for (var i = 0; i < items.length; i++) {
    var file = items[i];
    files.push(file);
  }
  return files;
}

// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
  if (typeof item.webkitGetAsEntry !== 'function') {
    return fromDataTransferItem(item);
  }
  var entry = item.webkitGetAsEntry();
  // Safari supports dropping an image node from a different window and can be retrieved using
  // the DataTransferItem.getAsFile() API
  // NOTE: FileSystemEntry.file() throws if trying to get the file
  if (entry && entry.isDirectory) {
    return fromDirEntry(entry);
  }
  return fromDataTransferItem(item);
}
function flatten(items) {
  return items.reduce(function (acc, files) {
    return [].concat(_toConsumableArray(acc), _toConsumableArray(Array.isArray(files) ? flatten(files) : [files]));
  }, []);
}
function fromDataTransferItem(item) {
  var file = item.getAsFile();
  if (!file) {
    return Promise.reject("".concat(item, " is not a File"));
  }
  var fwp = toFileWithPath(file);
  return Promise.resolve(fwp);
}

// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(_x4) {
  return _fromEntry.apply(this, arguments);
} // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function _fromEntry() {
  _fromEntry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(entry) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry));
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _fromEntry.apply(this, arguments);
}
function fromDirEntry(entry) {
  var reader = entry.createReader();
  return new Promise(function (resolve, reject) {
    var entries = [];
    function readEntries() {
      // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
      // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
      reader.readEntries( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(batch) {
          var files, items;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (batch.length) {
                  _context.next = 13;
                  break;
                }
                _context.prev = 1;
                _context.next = 4;
                return Promise.all(entries);
              case 4:
                files = _context.sent;
                resolve(files);
                _context.next = 11;
                break;
              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                reject(_context.t0);
              case 11:
                _context.next = 16;
                break;
              case 13:
                items = Promise.all(batch.map(fromEntry));
                entries.push(items);
                // Continue reading
                readEntries();
              case 16:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[1, 8]]);
        }));
        return function (_x5) {
          return _ref.apply(this, arguments);
        };
      }(), function (err) {
        reject(err);
      });
    }
    readEntries();
  });
}

// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(_x6) {
  return _fromFileEntry.apply(this, arguments);
}
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function _fromFileEntry() {
  _fromFileEntry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(entry) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", new Promise(function (resolve, reject) {
            entry.file(function (file) {
              var fwp = toFileWithPath(file, entry.fullPath);
              resolve(fwp);
            }, function (err) {
              reject(err);
            });
          }));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _fromFileEntry.apply(this, arguments);
}
function fromEvent(_x7) {
  return _fromEvent.apply(this, arguments);
}
function _fromEvent() {
  _fromEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(evt) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          if (!(isObject(evt) && isDataTransfer(evt))) {
            _context6.next = 4;
            break;
          }
          return _context6.abrupt("return", getDataTransferFiles(evt.dataTransfer, evt.type));
        case 4:
          if (!isChangeEvt(evt)) {
            _context6.next = 8;
            break;
          }
          return _context6.abrupt("return", getInputFiles(evt));
        case 8:
          if (!(Array.isArray(evt) && evt.every(function (item) {
            return 'getFile' in item && typeof item.getFile === 'function';
          }))) {
            _context6.next = 10;
            break;
          }
          return _context6.abrupt("return", getFsHandleFiles(evt));
        case 10:
          return _context6.abrupt("return", []);
        case 11:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _fromEvent.apply(this, arguments);
}

var _excluded$6 = ["children"],
  _excluded2$1 = ["open"],
  _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
  _excluded4 = ["refKey", "onChange", "onClick"];
function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultProps$1 = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: true
};
var Dropzone = /*#__PURE__*/forwardRef(function (rawProps, ref) {
  var _defaultProps$rawProp = _objectSpread$3(_objectSpread$3({}, defaultProps$1), rawProps),
    children = _defaultProps$rawProp.children,
    params = _objectWithoutProperties$1(_defaultProps$rawProp, _excluded$6);
  var _useDropzone = useDropzone(params),
    open = _useDropzone.open,
    restProps = _objectWithoutProperties$1(_useDropzone, _excluded2$1);
  useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]);

  // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
  return jsx(Fragment, null, children(_objectSpread$3(_objectSpread$3({}, restProps), {}, {
    open: open
  })));
});
Dropzone.displayName = 'Dropzone';
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes.func,
  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: PropTypes.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: PropTypes.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes.func,
  /**
   * Custom validation function
   * @param {File} file
   * @returns {FileError|FileError[]}
   */
  validator: PropTypes.func
};

/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  fileRejections: []
};

/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {string|string[]} [props.accept] Set accepted file types.
 * See https://github.com/okonet/attr-accept for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all.
 * See: https://github.com/react-dropzone/react-dropzone/issues/276
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 *
 * @returns {DropzoneState}
 */
function useDropzone() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _defaultProps$options = _objectSpread$3(_objectSpread$3({}, defaultProps$1), options),
    accept = _defaultProps$options.accept,
    disabled = _defaultProps$options.disabled,
    getFilesFromEvent = _defaultProps$options.getFilesFromEvent,
    maxSize = _defaultProps$options.maxSize,
    minSize = _defaultProps$options.minSize,
    multiple = _defaultProps$options.multiple,
    maxFiles = _defaultProps$options.maxFiles,
    onDragEnter = _defaultProps$options.onDragEnter,
    onDragLeave = _defaultProps$options.onDragLeave,
    onDragOver = _defaultProps$options.onDragOver,
    onDrop = _defaultProps$options.onDrop,
    onDropAccepted = _defaultProps$options.onDropAccepted,
    onDropRejected = _defaultProps$options.onDropRejected,
    onFileDialogCancel = _defaultProps$options.onFileDialogCancel,
    onFileDialogOpen = _defaultProps$options.onFileDialogOpen,
    useFsAccessApi = _defaultProps$options.useFsAccessApi,
    preventDropOnDocument = _defaultProps$options.preventDropOnDocument,
    noClick = _defaultProps$options.noClick,
    noKeyboard = _defaultProps$options.noKeyboard,
    noDrag = _defaultProps$options.noDrag,
    noDragEventsBubbling = _defaultProps$options.noDragEventsBubbling,
    validator = _defaultProps$options.validator;
  var onFileDialogOpenCb = useMemo(function () {
    return typeof onFileDialogOpen === 'function' ? onFileDialogOpen : noop;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = useMemo(function () {
    return typeof onFileDialogCancel === 'function' ? onFileDialogCancel : noop;
  }, [onFileDialogCancel]);
  var rootRef = useRef(null);
  var inputRef = useRef(null);
  var _useReducer = useReducer(reducer, initialState),
    _useReducer2 = _slicedToArray$1(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var isFocused = state.isFocused,
    isFileDialogActive = state.isFileDialogActive,
    draggedFiles = state.draggedFiles;
  var fsAccessApiWorksRef = useRef(typeof window !== 'undefined' && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI());

  // Update file dialog active state when the window is focused on
  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;
          if (!files.length) {
            dispatch({
              type: 'closeDialog'
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };
  useEffect(function () {
    window.addEventListener('focus', onWindowFocus, false);
    return function () {
      window.removeEventListener('focus', onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = useRef([]);
  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }
    event.preventDefault();
    dragTargetsRef.current = [];
  };
  useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener('dragover', onDocumentDragOver, false);
      document.addEventListener('drop', onDocumentDrop, false);
    }
    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener('dragover', onDocumentDragOver);
        document.removeEventListener('drop', onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = useCallback(function (event) {
    event.preventDefault();
    // Persist here because we need the event later after getFilesFromEvent() is done
    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);
    if (isEvtWithFiles(event)) {
      // eslint-disable-next-line promise/catch-or-return
      Promise.resolve(getFilesFromEvent(event)).then(function (draggedFiles) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        dispatch({
          draggedFiles: draggedFiles,
          isDragActive: true,
          type: 'setDraggedFiles'
        });

        // eslint-disable-next-line promise/always-return
        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);
    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = 'copy';
      } catch (_unused) {} /* eslint-disable-line no-empty */
    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }
    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);

    // Only deactivate once the dropzone and all children have been left
    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    });
    // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)
    var targetIdx = targets.indexOf(event.target);
    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }
    dragTargetsRef.current = targets;
    if (targets.length > 0) {
      return;
    }
    dispatch({
      isDragActive: false,
      type: 'setDraggedFiles',
      draggedFiles: []
    });
    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = useCallback(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray$1(_fileAccepted, 2),
        accepted = _fileAccepted2[0],
        acceptError = _fileAccepted2[1];
      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 2),
        sizeMatch = _fileMatchSize2[0],
        sizeError = _fileMatchSize2[1];
      var customErrors = validator ? validator(file) : null;
      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];
        if (customErrors) {
          errors = errors.concat(customErrors);
        }
        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });
    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      // Reject everything and empty accepted files
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }
    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      type: 'setFiles'
    });
    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }
    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }
    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, accept, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = useCallback(function (event) {
    event.preventDefault();
    // Persist here because we need the event later after getFilesFromEvent() is done
    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];
    if (isEvtWithFiles(event)) {
      // eslint-disable-next-line promise/catch-or-return
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        // eslint-disable-next-line promise/always-return
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        setFiles(files, event);
      });
    }
    dispatch({
      type: 'reset'
    });
  }, [getFilesFromEvent, setFiles, noDragEventsBubbling]);

  // Fn for opening the file dialog programmatically
  var openFileDialog = useCallback(function () {
    // No point to use FS access APIs if context is not secure
    // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: 'openDialog'
      });
      onFileDialogOpenCb();
      // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
      var opts = {
        multiple: multiple,
        types: filePickerOptionsTypes(accept)
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      })
      // eslint-disable-next-line promise/always-return
      .then(function (files) {
        setFiles(files, null);
        dispatch({
          type: 'closeDialog'
        });
      })["catch"](function (e) {
        // AbortError means the user canceled
        if (isAbort(e)) {
          onFileDialogCancelCb(e);
          dispatch({
            type: 'closeDialog'
          });
        } else if (isSecurityError(e)) {
          fsAccessApiWorksRef.current = false;
          // CORS, so cannot use this API
          // Try using the input
          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          }
        }
      });
      return;
    }
    if (inputRef.current) {
      dispatch({
        type: 'openDialog'
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, accept, multiple]);

  // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
  var onKeyDownCb = useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }
    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]);

  // Update focus state for the dropzone
  var onFocusCb = useCallback(function () {
    dispatch({
      type: 'focus'
    });
  }, []);
  var onBlurCb = useCallback(function () {
    dispatch({
      type: 'blur'
    });
  }, []);

  // Cb to open the file dialog when click occurs on the dropzone
  var onClickCb = useCallback(function () {
    if (noClick) {
      return;
    }

    // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450
    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);
  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };
  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };
  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };
  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };
  var getRootProps = useMemo(function () {
    return function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref$refKey = _ref.refKey,
        refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
        role = _ref.role,
        onKeyDown = _ref.onKeyDown,
        onFocus = _ref.onFocus,
        onBlur = _ref.onBlur,
        onClick = _ref.onClick,
        onDragEnter = _ref.onDragEnter,
        onDragOver = _ref.onDragOver,
        onDragLeave = _ref.onDragLeave,
        onDrop = _ref.onDrop,
        rest = _objectWithoutProperties$1(_ref, _excluded3);
      return _objectSpread$3(_objectSpread$3(_defineProperty$1({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
        role: typeof role === 'string' && role !== '' ? role : 'button'
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref2$refKey = _ref2.refKey,
        refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey,
        onChange = _ref2.onChange,
        onClick = _ref2.onClick,
        rest = _objectWithoutProperties$1(_ref2, _excluded4);
      var inputProps = _defineProperty$1({
        accept: accept,
        multiple: multiple,
        type: 'file',
        style: {
          display: 'none'
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        autoComplete: 'off',
        tabIndex: -1
      }, refKey, inputRef);
      return _objectSpread$3(_objectSpread$3({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isDragAccept = fileCount > 0 && allFilesAccepted({
    files: draggedFiles,
    accept: accept,
    minSize: minSize,
    maxSize: maxSize,
    multiple: multiple,
    maxFiles: maxFiles
  });
  var isDragReject = fileCount > 0 && !isDragAccept;
  return _objectSpread$3(_objectSpread$3({}, state), {}, {
    isDragAccept: isDragAccept,
    isDragReject: isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}
function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case 'focus':
      return _objectSpread$3(_objectSpread$3({}, state), {}, {
        isFocused: true
      });
    case 'blur':
      return _objectSpread$3(_objectSpread$3({}, state), {}, {
        isFocused: false
      });
    case 'openDialog':
      return _objectSpread$3(_objectSpread$3({}, initialState), {}, {
        isFileDialogActive: true
      });
    case 'closeDialog':
      return _objectSpread$3(_objectSpread$3({}, state), {}, {
        isFileDialogActive: false
      });
    case 'setDraggedFiles':
      /* eslint no-case-declarations: 0 */
      var isDragActive = action.isDragActive,
        draggedFiles = action.draggedFiles;
      return _objectSpread$3(_objectSpread$3({}, state), {}, {
        draggedFiles: draggedFiles,
        isDragActive: isDragActive
      });
    case 'setFiles':
      return _objectSpread$3(_objectSpread$3({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });
    case 'reset':
      return _objectSpread$3({}, initialState);
    default:
      return state;
  }
}
function noop() {}

var getColor = function getColor(props) {
  if (props.isDragAccept) {
    return 'var(--color-alert-success)';
  }
  if (props.isDragReject) {
    return 'var(--color-alert-error)';
  }
  if (props.isFocused) {
    return 'var(--color-primary)';
  }
  return '#a3a3a3';
};
var cssDropzoneContainer = function cssDropzoneContainer(props) {
  return /*#__PURE__*/css("flex:1;display:flex;flex-direction:column;align-items:center;padding:20px;outline:none;transition:border 0.24s ease-in-out;border-radius:15px;border-style:dashed;border-width:2px;border-color:", getColor(props), ";:focus,:hover{border-color:var(--color-primary);};label:cssDropzoneContainer;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkRyb3B6b25lQ29udGFpbmVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlCeUMiLCJmaWxlIjoiRHJvcHpvbmVDb250YWluZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgZm9yd2FyZFJlZiB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IGJvb2wgfSBmcm9tICdwcm9wLXR5cGVzJztcblxuY29uc3QgZ2V0Q29sb3IgPSBwcm9wcyA9PiB7XG4gIGlmIChwcm9wcy5pc0RyYWdBY2NlcHQpIHtcbiAgICByZXR1cm4gJ3ZhcigtLWNvbG9yLWFsZXJ0LXN1Y2Nlc3MpJztcbiAgfVxuICBpZiAocHJvcHMuaXNEcmFnUmVqZWN0KSB7XG4gICAgcmV0dXJuICd2YXIoLS1jb2xvci1hbGVydC1lcnJvciknO1xuICB9XG4gIGlmIChwcm9wcy5pc0ZvY3VzZWQpIHtcbiAgICByZXR1cm4gJ3ZhcigtLWNvbG9yLXByaW1hcnkpJztcbiAgfVxuICByZXR1cm4gJyNhM2EzYTMnO1xufTtcblxuY29uc3QgY3NzRHJvcHpvbmVDb250YWluZXIgPSBwcm9wcyA9PiBjc3NgXG4gIGZsZXg6IDE7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIHBhZGRpbmc6IDIwcHg7XG4gIG91dGxpbmU6IG5vbmU7XG4gIHRyYW5zaXRpb246IGJvcmRlciAwLjI0cyBlYXNlLWluLW91dDtcbiAgYm9yZGVyLXJhZGl1czogMTVweDtcbiAgYm9yZGVyLXN0eWxlOiBkYXNoZWQ7XG4gIGJvcmRlci13aWR0aDogMnB4O1xuICBib3JkZXItY29sb3I6ICR7Z2V0Q29sb3IocHJvcHMpfTtcblxuICA6Zm9jdXMsXG4gIDpob3ZlciB7XG4gICAgYm9yZGVyLWNvbG9yOiB2YXIoLS1jb2xvci1wcmltYXJ5KTtcbiAgfVxuYDtcblxuZXhwb3J0IGNvbnN0IERyb3B6b25lQ29udGFpbmVyID0gZm9yd2FyZFJlZigocHJvcHMsIHJlZikgPT4ge1xuICBjb25zdCB7IGlzRm9jdXNlZCwgaXNEcmFnQWNjZXB0LCBpc0RyYWdSZWplY3QgfSA9IHByb3BzO1xuICByZXR1cm4gKFxuICAgIDxkaXZcbiAgICAgIHsuLi5wcm9wc31cbiAgICAgIHJlZj17cmVmfVxuICAgICAgY3NzPXtjc3NEcm9wem9uZUNvbnRhaW5lcih7IGlzRm9jdXNlZCwgaXNEcmFnQWNjZXB0LCBpc0RyYWdSZWplY3QgfSl9XG4gICAgLz5cbiAgKTtcbn0pO1xuXG5Ecm9wem9uZUNvbnRhaW5lci5kaXNwbGF5TmFtZSA9ICdEcm9wem9uZUNvbnRhaW5lcic7XG5Ecm9wem9uZUNvbnRhaW5lci5wcm9wVHlwZXMgPSB7XG4gIGlzRm9jdXNlZDogYm9vbCxcbiAgaXNEcmFnQWNjZXB0OiBib29sLFxuICBpc0RyYWdSZWplY3Q6IGJvb2wsXG59O1xuIl19 */"));
};
var DropzoneContainer = /*#__PURE__*/forwardRef(function (props, ref) {
  var isFocused = props.isFocused,
    isDragAccept = props.isDragAccept,
    isDragReject = props.isDragReject;
  return jsx("div", _extends$1({}, props, {
    ref: ref,
    css: cssDropzoneContainer({
      isFocused: isFocused,
      isDragAccept: isDragAccept,
      isDragReject: isDragReject
    })
  }));
});
DropzoneContainer.displayName = 'DropzoneContainer';
DropzoneContainer.propTypes = {
  isFocused: bool,
  isDragAccept: bool,
  isDragReject: bool
};

var AnimatedColDrop = /*#__PURE__*/forwardRef(function (props, ref) {
  var colDropRef = useRef();
  var animatedColDropProps = getFwcProps$1(props, {
    delay: 'delay',
    disableAnimateMobile: 'disable-animate-mobile',
    triggerAnimate: 'trigger-animate'
  });
  useEffect(function () {
    if (colDropRef.current) {
      new FwcAnimColDrop(colDropRef.current).build();
    }
  }, []);
  return jsx("fwc-anim-col-drop", _extends$1({}, animatedColDropProps, {
    ref: mergeRefs(ref, colDropRef)
  }), props.children);
});
AnimatedColDrop.displayName = 'AnimatedColDrop';
AnimatedColDrop.propTypes = {
  children: node$2,
  className: string,
  delay: number$4,
  triggerAnimate: bool,
  disableAnimateMobile: oneOf(['small', 'medium'])
};

var DonutChart = /*#__PURE__*/forwardRef(function (props, ref) {
  var donutChartRef = useRef();
  var uiState = useSBUIState();
  var assetsPath = (uiState === null || uiState === void 0 ? void 0 : uiState.assetsPath) || './';
  var percentages = props.percentages,
    labels = props.labels;
  var fwcProps = getFwcProps$1(props, {
    text: 'text',
    legend: 'legend',
    title: 'title',
    symbol: 'symbol',
    labels: 'labels',
    tooltipLabel: 'tooltip-label',
    legendPosition: 'legend-pos',
    legendHide: 'legend-hide'
  });
  useEffect(function () {
    if (donutChartRef.current) {
      new FwcChartDonut(donutChartRef.current).build();
    }
  }, []);
  return jsx("fwc-chart-donut", _extends$1({}, fwcProps, {
    percentages: JSON.stringify(percentages),
    labels: JSON.stringify(labels),
    ref: mergeRefs(donutChartRef, ref),
    config: JSON.stringify({
      assetsPath: assetsPath
    })
  }));
});
DonutChart.displayName = 'DonutChart';
DonutChart.propTypes = {
  /**
   * An array of number values for each length of the donut
   */
  percentages: array$2,
  /**
   * Legend title
   */
  legend: string,
  /**
   * An array of string values for each bar label, corresponding to the 'percentages' attribute array, ['label 1','label 2]
   */
  labels: array$2,
  /**
   * The value label for inside the center of the donut chart, above the title.
   */
  text: string,
  /**
   * The donut chart title/label in the center.
   */
  title: string,
  /**
   * Sets the legend data symbol: ( currency | percent | none ). Setting to 'currency' transforms the data in the legend to show as a percent of the total. To show data as passed, set to 'currency,' 'none,' or null (default)
   */
  symbol: oneOf(['currency', 'percent', 'none']),
  /**
   * String value for the tooltip label. Default is 'Value'
   */
  tooltipLabel: string,
  /**
   * Set to remove the legend from the display
   */
  legendHide: bool,
  /**
   * Sets the position of the legend. 'bottom' | 'right' - Default is 'bottom'
   */
  legendPosition: oneOf(['right', 'bottom'])
};

var _excluded$5 = ["className", "active", "onChange", "children"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$e() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssLink = process.env.NODE_ENV === "production" ? {
  name: "26qtpq-cssLink",
  styles: ".side-nav-item{width:130px;height:40px;margin:0 1px 0 0;border:none;background-color:rgba(255, 255, 255, 0);cursor:pointer;}.side-nav-item-link{border:none;background-color:rgba(255, 255, 255, 0);cursor:pointer;width:117px;height:22px;margin:9px 0 9px 14px;font-family:Lato;font-size:14px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:1.57;letter-spacing:normal;}.normal{color:#333;}.active{color:#286ce2;};label:cssLink;"
} : {
  name: "26qtpq-cssLink",
  styles: ".side-nav-item{width:130px;height:40px;margin:0 1px 0 0;border:none;background-color:rgba(255, 255, 255, 0);cursor:pointer;}.side-nav-item-link{border:none;background-color:rgba(255, 255, 255, 0);cursor:pointer;width:117px;height:22px;margin:9px 0 9px 14px;font-family:Lato;font-size:14px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:1.57;letter-spacing:normal;}.normal{color:#333;}.active{color:#286ce2;};label:cssLink;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
};
var SideNav = function SideNav(props) {
  var className = props.className,
    active = props.active,
    onChange = props.onChange,
    children = props.children,
    restProps = _objectWithoutProperties$1(props, _excluded$5);
  var handleChange = function handleChange(e) {
    if (e !== active) {
      onChange === null || onChange === void 0 ? void 0 : onChange(e);
    }
  };
  return jsx("div", _extends$1({}, restProps, {
    css: cssLink,
    className: className
  }), React__default.Children.map(children, function (child) {
    var _child$type;
    if ((child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) !== 'SideNavItem') {
      console.error("Warning SideNav has children that aren't SideNav.Item components");
      return null;
    }
    return /*#__PURE__*/React__default.cloneElement(child, {
      active: active,
      onClick: handleChange
    });
  }));
};
SideNav.propTypes = {
  className: string,
  children: node$2,
  active: any,
  onChange: func
};
var SideNavItem = function SideNavItem(props) {
  var name = props.name,
    active = props.active,
    _onClick = props.onClick;
  return jsx("div", {
    className: 'side-nav-item'
  }, jsx(Button, {
    btnType: "link",
    onClick: function onClick() {
      return _onClick(name);
    },
    className: cx('side-nav-item-link', name === active ? 'active' : 'normal'),
    value: name
  }, props.children));
};
SideNav.Item = SideNavItem;
SideNav.Item.displayName = 'SideNavItem';
SideNavItem.propTypes = {
  children: node$2,
  name: string,
  onClick: func,
  active: string
};

var cssCheckboxControls = function cssCheckboxControls(isTwoColumn) {
  return /*#__PURE__*/css(".fwc-checkbox{.checkbox-label{width:100%;font-size:16px;&:before{height:18px;width:18px;}}}.checkbox-header{padding:30px;padding-bottom:15px;border-bottom:1px solid #eee;}.checkbox-content{display:grid;grid-row-gap:5px;grid-column-gap:15px;grid-template-columns:repeat(auto-fit, minmax(160px, 1fr));padding:30px;padding-top:10px;max-width:", isTwoColumn ? '400' : '200', "px;}@media screen and (max-width: 600px){.checkbox-content{width:100%;}};label:cssCheckboxControls;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};
var CheckboxControls = function CheckboxControls(props) {
  var _props$hideSelectAll = props.hideSelectAll,
    hideSelectAll = _props$hideSelectAll === void 0 ? false : _props$hideSelectAll,
    name = props.name,
    _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    onCheckboxChange = props.onCheckboxChange,
    onSelectAllChange = props.onSelectAllChange;
  var isAllSelected = !options.some(function (opt) {
    return !opt.selected;
  });
  return jsx("div", {
    className: "checkbox-controls",
    css: cssCheckboxControls(options.length > 10)
  }, !hideSelectAll && jsx("div", {
    className: "checkbox-header"
  }, jsx(Checkbox, {
    name: name,
    label: "Select All",
    id: "".concat(name, "-select-all"),
    value: "".concat(name, "-select-all"),
    checked: isAllSelected,
    onChange: function onChange() {
      return onSelectAllChange(isAllSelected);
    }
  })), jsx("div", {
    className: "checkbox-content"
  }, options.map(function (option) {
    return jsx(Checkbox, {
      key: option.value,
      id: "".concat(name, "-").concat(option.value),
      name: name,
      label: option.label,
      value: "".concat(name, "-").concat(option.value),
      checked: option.selected,
      onChange: function onChange() {
        return onCheckboxChange(option, option.selected);
      }
    });
  })));
};
CheckboxControls.propTypes = {
  hideSelectAll: bool,
  name: string,
  options: arrayOf(shape({
    label: string,
    value: string,
    selected: bool
  })),
  onCheckboxChange: func,
  onSelectAllChange: func
};

var cssRadioControls = function cssRadioControls(isTwoColumn) {
  return /*#__PURE__*/css("display:grid;grid-row-gap:5px;grid-column-gap:15px;grid-template-columns:repeat(auto-fit, minmax(160px, 1fr));max-width:", isTwoColumn ? '400' : '200', "px;margin:30px;.fwc-radio{input{height:18px;min-width:18px;margin-bottom:2px;}.radio-label{width:100%;font-size:16px;}}@media screen and (max-width: 600px){&.radio-controls{max-width:100%;}};label:cssRadioControls;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};
var RadioControls = function RadioControls(props) {
  var name = props.name,
    value = props.value,
    _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    onRadioChange = props.onRadioChange;
  return jsx("div", {
    className: "radio-controls",
    css: cssRadioControls(options.length > 10)
  }, options.map(function (option) {
    return jsx(Radio, {
      className: "radio-control",
      key: option.value,
      name: name,
      label: option.label,
      value: option.value,
      checked: option.value === value,
      onChange: function onChange() {
        return onRadioChange(option);
      }
    });
  }));
};
RadioControls.propTypes = {
  name: string,
  value: string,
  options: arrayOf(shape({
    label: string,
    value: string
  })),
  onRadioChange: func
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$d() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssSelectControl = process.env.NODE_ENV === "production" ? {
  name: "6jqfd9-cssSelectControl",
  styles: ".fwc-select-list.field-select{margin-bottom:0px;}.fwc-select{font-weight:bold;};label:cssSelectControl;"
} : {
  name: "6jqfd9-cssSelectControl",
  styles: ".fwc-select-list.field-select{margin-bottom:0px;}.fwc-select{font-weight:bold;};label:cssSelectControl;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
};
var SelectControl = function SelectControl(props) {
  var name = props.name,
    value = props.value,
    _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    placeholder = props.placeholder,
    onSelectChange = props.onSelectChange;
  return jsx("div", {
    className: "select-control",
    css: cssSelectControl
  }, jsx(Select, {
    name: name,
    value: value,
    options: [{
      value: '',
      label: placeholder
    }].concat(_toConsumableArray(options)),
    onChange: function onChange(e) {
      return onSelectChange(options.find(function (opt) {
        return opt.value === e.target.value;
      }));
    }
  }));
};
SelectControl.propTypes = {
  name: string,
  value: string,
  placeholder: string,
  options: arrayOf(shape({
    label: string,
    value: string
  })),
  onSelectChange: func
};

// Select Auto Complete

var SelectAutoCompleteControl = function SelectAutoCompleteControl(props) {
  var isLoading = props.isLoading,
    name = props.name,
    value = props.value,
    placeholder = props.placeholder,
    _props$options2 = props.options,
    options = _props$options2 === void 0 ? [] : _props$options2,
    loadOptions = props.loadOptions,
    onSelectChange = props.onSelectChange,
    onInputChange = props.onInputChange,
    _props$arrowIconType = props.arrowIconType,
    arrowIconType = _props$arrowIconType === void 0 ? 'secondary' : _props$arrowIconType;
  return jsx("div", {
    className: "select-autocomplete-control"
  }, jsx(Selector, {
    id: name,
    value: value,
    options: options,
    placeholder: placeholder,
    isSearchable: true,
    secondaryArrow: arrowIconType === 'secondary' ? true : false,
    showSearchIcon: arrowIconType === 'search',
    isLoading: isLoading,
    onInputChange: loadOptions ? function (text) {
      onInputChange(text, loadOptions);
    } : null,
    onChange: onSelectChange
  }));
};
SelectAutoCompleteControl.propTypes = {
  isLoading: bool,
  name: string,
  value: string,
  placeholder: string,
  arrowIconType: oneOf(['primary', 'secondary', 'search']),
  options: arrayOf(shape({
    label: string,
    value: string
  })),
  loadOptions: func,
  onInputChange: func,
  onSelectChange: func
};

// Multi Select control
var MultiSelectControl = function MultiSelectControl(props) {
  var name = props.name,
    value = props.value,
    placeholder = props.placeholder,
    _props$options3 = props.options,
    options = _props$options3 === void 0 ? [] : _props$options3,
    onMultiSelectChange = props.onMultiSelectChange;
  return jsx("div", {
    className: "multi-select-control"
  }, jsx(Selector, {
    multi: true,
    id: name,
    value: value,
    placeholder: placeholder,
    options: options,
    searchable: false,
    onChange: onMultiSelectChange,
    secondaryArrow: true
  }));
};
MultiSelectControl.propTypes = {
  name: string,
  placeholder: string,
  value: arrayOf(shape({
    label: string,
    value: string
  })),
  options: arrayOf(shape({
    label: string,
    value: string
  })),
  onMultiSelectChange: func
};

// Multi Select Autocomplete
var MultiSelectAutoCompleteControl = /*#__PURE__*/React__default.memo(function (props) {
  var isLoading = props.isLoading,
    name = props.name,
    value = props.value,
    placeholder = props.placeholder,
    _props$options4 = props.options,
    options = _props$options4 === void 0 ? [] : _props$options4,
    _props$arrowIconType2 = props.arrowIconType,
    arrowIconType = _props$arrowIconType2 === void 0 ? 'secondary' : _props$arrowIconType2,
    loadOptions = props.loadOptions,
    onInputChange = props.onInputChange,
    onMultiSelectChange = props.onMultiSelectChange;
  return jsx("div", {
    className: "multi-select-autocomplete-control"
  }, jsx(Selector, {
    multi: true,
    id: name,
    value: value,
    options: options,
    placeholder: placeholder,
    searchable: true,
    secondaryArrow: arrowIconType === 'secondary' ? true : false,
    showSearchIcon: arrowIconType === 'search',
    isLoading: isLoading,
    onInputChange: loadOptions ? function (text) {
      onInputChange(text, loadOptions);
    } : null,
    onChange: onMultiSelectChange
  }));
});
MultiSelectAutoCompleteControl.displayName = 'MultiSelectAutoCompleteControl';
MultiSelectAutoCompleteControl.propTypes = {
  isLoading: bool,
  name: string,
  placeholder: string,
  arrowIconType: oneOf(['primary', 'secondary', 'search']),
  value: arrayOf(shape({
    label: string,
    value: string
  })),
  options: arrayOf(shape({
    label: string,
    value: string
  })),
  loadOptions: func,
  onInputChange: func,
  onMultiSelectChange: func
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$c() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssInputControl = process.env.NODE_ENV === "production" ? {
  name: "1uf8m5i-cssInputControl",
  styles: ".fwc-input.field-input{margin-bottom:0px;};label:cssInputControl;"
} : {
  name: "1uf8m5i-cssInputControl",
  styles: ".fwc-input.field-input{margin-bottom:0px;};label:cssInputControl;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIklucHV0Q29udHJvbC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLMkIiLCJmaWxlIjoiSW5wdXRDb250cm9sLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IElucHV0IH0gZnJvbSAnLi4vLi4vSW5wdXQnO1xuaW1wb3J0IHsgZnVuYywgc3RyaW5nIH0gZnJvbSAncHJvcC10eXBlcyc7XG5cbmNvbnN0IGNzc0lucHV0Q29udHJvbCA9IGNzc2BcbiAgLmZ3Yy1pbnB1dC5maWVsZC1pbnB1dCB7XG4gICAgbWFyZ2luLWJvdHRvbTogMHB4O1xuICB9XG5gO1xuXG5leHBvcnQgY29uc3QgSW5wdXRDb250cm9sID0gcHJvcHMgPT4ge1xuICBjb25zdCB7IGlkLCB2YWx1ZSwgb25JbnB1dENoYW5nZSB9ID0gcHJvcHM7XG5cbiAgcmV0dXJuIChcbiAgICA8ZGl2IGNsYXNzTmFtZT1cImlucHV0LWNvbnRyb2xcIiBjc3M9e2Nzc0lucHV0Q29udHJvbH0+XG4gICAgICA8SW5wdXRcbiAgICAgICAgaWQ9e2lkfVxuICAgICAgICB0eXBlPVwidGV4dFwiXG4gICAgICAgIHZhbHVlPXt2YWx1ZX1cbiAgICAgICAgb25DaGFuZ2U9e2UgPT5cbiAgICAgICAgICBvbklucHV0Q2hhbmdlKHsgdmFsdWU6IGUudGFyZ2V0LnZhbHVlLCBsYWJlbDogZS50YXJnZXQudmFsdWUgfSlcbiAgICAgICAgfVxuICAgICAgLz5cbiAgICA8L2Rpdj5cbiAgKTtcbn07XG5cbklucHV0Q29udHJvbC5wcm9wVHlwZXMgPSB7XG4gIGlkOiBzdHJpbmcsXG4gIHZhbHVlOiBzdHJpbmcsXG4gIG9uSW5wdXRDaGFuZ2U6IGZ1bmMsXG59O1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$c
};
var InputControl = function InputControl(props) {
  var id = props.id,
    value = props.value,
    onInputChange = props.onInputChange;
  return jsx("div", {
    className: "input-control",
    css: cssInputControl
  }, jsx(Input, {
    id: id,
    type: "text",
    value: value,
    onChange: function onChange(e) {
      return onInputChange({
        value: e.target.value,
        label: e.target.value
      });
    }
  }));
};
InputControl.propTypes = {
  id: string,
  value: string,
  onInputChange: func
};

var moment$1 = {exports: {}};

(function (module, exports) {
(function (global, factory) {
    module.exports = factory() ;
}(commonjsGlobal, (function () {
    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            'object' !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = commonjsRequire;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));
}(moment$1));

var moment = moment$1.exports;

function _EMOTION_STRINGIFIED_CSS_ERROR__$b() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssDateRangePicker = process.env.NODE_ENV === "production" ? {
  name: "4jsvlu-cssDateRangePicker",
  styles: ".date-picker-field{margin-bottom:16px;}.date-picker-field input{margin-bottom:16px;};label:cssDateRangePicker;"
} : {
  name: "4jsvlu-cssDateRangePicker",
  styles: ".date-picker-field{margin-bottom:16px;}.date-picker-field input{margin-bottom:16px;};label:cssDateRangePicker;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
};
var DateRangeControl = function DateRangeControl(props) {
  var _props$id = props.id,
    id = _props$id === void 0 ? '' : _props$id,
    _props$dateFormat = props.dateFormat,
    dateFormat = _props$dateFormat === void 0 ? 'MM/DD/YYYY' : _props$dateFormat,
    _props$fromDate = props.fromDate,
    fromDate = _props$fromDate === void 0 ? '' : _props$fromDate,
    _props$toDate = props.toDate,
    toDate = _props$toDate === void 0 ? '' : _props$toDate,
    _props$fromPlaceholde = props.fromPlaceholder,
    fromPlaceholder = _props$fromPlaceholde === void 0 ? '' : _props$fromPlaceholde,
    _props$toPlaceholder = props.toPlaceholder,
    toPlaceholder = _props$toPlaceholder === void 0 ? '' : _props$toPlaceholder,
    _props$onFromDateChan = props.onFromDateChange,
    onFromDateChange = _props$onFromDateChan === void 0 ? function () {} : _props$onFromDateChan,
    _props$onToDateChange = props.onToDateChange,
    onToDateChange = _props$onToDateChange === void 0 ? function () {} : _props$onToDateChange;
  return jsx("div", {
    id: "".concat(id, "-date-range-picker"),
    className: "date-range-picker-control",
    css: cssDateRangePicker
  }, jsx("div", {
    className: "from-date-picker"
  }, jsx(DatePicker, {
    id: "".concat(id, "-from-date"),
    dateFormat: dateFormat,
    placeholder: fromPlaceholder,
    value: fromDate,
    onChange: onFromDateChange,
    dateRange: [null, moment(toDate).format('MM/DD/YYYY')]
  })), jsx("div", {
    className: "to-date-picker"
  }, jsx(DatePicker, {
    id: "".concat(id, "-to-date"),
    dateFormat: dateFormat,
    placeholder: toPlaceholder,
    value: toDate,
    onChange: onToDateChange,
    dateRange: [moment(fromDate).format('MM/DD/YYYY'), null]
  })));
};
DateRangeControl.propTypes = {
  id: string,
  dateFormat: string,
  fromDate: string,
  fromPlaceholder: string,
  onFromDateChange: func,
  toDate: string,
  toPlaceholder: string,
  onToDateChange: func
};

var controlTypes = ['TEXT',
// Done
'RADIO',
// Done
'SWITCH', 'CHECKBOX',
// Done
'DATE-RANGE',
// Done
'DATE-RANGE-OPTIONS',
// Done
'SELECT',
// Done
'SELECT-AUTOCOMPLETE',
// Done
'MULTI-SELECT',
// Done
'MULTI-SELECT-AUTOCOMPLETE' // Done
];

var getCheckboxTitleAndType = function getCheckboxTitleAndType(filter) {
  var title = filter.title,
    _filter$options = filter.options,
    options = _filter$options === void 0 ? [] : _filter$options;
  var selectedOptions = options.filter(function (filter) {
    return filter.hasOwnProperty('selected') && filter.selected;
  });
  if (selectedOptions.length === 0) {
    return {
      title: title,
      type: 'secondary',
      count: 0
    };
  } else if (selectedOptions.length === 1) {
    return {
      title: selectedOptions[0].label,
      type: 'primary',
      count: 1
    };
  } else if (selectedOptions.length === options.length) {
    return {
      title: "All ".concat(title),
      type: 'primary',
      count: selectedOptions.length
    };
  } else {
    return {
      title: "".concat(selectedOptions.length, " ").concat(title),
      type: 'primary',
      count: selectedOptions.length
    };
  }
};
var getMultiSelectTitleAndType = function getMultiSelectTitleAndType(filter) {
  var title = filter.title,
    _filter$selected = filter.selected,
    selected = _filter$selected === void 0 ? [] : _filter$selected;
  if (selected.length === 0) {
    return {
      title: title,
      type: 'secondary',
      count: 0
    };
  } else if (selected.length === 1) {
    return {
      title: "".concat(selected[0].label),
      type: 'primary',
      count: 1
    };
  } else {
    return {
      title: "".concat(selected.length, " ").concat(title),
      type: 'primary',
      count: selected.length
    };
  }
};
var getDateRangePickerTitleAndType = function getDateRangePickerTitleAndType(filter) {
  var title = filter.title,
    _filter$selected2 = filter.selected,
    selected = _filter$selected2 === void 0 ? {} : _filter$selected2;
  if (selected.fromDate && selected.toDate) {
    return {
      title: "".concat(moment(selected.fromDate).format('MM/DD/YYYY'), " - ").concat(moment(selected.toDate).format('MM/DD/YYYY')),
      type: 'primary',
      count: 1
    };
  } else {
    return {
      title: title,
      type: 'secondary',
      count: 0
    };
  }
};
var getDropdownTitleAndType = function getDropdownTitleAndType(filter) {
  var title = filter.title,
    _filter$selected3 = filter.selected,
    selected = _filter$selected3 === void 0 ? {} : _filter$selected3;
  if (selected.value) {
    if (selected.value === 'CUSTOM-DATE-RANGE') return getDateRangePickerTitleAndType(filter);else return {
      title: "".concat(selected.label),
      type: 'primary',
      count: 1
    };
  } else return {
    title: title,
    type: 'secondary',
    count: 0
  };
};
var getIndividualFilterTitleAndType = function getIndividualFilterTitleAndType(filter) {
  if (filter.type === 'CHECKBOX') {
    return getCheckboxTitleAndType(filter);
  } else if (['MULTI-SELECT', 'MULTI-SELECT-AUTOCOMPLETE'].includes(filter.type)) {
    return getMultiSelectTitleAndType(filter);
  } else if (filter.type === 'DATE-RANGE') {
    return getDateRangePickerTitleAndType(filter);
  } else {
    return getDropdownTitleAndType(filter);
  }
};
var getGroupedFiltersTitleAndType = function getGroupedFiltersTitleAndType(filter) {
  var _filter$title = filter.title,
    title = _filter$title === void 0 ? '' : _filter$title,
    _filter$children = filter.children,
    children = _filter$children === void 0 ? [] : _filter$children;
  return children.reduce(function (acc, filter) {
    var result = getIndividualFilterTitleAndType(filter);
    if (result.count === 1 && acc.count === 0) return result;else if (result.count > 0) {
      var count = acc.count + result.count;
      return {
        title: "".concat(count, " ").concat(title),
        type: 'primary',
        count: count
      };
    } else return acc;
  }, {
    title: "".concat(title),
    type: '',
    count: 0
  });
};
var getFilterTitleAndType = function getFilterTitleAndType(filter) {
  if (filter.type === 'GROUPED-FILTERS') {
    return getGroupedFiltersTitleAndType(filter);
  } else {
    return getIndividualFilterTitleAndType(filter);
  }
};
var getMoreFiltersTitleAndType = function getMoreFiltersTitleAndType(filters) {
  return filters.reduce(function (acc, filter) {
    var result = getFilterTitleAndType(filter);
    if (result.count > 0) {
      var count = acc.count + 1;
      return {
        title: "".concat(count, " More Filters"),
        type: 'primary',
        count: count
      };
    }
    return acc;
  }, {
    title: 'More Filters',
    type: 'secondary',
    count: 0
  });
};
var getFiltersTitleAndType = function getFiltersTitleAndType(filters) {
  if (filters.length === 1) {
    return getFilterTitleAndType(filters[0]);
  } else {
    return getMoreFiltersTitleAndType(filters);
  }
};

// Query String functions ...

var convertDaysToFromToDates = function convertDaysToFromToDates(days) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';
  if (days.indexOf('-') !== -1) {
    // subtract
    return {
      fromDate: moment().subtract(Math.abs(parseInt(days, 10)), 'days').format(format),
      toDate: moment().format(format)
    };
  } else {
    // add
    return {
      fromDate: moment().format(format),
      toDate: moment().add(Math.abs(parseInt(days, 10)), 'days').format(format)
    };
  }
};
var checkboxFilterQueryString = function checkboxFilterQueryString(filter) {
  var code = filter.code,
    _filter$equalSign = filter.equalSign,
    equalSign = _filter$equalSign === void 0 ? '=' : _filter$equalSign,
    _filter$delimiterSign = filter.delimiterSign,
    delimiterSign = _filter$delimiterSign === void 0 ? ',' : _filter$delimiterSign,
    _filter$options2 = filter.options,
    options = _filter$options2 === void 0 ? [] : _filter$options2;
  var selectedOptions = options.filter(function (opt) {
    return opt.selected === true;
  });
  if (selectedOptions.length > 0 && selectedOptions) {
    return "".concat(code).concat(equalSign).concat(delimiterSign === '|' ? encodeURIComponent(selectedOptions.map(function (opt) {
      return opt.value;
    }).join(delimiterSign)) : selectedOptions.map(function (opt) {
      return opt.value;
    }).join(delimiterSign));
  } else {
    return '';
  }
};
var multiSelectFilterQueryString = function multiSelectFilterQueryString(filter) {
  var _filter$code = filter.code,
    code = _filter$code === void 0 ? '' : _filter$code,
    _filter$equalSign2 = filter.equalSign,
    equalSign = _filter$equalSign2 === void 0 ? '=' : _filter$equalSign2,
    _filter$delimiterSign2 = filter.delimiterSign,
    delimiterSign = _filter$delimiterSign2 === void 0 ? ',' : _filter$delimiterSign2,
    _filter$selected4 = filter.selected,
    selected = _filter$selected4 === void 0 ? [] : _filter$selected4;
  if (selected && selected.length > 0) {
    return "".concat(code).concat(equalSign).concat(selected.map(function (opt) {
      return opt.value;
    }).join(delimiterSign));
  } else {
    return '';
  }
};
var dateDropdownFilterQueryString = function dateDropdownFilterQueryString(filter) {
  var _filter$code2 = filter.code,
    code = _filter$code2 === void 0 ? '' : _filter$code2,
    _filter$equalSign3 = filter.equalSign,
    equalSign = _filter$equalSign3 === void 0 ? '=' : _filter$equalSign3,
    _filter$delimiterSign3 = filter.delimiterSign,
    delimiterSign = _filter$delimiterSign3 === void 0 ? ',' : _filter$delimiterSign3,
    _filter$queryStrDateF = filter.queryStrDateFormat,
    queryStrDateFormat = _filter$queryStrDateF === void 0 ? 'YYYY-MM-DD' : _filter$queryStrDateF,
    _filter$convertCodeTo = filter.convertCodeToDates,
    convertCodeToDates = _filter$convertCodeTo === void 0 ? false : _filter$convertCodeTo,
    _filter$selected5 = filter.selected,
    selected = _filter$selected5 === void 0 ? {} : _filter$selected5;
  if (selected.value) {
    if (selected.value === 'CUSTOM-DATE-RANGE') {
      if (selected.fromDate && selected.toDate) {
        var fromDate = moment(selected.fromDate).format(queryStrDateFormat);
        var toDate = moment(selected.toDate).format(queryStrDateFormat);
        return "".concat(code).concat(equalSign).concat(fromDate).concat(delimiterSign).concat(toDate);
      } else {
        return '';
      }
    } else if (convertCodeToDates) {
      var _convertDaysToFromToD = convertDaysToFromToDates(selected.value, queryStrDateFormat),
        _convertDaysToFromToD2 = _convertDaysToFromToD.fromDate,
        _fromDate = _convertDaysToFromToD2 === void 0 ? '' : _convertDaysToFromToD2,
        _convertDaysToFromToD3 = _convertDaysToFromToD.toDate,
        _toDate = _convertDaysToFromToD3 === void 0 ? '' : _convertDaysToFromToD3;
      return "".concat(code).concat(equalSign).concat(_fromDate).concat(delimiterSign).concat(_toDate);
    } else {
      return "".concat(code).concat(equalSign).concat(selected.value);
    }
  } else {
    return '';
  }
};
var restFilterTypesQueryString = function restFilterTypesQueryString(filter) {
  var _filter$code3 = filter.code,
    code = _filter$code3 === void 0 ? '' : _filter$code3,
    _filter$equalSign4 = filter.equalSign,
    equalSign = _filter$equalSign4 === void 0 ? '=' : _filter$equalSign4,
    _filter$selected6 = filter.selected,
    selected = _filter$selected6 === void 0 ? {} : _filter$selected6;
  if (selected.value) {
    return "".concat(code).concat(equalSign).concat(encodeURIComponent(selected.value));
  } else {
    return '';
  }
};
var createIndividualFilterQueryString = function createIndividualFilterQueryString(filter) {
  var type = filter.type;
  if (type === 'CHECKBOX') {
    return checkboxFilterQueryString(filter);
  } else if (['MULTI-SELECT', 'MULTI-SELECT-AUTOCOMPLETE'].includes(type)) {
    return multiSelectFilterQueryString(filter);
  } else if (type === 'DATE-RANGE-OPTIONS') {
    return dateDropdownFilterQueryString(filter);
  } else {
    return restFilterTypesQueryString(filter);
  }
};
var createFiltersQueryString = function createFiltersQueryString(filterConfig, filterSeparator) {
  var separator = filterSeparator || '&';
  return filterConfig.map(function (filter) {
    if (filter.type === 'GROUPED-FILTERS') {
      return filter.children.map(createIndividualFilterQueryString).filter(function (param) {
        return param;
      }).join(separator);
    } else {
      return createIndividualFilterQueryString(filter);
    }
  }).filter(function (param) {
    return param;
  }).join(separator);
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$a() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssFilterControls = process.env.NODE_ENV === "production" ? {
  name: "4bmzpr-cssFilterControls",
  styles: ".filter-control-title{margin-bottom:4px;font-size:14px;font-weight:bold;color:#333;}.filter-control-content{.date-range-picker-options-control{display:grid;grid-gap:16px;}};label:cssFilterControls;"
} : {
  name: "4bmzpr-cssFilterControls",
  styles: ".filter-control-title{margin-bottom:4px;font-size:14px;font-weight:bold;color:#333;}.filter-control-content{.date-range-picker-options-control{display:grid;grid-gap:16px;}};label:cssFilterControls;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
};
var FilterControls = function FilterControls(props) {
  var _selected$value;
  var _props$isGrouped = props.isGrouped,
    isGrouped = _props$isGrouped === void 0 ? false : _props$isGrouped,
    _props$isMoreFilters = props.isMoreFilters,
    isMoreFilters = _props$isMoreFilters === void 0 ? false : _props$isMoreFilters,
    _props$isSingleFilter = props.isSingleFilter,
    isSingleFilter = _props$isSingleFilter === void 0 ? false : _props$isSingleFilter;
  var _ref = props.filter || {},
    type = _ref.type,
    _ref$code = _ref.code,
    code = _ref$code === void 0 ? '' : _ref$code,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    selected = _ref.selected,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$arrowIconType = _ref.arrowIconType,
    arrowIconType = _ref$arrowIconType === void 0 ? 'secondary' : _ref$arrowIconType,
    loadOptions = _ref.loadOptions;
  return jsx("div", {
    className: "filter-control-container ".concat(isGrouped ? 'is-grouped' : ''),
    css: cssFilterControls
  }, isGrouped && title && jsx("div", {
    className: "filter-control-title"
  }, title), jsx("div", {
    className: "filter-control-content"
  }, type === 'CHECKBOX' && jsx(CheckboxControls, {
    key: code,
    name: code,
    options: options,
    hideSelectAll: isMoreFilters,
    onCheckboxChange: props.handleToggleCheckbox,
    onSelectAllChange: props.handleToggleSelectAllCheckbox
  }), type === 'SELECT' && isSingleFilter && !isGrouped && !isMoreFilters && jsx(RadioControls, {
    key: code,
    name: code,
    value: selected === null || selected === void 0 ? void 0 : selected.value,
    options: options,
    onRadioChange: props.handleSelectedChange
  }), type === 'TEXT' && jsx(InputControl, {
    key: code,
    id: code,
    value: (_selected$value = selected === null || selected === void 0 ? void 0 : selected.value) !== null && _selected$value !== void 0 ? _selected$value : '',
    placeholder: placeholder,
    onInputChange: props.handleSelectedChange
  }), type === 'DATE-RANGE' && jsx(DateRangeControl, {
    id: code,
    fromDate: (selected === null || selected === void 0 ? void 0 : selected.fromDate) || null,
    fromPlaceholder: "START",
    onFromDateChange: function onFromDateChange(_, selectedDate) {
      return props.handleDatePickerChange(selectedDate, 'fromDate');
    },
    toDate: (selected === null || selected === void 0 ? void 0 : selected.toDate) || null,
    toPlaceholder: "END",
    onToDateChange: function onToDateChange(_, selectedDate) {
      return props.handleDatePickerChange(selectedDate, 'toDate');
    }
  }), type === 'DATE-RANGE-OPTIONS' && jsx("div", {
    className: "date-range-picker-options-control"
  }, jsx(SelectControl, {
    key: code,
    name: code,
    value: selected === null || selected === void 0 ? void 0 : selected.value,
    options: options,
    placeholder: placeholder,
    onSelectChange: props.handleSelectedChange
  }), selected && selected.value === 'CUSTOM-DATE-RANGE' && jsx(DateRangeControl, {
    id: code,
    fromDate: (selected === null || selected === void 0 ? void 0 : selected.fromDate) || null,
    fromPlaceholder: "START",
    onFromDateChange: function onFromDateChange(_, selectedDate) {
      return props.handleDatePickerChange(selectedDate, 'fromDate');
    },
    toDate: (selected === null || selected === void 0 ? void 0 : selected.toDate) || null,
    toPlaceholder: "END",
    onToDateChange: function onToDateChange(_, selectedDate) {
      return props.handleDatePickerChange(selectedDate, 'toDate');
    }
  })), type === 'SELECT' && (isGrouped || isMoreFilters) && jsx(SelectControl, {
    key: code,
    name: code,
    value: selected === null || selected === void 0 ? void 0 : selected.value,
    options: options,
    placeholder: placeholder,
    onSelectChange: props.handleSelectedChange
  }), type === 'SELECT-AUTOCOMPLETE' && jsx(SelectAutoCompleteControl, {
    key: code,
    name: code,
    value: selected === null || selected === void 0 ? void 0 : selected.value,
    options: options,
    placeholder: placeholder,
    isLoading: isLoading,
    loadOptions: loadOptions,
    arrowIconType: arrowIconType,
    onSelectChange: props.handleSelectedChange,
    onInputChange: props.handleSearchInputChange
  }), type === 'MULTI-SELECT' && jsx(MultiSelectControl, {
    key: code,
    name: code,
    value: selected || [],
    options: options,
    placeholder: placeholder,
    onMultiSelectChange: props.handleSelectedChange
  }), type === 'MULTI-SELECT-AUTOCOMPLETE' && jsx(MultiSelectAutoCompleteControl, {
    key: code,
    name: code,
    value: selected || [],
    options: options,
    placeholder: placeholder,
    isLoading: isLoading,
    loadOptions: loadOptions,
    arrowIconType: arrowIconType,
    onMultiSelectChange: props.handleSelectedChange,
    onInputChange: props.handleSearchInputChange
  })));
};
FilterControls.propTypes = {
  filter: shape({
    type: oneOf(_toConsumableArray(controlTypes)),
    code: string,
    title: string,
    equalSign: string,
    delimiterSign: string,
    queryStrDateFormat: string,
    convertCodeToDates: bool,
    dateFormat: string,
    inputType: string,
    placeholder: string,
    arrowIconType: oneOf(['primary', 'secondary', 'search']),
    loadOptions: func,
    options: arrayOf(shape({
      label: string,
      value: oneOfType([string, number$4])
    }))
  }),
  isGrouped: bool,
  isSingleFilter: bool,
  isMoreFilters: bool,
  // func
  handleToggleCheckbox: func,
  handleSelectedChange: func,
  handleDatePickerChange: func,
  handleToggleSelectAllCheckbox: func,
  handleSearchInputChange: func
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _EMOTION_STRINGIFIED_CSS_ERROR__$9() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssFilterContainer = process.env.NODE_ENV === "production" ? {
  name: "1fic647-cssFilterContainer",
  styles: ".filter-title{margin-bottom:4px;font-size:14px;font-weight:bold;color:#333;}.group-filter-title{font-size:16px;font-weight:bold;color:#333;}.grouped-filter{display:grid;grid-gap:10px;};label:cssFilterContainer;"
} : {
  name: "1fic647-cssFilterContainer",
  styles: ".filter-title{margin-bottom:4px;font-size:14px;font-weight:bold;color:#333;}.group-filter-title{font-size:16px;font-weight:bold;color:#333;}.grouped-filter{display:grid;grid-gap:10px;};label:cssFilterContainer;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
};
var FilterContainer = function FilterContainer(props) {
  var filter = props.filter,
    isSingleFilter = props.isSingleFilter,
    isMoreFilters = props.isMoreFilters;
  var type = filter.type,
    _filter$title = filter.title,
    title = _filter$title === void 0 ? '' : _filter$title,
    code = filter.code,
    index = filter.index,
    _filter$children = filter.children,
    children = _filter$children === void 0 ? [] : _filter$children;
  var groupedFilterId = title.replace(/\s/g, '-');
  return jsx("div", {
    key: code || title,
    id: "".concat(groupedFilterId || code, "-container"),
    css: cssFilterContainer
  }, type !== 'GROUPED-FILTERS' && jsx("div", {
    className: "single-filter"
  }, isMoreFilters && jsx("div", {
    className: "filter-title"
  }, title), jsx(FilterControls, {
    filter: filter,
    isGrouped: false,
    isMoreFilters: isMoreFilters,
    isSingleFilter: isSingleFilter,
    handleSelectedChange: props.handleSelectedChange({
      index: index
    }),
    handleToggleCheckbox: props.handleToggleCheckbox({
      index: index
    }),
    handleToggleSelectAllCheckbox: props.handleToggleSelectAllCheckbox({
      index: index
    }),
    handleDatePickerChange: props.handleDatePickerChange({
      index: index
    }),
    handleSearchInputChange: props.handleSearchInputChange({
      index: index
    })
  })), type === 'GROUPED-FILTERS' && jsx("div", {
    className: "grouped-filter"
  }, isMoreFilters && jsx("div", {
    className: "group-filter-title"
  }, title), children.map(function (childFilter, childIndex) {
    return jsx(FilterControls, {
      key: childFilter.code,
      isGrouped: true,
      filter: childFilter,
      isMoreFilters: isMoreFilters,
      isSingleFilter: isSingleFilter,
      handleSelectedChange: props.handleSelectedChange({
        index: index,
        childIndex: childIndex,
        isGrouped: true
      }),
      handleToggleCheckbox: props.handleToggleCheckbox({
        index: index,
        childIndex: childIndex,
        isGrouped: true
      }),
      handleToggleSelectAllCheckbox: props.handleToggleSelectAllCheckbox({
        index: index,
        childIndex: childIndex,
        isGrouped: true
      }),
      handleDatePickerChange: props.handleDatePickerChange({
        index: index,
        childIndex: childIndex,
        isGrouped: true
      }),
      handleSearchInputChange: props.handleSearchInputChange({
        index: index,
        childIndex: childIndex,
        isGrouped: true
      })
    });
  })));
};
FilterContainer.propTypes = {
  filter: shape({
    type: oneOf([].concat(_toConsumableArray(controlTypes), ['GROUPED-FILTERS'])),
    code: string,
    title: string,
    equalSign: string,
    delimiterSign: string,
    queryStrDateFormat: string,
    convertCodeToDates: bool,
    dateFormat: string,
    inputType: string,
    placeholder: string,
    arrowIconType: oneOf(['primary', 'secondary', 'search']),
    options: arrayOf(shape({
      label: string,
      value: oneOfType([string, number$4])
    }))
  }),
  isGrouped: bool,
  isSingleFilter: bool,
  isMoreFilters: bool,
  // func
  handleToggleCheckbox: func,
  handleSelectedChange: func,
  handleDatePickerChange: func,
  handleToggleSelectAllCheckbox: func,
  handleSearchInputChange: func
};
var isFilterLeftAligned = function isFilterLeftAligned(filter, isTabletMode, align) {
  if (isTabletMode) {
    if ('tabletAlign' in filter) {
      return filter.tabletAlign === align;
    } else {
      return align === 'left' ? filter.index % 2 === 0 : filter.index % 2 !== 0;
    }
  } else {
    if ('desktopAlign' in filter) {
      return filter.desktopAlign === align;
    } else {
      return align === 'left' ? filter.index % 2 === 0 : filter.index % 2 !== 0;
    }
  }
};
var cssFiltersContentSection = process.env.NODE_ENV === "production" ? {
  name: "1lh25k3-cssFiltersContentSection",
  styles: ".individual-filters.margins{margin:30px;width:300px;}.more-filters{width:700px;display:grid;grid-gap:30px;grid-auto-flow:column;grid-auto-columns:1fr;padding:30px;.checkbox-content{padding:0px;}.left-side{display:grid;grid-gap:30px;margin-bottom:auto;}.right-side{display:grid;grid-gap:30px;margin-bottom:auto;}}@media screen and (max-width: 600px){.more-filters{width:100%;grid-auto-flow:row;}};label:cssFiltersContentSection;"
} : {
  name: "1lh25k3-cssFiltersContentSection",
  styles: ".individual-filters.margins{margin:30px;width:300px;}.more-filters{width:700px;display:grid;grid-gap:30px;grid-auto-flow:column;grid-auto-columns:1fr;padding:30px;.checkbox-content{padding:0px;}.left-side{display:grid;grid-gap:30px;margin-bottom:auto;}.right-side{display:grid;grid-gap:30px;margin-bottom:auto;}}@media screen and (max-width: 600px){.more-filters{width:100%;grid-auto-flow:row;}};label:cssFiltersContentSection;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpbHRlckJ1dHRvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFvS29DIiwiZmlsZSI6IkZpbHRlckJ1dHRvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwge1xuICB1c2VDYWxsYmFjayxcbiAgdXNlUmVmLFxuICB1c2VTdGF0ZSxcbiAgdXNlRWZmZWN0LFxuICB1c2VNZW1vLFxufSBmcm9tICdyZWFjdCc7XG5pbXBvcnQge1xuICBvbmVPZixcbiAgc3RyaW5nLFxuICBhcnJheU9mLFxuICBzaGFwZSxcbiAgb25lT2ZUeXBlLFxuICBudW1iZXIsXG4gIGJvb2wsXG4gIGZ1bmMsXG4gIGFycmF5LFxufSBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IEJ1dHRvbiB9IGZyb20gJy4uL0J1dHRvbic7XG5pbXBvcnQgeyBGaWx0ZXJQYW5lbCB9IGZyb20gJy4uL0ZpbHRlclBhbmVsJztcbmltcG9ydCB7IEZpbHRlckNvbnRyb2xzIH0gZnJvbSAnLi9GaWx0ZXJDb250cm9scyc7XG5cbmltcG9ydCB7IGdldEZpbHRlcnNUaXRsZUFuZFR5cGUsIGNvbnRyb2xUeXBlcyB9IGZyb20gJy4vdXRpbHMnO1xuXG5jb25zdCBjc3NGaWx0ZXJDb250YWluZXIgPSBjc3NgXG4gIC5maWx0ZXItdGl0bGUge1xuICAgIG1hcmdpbi1ib3R0b206IDRweDtcbiAgICBmb250LXNpemU6IDE0cHg7XG4gICAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gICAgY29sb3I6ICMzMzM7XG4gIH1cblxuICAuZ3JvdXAtZmlsdGVyLXRpdGxlIHtcbiAgICBmb250LXNpemU6IDE2cHg7XG4gICAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gICAgY29sb3I6ICMzMzM7XG4gIH1cblxuICAuZ3JvdXBlZC1maWx0ZXIge1xuICAgIGRpc3BsYXk6IGdyaWQ7XG4gICAgZ3JpZC1nYXA6IDEwcHg7XG4gIH1cbmA7XG5cbmNvbnN0IEZpbHRlckNvbnRhaW5lciA9IHByb3BzID0+IHtcbiAgY29uc3QgeyBmaWx0ZXIsIGlzU2luZ2xlRmlsdGVyLCBpc01vcmVGaWx0ZXJzIH0gPSBwcm9wcztcbiAgY29uc3QgeyB0eXBlLCB0aXRsZSA9ICcnLCBjb2RlLCBpbmRleCwgY2hpbGRyZW4gPSBbXSB9ID0gZmlsdGVyO1xuICBjb25zdCBncm91cGVkRmlsdGVySWQgPSB0aXRsZS5yZXBsYWNlKC9cXHMvZywgJy0nKTtcbiAgcmV0dXJuIChcbiAgICA8ZGl2XG4gICAgICBrZXk9e2NvZGUgfHwgdGl0bGV9XG4gICAgICBpZD17YCR7Z3JvdXBlZEZpbHRlcklkIHx8IGNvZGV9LWNvbnRhaW5lcmB9XG4gICAgICBjc3M9e2Nzc0ZpbHRlckNvbnRhaW5lcn1cbiAgICA+XG4gICAgICB7dHlwZSAhPT0gJ0dST1VQRUQtRklMVEVSUycgJiYgKFxuICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cInNpbmdsZS1maWx0ZXJcIj5cbiAgICAgICAgICB7aXNNb3JlRmlsdGVycyAmJiA8ZGl2IGNsYXNzTmFtZT1cImZpbHRlci10aXRsZVwiPnt0aXRsZX08L2Rpdj59XG4gICAgICAgICAgPEZpbHRlckNvbnRyb2xzXG4gICAgICAgICAgICBmaWx0ZXI9e2ZpbHRlcn1cbiAgICAgICAgICAgIGlzR3JvdXBlZD17ZmFsc2V9XG4gICAgICAgICAgICBpc01vcmVGaWx0ZXJzPXtpc01vcmVGaWx0ZXJzfVxuICAgICAgICAgICAgaXNTaW5nbGVGaWx0ZXI9e2lzU2luZ2xlRmlsdGVyfVxuICAgICAgICAgICAgaGFuZGxlU2VsZWN0ZWRDaGFuZ2U9e3Byb3BzLmhhbmRsZVNlbGVjdGVkQ2hhbmdlKHsgaW5kZXggfSl9XG4gICAgICAgICAgICBoYW5kbGVUb2dnbGVDaGVja2JveD17cHJvcHMuaGFuZGxlVG9nZ2xlQ2hlY2tib3goeyBpbmRleCB9KX1cbiAgICAgICAgICAgIGhhbmRsZVRvZ2dsZVNlbGVjdEFsbENoZWNrYm94PXtwcm9wcy5oYW5kbGVUb2dnbGVTZWxlY3RBbGxDaGVja2JveCh7XG4gICAgICAgICAgICAgIGluZGV4LFxuICAgICAgICAgICAgfSl9XG4gICAgICAgICAgICBoYW5kbGVEYXRlUGlja2VyQ2hhbmdlPXtwcm9wcy5oYW5kbGVEYXRlUGlja2VyQ2hhbmdlKHsgaW5kZXggfSl9XG4gICAgICAgICAgICBoYW5kbGVTZWFyY2hJbnB1dENoYW5nZT17cHJvcHMuaGFuZGxlU2VhcmNoSW5wdXRDaGFuZ2UoeyBpbmRleCB9KX1cbiAgICAgICAgICAvPlxuICAgICAgICA8L2Rpdj5cbiAgICAgICl9XG4gICAgICB7dHlwZSA9PT0gJ0dST1VQRUQtRklMVEVSUycgJiYgKFxuICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cImdyb3VwZWQtZmlsdGVyXCI+XG4gICAgICAgICAge2lzTW9yZUZpbHRlcnMgJiYgPGRpdiBjbGFzc05hbWU9XCJncm91cC1maWx0ZXItdGl0bGVcIj57dGl0bGV9PC9kaXY+fVxuICAgICAgICAgIHtjaGlsZHJlbi5tYXAoKGNoaWxkRmlsdGVyLCBjaGlsZEluZGV4KSA9PiAoXG4gICAgICAgICAgICA8RmlsdGVyQ29udHJvbHNcbiAgICAgICAgICAgICAga2V5PXtjaGlsZEZpbHRlci5jb2RlfVxuICAgICAgICAgICAgICBpc0dyb3VwZWQ9e3RydWV9XG4gICAgICAgICAgICAgIGZpbHRlcj17Y2hpbGRGaWx0ZXJ9XG4gICAgICAgICAgICAgIGlzTW9yZUZpbHRlcnM9e2lzTW9yZUZpbHRlcnN9XG4gICAgICAgICAgICAgIGlzU2luZ2xlRmlsdGVyPXtpc1NpbmdsZUZpbHRlcn1cbiAgICAgICAgICAgICAgaGFuZGxlU2VsZWN0ZWRDaGFuZ2U9e3Byb3BzLmhhbmRsZVNlbGVjdGVkQ2hhbmdlKHtcbiAgICAgICAgICAgICAgICBpbmRleCxcbiAgICAgICAgICAgICAgICBjaGlsZEluZGV4LFxuICAgICAgICAgICAgICAgIGlzR3JvdXBlZDogdHJ1ZSxcbiAgICAgICAgICAgICAgfSl9XG4gICAgICAgICAgICAgIGhhbmRsZVRvZ2dsZUNoZWNrYm94PXtwcm9wcy5oYW5kbGVUb2dnbGVDaGVja2JveCh7XG4gICAgICAgICAgICAgICAgaW5kZXgsXG4gICAgICAgICAgICAgICAgY2hpbGRJbmRleCxcbiAgICAgICAgICAgICAgICBpc0dyb3VwZWQ6IHRydWUsXG4gICAgICAgICAgICAgIH0pfVxuICAgICAgICAgICAgICBoYW5kbGVUb2dnbGVTZWxlY3RBbGxDaGVja2JveD17cHJvcHMuaGFuZGxlVG9nZ2xlU2VsZWN0QWxsQ2hlY2tib3goXG4gICAgICAgICAgICAgICAge1xuICAgICAgICAgICAgICAgICAgaW5kZXgsXG4gICAgICAgICAgICAgICAgICBjaGlsZEluZGV4LFxuICAgICAgICAgICAgICAgICAgaXNHcm91cGVkOiB0cnVlLFxuICAgICAgICAgICAgICAgIH0sXG4gICAgICAgICAgICAgICl9XG4gICAgICAgICAgICAgIGhhbmRsZURhdGVQaWNrZXJDaGFuZ2U9e3Byb3BzLmhhbmRsZURhdGVQaWNrZXJDaGFuZ2Uoe1xuICAgICAgICAgICAgICAgIGluZGV4LFxuICAgICAgICAgICAgICAgIGNoaWxkSW5kZXgsXG4gICAgICAgICAgICAgICAgaXNHcm91cGVkOiB0cnVlLFxuICAgICAgICAgICAgICB9KX1cbiAgICAgICAgICAgICAgaGFuZGxlU2VhcmNoSW5wdXRDaGFuZ2U9e3Byb3BzLmhhbmRsZVNlYXJjaElucHV0Q2hhbmdlKHtcbiAgICAgICAgICAgICAgICBpbmRleCxcbiAgICAgICAgICAgICAgICBjaGlsZEluZGV4LFxuICAgICAgICAgICAgICAgIGlzR3JvdXBlZDogdHJ1ZSxcbiAgICAgICAgICAgICAgfSl9XG4gICAgICAgICAgICAvPlxuICAgICAgICAgICkpfVxuICAgICAgICA8L2Rpdj5cbiAgICAgICl9XG4gICAgPC9kaXY+XG4gICk7XG59O1xuXG5GaWx0ZXJDb250YWluZXIucHJvcFR5cGVzID0ge1xuICBmaWx0ZXI6IHNoYXBlKHtcbiAgICB0eXBlOiBvbmVPZihbLi4uY29udHJvbFR5cGVzLCAnR1JPVVBFRC1GSUxURVJTJ10pLFxuICAgIGNvZGU6IHN0cmluZyxcbiAgICB0aXRsZTogc3RyaW5nLFxuICAgIGVxdWFsU2lnbjogc3RyaW5nLFxuICAgIGRlbGltaXRlclNpZ246IHN0cmluZyxcbiAgICBxdWVyeVN0ckRhdGVGb3JtYXQ6IHN0cmluZyxcbiAgICBjb252ZXJ0Q29kZVRvRGF0ZXM6IGJvb2wsXG4gICAgZGF0ZUZvcm1hdDogc3RyaW5nLFxuICAgIGlucHV0VHlwZTogc3RyaW5nLFxuICAgIHBsYWNlaG9sZGVyOiBzdHJpbmcsXG4gICAgYXJyb3dJY29uVHlwZTogb25lT2YoWydwcmltYXJ5JywgJ3NlY29uZGFyeScsICdzZWFyY2gnXSksXG4gICAgb3B0aW9uczogYXJyYXlPZihcbiAgICAgIHNoYXBlKHsgbGFiZWw6IHN0cmluZywgdmFsdWU6IG9uZU9mVHlwZShbc3RyaW5nLCBudW1iZXJdKSB9KSxcbiAgICApLFxuICB9KSxcblxuICBpc0dyb3VwZWQ6IGJvb2wsXG4gIGlzU2luZ2xlRmlsdGVyOiBib29sLFxuICBpc01vcmVGaWx0ZXJzOiBib29sLFxuXG4gIC8vIGZ1bmNcbiAgaGFuZGxlVG9nZ2xlQ2hlY2tib3g6IGZ1bmMsXG4gIGhhbmRsZVNlbGVjdGVkQ2hhbmdlOiBmdW5jLFxuICBoYW5kbGVEYXRlUGlja2VyQ2hhbmdlOiBmdW5jLFxuICBoYW5kbGVUb2dnbGVTZWxlY3RBbGxDaGVja2JveDogZnVuYyxcbiAgaGFuZGxlU2VhcmNoSW5wdXRDaGFuZ2U6IGZ1bmMsXG59O1xuXG5jb25zdCBpc0ZpbHRlckxlZnRBbGlnbmVkID0gKGZpbHRlciwgaXNUYWJsZXRNb2RlLCBhbGlnbikgPT4ge1xuICBpZiAoaXNUYWJsZXRNb2RlKSB7XG4gICAgaWYgKCd0YWJsZXRBbGlnbicgaW4gZmlsdGVyKSB7XG4gICAgICByZXR1cm4gZmlsdGVyLnRhYmxldEFsaWduID09PSBhbGlnbjtcbiAgICB9IGVsc2Uge1xuICAgICAgcmV0dXJuIGFsaWduID09PSAnbGVmdCcgPyBmaWx0ZXIuaW5kZXggJSAyID09PSAwIDogZmlsdGVyLmluZGV4ICUgMiAhPT0gMDtcbiAgICB9XG4gIH0gZWxzZSB7XG4gICAgaWYgKCdkZXNrdG9wQWxpZ24nIGluIGZpbHRlcikge1xuICAgICAgcmV0dXJuIGZpbHRlci5kZXNrdG9wQWxpZ24gPT09IGFsaWduO1xuICAgIH0gZWxzZSB7XG4gICAgICByZXR1cm4gYWxpZ24gPT09ICdsZWZ0JyA/IGZpbHRlci5pbmRleCAlIDIgPT09IDAgOiBmaWx0ZXIuaW5kZXggJSAyICE9PSAwO1xuICAgIH1cbiAgfVxufTtcblxuY29uc3QgY3NzRmlsdGVyc0NvbnRlbnRTZWN0aW9uID0gY3NzYFxuICAuaW5kaXZpZHVhbC1maWx0ZXJzLm1hcmdpbnMge1xuICAgIG1hcmdpbjogMzBweDtcbiAgICB3aWR0aDogMzAwcHg7XG4gIH1cbiAgLm1vcmUtZmlsdGVycyB7XG4gICAgd2lkdGg6IDcwMHB4O1xuICAgIGRpc3BsYXk6IGdyaWQ7XG4gICAgZ3JpZC1nYXA6IDMwcHg7XG4gICAgZ3JpZC1hdXRvLWZsb3c6IGNvbHVtbjtcbiAgICBncmlkLWF1dG8tY29sdW1uczogMWZyO1xuICAgIHBhZGRpbmc6IDMwcHg7XG5cbiAgICAuY2hlY2tib3gtY29udGVudCB7XG4gICAgICBwYWRkaW5nOiAwcHg7XG4gICAgfVxuXG4gICAgLmxlZnQtc2lkZSB7XG4gICAgICBkaXNwbGF5OiBncmlkO1xuICAgICAgZ3JpZC1nYXA6IDMwcHg7XG4gICAgICBtYXJnaW4tYm90dG9tOiBhdXRvO1xuICAgIH1cbiAgICAucmlnaHQtc2lkZSB7XG4gICAgICBkaXNwbGF5OiBncmlkO1xuICAgICAgZ3JpZC1nYXA6IDMwcHg7XG4gICAgICBtYXJnaW4tYm90dG9tOiBhdXRvO1xuICAgIH1cbiAgfVxuXG4gIEBtZWRpYSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6IDYwMHB4KSB7XG4gICAgLm1vcmUtZmlsdGVycyB7XG4gICAgICB3aWR0aDogMTAwJTtcbiAgICAgIGdyaWQtYXV0by1mbG93OiByb3c7XG4gICAgfVxuICB9XG5gO1xuXG5jb25zdCBvdmVycmlkZVN0eWxlcyA9IGBcbiAgLmZ3Yy1wYW5lbC1jb250YWluZXIgLmZ3Yy1wYW5lbC13cmFwcGVyIHtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIH1cbiAgXG4gIC5md2MtcGFuZWwtY29udGFpbmVyIC5md2MtcGFuZWwtY29udGVudCB7XG4gICAgcGFkZGluZzogMHB4O1xuICAgIG1pbi13aWR0aDogMzAwcHg7XG4gICAgbWF4LXdpZHRoOiA3ODVweDtcbiAgICBtYXgtaGVpZ2h0OiA1MDBweDtcbiAgICBvdmVyZmxvdzogYXV0bztcbiAgfVxuXG4gIC5md2MtcGFuZWwtY29udGFpbmVyIC5oYXMtZGF0ZXBpY2tlciAuZndjLXBhbmVsLWNvbnRlbnQge1xuICAgIHdpZHRoOiA3ODVweDtcbiAgICBoZWlnaHQ6IDUwMHB4O1xuICB9XG5cbiAgLmZ3Yy1wYW5lbC1jb250YWluZXIgLmhhcy1zZWxlY3QgLmZ3Yy1wYW5lbC1jb250ZW50IHtcbiAgICBoZWlnaHQ6IDMwMHB4O1xuICB9XG5cbiAgLmZ3Yy1wYW5lbC1jb250YWluZXIgLmZ3Yy1wYW5lbC13cmFwcGVyLm9wZW4ubW9yZS1maWx0ZXJzIHtcbiAgICBsZWZ0OiAtNDAwcHg7XG4gIH1cbiAgLmZ3Yy1wYW5lbC1jb250YWluZXIgLmZ3Yy1wYW5lbC1mb290ZXIge1xuICAgIGJvcmRlci10b3A6IDFweCBzb2xpZCAjZWVlO1xuICB9XG4gIC5md2MtcGFuZWwtZm9vdGVyIC5md2MtcGFuZWwtYXBwbHktY2FuY2VsLXdyYXBwZXIge1xuICAgIG1hcmdpbi1sZWZ0OiBhdXRvO1xuICB9XG5cbiAgQG1lZGlhIHNjcmVlbiwgKG1pbi13aWR0aDogOTkycHgpIGFuZCAobWluLXdpZHRoOiAxODAwcHgpIHtcbiAgICAuZndjLXBhbmVsLWNvbnRhaW5lciAuZndjLXBhbmVsLXdyYXBwZXIub3Blbi5tb3JlLWZpbHRlcnMge1xuICAgICAgbGVmdDogLTQwMHB4O1xuICAgIH1cbiAgfVxuXG4gIEBtZWRpYSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6IDk5MnB4KSB7XG4gICAgLmZ3Yy1wYW5lbC1jb250YWluZXIgLmZ3Yy1wYW5lbC13cmFwcGVyLm9wZW4ubW9yZS1maWx0ZXJzIHtcbiAgICAgIGxlZnQ6IC0xMDBweDtcbiAgICB9XG4gIH1cblxuICBAbWVkaWEgc2NyZWVuIGFuZCAobWF4LXdpZHRoOiA2MDBweCkge1xuICAgIC5md2MtcGFuZWwtY29udGFpbmVyIC5md2MtcGFuZWwtY29udGVudCB7XG4gICAgICBtYXgtaGVpZ2h0OiAxMDAlO1xuICAgIH1cbiAgICAuZndjLXBhbmVsLWNvbnRhaW5lciAuZndjLXBhbmVsLXdyYXBwZXIub3BlbiB7XG4gICAgICB3aWR0aDogMTAwJTtcbiAgICB9XG5cbiAgICAuZndjLXBhbmVsLWNvbnRhaW5lciAuaGFzLWRhdGVwaWNrZXIgLmZ3Yy1wYW5lbC1jb250ZW50LFxuICAgIC5md2MtcGFuZWwtY29udGFpbmVyIC5oYXMtc2VsZWN0IC5md2MtcGFuZWwtY29udGVudCAge1xuICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICBoZWlnaHQ6IDEwMCU7XG4gICAgfVxuXG4gICAgLmZ3Yy1wYW5lbC1jb250YWluZXIgLmZ3Yy1wYW5lbC13cmFwcGVyLm9wZW4ubW9yZS1maWx0ZXJzIHtcbiAgICAgIGxlZnQ6IDBweDtcbiAgICB9XG4gIH1cbmA7XG5cbmV4cG9ydCBjb25zdCBGaWx0ZXJCdXR0b24gPSBwcm9wcyA9PiB7XG4gIGNvbnN0IHtcbiAgICBmaWx0ZXJzLFxuICAgIGluaXRpYWxGaWx0ZXJzLFxuICAgIGlzTW9yZUZpbHRlcnMsXG4gICAgaGlkZUNhbmNlbENvbnRyb2wgPSBmYWxzZSxcbiAgICBzaG93UmVzZXRDb250cm9sID0gZmFsc2UsXG4gICAgaXNUYWJsZXRNb2RlLFxuICAgIG9uQXBwbHlGaWx0ZXJzLFxuICB9ID0gcHJvcHM7XG4gIGNvbnN0IGZpbHRlckJ1dHRvbkN1c3RvbVN0eWxlID0gdXNlUmVmKGRvY3VtZW50LmNyZWF0ZUVsZW1lbnQoJ3N0eWxlJykpO1xuICBjb25zdCBmaWx0ZXJSZWYgPSB1c2VSZWYoKTtcbiAgY29uc3QgW3Nob3csIHNldFNob3ddID0gdXNlU3RhdGUoZmFsc2UpO1xuICBjb25zdCBbX2ZpbHRlcnMsIHNldEZpbHRlcnNdID0gdXNlU3RhdGUoWy4uLmZpbHRlcnNdKTtcblxuICB1c2VFZmZlY3QoKCkgPT4ge1xuICAgIGlmIChmaWx0ZXJSZWYuY3VycmVudCkge1xuICAgICAgY29uc3QgZmlsdGVyU2hhZG93RE9NID0gZmlsdGVyUmVmLmN1cnJlbnQuc2hhZG93Um9vdDtcbiAgICAgIGZpbHRlckJ1dHRvbkN1c3RvbVN0eWxlLmN1cnJlbnQuaW5uZXJIVE1MID0gb3ZlcnJpZGVTdHlsZXM7XG4gICAgICBzZXRUaW1lb3V0KCgpID0+IHtcbiAgICAgICAgZmlsdGVyU2hhZG93RE9NLmFwcGVuZENoaWxkKGZpbHRlckJ1dHRvbkN1c3RvbVN0eWxlLmN1cnJlbnQpO1xuICAgICAgfSwgMCk7XG4gICAgfVxuICB9LCBbXSk7XG5cbiAgdXNlRWZmZWN0KCgpID0+IHtcbiAgICBzZXRGaWx0ZXJzKGZpbHRlcnMpO1xuICB9LCBbZmlsdGVyc10pO1xuXG4gIHVzZUVmZmVjdCgoKSA9PiB7XG4gICAgY29uc3Qgbm9kZSA9IGZpbHRlclJlZi5jdXJyZW50LnJlbmRlclJvb3Q/LmdldEVsZW1lbnRCeUlkKCdQYW5lbCcpO1xuICAgIGlmIChpc01vcmVGaWx0ZXJzKSB7XG4gICAgICBub2RlPy5jbGFzc0xpc3Q/LmFkZCgnbW9yZS1maWx0ZXJzJyk7XG4gICAgfSBlbHNlIHtcbiAgICAgIG5vZGU/LmNsYXNzTGlzdD8ucmVtb3ZlKCdtb3JlLWZpbHRlcnMnKTtcbiAgICB9XG4gICAgaWYgKGhhc0RhdGVQaWNrZXIpIHtcbiAgICAgIG5vZGU/LmNsYXNzTGlzdD8uYWRkKCdoYXMtZGF0ZXBpY2tlcicpO1xuICAgIH0gZWxzZSB7XG4gICAgICBub2RlPy5jbGFzc0xpc3Q/LnJlbW92ZSgnaGFzLWRhdGVwaWNrZXInKTtcbiAgICB9XG5cbiAgICBpZiAoaGFzU2VsZWN0KSB7XG4gICAgICBub2RlPy5jbGFzc0xpc3Q/LmFkZCgnaGFzLXNlbGVjdCcpO1xuICAgIH0gZWxzZSB7XG4gICAgICBub2RlPy5jbGFzc0xpc3Q/LnJlbW92ZSgnaGFzLXNlbGVjdCcpO1xuICAgIH1cbiAgfSk7XG5cbiAgY29uc3QgaGFuZGxlT25Ub2dnbGVTaG93ID0gdXNlQ2FsbGJhY2soZSA9PiB7XG4gICAgZS5wcmV2ZW50RGVmYXVsdCgpO1xuICAgIHNldFNob3cob2xkID0+ICFvbGQpO1xuICB9LCBbXSk7XG5cbiAgY29uc3QgdXBkYXRlRmlsdGVyID0gdXNlQ2FsbGJhY2soXG4gICAgKG5ld0ZpbHRlclJlY29yZCwgaW5kZXgsIGNoaWxkSW5kZXggPSBudWxsKSA9PiB7XG4gICAgICBpZiAodHlwZW9mIGNoaWxkSW5kZXggPT09ICdudW1iZXInKSB7XG4gICAgICAgIHNldEZpbHRlcnMob2xkID0+XG4gICAgICAgICAgb2xkLm1hcCgoZmlsdGVyLCBpZHgpID0+XG4gICAgICAgICAgICBpZHggPT09IGluZGV4XG4gICAgICAgICAgICAgID8ge1xuICAgICAgICAgICAgICAgICAgLi4uZmlsdGVyLFxuICAgICAgICAgICAgICAgICAgY2hpbGRyZW46IGZpbHRlci5jaGlsZHJlbi5tYXAoKGNoaWxkRmlsdGVyLCBjaGlsZElkeCkgPT5cbiAgICAgICAgICAgICAgICAgICAgY2hpbGRJZHggPT09IGNoaWxkSW5kZXggPyBuZXdGaWx0ZXJSZWNvcmQgOiBjaGlsZEZpbHRlcixcbiAgICAgICAgICAgICAgICAgICksXG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICA6IGZpbHRlcixcbiAgICAgICAgICApLFxuICAgICAgICApO1xuICAgICAgfSBlbHNlIHtcbiAgICAgICAgc2V0RmlsdGVycyhvbGQgPT5cbiAgICAgICAgICBvbGQubWFwKChmaWx0ZXIsIGlkeCkgPT4gKGlkeCA9PT0gaW5kZXggPyBuZXdGaWx0ZXJSZWNvcmQgOiBmaWx0ZXIpKSxcbiAgICAgICAgKTtcbiAgICAgIH1cbiAgICB9LFxuICAgIFtdLFxuICApO1xuXG4gIGNvbnN0IGhhbmRsZVRvZ2dsZVNlbGVjdEFsbENoZWNrYm94ID0gdXNlQ2FsbGJhY2soXG4gICAgY29uZmlnUHJvcHMgPT4ge1xuICAgICAgY29uc3QgeyBpbmRleCwgaXNHcm91cGVkID0gZmFsc2UsIGNoaWxkSW5kZXggPSBudWxsIH0gPSBjb25maWdQcm9wcztcbiAgICAgIHJldHVybiBpc0FsbFNlbGVjdGVkID0+IHtcbiAgICAgICAgY29uc3QgZmlsdGVyUmVjb3JkID0gaXNHcm91cGVkXG4gICAgICAgICAgPyBfZmlsdGVyc1tpbmRleF0uY2hpbGRyZW5bY2hpbGRJbmRleF1cbiAgICAgICAgICA6IF9maWx0ZXJzW2luZGV4XTtcbiAgICAgICAgY29uc3QgdXBkYXRlZEZpbHRlclJlY29yZCA9IHtcbiAgICAgICAgICAuLi5maWx0ZXJSZWNvcmQsXG4gICAgICAgICAgb3B0aW9uczogZmlsdGVyUmVjb3JkLm9wdGlvbnMubWFwKG9wdGlvbiA9PiAoe1xuICAgICAgICAgICAgLi4ub3B0aW9uLFxuICAgICAgICAgICAgc2VsZWN0ZWQ6ICFpc0FsbFNlbGVjdGVkLFxuICAgICAgICAgIH0pKSxcbiAgICAgICAgfTtcbiAgICAgICAgaWYgKGlzR3JvdXBlZCkge1xuICAgICAgICAgIHVwZGF0ZUZpbHRlcih1cGRhdGVkRmlsdGVyUmVjb3JkLCBpbmRleCwgY2hpbGRJbmRleCk7XG4gICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgdXBkYXRlRmlsdGVyKHVwZGF0ZWRGaWx0ZXJSZWNvcmQsIGluZGV4KTtcbiAgICAgICAgfVxuICAgICAgfTtcbiAgICB9LFxuICAgIFtfZmlsdGVycywgdXBkYXRlRmlsdGVyXSxcbiAgKTtcblxuICBjb25zdCBoYW5kbGVUb2dnbGVDaGVja2JveCA9IHVzZUNhbGxiYWNrKFxuICAgIGNvbmZpZ1Byb3BzID0+IHtcbiAgICAgIGNvbnN0IHsgaW5kZXgsIGlzR3JvdXBlZCA9IGZhbHNlLCBjaGlsZEluZGV4ID0gbnVsbCB9ID0gY29uZmlnUHJvcHM7XG4gICAgICByZXR1cm4gKHNlbGVjdGVkT3B0aW9uLCBpc1NlbGVjdGVkKSA9PiB7XG4gICAgICAgIGNvbnN0IGZpbHRlclJlY29yZCA9IGlzR3JvdXBlZFxuICAgICAgICAgID8gX2ZpbHRlcnNbaW5kZXhdLmNoaWxkcmVuW2NoaWxkSW5kZXhdXG4gICAgICAgICAgOiBfZmlsdGVyc1tpbmRleF07XG4gICAgICAgIGNvbnN0IHVwZGF0ZWRGaWx0ZXJSZWNvcmQgPSB7XG4gICAgICAgICAgLi4uZmlsdGVyUmVjb3JkLFxuICAgICAgICAgIG9wdGlvbnM6IGZpbHRlclJlY29yZC5vcHRpb25zLm1hcChvcHRpb24gPT4gKHtcbiAgICAgICAgICAgIC4uLm9wdGlvbixcbiAgICAgICAgICAgIHNlbGVjdGVkOlxuICAgICAgICAgICAgICBzZWxlY3RlZE9wdGlvbi52YWx1ZSA9PT0gb3B0aW9uLnZhbHVlXG4gICAgICAgICAgICAgICAgPyAhaXNTZWxlY3RlZFxuICAgICAgICAgICAgICAgIDogb3B0aW9uLnNlbGVjdGVkIHx8IGZhbHNlLFxuICAgICAgICAgIH0pKSxcbiAgICAgICAgfTtcbiAgICAgICAgaWYgKGlzR3JvdXBlZCkge1xuICAgICAgICAgIHVwZGF0ZUZpbHRlcih1cGRhdGVkRmlsdGVyUmVjb3JkLCBpbmRleCwgY2hpbGRJbmRleCk7XG4gICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgdXBkYXRlRmlsdGVyKHVwZGF0ZWRGaWx0ZXJSZWNvcmQsIGluZGV4KTtcbiAgICAgICAgfVxuICAgICAgfTtcbiAgICB9LFxuICAgIFtfZmlsdGVycywgdXBkYXRlRmlsdGVyXSxcbiAgKTtcblxuICBjb25zdCBoYW5kbGVTZWxlY3RlZENoYW5nZSA9IHVzZUNhbGxiYWNrKFxuICAgIGNvbmZpZ1Byb3BzID0+IHtcbiAgICAgIGNvbnN0IHsgaW5kZXgsIGlzR3JvdXBlZCA9IGZhbHNlLCBjaGlsZEluZGV4ID0gbnVsbCB9ID0gY29uZmlnUHJvcHM7XG4gICAgICByZXR1cm4gc2VsZWN0ZWQgPT4ge1xuICAgICAgICBjb25zdCBmaWx0ZXJSZWNvcmQgPSBpc0dyb3VwZWRcbiAgICAgICAgICA/IF9maWx0ZXJzW2luZGV4XS5jaGlsZHJlbltjaGlsZEluZGV4XVxuICAgICAgICAgIDogX2ZpbHRlcnNbaW5kZXhdO1xuICAgICAgICBjb25zdCB1cGRhdGVkRmlsdGVyUmVjb3JkID0geyAuLi5maWx0ZXJSZWNvcmQsIHNlbGVjdGVkIH07XG4gICAgICAgIGlmIChpc0dyb3VwZWQpIHtcbiAgICAgICAgICB1cGRhdGVGaWx0ZXIodXBkYXRlZEZpbHRlclJlY29yZCwgaW5kZXgsIGNoaWxkSW5kZXgpO1xuICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgIHVwZGF0ZUZpbHRlcih1cGRhdGVkRmlsdGVyUmVjb3JkLCBpbmRleCk7XG4gICAgICAgIH1cbiAgICAgIH07XG4gICAgfSxcbiAgICBbX2ZpbHRlcnMsIHVwZGF0ZUZpbHRlcl0sXG4gICk7XG5cbiAgY29uc3QgaGFuZGxlRGF0ZVBpY2tlckNoYW5nZSA9IHVzZUNhbGxiYWNrKFxuICAgIGNvbmZpZ1Byb3BzID0+IHtcbiAgICAgIGNvbnN0IHsgaW5kZXgsIGlzR3JvdXBlZCA9IGZhbHNlLCBjaGlsZEluZGV4ID0gbnVsbCB9ID0gY29uZmlnUHJvcHM7XG4gICAgICByZXR1cm4gKHNlbGVjdGVkRGF0ZSwgZGF0ZVBpY2tlclR5cGUpID0+IHtcbiAgICAgICAgY29uc3QgZmlsdGVyUmVjb3JkID0gaXNHcm91cGVkXG4gICAgICAgICAgPyBfZmlsdGVyc1tpbmRleF0uY2hpbGRyZW5bY2hpbGRJbmRleF1cbiAgICAgICAgICA6IF9maWx0ZXJzW2luZGV4XTtcbiAgICAgICAgY29uc3QgdXBkYXRlZEZpbHRlclJlY29yZCA9IHtcbiAgICAgICAgICAuLi5maWx0ZXJSZWNvcmQsXG4gICAgICAgICAgc2VsZWN0ZWQ6IHtcbiAgICAgICAgICAgIC4uLmZpbHRlclJlY29yZC5zZWxlY3RlZCxcbiAgICAgICAgICAgIFtkYXRlUGlja2VyVHlwZV06IHNlbGVjdGVkRGF0ZSxcbiAgICAgICAgICB9LFxuICAgICAgICB9O1xuICAgICAgICBpZiAoaXNHcm91cGVkKSB7XG4gICAgICAgICAgdXBkYXRlRmlsdGVyKHVwZGF0ZWRGaWx0ZXJSZWNvcmQsIGluZGV4LCBjaGlsZEluZGV4KTtcbiAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICB1cGRhdGVGaWx0ZXIodXBkYXRlZEZpbHRlclJlY29yZCwgaW5kZXgpO1xuICAgICAgICB9XG4gICAgICB9O1xuICAgIH0sXG4gICAgW19maWx0ZXJzLCB1cGRhdGVGaWx0ZXJdLFxuICApO1xuXG4gIGNvbnN0IGhhbmRsZVNlYXJjaElucHV0Q2hhbmdlID0gdXNlQ2FsbGJhY2soXG4gICAgY29uZmlnUHJvcHMgPT4ge1xuICAgICAgY29uc3QgeyBpbmRleCwgaXNHcm91cGVkID0gZmFsc2UsIGNoaWxkSW5kZXggPSBudWxsIH0gPSBjb25maWdQcm9wcztcbiAgICAgIHJldHVybiAoc2VhcmNoVGV4dCwgcHJvbWlzZUNhbGxiYWNrKSA9PiB7XG4gICAgICAgIGNvbnN0IHVwZGF0ZUxvYWRpbmdBbmRPcHRpb25zID0gKGlzTG9hZGluZywgb3B0aW9ucykgPT4ge1xuICAgICAgICAgIGNvbnN0IGZpbHRlclJlY29yZCA9IGlzR3JvdXBlZFxuICAgICAgICAgICAgPyBfZmlsdGVyc1tpbmRleF0uY2hpbGRyZW5bY2hpbGRJbmRleF1cbiAgICAgICAgICAgIDogX2ZpbHRlcnNbaW5kZXhdO1xuICAgICAgICAgIGNvbnN0IHVwZGF0ZWRGaWx0ZXJSZWNvcmQgPSB7IC4uLmZpbHRlclJlY29yZCwgaXNMb2FkaW5nLCBvcHRpb25zIH07XG4gICAgICAgICAgaWYgKGlzR3JvdXBlZCkge1xuICAgICAgICAgICAgdXBkYXRlRmlsdGVyKHVwZGF0ZWRGaWx0ZXJSZWNvcmQsIGluZGV4LCBjaGlsZEluZGV4KTtcbiAgICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgICAgdXBkYXRlRmlsdGVyKHVwZGF0ZWRGaWx0ZXJSZWNvcmQsIGluZGV4KTtcbiAgICAgICAgICB9XG4gICAgICAgIH07XG5cbiAgICAgICAgaWYgKHNlYXJjaFRleHQubGVuZ3RoID4gMikge1xuICAgICAgICAgIHVwZGF0ZUxvYWRpbmdBbmRPcHRpb25zKHRydWUsIFtdKTtcbiAgICAgICAgICAvLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgcHJvbWlzZS9jYXRjaC1vci1yZXR1cm5cbiAgICAgICAgICBwcm9taXNlQ2FsbGJhY2soc2VhcmNoVGV4dCkudGhlbihyZXMgPT4ge1xuICAgICAgICAgICAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIHByb21pc2UvYWx3YXlzLXJldHVyblxuICAgICAgICAgICAgaWYgKHJlcyAmJiBBcnJheS5pc0FycmF5KHJlcykpIHtcbiAgICAgICAgICAgICAgdXBkYXRlTG9hZGluZ0FuZE9wdGlvbnMoZmFsc2UsIHJlcyk7XG4gICAgICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgICAgICAvLyBJZiBhbnkgZXJyb3Igb2NjdXJzIHRoZW4gcmVzIGNvbWVzIGFzIHVuZGVmaW5lZFxuICAgICAgICAgICAgICB1cGRhdGVMb2FkaW5nQW5kT3B0aW9ucyhmYWxzZSwgW10pO1xuICAgICAgICAgICAgfVxuICAgICAgICAgIH0pO1xuICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgIC8vIHVwZGF0ZUxvYWRpbmdBbmRPcHRpb25zKGZhbHNlLCBbXSk7XG4gICAgICAgIH1cbiAgICAgIH07XG4gICAgfSxcbiAgICBbX2ZpbHRlcnMsIHVwZGF0ZUZpbHRlcl0sXG4gICk7XG5cbiAgY29uc3QgaGFuZGxlT25DYW5jZWwgPSB1c2VDYWxsYmFjaygoKSA9PiB7XG4gICAgc2V0RmlsdGVycyhmaWx0ZXJzKTtcbiAgfSwgW2ZpbHRlcnNdKTtcblxuICBjb25zdCBoYW5kbGVPbkFwcGx5ID0gdXNlQ2FsbGJhY2soKCkgPT4ge1xuICAgIG9uQXBwbHlGaWx0ZXJzKF9maWx0ZXJzKTtcbiAgfSwgW19maWx0ZXJzLCBvbkFwcGx5RmlsdGVyc10pO1xuXG4gIGNvbnN0IGhhbmRsZU9uUmVzZXQgPSB1c2VDYWxsYmFjaygoKSA9PiB7XG4gICAgc2V0RmlsdGVycyhpbml0aWFsRmlsdGVycyk7XG4gICAgb25BcHBseUZpbHRlcnMoaW5pdGlhbEZpbHRlcnMpO1xuICB9LCBbaW5pdGlhbEZpbHRlcnMsIG9uQXBwbHlGaWx0ZXJzXSk7XG5cbiAgY29uc3QgZmlsdGVyQnV0dG9uSW5mbyA9IHVzZU1lbW8oXG4gICAgKCkgPT4gZ2V0RmlsdGVyc1RpdGxlQW5kVHlwZShmaWx0ZXJzKSxcbiAgICBbZmlsdGVyc10sXG4gICk7XG5cbiAgY29uc3QgaXNTaW5nbGVGaWx0ZXIgPSBfZmlsdGVycy5sZW5ndGggPT09IDE7XG5cbiAgY29uc3QgZGlzcGxheUZpbHRlcnMgPSB1c2VNZW1vKFxuICAgICgpID0+IF9maWx0ZXJzLm1hcCgoZmlsdGVyLCBpbmRleCkgPT4gKHsgLi4uZmlsdGVyLCBpbmRleCB9KSksXG4gICAgW19maWx0ZXJzXSxcbiAgKTtcblxuICBjb25zdCBoYXNEYXRlUGlja2VyID0gdXNlTWVtbyhcbiAgICAoKSA9PlxuICAgICAgX2ZpbHRlcnMuc29tZShmaWx0ZXIgPT4ge1xuICAgICAgICByZXR1cm4gKFxuICAgICAgICAgIGZpbHRlci5zZWxlY3RlZD8udmFsdWUgPT09ICdDVVNUT00tREFURS1SQU5HRScgfHxcbiAgICAgICAgICBmaWx0ZXIudHlwZSA9PT0gJ0RBVEUtUkFOR0UnIHx8XG4gICAgICAgICAgZmlsdGVyLmNoaWxkcmVuPy5zb21lKFxuICAgICAgICAgICAgY2hpbGRGaWx0ZXIgPT5cbiAgICAgICAgICAgICAgY2hpbGRGaWx0ZXIuc2VsZWN0ZWQ/LnZhbHVlID09PSAnQ1VTVE9NLURBVEUtUkFOR0UnIHx8XG4gICAgICAgICAgICAgIGNoaWxkRmlsdGVyLnR5cGUgPT09ICdEQVRFLVJBTkdFJyxcbiAgICAgICAgICApXG4gICAgICAgICk7XG4gICAgICB9KSxcbiAgICBbX2ZpbHRlcnNdLFxuICApO1xuXG4gIGNvbnN0IGhhc1NlbGVjdCA9IHVzZU1lbW8oXG4gICAgKCkgPT5cbiAgICAgIF9maWx0ZXJzLnNvbWUoZmlsdGVyID0+IHtcbiAgICAgICAgcmV0dXJuIChcbiAgICAgICAgICBmaWx0ZXIudHlwZSA9PT0gJ1NFTEVDVC1BVVRPQ09NUExFVEUnIHx8XG4gICAgICAgICAgZmlsdGVyLnR5cGUgPT09ICdNVUxUSS1TRUxFQ1QnIHx8XG4gICAgICAgICAgZmlsdGVyLnR5cGUgPT09ICdNVUxUSS1TRUxFQ1QtQVVUT0NPTVBMRVRFJ1xuICAgICAgICApO1xuICAgICAgfSksXG4gICAgW19maWx0ZXJzXSxcbiAgKTtcblxuICByZXR1cm4gKFxuICAgIDw+XG4gICAgICB7LyogPHA+e0pTT04uc3RyaW5naWZ5KHNob3cpfTwvcD4gKi99XG4gICAgICA8RmlsdGVyUGFuZWxcbiAgICAgICAgY2xhc3NOYW1lPXtgZmlsdGVyLWJ1dHRvbi1wYW5lbCAke2lzTW9yZUZpbHRlcnMgPyAnbW9yZS1maWx0ZXJzJyA6ICcnfWB9XG4gICAgICAgIHJlZj17ZmlsdGVyUmVmfVxuICAgICAgICBvcGVuPXtzaG93fVxuICAgICAgICBvblRvZ2dsZT17aGFuZGxlT25Ub2dnbGVTaG93fVxuICAgICAgICBvbkFwcGx5PXtoYW5kbGVPbkFwcGx5fVxuICAgICAgICBvbkNhbmNlbD17aGFuZGxlT25DYW5jZWx9XG4gICAgICAgIG9uUmVzZXQ9e2hhbmRsZU9uUmVzZXR9XG4gICAgICAgIGhpZGVSZXNldEJ1dHRvbj17IXNob3dSZXNldENvbnRyb2x9XG4gICAgICAgIGhpZGVDYW5jZWxCdXR0b249e2hpZGVDYW5jZWxDb250cm9sfVxuICAgICAgICBsYWJlbEFwcGx5QnV0dG9uPVwiQXBwbHlcIlxuICAgICAgICBsYWJlbENhbmNlbEJ1dHRvbj1cIkNhbmNlbFwiXG4gICAgICAgIGxhYmVsUmVzZXRCdXR0b249XCJSZXNldCBGaWx0ZXJcIlxuICAgICAgPlxuICAgICAgICA8RmlsdGVyUGFuZWwuQWN0aW9uPlxuICAgICAgICAgIDxCdXR0b25cbiAgICAgICAgICAgIGNsYXNzTmFtZT17YGZpbHRlci1idXR0b24gJHtzaG93ID8gJ2FjdGl2ZScgOiAnJ31gfVxuICAgICAgICAgICAgYnRuVHlwZT17ZmlsdGVyQnV0dG9uSW5mby50eXBlIHx8ICdzZWNvbmRhcnknfVxuICAgICAgICAgICAgb25DbGljaz17aGFuZGxlT25Ub2dnbGVTaG93fVxuICAgICAgICAgICAgc21hbGxcbiAgICAgICAgICA+XG4gICAgICAgICAgICB7ZmlsdGVyQnV0dG9uSW5mby50aXRsZX1cbiAgICAgICAgICA8L0J1dHRvbj5cbiAgICAgICAgPC9GaWx0ZXJQYW5lbC5BY3Rpb24+XG4gICAgICAgIDxGaWx0ZXJQYW5lbC5Db250ZW50PlxuICAgICAgICAgIDxkaXZcbiAgICAgICAgICAgIGNsYXNzTmFtZT1cImZpbHRlcnMtY29udGVudC1zZWN0aW9uXCJcbiAgICAgICAgICAgIGNzcz17Y3NzRmlsdGVyc0NvbnRlbnRTZWN0aW9ufVxuICAgICAgICAgID5cbiAgICAgICAgICAgIHtpc1NpbmdsZUZpbHRlciAmJlxuICAgICAgICAgICAgICBkaXNwbGF5RmlsdGVycy5tYXAoZmlsdGVyID0+IChcbiAgICAgICAgICAgICAgICA8ZGl2XG4gICAgICAgICAgICAgICAgICBrZXk9e2ZpbHRlci5jb2RlIHx8IGZpbHRlci50aXRsZX1cbiAgICAgICAgICAgICAgICAgIGNsYXNzTmFtZT17YGluZGl2aWR1YWwtZmlsdGVycyAke1xuICAgICAgICAgICAgICAgICAgICBbJ0NIRUNLQk9YJywgJ1NFTEVDVCcsICdSQURJTyddLmluY2x1ZGVzKGZpbHRlci50eXBlKVxuICAgICAgICAgICAgICAgICAgICAgID8gJydcbiAgICAgICAgICAgICAgICAgICAgICA6ICdtYXJnaW5zJ1xuICAgICAgICAgICAgICAgICAgfWB9XG4gICAgICAgICAgICAgICAgPlxuICAgICAgICAgICAgICAgICAgPEZpbHRlckNvbnRhaW5lclxuICAgICAgICAgICAgICAgICAgICBmaWx0ZXI9e2ZpbHRlcn1cbiAgICAgICAgICAgICAgICAgICAgaXNNb3JlRmlsdGVycz17aXNNb3JlRmlsdGVyc31cbiAgICAgICAgICAgICAgICAgICAgaXNTaW5nbGVGaWx0ZXI9e2lzU2luZ2xlRmlsdGVyfVxuICAgICAgICAgICAgICAgICAgICBoYW5kbGVTZWxlY3RlZENoYW5nZT17aGFuZGxlU2VsZWN0ZWRDaGFuZ2V9XG4gICAgICAgICAgICAgICAgICAgIGhhbmRsZVRvZ2dsZUNoZWNrYm94PXtoYW5kbGVUb2dnbGVDaGVja2JveH1cbiAgICAgICAgICAgICAgICAgICAgaGFuZGxlVG9nZ2xlU2VsZWN0QWxsQ2hlY2tib3g9e1xuICAgICAgICAgICAgICAgICAgICAgIGhhbmRsZVRvZ2dsZVNlbGVjdEFsbENoZWNrYm94XG4gICAgICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICAgICAgaGFuZGxlRGF0ZVBpY2tlckNoYW5nZT17aGFuZGxlRGF0ZVBpY2tlckNoYW5nZX1cbiAgICAgICAgICAgICAgICAgICAgaGFuZGxlU2VhcmNoSW5wdXRDaGFuZ2U9e2hhbmRsZVNlYXJjaElucHV0Q2hhbmdlfVxuICAgICAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAgKSl9XG5cbiAgICAgICAgICAgIHtpc01vcmVGaWx0ZXJzICYmIChcbiAgICAgICAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJtb3JlLWZpbHRlcnNcIj5cbiAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cImxlZnQtc2lkZVwiPlxuICAgICAgICAgICAgICAgICAge2Rpc3BsYXlGaWx0ZXJzXG4gICAgICAgICAgICAgICAgICAgIC5maWx0ZXIocmVjb3JkID0+XG4gICAgICAgICAgICAgICAgICAgICAgaXNGaWx0ZXJMZWZ0QWxpZ25lZChyZWNvcmQsIGlzVGFibGV0TW9kZSwgJ2xlZnQnKSxcbiAgICAgICAgICAgICAgICAgICAgKVxuICAgICAgICAgICAgICAgICAgICAubWFwKGZpbHRlciA9PiAoXG4gICAgICAgICAgICAgICAgICAgICAgPEZpbHRlckNvbnRhaW5lclxuICAgICAgICAgICAgICAgICAgICAgICAga2V5PXtmaWx0ZXIuY29kZSB8fCBmaWx0ZXIudGl0bGV9XG4gICAgICAgICAgICAgICAgICAgICAgICBmaWx0ZXI9e2ZpbHRlcn1cbiAgICAgICAgICAgICAgICAgICAgICAgIGlzTW9yZUZpbHRlcnM9e2lzTW9yZUZpbHRlcnN9XG4gICAgICAgICAgICAgICAgICAgICAgICBpc1NpbmdsZUZpbHRlcj17aXNTaW5nbGVGaWx0ZXJ9XG4gICAgICAgICAgICAgICAgICAgICAgICBoYW5kbGVTZWxlY3RlZENoYW5nZT17aGFuZGxlU2VsZWN0ZWRDaGFuZ2V9XG4gICAgICAgICAgICAgICAgICAgICAgICBoYW5kbGVUb2dnbGVDaGVja2JveD17aGFuZGxlVG9nZ2xlQ2hlY2tib3h9XG4gICAgICAgICAgICAgICAgICAgICAgICBoYW5kbGVUb2dnbGVTZWxlY3RBbGxDaGVja2JveD17XG4gICAgICAgICAgICAgICAgICAgICAgICAgIGhhbmRsZVRvZ2dsZVNlbGVjdEFsbENoZWNrYm94XG4gICAgICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgICAgICAgICBoYW5kbGVEYXRlUGlja2VyQ2hhbmdlPXtoYW5kbGVEYXRlUGlja2VyQ2hhbmdlfVxuICAgICAgICAgICAgICAgICAgICAgICAgaGFuZGxlU2VhcmNoSW5wdXRDaGFuZ2U9e2hhbmRsZVNlYXJjaElucHV0Q2hhbmdlfVxuICAgICAgICAgICAgICAgICAgICAgIC8+XG4gICAgICAgICAgICAgICAgICAgICkpfVxuICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwicmlnaHQtc2lkZVwiPlxuICAgICAgICAgICAgICAgICAge2Rpc3BsYXlGaWx0ZXJzXG4gICAgICAgICAgICAgICAgICAgIC5maWx0ZXIocmVjb3JkID0+XG4gICAgICAgICAgICAgICAgICAgICAgaXNGaWx0ZXJMZWZ0QWxpZ25lZChyZWNvcmQsIGlzVGFibGV0TW9kZSwgJ3JpZ2h0JyksXG4gICAgICAgICAgICAgICAgICAgIClcbiAgICAgICAgICAgICAgICAgICAgLm1hcChmaWx0ZXIgPT4gKFxuICAgICAgICAgICAgICAgICAgICAgIDxGaWx0ZXJDb250YWluZXJcbiAgICAgICAgICAgICAgICAgICAgICAgIGtleT17ZmlsdGVyLmNvZGUgfHwgZmlsdGVyLnRpdGxlfVxuICAgICAgICAgICAgICAgICAgICAgICAgZmlsdGVyPXtmaWx0ZXJ9XG4gICAgICAgICAgICAgICAgICAgICAgICBpc01vcmVGaWx0ZXJzPXtpc01vcmVGaWx0ZXJzfVxuICAgICAgICAgICAgICAgICAgICAgICAgaXNTaW5nbGVGaWx0ZXI9e2lzU2luZ2xlRmlsdGVyfVxuICAgICAgICAgICAgICAgICAgICAgICAgaGFuZGxlU2VsZWN0ZWRDaGFuZ2U9e2hhbmRsZVNlbGVjdGVkQ2hhbmdlfVxuICAgICAgICAgICAgICAgICAgICAgICAgaGFuZGxlVG9nZ2xlQ2hlY2tib3g9e2hhbmRsZVRvZ2dsZUNoZWNrYm94fVxuICAgICAgICAgICAgICAgICAgICAgICAgaGFuZGxlVG9nZ2xlU2VsZWN0QWxsQ2hlY2tib3g9e1xuICAgICAgICAgICAgICAgICAgICAgICAgICBoYW5kbGVUb2dnbGVTZWxlY3RBbGxDaGVja2JveFxuICAgICAgICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgICAgICAgICAgaGFuZGxlRGF0ZVBpY2tlckNoYW5nZT17aGFuZGxlRGF0ZVBpY2tlckNoYW5nZX1cbiAgICAgICAgICAgICAgICAgICAgICAgIGhhbmRsZVNlYXJjaElucHV0Q2hhbmdlPXtoYW5kbGVTZWFyY2hJbnB1dENoYW5nZX1cbiAgICAgICAgICAgICAgICAgICAgICAvPlxuICAgICAgICAgICAgICAgICAgICApKX1cbiAgICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICApfVxuICAgICAgICAgIDwvZGl2PlxuICAgICAgICA8L0ZpbHRlclBhbmVsLkNvbnRlbnQ+XG4gICAgICA8L0ZpbHRlclBhbmVsPlxuICAgIDwvPlxuICApO1xufTtcblxuRmlsdGVyQnV0dG9uLnByb3BUeXBlcyA9IHtcbiAgc2hvd1Jlc2V0Q29udHJvbDogYm9vbCxcbiAgaGlkZUNhbmNlbENvbnRyb2w6IGJvb2wsXG4gIGluaXRpYWxGaWx0ZXJzOiBhcnJheSxcbiAgaXNNb3JlRmlsdGVyczogYm9vbCxcbiAgZmlsdGVyczogYXJyYXksXG4gIGlzVGFibGV0TW9kZTogYm9vbCxcbiAgb25BcHBseUZpbHRlcnM6IGZ1bmMsXG4gIG9uUmVzZXRGaWx0ZXJzOiBmdW5jLFxufTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
};
var overrideStyles$2 = "\n  .fwc-panel-container .fwc-panel-wrapper {\n    position: absolute;\n  }\n  \n  .fwc-panel-container .fwc-panel-content {\n    padding: 0px;\n    min-width: 300px;\n    max-width: 785px;\n    max-height: 500px;\n    overflow: auto;\n  }\n\n  .fwc-panel-container .has-datepicker .fwc-panel-content {\n    width: 785px;\n    height: 500px;\n  }\n\n  .fwc-panel-container .has-select .fwc-panel-content {\n    height: 300px;\n  }\n\n  .fwc-panel-container .fwc-panel-wrapper.open.more-filters {\n    left: -400px;\n  }\n  .fwc-panel-container .fwc-panel-footer {\n    border-top: 1px solid #eee;\n  }\n  .fwc-panel-footer .fwc-panel-apply-cancel-wrapper {\n    margin-left: auto;\n  }\n\n  @media screen, (min-width: 992px) and (min-width: 1800px) {\n    .fwc-panel-container .fwc-panel-wrapper.open.more-filters {\n      left: -400px;\n    }\n  }\n\n  @media screen and (max-width: 992px) {\n    .fwc-panel-container .fwc-panel-wrapper.open.more-filters {\n      left: -100px;\n    }\n  }\n\n  @media screen and (max-width: 600px) {\n    .fwc-panel-container .fwc-panel-content {\n      max-height: 100%;\n    }\n    .fwc-panel-container .fwc-panel-wrapper.open {\n      width: 100%;\n    }\n\n    .fwc-panel-container .has-datepicker .fwc-panel-content,\n    .fwc-panel-container .has-select .fwc-panel-content  {\n      width: 100%;\n      height: 100%;\n    }\n\n    .fwc-panel-container .fwc-panel-wrapper.open.more-filters {\n      left: 0px;\n    }\n  }\n";
var FilterButton = function FilterButton(props) {
  var filters = props.filters,
    initialFilters = props.initialFilters,
    isMoreFilters = props.isMoreFilters,
    _props$hideCancelCont = props.hideCancelControl,
    hideCancelControl = _props$hideCancelCont === void 0 ? false : _props$hideCancelCont,
    _props$showResetContr = props.showResetControl,
    showResetControl = _props$showResetContr === void 0 ? false : _props$showResetContr,
    isTabletMode = props.isTabletMode,
    onApplyFilters = props.onApplyFilters;
  var filterButtonCustomStyle = useRef(document.createElement('style'));
  var filterRef = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray$1(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var _useState3 = useState(_toConsumableArray(filters)),
    _useState4 = _slicedToArray$1(_useState3, 2),
    _filters = _useState4[0],
    setFilters = _useState4[1];
  useEffect(function () {
    if (filterRef.current) {
      var filterShadowDOM = filterRef.current.shadowRoot;
      filterButtonCustomStyle.current.innerHTML = overrideStyles$2;
      setTimeout(function () {
        filterShadowDOM.appendChild(filterButtonCustomStyle.current);
      }, 0);
    }
  }, []);
  useEffect(function () {
    setFilters(filters);
  }, [filters]);
  useEffect(function () {
    var _filterRef$current$re;
    var node = (_filterRef$current$re = filterRef.current.renderRoot) === null || _filterRef$current$re === void 0 ? void 0 : _filterRef$current$re.getElementById('Panel');
    if (isMoreFilters) {
      var _node$classList;
      node === null || node === void 0 ? void 0 : (_node$classList = node.classList) === null || _node$classList === void 0 ? void 0 : _node$classList.add('more-filters');
    } else {
      var _node$classList2;
      node === null || node === void 0 ? void 0 : (_node$classList2 = node.classList) === null || _node$classList2 === void 0 ? void 0 : _node$classList2.remove('more-filters');
    }
    if (hasDatePicker) {
      var _node$classList3;
      node === null || node === void 0 ? void 0 : (_node$classList3 = node.classList) === null || _node$classList3 === void 0 ? void 0 : _node$classList3.add('has-datepicker');
    } else {
      var _node$classList4;
      node === null || node === void 0 ? void 0 : (_node$classList4 = node.classList) === null || _node$classList4 === void 0 ? void 0 : _node$classList4.remove('has-datepicker');
    }
    if (hasSelect) {
      var _node$classList5;
      node === null || node === void 0 ? void 0 : (_node$classList5 = node.classList) === null || _node$classList5 === void 0 ? void 0 : _node$classList5.add('has-select');
    } else {
      var _node$classList6;
      node === null || node === void 0 ? void 0 : (_node$classList6 = node.classList) === null || _node$classList6 === void 0 ? void 0 : _node$classList6.remove('has-select');
    }
  });
  var handleOnToggleShow = useCallback(function (e) {
    e.preventDefault();
    setShow(function (old) {
      return !old;
    });
  }, []);
  var updateFilter = useCallback(function (newFilterRecord, index) {
    var childIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (typeof childIndex === 'number') {
      setFilters(function (old) {
        return old.map(function (filter, idx) {
          return idx === index ? _objectSpread$2(_objectSpread$2({}, filter), {}, {
            children: filter.children.map(function (childFilter, childIdx) {
              return childIdx === childIndex ? newFilterRecord : childFilter;
            })
          }) : filter;
        });
      });
    } else {
      setFilters(function (old) {
        return old.map(function (filter, idx) {
          return idx === index ? newFilterRecord : filter;
        });
      });
    }
  }, []);
  var handleToggleSelectAllCheckbox = useCallback(function (configProps) {
    var index = configProps.index,
      _configProps$isGroupe = configProps.isGrouped,
      isGrouped = _configProps$isGroupe === void 0 ? false : _configProps$isGroupe,
      _configProps$childInd = configProps.childIndex,
      childIndex = _configProps$childInd === void 0 ? null : _configProps$childInd;
    return function (isAllSelected) {
      var filterRecord = isGrouped ? _filters[index].children[childIndex] : _filters[index];
      var updatedFilterRecord = _objectSpread$2(_objectSpread$2({}, filterRecord), {}, {
        options: filterRecord.options.map(function (option) {
          return _objectSpread$2(_objectSpread$2({}, option), {}, {
            selected: !isAllSelected
          });
        })
      });
      if (isGrouped) {
        updateFilter(updatedFilterRecord, index, childIndex);
      } else {
        updateFilter(updatedFilterRecord, index);
      }
    };
  }, [_filters, updateFilter]);
  var handleToggleCheckbox = useCallback(function (configProps) {
    var index = configProps.index,
      _configProps$isGroupe2 = configProps.isGrouped,
      isGrouped = _configProps$isGroupe2 === void 0 ? false : _configProps$isGroupe2,
      _configProps$childInd2 = configProps.childIndex,
      childIndex = _configProps$childInd2 === void 0 ? null : _configProps$childInd2;
    return function (selectedOption, isSelected) {
      var filterRecord = isGrouped ? _filters[index].children[childIndex] : _filters[index];
      var updatedFilterRecord = _objectSpread$2(_objectSpread$2({}, filterRecord), {}, {
        options: filterRecord.options.map(function (option) {
          return _objectSpread$2(_objectSpread$2({}, option), {}, {
            selected: selectedOption.value === option.value ? !isSelected : option.selected || false
          });
        })
      });
      if (isGrouped) {
        updateFilter(updatedFilterRecord, index, childIndex);
      } else {
        updateFilter(updatedFilterRecord, index);
      }
    };
  }, [_filters, updateFilter]);
  var handleSelectedChange = useCallback(function (configProps) {
    var index = configProps.index,
      _configProps$isGroupe3 = configProps.isGrouped,
      isGrouped = _configProps$isGroupe3 === void 0 ? false : _configProps$isGroupe3,
      _configProps$childInd3 = configProps.childIndex,
      childIndex = _configProps$childInd3 === void 0 ? null : _configProps$childInd3;
    return function (selected) {
      var filterRecord = isGrouped ? _filters[index].children[childIndex] : _filters[index];
      var updatedFilterRecord = _objectSpread$2(_objectSpread$2({}, filterRecord), {}, {
        selected: selected
      });
      if (isGrouped) {
        updateFilter(updatedFilterRecord, index, childIndex);
      } else {
        updateFilter(updatedFilterRecord, index);
      }
    };
  }, [_filters, updateFilter]);
  var handleDatePickerChange = useCallback(function (configProps) {
    var index = configProps.index,
      _configProps$isGroupe4 = configProps.isGrouped,
      isGrouped = _configProps$isGroupe4 === void 0 ? false : _configProps$isGroupe4,
      _configProps$childInd4 = configProps.childIndex,
      childIndex = _configProps$childInd4 === void 0 ? null : _configProps$childInd4;
    return function (selectedDate, datePickerType) {
      var filterRecord = isGrouped ? _filters[index].children[childIndex] : _filters[index];
      var updatedFilterRecord = _objectSpread$2(_objectSpread$2({}, filterRecord), {}, {
        selected: _objectSpread$2(_objectSpread$2({}, filterRecord.selected), {}, _defineProperty$1({}, datePickerType, selectedDate))
      });
      if (isGrouped) {
        updateFilter(updatedFilterRecord, index, childIndex);
      } else {
        updateFilter(updatedFilterRecord, index);
      }
    };
  }, [_filters, updateFilter]);
  var handleSearchInputChange = useCallback(function (configProps) {
    var index = configProps.index,
      _configProps$isGroupe5 = configProps.isGrouped,
      isGrouped = _configProps$isGroupe5 === void 0 ? false : _configProps$isGroupe5,
      _configProps$childInd5 = configProps.childIndex,
      childIndex = _configProps$childInd5 === void 0 ? null : _configProps$childInd5;
    return function (searchText, promiseCallback) {
      var updateLoadingAndOptions = function updateLoadingAndOptions(isLoading, options) {
        var filterRecord = isGrouped ? _filters[index].children[childIndex] : _filters[index];
        var updatedFilterRecord = _objectSpread$2(_objectSpread$2({}, filterRecord), {}, {
          isLoading: isLoading,
          options: options
        });
        if (isGrouped) {
          updateFilter(updatedFilterRecord, index, childIndex);
        } else {
          updateFilter(updatedFilterRecord, index);
        }
      };
      if (searchText.length > 2) {
        updateLoadingAndOptions(true, []);
        // eslint-disable-next-line promise/catch-or-return
        promiseCallback(searchText).then(function (res) {
          // eslint-disable-next-line promise/always-return
          if (res && Array.isArray(res)) {
            updateLoadingAndOptions(false, res);
          } else {
            // If any error occurs then res comes as undefined
            updateLoadingAndOptions(false, []);
          }
        });
      }
    };
  }, [_filters, updateFilter]);
  var handleOnCancel = useCallback(function () {
    setFilters(filters);
  }, [filters]);
  var handleOnApply = useCallback(function () {
    onApplyFilters(_filters);
  }, [_filters, onApplyFilters]);
  var handleOnReset = useCallback(function () {
    setFilters(initialFilters);
    onApplyFilters(initialFilters);
  }, [initialFilters, onApplyFilters]);
  var filterButtonInfo = useMemo(function () {
    return getFiltersTitleAndType(filters);
  }, [filters]);
  var isSingleFilter = _filters.length === 1;
  var displayFilters = useMemo(function () {
    return _filters.map(function (filter, index) {
      return _objectSpread$2(_objectSpread$2({}, filter), {}, {
        index: index
      });
    });
  }, [_filters]);
  var hasDatePicker = useMemo(function () {
    return _filters.some(function (filter) {
      var _filter$selected, _filter$children2;
      return ((_filter$selected = filter.selected) === null || _filter$selected === void 0 ? void 0 : _filter$selected.value) === 'CUSTOM-DATE-RANGE' || filter.type === 'DATE-RANGE' || ((_filter$children2 = filter.children) === null || _filter$children2 === void 0 ? void 0 : _filter$children2.some(function (childFilter) {
        var _childFilter$selected;
        return ((_childFilter$selected = childFilter.selected) === null || _childFilter$selected === void 0 ? void 0 : _childFilter$selected.value) === 'CUSTOM-DATE-RANGE' || childFilter.type === 'DATE-RANGE';
      }));
    });
  }, [_filters]);
  var hasSelect = useMemo(function () {
    return _filters.some(function (filter) {
      return filter.type === 'SELECT-AUTOCOMPLETE' || filter.type === 'MULTI-SELECT' || filter.type === 'MULTI-SELECT-AUTOCOMPLETE';
    });
  }, [_filters]);
  return jsx(React__default.Fragment, null, jsx(FilterPanel, {
    className: "filter-button-panel ".concat(isMoreFilters ? 'more-filters' : ''),
    ref: filterRef,
    open: show,
    onToggle: handleOnToggleShow,
    onApply: handleOnApply,
    onCancel: handleOnCancel,
    onReset: handleOnReset,
    hideResetButton: !showResetControl,
    hideCancelButton: hideCancelControl,
    labelApplyButton: "Apply",
    labelCancelButton: "Cancel",
    labelResetButton: "Reset Filter"
  }, jsx(FilterPanel.Action, null, jsx(Button, {
    className: "filter-button ".concat(show ? 'active' : ''),
    btnType: filterButtonInfo.type || 'secondary',
    onClick: handleOnToggleShow,
    small: true
  }, filterButtonInfo.title)), jsx(FilterPanel.Content, null, jsx("div", {
    className: "filters-content-section",
    css: cssFiltersContentSection
  }, isSingleFilter && displayFilters.map(function (filter) {
    return jsx("div", {
      key: filter.code || filter.title,
      className: "individual-filters ".concat(['CHECKBOX', 'SELECT', 'RADIO'].includes(filter.type) ? '' : 'margins')
    }, jsx(FilterContainer, {
      filter: filter,
      isMoreFilters: isMoreFilters,
      isSingleFilter: isSingleFilter,
      handleSelectedChange: handleSelectedChange,
      handleToggleCheckbox: handleToggleCheckbox,
      handleToggleSelectAllCheckbox: handleToggleSelectAllCheckbox,
      handleDatePickerChange: handleDatePickerChange,
      handleSearchInputChange: handleSearchInputChange
    }));
  }), isMoreFilters && jsx("div", {
    className: "more-filters"
  }, jsx("div", {
    className: "left-side"
  }, displayFilters.filter(function (record) {
    return isFilterLeftAligned(record, isTabletMode, 'left');
  }).map(function (filter) {
    return jsx(FilterContainer, {
      key: filter.code || filter.title,
      filter: filter,
      isMoreFilters: isMoreFilters,
      isSingleFilter: isSingleFilter,
      handleSelectedChange: handleSelectedChange,
      handleToggleCheckbox: handleToggleCheckbox,
      handleToggleSelectAllCheckbox: handleToggleSelectAllCheckbox,
      handleDatePickerChange: handleDatePickerChange,
      handleSearchInputChange: handleSearchInputChange
    });
  })), jsx("div", {
    className: "right-side"
  }, displayFilters.filter(function (record) {
    return isFilterLeftAligned(record, isTabletMode, 'right');
  }).map(function (filter) {
    return jsx(FilterContainer, {
      key: filter.code || filter.title,
      filter: filter,
      isMoreFilters: isMoreFilters,
      isSingleFilter: isSingleFilter,
      handleSelectedChange: handleSelectedChange,
      handleToggleCheckbox: handleToggleCheckbox,
      handleToggleSelectAllCheckbox: handleToggleSelectAllCheckbox,
      handleDatePickerChange: handleDatePickerChange,
      handleSearchInputChange: handleSearchInputChange
    });
  })))))));
};
FilterButton.propTypes = {
  showResetControl: bool,
  hideCancelControl: bool,
  initialFilters: array$2,
  isMoreFilters: bool,
  filters: array$2,
  isTabletMode: bool,
  onApplyFilters: func,
  onResetFilters: func
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _EMOTION_STRINGIFIED_CSS_ERROR__$8() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssFilters = process.env.NODE_ENV === "production" ? {
  name: "uialnk-cssFilters",
  styles: "display:flex;flex-flow:row wrap;align-items:center;.filter-button-panel{width:auto;margin:10px 0px;.filter-button{height:32px;font-size:16px;font-weight:normal;font-weight:normal;font-stretch:normal;font-style:normal;letter-spacing:normal;margin-right:10px;padding:3px 16px 5px 16px;&.fwc-btn-secondary{color:#333;border-color:#eee;}&.active{font-weight:700px;border-color:var(--color-primary-hover);}&:focus{outline:none;}}}.reset-all-filters{button:focus{outline:none;}};label:cssFilters;"
} : {
  name: "uialnk-cssFilters",
  styles: "display:flex;flex-flow:row wrap;align-items:center;.filter-button-panel{width:auto;margin:10px 0px;.filter-button{height:32px;font-size:16px;font-weight:normal;font-weight:normal;font-stretch:normal;font-style:normal;letter-spacing:normal;margin-right:10px;padding:3px 16px 5px 16px;&.fwc-btn-secondary{color:#333;border-color:#eee;}&.active{font-weight:700px;border-color:var(--color-primary-hover);}&:focus{outline:none;}}}.reset-all-filters{button:focus{outline:none;}};label:cssFilters;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
};
var Filters = function Filters(props) {
  var _props$filters = props.filters,
    filters = _props$filters === void 0 ? [] : _props$filters,
    _props$resetFilters = props.resetFilters,
    resetFilters = _props$resetFilters === void 0 ? [] : _props$resetFilters,
    _props$breakpoints = props.breakpoints,
    breakpoints = _props$breakpoints === void 0 ? {
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
      xxl: 1400
    } : _props$breakpoints,
    _props$hideCancelCont = props.hideCancelControl,
    hideCancelControl = _props$hideCancelCont === void 0 ? false : _props$hideCancelCont,
    _props$showResetContr = props.showResetControl,
    showResetControl = _props$showResetContr === void 0 ? false : _props$showResetContr,
    _props$onFiltersChang = props.onFiltersChange,
    onFiltersChange = _props$onFiltersChang === void 0 ? function () {} : _props$onFiltersChang;
  var _useWindowSize = useWindowSize(breakpoints),
    isMobileMode = _useWindowSize.isMobileMode,
    isSmallMobileMode = _useWindowSize.isSmallMobileMode,
    isTabletMode = _useWindowSize.isTabletMode;
  var divideFiltersByDeviceModes = useMemo(function () {
    if (isTabletMode) {
      return [filters.slice(0, 2), filters.slice(2)];
    }
    if (isMobileMode || isSmallMobileMode) {
      return [filters.slice(0, 1), filters.slice(1)];
    }
    return [filters.slice(0, 5), filters.slice(5)];
  }, [isSmallMobileMode, isMobileMode, isTabletMode, filters]);
  var handleApplyFilters = function handleApplyFilters(startIndex) {
    var isMoreFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function (updatedFilters) {
      var _props$filters2 = props.filters,
        filters = _props$filters2 === void 0 ? [] : _props$filters2;
      if (isMoreFilters) {
        var first = filters.slice(0, startIndex);
        fireFiltersOnChange([].concat(_toConsumableArray(first), _toConsumableArray(updatedFilters)));
      } else {
        var newFilters = filters.map(function (filter, idx) {
          return idx === startIndex ? _objectSpread$1({}, updatedFilters[0]) : filter;
        });
        fireFiltersOnChange(newFilters);
      }
    };
  };
  var handleResetFilters = function handleResetFilters(startIndex) {
    var isMoreFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function () {
      var _props$filters3 = props.filters,
        filters = _props$filters3 === void 0 ? [] : _props$filters3,
        _props$resetFilters2 = props.resetFilters,
        resetFilters = _props$resetFilters2 === void 0 ? [] : _props$resetFilters2;
      if (isMoreFilters) {
        var first = filters.slice(0, startIndex);
        var restFilters = resetFilters.slice(startIndex);
        fireFiltersOnChange([].concat(_toConsumableArray(first), _toConsumableArray(restFilters)));
      } else {
        var oldFilter = resetFilters[startIndex];
        var newFilters = filters.map(function (filter, idx) {
          return idx === startIndex ? _objectSpread$1({}, oldFilter) : filter;
        });
        fireFiltersOnChange(newFilters);
      }
    };
  };
  var handleResetAllFilters = function handleResetAllFilters() {
    fireFiltersOnChange(props.resetFilters, true);
  };
  var fireFiltersOnChange = function fireFiltersOnChange(newFilters) {
    var isResetFiltersLink = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var _props$filterSeparato = props.filterSeparator,
      filterSeparator = _props$filterSeparato === void 0 ? '&' : _props$filterSeparato;
    var newQueryString = createFiltersQueryString(newFilters, filterSeparator);
    onFiltersChange(newFilters, newQueryString, isResetFiltersLink);
  };
  var _divideFiltersByDevic = _slicedToArray$1(divideFiltersByDeviceModes, 2),
    _divideFiltersByDevic2 = _divideFiltersByDevic[0],
    individualFilters = _divideFiltersByDevic2 === void 0 ? [] : _divideFiltersByDevic2,
    _divideFiltersByDevic3 = _divideFiltersByDevic[1],
    moreFilters = _divideFiltersByDevic3 === void 0 ? [] : _divideFiltersByDevic3;
  return jsx("div", {
    css: cssFilters
  }, individualFilters.map(function (filter, index) {
    return jsx(FilterButton, {
      key: filter.title || filter.code,
      filterButtonInfo: false,
      filters: [filter],
      initialFilters: resetFilters === null || resetFilters === void 0 ? void 0 : resetFilters.filter(function (f) {
        return f.code === filter.code;
      }),
      hideCancelControl: hideCancelControl,
      showResetControl: showResetControl,
      onApplyFilters: handleApplyFilters(index),
      onResetFilters: handleResetFilters(index)
    });
  }), moreFilters.length > 0 && jsx(FilterButton, {
    isMoreFilters: true,
    isTabletMode: isTabletMode,
    filters: moreFilters,
    initialFilters: resetFilters === null || resetFilters === void 0 ? void 0 : resetFilters.filter(function (f) {
      return moreFilters.some(function (i) {
        return (i === null || i === void 0 ? void 0 : i.code) === (f === null || f === void 0 ? void 0 : f.code);
      });
    }),
    hideCancelControl: hideCancelControl,
    showResetControl: showResetControl,
    onApplyFilters: handleApplyFilters(individualFilters.length, true),
    onResetFilters: handleResetFilters(individualFilters.length, true)
  }), filters.length > 1 && jsx("div", {
    className: "reset-all-filters"
  }, jsx(Button, {
    id: "reset-all-filters",
    btnType: "link",
    icon: jsx(Icon, {
      name: "restart"
    }),
    role: "link",
    onClick: handleResetAllFilters
  }, jsx("span", null, "Reset Filters"))));
};
Filters.propTypes = {
  filterSeparator: string,
  showResetControl: bool,
  hideCancelControl: bool,
  filters: arrayOf(shape({
    type: oneOf(['TEXT', 'RADIO', 'CHECKBOX', 'DATE-RANGE', 'DATE-RANGE-OPTIONS', 'SELECT', 'SELECT-AUTOCOMPLETE', 'MULTI-SELECT', 'MULTI-SELECT-AUTOCOMPLETE', 'GROUPED-FILTERS']),
    code: string,
    title: string,
    equalSign: string,
    delimiterSign: string,
    queryStrDateFormat: string,
    convertCodeToDates: bool,
    dateFormat: string,
    inputType: string,
    placeholder: string,
    desktopAlign: oneOf(['left', 'right']),
    tabletAlign: oneOf(['left', 'right']),
    arrowIconType: oneOf(['primary', 'secondary', 'search']),
    options: arrayOf(shape({
      label: string,
      value: oneOfType([string, number$4])
    })),
    children: arrayOf(shape({
      type: oneOf(['TEXT', 'RADIO', 'CHECKBOX', 'DATE-RANGE', 'DATE-RANGE-OPTIONS', 'SELECT', 'SELECT-AUTOCOMPLETE', 'MULTI-SELECT', 'MULTI-SELECT-AUTOCOMPLETE']),
      code: string,
      title: string,
      equalSign: string,
      delimiterSign: string,
      queryStrDateFormat: string,
      convertCodeToDates: bool,
      dateFormat: string,
      inputType: string,
      placeholder: string,
      arrowIconType: oneOf(['primary', 'secondary', 'search']),
      options: arrayOf(shape({
        label: string,
        value: oneOfType([string, number$4])
      }))
    }))
  })),
  resetFilters: arrayOf(shape({
    type: oneOf(['TEXT', 'RADIO', 'CHECKBOX', 'DATE-RANGE', 'DATE-RANGE-OPTIONS', 'SELECT', 'SELECT-AUTOCOMPLETE', 'MULTI-SELECT', 'MULTI-SELECT-AUTOCOMPLETE', 'GROUPED-FILTERS']),
    code: string,
    title: string,
    equalSign: string,
    delimiterSign: string,
    queryStrDateFormat: string,
    convertCodeToDates: bool,
    dateFormat: string,
    inputType: string,
    placeholder: string,
    arrowIconType: oneOf(['primary', 'secondary', 'search']),
    options: arrayOf(shape({
      label: string,
      value: oneOfType([string, number$4])
    })),
    children: arrayOf(shape({
      type: oneOf(['TEXT', 'RADIO', 'CHECKBOX', 'DATE-RANGE', 'DATE-RANGE-OPTIONS', 'SELECT', 'SELECT-AUTOCOMPLETE', 'MULTI-SELECT', 'MULTI-SELECT-AUTOCOMPLETE']),
      code: string,
      title: string,
      equalSign: string,
      delimiterSign: string,
      queryStrDateFormat: string,
      convertCodeToDates: bool,
      dateFormat: string,
      inputType: string,
      placeholder: string,
      arrowIconType: oneOf(['primary', 'secondary', 'search']),
      options: arrayOf(shape({
        label: string,
        value: oneOfType([string, number$4])
      }))
    }))
  })),
  breakpoints: shape({
    sm: number$4,
    md: number$4,
    lg: number$4,
    xl: number$4,
    xxl: number$4
  }),
  onFiltersChange: func
};

var DropdownAction = function DropdownAction(props) {
  return jsx("div", _extends$1({}, props, {
    className: cx('dropdown-action', props.className),
    slot: "nav-item"
  }));
};
DropdownAction.propTypes = {
  className: string
};
var DropdownContent = function DropdownContent(props) {
  return jsx("div", _extends$1({}, props, {
    className: cx('dropdown-content', props.className),
    slot: "nav-content"
  }));
};
DropdownContent.propTypes = {
  className: node$2
};
var overridePanelNavStyles = "\n    .container.open .wrapper .content {\n        padding: 8px 0px;\n    }\n";
var Dropdown = /*#__PURE__*/forwardRef(function (props, ref) {
  var noPadding = props.noPadding,
    children = props.children,
    onToggle = props.onToggle;
  var panelNavRef = useRef();
  var uiState = useSBUIState();
  var assetsPath = (uiState === null || uiState === void 0 ? void 0 : uiState.assetsPath) || './';
  var fwcPanelProps = getFwcProps$1(props, {
    id: 'id',
    className: 'class'
  });
  var panelNavStyles = useRef(document.createElement('style'));
  var handlePanelToggle = useCallback(function (event) {
    return onToggle === null || onToggle === void 0 ? void 0 : onToggle(event);
  }, [onToggle]);
  useEffect(function () {
    if (panelNavRef.current) {
      new FwcPanelNav(panelNavRef.current).build();
    }
  }, []);
  useEffect(function () {
    if (noPadding) {
      setTimeout(function () {
        var _panelNavRef$current;
        var baseDropdownShadowDOM = panelNavRef === null || panelNavRef === void 0 ? void 0 : (_panelNavRef$current = panelNavRef.current) === null || _panelNavRef$current === void 0 ? void 0 : _panelNavRef$current.shadowRoot;
        if (baseDropdownShadowDOM) {
          panelNavStyles.current.innerHTML = overridePanelNavStyles;
          setTimeout(function () {
            baseDropdownShadowDOM.appendChild(panelNavStyles.current);
          }, 0);
        }
      }, 0);
    }
  }, [panelNavStyles, noPadding]);
  useEffect(function () {
    var panelNavElement = null;
    if (panelNavRef.current) {
      panelNavRef.current.addEventListener('fwc-panel-toggled', handlePanelToggle);
      panelNavElement = panelNavRef.current;
    }
    return function () {
      if (panelNavElement) {
        panelNavElement.removeEventListener('fwc-panel-toggle', handlePanelToggle);
      }
    };
  }, [handlePanelToggle]);
  return jsx("fwc-panel-nav", _extends$1({}, fwcPanelProps, {
    config: JSON.stringify({
      assetsPath: assetsPath
    }),
    ref: mergeRefs(panelNavRef, ref)
  }), React__default.Children.map(children, function (child) {
    var _child$type, _child$type2;
    if ((child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'Dropdown.Action') {
      return child;
    }
    if ((child === null || child === void 0 ? void 0 : (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) === 'Dropdown.Content') {
      return child;
    }
    console.error("Warning Dropdown has children that aren't Dropdown.Action or Dropdown.Content components");
    return null;
  }));
});
Dropdown.propTypes = {
  noPadding: bool,
  children: node$2,
  onToggle: func
};
Dropdown.displayName = 'Dropdown';
Dropdown.Action = DropdownAction;
Dropdown.Action.displayName = 'Dropdown.Action';
Dropdown.Content = DropdownContent;
Dropdown.Content.displayName = 'Dropdown.Content';

var _excluded$4 = ["label", "id", "name", "value", "disabled", "touched", "helperText", "layout", "className"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$7() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssTextareaHorizontal = process.env.NODE_ENV === "production" ? {
  name: "rjveey-cssTextareaHorizontal",
  styles: "display:flex;flex-flow:row nowrap;margin-bottom:20px;.field-label{width:30%;margin-top:10px;margin-right:10px;text-align:right;label{font-weight:bold;}}.field-control{width:70%;}@media screen and (max-width: 420px){flex-flow:column wrap;.field-label{width:100%;margin-top:0px;margin-right:0px;text-align:start;}.field-control{width:100%;}};label:cssTextareaHorizontal;"
} : {
  name: "rjveey-cssTextareaHorizontal",
  styles: "display:flex;flex-flow:row nowrap;margin-bottom:20px;.field-label{width:30%;margin-top:10px;margin-right:10px;text-align:right;label{font-weight:bold;}}.field-control{width:70%;}@media screen and (max-width: 420px){flex-flow:column wrap;.field-label{width:100%;margin-top:0px;margin-right:0px;text-align:start;}.field-control{width:100%;}};label:cssTextareaHorizontal;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRleHRhcmVhLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVNpQyIsImZpbGUiOiJUZXh0YXJlYS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBmb3J3YXJkUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IGN4IGZyb20gJ2NsYXNzbmFtZXMnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgc3RyaW5nLCBib29sLCBub2RlLCBvbmVPZlR5cGUsIGFycmF5T2YsIG9uZU9mIH0gZnJvbSAncHJvcC10eXBlcyc7XG5cbmltcG9ydCB7IEhlbHBlck1lc3NhZ2UgfSBmcm9tICcuLi9IZWxwZXJNZXNzYWdlJztcblxuaW1wb3J0ICcuLi8uLi9wdWJsaWMvZndjLWFzc2V0cy9zdHlsZXMvY29tcG9uZW50cy9md2MtaW5wdXQuY3NzJztcblxuY29uc3QgY3NzVGV4dGFyZWFIb3Jpem9udGFsID0gY3NzYFxuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWZsb3c6IHJvdyBub3dyYXA7XG4gIG1hcmdpbi1ib3R0b206IDIwcHg7XG4gIC5maWVsZC1sYWJlbCB7XG4gICAgd2lkdGg6IDMwJTtcbiAgICBtYXJnaW4tdG9wOiAxMHB4O1xuICAgIG1hcmdpbi1yaWdodDogMTBweDtcbiAgICB0ZXh0LWFsaWduOiByaWdodDtcbiAgICBsYWJlbCB7XG4gICAgICBmb250LXdlaWdodDogYm9sZDtcbiAgICB9XG4gIH1cbiAgLmZpZWxkLWNvbnRyb2wge1xuICAgIHdpZHRoOiA3MCU7XG4gIH1cblxuICBAbWVkaWEgc2NyZWVuIGFuZCAobWF4LXdpZHRoOiA0MjBweCkge1xuICAgIGZsZXgtZmxvdzogY29sdW1uIHdyYXA7XG4gICAgLmZpZWxkLWxhYmVsIHtcbiAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgbWFyZ2luLXRvcDogMHB4O1xuICAgICAgbWFyZ2luLXJpZ2h0OiAwcHg7XG4gICAgICB0ZXh0LWFsaWduOiBzdGFydDtcbiAgICB9XG4gICAgLmZpZWxkLWNvbnRyb2wge1xuICAgICAgd2lkdGg6IDEwMCU7XG4gICAgfVxuICB9XG5gO1xuXG5jb25zdCBjc3NUZXh0YXJlYVZlcnRpY2FsID0gY3NzYFxuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWZsb3c6IGNvbHVtbiB3cmFwO1xuICBtYXJnaW4tYm90dG9tOiAyMHB4O1xuICAuZmllbGQtbGFiZWwge1xuICAgIGxhYmVsIHtcbiAgICAgIGZvbnQtd2VpZ2h0OiBib2xkO1xuICAgIH1cbiAgfVxuYDtcblxuY29uc3QgY3NzVGV4dGFyZWEgPSBjc3NgXG4gICYuZndjLWRpc2FibGVkIHtcbiAgICAuZmllbGQtbGFiZWwge1xuICAgICAgb3BhY2l0eTogY2FsYyh2YXIoLS1kaXNhYmxlZC1vcGFjaXR5KSArIDAuMik7XG4gICAgfVxuICAgIC5maWVsZC1jb250cm9sIHtcbiAgICAgIHRleHRhcmVhLFxuICAgICAgdGV4dGFyZWE6OnBsYWNlaG9sZGVyIHtcbiAgICAgICAgb3BhY2l0eTogY2FsYyh2YXIoLS1kaXNhYmxlZC1vcGFjaXR5KSArIDAuNCk7XG4gICAgICB9XG4gICAgICB0ZXh0YXJlYVthcmlhLWludmFsaWQ9J3RydWUnXSB7XG4gICAgICAgIGJvcmRlci1jb2xvcjogdmFyKC0tY29sb3ItYWxlcnQtZXJyb3IpO1xuICAgICAgfVxuICAgIH1cbiAgfVxuYDtcblxuZXhwb3J0IGNvbnN0IFRleHRhcmVhID0gZm9yd2FyZFJlZigocHJvcHMsIHJlZikgPT4ge1xuICBjb25zdCB7XG4gICAgbGFiZWwsXG4gICAgaWQsXG4gICAgbmFtZSxcbiAgICB2YWx1ZSxcbiAgICBkaXNhYmxlZCA9IGZhbHNlLFxuICAgIHRvdWNoZWQsXG4gICAgaGVscGVyVGV4dCxcbiAgICBsYXlvdXQgPSAndmVydGljYWwnLFxuICAgIGNsYXNzTmFtZSxcbiAgICAuLi5yZXN0UHJvcHNcbiAgfSA9IHByb3BzO1xuXG4gIGNvbnN0IGlucHV0RGl2Q2xhc3MgPSBjeChcbiAgICB7XG4gICAgICAnZndjLXRleHRhcmVhJzogdHJ1ZSxcbiAgICAgICdmaWVsZC10ZXh0YXJlYSc6IHRydWUsXG4gICAgICAnZndjLWRpc2FibGVkJzogZGlzYWJsZWQsXG4gICAgfSxcbiAgICBjbGFzc05hbWUsXG4gICk7XG5cbiAgcmV0dXJuIChcbiAgICA8ZGl2XG4gICAgICBjbGFzc05hbWU9e2lucHV0RGl2Q2xhc3N9XG4gICAgICBjc3M9e1tcbiAgICAgICAgY3NzVGV4dGFyZWEsXG4gICAgICAgIGxheW91dCA9PT0gJ3ZlcnRpY2FsJyA/IGNzc1RleHRhcmVhVmVydGljYWwgOiBjc3NUZXh0YXJlYUhvcml6b250YWwsXG4gICAgICBdfVxuICAgID5cbiAgICAgIHtsYWJlbCAmJiAoXG4gICAgICAgIDxkaXYgY2xhc3NOYW1lPVwiZmllbGQtbGFiZWxcIj5cbiAgICAgICAgICA8bGFiZWwgaHRtbEZvcj17aWQgfHwgbmFtZX0+e2xhYmVsfTwvbGFiZWw+XG4gICAgICAgIDwvZGl2PlxuICAgICAgKX1cbiAgICAgIDxkaXYgY2xhc3NOYW1lPVwiZmllbGQtY29udHJvbFwiPlxuICAgICAgICA8dGV4dGFyZWFcbiAgICAgICAgICB7Li4ucmVzdFByb3BzfVxuICAgICAgICAgIHJlZj17cmVmfVxuICAgICAgICAgIGlkPXtpZCB8fCBuYW1lfVxuICAgICAgICAgIG5hbWU9e25hbWV9XG4gICAgICAgICAgey4uLih2YWx1ZSAhPT0gdW5kZWZpbmVkIHx8IHZhbHVlICE9PSBudWxsID8geyB2YWx1ZTogdmFsdWUgfSA6IHt9KX1cbiAgICAgICAgICBkaXNhYmxlZD17ZGlzYWJsZWR9XG4gICAgICAgICAgYXJpYS1pbnZhbGlkPXt0b3VjaGVkICYmICEhaGVscGVyVGV4dH1cbiAgICAgICAgLz5cbiAgICAgICAgPEhlbHBlck1lc3NhZ2UgdG91Y2hlZD17dG91Y2hlZH0gaGVscGVyVGV4dD17aGVscGVyVGV4dH0gLz5cbiAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuICApO1xufSk7XG5cblRleHRhcmVhLmRpc3BsYXlOYW1lID0gJ1RleHRhcmVhJztcblRleHRhcmVhLnByb3BUeXBlcyA9IHtcbiAgaWQ6IHN0cmluZyxcbiAgY2xhc3NOYW1lOiBzdHJpbmcsXG4gIGxheW91dDogb25lT2YoWyd2ZXJ0aWNhbCcsICdob3Jpem9udGFsJ10pLFxuICBsYWJlbDogc3RyaW5nLFxuICBuYW1lOiBzdHJpbmcsXG4gIGRpc2FibGVkOiBib29sLFxuICB0b3VjaGVkOiBib29sLFxuICB2YWx1ZTogc3RyaW5nLFxuICBwbGFjZWhvbGRlcjogc3RyaW5nLFxuICBoZWxwZXJUZXh0OiBvbmVPZlR5cGUoW3N0cmluZywgbm9kZSwgYXJyYXlPZihub2RlKV0pLFxufTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
};
var cssTextareaVertical = process.env.NODE_ENV === "production" ? {
  name: "1jpsuzp-cssTextareaVertical",
  styles: "display:flex;flex-flow:column wrap;margin-bottom:20px;.field-label{label{font-weight:bold;}};label:cssTextareaVertical;"
} : {
  name: "1jpsuzp-cssTextareaVertical",
  styles: "display:flex;flex-flow:column wrap;margin-bottom:20px;.field-label{label{font-weight:bold;}};label:cssTextareaVertical;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
};
var cssTextarea = process.env.NODE_ENV === "production" ? {
  name: "5mog09-cssTextarea",
  styles: "&.fwc-disabled{.field-label{opacity:calc(var(--disabled-opacity) + 0.2);}.field-control{textarea,textarea::placeholder{opacity:calc(var(--disabled-opacity) + 0.4);}textarea[aria-invalid='true']{border-color:var(--color-alert-error);}}};label:cssTextarea;"
} : {
  name: "5mog09-cssTextarea",
  styles: "&.fwc-disabled{.field-label{opacity:calc(var(--disabled-opacity) + 0.2);}.field-control{textarea,textarea::placeholder{opacity:calc(var(--disabled-opacity) + 0.4);}textarea[aria-invalid='true']{border-color:var(--color-alert-error);}}};label:cssTextarea;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
};
var Textarea = /*#__PURE__*/forwardRef(function (props, ref) {
  var label = props.label,
    id = props.id,
    name = props.name,
    value = props.value,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    touched = props.touched,
    helperText = props.helperText,
    _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'vertical' : _props$layout,
    className = props.className,
    restProps = _objectWithoutProperties$1(props, _excluded$4);
  var inputDivClass = cx({
    'fwc-textarea': true,
    'field-textarea': true,
    'fwc-disabled': disabled
  }, className);
  return jsx("div", {
    className: inputDivClass,
    css: [cssTextarea, layout === 'vertical' ? cssTextareaVertical : cssTextareaHorizontal, ";label:Textarea;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")]
  }, label && jsx("div", {
    className: "field-label"
  }, jsx("label", {
    htmlFor: id || name
  }, label)), jsx("div", {
    className: "field-control"
  }, jsx("textarea", _extends$1({}, restProps, {
    ref: ref,
    id: id || name,
    name: name
  }, value !== undefined || value !== null ? {
    value: value
  } : {}, {
    disabled: disabled,
    "aria-invalid": touched && !!helperText
  })), jsx(HelperMessage, {
    touched: touched,
    helperText: helperText
  })));
});
Textarea.displayName = 'Textarea';
Textarea.propTypes = {
  id: string,
  className: string,
  layout: oneOf(['vertical', 'horizontal']),
  label: string,
  name: string,
  disabled: bool,
  touched: bool,
  value: string,
  placeholder: string,
  helperText: oneOfType([string, node$2, arrayOf(node$2)])
};

var ExpandMobileItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children;
  return jsx("fwc-expand-mobile-col-item", {
    ref: ref
  }, children);
});
ExpandMobileItem.displayName = 'ExpandMobile.Item';
ExpandMobileItem.propTypes = {
  children: node$2
};
var ExpandMobile = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$border = props.border,
    border = _props$border === void 0 ? false : _props$border,
    _props$noTopBorder = props.noTopBorder,
    noTopBorder = _props$noTopBorder === void 0 ? false : _props$noTopBorder,
    children = props.children;
  var expandMobileRef = useRef();
  var uiState = useSBUIState();
  var assetsPath = (uiState === null || uiState === void 0 ? void 0 : uiState.assetsPath) || './';
  var fwcExpandMobileProps = getFwcProps$1(props, {
    id: 'id',
    mobileTitle: 'mobile-title',
    horizontal: 'horizontal'
  });
  useEffect(function () {
    if (expandMobileRef.current) {
      new FwcExpandMobileCol(expandMobileRef.current).build();
    }
  }, []);
  return jsx("fwc-expand-mobile-col", _extends$1({}, fwcExpandMobileProps, {
    "class": cx({
      border: border,
      'no-top-border': noTopBorder
    }),
    ref: mergeRefs(ref, expandMobileRef),
    config: JSON.stringify({
      assetsPath: assetsPath
    })
  }), Children.map(children, function (child) {
    var _child$type;
    if ((child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'ExpandMobile.Item') {
      return child;
    }
    console.error("Warning ExpandMobile has children that aren't ExpandMobile.Item components");
    return null;
  }));
});
ExpandMobile.displayName = 'ExpandMobile';
ExpandMobile.Item = ExpandMobileItem;
ExpandMobile.Item.displayName = 'ExpandMobile.Item';
ExpandMobile.propTypes = {
  /**
   * The mobile title, seen at 900px.
   */
  mobileTitle: string,
  /**
   * Top and bottom borders, seen at 900px.
   */
  border: bool,
  /**
   * No top border, seen at 900px.
   */
  noTopBorder: bool,
  horizontal: bool,
  children: node$2
};

var ExpandMultiHeader = function ExpandMultiHeader(props) {
  return jsx("div", _extends$1({}, props, {
    className: cx('expand-multi-item-header', props.className),
    slot: "expand-header"
  }));
};
ExpandMultiHeader.propTypes = {
  className: string
};
var ExpandMultiContent = function ExpandMultiContent(props) {
  return jsx("div", _extends$1({}, props, {
    className: cx('expand-multi-item-content', props.className),
    slot: "expand-panel"
  }));
};
ExpandMultiContent.propTypes = {
  className: string
};
var ExpandMultiItem = /*#__PURE__*/forwardRef(function (props, ref) {
  var expand = props.expand,
    onExpand = props.onExpand,
    children = props.children;
  var expandItemRef = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray$1(_useState, 2),
    isNodeMounted = _useState2[0],
    setIsNodeMounted = _useState2[1];
  var togglePanel = useCallback(function (_expand) {
    if (_expand) {
      var _expandItemRef$curren, _expandItemRef$curren2;
      expandItemRef === null || expandItemRef === void 0 ? void 0 : (_expandItemRef$curren = expandItemRef.current) === null || _expandItemRef$curren === void 0 ? void 0 : (_expandItemRef$curren2 = _expandItemRef$curren.expandPanel) === null || _expandItemRef$curren2 === void 0 ? void 0 : _expandItemRef$curren2.call(_expandItemRef$curren);
    } else {
      var _expandItemRef$curren3, _expandItemRef$curren4;
      expandItemRef === null || expandItemRef === void 0 ? void 0 : (_expandItemRef$curren3 = expandItemRef.current) === null || _expandItemRef$curren3 === void 0 ? void 0 : (_expandItemRef$curren4 = _expandItemRef$curren3.closePanel) === null || _expandItemRef$curren4 === void 0 ? void 0 : _expandItemRef$curren4.call(_expandItemRef$curren3);
    }
  }, []);
  var handleClick = useCallback(function () {
    onExpand === null || onExpand === void 0 ? void 0 : onExpand(!expandItemRef.current.expanded);
  }, [onExpand]);
  useEffect(function () {
    if (expandItemRef.current) {
      togglePanel(expand);
    }
  }, [expand, togglePanel]);
  useEffect(function () {
    expandItemRef.current._dispatchExpandEvent = function () {};
    setTimeout(function () {
      var _expandItemRef$curren5;
      if (expandItemRef !== null && expandItemRef !== void 0 && (_expandItemRef$curren5 = expandItemRef.current) !== null && _expandItemRef$curren5 !== void 0 && _expandItemRef$curren5.renderRoot) {
        setIsNodeMounted(true);
      }
    }, 0);
  }, []);
  useEffect(function () {
    var _expandItemRef$curren6, _expandItemRef$curren7, _expandItemRef$curren8;
    var expandButton = expandItemRef === null || expandItemRef === void 0 ? void 0 : (_expandItemRef$curren6 = expandItemRef.current) === null || _expandItemRef$curren6 === void 0 ? void 0 : (_expandItemRef$curren7 = _expandItemRef$curren6.renderRoot) === null || _expandItemRef$curren7 === void 0 ? void 0 : (_expandItemRef$curren8 = _expandItemRef$curren7.querySelector) === null || _expandItemRef$curren8 === void 0 ? void 0 : _expandItemRef$curren8.call(_expandItemRef$curren7, '.fwc-expand-multi-item > .fwc-expand-header > .fwc-expand-button');
    if (expandButton && isNodeMounted) {
      expandButton.addEventListener('click', handleClick);
    }
    return function () {
      if (expandButton && isNodeMounted) {
        expandButton.removeEventListener('click', handleClick);
      }
    };
  }, [isNodeMounted, handleClick]);
  return jsx("fwc-expand-multi-item", _extends$1({
    ref: mergeRefs(expandItemRef, ref)
  }, expand ? {
    expanded: true
  } : {}), React__default.Children.map(children, function (child) {
    var _child$type, _child$type2;
    if ((child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'ExpandMulti.Header') {
      return /*#__PURE__*/cloneElement(child);
    }
    if ((child === null || child === void 0 ? void 0 : (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) === 'ExpandMulti.Content') {
      return /*#__PURE__*/cloneElement(child);
    }
    console.error("Warning ExpandMulti.Item has children that aren't ExpandMulti.Header or ExpandMulti.Content components");
    return null;
  }));
});
ExpandMultiItem.displayName = 'ExpandMulti.Item';
ExpandMultiItem.propTypes = {
  activeKey: oneOfType([string, number$4]),
  itemKey: oneOfType([string, number$4]),
  expand: bool,
  onExpand: func,
  children: node$2
};
var ExpandMulti = /*#__PURE__*/forwardRef(function (props, ref) {
  var _ref;
  var defaultActiveKey = props.defaultActiveKey,
    activeKey = props.activeKey,
    onChange = props.onChange,
    children = props.children;
  var _useState3 = useState({
      itemKey: activeKey !== null && activeKey !== void 0 ? activeKey : defaultActiveKey,
      expand: ((_ref = activeKey !== null && activeKey !== void 0 ? activeKey : defaultActiveKey) !== null && _ref !== void 0 ? _ref : false) ? true : false
    }),
    _useState4 = _slicedToArray$1(_useState3, 2),
    active = _useState4[0],
    setActive = _useState4[1];
  var expandMultiRef = useRef();
  var uiState = useSBUIState();
  var assetsPath = (uiState === null || uiState === void 0 ? void 0 : uiState.assetsPath) || './';
  var fwcExpandMultiProps = getFwcProps$1(props, {
    id: 'id',
    ariaLabelExpandText: 'label-aria-expand-text'
  }, {
    ariaLabelExpandText: 'Expand Content'
  });
  useEffect(function () {
    if (expandMultiRef.current) {
      new FwcExpandMulti(expandMultiRef.current).build();
    }
  }, []);
  var handleOnExpand = useCallback(function (itemKey) {
    return function (expand) {
      if (activeKey == '0' || activeKey) {
        if (itemKey == active.itemKey) {
          setActive({
            itemKey: itemKey,
            expand: expand
          });
        } else {
          onChange === null || onChange === void 0 ? void 0 : onChange(itemKey, expand);
        }
      } else {
        setActive({
          itemKey: itemKey,
          expand: expand
        });
        onChange === null || onChange === void 0 ? void 0 : onChange(itemKey, expand);
      }
    };
  }, [activeKey, active.itemKey, onChange]);
  useEffect(function () {
    var validActiveKey = activeKey !== null && activeKey !== void 0 ? activeKey : false;
    if (validActiveKey) {
      setActive({
        itemKey: activeKey,
        expand: true
      });
    }
  }, [activeKey]);
  return jsx("fwc-expand-multi", _extends$1({}, fwcExpandMultiProps, {
    ref: mergeRefs(expandMultiRef, ref),
    config: JSON.stringify({
      assetsPath: assetsPath
    })
  }), React__default.Children.map(children, function (child, idx) {
    var _child$type3;
    if ((child === null || child === void 0 ? void 0 : (_child$type3 = child.type) === null || _child$type3 === void 0 ? void 0 : _child$type3.displayName) === 'ExpandMulti.Item') {
      var _child$props$itemKey, _child$props;
      var itemKey = (_child$props$itemKey = child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.itemKey) !== null && _child$props$itemKey !== void 0 ? _child$props$itemKey : idx;
      return /*#__PURE__*/cloneElement(child, {
        expand: itemKey == active.itemKey && active.expand ? true : false,
        onExpand: handleOnExpand(itemKey)
      });
    }
    console.error("Warning ExpandMulti has children that aren't ExpandMulti.Item components");
    return null;
  }));
});
ExpandMulti.Header = ExpandMultiHeader;
ExpandMulti.Header.displayName = 'ExpandMulti.Header';
ExpandMulti.Content = ExpandMultiContent;
ExpandMulti.Content.displayName = 'ExpandMulti.Content';
ExpandMulti.Item = ExpandMultiItem;
ExpandMulti.Item.displayName = 'ExpandMulti.Item';
ExpandMulti.displayName = 'ExpandMulti';
ExpandMulti.propTypes = {
  /**
   * Key of the initial active item
   */
  activeKey: oneOfType([number$4, string]),
  /**
   * Key of the active item
   */
  defaultActiveKey: oneOfType([number$4, string]),
  /**
   * Set on <ExpandMulti.Item>, an option for the aria-label on each items button.
   */
  ariaLabelExpandText: string,
  children: node$2,
  /**
   * Callback function executed when active item is changed
   * (activeKey, expand) => {}
   */
  onChange: func
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$6() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssTourCard = process.env.NODE_ENV === "production" ? {
  name: "5m55f2-cssTourCard",
  styles: "background-color:#fff;border-radius:10px;.tour-media{height:294px;background:linear-gradient(90deg, #58abdf 1.26%, #286ce2 100%);border-top-left-radius:10px;border-top-right-radius:10px;.tour-image{height:100%;padding:10px;margin:0px auto;object-fit:contain;}}.tour-body{padding:32px;.tour-content{min-height:150px;}.tour-actions{margin:32px 0px;text-align:right;.fwc-btn{min-width:90px;}}.tour-footer{text-align:center;.tour-skip-link button{margin-top:12px;font-size:16px;}}};label:cssTourCard;"
} : {
  name: "5m55f2-cssTourCard",
  styles: "background-color:#fff;border-radius:10px;.tour-media{height:294px;background:linear-gradient(90deg, #58abdf 1.26%, #286ce2 100%);border-top-left-radius:10px;border-top-right-radius:10px;.tour-image{height:100%;padding:10px;margin:0px auto;object-fit:contain;}}.tour-body{padding:32px;.tour-content{min-height:150px;}.tour-actions{margin:32px 0px;text-align:right;.fwc-btn{min-width:90px;}}.tour-footer{text-align:center;.tour-skip-link button{margin-top:12px;font-size:16px;}}};label:cssTourCard;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
};
var TourCard = function TourCard(props) {
  var isFirst = props.isFirst,
    isLast = props.isLast,
    isChecked = props.isChecked,
    imgSrc = props.imgSrc,
    content = props.content,
    _props$showLoginCheck = props.showLoginCheckbox,
    showLoginCheckbox = _props$showLoginCheck === void 0 ? false : _props$showLoginCheck,
    dataAnalytics = props.dataAnalytics;
  return jsx("div", {
    className: "tour-card",
    css: cssTourCard
  }, jsx("div", {
    className: "tour-media"
  }, jsx("img", {
    className: "tour-image",
    src: imgSrc,
    alt: "img-src"
  })), jsx("div", {
    className: "tour-body"
  }, jsx("div", {
    className: "tour-content"
  }, content), jsx("div", {
    className: "tour-actions"
  }, !isFirst && jsx(Button, {
    btnType: "secondary",
    small: true,
    onClick: props.onBack,
    "data-analytics": dataAnalytics.prevButton
  }, "Back"), jsx(Button, {
    btnType: "primary",
    small: true,
    onClick: function onClick() {
      return props.onNext(isLast);
    },
    "data-analytics": dataAnalytics.nextButton
  }, isLast ? 'Finish' : 'Next')), jsx("div", {
    className: "tour-footer"
  }, showLoginCheckbox && jsx(Checkbox, {
    label: jsx(Text$1, {
      size: 'sm'
    }, "Don't show me this again at login. Take the tour anytime from the top of your dashboard."),
    name: "confirm",
    value: "dont-show",
    checked: isChecked,
    onChange: props.onCheckboxChange,
    "data-analytics": dataAnalytics.checkbox
  }), jsx("div", {
    className: "tour-skip-link"
  }, jsx(Button, {
    btnType: "link",
    onClick: props.onSkipOverview,
    "data-analytics": dataAnalytics.skipOverview
  }, "Skip Overview")))));
};
TourCard.propTypes = {
  isChecked: bool,
  isFirst: bool,
  isLast: bool,
  imgSrc: string,
  content: any,
  dataAnalytics: shape({
    nextArrowButton: string,
    prevArrowButton: string,
    nextButton: string,
    prevButton: string,
    skipOverview: string,
    checkbox: string
  }),
  showLoginCheckbox: bool,
  onNext: func,
  onBack: func,
  onCheckboxChange: func,
  onSkipOverview: func
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$5() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssTourCarousel = process.env.NODE_ENV === "production" ? {
  name: "1706bf0-cssTourCarousel",
  styles: "max-width:720px;padding:5px 10px;margin:10px auto;label:cssTourCarousel;"
} : {
  name: "1706bf0-cssTourCarousel",
  styles: "max-width:720px;padding:5px 10px;margin:10px auto;label:cssTourCarousel;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
};
var overrideStyles$1 = "\n  .fwc-modal-wrapper .fwc-modal-container {\n    background-color: transparent;\n    box-shadow: none;\n    mix-blend-mode: difference;\n  }\n";
var TourCarousel = function TourCarousel(props) {
  var eventType = 'outside';
  var _props$open = props.open,
    open = _props$open === void 0 ? false : _props$open,
    _props$onClose = props.onClose,
    onClose = _props$onClose === void 0 ? null : _props$onClose,
    _props$isCheckboxChec = props.isCheckboxChecked,
    isCheckboxChecked = _props$isCheckboxChec === void 0 ? false : _props$isCheckboxChec,
    _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    _props$disableBackdro = props.disableBackdrop,
    disableBackdrop = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
    _props$disableEscapeK = props.disableEscapeKey,
    disableEscapeKey = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
    _props$dataAnalytics = props.dataAnalytics,
    dataAnalytics = _props$dataAnalytics === void 0 ? {} : _props$dataAnalytics,
    _props$onNextClick = props.onNextClick,
    onNextClick = _props$onNextClick === void 0 ? function () {} : _props$onNextClick,
    _props$onPreviousClic = props.onPreviousClick,
    onPreviousClick = _props$onPreviousClic === void 0 ? function () {} : _props$onPreviousClic;
  var _React$useState = React__default.useState(isCheckboxChecked),
    _React$useState2 = _slicedToArray$1(_React$useState, 2),
    isChecked = _React$useState2[0],
    setIsChecked = _React$useState2[1];
  var baseModalRef = useRef();
  var carouselRef = useRef();
  var baseModalCustomStyle = useRef(document.createElement('style'));
  var uiState = useSBUIState();
  var assetsPath = (uiState === null || uiState === void 0 ? void 0 : uiState.assetsPath) || './';
  var handleCloseModal = useCallback(function () {
    onClose === null || onClose === void 0 ? void 0 : onClose({
      eventType: eventType,
      isChecked: isChecked
    });
  }, [eventType, onClose, isChecked]);
  var handleCheckboxChange = function handleCheckboxChange() {
    setIsChecked(function (old) {
      return !old;
    });
  };
  var handleSkipOverview = function handleSkipOverview() {
    var _baseModalRef$current, _baseModalRef$current2;
    eventType = 'skip-overview';
    baseModalRef === null || baseModalRef === void 0 ? void 0 : (_baseModalRef$current = baseModalRef.current) === null || _baseModalRef$current === void 0 ? void 0 : _baseModalRef$current.removeAttribute('open');
    baseModalRef === null || baseModalRef === void 0 ? void 0 : (_baseModalRef$current2 = baseModalRef.current) === null || _baseModalRef$current2 === void 0 ? void 0 : _baseModalRef$current2.closeModal();
  };
  var handleNextSlide = function handleNextSlide(isLast) {
    var _carouselRef$current;
    carouselRef === null || carouselRef === void 0 ? void 0 : (_carouselRef$current = carouselRef.current) === null || _carouselRef$current === void 0 ? void 0 : _carouselRef$current.nextSlide();
    if (isLast) {
      var _baseModalRef$current3, _baseModalRef$current4;
      eventType = 'finish';
      baseModalRef === null || baseModalRef === void 0 ? void 0 : (_baseModalRef$current3 = baseModalRef.current) === null || _baseModalRef$current3 === void 0 ? void 0 : _baseModalRef$current3.removeAttribute('open');
      baseModalRef === null || baseModalRef === void 0 ? void 0 : (_baseModalRef$current4 = baseModalRef.current) === null || _baseModalRef$current4 === void 0 ? void 0 : _baseModalRef$current4.closeModal();
    }
  };
  var handlePreviousSlide = function handlePreviousSlide() {
    var _carouselRef$current2;
    carouselRef === null || carouselRef === void 0 ? void 0 : (_carouselRef$current2 = carouselRef.current) === null || _carouselRef$current2 === void 0 ? void 0 : _carouselRef$current2.prevSlide();
  };
  useEffect(function () {
    if (baseModalRef !== null && baseModalRef !== void 0 && baseModalRef.current) {
      new FwcModalBase(baseModalRef === null || baseModalRef === void 0 ? void 0 : baseModalRef.current).build();
      var baseModalShadowDOM = baseModalRef.current.shadowRoot;
      baseModalCustomStyle.current.innerHTML = overrideStyles$1;
      setTimeout(function () {
        baseModalShadowDOM.appendChild(baseModalCustomStyle.current);
      }, 0);
    }
  }, []);
  useEffect(function () {
    setTimeout(function () {
      if (baseModalRef !== null && baseModalRef !== void 0 && baseModalRef.current) {
        if (open) {
          var _baseModalRef$current5;
          baseModalRef === null || baseModalRef === void 0 ? void 0 : (_baseModalRef$current5 = baseModalRef.current) === null || _baseModalRef$current5 === void 0 ? void 0 : _baseModalRef$current5.openModal();
          setIsChecked(isCheckboxChecked);
        }
      }
    }, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  useEffect(function () {
    var baseModalElement = null;
    if (baseModalRef.current) {
      baseModalRef.current.addEventListener('fwc-modal-close', handleCloseModal);
      baseModalElement = baseModalRef.current;
    }
    return function () {
      if (baseModalElement) {
        baseModalElement.removeEventListener('fwc-modal-close', handleCloseModal);
      }
    };
  }, [handleCloseModal]);
  return jsx("fwc-modal-base", {
    ref: baseModalRef,
    config: JSON.stringify({
      assetsPath: assetsPath
    }),
    "disable-backdrop": disableBackdrop ? 'true' : 'false',
    "disable-escape-key": disableEscapeKey ? 'true' : 'false'
  }, jsx("div", {
    className: "carousel-section",
    css: cssTourCarousel
  }, open && jsx(Carousel, {
    ref: carouselRef,
    onNextClick: onNextClick,
    onPreviousClick: onPreviousClick,
    dataAnalyticsPrevBtn: (dataAnalytics === null || dataAnalytics === void 0 ? void 0 : dataAnalytics.prevArrowButton) || '',
    dataAnalyticsNextBtn: (dataAnalytics === null || dataAnalytics === void 0 ? void 0 : dataAnalytics.nextArrowButton) || ''
  }, data.map(function (record, idx) {
    return jsx(Carousel.Item, {
      key: record.id
    }, jsx(TourCard, {
      imgSrc: record.imgSrc,
      content: record.content,
      isChecked: isChecked,
      isFirst: idx === 0,
      isLast: idx + 1 === data.length,
      dataAnalytics: dataAnalytics,
      onNext: handleNextSlide,
      onBack: handlePreviousSlide,
      onCheckboxChange: handleCheckboxChange,
      onSkipOverview: handleSkipOverview
    }));
  }))));
};
TourCarousel.propTypes = {
  id: string,
  className: string,
  open: bool,
  isCheckboxChecked: bool,
  disableBackdrop: bool,
  disableEscapeKey: bool,
  onNextClick: func,
  onPreviousClick: func,
  onClose: func,
  data: object$1,
  dataAnalytics: shape({
    nextArrowButton: string,
    prevArrowButton: string,
    nextButton: string,
    prevButton: string,
    skipOverview: string,
    checkbox: string
  })
};

var overrideStyles = "\n  .fwc-modal-wrapper .fwc-modal-container {\n    background-color: transparent;\n    box-shadow: none;\n  }\n";
var ModalBase = /*#__PURE__*/forwardRef(function (props, ref) {
  var open = props.open,
    onClose = props.onClose,
    _props$disableBackdro = props.disableBackdrop,
    disableBackdrop = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
    _props$disableEscapeK = props.disableEscapeKey,
    disableEscapeKey = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK;
  var baseModalRef = useRef();
  var baseModalCustomStyle = useRef(document.createElement('style'));
  var uiState = useSBUIState();
  var assetsPath = (uiState === null || uiState === void 0 ? void 0 : uiState.assetsPath) || './';
  var fwcBaseModalProps = getFwcProps$1(props, {
    id: 'id',
    "class": 'class'
  });
  var handleCloseModal = useCallback(function (e) {
    onClose === null || onClose === void 0 ? void 0 : onClose(e);
  }, [onClose]);
  useEffect(function () {
    if (baseModalRef !== null && baseModalRef !== void 0 && baseModalRef.current) {
      new FwcModalBase(baseModalRef === null || baseModalRef === void 0 ? void 0 : baseModalRef.current).build();
      var baseModalShadowDOM = baseModalRef.current.shadowRoot;
      baseModalCustomStyle.current.innerHTML = overrideStyles;
      setTimeout(function () {
        baseModalShadowDOM.appendChild(baseModalCustomStyle.current);
      }, 0);
    }
  }, []);
  useEffect(function () {
    setTimeout(function () {
      if (baseModalRef !== null && baseModalRef !== void 0 && baseModalRef.current) {
        if (open) {
          var _baseModalRef$current;
          baseModalRef === null || baseModalRef === void 0 ? void 0 : (_baseModalRef$current = baseModalRef.current) === null || _baseModalRef$current === void 0 ? void 0 : _baseModalRef$current.openModal();
        } else {
          var _baseModalRef$current2;
          baseModalRef === null || baseModalRef === void 0 ? void 0 : (_baseModalRef$current2 = baseModalRef.current) === null || _baseModalRef$current2 === void 0 ? void 0 : _baseModalRef$current2.closeModal();
        }
      }
    }, 0);
  }, [open]);
  useEffect(function () {
    var baseModalElement = null;
    if (baseModalRef.current) {
      baseModalRef.current.addEventListener('fwc-modal-close', handleCloseModal);
      baseModalElement = baseModalRef.current;
    }
    return function () {
      if (baseModalElement) {
        var _baseModalElement;
        baseModalElement.removeEventListener('fwc-modal-close', handleCloseModal);
        (_baseModalElement = baseModalElement) === null || _baseModalElement === void 0 ? void 0 : _baseModalElement.closeModal();
      }
    };
  }, [handleCloseModal]);
  return jsx("fwc-modal-base", _extends$1({}, fwcBaseModalProps, {
    ref: mergeRefs(ref, baseModalRef),
    config: JSON.stringify({
      assetsPath: assetsPath
    }),
    "disable-backdrop": disableBackdrop ? 'true' : 'false',
    "disable-escape-key": disableEscapeKey ? 'true' : 'false'
  }), open && props.children);
});
ModalBase.displayName = 'ModalBase';
ModalBase.propTypes = {
  open: bool,
  disableBackdrop: bool,
  disableEscapeKey: bool,
  onClose: func,
  children: node$2
};

var _excluded$3 = ["confettiCount", "delay", "terminalVelocity", "gravity", "drag", "colors"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$4() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssConfetti = process.env.NODE_ENV === "production" ? {
  name: "tck4d4-cssConfetti",
  styles: "position:relative;canvas{position:absolute;top:0;left:0;pointer-events:none;};label:cssConfetti;"
} : {
  name: "tck4d4-cssConfetti",
  styles: "position:relative;canvas{position:absolute;top:0;left:0;pointer-events:none;};label:cssConfetti;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
};
var Confetti = function Confetti(props) {
  var _props$confettiCount = props.confettiCount,
    confettiCount = _props$confettiCount === void 0 ? 300 : _props$confettiCount,
    _props$delay = props.delay,
    delay = _props$delay === void 0 ? 0 : _props$delay,
    _props$terminalVeloci = props.terminalVelocity,
    terminalVelocity = _props$terminalVeloci === void 0 ? 4 : _props$terminalVeloci,
    _props$gravity = props.gravity,
    gravity = _props$gravity === void 0 ? 0.5 : _props$gravity,
    _props$drag = props.drag,
    drag = _props$drag === void 0 ? 0.1 : _props$drag,
    _props$colors = props.colors,
    colors = _props$colors === void 0 ? ['#FFE43B', '#B3FAFF', '#FF7CEC', '#D8D8D8'] : _props$colors,
    restProps = _objectWithoutProperties$1(props, _excluded$3);
  var canvasRef = /*#__PURE__*/React__default.createRef();
  var confettiRef = /*#__PURE__*/React__default.createRef();
  var canvas = null;
  var ctx = null;
  var confetti = [];
  var shapes = [{
    x: 4,
    y: 4,
    type: 'circle'
  }, {
    x: 8,
    y: 8,
    type: 'circle'
  }, {
    x: 10,
    y: 10,
    type: 'circle'
  }, {
    x: 4,
    y: 4,
    type: 'triangle'
  }, {
    x: 10,
    y: 10,
    type: 'triangle'
  }, {
    x: 16,
    y: 16,
    type: 'triangle'
  }, {
    x: 8,
    y: 2,
    type: 'rod'
  }, {
    x: 10,
    y: 4,
    type: 'rod'
  }, {
    x: 16,
    y: 4,
    type: 'rod'
  }];
  useEffect(function () {
    initConfetti();
  }, []);
  var initCanvas = function initCanvas() {
    var wrapper = confettiRef.current;
    canvas = canvasRef.current;
    ctx = canvas.getContext('2d');
    canvas.width = wrapper.clientWidth;
    canvas.height = wrapper.clientHeight;
  };
  var randomRange = function randomRange(min, max) {
    return Math.random() * (max - min) + min;
  };
  var initConfetti = function initConfetti() {
    initCanvas();
    confetti = [];
    for (var i = 0; i < confettiCount; i++) {
      confetti.push({
        color: colors[Math.floor(randomRange(0, colors.length))],
        dimensions: shapes[Math.floor(randomRange(0, shapes.length))],
        position: {
          x: randomRange(0, canvas.width),
          y: canvas.height - 1
        },
        rotation: randomRange(0, 2 * Math.PI),
        scale: {
          x: 1,
          y: 1
        },
        velocity: {
          x: randomRange(-25, 25),
          y: randomRange(0, -50)
        }
      });
    }

    // use optional delay attribute
    setTimeout(function () {
      renderConfetti();
    }, delay);
  };
  var renderConfetti = function renderConfetti() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    confetti.forEach(function (confetto, index) {
      var width = confetto.dimensions.x * confetto.scale.x;
      var height = confetto.dimensions.y * confetto.scale.y;

      // Move canvas to position and rotate
      ctx.translate(confetto.position.x, confetto.position.y);
      ctx.rotate(confetto.rotation);

      // Apply forces to velocity
      confetto.velocity.x -= confetto.velocity.x * drag;
      confetto.velocity.y = Math.min(confetto.velocity.y + gravity, terminalVelocity);
      confetto.velocity.x += Math.random() > 0.5 ? Math.random() : -Math.random();

      // Set position
      confetto.position.x += confetto.velocity.x;
      confetto.position.y += confetto.velocity.y;

      // Delete confetti when out of frame
      if (confetto.position.y >= canvas.height) confetti.splice(index, 1);

      // Loop confetto x position
      if (confetto.position.x > canvas.width) confetto.position.x = 0;
      if (confetto.position.x < 0) confetto.position.x = canvas.width;

      // Spin confetto by scaling y
      confetto.scale.y = Math.cos(confetto.position.y * 0.1);
      ctx.fillStyle = confetto.color;

      // Draw confetto
      if (confetto.dimensions.type === 'circle') {
        ctx.beginPath();
        ctx.arc(width / 2, height / 2, width / 2, 0, 2 * Math.PI, false);
        ctx.fill();
      }
      if (confetto.dimensions.type === 'rod') {
        ctx.fillRect(-width / 2, -height / 2, width, height);
      }
      if (confetto.dimensions.type === 'triangle') {
        ctx.beginPath();
        ctx.moveTo(width, height);
        ctx.lineTo(width * 0.75, height * 0.25);
        ctx.lineTo(width * 1.5, height * 0.5);
        ctx.fill();
      }

      // Reset transform matrix
      ctx.setTransform(1, 0, 0, 1, 0, 0);
    });
    window.requestAnimationFrame(renderConfetti);
  };
  return jsx("div", _extends$1({}, restProps, {
    css: cssConfetti,
    ref: confettiRef,
    className: cx('confetti-wrapper', restProps.className)
  }), props.children, jsx("canvas", {
    "aria-hidden": "true",
    ref: canvasRef
  }));
};
Confetti.propTypes = {
  drag: number$4,
  delay: number$4,
  gravity: number$4,
  colors: arrayOf(string),
  terminalVelocity: number$4,
  confettiCount: number$4,
  children: node$2
};

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */
function throttle (delay, callback, options) {
  var _ref = options || {},
      _ref$noTrailing = _ref.noTrailing,
      noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing,
      _ref$noLeading = _ref.noLeading,
      noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading,
      _ref$debounceMode = _ref.debounceMode,
      debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */


  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel(options) {
    var _ref2 = options || {},
        _ref2$upcomingOnly = _ref2.upcomingOnly,
        upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;

    clearExistingTimeout();
    cancelled = !upcomingOnly;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }

    var self = this;
    var elapsed = Date.now() - lastExec;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, arguments_);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (!noLeading && debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      if (noLeading) {
        /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */
        lastExec = Date.now();

        if (!noTrailing) {
          timeoutID = setTimeout(debounceMode ? clear : exec, delay);
        }
      } else {
        /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */
        exec();
      }
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ThresholdUnits = {
  Pixel: 'Pixel',
  Percent: 'Percent'
};
var defaultThreshold = {
  unit: ThresholdUnits.Percent,
  value: 0.8
};
function parseThreshold(scrollThreshold) {
  if (typeof scrollThreshold === 'number') {
    return {
      unit: ThresholdUnits.Percent,
      value: scrollThreshold * 100
    };
  }
  if (typeof scrollThreshold === 'string') {
    if (scrollThreshold.match(/^(\d*(\.\d+)?)px$/)) {
      return {
        unit: ThresholdUnits.Pixel,
        value: parseFloat(scrollThreshold)
      };
    }
    if (scrollThreshold.match(/^(\d*(\.\d+)?)%$/)) {
      return {
        unit: ThresholdUnits.Percent,
        value: parseFloat(scrollThreshold)
      };
    }
    console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...');
    return defaultThreshold;
  }
  console.warn('scrollThreshold should be string or number');
  return defaultThreshold;
}
var InfiniteScroll = /*#__PURE__*/function (_Component) {
  _inherits$1(InfiniteScroll, _Component);
  var _super = _createSuper(InfiniteScroll);
  function InfiniteScroll(props) {
    var _this;
    _classCallCheck$1(this, InfiniteScroll);
    _this = _super.call(this, props);
    _this.lastScrollTop = 0;
    _this.actionTriggered = false;
    // variables to keep track of pull down behaviour
    _this.startY = 0;
    _this.currentY = 0;
    _this.dragging = false;
    // will be populated in componentDidMount
    // based on the height of the pull down element
    _this.maxPullDownDistance = 0;
    _this.getScrollableTarget = function () {
      if (_this.props.scrollableTarget instanceof HTMLElement) return _this.props.scrollableTarget;
      if (typeof _this.props.scrollableTarget === 'string') {
        return document.getElementById(_this.props.scrollableTarget);
      }
      if (_this.props.scrollableTarget === null) {
        console.warn("You are trying to pass scrollableTarget but it is null. This might\n        happen because the element may not have been added to DOM yet.\n        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.\n      ");
      }
      return null;
    };
    _this.onStart = function (evt) {
      if (_this.lastScrollTop) return;
      _this.dragging = true;
      if (evt instanceof MouseEvent) {
        _this.startY = evt.pageY;
      } else if (evt instanceof TouchEvent) {
        _this.startY = evt.touches[0].pageY;
      }
      _this.currentY = _this.startY;
      if (_this._infScroll) {
        _this._infScroll.style.willChange = 'transform';
        _this._infScroll.style.transition = "transform 0.2s cubic-bezier(0,0,0.31,1)";
      }
    };
    _this.onMove = function (evt) {
      if (!_this.dragging) return;
      if (evt instanceof MouseEvent) {
        _this.currentY = evt.pageY;
      } else if (evt instanceof TouchEvent) {
        _this.currentY = evt.touches[0].pageY;
      }
      // user is scrolling down to up
      if (_this.currentY < _this.startY) return;
      if (_this.currentY - _this.startY >= Number(_this.props.pullDownToRefreshThreshold)) {
        _this.setState({
          pullToRefreshThresholdBreached: true
        });
      }
      // so you can drag upto 1.5 times of the maxPullDownDistance
      if (_this.currentY - _this.startY > _this.maxPullDownDistance * 1.5) return;
      if (_this._infScroll) {
        _this._infScroll.style.overflow = 'visible';
        _this._infScroll.style.transform = "translate3d(0px, ".concat(_this.currentY - _this.startY, "px, 0px)");
      }
    };
    _this.onEnd = function () {
      _this.startY = 0;
      _this.currentY = 0;
      _this.dragging = false;
      if (_this.state.pullToRefreshThresholdBreached) {
        _this.props.refreshFunction && _this.props.refreshFunction();
        _this.setState({
          pullToRefreshThresholdBreached: false
        });
      }
      requestAnimationFrame(function () {
        // this._infScroll
        if (_this._infScroll) {
          _this._infScroll.style.overflow = 'auto';
          _this._infScroll.style.transform = 'none';
          _this._infScroll.style.willChange = 'unset';
        }
      });
    };
    _this.onScrollListener = function (event) {
      if (typeof _this.props.onScroll === 'function') {
        // Execute this callback in next tick so that it does not affect the
        // functionality of the library.
        setTimeout(function () {
          return _this.props.onScroll && _this.props.onScroll(event);
        }, 0);
      }
      var target = _this.props.height || _this._scrollableNode ? event.target : document.documentElement.scrollTop ? document.documentElement : document.body;
      // return immediately if the action has already been triggered,
      // prevents multiple triggers.
      if (_this.actionTriggered) return;
      var atBottom = _this.props.inverse ? _this.isElementAtTop(target, _this.props.scrollThreshold) : _this.isElementAtBottom(target, _this.props.scrollThreshold);
      // call the `next` function in the props to trigger the next data fetch
      if (atBottom && _this.props.hasMore) {
        _this.actionTriggered = true;
        _this.setState({
          showLoader: true
        });
        _this.props.next && _this.props.next();
      }
      _this.lastScrollTop = target.scrollTop;
    };
    _this.state = {
      showLoader: false,
      pullToRefreshThresholdBreached: false,
      prevDataLength: props.dataLength
    };
    _this.throttledOnScrollListener = throttle(150, _this.onScrollListener).bind(_assertThisInitialized(_this));
    _this.onStart = _this.onStart.bind(_assertThisInitialized(_this));
    _this.onMove = _this.onMove.bind(_assertThisInitialized(_this));
    _this.onEnd = _this.onEnd.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass$1(InfiniteScroll, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof this.props.dataLength === 'undefined') {
        throw new Error("mandatory prop \"dataLength\" is missing. The prop is needed" + " when loading more content. Check README.md for usage");
      }
      this._scrollableNode = this.getScrollableTarget();
      this.el = this.props.height ? this._infScroll : this._scrollableNode || window;
      if (this.el) {
        this.el.addEventListener('scroll', this.throttledOnScrollListener);
      }
      if (typeof this.props.initialScrollY === 'number' && this.el && this.el instanceof HTMLElement && this.el.scrollHeight > this.props.initialScrollY) {
        this.el.scrollTo(0, this.props.initialScrollY);
      }
      if (this.props.pullDownToRefresh && this.el) {
        this.el.addEventListener('touchstart', this.onStart);
        this.el.addEventListener('touchmove', this.onMove);
        this.el.addEventListener('touchend', this.onEnd);
        this.el.addEventListener('mousedown', this.onStart);
        this.el.addEventListener('mousemove', this.onMove);
        this.el.addEventListener('mouseup', this.onEnd);
        // get BCR of pullDown element to position it above
        this.maxPullDownDistance = this._pullDown && this._pullDown.firstChild && this._pullDown.firstChild.getBoundingClientRect().height || 0;
        this.forceUpdate();
        if (typeof this.props.refreshFunction !== 'function') {
          throw new Error("Mandatory prop \"refreshFunction\" missing.\n          Pull Down To Refresh functionality will not work\n          as expected. Check README.md for usage'");
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.el) {
        this.el.removeEventListener('scroll', this.throttledOnScrollListener);
        if (this.props.pullDownToRefresh) {
          this.el.removeEventListener('touchstart', this.onStart);
          this.el.removeEventListener('touchmove', this.onMove);
          this.el.removeEventListener('touchend', this.onEnd);
          this.el.removeEventListener('mousedown', this.onStart);
          this.el.removeEventListener('mousemove', this.onMove);
          this.el.removeEventListener('mouseup', this.onEnd);
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // do nothing when dataLength is unchanged
      if (this.props.dataLength === prevProps.dataLength) return;
      this.actionTriggered = false;
      // update state when new data was sent in
      this.setState({
        showLoader: false
      });
    }
  }, {
    key: "isElementAtTop",
    value: function isElementAtTop(target) {
      var scrollThreshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.8;
      var clientHeight = target === document.body || target === document.documentElement ? window.screen.availHeight : target.clientHeight;
      var threshold = parseThreshold(scrollThreshold);
      if (threshold.unit === ThresholdUnits.Pixel) {
        return target.scrollTop <= threshold.value + clientHeight - target.scrollHeight + 1;
      }
      return target.scrollTop <= threshold.value / 100 + clientHeight - target.scrollHeight + 1;
    }
  }, {
    key: "isElementAtBottom",
    value: function isElementAtBottom(target) {
      var scrollThreshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.8;
      var clientHeight = target === document.body || target === document.documentElement ? window.screen.availHeight : target.clientHeight;
      var threshold = parseThreshold(scrollThreshold);
      if (threshold.unit === ThresholdUnits.Pixel) {
        return target.scrollTop + clientHeight >= target.scrollHeight - threshold.value;
      }
      return target.scrollTop + clientHeight >= threshold.value / 100 * target.scrollHeight;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var style = Object.assign({
        height: this.props.height || 'auto',
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch'
      }, this.props.style);
      var hasChildren = this.props.hasChildren || !!(this.props.children && this.props.children instanceof Array && this.props.children.length);
      // because heighted infiniteScroll visualy breaks
      // on drag down as overflow becomes visible
      var outerDivStyle = this.props.pullDownToRefresh && this.props.height ? {
        overflow: 'auto'
      } : {};
      return jsx("div", {
        style: outerDivStyle,
        className: "infinite-scroll-component__outerdiv"
      }, jsx("div", {
        className: "infinite-scroll-component ".concat(this.props.className || ''),
        ref: function ref(infScroll) {
          return _this2._infScroll = infScroll;
        },
        style: style
      }, this.props.pullDownToRefresh && jsx("div", {
        style: {
          position: 'relative'
        },
        ref: function ref(pullDown) {
          return _this2._pullDown = pullDown;
        }
      }, jsx("div", {
        style: {
          position: 'absolute',
          left: 0,
          right: 0,
          top: -1 * this.maxPullDownDistance
        }
      }, this.state.pullToRefreshThresholdBreached ? this.props.releaseToRefreshContent : this.props.pullDownToRefreshContent)), this.props.children, !this.state.showLoader && !hasChildren && this.props.hasMore && this.props.loader, this.state.showLoader && this.props.hasMore && this.props.loader, !this.props.hasMore && this.props.endMessage));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var dataLengthChanged = nextProps.dataLength !== prevState.prevDataLength;
      // reset when data changes
      if (dataLengthChanged) {
        return Object.assign(Object.assign({}, prevState), {
          prevDataLength: nextProps.dataLength
        });
      }
      return null;
    }
  }]);
  return InfiniteScroll;
}(Component);
InfiniteScroll.propTypes = {
  next: func,
  hasMore: bool,
  children: node$2,
  loader: node$2,
  scrollThreshold: oneOfType([number$4, string]),
  endMessage: node$2,
  style: object$1,
  height: oneOfType([number$4, string]),
  scrollableTarget: node$2,
  hasChildren: bool,
  inverse: bool,
  pullDownToRefresh: bool,
  pullDownToRefreshContent: node$2,
  releaseToRefreshContent: node$2,
  pullDownToRefreshThreshold: number$4,
  refreshFunction: func,
  onScroll: func,
  dataLength: number$4,
  initialScrollY: number$4,
  className: string
};

/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? React$2.useLayoutEffect : React$2.useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (process.env.NODE_ENV !== "production") {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (process.env.NODE_ENV !== "production") {
    var transitionProperty = getComputedStyle(state.elements.popper).transitionProperty || '';

    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;

    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
    .filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }

          break;

        case 'phase':
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'effect':
          if (modifier.effect != null && typeof modifier.effect !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'requires':
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (process.env.NODE_ENV !== "production") {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }

          var _getComputedStyle = getComputedStyle(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer


          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (process.env.NODE_ENV !== "production") {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (process.env.NODE_ENV !== "production") {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = React$2.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };

  var _React$useState = React$2.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = React$2.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        ReactDOM.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = React$2.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (reactFastCompare(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React$2.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssPopover = process.env.NODE_ENV === "production" ? {
  name: "1niekxx-cssPopover",
  styles: "background:#ffffff;padding:10px;border:1px solid rgba(0, 0, 0, 0.08);box-shadow:0px 16px 32px rgba(0, 0, 0, 0.1);border-radius:8px;.popover-arrow,.popover-arrow::before{position:absolute;width:10px;height:10px;background:inherit;}.popover-arrow{visibility:hidden;}.popover-arrow::before{visibility:visible;content:'';transform:rotate(45deg);}&[data-popper-placement^='top']>.popover-arrow{bottom:-6px;&::before{border-bottom:1px solid rgba(0, 0, 0, 0.08);border-right:1px solid rgba(0, 0, 0, 0.08);}}&[data-popper-placement^='bottom']>.popover-arrow{top:-6px;&::before{border-left:1px solid rgba(0, 0, 0, 0.08);border-top:1px solid rgba(0, 0, 0, 0.08);}}&[data-popper-placement^='left']>.popover-arrow{right:-6px;&::before{border-right:1px solid rgba(0, 0, 0, 0.08);border-top:1px solid rgba(0, 0, 0, 0.08);}}&[data-popper-placement^='right']>.popover-arrow{left:-6px;&::before{border-left:1px solid rgba(0, 0, 0, 0.08);border-bottom:1px solid rgba(0, 0, 0, 0.08);}}&[data-popper-reference-hidden^='true']{opacity:0;pointer-events:none;};label:cssPopover;"
} : {
  name: "1niekxx-cssPopover",
  styles: "background:#ffffff;padding:10px;border:1px solid rgba(0, 0, 0, 0.08);box-shadow:0px 16px 32px rgba(0, 0, 0, 0.1);border-radius:8px;.popover-arrow,.popover-arrow::before{position:absolute;width:10px;height:10px;background:inherit;}.popover-arrow{visibility:hidden;}.popover-arrow::before{visibility:visible;content:'';transform:rotate(45deg);}&[data-popper-placement^='top']>.popover-arrow{bottom:-6px;&::before{border-bottom:1px solid rgba(0, 0, 0, 0.08);border-right:1px solid rgba(0, 0, 0, 0.08);}}&[data-popper-placement^='bottom']>.popover-arrow{top:-6px;&::before{border-left:1px solid rgba(0, 0, 0, 0.08);border-top:1px solid rgba(0, 0, 0, 0.08);}}&[data-popper-placement^='left']>.popover-arrow{right:-6px;&::before{border-right:1px solid rgba(0, 0, 0, 0.08);border-top:1px solid rgba(0, 0, 0, 0.08);}}&[data-popper-placement^='right']>.popover-arrow{left:-6px;&::before{border-left:1px solid rgba(0, 0, 0, 0.08);border-bottom:1px solid rgba(0, 0, 0, 0.08);}}&[data-popper-reference-hidden^='true']{opacity:0;pointer-events:none;};label:cssPopover;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
};
var Popover = function Popover(props) {
  var anchorEl = props.anchorEl,
    placement = props.placement,
    onClickOutside = props.onClickOutside,
    _props$hideArrow = props.hideArrow,
    hideArrow = _props$hideArrow === void 0 ? false : _props$hideArrow;
  var popperRef = useRef();
  var _useState = useState(null),
    _useState2 = _slicedToArray$1(_useState, 2),
    popperEl = _useState2[0],
    setPopperEl = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray$1(_useState3, 2),
    arrowElement = _useState4[0],
    setArrowElement = _useState4[1];
  var _usePopper = usePopper(anchorEl, popperEl, {
      placement: placement,
      modifiers: [{
        name: 'offset',
        options: {
          offset: [0, hideArrow ? 5 : 10]
        }
      }, {
        name: 'arrow',
        enabled: !hideArrow,
        options: {
          element: arrowElement
        }
      }]
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  useClickAway(popperRef, function () {
    onClickOutside === null || onClickOutside === void 0 ? void 0 : onClickOutside();
  });
  return jsx("div", _extends$1({
    css: cssPopover,
    ref: mergeRefs(popperRef, setPopperEl),
    style: styles.popper
  }, attributes.popper), props.children, !hideArrow && jsx("div", {
    className: "popover-arrow",
    ref: setArrowElement,
    style: styles.arrow
  }));
};
Popover.propTypes = {
  anchorEl: any,
  hideArrow: bool,
  placement: oneOf(['auto-end', 'auto-start', 'auto', 'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  children: node$2,
  onClickOutside: func
};

var _excluded$2 = ["anchorProps", "anchorContent", "children"];
var AnchorPopover = function AnchorPopover(props) {
  var anchorProps = props.anchorProps,
    anchorContent = props.anchorContent,
    children = props.children,
    restProps = _objectWithoutProperties$1(props, _excluded$2);
  var _useState = useState(null),
    _useState2 = _slicedToArray$1(_useState, 2),
    anchor = _useState2[0],
    setAnchor = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray$1(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  var handleClick = function handleClick() {
    setOpen(function (old) {
      return !old;
    });
  };
  return jsx("span", null, jsx(Button, _extends$1({}, anchorProps, {
    ref: setAnchor,
    onClick: handleClick
  }), anchorContent), open && anchor && jsx(Popover, _extends$1({}, restProps, {
    anchorEl: anchor,
    onClickOutside: handleClick
  }), children));
};
AnchorPopover.propTypes = {
  hideArrow: bool,
  placement: oneOf(['auto-end', 'auto-start', 'auto', 'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  anchorProps: object$1,
  anchorContent: node$2,
  children: node$2
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssAreaChartTitleAndLegend = process.env.NODE_ENV === "production" ? {
  name: "c4rtqw-cssAreaChartTitleAndLegend",
  styles: "display:flex;flex-flow:row nowrap;justify-content:space-between;.area-chart-title{display:flex;justify-content:flex-start;}.area-chart-legend-section{display:flex;flex-flow:row nowrap;justify-content:flex-end;gap:20px;.area-chart-legend{display:flex;align-items:center;gap:4px;.area-chart-legend-dot{display:inline-block;height:14px;width:14px;border-radius:16px;}.area-chart-legend-label{font-size:14px;}}};label:cssAreaChartTitleAndLegend;"
} : {
  name: "c4rtqw-cssAreaChartTitleAndLegend",
  styles: "display:flex;flex-flow:row nowrap;justify-content:space-between;.area-chart-title{display:flex;justify-content:flex-start;}.area-chart-legend-section{display:flex;flex-flow:row nowrap;justify-content:flex-end;gap:20px;.area-chart-legend{display:flex;align-items:center;gap:4px;.area-chart-legend-dot{display:inline-block;height:14px;width:14px;border-radius:16px;}.area-chart-legend-label{font-size:14px;}}};label:cssAreaChartTitleAndLegend;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};
function AreaChartTitleAndLegend(props) {
  var title = props.title,
    legends = props.legends,
    showLegend = props.showLegend;
  return jsx("div", {
    css: cssAreaChartTitleAndLegend
  }, title && jsx("div", {
    className: "area-chart-title"
  }, jsx(Paragraph, {
    size: "lg",
    bold: true
  }, title)), showLegend && jsx("div", {
    className: "area-chart-legend-section"
  }, legends === null || legends === void 0 ? void 0 : legends.map(function (legend) {
    return jsx("span", {
      key: legend === null || legend === void 0 ? void 0 : legend.dataKey,
      className: "area-chart-legend"
    }, jsx("span", {
      className: "area-chart-legend-dot",
      style: {
        background: legend === null || legend === void 0 ? void 0 : legend.stroke
      }
    }), jsx("span", {
      className: "area-chart-legend-label"
    }, (legend === null || legend === void 0 ? void 0 : legend.label) || (legend === null || legend === void 0 ? void 0 : legend.dataKey)));
  })));
}
AreaChartTitleAndLegend.propTypes = {
  title: string,
  showLegend: bool,
  legends: arrayOf(shape({
    label: string,
    dataKey: string,
    stroke: string
  }))
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssAreaChart = process.env.NODE_ENV === "production" ? {
  name: "a9i1gk-cssAreaChart",
  styles: "position:relative;width:100%;height:100%;.axis path,.axis line{fill:none;stroke:#c4c4c4;shape-rendering:crispEdges;}.axis text{font-family:'Lato';font-style:normal;line-height:18px;letter-spacing:0px;}.axis-grid path{display:none;}.chart-polyline{fill:var(--color-white);stroke:var(--color-primary);stroke-width:1px;}svg{overflow:visible;}.keyVal{text-anchor:middle;font-size:var(--default-font-size);font-weight:bold;font-family:'Lato';font-style:normal;line-height:18px;letter-spacing:0px;}.keyVal.heading{text-anchor:middle;};label:cssAreaChart;"
} : {
  name: "a9i1gk-cssAreaChart",
  styles: "position:relative;width:100%;height:100%;.axis path,.axis line{fill:none;stroke:#c4c4c4;shape-rendering:crispEdges;}.axis text{font-family:'Lato';font-style:normal;line-height:18px;letter-spacing:0px;}.axis-grid path{display:none;}.chart-polyline{fill:var(--color-white);stroke:var(--color-primary);stroke-width:1px;}svg{overflow:visible;}.keyVal{text-anchor:middle;font-size:var(--default-font-size);font-weight:bold;font-family:'Lato';font-style:normal;line-height:18px;letter-spacing:0px;}.keyVal.heading{text-anchor:middle;};label:cssAreaChart;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};
var defaultProps = {
  id: 'area-chart',
  width: 900,
  height: 400,
  margin: {
    top: 30,
    right: 30,
    bottom: 30,
    left: 50
  },
  dataset: [],
  xAxis: {
    scaleType: 'time',
    dataKey: 'name'
  },
  yAxis: {
    scaleType: 'linear',
    dataKey: 'value'
  },
  showLegend: false,
  area: {
    hideDots: false,
    stroke: '#ff3757',
    fill: '#FFDE74',
    fillLinearGradient: false,
    linearGradient: [{
      offset: '0%',
      color: '#FF3757',
      opacity: 0.9
    }, {
      offset: '20%',
      color: '#FF715A',
      opacity: 0.7
    }, {
      offset: '40%',
      color: '#FFA974',
      opacity: 0.6
    }, {
      offset: '60%',
      color: '#FFDE74',
      opacity: 0.4
    }, {
      offset: '100%',
      color: 'white',
      opacity: 0.2
    }]
  }
};
var getScale = function getScale(config) {
  var scaleType = config.scaleType,
    dataKey = config.dataKey,
    data = config.data;
  if (Array.isArray(dataKey)) {
    var values = dataKey.map(function (key) {
      return data.map(function (item) {
        return item[key];
      });
    }).flat();
    if (scaleType === 'time') {
      return time().domain(extent(values));
    }
    if (scaleType === 'linear') {
      return linear().domain([0, max$2(values)]);
    }
    return point$2().domain(_toConsumableArray(new Set(values)));
  }
  if (scaleType === 'time') {
    return time().domain(extent(data, function (d) {
      return d[dataKey];
    }));
  }
  if (scaleType === 'linear') {
    return linear().domain([0, max$2(data, function (d) {
      return d[dataKey];
    })]);
  }
  return point$2().domain(data.map(function (d) {
    return d[dataKey];
  }));
};
var getAxis = function getAxis(config) {
  var scale = config.scale,
    ticks = config.ticks,
    type = config.type,
    _config$tickFormat = config.tickFormat,
    tickFormat = _config$tickFormat === void 0 ? null : _config$tickFormat;
  var axis = type === 'x' ? axisBottom(scale) : axisLeft(scale);
  if (ticks) {
    axis = axis.ticks(ticks);
  }
  if (tickFormat) {
    axis = axis.tickFormat(format$1(tickFormat));
  }
  return axis;
};
var processData = function processData(data, xAxis, yAxis) {
  var result = data;
  if (xAxis.scaleType === 'time') {
    result = result.map(function (d) {
      return _objectSpread(_objectSpread({}, d), {}, _defineProperty$1({}, xAxis.dataKey, timeParse(xAxis.timeParseFormat || '%Y-%m-%d')(d[xAxis.dataKey])));
    });
  }
  if (yAxis.scaleType === 'time') {
    result = result.map(function (d) {
      if (Array.isArray(yAxis.dataKey)) {
        return yAxis.dataKey.reduce(function (acc, dataKey) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty$1({}, dataKey, timeParse(yAxis.timeParseFormat || '%Y-%m-%d')(d[dataKey])));
        }, d);
      } else {
        return _objectSpread(_objectSpread({}, d), {}, _defineProperty$1({}, yAxis.dataKey, timeParse(yAxis.timeParseFormat || '%Y-%m-%d')(d[yAxis.dataKey])));
      }
    });
  }
  return result;
};
function AreaChart(rawProps) {
  var _this = this;
  var props = _objectSpread(_objectSpread({}, defaultProps), rawProps);
  var id = props.id,
    height = props.height,
    width = props.width,
    margin = props.margin,
    xAxis = props.xAxis,
    yAxis = props.yAxis,
    dataset = props.dataset,
    area$1 = props.area,
    _props$showTooltip = props.showTooltip,
    showTooltip = _props$showTooltip === void 0 ? false : _props$showTooltip,
    _props$showLegend = props.showLegend,
    showLegend = _props$showLegend === void 0 ? false : _props$showLegend;
  var areaConfigs = Array.isArray(area$1) ? area$1.map(function (config) {
    return _objectSpread(_objectSpread({}, defaultProps.area), config);
  }) : [_objectSpread(_objectSpread(_objectSpread({}, defaultProps.area), area$1), {}, {
    dataKey: yAxis.dataKey
  })];
  var _margin = _objectSpread(_objectSpread({}, defaultProps.margin), margin);
  var areaChartRef = useRef();
  useEffect(function () {
    var _width = areaChartRef.current.offsetWidth || width;
    var _height = areaChartRef.current.offsetHeight || height;
    var xDataKey = xAxis.dataKey;
    var yDataKeys = Array.isArray(yAxis.dataKey) ? yAxis.dataKey : [yAxis.dataKey];
    var data = processData(dataset, xAxis, yAxis);
    var xScale = getScale(_objectSpread(_objectSpread({}, xAxis), {}, {
      data: data
    })).range([0, _width]);
    var yScale = getScale(_objectSpread(_objectSpread({}, yAxis), {}, {
      data: data
    })).range([height, 0]);
    var _xAxis = getAxis(_objectSpread(_objectSpread({}, xAxis), {}, {
      scale: xScale,
      type: 'x'
    }));
    var _yAxis = getAxis(_objectSpread(_objectSpread({}, yAxis), {}, {
      scale: yScale,
      type: 'y'
    }));
    var _xAxisGrid = getAxis(_objectSpread(_objectSpread({}, xAxis), {}, {
      scale: xScale,
      type: 'x'
    })).tickSize(-_height).tickFormat('');
    // const _yAxisGrid = getAxis({ ...yAxis, scale: yScale, type: 'y' })
    //   .tickSize(-_width)
    //   .tickFormat('');

    // Add the svg canvas for the line chart
    var mainSVG = select(areaChartRef.current).append('svg').attr('viewBox', "0 0 ".concat(_width + _margin.left + _margin.right, " ").concat(height + _margin.top + _margin.bottom));
    // .attr('width', _width + margin.left + margin.right)
    // .attr('height', height + margin.top + margin.bottom)

    var svg = mainSVG.append('g').attr('transform', "translate(".concat(_margin.left, ",").concat(_margin.top, ")"));

    // Tooltip
    var tooltip = mainSVG.append('g').attr('class', 'tool-tip').style('display', 'none');
    tooltip.append('polyline').attr('points', '0,0  0,110 47,110 57,120 67,110 114,110 114,0 0,0').attr('class', 'chart-polyline');
    tooltip.append('text').attr('class', 'keyVal heading').attr('y', 30).attr('x', 55);
    tooltip.append('text').attr('class', 'keyVal value1').attr('text-anchor', 'start').attr('y', 60).attr('x', 55);
    tooltip.append('text').attr('class', 'keyVal value2').attr('text-anchor', 'start').attr('y', 90).attr('x', 55);

    // Add the X Axis
    svg.append('g').attr('class', 'x axis').attr('transform', "translate(0,".concat(height, ")")).call(_xAxis);
    svg.append('g').attr('class', 'x axis-grid').attr('transform', "translate(0,".concat(height, ")")).call(_xAxisGrid);
    svg.selectAll('.x.axis-grid .tick > line').attr('class', 'axis-line').style('stroke', '#eee').style('stroke-width', '1px');

    // Add the Y Axis
    svg.append('g').attr('class', 'y axis').call(_yAxis);
    // svg.append('g').attr('class', 'y axis-grid').call(_yAxisGrid);

    yDataKeys.forEach(function (yDataKey, idx) {
      var _area = areaConfigs.find(function (config) {
        return config.dataKey === yDataKey;
      }) || {};
      var _data = data.filter(function (item) {
        return item[xDataKey] && !['', undefined, null].includes(item[yDataKey]);
      });
      // Define the gradient below the line chart
      svg.append('defs').append('linearGradient').attr('id', "".concat(id, "-").concat(idx, "-areaGradient")).attr('x1', '0%').attr('y1', '0%').attr('x2', '0%').attr('y2', '100%').selectAll('stop').data((_area === null || _area === void 0 ? void 0 : _area.linearGradient) || []).enter().append('stop').attr('offset', function (d) {
        return d.offset;
      }).attr('stop-color', function (d) {
        return d.color;
      }).attr('stop-opacity', function (d) {
        return d.opacity;
      });
      // Initiate the area line function
      var areaFunction = area().curve(monotoneX).x(function (d) {
        return xScale(d[xDataKey]);
      }).y0(height).y1(function (d) {
        return yScale(d[yDataKey]);
      });
      // Draw the underlying area chart filled with the gradient
      svg.append('path').attr('class', 'area').style('fill', _area !== null && _area !== void 0 && _area.fillLinearGradient ? "url(#".concat(id, "-").concat(idx, "-areaGradient)") : _area === null || _area === void 0 ? void 0 : _area.fill).style('pointer-events', 'none').attr('d', areaFunction(_data));

      // Initiate the line function
      var lineFunction = line().curve(monotoneX).x(function (d) {
        return xScale(d[xDataKey]);
      }).y(function (d) {
        return yScale(d[yDataKey]);
      });
      // Draw the line
      svg.append('path').attr('class', 'line').attr('d', lineFunction(_data)).style('stroke', _area.stroke).style('stroke-width', '3px').style('fill', 'none');
      if (!(_area !== null && _area !== void 0 && _area.hideDots)) {
        svg.selectAll(".lineDots-".concat(idx)).data(_data, function (d) {
          return d[xDataKey];
        }).enter().append('circle').attr('class', "lineDots-".concat(idx)).attr('r', 4).attr('cx', function (d) {
          return xScale(d[xDataKey]);
        }).attr('cy', function (d) {
          return yScale(d[yDataKey]);
        }).style('fill', _area.stroke).style('stroke', _area.stroke).style('stroke-width', '4px').style('pointer-events', 'visible ').on('mouseover', function () {
          if (!showTooltip) return;
          select(_this).transition().duration(200).attr('r', 6);
          tooltip.transition().duration(500).style('display', null);
        }).on('mouseout', function () {
          if (!showTooltip) return;
          select(_this).transition().duration(200).attr('r', 4);
          tooltip.transition().duration(500).style('display', 'none');
        }).on('mousemove', function (event, d) {
          if (!showTooltip) return;
          var _d3$pointer = pointer(event),
            _d3$pointer2 = _slicedToArray$1(_d3$pointer, 2),
            x = _d3$pointer2[0],
            y = _d3$pointer2[1];
          tooltip.attr('transform', "translate(".concat(x - 10, ",").concat(y - 100, ")"));
          var labelValue = d[xDataKey];
          tooltip.select('.keyVal.heading').text(labelValue);
          yDataKeys.map(function (yDataKey, idx) {
            var selector = ".value".concat(idx + 1);
            var value = yAxis !== null && yAxis !== void 0 && yAxis.tickFormat ? format$1(yAxis === null || yAxis === void 0 ? void 0 : yAxis.tickFormat)(d[yDataKey]) : d[yDataKey];
            var dataKeyConfig = areaConfigs.find(function (config) {
              return config.dataKey === yDataKey;
            }) || {};
            if (![undefined, null].includes(d[yDataKey])) {
              tooltip.select(selector).text("".concat(dataKeyConfig.label || yDataKey, " : ").concat(value)).style('fill', dataKeyConfig.stroke);
            } else {
              tooltip.select(selector).text('');
            }
          });
        });
      }
    });
  }, []);
  return jsx("div", null, jsx(AreaChartTitleAndLegend, {
    title: props.title,
    showLegend: showLegend,
    legends: areaConfigs
  }), jsx("div", {
    ref: areaChartRef,
    className: "area-chart-wrapper",
    css: cssAreaChart
  }));
}
var areaPropTypes = shape({
  label: string,
  dataKey: string,
  hideDots: bool,
  stroke: string,
  fill: string,
  fillLinearGradient: bool,
  linearGradient: arrayOf(shape({
    offset: string,
    color: string,
    opacity: number$4
  }))
});
AreaChart.propTypes = {
  id: string,
  width: number$4,
  height: number$4,
  dataset: arrayOf(object$1),
  margin: shape({
    top: number$4,
    right: number$4,
    left: number$4,
    bottom: number$4
  }),
  xAxis: shape({
    scaleType: oneOf(['time', 'linear', 'point']),
    dataKey: string,
    timeParseFormat: string
  }),
  yAxis: shape({
    scaleType: oneOf(['time', 'linear', 'point']),
    dataKey: oneOfType([string, arrayOf(string)])
  }),
  area: oneOfType([areaPropTypes, arrayOf(areaPropTypes)]),
  showLegend: bool,
  title: string,
  showTooltip: bool
};

var _excluded$1 = ["data", "xAxisKey", "xAxisLabel", "yAxisLabel", "lineDataKeys"];
var LineChart = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    xAxisKey = props.xAxisKey,
    xAxisLabel = props.xAxisLabel,
    yAxisLabel = props.yAxisLabel,
    _props$lineDataKeys = props.lineDataKeys,
    lineDataKeys = _props$lineDataKeys === void 0 ? [] : _props$lineDataKeys,
    restProps = _objectWithoutProperties$1(props, _excluded$1);
  var lineChartRef = useRef();
  var chartData = useMemo(function () {
    var _ref, _ref$slice;
    var result = {
      legend: []
    };
    (_ref = lineDataKeys || []) === null || _ref === void 0 ? void 0 : (_ref$slice = _ref.slice(0, 3)) === null || _ref$slice === void 0 ? void 0 : _ref$slice.forEach(function (item, idx) {
      var dataSet = [];
      var labelKey = item.label || item.dataKey;
      data === null || data === void 0 ? void 0 : data.forEach(function (record) {
        dataSet.push([record[xAxisKey], record[item.dataKey]]);
      });
      result.legend.push(labelKey);
      result[idx] = dataSet;
    });
    return result;
  }, [data, lineDataKeys, xAxisKey]);
  useEffect(function () {
    if (lineChartRef.current) {
      new FwcChartLine(lineChartRef.current).build();
    }
  }, []);
  return jsx("div", null, jsx("fwc-chart-line", _extends$1({}, restProps, {
    ref: mergeRefs(lineChartRef, ref),
    legend: JSON.stringify(chartData.legend || []),
    "data-line-one": JSON.stringify((chartData === null || chartData === void 0 ? void 0 : chartData[0]) || []),
    "data-line-two": JSON.stringify((chartData === null || chartData === void 0 ? void 0 : chartData[1]) || []),
    "data-line-three": JSON.stringify((chartData === null || chartData === void 0 ? void 0 : chartData[2]) || []),
    "label-horizontal": xAxisLabel,
    "label-vertical": yAxisLabel
  })));
});
LineChart.displayName = 'LineChart';
LineChart.propTypes = {
  /**
   * Data source array
   */
  data: array$2.isRequired,
  /**
   * Key from data array that should be used for xAxis
   */
  xAxisKey: string.isRequired,
  /**
   * Label for X Axis
   */
  xAxisLabel: string.isRequired,
  /**
   * Label for Y-Axis
   */
  yAxisLabel: string.isRequired,
  /**
   * Key from data array that should be used for picking graph bar size and custom label to show in chart
   */
  lineDataKeys: arrayOf(shape({
    label: string,
    dataKey: string.isRequired
  }).isRequired).isRequired,
  ref: any
};

var _excluded = ["isActive", "className"],
  _excluded2 = ["className", "verticalAlign"];
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var cssNavBarItem = process.env.NODE_ENV === "production" ? {
  name: "1x5b8a4-cssNavBarItem",
  styles: "&.nav-bar-item{color:var(--color-gray-one);text-decoration:none;font-size:16px;&:focus,&:hover{cursor:pointer;}&:active,&.active{color:var(--color-primary);}};label:cssNavBarItem;"
} : {
  name: "1x5b8a4-cssNavBarItem",
  styles: "&.nav-bar-item{color:var(--color-gray-one);text-decoration:none;font-size:16px;&:focus,&:hover{cursor:pointer;}&:active,&.active{color:var(--color-primary);}};label:cssNavBarItem;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var NavBarItem = function NavBarItem(props) {
  var isActive = props.isActive,
    className = props.className,
    restProps = _objectWithoutProperties$1(props, _excluded);
  var navItemClass = cx('nav-bar-item', className, {
    active: isActive
  });
  return jsx(Button, _extends$1({}, restProps, {
    className: navItemClass,
    btnType: "link",
    css: cssNavBarItem
  }));
};
NavBarItem.propTypes = {
  isActive: bool,
  className: string
};
var cssMenuList = process.env.NODE_ENV === "production" ? {
  name: "knlhjz-cssMenuList",
  styles: ".fwc-list-item.title{cursor:none;pointer-events:none;padding:16px 16px;.paragraph{font-size:18px;color:rgba(0, 0, 0, 0.54);}}.fwc-list-item{background-color:transparent;outline:0px;border:0px;margin:0px;border-radius:0px;cursor:pointer;vertical-align:middle;display:flex;justify-content:flex-start;align-items:center;position:relative;text-decoration:none;min-height:auto;padding:8px 20px;box-sizing:border-box;white-space:nowrap;&:hover{background-color:rgba(0, 0, 0, 0.04);}.nav-bar-item{text-decoration:none;font-size:16px;font-weight:600;&:hover{color:var(--color-primary-hover);}}};label:cssMenuList;"
} : {
  name: "knlhjz-cssMenuList",
  styles: ".fwc-list-item.title{cursor:none;pointer-events:none;padding:16px 16px;.paragraph{font-size:18px;color:rgba(0, 0, 0, 0.54);}}.fwc-list-item{background-color:transparent;outline:0px;border:0px;margin:0px;border-radius:0px;cursor:pointer;vertical-align:middle;display:flex;justify-content:flex-start;align-items:center;position:relative;text-decoration:none;min-height:auto;padding:8px 20px;box-sizing:border-box;white-space:nowrap;&:hover{background-color:rgba(0, 0, 0, 0.04);}.nav-bar-item{text-decoration:none;font-size:16px;font-weight:600;&:hover{color:var(--color-primary-hover);}}};label:cssMenuList;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var NavBarMenu = function NavBarMenu(props) {
  var anchorElement = props.anchorElement,
    children = props.children;
  return jsx(Dropdown, {
    noPadding: true
  }, jsx(Dropdown.Action, null, anchorElement), jsx(Dropdown.Content, null, jsx(List, {
    css: cssMenuList
  }, React__default.Children.map(children, function (child) {
    var _child$type;
    if ((child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'NavBar.MenuItem') {
      return jsx(List.Item, null, child);
    }
    console.error("Warning NavBar.Menu has children that aren't NavBar.MenuItem components");
    return null;
  }))));
};
NavBarMenu.propTypes = {
  anchorElement: string,
  children: node$2
};
var cssNavBar = process.env.NODE_ENV === "production" ? {
  name: "1l4i6ka-cssNavBar",
  styles: "display:flex;flex-flow:row nowrap;justify-content:start;align-items:center;gap:24px;&.vertical{flex-flow:column nowrap;align-items:start;};label:cssNavBar;"
} : {
  name: "1l4i6ka-cssNavBar",
  styles: "display:flex;flex-flow:row nowrap;justify-content:start;align-items:center;gap:24px;&.vertical{flex-flow:column nowrap;align-items:start;};label:cssNavBar;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var NavBar = function NavBar(props) {
  var className = props.className,
    verticalAlign = props.verticalAlign,
    restProps = _objectWithoutProperties$1(props, _excluded2);
  return jsx("nav", _extends$1({}, restProps, {
    css: cssNavBar,
    className: cx('nav-bar', className, {
      vertical: verticalAlign
    })
  }));
};
NavBar.propTypes = {
  className: string,
  verticalAlign: bool
};

// Nav Item
NavBar.Item = NavBarItem;

// Menu
NavBar.Menu = NavBarMenu;

// Menu Item
NavBar.MenuItem = NavBarItem;
NavBar.MenuItem.displayName = 'NavBar.MenuItem';

export { Alert, AnchorPopover, AnimatedColDrop, AreaChart, ArrowTabs, Async, AsyncCreatable, BackToTop, Badge, BarChart, BorderTabs, Button, Card, CardBody, CardFooter, CardHeader, Carousel, Checkbox, CheckboxGroup, Chip, Col, CompareGrid, CompareGridItem, CompareGridSection, Confetti, Container, Content, Creatable, DatePicker, DetailsField, DetailsFieldContent, DetailsFieldLabel, DetailsGrid, Divider, DonutChart, Dropdown, Dropzone, DropzoneContainer, Expand, ExpandMobile, ExpandMulti, Field, FilterButton, FilterPanel, Filters, FlipCard, FlowProvider, Footer, Form, Formix, Header, HelperMessage, HyperLink, Icon, IconText, Image, InfiniteScroll, InfoBanner, Input, LargeLink, Layout, LineChart, LinearProgress, List, Media, MediaImgCard, Modal, ModalBase, ModalSlide, MultiSelectCheckbox, NavBar, Notifier, Option, PageHeader, Pagination, Paragraph, Popover, PreLoader, ProgressBars, Radio, RadioGroup, Row, SBUIProvider, Select, Selector, SideNav, Stepper, StickyFooter, TabPanel, Table, Tabs, Text$1 as Text, Textarea, Title, Toggle, ToggleGroup, Tooltip, TourCarousel, Value, ArrowRenderer as defaultArrowRenderer, ClearRenderer as defaultClearRenderer, filterOptions as defaultFilterOptions, MenuRenderer as defaultMenuRenderer, getIn, notify, off, on, setIn, useClickAway, useDebounce, useDebouncedCallback, useDropzone, useFlowState, useFormix, useSBUIState, useWindowSize };
//# sourceMappingURL=index.esm.js.map
